function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4894"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4894"] = parcelRequire;
}
parcelRequire.register("k149n", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e9271ecfadbf1707$export$ffb0004e005737fa, (v) => $e9271ecfadbf1707$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $e9271ecfadbf1707$export$34b9dba7ce09269b, (v) => $e9271ecfadbf1707$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $e9271ecfadbf1707$export$25062201e9e25d76, (v) => $e9271ecfadbf1707$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e9271ecfadbf1707$export$ffb0004e005737fa;
var $e9271ecfadbf1707$export$34b9dba7ce09269b;
var $e9271ecfadbf1707$export$25062201e9e25d76;
"use strict";

var $4hYjL = parcelRequire("4hYjL");
var $e9271ecfadbf1707$var$k = Symbol.for("react.element"), $e9271ecfadbf1707$var$l = Symbol.for("react.fragment"), $e9271ecfadbf1707$var$m = Object.prototype.hasOwnProperty, $e9271ecfadbf1707$var$n = $4hYjL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e9271ecfadbf1707$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e9271ecfadbf1707$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e9271ecfadbf1707$var$m.call(a, b) && !$e9271ecfadbf1707$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e9271ecfadbf1707$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e9271ecfadbf1707$var$n.current
    };
}
$e9271ecfadbf1707$export$ffb0004e005737fa = $e9271ecfadbf1707$var$l;
$e9271ecfadbf1707$export$34b9dba7ce09269b = $e9271ecfadbf1707$var$q;
$e9271ecfadbf1707$export$25062201e9e25d76 = $e9271ecfadbf1707$var$q;

});
parcelRequire.register("4hYjL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6CFpW"));

});
parcelRequire.register("6CFpW", function(module, exports) {

$parcel$export(module.exports, "Children", () => $4d266b5641126890$export$dca3b0875bd9a954, (v) => $4d266b5641126890$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $4d266b5641126890$export$16fa2f45be04daa8, (v) => $4d266b5641126890$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $4d266b5641126890$export$ffb0004e005737fa, (v) => $4d266b5641126890$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $4d266b5641126890$export$e2c29f18771995cb, (v) => $4d266b5641126890$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $4d266b5641126890$export$221d75b3f55bb0bd, (v) => $4d266b5641126890$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $4d266b5641126890$export$5f8d39834fd61797, (v) => $4d266b5641126890$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4d266b5641126890$export$74bf444e3cd11ea5, (v) => $4d266b5641126890$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $4d266b5641126890$export$ae55be85d98224ed, (v) => $4d266b5641126890$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $4d266b5641126890$export$3ba232387fd5d6dd, (v) => $4d266b5641126890$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $4d266b5641126890$export$e530037191fcd5d7, (v) => $4d266b5641126890$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $4d266b5641126890$export$fd42f52fd3ae1109, (v) => $4d266b5641126890$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $4d266b5641126890$export$c8a8987d4410bf2d, (v) => $4d266b5641126890$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $4d266b5641126890$export$d38cd72104c1f0e9, (v) => $4d266b5641126890$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $4d266b5641126890$export$7d1e3a5e95ceca43, (v) => $4d266b5641126890$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $4d266b5641126890$export$257a8862b851cb5b, (v) => $4d266b5641126890$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $4d266b5641126890$export$a8257692ac88316c, (v) => $4d266b5641126890$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $4d266b5641126890$export$488013bae63b21da, (v) => $4d266b5641126890$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $4d266b5641126890$export$7c73462e0d25e514, (v) => $4d266b5641126890$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $4d266b5641126890$export$7568632d0d33d16d, (v) => $4d266b5641126890$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $4d266b5641126890$export$88948ce120ea2619, (v) => $4d266b5641126890$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $4d266b5641126890$export$35808ee640e87ca7, (v) => $4d266b5641126890$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $4d266b5641126890$export$fae74005e78b1a27, (v) => $4d266b5641126890$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $4d266b5641126890$export$dc8fbce3eb94dc1e, (v) => $4d266b5641126890$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $4d266b5641126890$export$6a7bc4e911dc01cf, (v) => $4d266b5641126890$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $4d266b5641126890$export$6d9c69b0de29b591, (v) => $4d266b5641126890$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $4d266b5641126890$export$f680877a34711e37, (v) => $4d266b5641126890$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $4d266b5641126890$export$d5a552a76deda3c2, (v) => $4d266b5641126890$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $4d266b5641126890$export$aaabe4eda9ed9969, (v) => $4d266b5641126890$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $4d266b5641126890$export$e5c5a5f917a5871c, (v) => $4d266b5641126890$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $4d266b5641126890$export$1538c33de8887b59, (v) => $4d266b5641126890$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $4d266b5641126890$export$13e3392192263954, (v) => $4d266b5641126890$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $4d266b5641126890$export$b8f5890fc79d6aca, (v) => $4d266b5641126890$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $4d266b5641126890$export$60241385465d0a34, (v) => $4d266b5641126890$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $4d266b5641126890$export$306c0aa65ff9ec16, (v) => $4d266b5641126890$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $4d266b5641126890$export$7b286972b8d8ccbf, (v) => $4d266b5641126890$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $4d266b5641126890$export$83d89fbfd8236492, (v) => $4d266b5641126890$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4d266b5641126890$export$dca3b0875bd9a954;
var $4d266b5641126890$export$16fa2f45be04daa8;
var $4d266b5641126890$export$ffb0004e005737fa;
var $4d266b5641126890$export$e2c29f18771995cb;
var $4d266b5641126890$export$221d75b3f55bb0bd;
var $4d266b5641126890$export$5f8d39834fd61797;
var $4d266b5641126890$export$74bf444e3cd11ea5;
var $4d266b5641126890$export$ae55be85d98224ed;
var $4d266b5641126890$export$3ba232387fd5d6dd;
var $4d266b5641126890$export$e530037191fcd5d7;
var $4d266b5641126890$export$fd42f52fd3ae1109;
var $4d266b5641126890$export$c8a8987d4410bf2d;
var $4d266b5641126890$export$d38cd72104c1f0e9;
var $4d266b5641126890$export$7d1e3a5e95ceca43;
var $4d266b5641126890$export$257a8862b851cb5b;
var $4d266b5641126890$export$a8257692ac88316c;
var $4d266b5641126890$export$488013bae63b21da;
var $4d266b5641126890$export$7c73462e0d25e514;
var $4d266b5641126890$export$7568632d0d33d16d;
var $4d266b5641126890$export$88948ce120ea2619;
var $4d266b5641126890$export$35808ee640e87ca7;
var $4d266b5641126890$export$fae74005e78b1a27;
var $4d266b5641126890$export$dc8fbce3eb94dc1e;
var $4d266b5641126890$export$6a7bc4e911dc01cf;
var $4d266b5641126890$export$6d9c69b0de29b591;
var $4d266b5641126890$export$f680877a34711e37;
var $4d266b5641126890$export$d5a552a76deda3c2;
var $4d266b5641126890$export$aaabe4eda9ed9969;
var $4d266b5641126890$export$e5c5a5f917a5871c;
var $4d266b5641126890$export$1538c33de8887b59;
var $4d266b5641126890$export$13e3392192263954;
var $4d266b5641126890$export$b8f5890fc79d6aca;
var $4d266b5641126890$export$60241385465d0a34;
var $4d266b5641126890$export$306c0aa65ff9ec16;
var $4d266b5641126890$export$7b286972b8d8ccbf;
var $4d266b5641126890$export$83d89fbfd8236492;
"use strict";
var $4d266b5641126890$var$l = Symbol.for("react.element"), $4d266b5641126890$var$n = Symbol.for("react.portal"), $4d266b5641126890$var$p = Symbol.for("react.fragment"), $4d266b5641126890$var$q = Symbol.for("react.strict_mode"), $4d266b5641126890$var$r = Symbol.for("react.profiler"), $4d266b5641126890$var$t = Symbol.for("react.provider"), $4d266b5641126890$var$u = Symbol.for("react.context"), $4d266b5641126890$var$v = Symbol.for("react.forward_ref"), $4d266b5641126890$var$w = Symbol.for("react.suspense"), $4d266b5641126890$var$x = Symbol.for("react.memo"), $4d266b5641126890$var$y = Symbol.for("react.lazy"), $4d266b5641126890$var$z = Symbol.iterator;
function $4d266b5641126890$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d266b5641126890$var$z && a[$4d266b5641126890$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d266b5641126890$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4d266b5641126890$var$C = Object.assign, $4d266b5641126890$var$D = {};
function $4d266b5641126890$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4d266b5641126890$var$D;
    this.updater = e || $4d266b5641126890$var$B;
}
$4d266b5641126890$var$E.prototype.isReactComponent = {};
$4d266b5641126890$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4d266b5641126890$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4d266b5641126890$var$F() {}
$4d266b5641126890$var$F.prototype = $4d266b5641126890$var$E.prototype;
function $4d266b5641126890$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4d266b5641126890$var$D;
    this.updater = e || $4d266b5641126890$var$B;
}
var $4d266b5641126890$var$H = $4d266b5641126890$var$G.prototype = new $4d266b5641126890$var$F;
$4d266b5641126890$var$H.constructor = $4d266b5641126890$var$G;
$4d266b5641126890$var$C($4d266b5641126890$var$H, $4d266b5641126890$var$E.prototype);
$4d266b5641126890$var$H.isPureReactComponent = !0;
var $4d266b5641126890$var$I = Array.isArray, $4d266b5641126890$var$J = Object.prototype.hasOwnProperty, $4d266b5641126890$var$K = {
    current: null
}, $4d266b5641126890$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4d266b5641126890$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4d266b5641126890$var$J.call(b, d) && !$4d266b5641126890$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4d266b5641126890$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4d266b5641126890$var$K.current
    };
}
function $4d266b5641126890$var$N(a, b) {
    return {
        $$typeof: $4d266b5641126890$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4d266b5641126890$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4d266b5641126890$var$l;
}
function $4d266b5641126890$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4d266b5641126890$var$P = /\/+/g;
function $4d266b5641126890$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4d266b5641126890$var$escape("" + a.key) : b.toString(36);
}
function $4d266b5641126890$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4d266b5641126890$var$l:
                case $4d266b5641126890$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4d266b5641126890$var$Q(h, 0) : d, $4d266b5641126890$var$I(c) ? (e = "", null != a && (e = a.replace($4d266b5641126890$var$P, "$&/") + "/"), $4d266b5641126890$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4d266b5641126890$var$O(c) && (c = $4d266b5641126890$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4d266b5641126890$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4d266b5641126890$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4d266b5641126890$var$Q(k, g);
        h += $4d266b5641126890$var$R(k, b, e, f, c);
    }
    else if (f = $4d266b5641126890$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4d266b5641126890$var$Q(k, g++), h += $4d266b5641126890$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4d266b5641126890$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4d266b5641126890$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4d266b5641126890$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4d266b5641126890$var$U = {
    current: null
}, $4d266b5641126890$var$V = {
    transition: null
}, $4d266b5641126890$var$W = {
    ReactCurrentDispatcher: $4d266b5641126890$var$U,
    ReactCurrentBatchConfig: $4d266b5641126890$var$V,
    ReactCurrentOwner: $4d266b5641126890$var$K
};
function $4d266b5641126890$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$4d266b5641126890$export$dca3b0875bd9a954 = {
    map: $4d266b5641126890$var$S,
    forEach: function(a, b, e) {
        $4d266b5641126890$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4d266b5641126890$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4d266b5641126890$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4d266b5641126890$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4d266b5641126890$export$16fa2f45be04daa8 = $4d266b5641126890$var$E;
$4d266b5641126890$export$ffb0004e005737fa = $4d266b5641126890$var$p;
$4d266b5641126890$export$e2c29f18771995cb = $4d266b5641126890$var$r;
$4d266b5641126890$export$221d75b3f55bb0bd = $4d266b5641126890$var$G;
$4d266b5641126890$export$5f8d39834fd61797 = $4d266b5641126890$var$q;
$4d266b5641126890$export$74bf444e3cd11ea5 = $4d266b5641126890$var$w;
$4d266b5641126890$export$ae55be85d98224ed = $4d266b5641126890$var$W;
$4d266b5641126890$export$3ba232387fd5d6dd = $4d266b5641126890$var$X;
$4d266b5641126890$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4d266b5641126890$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4d266b5641126890$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4d266b5641126890$var$J.call(b, f) && !$4d266b5641126890$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4d266b5641126890$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4d266b5641126890$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4d266b5641126890$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4d266b5641126890$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4d266b5641126890$export$c8a8987d4410bf2d = $4d266b5641126890$var$M;
$4d266b5641126890$export$d38cd72104c1f0e9 = function(a) {
    var b = $4d266b5641126890$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4d266b5641126890$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4d266b5641126890$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4d266b5641126890$var$v,
        render: a
    };
};
$4d266b5641126890$export$a8257692ac88316c = $4d266b5641126890$var$O;
$4d266b5641126890$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4d266b5641126890$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4d266b5641126890$var$T
    };
};
$4d266b5641126890$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4d266b5641126890$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4d266b5641126890$export$7568632d0d33d16d = function(a) {
    var b = $4d266b5641126890$var$V.transition;
    $4d266b5641126890$var$V.transition = {};
    try {
        a();
    } finally{
        $4d266b5641126890$var$V.transition = b;
    }
};
$4d266b5641126890$export$88948ce120ea2619 = $4d266b5641126890$var$X;
$4d266b5641126890$export$35808ee640e87ca7 = function(a, b) {
    return $4d266b5641126890$var$U.current.useCallback(a, b);
};
$4d266b5641126890$export$fae74005e78b1a27 = function(a) {
    return $4d266b5641126890$var$U.current.useContext(a);
};
$4d266b5641126890$export$dc8fbce3eb94dc1e = function() {};
$4d266b5641126890$export$6a7bc4e911dc01cf = function(a) {
    return $4d266b5641126890$var$U.current.useDeferredValue(a);
};
$4d266b5641126890$export$6d9c69b0de29b591 = function(a, b) {
    return $4d266b5641126890$var$U.current.useEffect(a, b);
};
$4d266b5641126890$export$f680877a34711e37 = function() {
    return $4d266b5641126890$var$U.current.useId();
};
$4d266b5641126890$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4d266b5641126890$var$U.current.useImperativeHandle(a, b, e);
};
$4d266b5641126890$export$aaabe4eda9ed9969 = function(a, b) {
    return $4d266b5641126890$var$U.current.useInsertionEffect(a, b);
};
$4d266b5641126890$export$e5c5a5f917a5871c = function(a, b) {
    return $4d266b5641126890$var$U.current.useLayoutEffect(a, b);
};
$4d266b5641126890$export$1538c33de8887b59 = function(a, b) {
    return $4d266b5641126890$var$U.current.useMemo(a, b);
};
$4d266b5641126890$export$13e3392192263954 = function(a, b, e) {
    return $4d266b5641126890$var$U.current.useReducer(a, b, e);
};
$4d266b5641126890$export$b8f5890fc79d6aca = function(a) {
    return $4d266b5641126890$var$U.current.useRef(a);
};
$4d266b5641126890$export$60241385465d0a34 = function(a) {
    return $4d266b5641126890$var$U.current.useState(a);
};
$4d266b5641126890$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4d266b5641126890$var$U.current.useSyncExternalStore(a, b, e);
};
$4d266b5641126890$export$7b286972b8d8ccbf = function() {
    return $4d266b5641126890$var$U.current.useTransition();
};
$4d266b5641126890$export$83d89fbfd8236492 = "18.3.1";

});



parcelRequire.register("cNEZM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gK5hx = parcelRequire("gK5hx");
function $9519dc794e526025$var$emptyFunction() {}
function $9519dc794e526025$var$emptyFunctionWithReset() {}
$9519dc794e526025$var$emptyFunctionWithReset.resetWarningCache = $9519dc794e526025$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gK5hx) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9519dc794e526025$var$emptyFunctionWithReset,
        resetWarningCache: $9519dc794e526025$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("gK5hx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c3050a1a2e3c911f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $c3050a1a2e3c911f$var$ReactPropTypesSecret;

});


parcelRequire.register("1IBpg", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $1406eaaa4638d630$export$2b8d127b894957b9, (v) => $1406eaaa4638d630$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $1406eaaa4638d630$export$cea3a54a6425200c, (v) => $1406eaaa4638d630$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $1406eaaa4638d630$export$a7c73072b1a182ae, (v) => $1406eaaa4638d630$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $1406eaaa4638d630$export$9f27bc3417b4524d, (v) => $1406eaaa4638d630$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $1406eaaa4638d630$export$db77ccec0bb4ccac, (v) => $1406eaaa4638d630$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $1406eaaa4638d630$export$8392c0c9d3dcbd35, (v) => $1406eaaa4638d630$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $1406eaaa4638d630$export$ffb0004e005737fa, (v) => $1406eaaa4638d630$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $1406eaaa4638d630$export$b624eff549462981, (v) => $1406eaaa4638d630$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $1406eaaa4638d630$export$7897aa7841a5380c, (v) => $1406eaaa4638d630$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $1406eaaa4638d630$export$602eac185826482c, (v) => $1406eaaa4638d630$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $1406eaaa4638d630$export$e2c29f18771995cb, (v) => $1406eaaa4638d630$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $1406eaaa4638d630$export$5f8d39834fd61797, (v) => $1406eaaa4638d630$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1406eaaa4638d630$export$74bf444e3cd11ea5, (v) => $1406eaaa4638d630$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $1406eaaa4638d630$export$92387174baf9b227, (v) => $1406eaaa4638d630$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $1406eaaa4638d630$export$ec112efeb987d9c6, (v) => $1406eaaa4638d630$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $1406eaaa4638d630$export$b706b080d889d2c9, (v) => $1406eaaa4638d630$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $1406eaaa4638d630$export$5be5a87408f70ddc, (v) => $1406eaaa4638d630$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $1406eaaa4638d630$export$45a5e7f76e0caa8d, (v) => $1406eaaa4638d630$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $1406eaaa4638d630$export$455c2e768291efa6, (v) => $1406eaaa4638d630$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $1406eaaa4638d630$export$9522e17588c12572, (v) => $1406eaaa4638d630$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $1406eaaa4638d630$export$2110ac352bb060b9, (v) => $1406eaaa4638d630$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $1406eaaa4638d630$export$56885ab8b9c456ab, (v) => $1406eaaa4638d630$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $1406eaaa4638d630$export$d927fcb6adf8f9de, (v) => $1406eaaa4638d630$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $1406eaaa4638d630$export$b82d16f27459e05a, (v) => $1406eaaa4638d630$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $1406eaaa4638d630$export$522c17b4f5e123e8, (v) => $1406eaaa4638d630$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $1406eaaa4638d630$export$1aabd8a0274ecfd6, (v) => $1406eaaa4638d630$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $1406eaaa4638d630$export$9b621391a187a31a, (v) => $1406eaaa4638d630$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $1406eaaa4638d630$export$f5bbd400c2f4426f, (v) => $1406eaaa4638d630$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1406eaaa4638d630$export$2b8d127b894957b9;
var $1406eaaa4638d630$export$cea3a54a6425200c;
var $1406eaaa4638d630$export$a7c73072b1a182ae;
var $1406eaaa4638d630$export$9f27bc3417b4524d;
var $1406eaaa4638d630$export$db77ccec0bb4ccac;
var $1406eaaa4638d630$export$8392c0c9d3dcbd35;
var $1406eaaa4638d630$export$ffb0004e005737fa;
var $1406eaaa4638d630$export$b624eff549462981;
var $1406eaaa4638d630$export$7897aa7841a5380c;
var $1406eaaa4638d630$export$602eac185826482c;
var $1406eaaa4638d630$export$e2c29f18771995cb;
var $1406eaaa4638d630$export$5f8d39834fd61797;
var $1406eaaa4638d630$export$74bf444e3cd11ea5;
var $1406eaaa4638d630$export$92387174baf9b227;
var $1406eaaa4638d630$export$ec112efeb987d9c6;
var $1406eaaa4638d630$export$b706b080d889d2c9;
var $1406eaaa4638d630$export$5be5a87408f70ddc;
var $1406eaaa4638d630$export$45a5e7f76e0caa8d;
var $1406eaaa4638d630$export$455c2e768291efa6;
var $1406eaaa4638d630$export$9522e17588c12572;
var $1406eaaa4638d630$export$2110ac352bb060b9;
var $1406eaaa4638d630$export$56885ab8b9c456ab;
var $1406eaaa4638d630$export$d927fcb6adf8f9de;
var $1406eaaa4638d630$export$b82d16f27459e05a;
var $1406eaaa4638d630$export$522c17b4f5e123e8;
var $1406eaaa4638d630$export$1aabd8a0274ecfd6;
var $1406eaaa4638d630$export$9b621391a187a31a;
var $1406eaaa4638d630$export$f5bbd400c2f4426f;
"use strict";
var $1406eaaa4638d630$var$b = "function" === typeof Symbol && Symbol.for, $1406eaaa4638d630$var$c = $1406eaaa4638d630$var$b ? Symbol.for("react.element") : 60103, $1406eaaa4638d630$var$d = $1406eaaa4638d630$var$b ? Symbol.for("react.portal") : 60106, $1406eaaa4638d630$var$e = $1406eaaa4638d630$var$b ? Symbol.for("react.fragment") : 60107, $1406eaaa4638d630$var$f = $1406eaaa4638d630$var$b ? Symbol.for("react.strict_mode") : 60108, $1406eaaa4638d630$var$g = $1406eaaa4638d630$var$b ? Symbol.for("react.profiler") : 60114, $1406eaaa4638d630$var$h = $1406eaaa4638d630$var$b ? Symbol.for("react.provider") : 60109, $1406eaaa4638d630$var$k = $1406eaaa4638d630$var$b ? Symbol.for("react.context") : 60110, $1406eaaa4638d630$var$l = $1406eaaa4638d630$var$b ? Symbol.for("react.async_mode") : 60111, $1406eaaa4638d630$var$m = $1406eaaa4638d630$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1406eaaa4638d630$var$n = $1406eaaa4638d630$var$b ? Symbol.for("react.forward_ref") : 60112, $1406eaaa4638d630$var$p = $1406eaaa4638d630$var$b ? Symbol.for("react.suspense") : 60113, $1406eaaa4638d630$var$q = $1406eaaa4638d630$var$b ? Symbol.for("react.suspense_list") : 60120, $1406eaaa4638d630$var$r = $1406eaaa4638d630$var$b ? Symbol.for("react.memo") : 60115, $1406eaaa4638d630$var$t = $1406eaaa4638d630$var$b ? Symbol.for("react.lazy") : 60116, $1406eaaa4638d630$var$v = $1406eaaa4638d630$var$b ? Symbol.for("react.block") : 60121, $1406eaaa4638d630$var$w = $1406eaaa4638d630$var$b ? Symbol.for("react.fundamental") : 60117, $1406eaaa4638d630$var$x = $1406eaaa4638d630$var$b ? Symbol.for("react.responder") : 60118, $1406eaaa4638d630$var$y = $1406eaaa4638d630$var$b ? Symbol.for("react.scope") : 60119;
function $1406eaaa4638d630$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1406eaaa4638d630$var$c:
                switch(a = a.type, a){
                    case $1406eaaa4638d630$var$l:
                    case $1406eaaa4638d630$var$m:
                    case $1406eaaa4638d630$var$e:
                    case $1406eaaa4638d630$var$g:
                    case $1406eaaa4638d630$var$f:
                    case $1406eaaa4638d630$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1406eaaa4638d630$var$k:
                            case $1406eaaa4638d630$var$n:
                            case $1406eaaa4638d630$var$t:
                            case $1406eaaa4638d630$var$r:
                            case $1406eaaa4638d630$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1406eaaa4638d630$var$d:
                return u;
        }
    }
}
function $1406eaaa4638d630$var$A(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$m;
}
$1406eaaa4638d630$export$2b8d127b894957b9 = $1406eaaa4638d630$var$l;
$1406eaaa4638d630$export$cea3a54a6425200c = $1406eaaa4638d630$var$m;
$1406eaaa4638d630$export$a7c73072b1a182ae = $1406eaaa4638d630$var$k;
$1406eaaa4638d630$export$9f27bc3417b4524d = $1406eaaa4638d630$var$h;
$1406eaaa4638d630$export$db77ccec0bb4ccac = $1406eaaa4638d630$var$c;
$1406eaaa4638d630$export$8392c0c9d3dcbd35 = $1406eaaa4638d630$var$n;
$1406eaaa4638d630$export$ffb0004e005737fa = $1406eaaa4638d630$var$e;
$1406eaaa4638d630$export$b624eff549462981 = $1406eaaa4638d630$var$t;
$1406eaaa4638d630$export$7897aa7841a5380c = $1406eaaa4638d630$var$r;
$1406eaaa4638d630$export$602eac185826482c = $1406eaaa4638d630$var$d;
$1406eaaa4638d630$export$e2c29f18771995cb = $1406eaaa4638d630$var$g;
$1406eaaa4638d630$export$5f8d39834fd61797 = $1406eaaa4638d630$var$f;
$1406eaaa4638d630$export$74bf444e3cd11ea5 = $1406eaaa4638d630$var$p;
$1406eaaa4638d630$export$92387174baf9b227 = function(a) {
    return $1406eaaa4638d630$var$A(a) || $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$l;
};
$1406eaaa4638d630$export$ec112efeb987d9c6 = $1406eaaa4638d630$var$A;
$1406eaaa4638d630$export$b706b080d889d2c9 = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$k;
};
$1406eaaa4638d630$export$5be5a87408f70ddc = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$h;
};
$1406eaaa4638d630$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1406eaaa4638d630$var$c;
};
$1406eaaa4638d630$export$455c2e768291efa6 = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$n;
};
$1406eaaa4638d630$export$9522e17588c12572 = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$e;
};
$1406eaaa4638d630$export$2110ac352bb060b9 = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$t;
};
$1406eaaa4638d630$export$56885ab8b9c456ab = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$r;
};
$1406eaaa4638d630$export$d927fcb6adf8f9de = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$d;
};
$1406eaaa4638d630$export$b82d16f27459e05a = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$g;
};
$1406eaaa4638d630$export$522c17b4f5e123e8 = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$f;
};
$1406eaaa4638d630$export$1aabd8a0274ecfd6 = function(a) {
    return $1406eaaa4638d630$var$z(a) === $1406eaaa4638d630$var$p;
};
$1406eaaa4638d630$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1406eaaa4638d630$var$e || a === $1406eaaa4638d630$var$m || a === $1406eaaa4638d630$var$g || a === $1406eaaa4638d630$var$f || a === $1406eaaa4638d630$var$p || a === $1406eaaa4638d630$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1406eaaa4638d630$var$t || a.$$typeof === $1406eaaa4638d630$var$r || a.$$typeof === $1406eaaa4638d630$var$h || a.$$typeof === $1406eaaa4638d630$var$k || a.$$typeof === $1406eaaa4638d630$var$n || a.$$typeof === $1406eaaa4638d630$var$w || a.$$typeof === $1406eaaa4638d630$var$x || a.$$typeof === $1406eaaa4638d630$var$y || a.$$typeof === $1406eaaa4638d630$var$v);
};
$1406eaaa4638d630$export$f5bbd400c2f4426f = $1406eaaa4638d630$var$z;

});

parcelRequire.register("l1BPC", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $f4e7098da8c5ec4a$export$2b8d127b894957b9, (v) => $f4e7098da8c5ec4a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $f4e7098da8c5ec4a$export$cea3a54a6425200c, (v) => $f4e7098da8c5ec4a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $f4e7098da8c5ec4a$export$a7c73072b1a182ae, (v) => $f4e7098da8c5ec4a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $f4e7098da8c5ec4a$export$9f27bc3417b4524d, (v) => $f4e7098da8c5ec4a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $f4e7098da8c5ec4a$export$db77ccec0bb4ccac, (v) => $f4e7098da8c5ec4a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $f4e7098da8c5ec4a$export$8392c0c9d3dcbd35, (v) => $f4e7098da8c5ec4a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $f4e7098da8c5ec4a$export$ffb0004e005737fa, (v) => $f4e7098da8c5ec4a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $f4e7098da8c5ec4a$export$b624eff549462981, (v) => $f4e7098da8c5ec4a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $f4e7098da8c5ec4a$export$7897aa7841a5380c, (v) => $f4e7098da8c5ec4a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $f4e7098da8c5ec4a$export$602eac185826482c, (v) => $f4e7098da8c5ec4a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $f4e7098da8c5ec4a$export$e2c29f18771995cb, (v) => $f4e7098da8c5ec4a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $f4e7098da8c5ec4a$export$5f8d39834fd61797, (v) => $f4e7098da8c5ec4a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $f4e7098da8c5ec4a$export$74bf444e3cd11ea5, (v) => $f4e7098da8c5ec4a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $f4e7098da8c5ec4a$export$92387174baf9b227, (v) => $f4e7098da8c5ec4a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $f4e7098da8c5ec4a$export$ec112efeb987d9c6, (v) => $f4e7098da8c5ec4a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $f4e7098da8c5ec4a$export$b706b080d889d2c9, (v) => $f4e7098da8c5ec4a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $f4e7098da8c5ec4a$export$5be5a87408f70ddc, (v) => $f4e7098da8c5ec4a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $f4e7098da8c5ec4a$export$45a5e7f76e0caa8d, (v) => $f4e7098da8c5ec4a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $f4e7098da8c5ec4a$export$455c2e768291efa6, (v) => $f4e7098da8c5ec4a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $f4e7098da8c5ec4a$export$9522e17588c12572, (v) => $f4e7098da8c5ec4a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $f4e7098da8c5ec4a$export$2110ac352bb060b9, (v) => $f4e7098da8c5ec4a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $f4e7098da8c5ec4a$export$56885ab8b9c456ab, (v) => $f4e7098da8c5ec4a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $f4e7098da8c5ec4a$export$d927fcb6adf8f9de, (v) => $f4e7098da8c5ec4a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $f4e7098da8c5ec4a$export$b82d16f27459e05a, (v) => $f4e7098da8c5ec4a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $f4e7098da8c5ec4a$export$522c17b4f5e123e8, (v) => $f4e7098da8c5ec4a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $f4e7098da8c5ec4a$export$1aabd8a0274ecfd6, (v) => $f4e7098da8c5ec4a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $f4e7098da8c5ec4a$export$9b621391a187a31a, (v) => $f4e7098da8c5ec4a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $f4e7098da8c5ec4a$export$f5bbd400c2f4426f, (v) => $f4e7098da8c5ec4a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f4e7098da8c5ec4a$export$2b8d127b894957b9;
var $f4e7098da8c5ec4a$export$cea3a54a6425200c;
var $f4e7098da8c5ec4a$export$a7c73072b1a182ae;
var $f4e7098da8c5ec4a$export$9f27bc3417b4524d;
var $f4e7098da8c5ec4a$export$db77ccec0bb4ccac;
var $f4e7098da8c5ec4a$export$8392c0c9d3dcbd35;
var $f4e7098da8c5ec4a$export$ffb0004e005737fa;
var $f4e7098da8c5ec4a$export$b624eff549462981;
var $f4e7098da8c5ec4a$export$7897aa7841a5380c;
var $f4e7098da8c5ec4a$export$602eac185826482c;
var $f4e7098da8c5ec4a$export$e2c29f18771995cb;
var $f4e7098da8c5ec4a$export$5f8d39834fd61797;
var $f4e7098da8c5ec4a$export$74bf444e3cd11ea5;
var $f4e7098da8c5ec4a$export$92387174baf9b227;
var $f4e7098da8c5ec4a$export$ec112efeb987d9c6;
var $f4e7098da8c5ec4a$export$b706b080d889d2c9;
var $f4e7098da8c5ec4a$export$5be5a87408f70ddc;
var $f4e7098da8c5ec4a$export$45a5e7f76e0caa8d;
var $f4e7098da8c5ec4a$export$455c2e768291efa6;
var $f4e7098da8c5ec4a$export$9522e17588c12572;
var $f4e7098da8c5ec4a$export$2110ac352bb060b9;
var $f4e7098da8c5ec4a$export$56885ab8b9c456ab;
var $f4e7098da8c5ec4a$export$d927fcb6adf8f9de;
var $f4e7098da8c5ec4a$export$b82d16f27459e05a;
var $f4e7098da8c5ec4a$export$522c17b4f5e123e8;
var $f4e7098da8c5ec4a$export$1aabd8a0274ecfd6;
var $f4e7098da8c5ec4a$export$9b621391a187a31a;
var $f4e7098da8c5ec4a$export$f5bbd400c2f4426f;
"use strict";
var $f4e7098da8c5ec4a$var$b = "function" === typeof Symbol && Symbol.for, $f4e7098da8c5ec4a$var$c = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.element") : 60103, $f4e7098da8c5ec4a$var$d = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.portal") : 60106, $f4e7098da8c5ec4a$var$e = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.fragment") : 60107, $f4e7098da8c5ec4a$var$f = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.strict_mode") : 60108, $f4e7098da8c5ec4a$var$g = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.profiler") : 60114, $f4e7098da8c5ec4a$var$h = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.provider") : 60109, $f4e7098da8c5ec4a$var$k = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.context") : 60110, $f4e7098da8c5ec4a$var$l = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.async_mode") : 60111, $f4e7098da8c5ec4a$var$m = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f4e7098da8c5ec4a$var$n = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.forward_ref") : 60112, $f4e7098da8c5ec4a$var$p = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.suspense") : 60113, $f4e7098da8c5ec4a$var$q = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.suspense_list") : 60120, $f4e7098da8c5ec4a$var$r = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.memo") : 60115, $f4e7098da8c5ec4a$var$t = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.lazy") : 60116, $f4e7098da8c5ec4a$var$v = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.block") : 60121, $f4e7098da8c5ec4a$var$w = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.fundamental") : 60117, $f4e7098da8c5ec4a$var$x = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.responder") : 60118, $f4e7098da8c5ec4a$var$y = $f4e7098da8c5ec4a$var$b ? Symbol.for("react.scope") : 60119;
function $f4e7098da8c5ec4a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f4e7098da8c5ec4a$var$c:
                switch(a = a.type, a){
                    case $f4e7098da8c5ec4a$var$l:
                    case $f4e7098da8c5ec4a$var$m:
                    case $f4e7098da8c5ec4a$var$e:
                    case $f4e7098da8c5ec4a$var$g:
                    case $f4e7098da8c5ec4a$var$f:
                    case $f4e7098da8c5ec4a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f4e7098da8c5ec4a$var$k:
                            case $f4e7098da8c5ec4a$var$n:
                            case $f4e7098da8c5ec4a$var$t:
                            case $f4e7098da8c5ec4a$var$r:
                            case $f4e7098da8c5ec4a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f4e7098da8c5ec4a$var$d:
                return u;
        }
    }
}
function $f4e7098da8c5ec4a$var$A(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$m;
}
$f4e7098da8c5ec4a$export$2b8d127b894957b9 = $f4e7098da8c5ec4a$var$l;
$f4e7098da8c5ec4a$export$cea3a54a6425200c = $f4e7098da8c5ec4a$var$m;
$f4e7098da8c5ec4a$export$a7c73072b1a182ae = $f4e7098da8c5ec4a$var$k;
$f4e7098da8c5ec4a$export$9f27bc3417b4524d = $f4e7098da8c5ec4a$var$h;
$f4e7098da8c5ec4a$export$db77ccec0bb4ccac = $f4e7098da8c5ec4a$var$c;
$f4e7098da8c5ec4a$export$8392c0c9d3dcbd35 = $f4e7098da8c5ec4a$var$n;
$f4e7098da8c5ec4a$export$ffb0004e005737fa = $f4e7098da8c5ec4a$var$e;
$f4e7098da8c5ec4a$export$b624eff549462981 = $f4e7098da8c5ec4a$var$t;
$f4e7098da8c5ec4a$export$7897aa7841a5380c = $f4e7098da8c5ec4a$var$r;
$f4e7098da8c5ec4a$export$602eac185826482c = $f4e7098da8c5ec4a$var$d;
$f4e7098da8c5ec4a$export$e2c29f18771995cb = $f4e7098da8c5ec4a$var$g;
$f4e7098da8c5ec4a$export$5f8d39834fd61797 = $f4e7098da8c5ec4a$var$f;
$f4e7098da8c5ec4a$export$74bf444e3cd11ea5 = $f4e7098da8c5ec4a$var$p;
$f4e7098da8c5ec4a$export$92387174baf9b227 = function(a) {
    return $f4e7098da8c5ec4a$var$A(a) || $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$l;
};
$f4e7098da8c5ec4a$export$ec112efeb987d9c6 = $f4e7098da8c5ec4a$var$A;
$f4e7098da8c5ec4a$export$b706b080d889d2c9 = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$k;
};
$f4e7098da8c5ec4a$export$5be5a87408f70ddc = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$h;
};
$f4e7098da8c5ec4a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f4e7098da8c5ec4a$var$c;
};
$f4e7098da8c5ec4a$export$455c2e768291efa6 = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$n;
};
$f4e7098da8c5ec4a$export$9522e17588c12572 = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$e;
};
$f4e7098da8c5ec4a$export$2110ac352bb060b9 = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$t;
};
$f4e7098da8c5ec4a$export$56885ab8b9c456ab = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$r;
};
$f4e7098da8c5ec4a$export$d927fcb6adf8f9de = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$d;
};
$f4e7098da8c5ec4a$export$b82d16f27459e05a = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$g;
};
$f4e7098da8c5ec4a$export$522c17b4f5e123e8 = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$f;
};
$f4e7098da8c5ec4a$export$1aabd8a0274ecfd6 = function(a) {
    return $f4e7098da8c5ec4a$var$z(a) === $f4e7098da8c5ec4a$var$p;
};
$f4e7098da8c5ec4a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f4e7098da8c5ec4a$var$e || a === $f4e7098da8c5ec4a$var$m || a === $f4e7098da8c5ec4a$var$g || a === $f4e7098da8c5ec4a$var$f || a === $f4e7098da8c5ec4a$var$p || a === $f4e7098da8c5ec4a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f4e7098da8c5ec4a$var$t || a.$$typeof === $f4e7098da8c5ec4a$var$r || a.$$typeof === $f4e7098da8c5ec4a$var$h || a.$$typeof === $f4e7098da8c5ec4a$var$k || a.$$typeof === $f4e7098da8c5ec4a$var$n || a.$$typeof === $f4e7098da8c5ec4a$var$w || a.$$typeof === $f4e7098da8c5ec4a$var$x || a.$$typeof === $f4e7098da8c5ec4a$var$y || a.$$typeof === $f4e7098da8c5ec4a$var$v);
};
$f4e7098da8c5ec4a$export$f5bbd400c2f4426f = $f4e7098da8c5ec4a$var$z;

});

parcelRequire.register("50VM8", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $3a69c4d89250e3bc$export$a7c73072b1a182ae, (v) => $3a69c4d89250e3bc$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $3a69c4d89250e3bc$export$9f27bc3417b4524d, (v) => $3a69c4d89250e3bc$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $3a69c4d89250e3bc$export$db77ccec0bb4ccac, (v) => $3a69c4d89250e3bc$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $3a69c4d89250e3bc$export$8392c0c9d3dcbd35, (v) => $3a69c4d89250e3bc$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $3a69c4d89250e3bc$export$ffb0004e005737fa, (v) => $3a69c4d89250e3bc$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $3a69c4d89250e3bc$export$b624eff549462981, (v) => $3a69c4d89250e3bc$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $3a69c4d89250e3bc$export$7897aa7841a5380c, (v) => $3a69c4d89250e3bc$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $3a69c4d89250e3bc$export$602eac185826482c, (v) => $3a69c4d89250e3bc$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $3a69c4d89250e3bc$export$e2c29f18771995cb, (v) => $3a69c4d89250e3bc$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $3a69c4d89250e3bc$export$5f8d39834fd61797, (v) => $3a69c4d89250e3bc$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3a69c4d89250e3bc$export$74bf444e3cd11ea5, (v) => $3a69c4d89250e3bc$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $3a69c4d89250e3bc$export$92387174baf9b227, (v) => $3a69c4d89250e3bc$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $3a69c4d89250e3bc$export$ec112efeb987d9c6, (v) => $3a69c4d89250e3bc$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $3a69c4d89250e3bc$export$b706b080d889d2c9, (v) => $3a69c4d89250e3bc$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $3a69c4d89250e3bc$export$5be5a87408f70ddc, (v) => $3a69c4d89250e3bc$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $3a69c4d89250e3bc$export$45a5e7f76e0caa8d, (v) => $3a69c4d89250e3bc$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $3a69c4d89250e3bc$export$455c2e768291efa6, (v) => $3a69c4d89250e3bc$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $3a69c4d89250e3bc$export$9522e17588c12572, (v) => $3a69c4d89250e3bc$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $3a69c4d89250e3bc$export$2110ac352bb060b9, (v) => $3a69c4d89250e3bc$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $3a69c4d89250e3bc$export$56885ab8b9c456ab, (v) => $3a69c4d89250e3bc$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $3a69c4d89250e3bc$export$d927fcb6adf8f9de, (v) => $3a69c4d89250e3bc$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $3a69c4d89250e3bc$export$b82d16f27459e05a, (v) => $3a69c4d89250e3bc$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $3a69c4d89250e3bc$export$522c17b4f5e123e8, (v) => $3a69c4d89250e3bc$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $3a69c4d89250e3bc$export$1aabd8a0274ecfd6, (v) => $3a69c4d89250e3bc$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $3a69c4d89250e3bc$export$9b621391a187a31a, (v) => $3a69c4d89250e3bc$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $3a69c4d89250e3bc$export$f5bbd400c2f4426f, (v) => $3a69c4d89250e3bc$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a69c4d89250e3bc$export$a7c73072b1a182ae;
var $3a69c4d89250e3bc$export$9f27bc3417b4524d;
var $3a69c4d89250e3bc$export$db77ccec0bb4ccac;
var $3a69c4d89250e3bc$export$8392c0c9d3dcbd35;
var $3a69c4d89250e3bc$export$ffb0004e005737fa;
var $3a69c4d89250e3bc$export$b624eff549462981;
var $3a69c4d89250e3bc$export$7897aa7841a5380c;
var $3a69c4d89250e3bc$export$602eac185826482c;
var $3a69c4d89250e3bc$export$e2c29f18771995cb;
var $3a69c4d89250e3bc$export$5f8d39834fd61797;
var $3a69c4d89250e3bc$export$74bf444e3cd11ea5;
var $3a69c4d89250e3bc$export$92387174baf9b227;
var $3a69c4d89250e3bc$export$ec112efeb987d9c6;
var $3a69c4d89250e3bc$export$b706b080d889d2c9;
var $3a69c4d89250e3bc$export$5be5a87408f70ddc;
var $3a69c4d89250e3bc$export$45a5e7f76e0caa8d;
var $3a69c4d89250e3bc$export$455c2e768291efa6;
var $3a69c4d89250e3bc$export$9522e17588c12572;
var $3a69c4d89250e3bc$export$2110ac352bb060b9;
var $3a69c4d89250e3bc$export$56885ab8b9c456ab;
var $3a69c4d89250e3bc$export$d927fcb6adf8f9de;
var $3a69c4d89250e3bc$export$b82d16f27459e05a;
var $3a69c4d89250e3bc$export$522c17b4f5e123e8;
var $3a69c4d89250e3bc$export$1aabd8a0274ecfd6;
var $3a69c4d89250e3bc$export$9b621391a187a31a;
var $3a69c4d89250e3bc$export$f5bbd400c2f4426f;
"use strict";
var $3a69c4d89250e3bc$var$b = 60103, $3a69c4d89250e3bc$var$c = 60106, $3a69c4d89250e3bc$var$d = 60107, $3a69c4d89250e3bc$var$e = 60108, $3a69c4d89250e3bc$var$f = 60114, $3a69c4d89250e3bc$var$g = 60109, $3a69c4d89250e3bc$var$h = 60110, $3a69c4d89250e3bc$var$k = 60112, $3a69c4d89250e3bc$var$l = 60113, $3a69c4d89250e3bc$var$m = 60120, $3a69c4d89250e3bc$var$n = 60115, $3a69c4d89250e3bc$var$p = 60116, $3a69c4d89250e3bc$var$q = 60121, $3a69c4d89250e3bc$var$r = 60122, $3a69c4d89250e3bc$var$u = 60117, $3a69c4d89250e3bc$var$v = 60129, $3a69c4d89250e3bc$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $3a69c4d89250e3bc$var$x = Symbol.for;
    $3a69c4d89250e3bc$var$b = $3a69c4d89250e3bc$var$x("react.element");
    $3a69c4d89250e3bc$var$c = $3a69c4d89250e3bc$var$x("react.portal");
    $3a69c4d89250e3bc$var$d = $3a69c4d89250e3bc$var$x("react.fragment");
    $3a69c4d89250e3bc$var$e = $3a69c4d89250e3bc$var$x("react.strict_mode");
    $3a69c4d89250e3bc$var$f = $3a69c4d89250e3bc$var$x("react.profiler");
    $3a69c4d89250e3bc$var$g = $3a69c4d89250e3bc$var$x("react.provider");
    $3a69c4d89250e3bc$var$h = $3a69c4d89250e3bc$var$x("react.context");
    $3a69c4d89250e3bc$var$k = $3a69c4d89250e3bc$var$x("react.forward_ref");
    $3a69c4d89250e3bc$var$l = $3a69c4d89250e3bc$var$x("react.suspense");
    $3a69c4d89250e3bc$var$m = $3a69c4d89250e3bc$var$x("react.suspense_list");
    $3a69c4d89250e3bc$var$n = $3a69c4d89250e3bc$var$x("react.memo");
    $3a69c4d89250e3bc$var$p = $3a69c4d89250e3bc$var$x("react.lazy");
    $3a69c4d89250e3bc$var$q = $3a69c4d89250e3bc$var$x("react.block");
    $3a69c4d89250e3bc$var$r = $3a69c4d89250e3bc$var$x("react.server.block");
    $3a69c4d89250e3bc$var$u = $3a69c4d89250e3bc$var$x("react.fundamental");
    $3a69c4d89250e3bc$var$v = $3a69c4d89250e3bc$var$x("react.debug_trace_mode");
    $3a69c4d89250e3bc$var$w = $3a69c4d89250e3bc$var$x("react.legacy_hidden");
}
function $3a69c4d89250e3bc$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $3a69c4d89250e3bc$var$b:
                switch(a = a.type, a){
                    case $3a69c4d89250e3bc$var$d:
                    case $3a69c4d89250e3bc$var$f:
                    case $3a69c4d89250e3bc$var$e:
                    case $3a69c4d89250e3bc$var$l:
                    case $3a69c4d89250e3bc$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3a69c4d89250e3bc$var$h:
                            case $3a69c4d89250e3bc$var$k:
                            case $3a69c4d89250e3bc$var$p:
                            case $3a69c4d89250e3bc$var$n:
                            case $3a69c4d89250e3bc$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $3a69c4d89250e3bc$var$c:
                return t;
        }
    }
}
var $3a69c4d89250e3bc$var$z = $3a69c4d89250e3bc$var$g, $3a69c4d89250e3bc$var$A = $3a69c4d89250e3bc$var$b, $3a69c4d89250e3bc$var$B = $3a69c4d89250e3bc$var$k, $3a69c4d89250e3bc$var$C = $3a69c4d89250e3bc$var$d, $3a69c4d89250e3bc$var$D = $3a69c4d89250e3bc$var$p, $3a69c4d89250e3bc$var$E = $3a69c4d89250e3bc$var$n, $3a69c4d89250e3bc$var$F = $3a69c4d89250e3bc$var$c, $3a69c4d89250e3bc$var$G = $3a69c4d89250e3bc$var$f, $3a69c4d89250e3bc$var$H = $3a69c4d89250e3bc$var$e, $3a69c4d89250e3bc$var$I = $3a69c4d89250e3bc$var$l;
$3a69c4d89250e3bc$export$a7c73072b1a182ae = $3a69c4d89250e3bc$var$h;
$3a69c4d89250e3bc$export$9f27bc3417b4524d = $3a69c4d89250e3bc$var$z;
$3a69c4d89250e3bc$export$db77ccec0bb4ccac = $3a69c4d89250e3bc$var$A;
$3a69c4d89250e3bc$export$8392c0c9d3dcbd35 = $3a69c4d89250e3bc$var$B;
$3a69c4d89250e3bc$export$ffb0004e005737fa = $3a69c4d89250e3bc$var$C;
$3a69c4d89250e3bc$export$b624eff549462981 = $3a69c4d89250e3bc$var$D;
$3a69c4d89250e3bc$export$7897aa7841a5380c = $3a69c4d89250e3bc$var$E;
$3a69c4d89250e3bc$export$602eac185826482c = $3a69c4d89250e3bc$var$F;
$3a69c4d89250e3bc$export$e2c29f18771995cb = $3a69c4d89250e3bc$var$G;
$3a69c4d89250e3bc$export$5f8d39834fd61797 = $3a69c4d89250e3bc$var$H;
$3a69c4d89250e3bc$export$74bf444e3cd11ea5 = $3a69c4d89250e3bc$var$I;
$3a69c4d89250e3bc$export$92387174baf9b227 = function() {
    return !1;
};
$3a69c4d89250e3bc$export$ec112efeb987d9c6 = function() {
    return !1;
};
$3a69c4d89250e3bc$export$b706b080d889d2c9 = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$h;
};
$3a69c4d89250e3bc$export$5be5a87408f70ddc = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$g;
};
$3a69c4d89250e3bc$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3a69c4d89250e3bc$var$b;
};
$3a69c4d89250e3bc$export$455c2e768291efa6 = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$k;
};
$3a69c4d89250e3bc$export$9522e17588c12572 = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$d;
};
$3a69c4d89250e3bc$export$2110ac352bb060b9 = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$p;
};
$3a69c4d89250e3bc$export$56885ab8b9c456ab = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$n;
};
$3a69c4d89250e3bc$export$d927fcb6adf8f9de = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$c;
};
$3a69c4d89250e3bc$export$b82d16f27459e05a = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$f;
};
$3a69c4d89250e3bc$export$522c17b4f5e123e8 = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$e;
};
$3a69c4d89250e3bc$export$1aabd8a0274ecfd6 = function(a) {
    return $3a69c4d89250e3bc$var$y(a) === $3a69c4d89250e3bc$var$l;
};
$3a69c4d89250e3bc$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3a69c4d89250e3bc$var$d || a === $3a69c4d89250e3bc$var$f || a === $3a69c4d89250e3bc$var$v || a === $3a69c4d89250e3bc$var$e || a === $3a69c4d89250e3bc$var$l || a === $3a69c4d89250e3bc$var$m || a === $3a69c4d89250e3bc$var$w || "object" === typeof a && null !== a && (a.$$typeof === $3a69c4d89250e3bc$var$p || a.$$typeof === $3a69c4d89250e3bc$var$n || a.$$typeof === $3a69c4d89250e3bc$var$g || a.$$typeof === $3a69c4d89250e3bc$var$h || a.$$typeof === $3a69c4d89250e3bc$var$k || a.$$typeof === $3a69c4d89250e3bc$var$u || a.$$typeof === $3a69c4d89250e3bc$var$q || a[0] === $3a69c4d89250e3bc$var$r) ? !0 : !1;
};
$3a69c4d89250e3bc$export$f5bbd400c2f4426f = $3a69c4d89250e3bc$var$y;

});

parcelRequire.register("87r5V", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $5e93fe9694875c06$export$ae55be85d98224ed, (v) => $5e93fe9694875c06$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $5e93fe9694875c06$export$d39a5bbd09211389, (v) => $5e93fe9694875c06$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $5e93fe9694875c06$export$882461b6382ed46c, (v) => $5e93fe9694875c06$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $5e93fe9694875c06$export$466bfc07425424d5, (v) => $5e93fe9694875c06$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $5e93fe9694875c06$export$cd75ccfd720a3cd4, (v) => $5e93fe9694875c06$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $5e93fe9694875c06$export$fa8d919ba61d84db, (v) => $5e93fe9694875c06$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $5e93fe9694875c06$export$757ceba2d55c277e, (v) => $5e93fe9694875c06$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $5e93fe9694875c06$export$b3890eb0ae9dca99, (v) => $5e93fe9694875c06$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $5e93fe9694875c06$export$502457920280e6be, (v) => $5e93fe9694875c06$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $5e93fe9694875c06$export$c78a37762a8d58e1, (v) => $5e93fe9694875c06$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $5e93fe9694875c06$export$dc54d992c10e8a18, (v) => $5e93fe9694875c06$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $5e93fe9694875c06$export$83d89fbfd8236492, (v) => $5e93fe9694875c06$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5e93fe9694875c06$export$ae55be85d98224ed;
var $5e93fe9694875c06$export$d39a5bbd09211389;
var $5e93fe9694875c06$export$882461b6382ed46c;
var $5e93fe9694875c06$export$466bfc07425424d5;
var $5e93fe9694875c06$export$cd75ccfd720a3cd4;
var $5e93fe9694875c06$export$fa8d919ba61d84db;
var $5e93fe9694875c06$export$757ceba2d55c277e;
var $5e93fe9694875c06$export$b3890eb0ae9dca99;
var $5e93fe9694875c06$export$502457920280e6be;
var $5e93fe9694875c06$export$c78a37762a8d58e1;
var $5e93fe9694875c06$export$dc54d992c10e8a18;
var $5e93fe9694875c06$export$83d89fbfd8236492;
"use strict";

var $4hYjL = parcelRequire("4hYjL");

var $dmA7Z = parcelRequire("dmA7Z");
function $5e93fe9694875c06$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5e93fe9694875c06$var$da = new Set, $5e93fe9694875c06$var$ea = {};
function $5e93fe9694875c06$var$fa(a, b) {
    $5e93fe9694875c06$var$ha(a, b);
    $5e93fe9694875c06$var$ha(a + "Capture", b);
}
function $5e93fe9694875c06$var$ha(a, b) {
    $5e93fe9694875c06$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$5e93fe9694875c06$var$da.add(b[a]);
}
var $5e93fe9694875c06$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5e93fe9694875c06$var$ja = Object.prototype.hasOwnProperty, $5e93fe9694875c06$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5e93fe9694875c06$var$la = {}, $5e93fe9694875c06$var$ma = {};
function $5e93fe9694875c06$var$oa(a) {
    if ($5e93fe9694875c06$var$ja.call($5e93fe9694875c06$var$ma, a)) return !0;
    if ($5e93fe9694875c06$var$ja.call($5e93fe9694875c06$var$la, a)) return !1;
    if ($5e93fe9694875c06$var$ka.test(a)) return $5e93fe9694875c06$var$ma[a] = !0;
    $5e93fe9694875c06$var$la[a] = !0;
    return !1;
}
function $5e93fe9694875c06$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5e93fe9694875c06$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5e93fe9694875c06$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5e93fe9694875c06$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $5e93fe9694875c06$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5e93fe9694875c06$var$z[b] = new $5e93fe9694875c06$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5e93fe9694875c06$var$ra = /[\-:]([a-z])/g;
function $5e93fe9694875c06$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5e93fe9694875c06$var$ra, $5e93fe9694875c06$var$sa);
    $5e93fe9694875c06$var$z[b] = new $5e93fe9694875c06$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5e93fe9694875c06$var$ra, $5e93fe9694875c06$var$sa);
    $5e93fe9694875c06$var$z[b] = new $5e93fe9694875c06$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5e93fe9694875c06$var$ra, $5e93fe9694875c06$var$sa);
    $5e93fe9694875c06$var$z[b] = new $5e93fe9694875c06$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5e93fe9694875c06$var$z.xlinkHref = new $5e93fe9694875c06$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5e93fe9694875c06$var$z[a] = new $5e93fe9694875c06$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $5e93fe9694875c06$var$ta(a, b, c, d) {
    var e = $5e93fe9694875c06$var$z.hasOwnProperty(b) ? $5e93fe9694875c06$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $5e93fe9694875c06$var$qa(b, c, e, d) && (c = null), d || null === e ? $5e93fe9694875c06$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $5e93fe9694875c06$var$ua = $4hYjL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $5e93fe9694875c06$var$va = Symbol.for("react.element"), $5e93fe9694875c06$var$wa = Symbol.for("react.portal"), $5e93fe9694875c06$var$ya = Symbol.for("react.fragment"), $5e93fe9694875c06$var$za = Symbol.for("react.strict_mode"), $5e93fe9694875c06$var$Aa = Symbol.for("react.profiler"), $5e93fe9694875c06$var$Ba = Symbol.for("react.provider"), $5e93fe9694875c06$var$Ca = Symbol.for("react.context"), $5e93fe9694875c06$var$Da = Symbol.for("react.forward_ref"), $5e93fe9694875c06$var$Ea = Symbol.for("react.suspense"), $5e93fe9694875c06$var$Fa = Symbol.for("react.suspense_list"), $5e93fe9694875c06$var$Ga = Symbol.for("react.memo"), $5e93fe9694875c06$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $5e93fe9694875c06$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $5e93fe9694875c06$var$Ja = Symbol.iterator;
function $5e93fe9694875c06$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5e93fe9694875c06$var$Ja && a[$5e93fe9694875c06$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5e93fe9694875c06$var$A = Object.assign, $5e93fe9694875c06$var$La;
function $5e93fe9694875c06$var$Ma(a) {
    if (void 0 === $5e93fe9694875c06$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $5e93fe9694875c06$var$La = b && b[1] || "";
    }
    return "\n" + $5e93fe9694875c06$var$La + a;
}
var $5e93fe9694875c06$var$Na = !1;
function $5e93fe9694875c06$var$Oa(a, b) {
    if (!a || $5e93fe9694875c06$var$Na) return "";
    $5e93fe9694875c06$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $5e93fe9694875c06$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $5e93fe9694875c06$var$Ma(a) : "";
}
function $5e93fe9694875c06$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $5e93fe9694875c06$var$Ma(a.type);
        case 16:
            return $5e93fe9694875c06$var$Ma("Lazy");
        case 13:
            return $5e93fe9694875c06$var$Ma("Suspense");
        case 19:
            return $5e93fe9694875c06$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $5e93fe9694875c06$var$Oa(a.type, !1), a;
        case 11:
            return a = $5e93fe9694875c06$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $5e93fe9694875c06$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $5e93fe9694875c06$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5e93fe9694875c06$var$ya:
            return "Fragment";
        case $5e93fe9694875c06$var$wa:
            return "Portal";
        case $5e93fe9694875c06$var$Aa:
            return "Profiler";
        case $5e93fe9694875c06$var$za:
            return "StrictMode";
        case $5e93fe9694875c06$var$Ea:
            return "Suspense";
        case $5e93fe9694875c06$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5e93fe9694875c06$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $5e93fe9694875c06$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $5e93fe9694875c06$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5e93fe9694875c06$var$Ga:
            return b = a.displayName || null, null !== b ? b : $5e93fe9694875c06$var$Qa(a.type) || "Memo";
        case $5e93fe9694875c06$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $5e93fe9694875c06$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $5e93fe9694875c06$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $5e93fe9694875c06$var$Qa(b);
        case 8:
            return b === $5e93fe9694875c06$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $5e93fe9694875c06$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $5e93fe9694875c06$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5e93fe9694875c06$var$Ua(a) {
    var b = $5e93fe9694875c06$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5e93fe9694875c06$var$Va(a) {
    a._valueTracker || (a._valueTracker = $5e93fe9694875c06$var$Ua(a));
}
function $5e93fe9694875c06$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5e93fe9694875c06$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5e93fe9694875c06$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5e93fe9694875c06$var$Ya(a, b) {
    var c = b.checked;
    return $5e93fe9694875c06$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5e93fe9694875c06$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5e93fe9694875c06$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5e93fe9694875c06$var$ab(a, b) {
    b = b.checked;
    null != b && $5e93fe9694875c06$var$ta(a, "checked", b, !1);
}
function $5e93fe9694875c06$var$bb(a, b) {
    $5e93fe9694875c06$var$ab(a, b);
    var c = $5e93fe9694875c06$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5e93fe9694875c06$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5e93fe9694875c06$var$cb(a, b.type, $5e93fe9694875c06$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5e93fe9694875c06$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5e93fe9694875c06$var$cb(a, b, c) {
    if ("number" !== b || $5e93fe9694875c06$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $5e93fe9694875c06$var$eb = Array.isArray;
function $5e93fe9694875c06$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5e93fe9694875c06$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5e93fe9694875c06$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5e93fe9694875c06$var$p(91));
    return $5e93fe9694875c06$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5e93fe9694875c06$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5e93fe9694875c06$var$p(92));
            if ($5e93fe9694875c06$var$eb(c)) {
                if (1 < c.length) throw Error($5e93fe9694875c06$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5e93fe9694875c06$var$Sa(c)
    };
}
function $5e93fe9694875c06$var$ib(a, b) {
    var c = $5e93fe9694875c06$var$Sa(b.value), d = $5e93fe9694875c06$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5e93fe9694875c06$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $5e93fe9694875c06$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5e93fe9694875c06$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5e93fe9694875c06$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5e93fe9694875c06$var$mb, $5e93fe9694875c06$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $5e93fe9694875c06$var$mb = $5e93fe9694875c06$var$mb || document.createElement("div");
        $5e93fe9694875c06$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5e93fe9694875c06$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5e93fe9694875c06$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $5e93fe9694875c06$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5e93fe9694875c06$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5e93fe9694875c06$var$pb).forEach(function(a) {
    $5e93fe9694875c06$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5e93fe9694875c06$var$pb[b] = $5e93fe9694875c06$var$pb[a];
    });
});
function $5e93fe9694875c06$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5e93fe9694875c06$var$pb.hasOwnProperty(a) && $5e93fe9694875c06$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $5e93fe9694875c06$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5e93fe9694875c06$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5e93fe9694875c06$var$tb = $5e93fe9694875c06$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5e93fe9694875c06$var$ub(a, b) {
    if (b) {
        if ($5e93fe9694875c06$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5e93fe9694875c06$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5e93fe9694875c06$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($5e93fe9694875c06$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5e93fe9694875c06$var$p(62));
    }
}
function $5e93fe9694875c06$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5e93fe9694875c06$var$wb = null;
function $5e93fe9694875c06$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $5e93fe9694875c06$var$yb = null, $5e93fe9694875c06$var$zb = null, $5e93fe9694875c06$var$Ab = null;
function $5e93fe9694875c06$var$Bb(a) {
    if (a = $5e93fe9694875c06$var$Cb(a)) {
        if ("function" !== typeof $5e93fe9694875c06$var$yb) throw Error($5e93fe9694875c06$var$p(280));
        var b = a.stateNode;
        b && (b = $5e93fe9694875c06$var$Db(b), $5e93fe9694875c06$var$yb(a.stateNode, a.type, b));
    }
}
function $5e93fe9694875c06$var$Eb(a) {
    $5e93fe9694875c06$var$zb ? $5e93fe9694875c06$var$Ab ? $5e93fe9694875c06$var$Ab.push(a) : $5e93fe9694875c06$var$Ab = [
        a
    ] : $5e93fe9694875c06$var$zb = a;
}
function $5e93fe9694875c06$var$Fb() {
    if ($5e93fe9694875c06$var$zb) {
        var a = $5e93fe9694875c06$var$zb, b = $5e93fe9694875c06$var$Ab;
        $5e93fe9694875c06$var$Ab = $5e93fe9694875c06$var$zb = null;
        $5e93fe9694875c06$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$5e93fe9694875c06$var$Bb(b[a]);
    }
}
function $5e93fe9694875c06$var$Gb(a, b) {
    return a(b);
}
function $5e93fe9694875c06$var$Hb() {}
var $5e93fe9694875c06$var$Ib = !1;
function $5e93fe9694875c06$var$Jb(a, b, c) {
    if ($5e93fe9694875c06$var$Ib) return a(b, c);
    $5e93fe9694875c06$var$Ib = !0;
    try {
        return $5e93fe9694875c06$var$Gb(a, b, c);
    } finally{
        if ($5e93fe9694875c06$var$Ib = !1, null !== $5e93fe9694875c06$var$zb || null !== $5e93fe9694875c06$var$Ab) $5e93fe9694875c06$var$Hb(), $5e93fe9694875c06$var$Fb();
    }
}
function $5e93fe9694875c06$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $5e93fe9694875c06$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5e93fe9694875c06$var$p(231, b, typeof c));
    return c;
}
var $5e93fe9694875c06$var$Lb = !1;
if ($5e93fe9694875c06$var$ia) try {
    var $5e93fe9694875c06$var$Mb = {};
    Object.defineProperty($5e93fe9694875c06$var$Mb, "passive", {
        get: function() {
            $5e93fe9694875c06$var$Lb = !0;
        }
    });
    window.addEventListener("test", $5e93fe9694875c06$var$Mb, $5e93fe9694875c06$var$Mb);
    window.removeEventListener("test", $5e93fe9694875c06$var$Mb, $5e93fe9694875c06$var$Mb);
} catch (a) {
    $5e93fe9694875c06$var$Lb = !1;
}
function $5e93fe9694875c06$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5e93fe9694875c06$var$Ob = !1, $5e93fe9694875c06$var$Pb = null, $5e93fe9694875c06$var$Qb = !1, $5e93fe9694875c06$var$Rb = null, $5e93fe9694875c06$var$Sb = {
    onError: function(a) {
        $5e93fe9694875c06$var$Ob = !0;
        $5e93fe9694875c06$var$Pb = a;
    }
};
function $5e93fe9694875c06$var$Tb(a, b, c, d, e, f, g, h, k) {
    $5e93fe9694875c06$var$Ob = !1;
    $5e93fe9694875c06$var$Pb = null;
    $5e93fe9694875c06$var$Nb.apply($5e93fe9694875c06$var$Sb, arguments);
}
function $5e93fe9694875c06$var$Ub(a, b, c, d, e, f, g, h, k) {
    $5e93fe9694875c06$var$Tb.apply(this, arguments);
    if ($5e93fe9694875c06$var$Ob) {
        if ($5e93fe9694875c06$var$Ob) {
            var l = $5e93fe9694875c06$var$Pb;
            $5e93fe9694875c06$var$Ob = !1;
            $5e93fe9694875c06$var$Pb = null;
        } else throw Error($5e93fe9694875c06$var$p(198));
        $5e93fe9694875c06$var$Qb || ($5e93fe9694875c06$var$Qb = !0, $5e93fe9694875c06$var$Rb = l);
    }
}
function $5e93fe9694875c06$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5e93fe9694875c06$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5e93fe9694875c06$var$Xb(a) {
    if ($5e93fe9694875c06$var$Vb(a) !== a) throw Error($5e93fe9694875c06$var$p(188));
}
function $5e93fe9694875c06$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $5e93fe9694875c06$var$Vb(a);
        if (null === b) throw Error($5e93fe9694875c06$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5e93fe9694875c06$var$Xb(e), a;
                if (f === d) return $5e93fe9694875c06$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($5e93fe9694875c06$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5e93fe9694875c06$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($5e93fe9694875c06$var$p(190));
    }
    if (3 !== c.tag) throw Error($5e93fe9694875c06$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $5e93fe9694875c06$var$Zb(a) {
    a = $5e93fe9694875c06$var$Yb(a);
    return null !== a ? $5e93fe9694875c06$var$$b(a) : null;
}
function $5e93fe9694875c06$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $5e93fe9694875c06$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $5e93fe9694875c06$var$ac = $dmA7Z.unstable_scheduleCallback, $5e93fe9694875c06$var$bc = $dmA7Z.unstable_cancelCallback, $5e93fe9694875c06$var$cc = $dmA7Z.unstable_shouldYield, $5e93fe9694875c06$var$dc = $dmA7Z.unstable_requestPaint, $5e93fe9694875c06$var$B = $dmA7Z.unstable_now, $5e93fe9694875c06$var$ec = $dmA7Z.unstable_getCurrentPriorityLevel, $5e93fe9694875c06$var$fc = $dmA7Z.unstable_ImmediatePriority, $5e93fe9694875c06$var$gc = $dmA7Z.unstable_UserBlockingPriority, $5e93fe9694875c06$var$hc = $dmA7Z.unstable_NormalPriority, $5e93fe9694875c06$var$ic = $dmA7Z.unstable_LowPriority, $5e93fe9694875c06$var$jc = $dmA7Z.unstable_IdlePriority, $5e93fe9694875c06$var$kc = null, $5e93fe9694875c06$var$lc = null;
function $5e93fe9694875c06$var$mc(a) {
    if ($5e93fe9694875c06$var$lc && "function" === typeof $5e93fe9694875c06$var$lc.onCommitFiberRoot) try {
        $5e93fe9694875c06$var$lc.onCommitFiberRoot($5e93fe9694875c06$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $5e93fe9694875c06$var$oc = Math.clz32 ? Math.clz32 : $5e93fe9694875c06$var$nc, $5e93fe9694875c06$var$pc = Math.log, $5e93fe9694875c06$var$qc = Math.LN2;
function $5e93fe9694875c06$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5e93fe9694875c06$var$pc(a) / $5e93fe9694875c06$var$qc | 0) | 0;
}
var $5e93fe9694875c06$var$rc = 64, $5e93fe9694875c06$var$sc = 4194304;
function $5e93fe9694875c06$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $5e93fe9694875c06$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $5e93fe9694875c06$var$tc(h) : (f &= g, 0 !== f && (d = $5e93fe9694875c06$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $5e93fe9694875c06$var$tc(g) : 0 !== f && (d = $5e93fe9694875c06$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $5e93fe9694875c06$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $5e93fe9694875c06$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5e93fe9694875c06$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $5e93fe9694875c06$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $5e93fe9694875c06$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $5e93fe9694875c06$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $5e93fe9694875c06$var$yc() {
    var a = $5e93fe9694875c06$var$rc;
    $5e93fe9694875c06$var$rc <<= 1;
    0 === ($5e93fe9694875c06$var$rc & 4194240) && ($5e93fe9694875c06$var$rc = 64);
    return a;
}
function $5e93fe9694875c06$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $5e93fe9694875c06$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $5e93fe9694875c06$var$oc(b);
    a[b] = c;
}
function $5e93fe9694875c06$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $5e93fe9694875c06$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $5e93fe9694875c06$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $5e93fe9694875c06$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $5e93fe9694875c06$var$C = 0;
function $5e93fe9694875c06$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $5e93fe9694875c06$var$Ec, $5e93fe9694875c06$var$Fc, $5e93fe9694875c06$var$Gc, $5e93fe9694875c06$var$Hc, $5e93fe9694875c06$var$Ic, $5e93fe9694875c06$var$Jc = !1, $5e93fe9694875c06$var$Kc = [], $5e93fe9694875c06$var$Lc = null, $5e93fe9694875c06$var$Mc = null, $5e93fe9694875c06$var$Nc = null, $5e93fe9694875c06$var$Oc = new Map, $5e93fe9694875c06$var$Pc = new Map, $5e93fe9694875c06$var$Qc = [], $5e93fe9694875c06$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $5e93fe9694875c06$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $5e93fe9694875c06$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5e93fe9694875c06$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5e93fe9694875c06$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5e93fe9694875c06$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5e93fe9694875c06$var$Pc.delete(b.pointerId);
    }
}
function $5e93fe9694875c06$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $5e93fe9694875c06$var$Cb(b), null !== b && $5e93fe9694875c06$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $5e93fe9694875c06$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $5e93fe9694875c06$var$Lc = $5e93fe9694875c06$var$Tc($5e93fe9694875c06$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $5e93fe9694875c06$var$Mc = $5e93fe9694875c06$var$Tc($5e93fe9694875c06$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $5e93fe9694875c06$var$Nc = $5e93fe9694875c06$var$Tc($5e93fe9694875c06$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5e93fe9694875c06$var$Oc.set(f, $5e93fe9694875c06$var$Tc($5e93fe9694875c06$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5e93fe9694875c06$var$Pc.set(f, $5e93fe9694875c06$var$Tc($5e93fe9694875c06$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5e93fe9694875c06$var$Vc(a) {
    var b = $5e93fe9694875c06$var$Wc(a.target);
    if (null !== b) {
        var c = $5e93fe9694875c06$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5e93fe9694875c06$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $5e93fe9694875c06$var$Ic(a.priority, function() {
                        $5e93fe9694875c06$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5e93fe9694875c06$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $5e93fe9694875c06$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $5e93fe9694875c06$var$wb = d;
            c.target.dispatchEvent(d);
            $5e93fe9694875c06$var$wb = null;
        } else return b = $5e93fe9694875c06$var$Cb(c), null !== b && $5e93fe9694875c06$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $5e93fe9694875c06$var$Zc(a, b, c) {
    $5e93fe9694875c06$var$Xc(a) && c.delete(b);
}
function $5e93fe9694875c06$var$$c() {
    $5e93fe9694875c06$var$Jc = !1;
    null !== $5e93fe9694875c06$var$Lc && $5e93fe9694875c06$var$Xc($5e93fe9694875c06$var$Lc) && ($5e93fe9694875c06$var$Lc = null);
    null !== $5e93fe9694875c06$var$Mc && $5e93fe9694875c06$var$Xc($5e93fe9694875c06$var$Mc) && ($5e93fe9694875c06$var$Mc = null);
    null !== $5e93fe9694875c06$var$Nc && $5e93fe9694875c06$var$Xc($5e93fe9694875c06$var$Nc) && ($5e93fe9694875c06$var$Nc = null);
    $5e93fe9694875c06$var$Oc.forEach($5e93fe9694875c06$var$Zc);
    $5e93fe9694875c06$var$Pc.forEach($5e93fe9694875c06$var$Zc);
}
function $5e93fe9694875c06$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5e93fe9694875c06$var$Jc || ($5e93fe9694875c06$var$Jc = !0, $dmA7Z.unstable_scheduleCallback($dmA7Z.unstable_NormalPriority, $5e93fe9694875c06$var$$c)));
}
function $5e93fe9694875c06$var$bd(a) {
    function b(b) {
        return $5e93fe9694875c06$var$ad(b, a);
    }
    if (0 < $5e93fe9694875c06$var$Kc.length) {
        $5e93fe9694875c06$var$ad($5e93fe9694875c06$var$Kc[0], a);
        for(var c = 1; c < $5e93fe9694875c06$var$Kc.length; c++){
            var d = $5e93fe9694875c06$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5e93fe9694875c06$var$Lc && $5e93fe9694875c06$var$ad($5e93fe9694875c06$var$Lc, a);
    null !== $5e93fe9694875c06$var$Mc && $5e93fe9694875c06$var$ad($5e93fe9694875c06$var$Mc, a);
    null !== $5e93fe9694875c06$var$Nc && $5e93fe9694875c06$var$ad($5e93fe9694875c06$var$Nc, a);
    $5e93fe9694875c06$var$Oc.forEach(b);
    $5e93fe9694875c06$var$Pc.forEach(b);
    for(c = 0; c < $5e93fe9694875c06$var$Qc.length; c++)d = $5e93fe9694875c06$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5e93fe9694875c06$var$Qc.length && (c = $5e93fe9694875c06$var$Qc[0], null === c.blockedOn);)$5e93fe9694875c06$var$Vc(c), null === c.blockedOn && $5e93fe9694875c06$var$Qc.shift();
}
var $5e93fe9694875c06$var$cd = $5e93fe9694875c06$var$ua.ReactCurrentBatchConfig, $5e93fe9694875c06$var$dd = !0;
function $5e93fe9694875c06$var$ed(a, b, c, d) {
    var e = $5e93fe9694875c06$var$C, f = $5e93fe9694875c06$var$cd.transition;
    $5e93fe9694875c06$var$cd.transition = null;
    try {
        $5e93fe9694875c06$var$C = 1, $5e93fe9694875c06$var$fd(a, b, c, d);
    } finally{
        $5e93fe9694875c06$var$C = e, $5e93fe9694875c06$var$cd.transition = f;
    }
}
function $5e93fe9694875c06$var$gd(a, b, c, d) {
    var e = $5e93fe9694875c06$var$C, f = $5e93fe9694875c06$var$cd.transition;
    $5e93fe9694875c06$var$cd.transition = null;
    try {
        $5e93fe9694875c06$var$C = 4, $5e93fe9694875c06$var$fd(a, b, c, d);
    } finally{
        $5e93fe9694875c06$var$C = e, $5e93fe9694875c06$var$cd.transition = f;
    }
}
function $5e93fe9694875c06$var$fd(a, b, c, d) {
    if ($5e93fe9694875c06$var$dd) {
        var e = $5e93fe9694875c06$var$Yc(a, b, c, d);
        if (null === e) $5e93fe9694875c06$var$hd(a, b, d, $5e93fe9694875c06$var$id, c), $5e93fe9694875c06$var$Sc(a, d);
        else if ($5e93fe9694875c06$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($5e93fe9694875c06$var$Sc(a, d), b & 4 && -1 < $5e93fe9694875c06$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $5e93fe9694875c06$var$Cb(e);
                null !== f && $5e93fe9694875c06$var$Ec(f);
                f = $5e93fe9694875c06$var$Yc(a, b, c, d);
                null === f && $5e93fe9694875c06$var$hd(a, b, d, $5e93fe9694875c06$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $5e93fe9694875c06$var$hd(a, b, d, null, c);
    }
}
var $5e93fe9694875c06$var$id = null;
function $5e93fe9694875c06$var$Yc(a, b, c, d) {
    $5e93fe9694875c06$var$id = null;
    a = $5e93fe9694875c06$var$xb(d);
    a = $5e93fe9694875c06$var$Wc(a);
    if (null !== a) {
        if (b = $5e93fe9694875c06$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $5e93fe9694875c06$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $5e93fe9694875c06$var$id = a;
    return null;
}
function $5e93fe9694875c06$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($5e93fe9694875c06$var$ec()){
                case $5e93fe9694875c06$var$fc:
                    return 1;
                case $5e93fe9694875c06$var$gc:
                    return 4;
                case $5e93fe9694875c06$var$hc:
                case $5e93fe9694875c06$var$ic:
                    return 16;
                case $5e93fe9694875c06$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $5e93fe9694875c06$var$kd = null, $5e93fe9694875c06$var$ld = null, $5e93fe9694875c06$var$md = null;
function $5e93fe9694875c06$var$nd() {
    if ($5e93fe9694875c06$var$md) return $5e93fe9694875c06$var$md;
    var a, b = $5e93fe9694875c06$var$ld, c = b.length, d, e = "value" in $5e93fe9694875c06$var$kd ? $5e93fe9694875c06$var$kd.value : $5e93fe9694875c06$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5e93fe9694875c06$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5e93fe9694875c06$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $5e93fe9694875c06$var$pd() {
    return !0;
}
function $5e93fe9694875c06$var$qd() {
    return !1;
}
function $5e93fe9694875c06$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $5e93fe9694875c06$var$pd : $5e93fe9694875c06$var$qd;
        this.isPropagationStopped = $5e93fe9694875c06$var$qd;
        return this;
    }
    $5e93fe9694875c06$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $5e93fe9694875c06$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $5e93fe9694875c06$var$pd);
        },
        persist: function() {},
        isPersistent: $5e93fe9694875c06$var$pd
    });
    return b;
}
var $5e93fe9694875c06$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5e93fe9694875c06$var$td = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$sd), $5e93fe9694875c06$var$ud = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$sd, {
    view: 0,
    detail: 0
}), $5e93fe9694875c06$var$vd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$ud), $5e93fe9694875c06$var$wd, $5e93fe9694875c06$var$xd, $5e93fe9694875c06$var$yd, $5e93fe9694875c06$var$Ad = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5e93fe9694875c06$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $5e93fe9694875c06$var$yd && ($5e93fe9694875c06$var$yd && "mousemove" === a.type ? ($5e93fe9694875c06$var$wd = a.screenX - $5e93fe9694875c06$var$yd.screenX, $5e93fe9694875c06$var$xd = a.screenY - $5e93fe9694875c06$var$yd.screenY) : $5e93fe9694875c06$var$xd = $5e93fe9694875c06$var$wd = 0, $5e93fe9694875c06$var$yd = a);
        return $5e93fe9694875c06$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $5e93fe9694875c06$var$xd;
    }
}), $5e93fe9694875c06$var$Bd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Ad), $5e93fe9694875c06$var$Cd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$Ad, {
    dataTransfer: 0
}), $5e93fe9694875c06$var$Dd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Cd), $5e93fe9694875c06$var$Ed = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$ud, {
    relatedTarget: 0
}), $5e93fe9694875c06$var$Fd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Ed), $5e93fe9694875c06$var$Gd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5e93fe9694875c06$var$Hd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Gd), $5e93fe9694875c06$var$Id = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5e93fe9694875c06$var$Jd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Id), $5e93fe9694875c06$var$Kd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$sd, {
    data: 0
}), $5e93fe9694875c06$var$Ld = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Kd), $5e93fe9694875c06$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5e93fe9694875c06$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5e93fe9694875c06$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5e93fe9694875c06$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5e93fe9694875c06$var$Od[a]) ? !!b[a] : !1;
}
function $5e93fe9694875c06$var$zd() {
    return $5e93fe9694875c06$var$Pd;
}
var $5e93fe9694875c06$var$Qd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $5e93fe9694875c06$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5e93fe9694875c06$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5e93fe9694875c06$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5e93fe9694875c06$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $5e93fe9694875c06$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $5e93fe9694875c06$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5e93fe9694875c06$var$Rd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Qd), $5e93fe9694875c06$var$Sd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5e93fe9694875c06$var$Td = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Sd), $5e93fe9694875c06$var$Ud = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5e93fe9694875c06$var$zd
}), $5e93fe9694875c06$var$Vd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Ud), $5e93fe9694875c06$var$Wd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5e93fe9694875c06$var$Xd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Wd), $5e93fe9694875c06$var$Yd = $5e93fe9694875c06$var$A({}, $5e93fe9694875c06$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5e93fe9694875c06$var$Zd = $5e93fe9694875c06$var$rd($5e93fe9694875c06$var$Yd), $5e93fe9694875c06$var$$d = [
    9,
    13,
    27,
    32
], $5e93fe9694875c06$var$ae = $5e93fe9694875c06$var$ia && "CompositionEvent" in window, $5e93fe9694875c06$var$be = null;
$5e93fe9694875c06$var$ia && "documentMode" in document && ($5e93fe9694875c06$var$be = document.documentMode);
var $5e93fe9694875c06$var$ce = $5e93fe9694875c06$var$ia && "TextEvent" in window && !$5e93fe9694875c06$var$be, $5e93fe9694875c06$var$de = $5e93fe9694875c06$var$ia && (!$5e93fe9694875c06$var$ae || $5e93fe9694875c06$var$be && 8 < $5e93fe9694875c06$var$be && 11 >= $5e93fe9694875c06$var$be), $5e93fe9694875c06$var$ee = String.fromCharCode(32), $5e93fe9694875c06$var$fe = !1;
function $5e93fe9694875c06$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5e93fe9694875c06$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5e93fe9694875c06$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5e93fe9694875c06$var$ie = !1;
function $5e93fe9694875c06$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $5e93fe9694875c06$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5e93fe9694875c06$var$fe = !0;
            return $5e93fe9694875c06$var$ee;
        case "textInput":
            return a = b.data, a === $5e93fe9694875c06$var$ee && $5e93fe9694875c06$var$fe ? null : a;
        default:
            return null;
    }
}
function $5e93fe9694875c06$var$ke(a, b) {
    if ($5e93fe9694875c06$var$ie) return "compositionend" === a || !$5e93fe9694875c06$var$ae && $5e93fe9694875c06$var$ge(a, b) ? (a = $5e93fe9694875c06$var$nd(), $5e93fe9694875c06$var$md = $5e93fe9694875c06$var$ld = $5e93fe9694875c06$var$kd = null, $5e93fe9694875c06$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5e93fe9694875c06$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5e93fe9694875c06$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5e93fe9694875c06$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5e93fe9694875c06$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $5e93fe9694875c06$var$ne(a, b, c, d) {
    $5e93fe9694875c06$var$Eb(d);
    b = $5e93fe9694875c06$var$oe(b, "onChange");
    0 < b.length && (c = new $5e93fe9694875c06$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $5e93fe9694875c06$var$pe = null, $5e93fe9694875c06$var$qe = null;
function $5e93fe9694875c06$var$re(a) {
    $5e93fe9694875c06$var$se(a, 0);
}
function $5e93fe9694875c06$var$te(a) {
    var b = $5e93fe9694875c06$var$ue(a);
    if ($5e93fe9694875c06$var$Wa(b)) return a;
}
function $5e93fe9694875c06$var$ve(a, b) {
    if ("change" === a) return b;
}
var $5e93fe9694875c06$var$we = !1;
if ($5e93fe9694875c06$var$ia) {
    var $5e93fe9694875c06$var$xe;
    if ($5e93fe9694875c06$var$ia) {
        var $5e93fe9694875c06$var$ye = "oninput" in document;
        if (!$5e93fe9694875c06$var$ye) {
            var $5e93fe9694875c06$var$ze = document.createElement("div");
            $5e93fe9694875c06$var$ze.setAttribute("oninput", "return;");
            $5e93fe9694875c06$var$ye = "function" === typeof $5e93fe9694875c06$var$ze.oninput;
        }
        $5e93fe9694875c06$var$xe = $5e93fe9694875c06$var$ye;
    } else $5e93fe9694875c06$var$xe = !1;
    $5e93fe9694875c06$var$we = $5e93fe9694875c06$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $5e93fe9694875c06$var$Ae() {
    $5e93fe9694875c06$var$pe && ($5e93fe9694875c06$var$pe.detachEvent("onpropertychange", $5e93fe9694875c06$var$Be), $5e93fe9694875c06$var$qe = $5e93fe9694875c06$var$pe = null);
}
function $5e93fe9694875c06$var$Be(a) {
    if ("value" === a.propertyName && $5e93fe9694875c06$var$te($5e93fe9694875c06$var$qe)) {
        var b = [];
        $5e93fe9694875c06$var$ne(b, $5e93fe9694875c06$var$qe, a, $5e93fe9694875c06$var$xb(a));
        $5e93fe9694875c06$var$Jb($5e93fe9694875c06$var$re, b);
    }
}
function $5e93fe9694875c06$var$Ce(a, b, c) {
    "focusin" === a ? ($5e93fe9694875c06$var$Ae(), $5e93fe9694875c06$var$pe = b, $5e93fe9694875c06$var$qe = c, $5e93fe9694875c06$var$pe.attachEvent("onpropertychange", $5e93fe9694875c06$var$Be)) : "focusout" === a && $5e93fe9694875c06$var$Ae();
}
function $5e93fe9694875c06$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5e93fe9694875c06$var$te($5e93fe9694875c06$var$qe);
}
function $5e93fe9694875c06$var$Ee(a, b) {
    if ("click" === a) return $5e93fe9694875c06$var$te(b);
}
function $5e93fe9694875c06$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $5e93fe9694875c06$var$te(b);
}
function $5e93fe9694875c06$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5e93fe9694875c06$var$He = "function" === typeof Object.is ? Object.is : $5e93fe9694875c06$var$Ge;
function $5e93fe9694875c06$var$Ie(a, b) {
    if ($5e93fe9694875c06$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$5e93fe9694875c06$var$ja.call(b, e) || !$5e93fe9694875c06$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $5e93fe9694875c06$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5e93fe9694875c06$var$Ke(a, b) {
    var c = $5e93fe9694875c06$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5e93fe9694875c06$var$Je(c);
    }
}
function $5e93fe9694875c06$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5e93fe9694875c06$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5e93fe9694875c06$var$Me() {
    for(var a = window, b = $5e93fe9694875c06$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5e93fe9694875c06$var$Xa(a.document);
    }
    return b;
}
function $5e93fe9694875c06$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $5e93fe9694875c06$var$Oe(a) {
    var b = $5e93fe9694875c06$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $5e93fe9694875c06$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $5e93fe9694875c06$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $5e93fe9694875c06$var$Ke(c, f);
                var g = $5e93fe9694875c06$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $5e93fe9694875c06$var$Pe = $5e93fe9694875c06$var$ia && "documentMode" in document && 11 >= document.documentMode, $5e93fe9694875c06$var$Qe = null, $5e93fe9694875c06$var$Re = null, $5e93fe9694875c06$var$Se = null, $5e93fe9694875c06$var$Te = !1;
function $5e93fe9694875c06$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $5e93fe9694875c06$var$Te || null == $5e93fe9694875c06$var$Qe || $5e93fe9694875c06$var$Qe !== $5e93fe9694875c06$var$Xa(d) || (d = $5e93fe9694875c06$var$Qe, "selectionStart" in d && $5e93fe9694875c06$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $5e93fe9694875c06$var$Se && $5e93fe9694875c06$var$Ie($5e93fe9694875c06$var$Se, d) || ($5e93fe9694875c06$var$Se = d, d = $5e93fe9694875c06$var$oe($5e93fe9694875c06$var$Re, "onSelect"), 0 < d.length && (b = new $5e93fe9694875c06$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $5e93fe9694875c06$var$Qe)));
}
function $5e93fe9694875c06$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5e93fe9694875c06$var$We = {
    animationend: $5e93fe9694875c06$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $5e93fe9694875c06$var$Ve("Animation", "AnimationIteration"),
    animationstart: $5e93fe9694875c06$var$Ve("Animation", "AnimationStart"),
    transitionend: $5e93fe9694875c06$var$Ve("Transition", "TransitionEnd")
}, $5e93fe9694875c06$var$Xe = {}, $5e93fe9694875c06$var$Ye = {};
$5e93fe9694875c06$var$ia && ($5e93fe9694875c06$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $5e93fe9694875c06$var$We.animationend.animation, delete $5e93fe9694875c06$var$We.animationiteration.animation, delete $5e93fe9694875c06$var$We.animationstart.animation), "TransitionEvent" in window || delete $5e93fe9694875c06$var$We.transitionend.transition);
function $5e93fe9694875c06$var$Ze(a) {
    if ($5e93fe9694875c06$var$Xe[a]) return $5e93fe9694875c06$var$Xe[a];
    if (!$5e93fe9694875c06$var$We[a]) return a;
    var b = $5e93fe9694875c06$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5e93fe9694875c06$var$Ye) return $5e93fe9694875c06$var$Xe[a] = b[c];
    return a;
}
var $5e93fe9694875c06$var$$e = $5e93fe9694875c06$var$Ze("animationend"), $5e93fe9694875c06$var$af = $5e93fe9694875c06$var$Ze("animationiteration"), $5e93fe9694875c06$var$bf = $5e93fe9694875c06$var$Ze("animationstart"), $5e93fe9694875c06$var$cf = $5e93fe9694875c06$var$Ze("transitionend"), $5e93fe9694875c06$var$df = new Map, $5e93fe9694875c06$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $5e93fe9694875c06$var$ff(a, b) {
    $5e93fe9694875c06$var$df.set(a, b);
    $5e93fe9694875c06$var$fa(b, [
        a
    ]);
}
for(var $5e93fe9694875c06$var$gf = 0; $5e93fe9694875c06$var$gf < $5e93fe9694875c06$var$ef.length; $5e93fe9694875c06$var$gf++){
    var $5e93fe9694875c06$var$hf = $5e93fe9694875c06$var$ef[$5e93fe9694875c06$var$gf], $5e93fe9694875c06$var$jf = $5e93fe9694875c06$var$hf.toLowerCase(), $5e93fe9694875c06$var$kf = $5e93fe9694875c06$var$hf[0].toUpperCase() + $5e93fe9694875c06$var$hf.slice(1);
    $5e93fe9694875c06$var$ff($5e93fe9694875c06$var$jf, "on" + $5e93fe9694875c06$var$kf);
}
$5e93fe9694875c06$var$ff($5e93fe9694875c06$var$$e, "onAnimationEnd");
$5e93fe9694875c06$var$ff($5e93fe9694875c06$var$af, "onAnimationIteration");
$5e93fe9694875c06$var$ff($5e93fe9694875c06$var$bf, "onAnimationStart");
$5e93fe9694875c06$var$ff("dblclick", "onDoubleClick");
$5e93fe9694875c06$var$ff("focusin", "onFocus");
$5e93fe9694875c06$var$ff("focusout", "onBlur");
$5e93fe9694875c06$var$ff($5e93fe9694875c06$var$cf, "onTransitionEnd");
$5e93fe9694875c06$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5e93fe9694875c06$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5e93fe9694875c06$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5e93fe9694875c06$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5e93fe9694875c06$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5e93fe9694875c06$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5e93fe9694875c06$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5e93fe9694875c06$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5e93fe9694875c06$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5e93fe9694875c06$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5e93fe9694875c06$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5e93fe9694875c06$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($5e93fe9694875c06$var$lf));
function $5e93fe9694875c06$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $5e93fe9694875c06$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $5e93fe9694875c06$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5e93fe9694875c06$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5e93fe9694875c06$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($5e93fe9694875c06$var$Qb) throw a = $5e93fe9694875c06$var$Rb, $5e93fe9694875c06$var$Qb = !1, $5e93fe9694875c06$var$Rb = null, a;
}
function $5e93fe9694875c06$var$D(a, b) {
    var c = b[$5e93fe9694875c06$var$of];
    void 0 === c && (c = b[$5e93fe9694875c06$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($5e93fe9694875c06$var$pf(b, a, 2, !1), c.add(d));
}
function $5e93fe9694875c06$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $5e93fe9694875c06$var$pf(c, a, d, b);
}
var $5e93fe9694875c06$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $5e93fe9694875c06$var$sf(a) {
    if (!a[$5e93fe9694875c06$var$rf]) {
        a[$5e93fe9694875c06$var$rf] = !0;
        $5e93fe9694875c06$var$da.forEach(function(b) {
            "selectionchange" !== b && ($5e93fe9694875c06$var$mf.has(b) || $5e93fe9694875c06$var$qf(b, !1, a), $5e93fe9694875c06$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$5e93fe9694875c06$var$rf] || (b[$5e93fe9694875c06$var$rf] = !0, $5e93fe9694875c06$var$qf("selectionchange", !1, b));
    }
}
function $5e93fe9694875c06$var$pf(a, b, c, d) {
    switch($5e93fe9694875c06$var$jd(b)){
        case 1:
            var e = $5e93fe9694875c06$var$ed;
            break;
        case 4:
            e = $5e93fe9694875c06$var$gd;
            break;
        default:
            e = $5e93fe9694875c06$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$5e93fe9694875c06$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $5e93fe9694875c06$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $5e93fe9694875c06$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $5e93fe9694875c06$var$Jb(function() {
        var d = f, e = $5e93fe9694875c06$var$xb(c), g = [];
        a: {
            var h = $5e93fe9694875c06$var$df.get(a);
            if (void 0 !== h) {
                var k = $5e93fe9694875c06$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $5e93fe9694875c06$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $5e93fe9694875c06$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $5e93fe9694875c06$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $5e93fe9694875c06$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $5e93fe9694875c06$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $5e93fe9694875c06$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $5e93fe9694875c06$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $5e93fe9694875c06$var$Vd;
                        break;
                    case $5e93fe9694875c06$var$$e:
                    case $5e93fe9694875c06$var$af:
                    case $5e93fe9694875c06$var$bf:
                        k = $5e93fe9694875c06$var$Hd;
                        break;
                    case $5e93fe9694875c06$var$cf:
                        k = $5e93fe9694875c06$var$Xd;
                        break;
                    case "scroll":
                        k = $5e93fe9694875c06$var$vd;
                        break;
                    case "wheel":
                        k = $5e93fe9694875c06$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $5e93fe9694875c06$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $5e93fe9694875c06$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $5e93fe9694875c06$var$Kb(w, x), null != F && t.push($5e93fe9694875c06$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $5e93fe9694875c06$var$wb && (n = c.relatedTarget || c.fromElement) && ($5e93fe9694875c06$var$Wc(n) || n[$5e93fe9694875c06$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $5e93fe9694875c06$var$Wc(n) : null, null !== n && (J = $5e93fe9694875c06$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $5e93fe9694875c06$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $5e93fe9694875c06$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $5e93fe9694875c06$var$ue(k);
                        u = null == n ? h : $5e93fe9694875c06$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $5e93fe9694875c06$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $5e93fe9694875c06$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $5e93fe9694875c06$var$vf(F))u++;
                            for(; 0 < w - u;)t = $5e93fe9694875c06$var$vf(t), w--;
                            for(; 0 < u - w;)x = $5e93fe9694875c06$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $5e93fe9694875c06$var$vf(t);
                                x = $5e93fe9694875c06$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $5e93fe9694875c06$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $5e93fe9694875c06$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $5e93fe9694875c06$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $5e93fe9694875c06$var$ve;
                else if ($5e93fe9694875c06$var$me(h)) {
                    if ($5e93fe9694875c06$var$we) na = $5e93fe9694875c06$var$Fe;
                    else {
                        na = $5e93fe9694875c06$var$De;
                        var xa = $5e93fe9694875c06$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $5e93fe9694875c06$var$Ee);
                if (na && (na = na(a, d))) {
                    $5e93fe9694875c06$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $5e93fe9694875c06$var$cb(h, "number", h.value);
            }
            xa = d ? $5e93fe9694875c06$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($5e93fe9694875c06$var$me(xa) || "true" === xa.contentEditable) $5e93fe9694875c06$var$Qe = xa, $5e93fe9694875c06$var$Re = d, $5e93fe9694875c06$var$Se = null;
                    break;
                case "focusout":
                    $5e93fe9694875c06$var$Se = $5e93fe9694875c06$var$Re = $5e93fe9694875c06$var$Qe = null;
                    break;
                case "mousedown":
                    $5e93fe9694875c06$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5e93fe9694875c06$var$Te = !1;
                    $5e93fe9694875c06$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($5e93fe9694875c06$var$Pe) break;
                case "keydown":
                case "keyup":
                    $5e93fe9694875c06$var$Ue(g, c, e);
            }
            var $a;
            if ($5e93fe9694875c06$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $5e93fe9694875c06$var$ie ? $5e93fe9694875c06$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($5e93fe9694875c06$var$de && "ko" !== c.locale && ($5e93fe9694875c06$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $5e93fe9694875c06$var$ie && ($a = $5e93fe9694875c06$var$nd()) : ($5e93fe9694875c06$var$kd = e, $5e93fe9694875c06$var$ld = "value" in $5e93fe9694875c06$var$kd ? $5e93fe9694875c06$var$kd.value : $5e93fe9694875c06$var$kd.textContent, $5e93fe9694875c06$var$ie = !0)), xa = $5e93fe9694875c06$var$oe(d, ba), 0 < xa.length && (ba = new $5e93fe9694875c06$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $5e93fe9694875c06$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $5e93fe9694875c06$var$ce ? $5e93fe9694875c06$var$je(a, c) : $5e93fe9694875c06$var$ke(a, c)) d = $5e93fe9694875c06$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $5e93fe9694875c06$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $5e93fe9694875c06$var$se(g, b);
    });
}
function $5e93fe9694875c06$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $5e93fe9694875c06$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $5e93fe9694875c06$var$Kb(a, c), null != f && d.unshift($5e93fe9694875c06$var$tf(a, f, e)), f = $5e93fe9694875c06$var$Kb(a, b), null != f && d.push($5e93fe9694875c06$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $5e93fe9694875c06$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5e93fe9694875c06$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $5e93fe9694875c06$var$Kb(c, f), null != k && g.unshift($5e93fe9694875c06$var$tf(c, k, h))) : e || (k = $5e93fe9694875c06$var$Kb(c, f), null != k && g.push($5e93fe9694875c06$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $5e93fe9694875c06$var$xf = /\r\n?/g, $5e93fe9694875c06$var$yf = /\u0000|\uFFFD/g;
function $5e93fe9694875c06$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($5e93fe9694875c06$var$xf, "\n").replace($5e93fe9694875c06$var$yf, "");
}
function $5e93fe9694875c06$var$Af(a, b, c) {
    b = $5e93fe9694875c06$var$zf(b);
    if ($5e93fe9694875c06$var$zf(a) !== b && c) throw Error($5e93fe9694875c06$var$p(425));
}
function $5e93fe9694875c06$var$Bf() {}
var $5e93fe9694875c06$var$Cf = null, $5e93fe9694875c06$var$Df = null;
function $5e93fe9694875c06$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5e93fe9694875c06$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $5e93fe9694875c06$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $5e93fe9694875c06$var$Hf = "function" === typeof Promise ? Promise : void 0, $5e93fe9694875c06$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5e93fe9694875c06$var$Hf ? function(a) {
    return $5e93fe9694875c06$var$Hf.resolve(null).then(a).catch($5e93fe9694875c06$var$If);
} : $5e93fe9694875c06$var$Ff;
function $5e93fe9694875c06$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $5e93fe9694875c06$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $5e93fe9694875c06$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $5e93fe9694875c06$var$bd(b);
}
function $5e93fe9694875c06$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $5e93fe9694875c06$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5e93fe9694875c06$var$Nf = Math.random().toString(36).slice(2), $5e93fe9694875c06$var$Of = "__reactFiber$" + $5e93fe9694875c06$var$Nf, $5e93fe9694875c06$var$Pf = "__reactProps$" + $5e93fe9694875c06$var$Nf, $5e93fe9694875c06$var$uf = "__reactContainer$" + $5e93fe9694875c06$var$Nf, $5e93fe9694875c06$var$of = "__reactEvents$" + $5e93fe9694875c06$var$Nf, $5e93fe9694875c06$var$Qf = "__reactListeners$" + $5e93fe9694875c06$var$Nf, $5e93fe9694875c06$var$Rf = "__reactHandles$" + $5e93fe9694875c06$var$Nf;
function $5e93fe9694875c06$var$Wc(a) {
    var b = a[$5e93fe9694875c06$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5e93fe9694875c06$var$uf] || c[$5e93fe9694875c06$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5e93fe9694875c06$var$Mf(a); null !== a;){
                if (c = a[$5e93fe9694875c06$var$Of]) return c;
                a = $5e93fe9694875c06$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5e93fe9694875c06$var$Cb(a) {
    a = a[$5e93fe9694875c06$var$Of] || a[$5e93fe9694875c06$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5e93fe9694875c06$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5e93fe9694875c06$var$p(33));
}
function $5e93fe9694875c06$var$Db(a) {
    return a[$5e93fe9694875c06$var$Pf] || null;
}
var $5e93fe9694875c06$var$Sf = [], $5e93fe9694875c06$var$Tf = -1;
function $5e93fe9694875c06$var$Uf(a) {
    return {
        current: a
    };
}
function $5e93fe9694875c06$var$E(a) {
    0 > $5e93fe9694875c06$var$Tf || (a.current = $5e93fe9694875c06$var$Sf[$5e93fe9694875c06$var$Tf], $5e93fe9694875c06$var$Sf[$5e93fe9694875c06$var$Tf] = null, $5e93fe9694875c06$var$Tf--);
}
function $5e93fe9694875c06$var$G(a, b) {
    $5e93fe9694875c06$var$Tf++;
    $5e93fe9694875c06$var$Sf[$5e93fe9694875c06$var$Tf] = a.current;
    a.current = b;
}
var $5e93fe9694875c06$var$Vf = {}, $5e93fe9694875c06$var$H = $5e93fe9694875c06$var$Uf($5e93fe9694875c06$var$Vf), $5e93fe9694875c06$var$Wf = $5e93fe9694875c06$var$Uf(!1), $5e93fe9694875c06$var$Xf = $5e93fe9694875c06$var$Vf;
function $5e93fe9694875c06$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5e93fe9694875c06$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5e93fe9694875c06$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5e93fe9694875c06$var$$f() {
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wf);
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$H);
}
function $5e93fe9694875c06$var$ag(a, b, c) {
    if ($5e93fe9694875c06$var$H.current !== $5e93fe9694875c06$var$Vf) throw Error($5e93fe9694875c06$var$p(168));
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$H, b);
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$Wf, c);
}
function $5e93fe9694875c06$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($5e93fe9694875c06$var$p(108, $5e93fe9694875c06$var$Ra(a) || "Unknown", e));
    return $5e93fe9694875c06$var$A({}, c, d);
}
function $5e93fe9694875c06$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5e93fe9694875c06$var$Vf;
    $5e93fe9694875c06$var$Xf = $5e93fe9694875c06$var$H.current;
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$H, a);
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$Wf, $5e93fe9694875c06$var$Wf.current);
    return !0;
}
function $5e93fe9694875c06$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5e93fe9694875c06$var$p(169));
    c ? (a = $5e93fe9694875c06$var$bg(a, b, $5e93fe9694875c06$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wf), $5e93fe9694875c06$var$E($5e93fe9694875c06$var$H), $5e93fe9694875c06$var$G($5e93fe9694875c06$var$H, a)) : $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wf);
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$Wf, c);
}
var $5e93fe9694875c06$var$eg = null, $5e93fe9694875c06$var$fg = !1, $5e93fe9694875c06$var$gg = !1;
function $5e93fe9694875c06$var$hg(a) {
    null === $5e93fe9694875c06$var$eg ? $5e93fe9694875c06$var$eg = [
        a
    ] : $5e93fe9694875c06$var$eg.push(a);
}
function $5e93fe9694875c06$var$ig(a) {
    $5e93fe9694875c06$var$fg = !0;
    $5e93fe9694875c06$var$hg(a);
}
function $5e93fe9694875c06$var$jg() {
    if (!$5e93fe9694875c06$var$gg && null !== $5e93fe9694875c06$var$eg) {
        $5e93fe9694875c06$var$gg = !0;
        var a = 0, b = $5e93fe9694875c06$var$C;
        try {
            var c = $5e93fe9694875c06$var$eg;
            for($5e93fe9694875c06$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $5e93fe9694875c06$var$eg = null;
            $5e93fe9694875c06$var$fg = !1;
        } catch (e) {
            throw null !== $5e93fe9694875c06$var$eg && ($5e93fe9694875c06$var$eg = $5e93fe9694875c06$var$eg.slice(a + 1)), $5e93fe9694875c06$var$ac($5e93fe9694875c06$var$fc, $5e93fe9694875c06$var$jg), e;
        } finally{
            $5e93fe9694875c06$var$C = b, $5e93fe9694875c06$var$gg = !1;
        }
    }
    return null;
}
var $5e93fe9694875c06$var$kg = [], $5e93fe9694875c06$var$lg = 0, $5e93fe9694875c06$var$mg = null, $5e93fe9694875c06$var$ng = 0, $5e93fe9694875c06$var$og = [], $5e93fe9694875c06$var$pg = 0, $5e93fe9694875c06$var$qg = null, $5e93fe9694875c06$var$rg = 1, $5e93fe9694875c06$var$sg = "";
function $5e93fe9694875c06$var$tg(a, b) {
    $5e93fe9694875c06$var$kg[$5e93fe9694875c06$var$lg++] = $5e93fe9694875c06$var$ng;
    $5e93fe9694875c06$var$kg[$5e93fe9694875c06$var$lg++] = $5e93fe9694875c06$var$mg;
    $5e93fe9694875c06$var$mg = a;
    $5e93fe9694875c06$var$ng = b;
}
function $5e93fe9694875c06$var$ug(a, b, c) {
    $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg++] = $5e93fe9694875c06$var$rg;
    $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg++] = $5e93fe9694875c06$var$sg;
    $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg++] = $5e93fe9694875c06$var$qg;
    $5e93fe9694875c06$var$qg = a;
    var d = $5e93fe9694875c06$var$rg;
    a = $5e93fe9694875c06$var$sg;
    var e = 32 - $5e93fe9694875c06$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $5e93fe9694875c06$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $5e93fe9694875c06$var$rg = 1 << 32 - $5e93fe9694875c06$var$oc(b) + e | c << e | d;
        $5e93fe9694875c06$var$sg = f + a;
    } else $5e93fe9694875c06$var$rg = 1 << f | c << e | d, $5e93fe9694875c06$var$sg = a;
}
function $5e93fe9694875c06$var$vg(a) {
    null !== a.return && ($5e93fe9694875c06$var$tg(a, 1), $5e93fe9694875c06$var$ug(a, 1, 0));
}
function $5e93fe9694875c06$var$wg(a) {
    for(; a === $5e93fe9694875c06$var$mg;)$5e93fe9694875c06$var$mg = $5e93fe9694875c06$var$kg[--$5e93fe9694875c06$var$lg], $5e93fe9694875c06$var$kg[$5e93fe9694875c06$var$lg] = null, $5e93fe9694875c06$var$ng = $5e93fe9694875c06$var$kg[--$5e93fe9694875c06$var$lg], $5e93fe9694875c06$var$kg[$5e93fe9694875c06$var$lg] = null;
    for(; a === $5e93fe9694875c06$var$qg;)$5e93fe9694875c06$var$qg = $5e93fe9694875c06$var$og[--$5e93fe9694875c06$var$pg], $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg] = null, $5e93fe9694875c06$var$sg = $5e93fe9694875c06$var$og[--$5e93fe9694875c06$var$pg], $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg] = null, $5e93fe9694875c06$var$rg = $5e93fe9694875c06$var$og[--$5e93fe9694875c06$var$pg], $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg] = null;
}
var $5e93fe9694875c06$var$xg = null, $5e93fe9694875c06$var$yg = null, $5e93fe9694875c06$var$I = !1, $5e93fe9694875c06$var$zg = null;
function $5e93fe9694875c06$var$Ag(a, b) {
    var c = $5e93fe9694875c06$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $5e93fe9694875c06$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $5e93fe9694875c06$var$xg = a, $5e93fe9694875c06$var$yg = $5e93fe9694875c06$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $5e93fe9694875c06$var$xg = a, $5e93fe9694875c06$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $5e93fe9694875c06$var$qg ? {
                id: $5e93fe9694875c06$var$rg,
                overflow: $5e93fe9694875c06$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $5e93fe9694875c06$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $5e93fe9694875c06$var$xg = a, $5e93fe9694875c06$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $5e93fe9694875c06$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $5e93fe9694875c06$var$Eg(a) {
    if ($5e93fe9694875c06$var$I) {
        var b = $5e93fe9694875c06$var$yg;
        if (b) {
            var c = b;
            if (!$5e93fe9694875c06$var$Cg(a, b)) {
                if ($5e93fe9694875c06$var$Dg(a)) throw Error($5e93fe9694875c06$var$p(418));
                b = $5e93fe9694875c06$var$Lf(c.nextSibling);
                var d = $5e93fe9694875c06$var$xg;
                b && $5e93fe9694875c06$var$Cg(a, b) ? $5e93fe9694875c06$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $5e93fe9694875c06$var$I = !1, $5e93fe9694875c06$var$xg = a);
            }
        } else {
            if ($5e93fe9694875c06$var$Dg(a)) throw Error($5e93fe9694875c06$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $5e93fe9694875c06$var$I = !1;
            $5e93fe9694875c06$var$xg = a;
        }
    }
}
function $5e93fe9694875c06$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5e93fe9694875c06$var$xg = a;
}
function $5e93fe9694875c06$var$Gg(a) {
    if (a !== $5e93fe9694875c06$var$xg) return !1;
    if (!$5e93fe9694875c06$var$I) return $5e93fe9694875c06$var$Fg(a), $5e93fe9694875c06$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$5e93fe9694875c06$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $5e93fe9694875c06$var$yg)) {
        if ($5e93fe9694875c06$var$Dg(a)) throw $5e93fe9694875c06$var$Hg(), Error($5e93fe9694875c06$var$p(418));
        for(; b;)$5e93fe9694875c06$var$Ag(a, b), b = $5e93fe9694875c06$var$Lf(b.nextSibling);
    }
    $5e93fe9694875c06$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5e93fe9694875c06$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $5e93fe9694875c06$var$yg = $5e93fe9694875c06$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $5e93fe9694875c06$var$yg = null;
        }
    } else $5e93fe9694875c06$var$yg = $5e93fe9694875c06$var$xg ? $5e93fe9694875c06$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $5e93fe9694875c06$var$Hg() {
    for(var a = $5e93fe9694875c06$var$yg; a;)a = $5e93fe9694875c06$var$Lf(a.nextSibling);
}
function $5e93fe9694875c06$var$Ig() {
    $5e93fe9694875c06$var$yg = $5e93fe9694875c06$var$xg = null;
    $5e93fe9694875c06$var$I = !1;
}
function $5e93fe9694875c06$var$Jg(a) {
    null === $5e93fe9694875c06$var$zg ? $5e93fe9694875c06$var$zg = [
        a
    ] : $5e93fe9694875c06$var$zg.push(a);
}
var $5e93fe9694875c06$var$Kg = $5e93fe9694875c06$var$ua.ReactCurrentBatchConfig;
function $5e93fe9694875c06$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5e93fe9694875c06$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5e93fe9694875c06$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($5e93fe9694875c06$var$p(284));
        if (!c._owner) throw Error($5e93fe9694875c06$var$p(290, a));
    }
    return a;
}
function $5e93fe9694875c06$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($5e93fe9694875c06$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $5e93fe9694875c06$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $5e93fe9694875c06$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5e93fe9694875c06$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5e93fe9694875c06$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $5e93fe9694875c06$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $5e93fe9694875c06$var$Ha && $5e93fe9694875c06$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $5e93fe9694875c06$var$Lg(a, b, c), d.return = a, d;
        d = $5e93fe9694875c06$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5e93fe9694875c06$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5e93fe9694875c06$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5e93fe9694875c06$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $5e93fe9694875c06$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5e93fe9694875c06$var$va:
                    return c = $5e93fe9694875c06$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $5e93fe9694875c06$var$Lg(a, null, b), c.return = a, c;
                case $5e93fe9694875c06$var$wa:
                    return b = $5e93fe9694875c06$var$Sg(b, a.mode, c), b.return = a, b;
                case $5e93fe9694875c06$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($5e93fe9694875c06$var$eb(b) || $5e93fe9694875c06$var$Ka(b)) return b = $5e93fe9694875c06$var$Tg(b, a.mode, c, null), b.return = a, b;
            $5e93fe9694875c06$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5e93fe9694875c06$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $5e93fe9694875c06$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $5e93fe9694875c06$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($5e93fe9694875c06$var$eb(c) || $5e93fe9694875c06$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $5e93fe9694875c06$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5e93fe9694875c06$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $5e93fe9694875c06$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $5e93fe9694875c06$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($5e93fe9694875c06$var$eb(d) || $5e93fe9694875c06$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5e93fe9694875c06$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $5e93fe9694875c06$var$I && $5e93fe9694875c06$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $5e93fe9694875c06$var$I && $5e93fe9694875c06$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $5e93fe9694875c06$var$I && $5e93fe9694875c06$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $5e93fe9694875c06$var$Ka(h);
        if ("function" !== typeof l) throw Error($5e93fe9694875c06$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($5e93fe9694875c06$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $5e93fe9694875c06$var$I && $5e93fe9694875c06$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $5e93fe9694875c06$var$I && $5e93fe9694875c06$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $5e93fe9694875c06$var$I && $5e93fe9694875c06$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $5e93fe9694875c06$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $5e93fe9694875c06$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $5e93fe9694875c06$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $5e93fe9694875c06$var$Ha && $5e93fe9694875c06$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $5e93fe9694875c06$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $5e93fe9694875c06$var$ya ? (d = $5e93fe9694875c06$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5e93fe9694875c06$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $5e93fe9694875c06$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $5e93fe9694875c06$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $5e93fe9694875c06$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $5e93fe9694875c06$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($5e93fe9694875c06$var$eb(f)) return n(a, d, f, h);
            if ($5e93fe9694875c06$var$Ka(f)) return t(a, d, f, h);
            $5e93fe9694875c06$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5e93fe9694875c06$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $5e93fe9694875c06$var$Ug = $5e93fe9694875c06$var$Og(!0), $5e93fe9694875c06$var$Vg = $5e93fe9694875c06$var$Og(!1), $5e93fe9694875c06$var$Wg = $5e93fe9694875c06$var$Uf(null), $5e93fe9694875c06$var$Xg = null, $5e93fe9694875c06$var$Yg = null, $5e93fe9694875c06$var$Zg = null;
function $5e93fe9694875c06$var$$g() {
    $5e93fe9694875c06$var$Zg = $5e93fe9694875c06$var$Yg = $5e93fe9694875c06$var$Xg = null;
}
function $5e93fe9694875c06$var$ah(a) {
    var b = $5e93fe9694875c06$var$Wg.current;
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wg);
    a._currentValue = b;
}
function $5e93fe9694875c06$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $5e93fe9694875c06$var$ch(a, b) {
    $5e93fe9694875c06$var$Xg = a;
    $5e93fe9694875c06$var$Zg = $5e93fe9694875c06$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($5e93fe9694875c06$var$dh = !0), a.firstContext = null);
}
function $5e93fe9694875c06$var$eh(a) {
    var b = a._currentValue;
    if ($5e93fe9694875c06$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $5e93fe9694875c06$var$Yg) {
            if (null === $5e93fe9694875c06$var$Xg) throw Error($5e93fe9694875c06$var$p(308));
            $5e93fe9694875c06$var$Yg = a;
            $5e93fe9694875c06$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $5e93fe9694875c06$var$Yg = $5e93fe9694875c06$var$Yg.next = a;
    }
    return b;
}
var $5e93fe9694875c06$var$fh = null;
function $5e93fe9694875c06$var$gh(a) {
    null === $5e93fe9694875c06$var$fh ? $5e93fe9694875c06$var$fh = [
        a
    ] : $5e93fe9694875c06$var$fh.push(a);
}
function $5e93fe9694875c06$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $5e93fe9694875c06$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $5e93fe9694875c06$var$ih(a, d);
}
function $5e93fe9694875c06$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $5e93fe9694875c06$var$jh = !1;
function $5e93fe9694875c06$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $5e93fe9694875c06$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $5e93fe9694875c06$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5e93fe9694875c06$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($5e93fe9694875c06$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $5e93fe9694875c06$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $5e93fe9694875c06$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $5e93fe9694875c06$var$ih(a, c);
}
function $5e93fe9694875c06$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5e93fe9694875c06$var$Cc(a, c);
    }
}
function $5e93fe9694875c06$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $5e93fe9694875c06$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $5e93fe9694875c06$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $5e93fe9694875c06$var$A({}, q, r);
                            break a;
                        case 2:
                            $5e93fe9694875c06$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $5e93fe9694875c06$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $5e93fe9694875c06$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($5e93fe9694875c06$var$p(191, e));
            e.call(d);
        }
    }
}
var $5e93fe9694875c06$var$th = {}, $5e93fe9694875c06$var$uh = $5e93fe9694875c06$var$Uf($5e93fe9694875c06$var$th), $5e93fe9694875c06$var$vh = $5e93fe9694875c06$var$Uf($5e93fe9694875c06$var$th), $5e93fe9694875c06$var$wh = $5e93fe9694875c06$var$Uf($5e93fe9694875c06$var$th);
function $5e93fe9694875c06$var$xh(a) {
    if (a === $5e93fe9694875c06$var$th) throw Error($5e93fe9694875c06$var$p(174));
    return a;
}
function $5e93fe9694875c06$var$yh(a, b) {
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$wh, b);
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$vh, a);
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$uh, $5e93fe9694875c06$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5e93fe9694875c06$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5e93fe9694875c06$var$lb(b, a);
    }
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$uh);
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$uh, b);
}
function $5e93fe9694875c06$var$zh() {
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$uh);
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$vh);
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$wh);
}
function $5e93fe9694875c06$var$Ah(a) {
    $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$wh.current);
    var b = $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$uh.current);
    var c = $5e93fe9694875c06$var$lb(b, a.type);
    b !== c && ($5e93fe9694875c06$var$G($5e93fe9694875c06$var$vh, a), $5e93fe9694875c06$var$G($5e93fe9694875c06$var$uh, c));
}
function $5e93fe9694875c06$var$Bh(a) {
    $5e93fe9694875c06$var$vh.current === a && ($5e93fe9694875c06$var$E($5e93fe9694875c06$var$uh), $5e93fe9694875c06$var$E($5e93fe9694875c06$var$vh));
}
var $5e93fe9694875c06$var$L = $5e93fe9694875c06$var$Uf(0);
function $5e93fe9694875c06$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $5e93fe9694875c06$var$Dh = [];
function $5e93fe9694875c06$var$Eh() {
    for(var a = 0; a < $5e93fe9694875c06$var$Dh.length; a++)$5e93fe9694875c06$var$Dh[a]._workInProgressVersionPrimary = null;
    $5e93fe9694875c06$var$Dh.length = 0;
}
var $5e93fe9694875c06$var$Fh = $5e93fe9694875c06$var$ua.ReactCurrentDispatcher, $5e93fe9694875c06$var$Gh = $5e93fe9694875c06$var$ua.ReactCurrentBatchConfig, $5e93fe9694875c06$var$Hh = 0, $5e93fe9694875c06$var$M = null, $5e93fe9694875c06$var$N = null, $5e93fe9694875c06$var$O = null, $5e93fe9694875c06$var$Ih = !1, $5e93fe9694875c06$var$Jh = !1, $5e93fe9694875c06$var$Kh = 0, $5e93fe9694875c06$var$Lh = 0;
function $5e93fe9694875c06$var$P() {
    throw Error($5e93fe9694875c06$var$p(321));
}
function $5e93fe9694875c06$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5e93fe9694875c06$var$He(a[c], b[c])) return !1;
    return !0;
}
function $5e93fe9694875c06$var$Nh(a, b, c, d, e, f) {
    $5e93fe9694875c06$var$Hh = f;
    $5e93fe9694875c06$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $5e93fe9694875c06$var$Fh.current = null === a || null === a.memoizedState ? $5e93fe9694875c06$var$Oh : $5e93fe9694875c06$var$Ph;
    a = c(d, e);
    if ($5e93fe9694875c06$var$Jh) {
        f = 0;
        do {
            $5e93fe9694875c06$var$Jh = !1;
            $5e93fe9694875c06$var$Kh = 0;
            if (25 <= f) throw Error($5e93fe9694875c06$var$p(301));
            f += 1;
            $5e93fe9694875c06$var$O = $5e93fe9694875c06$var$N = null;
            b.updateQueue = null;
            $5e93fe9694875c06$var$Fh.current = $5e93fe9694875c06$var$Qh;
            a = c(d, e);
        }while ($5e93fe9694875c06$var$Jh);
    }
    $5e93fe9694875c06$var$Fh.current = $5e93fe9694875c06$var$Rh;
    b = null !== $5e93fe9694875c06$var$N && null !== $5e93fe9694875c06$var$N.next;
    $5e93fe9694875c06$var$Hh = 0;
    $5e93fe9694875c06$var$O = $5e93fe9694875c06$var$N = $5e93fe9694875c06$var$M = null;
    $5e93fe9694875c06$var$Ih = !1;
    if (b) throw Error($5e93fe9694875c06$var$p(300));
    return a;
}
function $5e93fe9694875c06$var$Sh() {
    var a = 0 !== $5e93fe9694875c06$var$Kh;
    $5e93fe9694875c06$var$Kh = 0;
    return a;
}
function $5e93fe9694875c06$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5e93fe9694875c06$var$O ? $5e93fe9694875c06$var$M.memoizedState = $5e93fe9694875c06$var$O = a : $5e93fe9694875c06$var$O = $5e93fe9694875c06$var$O.next = a;
    return $5e93fe9694875c06$var$O;
}
function $5e93fe9694875c06$var$Uh() {
    if (null === $5e93fe9694875c06$var$N) {
        var a = $5e93fe9694875c06$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5e93fe9694875c06$var$N.next;
    var b = null === $5e93fe9694875c06$var$O ? $5e93fe9694875c06$var$M.memoizedState : $5e93fe9694875c06$var$O.next;
    if (null !== b) $5e93fe9694875c06$var$O = b, $5e93fe9694875c06$var$N = a;
    else {
        if (null === a) throw Error($5e93fe9694875c06$var$p(310));
        $5e93fe9694875c06$var$N = a;
        a = {
            memoizedState: $5e93fe9694875c06$var$N.memoizedState,
            baseState: $5e93fe9694875c06$var$N.baseState,
            baseQueue: $5e93fe9694875c06$var$N.baseQueue,
            queue: $5e93fe9694875c06$var$N.queue,
            next: null
        };
        null === $5e93fe9694875c06$var$O ? $5e93fe9694875c06$var$M.memoizedState = $5e93fe9694875c06$var$O = a : $5e93fe9694875c06$var$O = $5e93fe9694875c06$var$O.next = a;
    }
    return $5e93fe9694875c06$var$O;
}
function $5e93fe9694875c06$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5e93fe9694875c06$var$Wh(a) {
    var b = $5e93fe9694875c06$var$Uh(), c = b.queue;
    if (null === c) throw Error($5e93fe9694875c06$var$p(311));
    c.lastRenderedReducer = a;
    var d = $5e93fe9694875c06$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($5e93fe9694875c06$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $5e93fe9694875c06$var$M.lanes |= m;
                $5e93fe9694875c06$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $5e93fe9694875c06$var$He(d, b.memoizedState) || ($5e93fe9694875c06$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $5e93fe9694875c06$var$M.lanes |= f, $5e93fe9694875c06$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5e93fe9694875c06$var$Xh(a) {
    var b = $5e93fe9694875c06$var$Uh(), c = b.queue;
    if (null === c) throw Error($5e93fe9694875c06$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5e93fe9694875c06$var$He(f, b.memoizedState) || ($5e93fe9694875c06$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5e93fe9694875c06$var$Yh() {}
function $5e93fe9694875c06$var$Zh(a, b) {
    var c = $5e93fe9694875c06$var$M, d = $5e93fe9694875c06$var$Uh(), e = b(), f = !$5e93fe9694875c06$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $5e93fe9694875c06$var$dh = !0);
    d = d.queue;
    $5e93fe9694875c06$var$$h($5e93fe9694875c06$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $5e93fe9694875c06$var$O && $5e93fe9694875c06$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $5e93fe9694875c06$var$bi(9, $5e93fe9694875c06$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $5e93fe9694875c06$var$Q) throw Error($5e93fe9694875c06$var$p(349));
        0 !== ($5e93fe9694875c06$var$Hh & 30) || $5e93fe9694875c06$var$di(c, b, e);
    }
    return e;
}
function $5e93fe9694875c06$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $5e93fe9694875c06$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5e93fe9694875c06$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $5e93fe9694875c06$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $5e93fe9694875c06$var$ei(b) && $5e93fe9694875c06$var$fi(a);
}
function $5e93fe9694875c06$var$ai(a, b, c) {
    return c(function() {
        $5e93fe9694875c06$var$ei(b) && $5e93fe9694875c06$var$fi(a);
    });
}
function $5e93fe9694875c06$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$5e93fe9694875c06$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $5e93fe9694875c06$var$fi(a) {
    var b = $5e93fe9694875c06$var$ih(a, 1);
    null !== b && $5e93fe9694875c06$var$gi(b, a, 1, -1);
}
function $5e93fe9694875c06$var$hi(a) {
    var b = $5e93fe9694875c06$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5e93fe9694875c06$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $5e93fe9694875c06$var$ii.bind(null, $5e93fe9694875c06$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5e93fe9694875c06$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5e93fe9694875c06$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5e93fe9694875c06$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5e93fe9694875c06$var$ji() {
    return $5e93fe9694875c06$var$Uh().memoizedState;
}
function $5e93fe9694875c06$var$ki(a, b, c, d) {
    var e = $5e93fe9694875c06$var$Th();
    $5e93fe9694875c06$var$M.flags |= a;
    e.memoizedState = $5e93fe9694875c06$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5e93fe9694875c06$var$li(a, b, c, d) {
    var e = $5e93fe9694875c06$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5e93fe9694875c06$var$N) {
        var g = $5e93fe9694875c06$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $5e93fe9694875c06$var$Mh(d, g.deps)) {
            e.memoizedState = $5e93fe9694875c06$var$bi(b, c, f, d);
            return;
        }
    }
    $5e93fe9694875c06$var$M.flags |= a;
    e.memoizedState = $5e93fe9694875c06$var$bi(1 | b, c, f, d);
}
function $5e93fe9694875c06$var$mi(a, b) {
    return $5e93fe9694875c06$var$ki(8390656, 8, a, b);
}
function $5e93fe9694875c06$var$$h(a, b) {
    return $5e93fe9694875c06$var$li(2048, 8, a, b);
}
function $5e93fe9694875c06$var$ni(a, b) {
    return $5e93fe9694875c06$var$li(4, 2, a, b);
}
function $5e93fe9694875c06$var$oi(a, b) {
    return $5e93fe9694875c06$var$li(4, 4, a, b);
}
function $5e93fe9694875c06$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5e93fe9694875c06$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5e93fe9694875c06$var$li(4, 4, $5e93fe9694875c06$var$pi.bind(null, b, a), c);
}
function $5e93fe9694875c06$var$ri() {}
function $5e93fe9694875c06$var$si(a, b) {
    var c = $5e93fe9694875c06$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5e93fe9694875c06$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5e93fe9694875c06$var$ti(a, b) {
    var c = $5e93fe9694875c06$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5e93fe9694875c06$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5e93fe9694875c06$var$ui(a, b, c) {
    if (0 === ($5e93fe9694875c06$var$Hh & 21)) return a.baseState && (a.baseState = !1, $5e93fe9694875c06$var$dh = !0), a.memoizedState = c;
    $5e93fe9694875c06$var$He(c, b) || (c = $5e93fe9694875c06$var$yc(), $5e93fe9694875c06$var$M.lanes |= c, $5e93fe9694875c06$var$rh |= c, a.baseState = !0);
    return b;
}
function $5e93fe9694875c06$var$vi(a, b) {
    var c = $5e93fe9694875c06$var$C;
    $5e93fe9694875c06$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $5e93fe9694875c06$var$Gh.transition;
    $5e93fe9694875c06$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $5e93fe9694875c06$var$C = c, $5e93fe9694875c06$var$Gh.transition = d;
    }
}
function $5e93fe9694875c06$var$wi() {
    return $5e93fe9694875c06$var$Uh().memoizedState;
}
function $5e93fe9694875c06$var$xi(a, b, c) {
    var d = $5e93fe9694875c06$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5e93fe9694875c06$var$zi(a)) $5e93fe9694875c06$var$Ai(b, c);
    else if (c = $5e93fe9694875c06$var$hh(a, b, c, d), null !== c) {
        var e = $5e93fe9694875c06$var$R();
        $5e93fe9694875c06$var$gi(c, a, d, e);
        $5e93fe9694875c06$var$Bi(c, b, d);
    }
}
function $5e93fe9694875c06$var$ii(a, b, c) {
    var d = $5e93fe9694875c06$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5e93fe9694875c06$var$zi(a)) $5e93fe9694875c06$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($5e93fe9694875c06$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $5e93fe9694875c06$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $5e93fe9694875c06$var$hh(a, b, e, d);
        null !== c && (e = $5e93fe9694875c06$var$R(), $5e93fe9694875c06$var$gi(c, a, d, e), $5e93fe9694875c06$var$Bi(c, b, d));
    }
}
function $5e93fe9694875c06$var$zi(a) {
    var b = a.alternate;
    return a === $5e93fe9694875c06$var$M || null !== b && b === $5e93fe9694875c06$var$M;
}
function $5e93fe9694875c06$var$Ai(a, b) {
    $5e93fe9694875c06$var$Jh = $5e93fe9694875c06$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $5e93fe9694875c06$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5e93fe9694875c06$var$Cc(a, c);
    }
}
var $5e93fe9694875c06$var$Rh = {
    readContext: $5e93fe9694875c06$var$eh,
    useCallback: $5e93fe9694875c06$var$P,
    useContext: $5e93fe9694875c06$var$P,
    useEffect: $5e93fe9694875c06$var$P,
    useImperativeHandle: $5e93fe9694875c06$var$P,
    useInsertionEffect: $5e93fe9694875c06$var$P,
    useLayoutEffect: $5e93fe9694875c06$var$P,
    useMemo: $5e93fe9694875c06$var$P,
    useReducer: $5e93fe9694875c06$var$P,
    useRef: $5e93fe9694875c06$var$P,
    useState: $5e93fe9694875c06$var$P,
    useDebugValue: $5e93fe9694875c06$var$P,
    useDeferredValue: $5e93fe9694875c06$var$P,
    useTransition: $5e93fe9694875c06$var$P,
    useMutableSource: $5e93fe9694875c06$var$P,
    useSyncExternalStore: $5e93fe9694875c06$var$P,
    useId: $5e93fe9694875c06$var$P,
    unstable_isNewReconciler: !1
}, $5e93fe9694875c06$var$Oh = {
    readContext: $5e93fe9694875c06$var$eh,
    useCallback: function(a, b) {
        $5e93fe9694875c06$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $5e93fe9694875c06$var$eh,
    useEffect: $5e93fe9694875c06$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5e93fe9694875c06$var$ki(4194308, 4, $5e93fe9694875c06$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $5e93fe9694875c06$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $5e93fe9694875c06$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $5e93fe9694875c06$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $5e93fe9694875c06$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $5e93fe9694875c06$var$xi.bind(null, $5e93fe9694875c06$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $5e93fe9694875c06$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5e93fe9694875c06$var$hi,
    useDebugValue: $5e93fe9694875c06$var$ri,
    useDeferredValue: function(a) {
        return $5e93fe9694875c06$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $5e93fe9694875c06$var$hi(!1), b = a[0];
        a = $5e93fe9694875c06$var$vi.bind(null, a[1]);
        $5e93fe9694875c06$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $5e93fe9694875c06$var$M, e = $5e93fe9694875c06$var$Th();
        if ($5e93fe9694875c06$var$I) {
            if (void 0 === c) throw Error($5e93fe9694875c06$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $5e93fe9694875c06$var$Q) throw Error($5e93fe9694875c06$var$p(349));
            0 !== ($5e93fe9694875c06$var$Hh & 30) || $5e93fe9694875c06$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $5e93fe9694875c06$var$mi($5e93fe9694875c06$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $5e93fe9694875c06$var$bi(9, $5e93fe9694875c06$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $5e93fe9694875c06$var$Th(), b = $5e93fe9694875c06$var$Q.identifierPrefix;
        if ($5e93fe9694875c06$var$I) {
            var c = $5e93fe9694875c06$var$sg;
            var d = $5e93fe9694875c06$var$rg;
            c = (d & ~(1 << 32 - $5e93fe9694875c06$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $5e93fe9694875c06$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $5e93fe9694875c06$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $5e93fe9694875c06$var$Ph = {
    readContext: $5e93fe9694875c06$var$eh,
    useCallback: $5e93fe9694875c06$var$si,
    useContext: $5e93fe9694875c06$var$eh,
    useEffect: $5e93fe9694875c06$var$$h,
    useImperativeHandle: $5e93fe9694875c06$var$qi,
    useInsertionEffect: $5e93fe9694875c06$var$ni,
    useLayoutEffect: $5e93fe9694875c06$var$oi,
    useMemo: $5e93fe9694875c06$var$ti,
    useReducer: $5e93fe9694875c06$var$Wh,
    useRef: $5e93fe9694875c06$var$ji,
    useState: function() {
        return $5e93fe9694875c06$var$Wh($5e93fe9694875c06$var$Vh);
    },
    useDebugValue: $5e93fe9694875c06$var$ri,
    useDeferredValue: function(a) {
        var b = $5e93fe9694875c06$var$Uh();
        return $5e93fe9694875c06$var$ui(b, $5e93fe9694875c06$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $5e93fe9694875c06$var$Wh($5e93fe9694875c06$var$Vh)[0], b = $5e93fe9694875c06$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5e93fe9694875c06$var$Yh,
    useSyncExternalStore: $5e93fe9694875c06$var$Zh,
    useId: $5e93fe9694875c06$var$wi,
    unstable_isNewReconciler: !1
}, $5e93fe9694875c06$var$Qh = {
    readContext: $5e93fe9694875c06$var$eh,
    useCallback: $5e93fe9694875c06$var$si,
    useContext: $5e93fe9694875c06$var$eh,
    useEffect: $5e93fe9694875c06$var$$h,
    useImperativeHandle: $5e93fe9694875c06$var$qi,
    useInsertionEffect: $5e93fe9694875c06$var$ni,
    useLayoutEffect: $5e93fe9694875c06$var$oi,
    useMemo: $5e93fe9694875c06$var$ti,
    useReducer: $5e93fe9694875c06$var$Xh,
    useRef: $5e93fe9694875c06$var$ji,
    useState: function() {
        return $5e93fe9694875c06$var$Xh($5e93fe9694875c06$var$Vh);
    },
    useDebugValue: $5e93fe9694875c06$var$ri,
    useDeferredValue: function(a) {
        var b = $5e93fe9694875c06$var$Uh();
        return null === $5e93fe9694875c06$var$N ? b.memoizedState = a : $5e93fe9694875c06$var$ui(b, $5e93fe9694875c06$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $5e93fe9694875c06$var$Xh($5e93fe9694875c06$var$Vh)[0], b = $5e93fe9694875c06$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5e93fe9694875c06$var$Yh,
    useSyncExternalStore: $5e93fe9694875c06$var$Zh,
    useId: $5e93fe9694875c06$var$wi,
    unstable_isNewReconciler: !1
};
function $5e93fe9694875c06$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $5e93fe9694875c06$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $5e93fe9694875c06$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5e93fe9694875c06$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $5e93fe9694875c06$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $5e93fe9694875c06$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5e93fe9694875c06$var$R(), e = $5e93fe9694875c06$var$yi(a), f = $5e93fe9694875c06$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5e93fe9694875c06$var$nh(a, f, e);
        null !== b && ($5e93fe9694875c06$var$gi(b, a, e, d), $5e93fe9694875c06$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5e93fe9694875c06$var$R(), e = $5e93fe9694875c06$var$yi(a), f = $5e93fe9694875c06$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5e93fe9694875c06$var$nh(a, f, e);
        null !== b && ($5e93fe9694875c06$var$gi(b, a, e, d), $5e93fe9694875c06$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $5e93fe9694875c06$var$R(), d = $5e93fe9694875c06$var$yi(a), e = $5e93fe9694875c06$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $5e93fe9694875c06$var$nh(a, e, d);
        null !== b && ($5e93fe9694875c06$var$gi(b, a, d, c), $5e93fe9694875c06$var$oh(b, a, d));
    }
};
function $5e93fe9694875c06$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5e93fe9694875c06$var$Ie(c, d) || !$5e93fe9694875c06$var$Ie(e, f) : !0;
}
function $5e93fe9694875c06$var$Gi(a, b, c) {
    var d = !1, e = $5e93fe9694875c06$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5e93fe9694875c06$var$eh(f) : (e = $5e93fe9694875c06$var$Zf(b) ? $5e93fe9694875c06$var$Xf : $5e93fe9694875c06$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5e93fe9694875c06$var$Yf(a, e) : $5e93fe9694875c06$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5e93fe9694875c06$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5e93fe9694875c06$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5e93fe9694875c06$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $5e93fe9694875c06$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $5e93fe9694875c06$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5e93fe9694875c06$var$eh(f) : (f = $5e93fe9694875c06$var$Zf(b) ? $5e93fe9694875c06$var$Xf : $5e93fe9694875c06$var$H.current, e.context = $5e93fe9694875c06$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5e93fe9694875c06$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5e93fe9694875c06$var$Ei.enqueueReplaceState(e, e.state, null), $5e93fe9694875c06$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $5e93fe9694875c06$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $5e93fe9694875c06$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $5e93fe9694875c06$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $5e93fe9694875c06$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $5e93fe9694875c06$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $5e93fe9694875c06$var$Ni(a, b, c) {
    c = $5e93fe9694875c06$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5e93fe9694875c06$var$Oi || ($5e93fe9694875c06$var$Oi = !0, $5e93fe9694875c06$var$Pi = d);
        $5e93fe9694875c06$var$Li(a, b);
    };
    return c;
}
function $5e93fe9694875c06$var$Qi(a, b, c) {
    c = $5e93fe9694875c06$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $5e93fe9694875c06$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $5e93fe9694875c06$var$Li(a, b);
        "function" !== typeof d && (null === $5e93fe9694875c06$var$Ri ? $5e93fe9694875c06$var$Ri = new Set([
            this
        ]) : $5e93fe9694875c06$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $5e93fe9694875c06$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $5e93fe9694875c06$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $5e93fe9694875c06$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $5e93fe9694875c06$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $5e93fe9694875c06$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $5e93fe9694875c06$var$mh(-1, 1), b.tag = 2, $5e93fe9694875c06$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $5e93fe9694875c06$var$Wi = $5e93fe9694875c06$var$ua.ReactCurrentOwner, $5e93fe9694875c06$var$dh = !1;
function $5e93fe9694875c06$var$Xi(a, b, c, d) {
    b.child = null === a ? $5e93fe9694875c06$var$Vg(b, null, c, d) : $5e93fe9694875c06$var$Ug(b, a.child, c, d);
}
function $5e93fe9694875c06$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5e93fe9694875c06$var$ch(b, e);
    d = $5e93fe9694875c06$var$Nh(a, b, c, d, f, e);
    c = $5e93fe9694875c06$var$Sh();
    if (null !== a && !$5e93fe9694875c06$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5e93fe9694875c06$var$Zi(a, b, e);
    $5e93fe9694875c06$var$I && c && $5e93fe9694875c06$var$vg(b);
    b.flags |= 1;
    $5e93fe9694875c06$var$Xi(a, b, d, e);
    return b.child;
}
function $5e93fe9694875c06$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$5e93fe9694875c06$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $5e93fe9694875c06$var$bj(a, b, f, d, e);
        a = $5e93fe9694875c06$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $5e93fe9694875c06$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $5e93fe9694875c06$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $5e93fe9694875c06$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5e93fe9694875c06$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($5e93fe9694875c06$var$Ie(f, d) && a.ref === b.ref) {
            if ($5e93fe9694875c06$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($5e93fe9694875c06$var$dh = !0);
            else return b.lanes = a.lanes, $5e93fe9694875c06$var$Zi(a, b, e);
        }
    }
    return $5e93fe9694875c06$var$cj(a, b, c, d, e);
}
function $5e93fe9694875c06$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $5e93fe9694875c06$var$G($5e93fe9694875c06$var$ej, $5e93fe9694875c06$var$fj), $5e93fe9694875c06$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $5e93fe9694875c06$var$G($5e93fe9694875c06$var$ej, $5e93fe9694875c06$var$fj), $5e93fe9694875c06$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $5e93fe9694875c06$var$G($5e93fe9694875c06$var$ej, $5e93fe9694875c06$var$fj);
            $5e93fe9694875c06$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $5e93fe9694875c06$var$G($5e93fe9694875c06$var$ej, $5e93fe9694875c06$var$fj), $5e93fe9694875c06$var$fj |= d;
    $5e93fe9694875c06$var$Xi(a, b, e, c);
    return b.child;
}
function $5e93fe9694875c06$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $5e93fe9694875c06$var$cj(a, b, c, d, e) {
    var f = $5e93fe9694875c06$var$Zf(c) ? $5e93fe9694875c06$var$Xf : $5e93fe9694875c06$var$H.current;
    f = $5e93fe9694875c06$var$Yf(b, f);
    $5e93fe9694875c06$var$ch(b, e);
    c = $5e93fe9694875c06$var$Nh(a, b, c, d, f, e);
    d = $5e93fe9694875c06$var$Sh();
    if (null !== a && !$5e93fe9694875c06$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5e93fe9694875c06$var$Zi(a, b, e);
    $5e93fe9694875c06$var$I && d && $5e93fe9694875c06$var$vg(b);
    b.flags |= 1;
    $5e93fe9694875c06$var$Xi(a, b, c, e);
    return b.child;
}
function $5e93fe9694875c06$var$hj(a, b, c, d, e) {
    if ($5e93fe9694875c06$var$Zf(c)) {
        var f = !0;
        $5e93fe9694875c06$var$cg(b);
    } else f = !1;
    $5e93fe9694875c06$var$ch(b, e);
    if (null === b.stateNode) $5e93fe9694875c06$var$ij(a, b), $5e93fe9694875c06$var$Gi(b, c, d), $5e93fe9694875c06$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5e93fe9694875c06$var$eh(l) : (l = $5e93fe9694875c06$var$Zf(c) ? $5e93fe9694875c06$var$Xf : $5e93fe9694875c06$var$H.current, l = $5e93fe9694875c06$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5e93fe9694875c06$var$Hi(b, g, d, l);
        $5e93fe9694875c06$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $5e93fe9694875c06$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $5e93fe9694875c06$var$Wf.current || $5e93fe9694875c06$var$jh ? ("function" === typeof m && ($5e93fe9694875c06$var$Di(b, c, m, d), k = b.memoizedState), (h = $5e93fe9694875c06$var$jh || $5e93fe9694875c06$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $5e93fe9694875c06$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $5e93fe9694875c06$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $5e93fe9694875c06$var$eh(k) : (k = $5e93fe9694875c06$var$Zf(c) ? $5e93fe9694875c06$var$Xf : $5e93fe9694875c06$var$H.current, k = $5e93fe9694875c06$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $5e93fe9694875c06$var$Hi(b, g, d, k);
        $5e93fe9694875c06$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $5e93fe9694875c06$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $5e93fe9694875c06$var$Wf.current || $5e93fe9694875c06$var$jh ? ("function" === typeof y && ($5e93fe9694875c06$var$Di(b, c, y, d), n = b.memoizedState), (l = $5e93fe9694875c06$var$jh || $5e93fe9694875c06$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $5e93fe9694875c06$var$jj(a, b, c, d, f, e);
}
function $5e93fe9694875c06$var$jj(a, b, c, d, e, f) {
    $5e93fe9694875c06$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $5e93fe9694875c06$var$dg(b, c, !1), $5e93fe9694875c06$var$Zi(a, b, f);
    d = b.stateNode;
    $5e93fe9694875c06$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $5e93fe9694875c06$var$Ug(b, a.child, null, f), b.child = $5e93fe9694875c06$var$Ug(b, null, h, f)) : $5e93fe9694875c06$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $5e93fe9694875c06$var$dg(b, c, !0);
    return b.child;
}
function $5e93fe9694875c06$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $5e93fe9694875c06$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5e93fe9694875c06$var$ag(a, b.context, !1);
    $5e93fe9694875c06$var$yh(a, b.containerInfo);
}
function $5e93fe9694875c06$var$lj(a, b, c, d, e) {
    $5e93fe9694875c06$var$Ig();
    $5e93fe9694875c06$var$Jg(e);
    b.flags |= 256;
    $5e93fe9694875c06$var$Xi(a, b, c, d);
    return b.child;
}
var $5e93fe9694875c06$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $5e93fe9694875c06$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $5e93fe9694875c06$var$oj(a, b, c) {
    var d = b.pendingProps, e = $5e93fe9694875c06$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, e & 1);
    if (null === a) {
        $5e93fe9694875c06$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $5e93fe9694875c06$var$pj(g, d, 0, null), a = $5e93fe9694875c06$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $5e93fe9694875c06$var$nj(c), b.memoizedState = $5e93fe9694875c06$var$mj, a) : $5e93fe9694875c06$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $5e93fe9694875c06$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $5e93fe9694875c06$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $5e93fe9694875c06$var$Pg(h, f) : (f = $5e93fe9694875c06$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $5e93fe9694875c06$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $5e93fe9694875c06$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $5e93fe9694875c06$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $5e93fe9694875c06$var$qj(a, b) {
    b = $5e93fe9694875c06$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $5e93fe9694875c06$var$sj(a, b, c, d) {
    null !== d && $5e93fe9694875c06$var$Jg(d);
    $5e93fe9694875c06$var$Ug(b, a.child, null, c);
    a = $5e93fe9694875c06$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $5e93fe9694875c06$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $5e93fe9694875c06$var$Ki(Error($5e93fe9694875c06$var$p(422))), $5e93fe9694875c06$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $5e93fe9694875c06$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $5e93fe9694875c06$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $5e93fe9694875c06$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $5e93fe9694875c06$var$nj(g);
        b.memoizedState = $5e93fe9694875c06$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $5e93fe9694875c06$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($5e93fe9694875c06$var$p(419));
        d = $5e93fe9694875c06$var$Ki(f, d, void 0);
        return $5e93fe9694875c06$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($5e93fe9694875c06$var$dh || h) {
        d = $5e93fe9694875c06$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $5e93fe9694875c06$var$ih(a, e), $5e93fe9694875c06$var$gi(d, a, e, -1));
        }
        $5e93fe9694875c06$var$tj();
        d = $5e93fe9694875c06$var$Ki(Error($5e93fe9694875c06$var$p(421)));
        return $5e93fe9694875c06$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $5e93fe9694875c06$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $5e93fe9694875c06$var$yg = $5e93fe9694875c06$var$Lf(e.nextSibling);
    $5e93fe9694875c06$var$xg = b;
    $5e93fe9694875c06$var$I = !0;
    $5e93fe9694875c06$var$zg = null;
    null !== a && ($5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg++] = $5e93fe9694875c06$var$rg, $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg++] = $5e93fe9694875c06$var$sg, $5e93fe9694875c06$var$og[$5e93fe9694875c06$var$pg++] = $5e93fe9694875c06$var$qg, $5e93fe9694875c06$var$rg = a.id, $5e93fe9694875c06$var$sg = a.overflow, $5e93fe9694875c06$var$qg = b);
    b = $5e93fe9694875c06$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $5e93fe9694875c06$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $5e93fe9694875c06$var$bh(a.return, b, c);
}
function $5e93fe9694875c06$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $5e93fe9694875c06$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5e93fe9694875c06$var$Xi(a, b, d.children, c);
    d = $5e93fe9694875c06$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5e93fe9694875c06$var$vj(a, c, b);
            else if (19 === a.tag) $5e93fe9694875c06$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5e93fe9694875c06$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5e93fe9694875c06$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5e93fe9694875c06$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5e93fe9694875c06$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $5e93fe9694875c06$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5e93fe9694875c06$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $5e93fe9694875c06$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $5e93fe9694875c06$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($5e93fe9694875c06$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $5e93fe9694875c06$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5e93fe9694875c06$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $5e93fe9694875c06$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $5e93fe9694875c06$var$kj(b);
            $5e93fe9694875c06$var$Ig();
            break;
        case 5:
            $5e93fe9694875c06$var$Ah(b);
            break;
        case 1:
            $5e93fe9694875c06$var$Zf(b.type) && $5e93fe9694875c06$var$cg(b);
            break;
        case 4:
            $5e93fe9694875c06$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $5e93fe9694875c06$var$G($5e93fe9694875c06$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, $5e93fe9694875c06$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $5e93fe9694875c06$var$oj(a, b, c);
                $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, $5e93fe9694875c06$var$L.current & 1);
                a = $5e93fe9694875c06$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, $5e93fe9694875c06$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $5e93fe9694875c06$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, $5e93fe9694875c06$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $5e93fe9694875c06$var$dj(a, b, c);
    }
    return $5e93fe9694875c06$var$Zi(a, b, c);
}
var $5e93fe9694875c06$var$zj, $5e93fe9694875c06$var$Aj, $5e93fe9694875c06$var$Bj, $5e93fe9694875c06$var$Cj;
$5e93fe9694875c06$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5e93fe9694875c06$var$Aj = function() {};
$5e93fe9694875c06$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $5e93fe9694875c06$var$Ya(a, e);
                d = $5e93fe9694875c06$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $5e93fe9694875c06$var$A({}, e, {
                    value: void 0
                });
                d = $5e93fe9694875c06$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $5e93fe9694875c06$var$gb(a, e);
                d = $5e93fe9694875c06$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $5e93fe9694875c06$var$Bf);
        }
        $5e93fe9694875c06$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($5e93fe9694875c06$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($5e93fe9694875c06$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $5e93fe9694875c06$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$5e93fe9694875c06$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $5e93fe9694875c06$var$Dj(a, b) {
    if (!$5e93fe9694875c06$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5e93fe9694875c06$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $5e93fe9694875c06$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $5e93fe9694875c06$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5e93fe9694875c06$var$S(b), null;
        case 1:
            return $5e93fe9694875c06$var$Zf(b.type) && $5e93fe9694875c06$var$$f(), $5e93fe9694875c06$var$S(b), null;
        case 3:
            d = b.stateNode;
            $5e93fe9694875c06$var$zh();
            $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wf);
            $5e93fe9694875c06$var$E($5e93fe9694875c06$var$H);
            $5e93fe9694875c06$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $5e93fe9694875c06$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $5e93fe9694875c06$var$zg && ($5e93fe9694875c06$var$Fj($5e93fe9694875c06$var$zg), $5e93fe9694875c06$var$zg = null));
            $5e93fe9694875c06$var$Aj(a, b);
            $5e93fe9694875c06$var$S(b);
            return null;
        case 5:
            $5e93fe9694875c06$var$Bh(b);
            var e = $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $5e93fe9694875c06$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5e93fe9694875c06$var$p(166));
                    $5e93fe9694875c06$var$S(b);
                    return null;
                }
                a = $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$uh.current);
                if ($5e93fe9694875c06$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$5e93fe9694875c06$var$Of] = b;
                    d[$5e93fe9694875c06$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $5e93fe9694875c06$var$D("cancel", d);
                            $5e93fe9694875c06$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $5e93fe9694875c06$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $5e93fe9694875c06$var$lf.length; e++)$5e93fe9694875c06$var$D($5e93fe9694875c06$var$lf[e], d);
                            break;
                        case "source":
                            $5e93fe9694875c06$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5e93fe9694875c06$var$D("error", d);
                            $5e93fe9694875c06$var$D("load", d);
                            break;
                        case "details":
                            $5e93fe9694875c06$var$D("toggle", d);
                            break;
                        case "input":
                            $5e93fe9694875c06$var$Za(d, f);
                            $5e93fe9694875c06$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5e93fe9694875c06$var$D("invalid", d);
                            break;
                        case "textarea":
                            $5e93fe9694875c06$var$hb(d, f), $5e93fe9694875c06$var$D("invalid", d);
                    }
                    $5e93fe9694875c06$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $5e93fe9694875c06$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $5e93fe9694875c06$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $5e93fe9694875c06$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $5e93fe9694875c06$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $5e93fe9694875c06$var$Va(d);
                            $5e93fe9694875c06$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $5e93fe9694875c06$var$Va(d);
                            $5e93fe9694875c06$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5e93fe9694875c06$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $5e93fe9694875c06$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$5e93fe9694875c06$var$Of] = b;
                    a[$5e93fe9694875c06$var$Pf] = d;
                    $5e93fe9694875c06$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $5e93fe9694875c06$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $5e93fe9694875c06$var$D("cancel", a);
                                $5e93fe9694875c06$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $5e93fe9694875c06$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $5e93fe9694875c06$var$lf.length; e++)$5e93fe9694875c06$var$D($5e93fe9694875c06$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $5e93fe9694875c06$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $5e93fe9694875c06$var$D("error", a);
                                $5e93fe9694875c06$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $5e93fe9694875c06$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $5e93fe9694875c06$var$Za(a, d);
                                e = $5e93fe9694875c06$var$Ya(a, d);
                                $5e93fe9694875c06$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $5e93fe9694875c06$var$A({}, d, {
                                    value: void 0
                                });
                                $5e93fe9694875c06$var$D("invalid", a);
                                break;
                            case "textarea":
                                $5e93fe9694875c06$var$hb(a, d);
                                e = $5e93fe9694875c06$var$gb(a, d);
                                $5e93fe9694875c06$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $5e93fe9694875c06$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $5e93fe9694875c06$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $5e93fe9694875c06$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $5e93fe9694875c06$var$ob(a, k) : "number" === typeof k && $5e93fe9694875c06$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5e93fe9694875c06$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $5e93fe9694875c06$var$D("scroll", a) : null != k && $5e93fe9694875c06$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $5e93fe9694875c06$var$Va(a);
                                $5e93fe9694875c06$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $5e93fe9694875c06$var$Va(a);
                                $5e93fe9694875c06$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $5e93fe9694875c06$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $5e93fe9694875c06$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $5e93fe9694875c06$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $5e93fe9694875c06$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $5e93fe9694875c06$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $5e93fe9694875c06$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5e93fe9694875c06$var$p(166));
                c = $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$wh.current);
                $5e93fe9694875c06$var$xh($5e93fe9694875c06$var$uh.current);
                if ($5e93fe9694875c06$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$5e93fe9694875c06$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $5e93fe9694875c06$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $5e93fe9694875c06$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $5e93fe9694875c06$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$5e93fe9694875c06$var$Of] = b, b.stateNode = d;
            }
            $5e93fe9694875c06$var$S(b);
            return null;
        case 13:
            $5e93fe9694875c06$var$E($5e93fe9694875c06$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($5e93fe9694875c06$var$I && null !== $5e93fe9694875c06$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $5e93fe9694875c06$var$Hg(), $5e93fe9694875c06$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $5e93fe9694875c06$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($5e93fe9694875c06$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($5e93fe9694875c06$var$p(317));
                        f[$5e93fe9694875c06$var$Of] = b;
                    } else $5e93fe9694875c06$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $5e93fe9694875c06$var$S(b);
                    f = !1;
                } else null !== $5e93fe9694875c06$var$zg && ($5e93fe9694875c06$var$Fj($5e93fe9694875c06$var$zg), $5e93fe9694875c06$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($5e93fe9694875c06$var$L.current & 1) ? 0 === $5e93fe9694875c06$var$T && ($5e93fe9694875c06$var$T = 3) : $5e93fe9694875c06$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $5e93fe9694875c06$var$S(b);
            return null;
        case 4:
            return $5e93fe9694875c06$var$zh(), $5e93fe9694875c06$var$Aj(a, b), null === a && $5e93fe9694875c06$var$sf(b.stateNode.containerInfo), $5e93fe9694875c06$var$S(b), null;
        case 10:
            return $5e93fe9694875c06$var$ah(b.type._context), $5e93fe9694875c06$var$S(b), null;
        case 17:
            return $5e93fe9694875c06$var$Zf(b.type) && $5e93fe9694875c06$var$$f(), $5e93fe9694875c06$var$S(b), null;
        case 19:
            $5e93fe9694875c06$var$E($5e93fe9694875c06$var$L);
            f = b.memoizedState;
            if (null === f) return $5e93fe9694875c06$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $5e93fe9694875c06$var$Dj(f, !1);
                else {
                    if (0 !== $5e93fe9694875c06$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $5e93fe9694875c06$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $5e93fe9694875c06$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, $5e93fe9694875c06$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $5e93fe9694875c06$var$B() > $5e93fe9694875c06$var$Gj && (b.flags |= 128, d = !0, $5e93fe9694875c06$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $5e93fe9694875c06$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $5e93fe9694875c06$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$5e93fe9694875c06$var$I) return $5e93fe9694875c06$var$S(b), null;
                    } else 2 * $5e93fe9694875c06$var$B() - f.renderingStartTime > $5e93fe9694875c06$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $5e93fe9694875c06$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $5e93fe9694875c06$var$B(), b.sibling = null, c = $5e93fe9694875c06$var$L.current, $5e93fe9694875c06$var$G($5e93fe9694875c06$var$L, d ? c & 1 | 2 : c & 1), b;
            $5e93fe9694875c06$var$S(b);
            return null;
        case 22:
        case 23:
            return $5e93fe9694875c06$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($5e93fe9694875c06$var$fj & 1073741824) && ($5e93fe9694875c06$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $5e93fe9694875c06$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($5e93fe9694875c06$var$p(156, b.tag));
}
function $5e93fe9694875c06$var$Ij(a, b) {
    $5e93fe9694875c06$var$wg(b);
    switch(b.tag){
        case 1:
            return $5e93fe9694875c06$var$Zf(b.type) && $5e93fe9694875c06$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $5e93fe9694875c06$var$zh(), $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wf), $5e93fe9694875c06$var$E($5e93fe9694875c06$var$H), $5e93fe9694875c06$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $5e93fe9694875c06$var$Bh(b), null;
        case 13:
            $5e93fe9694875c06$var$E($5e93fe9694875c06$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($5e93fe9694875c06$var$p(340));
                $5e93fe9694875c06$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $5e93fe9694875c06$var$E($5e93fe9694875c06$var$L), null;
        case 4:
            return $5e93fe9694875c06$var$zh(), null;
        case 10:
            return $5e93fe9694875c06$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $5e93fe9694875c06$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $5e93fe9694875c06$var$Jj = !1, $5e93fe9694875c06$var$U = !1, $5e93fe9694875c06$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $5e93fe9694875c06$var$V = null;
function $5e93fe9694875c06$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $5e93fe9694875c06$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $5e93fe9694875c06$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $5e93fe9694875c06$var$W(a, b, d);
    }
}
var $5e93fe9694875c06$var$Nj = !1;
function $5e93fe9694875c06$var$Oj(a, b) {
    $5e93fe9694875c06$var$Cf = $5e93fe9694875c06$var$dd;
    a = $5e93fe9694875c06$var$Me();
    if ($5e93fe9694875c06$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $5e93fe9694875c06$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $5e93fe9694875c06$var$dd = !1;
    for($5e93fe9694875c06$var$V = b; null !== $5e93fe9694875c06$var$V;)if (b = $5e93fe9694875c06$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $5e93fe9694875c06$var$V = a;
    else for(; null !== $5e93fe9694875c06$var$V;){
        b = $5e93fe9694875c06$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $5e93fe9694875c06$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($5e93fe9694875c06$var$p(163));
            }
        } catch (F) {
            $5e93fe9694875c06$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $5e93fe9694875c06$var$V = a;
            break;
        }
        $5e93fe9694875c06$var$V = b.return;
    }
    n = $5e93fe9694875c06$var$Nj;
    $5e93fe9694875c06$var$Nj = !1;
    return n;
}
function $5e93fe9694875c06$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $5e93fe9694875c06$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $5e93fe9694875c06$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5e93fe9694875c06$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $5e93fe9694875c06$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $5e93fe9694875c06$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$5e93fe9694875c06$var$Of], delete b[$5e93fe9694875c06$var$Pf], delete b[$5e93fe9694875c06$var$of], delete b[$5e93fe9694875c06$var$Qf], delete b[$5e93fe9694875c06$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $5e93fe9694875c06$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5e93fe9694875c06$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $5e93fe9694875c06$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $5e93fe9694875c06$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5e93fe9694875c06$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($5e93fe9694875c06$var$Vj(a, b, c), a = a.sibling; null !== a;)$5e93fe9694875c06$var$Vj(a, b, c), a = a.sibling;
}
function $5e93fe9694875c06$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5e93fe9694875c06$var$Wj(a, b, c), a = a.sibling; null !== a;)$5e93fe9694875c06$var$Wj(a, b, c), a = a.sibling;
}
var $5e93fe9694875c06$var$X = null, $5e93fe9694875c06$var$Xj = !1;
function $5e93fe9694875c06$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$5e93fe9694875c06$var$Zj(a, b, c), c = c.sibling;
}
function $5e93fe9694875c06$var$Zj(a, b, c) {
    if ($5e93fe9694875c06$var$lc && "function" === typeof $5e93fe9694875c06$var$lc.onCommitFiberUnmount) try {
        $5e93fe9694875c06$var$lc.onCommitFiberUnmount($5e93fe9694875c06$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $5e93fe9694875c06$var$U || $5e93fe9694875c06$var$Lj(c, b);
        case 6:
            var d = $5e93fe9694875c06$var$X, e = $5e93fe9694875c06$var$Xj;
            $5e93fe9694875c06$var$X = null;
            $5e93fe9694875c06$var$Yj(a, b, c);
            $5e93fe9694875c06$var$X = d;
            $5e93fe9694875c06$var$Xj = e;
            null !== $5e93fe9694875c06$var$X && ($5e93fe9694875c06$var$Xj ? (a = $5e93fe9694875c06$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $5e93fe9694875c06$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $5e93fe9694875c06$var$X && ($5e93fe9694875c06$var$Xj ? (a = $5e93fe9694875c06$var$X, c = c.stateNode, 8 === a.nodeType ? $5e93fe9694875c06$var$Kf(a.parentNode, c) : 1 === a.nodeType && $5e93fe9694875c06$var$Kf(a, c), $5e93fe9694875c06$var$bd(a)) : $5e93fe9694875c06$var$Kf($5e93fe9694875c06$var$X, c.stateNode));
            break;
        case 4:
            d = $5e93fe9694875c06$var$X;
            e = $5e93fe9694875c06$var$Xj;
            $5e93fe9694875c06$var$X = c.stateNode.containerInfo;
            $5e93fe9694875c06$var$Xj = !0;
            $5e93fe9694875c06$var$Yj(a, b, c);
            $5e93fe9694875c06$var$X = d;
            $5e93fe9694875c06$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$5e93fe9694875c06$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $5e93fe9694875c06$var$Mj(c, b, g) : 0 !== (f & 4) && $5e93fe9694875c06$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $5e93fe9694875c06$var$Yj(a, b, c);
            break;
        case 1:
            if (!$5e93fe9694875c06$var$U && ($5e93fe9694875c06$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $5e93fe9694875c06$var$W(c, b, h);
            }
            $5e93fe9694875c06$var$Yj(a, b, c);
            break;
        case 21:
            $5e93fe9694875c06$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($5e93fe9694875c06$var$U = (d = $5e93fe9694875c06$var$U) || null !== c.memoizedState, $5e93fe9694875c06$var$Yj(a, b, c), $5e93fe9694875c06$var$U = d) : $5e93fe9694875c06$var$Yj(a, b, c);
            break;
        default:
            $5e93fe9694875c06$var$Yj(a, b, c);
    }
}
function $5e93fe9694875c06$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5e93fe9694875c06$var$Kj);
        b.forEach(function(b) {
            var d = $5e93fe9694875c06$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $5e93fe9694875c06$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $5e93fe9694875c06$var$X = h.stateNode;
                        $5e93fe9694875c06$var$Xj = !1;
                        break a;
                    case 3:
                        $5e93fe9694875c06$var$X = h.stateNode.containerInfo;
                        $5e93fe9694875c06$var$Xj = !0;
                        break a;
                    case 4:
                        $5e93fe9694875c06$var$X = h.stateNode.containerInfo;
                        $5e93fe9694875c06$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $5e93fe9694875c06$var$X) throw Error($5e93fe9694875c06$var$p(160));
            $5e93fe9694875c06$var$Zj(f, g, e);
            $5e93fe9694875c06$var$X = null;
            $5e93fe9694875c06$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $5e93fe9694875c06$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$5e93fe9694875c06$var$dk(b, a), b = b.sibling;
}
function $5e93fe9694875c06$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            if (d & 4) {
                try {
                    $5e93fe9694875c06$var$Pj(3, a, a.return), $5e93fe9694875c06$var$Qj(3, a);
                } catch (t) {
                    $5e93fe9694875c06$var$W(a, a.return, t);
                }
                try {
                    $5e93fe9694875c06$var$Pj(5, a, a.return);
                } catch (t) {
                    $5e93fe9694875c06$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            d & 512 && null !== c && $5e93fe9694875c06$var$Lj(c, c.return);
            break;
        case 5:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            d & 512 && null !== c && $5e93fe9694875c06$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $5e93fe9694875c06$var$ob(e, "");
                } catch (t) {
                    $5e93fe9694875c06$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $5e93fe9694875c06$var$ab(e, f);
                    $5e93fe9694875c06$var$vb(h, g);
                    var l = $5e93fe9694875c06$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $5e93fe9694875c06$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $5e93fe9694875c06$var$nb(e, q) : "children" === m ? $5e93fe9694875c06$var$ob(e, q) : $5e93fe9694875c06$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $5e93fe9694875c06$var$bb(e, f);
                            break;
                        case "textarea":
                            $5e93fe9694875c06$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $5e93fe9694875c06$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $5e93fe9694875c06$var$fb(e, !!f.multiple, f.defaultValue, !0) : $5e93fe9694875c06$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$5e93fe9694875c06$var$Pf] = f;
                } catch (t) {
                    $5e93fe9694875c06$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($5e93fe9694875c06$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $5e93fe9694875c06$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $5e93fe9694875c06$var$bd(b.containerInfo);
            } catch (t) {
                $5e93fe9694875c06$var$W(a, a.return, t);
            }
            break;
        case 4:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            break;
        case 13:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($5e93fe9694875c06$var$fk = $5e93fe9694875c06$var$B()));
            d & 4 && $5e93fe9694875c06$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($5e93fe9694875c06$var$U = (l = $5e93fe9694875c06$var$U) || m, $5e93fe9694875c06$var$ck(b, a), $5e93fe9694875c06$var$U = l) : $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($5e93fe9694875c06$var$V = a, m = a.child; null !== m;){
                    for(q = $5e93fe9694875c06$var$V = m; null !== $5e93fe9694875c06$var$V;){
                        r = $5e93fe9694875c06$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $5e93fe9694875c06$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $5e93fe9694875c06$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $5e93fe9694875c06$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $5e93fe9694875c06$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $5e93fe9694875c06$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $5e93fe9694875c06$var$V = y) : $5e93fe9694875c06$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $5e93fe9694875c06$var$rb("display", g));
                            } catch (t) {
                                $5e93fe9694875c06$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $5e93fe9694875c06$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $5e93fe9694875c06$var$ck(b, a);
            $5e93fe9694875c06$var$ek(a);
            d & 4 && $5e93fe9694875c06$var$ak(a);
            break;
        case 21:
            break;
        default:
            $5e93fe9694875c06$var$ck(b, a), $5e93fe9694875c06$var$ek(a);
    }
}
function $5e93fe9694875c06$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($5e93fe9694875c06$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($5e93fe9694875c06$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($5e93fe9694875c06$var$ob(e, ""), d.flags &= -33);
                    var f = $5e93fe9694875c06$var$Uj(a);
                    $5e93fe9694875c06$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $5e93fe9694875c06$var$Uj(a);
                    $5e93fe9694875c06$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($5e93fe9694875c06$var$p(161));
            }
        } catch (k) {
            $5e93fe9694875c06$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $5e93fe9694875c06$var$hk(a, b, c) {
    $5e93fe9694875c06$var$V = a;
    $5e93fe9694875c06$var$ik(a, b, c);
}
function $5e93fe9694875c06$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $5e93fe9694875c06$var$V;){
        var e = $5e93fe9694875c06$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $5e93fe9694875c06$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $5e93fe9694875c06$var$U;
                h = $5e93fe9694875c06$var$Jj;
                var l = $5e93fe9694875c06$var$U;
                $5e93fe9694875c06$var$Jj = g;
                if (($5e93fe9694875c06$var$U = k) && !l) for($5e93fe9694875c06$var$V = e; null !== $5e93fe9694875c06$var$V;)g = $5e93fe9694875c06$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $5e93fe9694875c06$var$jk(e) : null !== k ? (k.return = g, $5e93fe9694875c06$var$V = k) : $5e93fe9694875c06$var$jk(e);
                for(; null !== f;)$5e93fe9694875c06$var$V = f, $5e93fe9694875c06$var$ik(f, b, c), f = f.sibling;
                $5e93fe9694875c06$var$V = e;
                $5e93fe9694875c06$var$Jj = h;
                $5e93fe9694875c06$var$U = l;
            }
            $5e93fe9694875c06$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $5e93fe9694875c06$var$V = f) : $5e93fe9694875c06$var$kk(a, b, c);
    }
}
function $5e93fe9694875c06$var$kk(a) {
    for(; null !== $5e93fe9694875c06$var$V;){
        var b = $5e93fe9694875c06$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $5e93fe9694875c06$var$U || $5e93fe9694875c06$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$5e93fe9694875c06$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $5e93fe9694875c06$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $5e93fe9694875c06$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $5e93fe9694875c06$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $5e93fe9694875c06$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($5e93fe9694875c06$var$p(163));
                }
                $5e93fe9694875c06$var$U || b.flags & 512 && $5e93fe9694875c06$var$Rj(b);
            } catch (r) {
                $5e93fe9694875c06$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $5e93fe9694875c06$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5e93fe9694875c06$var$V = c;
            break;
        }
        $5e93fe9694875c06$var$V = b.return;
    }
}
function $5e93fe9694875c06$var$gk(a) {
    for(; null !== $5e93fe9694875c06$var$V;){
        var b = $5e93fe9694875c06$var$V;
        if (b === a) {
            $5e93fe9694875c06$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5e93fe9694875c06$var$V = c;
            break;
        }
        $5e93fe9694875c06$var$V = b.return;
    }
}
function $5e93fe9694875c06$var$jk(a) {
    for(; null !== $5e93fe9694875c06$var$V;){
        var b = $5e93fe9694875c06$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $5e93fe9694875c06$var$Qj(4, b);
                    } catch (k) {
                        $5e93fe9694875c06$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $5e93fe9694875c06$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $5e93fe9694875c06$var$Rj(b);
                    } catch (k) {
                        $5e93fe9694875c06$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $5e93fe9694875c06$var$Rj(b);
                    } catch (k) {
                        $5e93fe9694875c06$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $5e93fe9694875c06$var$W(b, b.return, k);
        }
        if (b === a) {
            $5e93fe9694875c06$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $5e93fe9694875c06$var$V = h;
            break;
        }
        $5e93fe9694875c06$var$V = b.return;
    }
}
var $5e93fe9694875c06$var$lk = Math.ceil, $5e93fe9694875c06$var$mk = $5e93fe9694875c06$var$ua.ReactCurrentDispatcher, $5e93fe9694875c06$var$nk = $5e93fe9694875c06$var$ua.ReactCurrentOwner, $5e93fe9694875c06$var$ok = $5e93fe9694875c06$var$ua.ReactCurrentBatchConfig, $5e93fe9694875c06$var$K = 0, $5e93fe9694875c06$var$Q = null, $5e93fe9694875c06$var$Y = null, $5e93fe9694875c06$var$Z = 0, $5e93fe9694875c06$var$fj = 0, $5e93fe9694875c06$var$ej = $5e93fe9694875c06$var$Uf(0), $5e93fe9694875c06$var$T = 0, $5e93fe9694875c06$var$pk = null, $5e93fe9694875c06$var$rh = 0, $5e93fe9694875c06$var$qk = 0, $5e93fe9694875c06$var$rk = 0, $5e93fe9694875c06$var$sk = null, $5e93fe9694875c06$var$tk = null, $5e93fe9694875c06$var$fk = 0, $5e93fe9694875c06$var$Gj = Infinity, $5e93fe9694875c06$var$uk = null, $5e93fe9694875c06$var$Oi = !1, $5e93fe9694875c06$var$Pi = null, $5e93fe9694875c06$var$Ri = null, $5e93fe9694875c06$var$vk = !1, $5e93fe9694875c06$var$wk = null, $5e93fe9694875c06$var$xk = 0, $5e93fe9694875c06$var$yk = 0, $5e93fe9694875c06$var$zk = null, $5e93fe9694875c06$var$Ak = -1, $5e93fe9694875c06$var$Bk = 0;
function $5e93fe9694875c06$var$R() {
    return 0 !== ($5e93fe9694875c06$var$K & 6) ? $5e93fe9694875c06$var$B() : -1 !== $5e93fe9694875c06$var$Ak ? $5e93fe9694875c06$var$Ak : $5e93fe9694875c06$var$Ak = $5e93fe9694875c06$var$B();
}
function $5e93fe9694875c06$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($5e93fe9694875c06$var$K & 2) && 0 !== $5e93fe9694875c06$var$Z) return $5e93fe9694875c06$var$Z & -$5e93fe9694875c06$var$Z;
    if (null !== $5e93fe9694875c06$var$Kg.transition) return 0 === $5e93fe9694875c06$var$Bk && ($5e93fe9694875c06$var$Bk = $5e93fe9694875c06$var$yc()), $5e93fe9694875c06$var$Bk;
    a = $5e93fe9694875c06$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $5e93fe9694875c06$var$jd(a.type);
    return a;
}
function $5e93fe9694875c06$var$gi(a, b, c, d) {
    if (50 < $5e93fe9694875c06$var$yk) throw $5e93fe9694875c06$var$yk = 0, $5e93fe9694875c06$var$zk = null, Error($5e93fe9694875c06$var$p(185));
    $5e93fe9694875c06$var$Ac(a, c, d);
    if (0 === ($5e93fe9694875c06$var$K & 2) || a !== $5e93fe9694875c06$var$Q) a === $5e93fe9694875c06$var$Q && (0 === ($5e93fe9694875c06$var$K & 2) && ($5e93fe9694875c06$var$qk |= c), 4 === $5e93fe9694875c06$var$T && $5e93fe9694875c06$var$Ck(a, $5e93fe9694875c06$var$Z)), $5e93fe9694875c06$var$Dk(a, d), 1 === c && 0 === $5e93fe9694875c06$var$K && 0 === (b.mode & 1) && ($5e93fe9694875c06$var$Gj = $5e93fe9694875c06$var$B() + 500, $5e93fe9694875c06$var$fg && $5e93fe9694875c06$var$jg());
}
function $5e93fe9694875c06$var$Dk(a, b) {
    var c = a.callbackNode;
    $5e93fe9694875c06$var$wc(a, b);
    var d = $5e93fe9694875c06$var$uc(a, a === $5e93fe9694875c06$var$Q ? $5e93fe9694875c06$var$Z : 0);
    if (0 === d) null !== c && $5e93fe9694875c06$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $5e93fe9694875c06$var$bc(c);
        if (1 === b) 0 === a.tag ? $5e93fe9694875c06$var$ig($5e93fe9694875c06$var$Ek.bind(null, a)) : $5e93fe9694875c06$var$hg($5e93fe9694875c06$var$Ek.bind(null, a)), $5e93fe9694875c06$var$Jf(function() {
            0 === ($5e93fe9694875c06$var$K & 6) && $5e93fe9694875c06$var$jg();
        }), c = null;
        else {
            switch($5e93fe9694875c06$var$Dc(d)){
                case 1:
                    c = $5e93fe9694875c06$var$fc;
                    break;
                case 4:
                    c = $5e93fe9694875c06$var$gc;
                    break;
                case 16:
                    c = $5e93fe9694875c06$var$hc;
                    break;
                case 536870912:
                    c = $5e93fe9694875c06$var$jc;
                    break;
                default:
                    c = $5e93fe9694875c06$var$hc;
            }
            c = $5e93fe9694875c06$var$Fk(c, $5e93fe9694875c06$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $5e93fe9694875c06$var$Gk(a, b) {
    $5e93fe9694875c06$var$Ak = -1;
    $5e93fe9694875c06$var$Bk = 0;
    if (0 !== ($5e93fe9694875c06$var$K & 6)) throw Error($5e93fe9694875c06$var$p(327));
    var c = a.callbackNode;
    if ($5e93fe9694875c06$var$Hk() && a.callbackNode !== c) return null;
    var d = $5e93fe9694875c06$var$uc(a, a === $5e93fe9694875c06$var$Q ? $5e93fe9694875c06$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $5e93fe9694875c06$var$Ik(a, d);
    else {
        b = d;
        var e = $5e93fe9694875c06$var$K;
        $5e93fe9694875c06$var$K |= 2;
        var f = $5e93fe9694875c06$var$Jk();
        if ($5e93fe9694875c06$var$Q !== a || $5e93fe9694875c06$var$Z !== b) $5e93fe9694875c06$var$uk = null, $5e93fe9694875c06$var$Gj = $5e93fe9694875c06$var$B() + 500, $5e93fe9694875c06$var$Kk(a, b);
        for(;;)try {
            $5e93fe9694875c06$var$Lk();
            break;
        } catch (h) {
            $5e93fe9694875c06$var$Mk(a, h);
        }
        $5e93fe9694875c06$var$$g();
        $5e93fe9694875c06$var$mk.current = f;
        $5e93fe9694875c06$var$K = e;
        null !== $5e93fe9694875c06$var$Y ? b = 0 : ($5e93fe9694875c06$var$Q = null, $5e93fe9694875c06$var$Z = 0, b = $5e93fe9694875c06$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $5e93fe9694875c06$var$xc(a), 0 !== e && (d = e, b = $5e93fe9694875c06$var$Nk(a, e)));
        if (1 === b) throw c = $5e93fe9694875c06$var$pk, $5e93fe9694875c06$var$Kk(a, 0), $5e93fe9694875c06$var$Ck(a, d), $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B()), c;
        if (6 === b) $5e93fe9694875c06$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$5e93fe9694875c06$var$Ok(e) && (b = $5e93fe9694875c06$var$Ik(a, d), 2 === b && (f = $5e93fe9694875c06$var$xc(a), 0 !== f && (d = f, b = $5e93fe9694875c06$var$Nk(a, f))), 1 === b)) throw c = $5e93fe9694875c06$var$pk, $5e93fe9694875c06$var$Kk(a, 0), $5e93fe9694875c06$var$Ck(a, d), $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($5e93fe9694875c06$var$p(345));
                case 2:
                    $5e93fe9694875c06$var$Pk(a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk);
                    break;
                case 3:
                    $5e93fe9694875c06$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $5e93fe9694875c06$var$fk + 500 - $5e93fe9694875c06$var$B(), 10 < b)) {
                        if (0 !== $5e93fe9694875c06$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $5e93fe9694875c06$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $5e93fe9694875c06$var$Ff($5e93fe9694875c06$var$Pk.bind(null, a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk), b);
                        break;
                    }
                    $5e93fe9694875c06$var$Pk(a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk);
                    break;
                case 4:
                    $5e93fe9694875c06$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $5e93fe9694875c06$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $5e93fe9694875c06$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5e93fe9694875c06$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $5e93fe9694875c06$var$Ff($5e93fe9694875c06$var$Pk.bind(null, a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk), d);
                        break;
                    }
                    $5e93fe9694875c06$var$Pk(a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk);
                    break;
                case 5:
                    $5e93fe9694875c06$var$Pk(a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk);
                    break;
                default:
                    throw Error($5e93fe9694875c06$var$p(329));
            }
        }
    }
    $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B());
    return a.callbackNode === c ? $5e93fe9694875c06$var$Gk.bind(null, a) : null;
}
function $5e93fe9694875c06$var$Nk(a, b) {
    var c = $5e93fe9694875c06$var$sk;
    a.current.memoizedState.isDehydrated && ($5e93fe9694875c06$var$Kk(a, b).flags |= 256);
    a = $5e93fe9694875c06$var$Ik(a, b);
    2 !== a && (b = $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$tk = c, null !== b && $5e93fe9694875c06$var$Fj(b));
    return a;
}
function $5e93fe9694875c06$var$Fj(a) {
    null === $5e93fe9694875c06$var$tk ? $5e93fe9694875c06$var$tk = a : $5e93fe9694875c06$var$tk.push.apply($5e93fe9694875c06$var$tk, a);
}
function $5e93fe9694875c06$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$5e93fe9694875c06$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $5e93fe9694875c06$var$Ck(a, b) {
    b &= ~$5e93fe9694875c06$var$rk;
    b &= ~$5e93fe9694875c06$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $5e93fe9694875c06$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $5e93fe9694875c06$var$Ek(a) {
    if (0 !== ($5e93fe9694875c06$var$K & 6)) throw Error($5e93fe9694875c06$var$p(327));
    $5e93fe9694875c06$var$Hk();
    var b = $5e93fe9694875c06$var$uc(a, 0);
    if (0 === (b & 1)) return $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B()), null;
    var c = $5e93fe9694875c06$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $5e93fe9694875c06$var$xc(a);
        0 !== d && (b = d, c = $5e93fe9694875c06$var$Nk(a, d));
    }
    if (1 === c) throw c = $5e93fe9694875c06$var$pk, $5e93fe9694875c06$var$Kk(a, 0), $5e93fe9694875c06$var$Ck(a, b), $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B()), c;
    if (6 === c) throw Error($5e93fe9694875c06$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $5e93fe9694875c06$var$Pk(a, $5e93fe9694875c06$var$tk, $5e93fe9694875c06$var$uk);
    $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B());
    return null;
}
function $5e93fe9694875c06$var$Qk(a, b) {
    var c = $5e93fe9694875c06$var$K;
    $5e93fe9694875c06$var$K |= 1;
    try {
        return a(b);
    } finally{
        $5e93fe9694875c06$var$K = c, 0 === $5e93fe9694875c06$var$K && ($5e93fe9694875c06$var$Gj = $5e93fe9694875c06$var$B() + 500, $5e93fe9694875c06$var$fg && $5e93fe9694875c06$var$jg());
    }
}
function $5e93fe9694875c06$var$Rk(a) {
    null !== $5e93fe9694875c06$var$wk && 0 === $5e93fe9694875c06$var$wk.tag && 0 === ($5e93fe9694875c06$var$K & 6) && $5e93fe9694875c06$var$Hk();
    var b = $5e93fe9694875c06$var$K;
    $5e93fe9694875c06$var$K |= 1;
    var c = $5e93fe9694875c06$var$ok.transition, d = $5e93fe9694875c06$var$C;
    try {
        if ($5e93fe9694875c06$var$ok.transition = null, $5e93fe9694875c06$var$C = 1, a) return a();
    } finally{
        $5e93fe9694875c06$var$C = d, $5e93fe9694875c06$var$ok.transition = c, $5e93fe9694875c06$var$K = b, 0 === ($5e93fe9694875c06$var$K & 6) && $5e93fe9694875c06$var$jg();
    }
}
function $5e93fe9694875c06$var$Hj() {
    $5e93fe9694875c06$var$fj = $5e93fe9694875c06$var$ej.current;
    $5e93fe9694875c06$var$E($5e93fe9694875c06$var$ej);
}
function $5e93fe9694875c06$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5e93fe9694875c06$var$Gf(c));
    if (null !== $5e93fe9694875c06$var$Y) for(c = $5e93fe9694875c06$var$Y.return; null !== c;){
        var d = c;
        $5e93fe9694875c06$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5e93fe9694875c06$var$$f();
                break;
            case 3:
                $5e93fe9694875c06$var$zh();
                $5e93fe9694875c06$var$E($5e93fe9694875c06$var$Wf);
                $5e93fe9694875c06$var$E($5e93fe9694875c06$var$H);
                $5e93fe9694875c06$var$Eh();
                break;
            case 5:
                $5e93fe9694875c06$var$Bh(d);
                break;
            case 4:
                $5e93fe9694875c06$var$zh();
                break;
            case 13:
                $5e93fe9694875c06$var$E($5e93fe9694875c06$var$L);
                break;
            case 19:
                $5e93fe9694875c06$var$E($5e93fe9694875c06$var$L);
                break;
            case 10:
                $5e93fe9694875c06$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $5e93fe9694875c06$var$Hj();
        }
        c = c.return;
    }
    $5e93fe9694875c06$var$Q = a;
    $5e93fe9694875c06$var$Y = a = $5e93fe9694875c06$var$Pg(a.current, null);
    $5e93fe9694875c06$var$Z = $5e93fe9694875c06$var$fj = b;
    $5e93fe9694875c06$var$T = 0;
    $5e93fe9694875c06$var$pk = null;
    $5e93fe9694875c06$var$rk = $5e93fe9694875c06$var$qk = $5e93fe9694875c06$var$rh = 0;
    $5e93fe9694875c06$var$tk = $5e93fe9694875c06$var$sk = null;
    if (null !== $5e93fe9694875c06$var$fh) {
        for(b = 0; b < $5e93fe9694875c06$var$fh.length; b++)if (c = $5e93fe9694875c06$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $5e93fe9694875c06$var$fh = null;
    }
    return a;
}
function $5e93fe9694875c06$var$Mk(a, b) {
    do {
        var c = $5e93fe9694875c06$var$Y;
        try {
            $5e93fe9694875c06$var$$g();
            $5e93fe9694875c06$var$Fh.current = $5e93fe9694875c06$var$Rh;
            if ($5e93fe9694875c06$var$Ih) {
                for(var d = $5e93fe9694875c06$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $5e93fe9694875c06$var$Ih = !1;
            }
            $5e93fe9694875c06$var$Hh = 0;
            $5e93fe9694875c06$var$O = $5e93fe9694875c06$var$N = $5e93fe9694875c06$var$M = null;
            $5e93fe9694875c06$var$Jh = !1;
            $5e93fe9694875c06$var$Kh = 0;
            $5e93fe9694875c06$var$nk.current = null;
            if (null === c || null === c.return) {
                $5e93fe9694875c06$var$T = 1;
                $5e93fe9694875c06$var$pk = b;
                $5e93fe9694875c06$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $5e93fe9694875c06$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $5e93fe9694875c06$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $5e93fe9694875c06$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $5e93fe9694875c06$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $5e93fe9694875c06$var$Si(f, l, b);
                            $5e93fe9694875c06$var$tj();
                            break a;
                        }
                        k = Error($5e93fe9694875c06$var$p(426));
                    }
                } else if ($5e93fe9694875c06$var$I && h.mode & 1) {
                    var J = $5e93fe9694875c06$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $5e93fe9694875c06$var$Vi(J, g, h, f, b);
                        $5e93fe9694875c06$var$Jg($5e93fe9694875c06$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $5e93fe9694875c06$var$Ji(k, h);
                4 !== $5e93fe9694875c06$var$T && ($5e93fe9694875c06$var$T = 2);
                null === $5e93fe9694875c06$var$sk ? $5e93fe9694875c06$var$sk = [
                    f
                ] : $5e93fe9694875c06$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $5e93fe9694875c06$var$Ni(f, k, b);
                            $5e93fe9694875c06$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $5e93fe9694875c06$var$Ri || !$5e93fe9694875c06$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $5e93fe9694875c06$var$Qi(f, h, b);
                                $5e93fe9694875c06$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $5e93fe9694875c06$var$Sk(c);
        } catch (na) {
            b = na;
            $5e93fe9694875c06$var$Y === c && null !== c && ($5e93fe9694875c06$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $5e93fe9694875c06$var$Jk() {
    var a = $5e93fe9694875c06$var$mk.current;
    $5e93fe9694875c06$var$mk.current = $5e93fe9694875c06$var$Rh;
    return null === a ? $5e93fe9694875c06$var$Rh : a;
}
function $5e93fe9694875c06$var$tj() {
    if (0 === $5e93fe9694875c06$var$T || 3 === $5e93fe9694875c06$var$T || 2 === $5e93fe9694875c06$var$T) $5e93fe9694875c06$var$T = 4;
    null === $5e93fe9694875c06$var$Q || 0 === ($5e93fe9694875c06$var$rh & 268435455) && 0 === ($5e93fe9694875c06$var$qk & 268435455) || $5e93fe9694875c06$var$Ck($5e93fe9694875c06$var$Q, $5e93fe9694875c06$var$Z);
}
function $5e93fe9694875c06$var$Ik(a, b) {
    var c = $5e93fe9694875c06$var$K;
    $5e93fe9694875c06$var$K |= 2;
    var d = $5e93fe9694875c06$var$Jk();
    if ($5e93fe9694875c06$var$Q !== a || $5e93fe9694875c06$var$Z !== b) $5e93fe9694875c06$var$uk = null, $5e93fe9694875c06$var$Kk(a, b);
    for(;;)try {
        $5e93fe9694875c06$var$Tk();
        break;
    } catch (e) {
        $5e93fe9694875c06$var$Mk(a, e);
    }
    $5e93fe9694875c06$var$$g();
    $5e93fe9694875c06$var$K = c;
    $5e93fe9694875c06$var$mk.current = d;
    if (null !== $5e93fe9694875c06$var$Y) throw Error($5e93fe9694875c06$var$p(261));
    $5e93fe9694875c06$var$Q = null;
    $5e93fe9694875c06$var$Z = 0;
    return $5e93fe9694875c06$var$T;
}
function $5e93fe9694875c06$var$Tk() {
    for(; null !== $5e93fe9694875c06$var$Y;)$5e93fe9694875c06$var$Uk($5e93fe9694875c06$var$Y);
}
function $5e93fe9694875c06$var$Lk() {
    for(; null !== $5e93fe9694875c06$var$Y && !$5e93fe9694875c06$var$cc();)$5e93fe9694875c06$var$Uk($5e93fe9694875c06$var$Y);
}
function $5e93fe9694875c06$var$Uk(a) {
    var b = $5e93fe9694875c06$var$Vk(a.alternate, a, $5e93fe9694875c06$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $5e93fe9694875c06$var$Sk(a) : $5e93fe9694875c06$var$Y = b;
    $5e93fe9694875c06$var$nk.current = null;
}
function $5e93fe9694875c06$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $5e93fe9694875c06$var$Ej(c, b, $5e93fe9694875c06$var$fj), null !== c) {
                $5e93fe9694875c06$var$Y = c;
                return;
            }
        } else {
            c = $5e93fe9694875c06$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $5e93fe9694875c06$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $5e93fe9694875c06$var$T = 6;
                $5e93fe9694875c06$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $5e93fe9694875c06$var$Y = b;
            return;
        }
        $5e93fe9694875c06$var$Y = b = a;
    }while (null !== b);
    0 === $5e93fe9694875c06$var$T && ($5e93fe9694875c06$var$T = 5);
}
function $5e93fe9694875c06$var$Pk(a, b, c) {
    var d = $5e93fe9694875c06$var$C, e = $5e93fe9694875c06$var$ok.transition;
    try {
        $5e93fe9694875c06$var$ok.transition = null, $5e93fe9694875c06$var$C = 1, $5e93fe9694875c06$var$Wk(a, b, c, d);
    } finally{
        $5e93fe9694875c06$var$ok.transition = e, $5e93fe9694875c06$var$C = d;
    }
    return null;
}
function $5e93fe9694875c06$var$Wk(a, b, c, d) {
    do $5e93fe9694875c06$var$Hk();
    while (null !== $5e93fe9694875c06$var$wk);
    if (0 !== ($5e93fe9694875c06$var$K & 6)) throw Error($5e93fe9694875c06$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($5e93fe9694875c06$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $5e93fe9694875c06$var$Bc(a, f);
    a === $5e93fe9694875c06$var$Q && ($5e93fe9694875c06$var$Y = $5e93fe9694875c06$var$Q = null, $5e93fe9694875c06$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $5e93fe9694875c06$var$vk || ($5e93fe9694875c06$var$vk = !0, $5e93fe9694875c06$var$Fk($5e93fe9694875c06$var$hc, function() {
        $5e93fe9694875c06$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $5e93fe9694875c06$var$ok.transition;
        $5e93fe9694875c06$var$ok.transition = null;
        var g = $5e93fe9694875c06$var$C;
        $5e93fe9694875c06$var$C = 1;
        var h = $5e93fe9694875c06$var$K;
        $5e93fe9694875c06$var$K |= 4;
        $5e93fe9694875c06$var$nk.current = null;
        $5e93fe9694875c06$var$Oj(a, c);
        $5e93fe9694875c06$var$dk(c, a);
        $5e93fe9694875c06$var$Oe($5e93fe9694875c06$var$Df);
        $5e93fe9694875c06$var$dd = !!$5e93fe9694875c06$var$Cf;
        $5e93fe9694875c06$var$Df = $5e93fe9694875c06$var$Cf = null;
        a.current = c;
        $5e93fe9694875c06$var$hk(c, a, e);
        $5e93fe9694875c06$var$dc();
        $5e93fe9694875c06$var$K = h;
        $5e93fe9694875c06$var$C = g;
        $5e93fe9694875c06$var$ok.transition = f;
    } else a.current = c;
    $5e93fe9694875c06$var$vk && ($5e93fe9694875c06$var$vk = !1, $5e93fe9694875c06$var$wk = a, $5e93fe9694875c06$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($5e93fe9694875c06$var$Ri = null);
    $5e93fe9694875c06$var$mc(c.stateNode, d);
    $5e93fe9694875c06$var$Dk(a, $5e93fe9694875c06$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($5e93fe9694875c06$var$Oi) throw $5e93fe9694875c06$var$Oi = !1, a = $5e93fe9694875c06$var$Pi, $5e93fe9694875c06$var$Pi = null, a;
    0 !== ($5e93fe9694875c06$var$xk & 1) && 0 !== a.tag && $5e93fe9694875c06$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $5e93fe9694875c06$var$zk ? $5e93fe9694875c06$var$yk++ : ($5e93fe9694875c06$var$yk = 0, $5e93fe9694875c06$var$zk = a) : $5e93fe9694875c06$var$yk = 0;
    $5e93fe9694875c06$var$jg();
    return null;
}
function $5e93fe9694875c06$var$Hk() {
    if (null !== $5e93fe9694875c06$var$wk) {
        var a = $5e93fe9694875c06$var$Dc($5e93fe9694875c06$var$xk), b = $5e93fe9694875c06$var$ok.transition, c = $5e93fe9694875c06$var$C;
        try {
            $5e93fe9694875c06$var$ok.transition = null;
            $5e93fe9694875c06$var$C = 16 > a ? 16 : a;
            if (null === $5e93fe9694875c06$var$wk) var d = !1;
            else {
                a = $5e93fe9694875c06$var$wk;
                $5e93fe9694875c06$var$wk = null;
                $5e93fe9694875c06$var$xk = 0;
                if (0 !== ($5e93fe9694875c06$var$K & 6)) throw Error($5e93fe9694875c06$var$p(331));
                var e = $5e93fe9694875c06$var$K;
                $5e93fe9694875c06$var$K |= 4;
                for($5e93fe9694875c06$var$V = a.current; null !== $5e93fe9694875c06$var$V;){
                    var f = $5e93fe9694875c06$var$V, g = f.child;
                    if (0 !== ($5e93fe9694875c06$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($5e93fe9694875c06$var$V = l; null !== $5e93fe9694875c06$var$V;){
                                    var m = $5e93fe9694875c06$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $5e93fe9694875c06$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $5e93fe9694875c06$var$V = q;
                                    else for(; null !== $5e93fe9694875c06$var$V;){
                                        m = $5e93fe9694875c06$var$V;
                                        var r = m.sibling, y = m.return;
                                        $5e93fe9694875c06$var$Sj(m);
                                        if (m === l) {
                                            $5e93fe9694875c06$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $5e93fe9694875c06$var$V = r;
                                            break;
                                        }
                                        $5e93fe9694875c06$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $5e93fe9694875c06$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $5e93fe9694875c06$var$V = g;
                    else b: for(; null !== $5e93fe9694875c06$var$V;){
                        f = $5e93fe9694875c06$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $5e93fe9694875c06$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $5e93fe9694875c06$var$V = x;
                            break b;
                        }
                        $5e93fe9694875c06$var$V = f.return;
                    }
                }
                var w = a.current;
                for($5e93fe9694875c06$var$V = w; null !== $5e93fe9694875c06$var$V;){
                    g = $5e93fe9694875c06$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $5e93fe9694875c06$var$V = u;
                    else b: for(g = w; null !== $5e93fe9694875c06$var$V;){
                        h = $5e93fe9694875c06$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $5e93fe9694875c06$var$Qj(9, h);
                            }
                        } catch (na) {
                            $5e93fe9694875c06$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $5e93fe9694875c06$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $5e93fe9694875c06$var$V = F;
                            break b;
                        }
                        $5e93fe9694875c06$var$V = h.return;
                    }
                }
                $5e93fe9694875c06$var$K = e;
                $5e93fe9694875c06$var$jg();
                if ($5e93fe9694875c06$var$lc && "function" === typeof $5e93fe9694875c06$var$lc.onPostCommitFiberRoot) try {
                    $5e93fe9694875c06$var$lc.onPostCommitFiberRoot($5e93fe9694875c06$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $5e93fe9694875c06$var$C = c, $5e93fe9694875c06$var$ok.transition = b;
        }
    }
    return !1;
}
function $5e93fe9694875c06$var$Xk(a, b, c) {
    b = $5e93fe9694875c06$var$Ji(c, b);
    b = $5e93fe9694875c06$var$Ni(a, b, 1);
    a = $5e93fe9694875c06$var$nh(a, b, 1);
    b = $5e93fe9694875c06$var$R();
    null !== a && ($5e93fe9694875c06$var$Ac(a, 1, b), $5e93fe9694875c06$var$Dk(a, b));
}
function $5e93fe9694875c06$var$W(a, b, c) {
    if (3 === a.tag) $5e93fe9694875c06$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $5e93fe9694875c06$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5e93fe9694875c06$var$Ri || !$5e93fe9694875c06$var$Ri.has(d))) {
                a = $5e93fe9694875c06$var$Ji(c, a);
                a = $5e93fe9694875c06$var$Qi(b, a, 1);
                b = $5e93fe9694875c06$var$nh(b, a, 1);
                a = $5e93fe9694875c06$var$R();
                null !== b && ($5e93fe9694875c06$var$Ac(b, 1, a), $5e93fe9694875c06$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $5e93fe9694875c06$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $5e93fe9694875c06$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $5e93fe9694875c06$var$Q === a && ($5e93fe9694875c06$var$Z & c) === c && (4 === $5e93fe9694875c06$var$T || 3 === $5e93fe9694875c06$var$T && ($5e93fe9694875c06$var$Z & 130023424) === $5e93fe9694875c06$var$Z && 500 > $5e93fe9694875c06$var$B() - $5e93fe9694875c06$var$fk ? $5e93fe9694875c06$var$Kk(a, 0) : $5e93fe9694875c06$var$rk |= c);
    $5e93fe9694875c06$var$Dk(a, b);
}
function $5e93fe9694875c06$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $5e93fe9694875c06$var$sc, $5e93fe9694875c06$var$sc <<= 1, 0 === ($5e93fe9694875c06$var$sc & 130023424) && ($5e93fe9694875c06$var$sc = 4194304)));
    var c = $5e93fe9694875c06$var$R();
    a = $5e93fe9694875c06$var$ih(a, b);
    null !== a && ($5e93fe9694875c06$var$Ac(a, b, c), $5e93fe9694875c06$var$Dk(a, c));
}
function $5e93fe9694875c06$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $5e93fe9694875c06$var$Yk(a, c);
}
function $5e93fe9694875c06$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($5e93fe9694875c06$var$p(314));
    }
    null !== d && d.delete(b);
    $5e93fe9694875c06$var$Yk(a, c);
}
var $5e93fe9694875c06$var$Vk;
$5e93fe9694875c06$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $5e93fe9694875c06$var$Wf.current) $5e93fe9694875c06$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $5e93fe9694875c06$var$dh = !1, $5e93fe9694875c06$var$yj(a, b, c);
            $5e93fe9694875c06$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $5e93fe9694875c06$var$dh = !1, $5e93fe9694875c06$var$I && 0 !== (b.flags & 1048576) && $5e93fe9694875c06$var$ug(b, $5e93fe9694875c06$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $5e93fe9694875c06$var$ij(a, b);
            a = b.pendingProps;
            var e = $5e93fe9694875c06$var$Yf(b, $5e93fe9694875c06$var$H.current);
            $5e93fe9694875c06$var$ch(b, c);
            e = $5e93fe9694875c06$var$Nh(null, b, d, a, e, c);
            var f = $5e93fe9694875c06$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $5e93fe9694875c06$var$Zf(d) ? (f = !0, $5e93fe9694875c06$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $5e93fe9694875c06$var$kh(b), e.updater = $5e93fe9694875c06$var$Ei, b.stateNode = e, e._reactInternals = b, $5e93fe9694875c06$var$Ii(b, d, a, c), b = $5e93fe9694875c06$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $5e93fe9694875c06$var$I && f && $5e93fe9694875c06$var$vg(b), $5e93fe9694875c06$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $5e93fe9694875c06$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $5e93fe9694875c06$var$Zk(d);
                a = $5e93fe9694875c06$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $5e93fe9694875c06$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $5e93fe9694875c06$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $5e93fe9694875c06$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $5e93fe9694875c06$var$$i(null, b, d, $5e93fe9694875c06$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($5e93fe9694875c06$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5e93fe9694875c06$var$Ci(d, e), $5e93fe9694875c06$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5e93fe9694875c06$var$Ci(d, e), $5e93fe9694875c06$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $5e93fe9694875c06$var$kj(b);
                if (null === a) throw Error($5e93fe9694875c06$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $5e93fe9694875c06$var$lh(a, b);
                $5e93fe9694875c06$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $5e93fe9694875c06$var$Ji(Error($5e93fe9694875c06$var$p(423)), b);
                        b = $5e93fe9694875c06$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $5e93fe9694875c06$var$Ji(Error($5e93fe9694875c06$var$p(424)), b);
                        b = $5e93fe9694875c06$var$lj(a, b, d, c, e);
                        break a;
                    } else for($5e93fe9694875c06$var$yg = $5e93fe9694875c06$var$Lf(b.stateNode.containerInfo.firstChild), $5e93fe9694875c06$var$xg = b, $5e93fe9694875c06$var$I = !0, $5e93fe9694875c06$var$zg = null, c = $5e93fe9694875c06$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $5e93fe9694875c06$var$Ig();
                    if (d === e) {
                        b = $5e93fe9694875c06$var$Zi(a, b, c);
                        break a;
                    }
                    $5e93fe9694875c06$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $5e93fe9694875c06$var$Ah(b), null === a && $5e93fe9694875c06$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5e93fe9694875c06$var$Ef(d, e) ? g = null : null !== f && $5e93fe9694875c06$var$Ef(d, f) && (b.flags |= 32), $5e93fe9694875c06$var$gj(a, b), $5e93fe9694875c06$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $5e93fe9694875c06$var$Eg(b), null;
        case 13:
            return $5e93fe9694875c06$var$oj(a, b, c);
        case 4:
            return $5e93fe9694875c06$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5e93fe9694875c06$var$Ug(b, null, d, c) : $5e93fe9694875c06$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5e93fe9694875c06$var$Ci(d, e), $5e93fe9694875c06$var$Yi(a, b, d, e, c);
        case 7:
            return $5e93fe9694875c06$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5e93fe9694875c06$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5e93fe9694875c06$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $5e93fe9694875c06$var$G($5e93fe9694875c06$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($5e93fe9694875c06$var$He(f.value, g)) {
                        if (f.children === e.children && !$5e93fe9694875c06$var$Wf.current) {
                            b = $5e93fe9694875c06$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $5e93fe9694875c06$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $5e93fe9694875c06$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($5e93fe9694875c06$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $5e93fe9694875c06$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $5e93fe9694875c06$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $5e93fe9694875c06$var$ch(b, c), e = $5e93fe9694875c06$var$eh(e), d = d(e), b.flags |= 1, $5e93fe9694875c06$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $5e93fe9694875c06$var$Ci(d, b.pendingProps), e = $5e93fe9694875c06$var$Ci(d.type, e), $5e93fe9694875c06$var$$i(a, b, d, e, c);
        case 15:
            return $5e93fe9694875c06$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5e93fe9694875c06$var$Ci(d, e), $5e93fe9694875c06$var$ij(a, b), b.tag = 1, $5e93fe9694875c06$var$Zf(d) ? (a = !0, $5e93fe9694875c06$var$cg(b)) : a = !1, $5e93fe9694875c06$var$ch(b, c), $5e93fe9694875c06$var$Gi(b, d, e), $5e93fe9694875c06$var$Ii(b, d, e, c), $5e93fe9694875c06$var$jj(null, b, d, !0, a, c);
        case 19:
            return $5e93fe9694875c06$var$xj(a, b, c);
        case 22:
            return $5e93fe9694875c06$var$dj(a, b, c);
    }
    throw Error($5e93fe9694875c06$var$p(156, b.tag));
};
function $5e93fe9694875c06$var$Fk(a, b) {
    return $5e93fe9694875c06$var$ac(a, b);
}
function $5e93fe9694875c06$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5e93fe9694875c06$var$Bg(a, b, c, d) {
    return new $5e93fe9694875c06$var$$k(a, b, c, d);
}
function $5e93fe9694875c06$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5e93fe9694875c06$var$Zk(a) {
    if ("function" === typeof a) return $5e93fe9694875c06$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5e93fe9694875c06$var$Da) return 11;
        if (a === $5e93fe9694875c06$var$Ga) return 14;
    }
    return 2;
}
function $5e93fe9694875c06$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $5e93fe9694875c06$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5e93fe9694875c06$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5e93fe9694875c06$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5e93fe9694875c06$var$ya:
            return $5e93fe9694875c06$var$Tg(c.children, e, f, b);
        case $5e93fe9694875c06$var$za:
            g = 8;
            e |= 8;
            break;
        case $5e93fe9694875c06$var$Aa:
            return a = $5e93fe9694875c06$var$Bg(12, c, b, e | 2), a.elementType = $5e93fe9694875c06$var$Aa, a.lanes = f, a;
        case $5e93fe9694875c06$var$Ea:
            return a = $5e93fe9694875c06$var$Bg(13, c, b, e), a.elementType = $5e93fe9694875c06$var$Ea, a.lanes = f, a;
        case $5e93fe9694875c06$var$Fa:
            return a = $5e93fe9694875c06$var$Bg(19, c, b, e), a.elementType = $5e93fe9694875c06$var$Fa, a.lanes = f, a;
        case $5e93fe9694875c06$var$Ia:
            return $5e93fe9694875c06$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5e93fe9694875c06$var$Ba:
                    g = 10;
                    break a;
                case $5e93fe9694875c06$var$Ca:
                    g = 9;
                    break a;
                case $5e93fe9694875c06$var$Da:
                    g = 11;
                    break a;
                case $5e93fe9694875c06$var$Ga:
                    g = 14;
                    break a;
                case $5e93fe9694875c06$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($5e93fe9694875c06$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $5e93fe9694875c06$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $5e93fe9694875c06$var$Tg(a, b, c, d) {
    a = $5e93fe9694875c06$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $5e93fe9694875c06$var$pj(a, b, c, d) {
    a = $5e93fe9694875c06$var$Bg(22, a, d, b);
    a.elementType = $5e93fe9694875c06$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $5e93fe9694875c06$var$Qg(a, b, c) {
    a = $5e93fe9694875c06$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $5e93fe9694875c06$var$Sg(a, b, c) {
    b = $5e93fe9694875c06$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5e93fe9694875c06$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $5e93fe9694875c06$var$zc(0);
    this.expirationTimes = $5e93fe9694875c06$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5e93fe9694875c06$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $5e93fe9694875c06$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $5e93fe9694875c06$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $5e93fe9694875c06$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $5e93fe9694875c06$var$kh(f);
    return a;
}
function $5e93fe9694875c06$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5e93fe9694875c06$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $5e93fe9694875c06$var$dl(a) {
    if (!a) return $5e93fe9694875c06$var$Vf;
    a = a._reactInternals;
    a: {
        if ($5e93fe9694875c06$var$Vb(a) !== a || 1 !== a.tag) throw Error($5e93fe9694875c06$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($5e93fe9694875c06$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($5e93fe9694875c06$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($5e93fe9694875c06$var$Zf(c)) return $5e93fe9694875c06$var$bg(a, c, b);
    }
    return b;
}
function $5e93fe9694875c06$var$el(a, b, c, d, e, f, g, h, k) {
    a = $5e93fe9694875c06$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $5e93fe9694875c06$var$dl(null);
    c = a.current;
    d = $5e93fe9694875c06$var$R();
    e = $5e93fe9694875c06$var$yi(c);
    f = $5e93fe9694875c06$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $5e93fe9694875c06$var$nh(c, f, e);
    a.current.lanes = e;
    $5e93fe9694875c06$var$Ac(a, e, d);
    $5e93fe9694875c06$var$Dk(a, d);
    return a;
}
function $5e93fe9694875c06$var$fl(a, b, c, d) {
    var e = b.current, f = $5e93fe9694875c06$var$R(), g = $5e93fe9694875c06$var$yi(e);
    c = $5e93fe9694875c06$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5e93fe9694875c06$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $5e93fe9694875c06$var$nh(e, b, g);
    null !== a && ($5e93fe9694875c06$var$gi(a, e, g, f), $5e93fe9694875c06$var$oh(a, e, g));
    return g;
}
function $5e93fe9694875c06$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5e93fe9694875c06$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $5e93fe9694875c06$var$il(a, b) {
    $5e93fe9694875c06$var$hl(a, b);
    (a = a.alternate) && $5e93fe9694875c06$var$hl(a, b);
}
function $5e93fe9694875c06$var$jl() {
    return null;
}
var $5e93fe9694875c06$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $5e93fe9694875c06$var$ll(a) {
    this._internalRoot = a;
}
$5e93fe9694875c06$var$ml.prototype.render = $5e93fe9694875c06$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($5e93fe9694875c06$var$p(409));
    $5e93fe9694875c06$var$fl(a, b, null, null);
};
$5e93fe9694875c06$var$ml.prototype.unmount = $5e93fe9694875c06$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $5e93fe9694875c06$var$Rk(function() {
            $5e93fe9694875c06$var$fl(null, a, null, null);
        });
        b[$5e93fe9694875c06$var$uf] = null;
    }
};
function $5e93fe9694875c06$var$ml(a) {
    this._internalRoot = a;
}
$5e93fe9694875c06$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $5e93fe9694875c06$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $5e93fe9694875c06$var$Qc.length && 0 !== b && b < $5e93fe9694875c06$var$Qc[c].priority; c++);
        $5e93fe9694875c06$var$Qc.splice(c, 0, a);
        0 === c && $5e93fe9694875c06$var$Vc(a);
    }
};
function $5e93fe9694875c06$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $5e93fe9694875c06$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5e93fe9694875c06$var$pl() {}
function $5e93fe9694875c06$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $5e93fe9694875c06$var$gl(g);
                f.call(a);
            };
        }
        var g = $5e93fe9694875c06$var$el(b, d, a, 0, null, !1, !1, "", $5e93fe9694875c06$var$pl);
        a._reactRootContainer = g;
        a[$5e93fe9694875c06$var$uf] = g.current;
        $5e93fe9694875c06$var$sf(8 === a.nodeType ? a.parentNode : a);
        $5e93fe9694875c06$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $5e93fe9694875c06$var$gl(k);
            h.call(a);
        };
    }
    var k = $5e93fe9694875c06$var$bl(a, 0, !1, null, null, !1, !1, "", $5e93fe9694875c06$var$pl);
    a._reactRootContainer = k;
    a[$5e93fe9694875c06$var$uf] = k.current;
    $5e93fe9694875c06$var$sf(8 === a.nodeType ? a.parentNode : a);
    $5e93fe9694875c06$var$Rk(function() {
        $5e93fe9694875c06$var$fl(b, k, c, d);
    });
    return k;
}
function $5e93fe9694875c06$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $5e93fe9694875c06$var$gl(g);
                h.call(a);
            };
        }
        $5e93fe9694875c06$var$fl(b, g, a, e);
    } else g = $5e93fe9694875c06$var$ql(c, b, a, e, d);
    return $5e93fe9694875c06$var$gl(g);
}
$5e93fe9694875c06$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $5e93fe9694875c06$var$tc(b.pendingLanes);
                0 !== c && ($5e93fe9694875c06$var$Cc(b, c | 1), $5e93fe9694875c06$var$Dk(b, $5e93fe9694875c06$var$B()), 0 === ($5e93fe9694875c06$var$K & 6) && ($5e93fe9694875c06$var$Gj = $5e93fe9694875c06$var$B() + 500, $5e93fe9694875c06$var$jg()));
            }
            break;
        case 13:
            $5e93fe9694875c06$var$Rk(function() {
                var b = $5e93fe9694875c06$var$ih(a, 1);
                if (null !== b) {
                    var c = $5e93fe9694875c06$var$R();
                    $5e93fe9694875c06$var$gi(b, a, 1, c);
                }
            }), $5e93fe9694875c06$var$il(a, 1);
    }
};
$5e93fe9694875c06$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $5e93fe9694875c06$var$ih(a, 134217728);
        if (null !== b) {
            var c = $5e93fe9694875c06$var$R();
            $5e93fe9694875c06$var$gi(b, a, 134217728, c);
        }
        $5e93fe9694875c06$var$il(a, 134217728);
    }
};
$5e93fe9694875c06$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $5e93fe9694875c06$var$yi(a), c = $5e93fe9694875c06$var$ih(a, b);
        if (null !== c) {
            var d = $5e93fe9694875c06$var$R();
            $5e93fe9694875c06$var$gi(c, a, b, d);
        }
        $5e93fe9694875c06$var$il(a, b);
    }
};
$5e93fe9694875c06$var$Hc = function() {
    return $5e93fe9694875c06$var$C;
};
$5e93fe9694875c06$var$Ic = function(a, b) {
    var c = $5e93fe9694875c06$var$C;
    try {
        return $5e93fe9694875c06$var$C = a, b();
    } finally{
        $5e93fe9694875c06$var$C = c;
    }
};
$5e93fe9694875c06$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $5e93fe9694875c06$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5e93fe9694875c06$var$Db(d);
                        if (!e) throw Error($5e93fe9694875c06$var$p(90));
                        $5e93fe9694875c06$var$Wa(d);
                        $5e93fe9694875c06$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5e93fe9694875c06$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $5e93fe9694875c06$var$fb(a, !!c.multiple, b, !1);
    }
};
$5e93fe9694875c06$var$Gb = $5e93fe9694875c06$var$Qk;
$5e93fe9694875c06$var$Hb = $5e93fe9694875c06$var$Rk;
var $5e93fe9694875c06$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $5e93fe9694875c06$var$Cb,
        $5e93fe9694875c06$var$ue,
        $5e93fe9694875c06$var$Db,
        $5e93fe9694875c06$var$Eb,
        $5e93fe9694875c06$var$Fb,
        $5e93fe9694875c06$var$Qk
    ]
}, $5e93fe9694875c06$var$tl = {
    findFiberByHostInstance: $5e93fe9694875c06$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $5e93fe9694875c06$var$ul = {
    bundleType: $5e93fe9694875c06$var$tl.bundleType,
    version: $5e93fe9694875c06$var$tl.version,
    rendererPackageName: $5e93fe9694875c06$var$tl.rendererPackageName,
    rendererConfig: $5e93fe9694875c06$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $5e93fe9694875c06$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $5e93fe9694875c06$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $5e93fe9694875c06$var$tl.findFiberByHostInstance || $5e93fe9694875c06$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5e93fe9694875c06$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5e93fe9694875c06$var$vl.isDisabled && $5e93fe9694875c06$var$vl.supportsFiber) try {
        $5e93fe9694875c06$var$kc = $5e93fe9694875c06$var$vl.inject($5e93fe9694875c06$var$ul), $5e93fe9694875c06$var$lc = $5e93fe9694875c06$var$vl;
    } catch (a) {}
}
$5e93fe9694875c06$export$ae55be85d98224ed = $5e93fe9694875c06$var$sl;
$5e93fe9694875c06$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5e93fe9694875c06$var$nl(b)) throw Error($5e93fe9694875c06$var$p(200));
    return $5e93fe9694875c06$var$cl(a, b, null, c);
};
$5e93fe9694875c06$export$882461b6382ed46c = function(a, b) {
    if (!$5e93fe9694875c06$var$nl(a)) throw Error($5e93fe9694875c06$var$p(299));
    var c = !1, d = "", e = $5e93fe9694875c06$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $5e93fe9694875c06$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$5e93fe9694875c06$var$uf] = b.current;
    $5e93fe9694875c06$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $5e93fe9694875c06$var$ll(b);
};
$5e93fe9694875c06$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5e93fe9694875c06$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($5e93fe9694875c06$var$p(268, a));
    }
    a = $5e93fe9694875c06$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5e93fe9694875c06$export$cd75ccfd720a3cd4 = function(a) {
    return $5e93fe9694875c06$var$Rk(a);
};
$5e93fe9694875c06$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5e93fe9694875c06$var$ol(b)) throw Error($5e93fe9694875c06$var$p(200));
    return $5e93fe9694875c06$var$rl(null, a, b, !0, c);
};
$5e93fe9694875c06$export$757ceba2d55c277e = function(a, b, c) {
    if (!$5e93fe9694875c06$var$nl(a)) throw Error($5e93fe9694875c06$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $5e93fe9694875c06$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $5e93fe9694875c06$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$5e93fe9694875c06$var$uf] = b.current;
    $5e93fe9694875c06$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $5e93fe9694875c06$var$ml(b);
};
$5e93fe9694875c06$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5e93fe9694875c06$var$ol(b)) throw Error($5e93fe9694875c06$var$p(200));
    return $5e93fe9694875c06$var$rl(null, a, b, !1, c);
};
$5e93fe9694875c06$export$502457920280e6be = function(a) {
    if (!$5e93fe9694875c06$var$ol(a)) throw Error($5e93fe9694875c06$var$p(40));
    return a._reactRootContainer ? ($5e93fe9694875c06$var$Rk(function() {
        $5e93fe9694875c06$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5e93fe9694875c06$var$uf] = null;
        });
    }), !0) : !1;
};
$5e93fe9694875c06$export$c78a37762a8d58e1 = $5e93fe9694875c06$var$Qk;
$5e93fe9694875c06$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5e93fe9694875c06$var$ol(c)) throw Error($5e93fe9694875c06$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($5e93fe9694875c06$var$p(38));
    return $5e93fe9694875c06$var$rl(a, b, c, !1, d);
};
$5e93fe9694875c06$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRequire.register("dmA7Z", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3orDJ"));

});
parcelRequire.register("3orDJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $27890db1971b1caa$export$c4744153514ff05d, (v) => $27890db1971b1caa$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $27890db1971b1caa$export$3e506c1ccc9cc1a7, (v) => $27890db1971b1caa$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $27890db1971b1caa$export$e26fe2ed2fa76875, (v) => $27890db1971b1caa$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $27890db1971b1caa$export$502329bbf4b505b1, (v) => $27890db1971b1caa$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $27890db1971b1caa$export$6e3807111c4874c4, (v) => $27890db1971b1caa$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $27890db1971b1caa$export$c27134553091fb3a, (v) => $27890db1971b1caa$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $27890db1971b1caa$export$33ee1acdc04fd2a2, (v) => $27890db1971b1caa$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $27890db1971b1caa$export$b00a404bbd5edef2, (v) => $27890db1971b1caa$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $27890db1971b1caa$export$8352ce38b91d0c62, (v) => $27890db1971b1caa$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $27890db1971b1caa$export$d66a1c1c77bd778b, (v) => $27890db1971b1caa$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $27890db1971b1caa$export$d3dfb8e4810cb555, (v) => $27890db1971b1caa$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $27890db1971b1caa$export$839f9183b0465a69, (v) => $27890db1971b1caa$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $27890db1971b1caa$export$72fdf0e06517287b, (v) => $27890db1971b1caa$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $27890db1971b1caa$export$4b844e58a3e414b4, (v) => $27890db1971b1caa$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $27890db1971b1caa$export$816d2913ae6b83b1, (v) => $27890db1971b1caa$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $27890db1971b1caa$export$61bcfe829111a1d0, (v) => $27890db1971b1caa$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $27890db1971b1caa$export$7ee8c9beb337bc3f, (v) => $27890db1971b1caa$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $27890db1971b1caa$export$b5836b71941fa3ed, (v) => $27890db1971b1caa$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $27890db1971b1caa$export$cf845f2c119da08a, (v) => $27890db1971b1caa$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27890db1971b1caa$export$c4744153514ff05d;
var $27890db1971b1caa$export$3e506c1ccc9cc1a7;
var $27890db1971b1caa$export$e26fe2ed2fa76875;
var $27890db1971b1caa$export$502329bbf4b505b1;
var $27890db1971b1caa$export$6e3807111c4874c4;
var $27890db1971b1caa$export$c27134553091fb3a;
var $27890db1971b1caa$export$33ee1acdc04fd2a2;
var $27890db1971b1caa$export$b00a404bbd5edef2;
var $27890db1971b1caa$export$8352ce38b91d0c62;
var $27890db1971b1caa$export$d66a1c1c77bd778b;
var $27890db1971b1caa$export$d3dfb8e4810cb555;
var $27890db1971b1caa$export$839f9183b0465a69;
var $27890db1971b1caa$export$72fdf0e06517287b;
var $27890db1971b1caa$export$4b844e58a3e414b4;
var $27890db1971b1caa$export$816d2913ae6b83b1;
var $27890db1971b1caa$export$61bcfe829111a1d0;
var $27890db1971b1caa$export$7ee8c9beb337bc3f;
var $27890db1971b1caa$export$b5836b71941fa3ed;
var $27890db1971b1caa$export$cf845f2c119da08a;
"use strict";
function $27890db1971b1caa$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $27890db1971b1caa$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $27890db1971b1caa$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $27890db1971b1caa$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $27890db1971b1caa$var$g(C, c)) n < e && 0 > $27890db1971b1caa$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $27890db1971b1caa$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $27890db1971b1caa$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $27890db1971b1caa$var$l = performance;
    $27890db1971b1caa$export$c4744153514ff05d = function() {
        return $27890db1971b1caa$var$l.now();
    };
} else {
    var $27890db1971b1caa$var$p = Date, $27890db1971b1caa$var$q = $27890db1971b1caa$var$p.now();
    $27890db1971b1caa$export$c4744153514ff05d = function() {
        return $27890db1971b1caa$var$p.now() - $27890db1971b1caa$var$q;
    };
}
var $27890db1971b1caa$var$r = [], $27890db1971b1caa$var$t = [], $27890db1971b1caa$var$u = 1, $27890db1971b1caa$var$v = null, $27890db1971b1caa$var$y = 3, $27890db1971b1caa$var$z = !1, $27890db1971b1caa$var$A = !1, $27890db1971b1caa$var$B = !1, $27890db1971b1caa$var$D = "function" === typeof setTimeout ? setTimeout : null, $27890db1971b1caa$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $27890db1971b1caa$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $27890db1971b1caa$var$G(a) {
    for(var b = $27890db1971b1caa$var$h($27890db1971b1caa$var$t); null !== b;){
        if (null === b.callback) $27890db1971b1caa$var$k($27890db1971b1caa$var$t);
        else if (b.startTime <= a) $27890db1971b1caa$var$k($27890db1971b1caa$var$t), b.sortIndex = b.expirationTime, $27890db1971b1caa$var$f($27890db1971b1caa$var$r, b);
        else break;
        b = $27890db1971b1caa$var$h($27890db1971b1caa$var$t);
    }
}
function $27890db1971b1caa$var$H(a) {
    $27890db1971b1caa$var$B = !1;
    $27890db1971b1caa$var$G(a);
    if (!$27890db1971b1caa$var$A) {
        if (null !== $27890db1971b1caa$var$h($27890db1971b1caa$var$r)) $27890db1971b1caa$var$A = !0, $27890db1971b1caa$var$I($27890db1971b1caa$var$J);
        else {
            var b = $27890db1971b1caa$var$h($27890db1971b1caa$var$t);
            null !== b && $27890db1971b1caa$var$K($27890db1971b1caa$var$H, b.startTime - a);
        }
    }
}
function $27890db1971b1caa$var$J(a, b) {
    $27890db1971b1caa$var$A = !1;
    $27890db1971b1caa$var$B && ($27890db1971b1caa$var$B = !1, $27890db1971b1caa$var$E($27890db1971b1caa$var$L), $27890db1971b1caa$var$L = -1);
    $27890db1971b1caa$var$z = !0;
    var c = $27890db1971b1caa$var$y;
    try {
        $27890db1971b1caa$var$G(b);
        for($27890db1971b1caa$var$v = $27890db1971b1caa$var$h($27890db1971b1caa$var$r); null !== $27890db1971b1caa$var$v && (!($27890db1971b1caa$var$v.expirationTime > b) || a && !$27890db1971b1caa$var$M());){
            var d = $27890db1971b1caa$var$v.callback;
            if ("function" === typeof d) {
                $27890db1971b1caa$var$v.callback = null;
                $27890db1971b1caa$var$y = $27890db1971b1caa$var$v.priorityLevel;
                var e = d($27890db1971b1caa$var$v.expirationTime <= b);
                b = $27890db1971b1caa$export$c4744153514ff05d();
                "function" === typeof e ? $27890db1971b1caa$var$v.callback = e : $27890db1971b1caa$var$v === $27890db1971b1caa$var$h($27890db1971b1caa$var$r) && $27890db1971b1caa$var$k($27890db1971b1caa$var$r);
                $27890db1971b1caa$var$G(b);
            } else $27890db1971b1caa$var$k($27890db1971b1caa$var$r);
            $27890db1971b1caa$var$v = $27890db1971b1caa$var$h($27890db1971b1caa$var$r);
        }
        if (null !== $27890db1971b1caa$var$v) var w = !0;
        else {
            var m = $27890db1971b1caa$var$h($27890db1971b1caa$var$t);
            null !== m && $27890db1971b1caa$var$K($27890db1971b1caa$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $27890db1971b1caa$var$v = null, $27890db1971b1caa$var$y = c, $27890db1971b1caa$var$z = !1;
    }
}
var $27890db1971b1caa$var$N = !1, $27890db1971b1caa$var$O = null, $27890db1971b1caa$var$L = -1, $27890db1971b1caa$var$P = 5, $27890db1971b1caa$var$Q = -1;
function $27890db1971b1caa$var$M() {
    return $27890db1971b1caa$export$c4744153514ff05d() - $27890db1971b1caa$var$Q < $27890db1971b1caa$var$P ? !1 : !0;
}
function $27890db1971b1caa$var$R() {
    if (null !== $27890db1971b1caa$var$O) {
        var a = $27890db1971b1caa$export$c4744153514ff05d();
        $27890db1971b1caa$var$Q = a;
        var b = !0;
        try {
            b = $27890db1971b1caa$var$O(!0, a);
        } finally{
            b ? $27890db1971b1caa$var$S() : ($27890db1971b1caa$var$N = !1, $27890db1971b1caa$var$O = null);
        }
    } else $27890db1971b1caa$var$N = !1;
}
var $27890db1971b1caa$var$S;
if ("function" === typeof $27890db1971b1caa$var$F) $27890db1971b1caa$var$S = function() {
    $27890db1971b1caa$var$F($27890db1971b1caa$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $27890db1971b1caa$var$T = new MessageChannel, $27890db1971b1caa$var$U = $27890db1971b1caa$var$T.port2;
    $27890db1971b1caa$var$T.port1.onmessage = $27890db1971b1caa$var$R;
    $27890db1971b1caa$var$S = function() {
        $27890db1971b1caa$var$U.postMessage(null);
    };
} else $27890db1971b1caa$var$S = function() {
    $27890db1971b1caa$var$D($27890db1971b1caa$var$R, 0);
};
function $27890db1971b1caa$var$I(a) {
    $27890db1971b1caa$var$O = a;
    $27890db1971b1caa$var$N || ($27890db1971b1caa$var$N = !0, $27890db1971b1caa$var$S());
}
function $27890db1971b1caa$var$K(a, b) {
    $27890db1971b1caa$var$L = $27890db1971b1caa$var$D(function() {
        a($27890db1971b1caa$export$c4744153514ff05d());
    }, b);
}
$27890db1971b1caa$export$3e506c1ccc9cc1a7 = 5;
$27890db1971b1caa$export$e26fe2ed2fa76875 = 1;
$27890db1971b1caa$export$502329bbf4b505b1 = 4;
$27890db1971b1caa$export$6e3807111c4874c4 = 3;
$27890db1971b1caa$export$c27134553091fb3a = null;
$27890db1971b1caa$export$33ee1acdc04fd2a2 = 2;
$27890db1971b1caa$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$27890db1971b1caa$export$8352ce38b91d0c62 = function() {
    $27890db1971b1caa$var$A || $27890db1971b1caa$var$z || ($27890db1971b1caa$var$A = !0, $27890db1971b1caa$var$I($27890db1971b1caa$var$J));
};
$27890db1971b1caa$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $27890db1971b1caa$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$27890db1971b1caa$export$d3dfb8e4810cb555 = function() {
    return $27890db1971b1caa$var$y;
};
$27890db1971b1caa$export$839f9183b0465a69 = function() {
    return $27890db1971b1caa$var$h($27890db1971b1caa$var$r);
};
$27890db1971b1caa$export$72fdf0e06517287b = function(a) {
    switch($27890db1971b1caa$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $27890db1971b1caa$var$y;
    }
    var c = $27890db1971b1caa$var$y;
    $27890db1971b1caa$var$y = b;
    try {
        return a();
    } finally{
        $27890db1971b1caa$var$y = c;
    }
};
$27890db1971b1caa$export$4b844e58a3e414b4 = function() {};
$27890db1971b1caa$export$816d2913ae6b83b1 = function() {};
$27890db1971b1caa$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $27890db1971b1caa$var$y;
    $27890db1971b1caa$var$y = a;
    try {
        return b();
    } finally{
        $27890db1971b1caa$var$y = c;
    }
};
$27890db1971b1caa$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $27890db1971b1caa$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $27890db1971b1caa$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $27890db1971b1caa$var$f($27890db1971b1caa$var$t, a), null === $27890db1971b1caa$var$h($27890db1971b1caa$var$r) && a === $27890db1971b1caa$var$h($27890db1971b1caa$var$t) && ($27890db1971b1caa$var$B ? ($27890db1971b1caa$var$E($27890db1971b1caa$var$L), $27890db1971b1caa$var$L = -1) : $27890db1971b1caa$var$B = !0, $27890db1971b1caa$var$K($27890db1971b1caa$var$H, c - d))) : (a.sortIndex = e, $27890db1971b1caa$var$f($27890db1971b1caa$var$r, a), $27890db1971b1caa$var$A || $27890db1971b1caa$var$z || ($27890db1971b1caa$var$A = !0, $27890db1971b1caa$var$I($27890db1971b1caa$var$J)));
    return a;
};
$27890db1971b1caa$export$b5836b71941fa3ed = $27890db1971b1caa$var$M;
$27890db1971b1caa$export$cf845f2c119da08a = function(a) {
    var b = $27890db1971b1caa$var$y;
    return function() {
        var c = $27890db1971b1caa$var$y;
        $27890db1971b1caa$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $27890db1971b1caa$var$y = c;
        }
    };
};

});



parcelRequire.register("fJICV", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");

var $dbLTi = parcelRequire("dbLTi");

var $19kvf = parcelRequire("19kvf");

var $cGFxB = parcelRequire("cGFxB");

var $fpjO2 = parcelRequire("fpjO2");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $b74dacf1760c22e6$var$createInstance(defaultConfig) {
    var context = new $19kvf(defaultConfig);
    var instance = $dbLTi($19kvf.prototype.request, context);
    // Copy axios.prototype to instance
    $8IOzy.extend(instance, $19kvf.prototype, context);
    // Copy context to instance
    $8IOzy.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $b74dacf1760c22e6$var$axios = $b74dacf1760c22e6$var$createInstance($fpjO2);
// Expose Axios class to allow class inheritance
$b74dacf1760c22e6$var$axios.Axios = $19kvf;
// Factory for creating new instances
$b74dacf1760c22e6$var$axios.create = function create(instanceConfig) {
    return $b74dacf1760c22e6$var$createInstance($cGFxB($b74dacf1760c22e6$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$b74dacf1760c22e6$var$axios.Cancel = (parcelRequire("30Zfx"));

$b74dacf1760c22e6$var$axios.CancelToken = (parcelRequire("492y7"));

$b74dacf1760c22e6$var$axios.isCancel = (parcelRequire("eydkR"));
// Expose all/spread
$b74dacf1760c22e6$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$b74dacf1760c22e6$var$axios.spread = (parcelRequire("aCEp5"));

// Expose isAxiosError
$b74dacf1760c22e6$var$axios.isAxiosError = (parcelRequire("28bqL"));
module.exports = $b74dacf1760c22e6$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $b74dacf1760c22e6$var$axios;

});
parcelRequire.register("8IOzy", function(module, exports) {
"use strict";

var $dbLTi = parcelRequire("dbLTi");
// utils is a library of generic helper functions non-specific to axios
var $6599a9705d575d70$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $6599a9705d575d70$var$isArray(val) {
    return $6599a9705d575d70$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $6599a9705d575d70$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $6599a9705d575d70$var$isBuffer(val) {
    return val !== null && !$6599a9705d575d70$var$isUndefined(val) && val.constructor !== null && !$6599a9705d575d70$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $6599a9705d575d70$var$isArrayBuffer(val) {
    return $6599a9705d575d70$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $6599a9705d575d70$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $6599a9705d575d70$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $6599a9705d575d70$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $6599a9705d575d70$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $6599a9705d575d70$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $6599a9705d575d70$var$isPlainObject(val) {
    if ($6599a9705d575d70$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $6599a9705d575d70$var$isDate(val) {
    return $6599a9705d575d70$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $6599a9705d575d70$var$isFile(val) {
    return $6599a9705d575d70$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $6599a9705d575d70$var$isBlob(val) {
    return $6599a9705d575d70$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $6599a9705d575d70$var$isFunction(val) {
    return $6599a9705d575d70$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $6599a9705d575d70$var$isStream(val) {
    return $6599a9705d575d70$var$isObject(val) && $6599a9705d575d70$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $6599a9705d575d70$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $6599a9705d575d70$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $6599a9705d575d70$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $6599a9705d575d70$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($6599a9705d575d70$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $6599a9705d575d70$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($6599a9705d575d70$var$isPlainObject(result[key]) && $6599a9705d575d70$var$isPlainObject(val)) result[key] = $6599a9705d575d70$var$merge(result[key], val);
        else if ($6599a9705d575d70$var$isPlainObject(val)) result[key] = $6599a9705d575d70$var$merge({}, val);
        else if ($6599a9705d575d70$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$6599a9705d575d70$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $6599a9705d575d70$var$extend(a, b, thisArg) {
    $6599a9705d575d70$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $dbLTi(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $6599a9705d575d70$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $6599a9705d575d70$var$isArray,
    isArrayBuffer: $6599a9705d575d70$var$isArrayBuffer,
    isBuffer: $6599a9705d575d70$var$isBuffer,
    isFormData: $6599a9705d575d70$var$isFormData,
    isArrayBufferView: $6599a9705d575d70$var$isArrayBufferView,
    isString: $6599a9705d575d70$var$isString,
    isNumber: $6599a9705d575d70$var$isNumber,
    isObject: $6599a9705d575d70$var$isObject,
    isPlainObject: $6599a9705d575d70$var$isPlainObject,
    isUndefined: $6599a9705d575d70$var$isUndefined,
    isDate: $6599a9705d575d70$var$isDate,
    isFile: $6599a9705d575d70$var$isFile,
    isBlob: $6599a9705d575d70$var$isBlob,
    isFunction: $6599a9705d575d70$var$isFunction,
    isStream: $6599a9705d575d70$var$isStream,
    isURLSearchParams: $6599a9705d575d70$var$isURLSearchParams,
    isStandardBrowserEnv: $6599a9705d575d70$var$isStandardBrowserEnv,
    forEach: $6599a9705d575d70$var$forEach,
    merge: $6599a9705d575d70$var$merge,
    extend: $6599a9705d575d70$var$extend,
    trim: $6599a9705d575d70$var$trim,
    stripBOM: $6599a9705d575d70$var$stripBOM
};

});
parcelRequire.register("dbLTi", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("19kvf", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");

var $foKcx = parcelRequire("foKcx");

var $jD1rz = parcelRequire("jD1rz");

var $iU1T1 = parcelRequire("iU1T1");

var $cGFxB = parcelRequire("cGFxB");

var $fGVL9 = parcelRequire("fGVL9");
var $0d668932d6194043$var$validators = $fGVL9.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $0d668932d6194043$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $jD1rz(),
        response: new $jD1rz()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $0d668932d6194043$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $cGFxB(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $fGVL9.assertOptions(transitional, {
        silentJSONParsing: $0d668932d6194043$var$validators.transitional($0d668932d6194043$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $0d668932d6194043$var$validators.transitional($0d668932d6194043$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $0d668932d6194043$var$validators.transitional($0d668932d6194043$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $iU1T1,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $iU1T1(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$0d668932d6194043$var$Axios.prototype.getUri = function getUri(config) {
    config = $cGFxB(this.defaults, config);
    return $foKcx(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$8IOzy.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0d668932d6194043$var$Axios.prototype[method] = function(url, config) {
        return this.request($cGFxB(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$8IOzy.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $0d668932d6194043$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($cGFxB(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $0d668932d6194043$var$Axios;

});
parcelRequire.register("foKcx", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
function $b35cef839ef2753e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($8IOzy.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $8IOzy.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($8IOzy.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $8IOzy.forEach(val, function parseValue(v) {
                if ($8IOzy.isDate(v)) v = v.toISOString();
                else if ($8IOzy.isObject(v)) v = JSON.stringify(v);
                parts.push($b35cef839ef2753e$var$encode(key) + "=" + $b35cef839ef2753e$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("jD1rz", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
function $e4a2c7854746d62b$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $e4a2c7854746d62b$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $e4a2c7854746d62b$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $e4a2c7854746d62b$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $8IOzy.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $e4a2c7854746d62b$var$InterceptorManager;

});

parcelRequire.register("iU1T1", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");

var $avVK7 = parcelRequire("avVK7");

var $eydkR = parcelRequire("eydkR");

var $fpjO2 = parcelRequire("fpjO2");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $dc2eeb8bddb37c67$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $dc2eeb8bddb37c67$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $avVK7.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $8IOzy.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $8IOzy.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $fpjO2.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $dc2eeb8bddb37c67$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $avVK7.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$eydkR(reason)) {
            $dc2eeb8bddb37c67$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $avVK7.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("avVK7", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");

var $fpjO2 = parcelRequire("fpjO2");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $fpjO2;
    /*eslint no-param-reassign:0*/ $8IOzy.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("fpjO2", function(module, exports) {

var $g7XGz = parcelRequire("g7XGz");
"use strict";

var $8IOzy = parcelRequire("8IOzy");

var $ed7sb = parcelRequire("ed7sb");

var $2Yj3t = parcelRequire("2Yj3t");
var $b3788de439951053$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $b3788de439951053$var$setContentTypeIfUnset(headers, value) {
    if (!$8IOzy.isUndefined(headers) && $8IOzy.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $b3788de439951053$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("1OqAU"));
    else if (typeof $g7XGz !== "undefined" && Object.prototype.toString.call($g7XGz) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("1OqAU"));
    return adapter;
}
function $b3788de439951053$var$stringifySafely(rawValue, parser, encoder) {
    if ($8IOzy.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $8IOzy.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $b3788de439951053$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $b3788de439951053$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $ed7sb(headers, "Accept");
            $ed7sb(headers, "Content-Type");
            if ($8IOzy.isFormData(data) || $8IOzy.isArrayBuffer(data) || $8IOzy.isBuffer(data) || $8IOzy.isStream(data) || $8IOzy.isFile(data) || $8IOzy.isBlob(data)) return data;
            if ($8IOzy.isArrayBufferView(data)) return data.buffer;
            if ($8IOzy.isURLSearchParams(data)) {
                $b3788de439951053$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($8IOzy.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $b3788de439951053$var$setContentTypeIfUnset(headers, "application/json");
                return $b3788de439951053$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $8IOzy.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $2Yj3t(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$b3788de439951053$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$8IOzy.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $b3788de439951053$var$defaults.headers[method] = {};
});
$8IOzy.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $b3788de439951053$var$defaults.headers[method] = $8IOzy.merge($b3788de439951053$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $b3788de439951053$var$defaults;

});
parcelRequire.register("g7XGz", function(module, exports) {
"use strict";

});

parcelRequire.register("ed7sb", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $8IOzy.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("2Yj3t", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRequire.register("1OqAU", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");

var $3UgJC = parcelRequire("3UgJC");

var $5IVMp = parcelRequire("5IVMp");

var $foKcx = parcelRequire("foKcx");

var $buV2A = parcelRequire("buV2A");

var $kN6wB = parcelRequire("kN6wB");

var $hQ47t = parcelRequire("hQ47t");

var $l1Bnl = parcelRequire("l1Bnl");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($8IOzy.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $buV2A(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $foKcx(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $kN6wB(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3UgJC(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($l1Bnl("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($l1Bnl("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($l1Bnl(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($8IOzy.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $hQ47t(fullPath)) && config.xsrfCookieName ? $5IVMp.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $8IOzy.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$8IOzy.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("3UgJC", function(module, exports) {
"use strict";

var $l1Bnl = parcelRequire("l1Bnl");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($l1Bnl("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("l1Bnl", function(module, exports) {
"use strict";

var $2Yj3t = parcelRequire("2Yj3t");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $2Yj3t(error, config, code, request, response);
};

});


parcelRequire.register("5IVMp", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
module.exports = $8IOzy.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($8IOzy.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($8IOzy.isString(path)) cookie.push("path=" + path);
            if ($8IOzy.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("buV2A", function(module, exports) {
"use strict";

var $azyLy = parcelRequire("azyLy");

var $eaYhW = parcelRequire("eaYhW");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$azyLy(requestedURL)) return $eaYhW(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("azyLy", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("eaYhW", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("kN6wB", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $f22d71ed0ce17a69$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $8IOzy.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $8IOzy.trim(line.substr(0, i)).toLowerCase();
        val = $8IOzy.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $f22d71ed0ce17a69$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("hQ47t", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
module.exports = $8IOzy.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $8IOzy.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRequire.register("eydkR", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("cGFxB", function(module, exports) {
"use strict";

var $8IOzy = parcelRequire("8IOzy");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($8IOzy.isPlainObject(target) && $8IOzy.isPlainObject(source)) return $8IOzy.merge(target, source);
        else if ($8IOzy.isPlainObject(source)) return $8IOzy.merge({}, source);
        else if ($8IOzy.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$8IOzy.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$8IOzy.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $8IOzy.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$8IOzy.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $8IOzy.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $8IOzy.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$8IOzy.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$8IOzy.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $8IOzy.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $8IOzy.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRequire.register("fGVL9", function(module, exports) {
"use strict";

var $b2CWC = parcelRequire("b2CWC");
var $b6c7951ab9bd4b64$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $b6c7951ab9bd4b64$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $b6c7951ab9bd4b64$var$deprecatedWarnings = {};
var $b6c7951ab9bd4b64$var$currentVerArr = $b2CWC.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $b6c7951ab9bd4b64$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $b6c7951ab9bd4b64$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $b6c7951ab9bd4b64$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $b6c7951ab9bd4b64$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $b2CWC.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$b6c7951ab9bd4b64$var$deprecatedWarnings[opt]) {
            $b6c7951ab9bd4b64$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $b6c7951ab9bd4b64$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $b6c7951ab9bd4b64$var$isOlderVersion,
    assertOptions: $b6c7951ab9bd4b64$var$assertOptions,
    validators: $b6c7951ab9bd4b64$var$validators
};

});
parcelRequire.register("b2CWC", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRequire.register("30Zfx", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $2320e213b9cc1836$var$Cancel(message) {
    this.message = message;
}
$2320e213b9cc1836$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$2320e213b9cc1836$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $2320e213b9cc1836$var$Cancel;

});

parcelRequire.register("492y7", function(module, exports) {
"use strict";

var $30Zfx = parcelRequire("30Zfx");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3049faeae7883c54$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $30Zfx(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $3049faeae7883c54$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3049faeae7883c54$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3049faeae7883c54$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3049faeae7883c54$var$CancelToken;

});

parcelRequire.register("aCEp5", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("28bqL", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


parcelRequire.register("iLQHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $daa57ea8219a3eab$var$assertString;
function $daa57ea8219a3eab$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $daa57ea8219a3eab$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $daa57ea8219a3eab$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $daa57ea8219a3eab$var$_typeof(obj);
}
function $daa57ea8219a3eab$var$assertString(input) {
    var isString = typeof input === "string" || input instanceof String;
    if (!isString) {
        var invalidType = $daa57ea8219a3eab$var$_typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRequire.register("2gz21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $1a683feebc239252$var$_gtag = $1a683feebc239252$var$_interopRequireDefault((parcelRequire("9zbsF")));

var $1a683feebc239252$var$_format = $1a683feebc239252$var$_interopRequireDefault((parcelRequire("Wp6aE")));
var $1a683feebc239252$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $1a683feebc239252$var$_excluded2 = [
    "title",
    "location"
], $1a683feebc239252$var$_excluded3 = [
    "page",
    "hitType"
];
function $1a683feebc239252$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1a683feebc239252$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1a683feebc239252$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1a683feebc239252$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1a683feebc239252$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1a683feebc239252$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1a683feebc239252$var$_typeof(obj);
}
function $1a683feebc239252$var$_toConsumableArray(arr) {
    return $1a683feebc239252$var$_arrayWithoutHoles(arr) || $1a683feebc239252$var$_iterableToArray(arr) || $1a683feebc239252$var$_unsupportedIterableToArray(arr) || $1a683feebc239252$var$_nonIterableSpread();
}
function $1a683feebc239252$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a683feebc239252$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1a683feebc239252$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1a683feebc239252$var$_arrayLikeToArray(arr);
}
function $1a683feebc239252$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1a683feebc239252$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1a683feebc239252$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1a683feebc239252$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1a683feebc239252$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1a683feebc239252$var$_slicedToArray(arr, i) {
    return $1a683feebc239252$var$_arrayWithHoles(arr) || $1a683feebc239252$var$_iterableToArrayLimit(arr, i) || $1a683feebc239252$var$_unsupportedIterableToArray(arr, i) || $1a683feebc239252$var$_nonIterableRest();
}
function $1a683feebc239252$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a683feebc239252$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1a683feebc239252$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1a683feebc239252$var$_arrayLikeToArray(o, minLen);
}
function $1a683feebc239252$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1a683feebc239252$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $1a683feebc239252$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1a683feebc239252$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1a683feebc239252$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1a683feebc239252$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1a683feebc239252$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1a683feebc239252$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1a683feebc239252$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1a683feebc239252$var$_defineProperty(obj, key, value) {
    key = $1a683feebc239252$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a683feebc239252$var$_toPropertyKey(arg) {
    var key = $1a683feebc239252$var$_toPrimitive(arg, "string");
    return $1a683feebc239252$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1a683feebc239252$var$_toPrimitive(input, hint) {
    if ($1a683feebc239252$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1a683feebc239252$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $1a683feebc239252$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $1a683feebc239252$var$_classCallCheck(this, GA4);
        $1a683feebc239252$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $1a683feebc239252$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $1a683feebc239252$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $1a683feebc239252$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $1a683feebc239252$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $1a683feebc239252$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread({}, _this._toGtagOptions($1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $1a683feebc239252$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $1a683feebc239252$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($1a683feebc239252$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $1a683feebc239252$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $1a683feebc239252$var$_objectWithoutProperties(_args$, $1a683feebc239252$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $1a683feebc239252$var$_objectWithoutProperties(_this$_toGtagOptions, $1a683feebc239252$var$_excluded2);
                _this._gtag("event", "page_view", $1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread($1a683feebc239252$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $1a683feebc239252$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $1a683feebc239252$var$_objectWithoutProperties(_args$2, $1a683feebc239252$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $1a683feebc239252$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $1a683feebc239252$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $1a683feebc239252$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $1a683feebc239252$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $1a683feebc239252$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $1a683feebc239252$var$_format["default"])(category),
                    eventAction: (0, $1a683feebc239252$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $1a683feebc239252$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $1a683feebc239252$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $1a683feebc239252$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $1a683feebc239252$var$GA4;
var $1a683feebc239252$var$_default = new $1a683feebc239252$var$GA4();
module.exports["default"] = $1a683feebc239252$var$_default;

});
parcelRequire.register("9zbsF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $6f7045ee9a312cd2$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $6f7045ee9a312cd2$var$_default = $6f7045ee9a312cd2$var$gtag;
module.exports["default"] = $6f7045ee9a312cd2$var$_default;

});

parcelRequire.register("Wp6aE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0af8e2f06cf300a4$var$format;
var $0af8e2f06cf300a4$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $0af8e2f06cf300a4$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($0af8e2f06cf300a4$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $0af8e2f06cf300a4$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $0af8e2f06cf300a4$var$redacted = "REDACTED (Potential Email Address)";
function $0af8e2f06cf300a4$var$redactEmail(string) {
    if ($0af8e2f06cf300a4$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $0af8e2f06cf300a4$var$redacted;
    }
    return string;
}
function $0af8e2f06cf300a4$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $0af8e2f06cf300a4$var$toTitleCase(s);
    if (redactingEmail) _str = $0af8e2f06cf300a4$var$redactEmail(_str);
    return _str;
}

});


parcelRequire.register("3T7bj", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $2d4c143a46bcf3a1$export$a7c73072b1a182ae, (v) => $2d4c143a46bcf3a1$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2d4c143a46bcf3a1$export$9f27bc3417b4524d, (v) => $2d4c143a46bcf3a1$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2d4c143a46bcf3a1$export$db77ccec0bb4ccac, (v) => $2d4c143a46bcf3a1$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2d4c143a46bcf3a1$export$8392c0c9d3dcbd35, (v) => $2d4c143a46bcf3a1$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2d4c143a46bcf3a1$export$ffb0004e005737fa, (v) => $2d4c143a46bcf3a1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2d4c143a46bcf3a1$export$b624eff549462981, (v) => $2d4c143a46bcf3a1$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2d4c143a46bcf3a1$export$7897aa7841a5380c, (v) => $2d4c143a46bcf3a1$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2d4c143a46bcf3a1$export$602eac185826482c, (v) => $2d4c143a46bcf3a1$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2d4c143a46bcf3a1$export$e2c29f18771995cb, (v) => $2d4c143a46bcf3a1$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2d4c143a46bcf3a1$export$5f8d39834fd61797, (v) => $2d4c143a46bcf3a1$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2d4c143a46bcf3a1$export$74bf444e3cd11ea5, (v) => $2d4c143a46bcf3a1$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $2d4c143a46bcf3a1$export$998bcd577473dd93, (v) => $2d4c143a46bcf3a1$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2d4c143a46bcf3a1$export$92387174baf9b227, (v) => $2d4c143a46bcf3a1$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2d4c143a46bcf3a1$export$ec112efeb987d9c6, (v) => $2d4c143a46bcf3a1$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2d4c143a46bcf3a1$export$b706b080d889d2c9, (v) => $2d4c143a46bcf3a1$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2d4c143a46bcf3a1$export$5be5a87408f70ddc, (v) => $2d4c143a46bcf3a1$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2d4c143a46bcf3a1$export$45a5e7f76e0caa8d, (v) => $2d4c143a46bcf3a1$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2d4c143a46bcf3a1$export$455c2e768291efa6, (v) => $2d4c143a46bcf3a1$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2d4c143a46bcf3a1$export$9522e17588c12572, (v) => $2d4c143a46bcf3a1$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2d4c143a46bcf3a1$export$2110ac352bb060b9, (v) => $2d4c143a46bcf3a1$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2d4c143a46bcf3a1$export$56885ab8b9c456ab, (v) => $2d4c143a46bcf3a1$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2d4c143a46bcf3a1$export$d927fcb6adf8f9de, (v) => $2d4c143a46bcf3a1$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2d4c143a46bcf3a1$export$b82d16f27459e05a, (v) => $2d4c143a46bcf3a1$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2d4c143a46bcf3a1$export$522c17b4f5e123e8, (v) => $2d4c143a46bcf3a1$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2d4c143a46bcf3a1$export$1aabd8a0274ecfd6, (v) => $2d4c143a46bcf3a1$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $2d4c143a46bcf3a1$export$3d6c20d97e46b957, (v) => $2d4c143a46bcf3a1$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $2d4c143a46bcf3a1$export$9b621391a187a31a, (v) => $2d4c143a46bcf3a1$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2d4c143a46bcf3a1$export$f5bbd400c2f4426f, (v) => $2d4c143a46bcf3a1$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2d4c143a46bcf3a1$export$a7c73072b1a182ae;
var $2d4c143a46bcf3a1$export$9f27bc3417b4524d;
var $2d4c143a46bcf3a1$export$db77ccec0bb4ccac;
var $2d4c143a46bcf3a1$export$8392c0c9d3dcbd35;
var $2d4c143a46bcf3a1$export$ffb0004e005737fa;
var $2d4c143a46bcf3a1$export$b624eff549462981;
var $2d4c143a46bcf3a1$export$7897aa7841a5380c;
var $2d4c143a46bcf3a1$export$602eac185826482c;
var $2d4c143a46bcf3a1$export$e2c29f18771995cb;
var $2d4c143a46bcf3a1$export$5f8d39834fd61797;
var $2d4c143a46bcf3a1$export$74bf444e3cd11ea5;
var $2d4c143a46bcf3a1$export$998bcd577473dd93;
var $2d4c143a46bcf3a1$export$92387174baf9b227;
var $2d4c143a46bcf3a1$export$ec112efeb987d9c6;
var $2d4c143a46bcf3a1$export$b706b080d889d2c9;
var $2d4c143a46bcf3a1$export$5be5a87408f70ddc;
var $2d4c143a46bcf3a1$export$45a5e7f76e0caa8d;
var $2d4c143a46bcf3a1$export$455c2e768291efa6;
var $2d4c143a46bcf3a1$export$9522e17588c12572;
var $2d4c143a46bcf3a1$export$2110ac352bb060b9;
var $2d4c143a46bcf3a1$export$56885ab8b9c456ab;
var $2d4c143a46bcf3a1$export$d927fcb6adf8f9de;
var $2d4c143a46bcf3a1$export$b82d16f27459e05a;
var $2d4c143a46bcf3a1$export$522c17b4f5e123e8;
var $2d4c143a46bcf3a1$export$1aabd8a0274ecfd6;
var $2d4c143a46bcf3a1$export$3d6c20d97e46b957;
var $2d4c143a46bcf3a1$export$9b621391a187a31a;
var $2d4c143a46bcf3a1$export$f5bbd400c2f4426f;
"use strict";
var $2d4c143a46bcf3a1$var$b = Symbol.for("react.element"), $2d4c143a46bcf3a1$var$c = Symbol.for("react.portal"), $2d4c143a46bcf3a1$var$d = Symbol.for("react.fragment"), $2d4c143a46bcf3a1$var$e = Symbol.for("react.strict_mode"), $2d4c143a46bcf3a1$var$f = Symbol.for("react.profiler"), $2d4c143a46bcf3a1$var$g = Symbol.for("react.provider"), $2d4c143a46bcf3a1$var$h = Symbol.for("react.context"), $2d4c143a46bcf3a1$var$k = Symbol.for("react.server_context"), $2d4c143a46bcf3a1$var$l = Symbol.for("react.forward_ref"), $2d4c143a46bcf3a1$var$m = Symbol.for("react.suspense"), $2d4c143a46bcf3a1$var$n = Symbol.for("react.suspense_list"), $2d4c143a46bcf3a1$var$p = Symbol.for("react.memo"), $2d4c143a46bcf3a1$var$q = Symbol.for("react.lazy"), $2d4c143a46bcf3a1$var$t = Symbol.for("react.offscreen"), $2d4c143a46bcf3a1$var$u;
$2d4c143a46bcf3a1$var$u = Symbol.for("react.module.reference");
function $2d4c143a46bcf3a1$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $2d4c143a46bcf3a1$var$b:
                switch(a = a.type, a){
                    case $2d4c143a46bcf3a1$var$d:
                    case $2d4c143a46bcf3a1$var$f:
                    case $2d4c143a46bcf3a1$var$e:
                    case $2d4c143a46bcf3a1$var$m:
                    case $2d4c143a46bcf3a1$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2d4c143a46bcf3a1$var$k:
                            case $2d4c143a46bcf3a1$var$h:
                            case $2d4c143a46bcf3a1$var$l:
                            case $2d4c143a46bcf3a1$var$q:
                            case $2d4c143a46bcf3a1$var$p:
                            case $2d4c143a46bcf3a1$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $2d4c143a46bcf3a1$var$c:
                return r;
        }
    }
}
$2d4c143a46bcf3a1$export$a7c73072b1a182ae = $2d4c143a46bcf3a1$var$h;
$2d4c143a46bcf3a1$export$9f27bc3417b4524d = $2d4c143a46bcf3a1$var$g;
$2d4c143a46bcf3a1$export$db77ccec0bb4ccac = $2d4c143a46bcf3a1$var$b;
$2d4c143a46bcf3a1$export$8392c0c9d3dcbd35 = $2d4c143a46bcf3a1$var$l;
$2d4c143a46bcf3a1$export$ffb0004e005737fa = $2d4c143a46bcf3a1$var$d;
$2d4c143a46bcf3a1$export$b624eff549462981 = $2d4c143a46bcf3a1$var$q;
$2d4c143a46bcf3a1$export$7897aa7841a5380c = $2d4c143a46bcf3a1$var$p;
$2d4c143a46bcf3a1$export$602eac185826482c = $2d4c143a46bcf3a1$var$c;
$2d4c143a46bcf3a1$export$e2c29f18771995cb = $2d4c143a46bcf3a1$var$f;
$2d4c143a46bcf3a1$export$5f8d39834fd61797 = $2d4c143a46bcf3a1$var$e;
$2d4c143a46bcf3a1$export$74bf444e3cd11ea5 = $2d4c143a46bcf3a1$var$m;
$2d4c143a46bcf3a1$export$998bcd577473dd93 = $2d4c143a46bcf3a1$var$n;
$2d4c143a46bcf3a1$export$92387174baf9b227 = function() {
    return !1;
};
$2d4c143a46bcf3a1$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2d4c143a46bcf3a1$export$b706b080d889d2c9 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$h;
};
$2d4c143a46bcf3a1$export$5be5a87408f70ddc = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$g;
};
$2d4c143a46bcf3a1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2d4c143a46bcf3a1$var$b;
};
$2d4c143a46bcf3a1$export$455c2e768291efa6 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$l;
};
$2d4c143a46bcf3a1$export$9522e17588c12572 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$d;
};
$2d4c143a46bcf3a1$export$2110ac352bb060b9 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$q;
};
$2d4c143a46bcf3a1$export$56885ab8b9c456ab = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$p;
};
$2d4c143a46bcf3a1$export$d927fcb6adf8f9de = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$c;
};
$2d4c143a46bcf3a1$export$b82d16f27459e05a = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$f;
};
$2d4c143a46bcf3a1$export$522c17b4f5e123e8 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$e;
};
$2d4c143a46bcf3a1$export$1aabd8a0274ecfd6 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$m;
};
$2d4c143a46bcf3a1$export$3d6c20d97e46b957 = function(a) {
    return $2d4c143a46bcf3a1$var$v(a) === $2d4c143a46bcf3a1$var$n;
};
$2d4c143a46bcf3a1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2d4c143a46bcf3a1$var$d || a === $2d4c143a46bcf3a1$var$f || a === $2d4c143a46bcf3a1$var$e || a === $2d4c143a46bcf3a1$var$m || a === $2d4c143a46bcf3a1$var$n || a === $2d4c143a46bcf3a1$var$t || "object" === typeof a && null !== a && (a.$$typeof === $2d4c143a46bcf3a1$var$q || a.$$typeof === $2d4c143a46bcf3a1$var$p || a.$$typeof === $2d4c143a46bcf3a1$var$g || a.$$typeof === $2d4c143a46bcf3a1$var$h || a.$$typeof === $2d4c143a46bcf3a1$var$l || a.$$typeof === $2d4c143a46bcf3a1$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$2d4c143a46bcf3a1$export$f5bbd400c2f4426f = $2d4c143a46bcf3a1$var$v;

});

parcelRequire.register("l6Ec8", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
$parcel$export(module.exports, "extractNodeRequestData", () => extractNodeRequestData, (v) => extractNodeRequestData = v);

var $hGRpR = parcelRequire("hGRpR");

var $i2LGp = parcelRequire("i2LGp");

var $g7XGz = parcelRequire("g7XGz");
function isNodeEnv() {
    return Object.prototype.toString.call(typeof $g7XGz !== "undefined" ? $g7XGz : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/** Default request keys that'll be used to extract data from the request */ var DEFAULT_REQUEST_KEYS = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
function extractNodeRequestData(req, keys) {
    if (keys === void 0) keys = DEFAULT_REQUEST_KEYS;
    // make sure we can safely use dynamicRequire below
    if (!isNodeEnv()) throw new Error("Can't get node request data outside of a node environment");
    var requestData = {};
    // headers:
    //   node, express: req.headers
    //   koa: req.header
    var headers = req.headers || req.header || {};
    // method:
    //   node, express, koa: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node: req.headers.host
    var host = req.hostname || req.host || headers.host || "<no host>";
    // protocol:
    //   node: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === "https" || req.secure || (req.socket || {}).encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa: req.url
    var originalUrl = req.originalUrl || req.url || "";
    // absolute url
    var absoluteUrl = protocol + "://" + host + originalUrl;
    keys.forEach(function(key) {
        switch(key){
            case "headers":
                requestData.headers = headers;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = req.cookies || dynamicRequire(module, "cookie").parse(headers.cookie || "");
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = dynamicRequire(module, "url").parse(originalUrl || "", false).query;
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   node, express, koa: req.body
                if (req.body !== undefined) requestData.data = (0, $hGRpR.isString)(req.body) ? req.body : JSON.stringify((0, $i2LGp.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}

});
parcelRequire.register("hGRpR", function(module, exports) {

$parcel$export(module.exports, "isError", () => $ce0fcb3e76ae6798$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $ce0fcb3e76ae6798$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $ce0fcb3e76ae6798$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $ce0fcb3e76ae6798$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $ce0fcb3e76ae6798$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $ce0fcb3e76ae6798$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $ce0fcb3e76ae6798$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $ce0fcb3e76ae6798$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $ce0fcb3e76ae6798$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $ce0fcb3e76ae6798$export$bc2894c7158efbac);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ce0fcb3e76ae6798$export$e6127cc7fe7395c3(wat) {
    switch(Object.prototype.toString.call(wat)){
        case "[object Error]":
            return true;
        case "[object Exception]":
            return true;
        case "[object DOMException]":
            return true;
        default:
            return $ce0fcb3e76ae6798$export$49034edbe6b62415(wat, Error);
    }
}
function $ce0fcb3e76ae6798$export$9f9636d330b71954(wat) {
    return Object.prototype.toString.call(wat) === "[object ErrorEvent]";
}
function $ce0fcb3e76ae6798$export$ef9e2056653f0c8e(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMError]";
}
function $ce0fcb3e76ae6798$export$12e869b2a583f783(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMException]";
}
function $ce0fcb3e76ae6798$export$844ec244b1367d54(wat) {
    return Object.prototype.toString.call(wat) === "[object String]";
}
function $ce0fcb3e76ae6798$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $ce0fcb3e76ae6798$export$53b83ca8eaab0383(wat) {
    return Object.prototype.toString.call(wat) === "[object Object]";
}
function $ce0fcb3e76ae6798$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $ce0fcb3e76ae6798$export$49034edbe6b62415(wat, Event);
}
function $ce0fcb3e76ae6798$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $ce0fcb3e76ae6798$export$49034edbe6b62415(wat, Element);
}
function $ce0fcb3e76ae6798$export$49841c62b9eff15(wat) {
    return Object.prototype.toString.call(wat) === "[object RegExp]";
}
function $ce0fcb3e76ae6798$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function $ce0fcb3e76ae6798$export$bc2894c7158efbac(wat) {
    return $ce0fcb3e76ae6798$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $ce0fcb3e76ae6798$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRequire.register("i2LGp", function(module, exports) {

$parcel$export(module.exports, "fill", () => $d22d66c5344d66f4$export$9563e054e6f787fb);
$parcel$export(module.exports, "normalize", () => $d22d66c5344d66f4$export$a3295358bff77e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $d22d66c5344d66f4$export$d25f2688db1bb433);

var $7QK2E = parcelRequire("7QK2E");

var $iAnu1 = parcelRequire("iAnu1");

var $hGRpR = parcelRequire("hGRpR");

var $1uH2L = parcelRequire("1uH2L");

var $3UwOP = parcelRequire("3UwOP");

var $4Jr31 = parcelRequire("4Jr31");
function $d22d66c5344d66f4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        wrapped.prototype = wrapped.prototype || {};
        Object.defineProperties(wrapped, {
            __sentry_original__: {
                enumerable: false,
                value: original
            }
        });
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $d22d66c5344d66f4$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */ function $d22d66c5344d66f4$var$getWalkSource(value) {
    if ((0, $hGRpR.isError)(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack
        };
        for(var i in error)if (Object.prototype.hasOwnProperty.call(error, i)) err[i] = error[i];
        return err;
    }
    if ((0, $hGRpR.isEvent)(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = (0, $hGRpR.isElement)(event_1.target) ? (0, $iAnu1.htmlTreeAsString)(event_1.target) : Object.prototype.toString.call(event_1.target);
        } catch (_oO) {
            source.target = "<unknown>";
        }
        try {
            source.currentTarget = (0, $hGRpR.isElement)(event_1.currentTarget) ? (0, $iAnu1.htmlTreeAsString)(event_1.currentTarget) : Object.prototype.toString.call(event_1.currentTarget);
        } catch (_oO) {
            source.currentTarget = "<unknown>";
        }
        if (typeof CustomEvent !== "undefined" && (0, $hGRpR.isInstanceOf)(value, CustomEvent)) source.detail = event_1.detail;
        for(var i in event_1)if (Object.prototype.hasOwnProperty.call(event_1, i)) source[i] = event_1;
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */ function $d22d66c5344d66f4$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $d22d66c5344d66f4$var$jsonSize(value) {
    return $d22d66c5344d66f4$var$utf8Length(JSON.stringify(value));
}
function $d22d66c5344d66f4$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var serialized = $d22d66c5344d66f4$export$a3295358bff77e(object, depth);
    if ($d22d66c5344d66f4$var$jsonSize(serialized) > maxSize) return $d22d66c5344d66f4$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */ function $d22d66c5344d66f4$var$serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === "string") return value;
    if (type === "[object Object]") return "[Object]";
    if (type === "[object Array]") return "[Array]";
    var normalized = $d22d66c5344d66f4$var$normalizeValue(value);
    return (0, $hGRpR.isPrimitive)(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */ function $d22d66c5344d66f4$var$normalizeValue(value, key) {
    if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
    if (key === "domainEmitter") return "[DomainEmitter]";
    if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    // React's SyntheticEvent thingy
    if ((0, $hGRpR.isSyntheticEvent)(value)) return "[SyntheticEvent]";
    if (typeof value === "number" && value !== value) return "[NaN]";
    if (value === void 0) return "[undefined]";
    if (typeof value === "function") return "[Function: " + (0, $3UwOP.getFunctionName)(value) + "]";
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === "symbol") return "[" + String(value) + "]";
    if (typeof value === "bigint") return "[BigInt: " + String(value) + "]";
    return value;
}
function $d22d66c5344d66f4$export$588732934346abbf(key, value, depth, memo) {
    if (depth === void 0) depth = Infinity;
    if (memo === void 0) memo = new (0, $1uH2L.Memo)();
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) return $d22d66c5344d66f4$var$serializeValue(value);
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === "function") return value.toJSON();
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = $d22d66c5344d66f4$var$normalizeValue(value, key);
    if ((0, $hGRpR.isPrimitive)(normalized)) return normalized;
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = $d22d66c5344d66f4$var$getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) return "[Circular ~]";
    // Walk all keys of the source
    for(var innerKey in source){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) continue;
        // Recursively walk through all the child nodes
        acc[innerKey] = $d22d66c5344d66f4$export$588732934346abbf(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
function $d22d66c5344d66f4$export$a3295358bff77e(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function(key, value) {
            return $d22d66c5344d66f4$export$588732934346abbf(key, value, depth);
        }));
    } catch (_oO) {
        return "**non-serializable**";
    }
}
function $d22d66c5344d66f4$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($d22d66c5344d66f4$var$getWalkSource(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $4Jr31.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4Jr31.truncate)(serialized, maxLength);
    }
    return "";
}
function $d22d66c5344d66f4$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $hGRpR.isPlainObject)(val)) {
        var obj = val;
        var rv = {};
        try {
            for(var _b = (0, $7QK2E.__values)(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof obj[key] !== "undefined") rv[key] = $d22d66c5344d66f4$export$d25f2688db1bb433(obj[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($d22d66c5344d66f4$export$d25f2688db1bb433);
    return val;
}

});
parcelRequire.register("7QK2E", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5b711aa7fb594264$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5b711aa7fb594264$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5b711aa7fb594264$export$3c9a16f847548506);
$parcel$export(module.exports, "__values", () => $5b711aa7fb594264$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5b711aa7fb594264$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $5b711aa7fb594264$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5b711aa7fb594264$var$extendStatics = function(d, b) {
    $5b711aa7fb594264$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5b711aa7fb594264$var$extendStatics(d, b);
};
function $5b711aa7fb594264$export$a8ba968b8961cb8a(d, b) {
    $5b711aa7fb594264$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5b711aa7fb594264$export$18ce0697a983be9b = function() {
    $5b711aa7fb594264$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b711aa7fb594264$export$18ce0697a983be9b.apply(this, arguments);
};
function $5b711aa7fb594264$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5b711aa7fb594264$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5b711aa7fb594264$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5b711aa7fb594264$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5b711aa7fb594264$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5b711aa7fb594264$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5b711aa7fb594264$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5b711aa7fb594264$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5b711aa7fb594264$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5b711aa7fb594264$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5b711aa7fb594264$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5b711aa7fb594264$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5b711aa7fb594264$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5b711aa7fb594264$export$10c90e4f7922046c(v) {
    return this instanceof $5b711aa7fb594264$export$10c90e4f7922046c ? (this.v = v, this) : new $5b711aa7fb594264$export$10c90e4f7922046c(v);
}
function $5b711aa7fb594264$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5b711aa7fb594264$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5b711aa7fb594264$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5b711aa7fb594264$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5b711aa7fb594264$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5b711aa7fb594264$export$19a8beecd37a4c45 === "function" ? $5b711aa7fb594264$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5b711aa7fb594264$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5b711aa7fb594264$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5b711aa7fb594264$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5b711aa7fb594264$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5b711aa7fb594264$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("iAnu1", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $d87dce15707d4083$export$5647df6b7814ac86);

var $hGRpR = parcelRequire("hGRpR");
function $d87dce15707d4083$export$5647df6b7814ac86(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d87dce15707d4083$var$_htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d87dce15707d4083$var$_htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    if (elem.id) out.push("#" + elem.id);
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0, $hGRpR.isString)(className)) {
        classes = className.split(/\s+/);
        for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}

});

parcelRequire.register("1uH2L", function(module, exports) {

$parcel$export(module.exports, "Memo", () => $1169fb57bd849a87$export$7897aa7841a5380c);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */ var $1169fb57bd849a87$export$7897aa7841a5380c = /** @class */ function() {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === "function";
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */ Memo.prototype.memoize = function(obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) return true;
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < this._inner.length; i++){
            var value = this._inner[i];
            if (value === obj) return true;
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */ Memo.prototype.unmemoize = function(obj) {
        if (this._hasWeakSet) this._inner.delete(obj);
        else {
            for(var i = 0; i < this._inner.length; i++)if (this._inner[i] === obj) {
                this._inner.splice(i, 1);
                break;
            }
        }
    };
    return Memo;
}();

});

parcelRequire.register("3UwOP", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", () => $2d900f3328687951$export$aad197c7121a6651);
var $2d900f3328687951$var$defaultFunctionName = "<anonymous>";
function $2d900f3328687951$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $2d900f3328687951$var$defaultFunctionName;
        return fn.name || $2d900f3328687951$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $2d900f3328687951$var$defaultFunctionName;
    }
}

});

parcelRequire.register("4Jr31", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $37205884f5da2e11$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $37205884f5da2e11$export$4215662d762d6f9d);
$parcel$export(module.exports, "isMatchingPattern", () => $37205884f5da2e11$export$cdded5b28a5f8c6d);

var $hGRpR = parcelRequire("hGRpR");
function $37205884f5da2e11$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $37205884f5da2e11$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) return newLine;
    if (colno > ll) // eslint-disable-next-line no-param-reassign
    colno = ll;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) end = ll;
    if (end === ll) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < ll) newLine += " {snip}";
    return newLine;
}
function $37205884f5da2e11$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $37205884f5da2e11$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $hGRpR.isString)(value)) return false;
    if ((0, $hGRpR.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}

});



parcelRequire.register("evtBA", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs, (v) => timestampWithMs = v);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => browserPerformanceTimeOrigin, (v) => browserPerformanceTimeOrigin = v);

var $8gwLa = parcelRequire("8gwLa");

var $l6Ec8 = parcelRequire("l6Ec8");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $8gwLa.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $l6Ec8.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $l6Ec8.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var browserPerformanceTimeOrigin = function() {
    var performance = (0, $8gwLa.getGlobalObject)().performance;
    if (!performance) return undefined;
    if (performance.timeOrigin) return performance.timeOrigin;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    return performance.timing && performance.timing.navigationStart || Date.now();
}();

});
parcelRequire.register("8gwLa", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $60493ac04bf7f741$export$256479dc0cea61c4);
$parcel$export(module.exports, "uuid4", () => $60493ac04bf7f741$export$19f53698e68b2496);
$parcel$export(module.exports, "consoleSandbox", () => $60493ac04bf7f741$export$cda52e2a8927a2ca);

var $l6Ec8 = parcelRequire("l6Ec8");

var $4Jr31 = parcelRequire("4Jr31");
var $60493ac04bf7f741$var$fallbackGlobalObject = {};
function $60493ac04bf7f741$export$256479dc0cea61c4() {
    return (0, $l6Ec8.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : $60493ac04bf7f741$var$fallbackGlobalObject;
}
function $60493ac04bf7f741$export$19f53698e68b2496() {
    var global1 = $60493ac04bf7f741$export$256479dc0cea61c4();
    var crypto = global1.crypto || global1.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $60493ac04bf7f741$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $60493ac04bf7f741$export$4157119e2b157127(event) {
    if (event.message) return event.message;
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) return exception.type + ": " + exception.value;
        return exception.type || exception.value || event.event_id || "<unknown>";
    }
    return event.event_id || "<unknown>";
}
function $60493ac04bf7f741$export$cda52e2a8927a2ca(callback) {
    var global1 = $60493ac04bf7f741$export$256479dc0cea61c4();
    var levels = [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ];
    if (!("console" in global1)) return callback();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global1.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function(level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global1.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function(level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
function $60493ac04bf7f741$export$f26508487bf83ee7(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || "";
    event.exception.values[0].type = event.exception.values[0].type || type || "Error";
}
function $60493ac04bf7f741$export$c69a9a0313b03bb1(event, mechanism) {
    if (mechanism === void 0) mechanism = {};
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function(key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    } catch (_oO) {
    // no-empty
    }
}
function $60493ac04bf7f741$export$1cfafeee2987818b() {
    try {
        return document.location.href;
    } catch (oO) {
        return "";
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $60493ac04bf7f741$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $60493ac04bf7f741$export$d364f2020ab30578(input) {
    var match = input.match($60493ac04bf7f741$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
var $60493ac04bf7f741$var$defaultRetryAfter = 60000; // 60 seconds
function $60493ac04bf7f741$export$615352e17ed7741(now, header) {
    if (!header) return $60493ac04bf7f741$var$defaultRetryAfter;
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $60493ac04bf7f741$var$defaultRetryAfter;
}
function $60493ac04bf7f741$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $4Jr31.snipLine)(line, 0);
    });
    frame.context_line = (0, $4Jr31.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $4Jr31.snipLine)(line, 0);
    });
}
function $60493ac04bf7f741$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}

});


parcelRequire.register("4J6aQ", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => startIdleTransaction, (v) => startIdleTransaction = v);
$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods, (v) => addExtensionMethods = v);

var $7QK2E = parcelRequire("7QK2E");

var $bn2rP = parcelRequire("bn2rP");

var $egrZk = parcelRequire("egrZk");
parcelRequire("8wDn2");
var $l6Ec8 = parcelRequire("l6Ec8");
var $8gwLa = parcelRequire("8gwLa");
var $hGRpR = parcelRequire("hGRpR");
var $5TQck = parcelRequire("5TQck");

var $6CcjJ = parcelRequire("6CcjJ");

var $hh22J = parcelRequire("hh22J");

var $lcwYo = parcelRequire("lcwYo");

var $SQznX = parcelRequire("SQznX");
/** Returns all trace headers that are currently on the top scope. */ function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) return {
            "sentry-trace": span.toTraceparent()
        };
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param hub: The hub off of which to read config options
 * @param transaction: The transaction needing a sampling decision
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function sample(hub, transaction, samplingContext) {
    var _a;
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    // nothing to do if there's no client or if tracing is disabled
    if (!client || !(0, $SQznX.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, transaction.tags), {
            __sentry_samplingMethod: (0, $egrZk.TransactionSamplingMethod).Explicit
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        // cast the rate to a number first in case it's a boolean
        transaction.tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, transaction.tags), {
            __sentry_samplingMethod: (0, $egrZk.TransactionSamplingMethod).Sampler,
            // TODO kmclb - once tag types are loosened, don't need to cast to string here
            __sentry_sampleRate: String(Number(sampleRate))
        });
    } else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, transaction.tags), {
            __sentry_samplingMethod: (0, $egrZk.TransactionSamplingMethod).Inheritance
        });
    } else {
        sampleRate = options.tracesSampleRate;
        // cast the rate to a number first in case it's a boolean
        transaction.tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, transaction.tags), {
            __sentry_samplingMethod: (0, $egrZk.TransactionSamplingMethod).Rate,
            // TODO kmclb - once tag types are loosened, don't need to cast to string here
            __sentry_sampleRate: String(Number(sampleRate))
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        (0, $5TQck.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $5TQck.logger).log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (0, $5TQck.logger).log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    // at this point we know we're keeping the transaction, whether because of an inherited decision or because it got
    // lucky with the dice roll
    transaction.initSpanRecorder((_a = options._experiments) === null || _a === void 0 ? void 0 : _a.maxSpans);
    (0, $5TQck.logger).log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Gets the correct context to pass to the tracesSampler, based on the environment (i.e., which SDK is being used)
 *
 * @returns The default sample context
 */ function getDefaultSamplingContext(transactionContext) {
    // promote parent sampling decision (if any) for easy access
    var parentSampled = transactionContext.parentSampled;
    var defaultSamplingContext = {
        transactionContext: transactionContext,
        parentSampled: parentSampled
    };
    if ((0, $l6Ec8.isNodeEnv)()) {
        var domain = (0, $bn2rP.getActiveDomain)();
        if (domain) {
            // for all node servers that we currently support, we store the incoming request object (which is an instance of
            // http.IncomingMessage) on the domain
            // the domain members are stored as an array, so our only way to find the request is to iterate through the array
            // and compare types
            var nodeHttpModule = (0, $l6Ec8.dynamicRequire)(module, "http");
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            var requestType_1 = nodeHttpModule.IncomingMessage;
            var request = domain.members.find(function(member) {
                return (0, $hGRpR.isInstanceOf)(member, requestType_1);
            });
            if (request) defaultSamplingContext.request = (0, $l6Ec8.extractNodeRequestData)(request);
        }
    } else {
        // we use `getGlobalObject()` rather than `window` since service workers also have a `location` property on `self`
        var globalObject = (0, $8gwLa.getGlobalObject)();
        if ("location" in globalObject) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        defaultSamplingContext.location = (0, $7QK2E.__assign)({}, globalObject.location);
    }
    return defaultSamplingContext;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (isNaN(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $5TQck.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $5TQck.logger).warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(transactionContext, customSamplingContext) {
    var transaction = new (0, $lcwYo.Transaction)(transactionContext, this);
    return sample(this, transaction, (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, getDefaultSamplingContext(transactionContext)), customSamplingContext));
}
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope) {
    var transaction = new (0, $hh22J.IdleTransaction)(transactionContext, hub, idleTimeout, onScope);
    return sample(hub, transaction, getDefaultSamplingContext(transactionContext));
}
function _addTracingExtensions() {
    var carrier = (0, $bn2rP.getMainCarrier)();
    if (carrier.__SENTRY__) {
        carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
        if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
        if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
function addExtensionMethods() {
    _addTracingExtensions();
    // If an error happens globally, we should make sure transaction status is set to error.
    (0, $6CcjJ.registerErrorInstrumentation)();
}

});
parcelRequire.register("bn2rP", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $8473bdc5cb063fd8$export$8c41bb232f1008b1);
$parcel$export(module.exports, "getMainCarrier", () => $8473bdc5cb063fd8$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $8473bdc5cb063fd8$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getActiveDomain", () => $8473bdc5cb063fd8$export$1c4d656130202699);

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $8gwLa = parcelRequire("8gwLa");
var $evtBA = parcelRequire("evtBA");
var $l6Ec8 = parcelRequire("l6Ec8");
var $5TQck = parcelRequire("5TQck");

var $3tCyj = parcelRequire("3tCyj");

var $8UKb7 = parcelRequire("8UKb7");
var $8473bdc5cb063fd8$export$24a86ef7798177e4 = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $8473bdc5cb063fd8$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */ var $8473bdc5cb063fd8$var$MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $8473bdc5cb063fd8$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $3tCyj.Scope)();
        if (_version === void 0) _version = $8473bdc5cb063fd8$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $3tCyj.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = (0, $8gwLa.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error("Sentry syntheticException");
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureException", exception, (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = (0, $8gwLa.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureMessage", message, level, (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = this._lastEventId = (0, $8gwLa.uuid4)();
        this._invokeClient("captureEvent", event, (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $8473bdc5cb063fd8$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $evtBA.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $7QK2E.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $8gwLa.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, $8473bdc5cb063fd8$var$MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $8473bdc5cb063fd8$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $8473bdc5cb063fd8$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $5TQck.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod("startSpan", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod("startTransaction", context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod("traceHeaders");
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        // End existing session if there's one
        this.endSession();
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        var session = new (0, $8UKb7.Session)((0, $7QK2E.__assign)((0, $7QK2E.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), context));
        if (scope) scope.setSession(session);
        return session;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            session.close();
            if (client && client.captureSession) client.captureSession(session);
            scope.setSession();
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $7QK2E.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $8473bdc5cb063fd8$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $5TQck.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $8473bdc5cb063fd8$export$19eade501500c6c1() {
    var carrier = (0, $8gwLa.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $8473bdc5cb063fd8$export$4188a14ad302d1bc(hub) {
    var registry = $8473bdc5cb063fd8$export$19eade501500c6c1();
    var oldHub = $8473bdc5cb063fd8$export$bfa8a924a84a76b7(registry);
    $8473bdc5cb063fd8$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $8473bdc5cb063fd8$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $8473bdc5cb063fd8$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$8473bdc5cb063fd8$var$hasHubOnCarrier(registry) || $8473bdc5cb063fd8$export$bfa8a924a84a76b7(registry).isOlderThan($8473bdc5cb063fd8$export$24a86ef7798177e4)) $8473bdc5cb063fd8$export$849f05434e95d2f2(registry, new $8473bdc5cb063fd8$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $l6Ec8.isNodeEnv)()) return $8473bdc5cb063fd8$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $8473bdc5cb063fd8$export$bfa8a924a84a76b7(registry);
}
function $8473bdc5cb063fd8$export$1c4d656130202699() {
    var sentry = $8473bdc5cb063fd8$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $8473bdc5cb063fd8$var$getHubFromActiveDomain(registry) {
    try {
        var activeDomain = $8473bdc5cb063fd8$export$1c4d656130202699();
        // If there's no active domain, just return global hub
        if (!activeDomain) return $8473bdc5cb063fd8$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$8473bdc5cb063fd8$var$hasHubOnCarrier(activeDomain) || $8473bdc5cb063fd8$export$bfa8a924a84a76b7(activeDomain).isOlderThan($8473bdc5cb063fd8$export$24a86ef7798177e4)) {
            var registryHubTopStack = $8473bdc5cb063fd8$export$bfa8a924a84a76b7(registry).getStackTop();
            $8473bdc5cb063fd8$export$849f05434e95d2f2(activeDomain, new $8473bdc5cb063fd8$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $3tCyj.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $8473bdc5cb063fd8$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $8473bdc5cb063fd8$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $8473bdc5cb063fd8$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $8473bdc5cb063fd8$export$bfa8a924a84a76b7(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new $8473bdc5cb063fd8$export$8c41bb232f1008b1();
    return carrier.__SENTRY__.hub;
}
function $8473bdc5cb063fd8$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}

});
parcelRequire.register("8wDn2", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("chSbG")).addInstrumentationHandler);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("hGRpR")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("hGRpR")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("hGRpR")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("5TQck")).logger);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("8gwLa")).consoleSandbox);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("8gwLa")).getGlobalObject);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("8gwLa")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("i2LGp")).dropUndefinedKeys);
$parcel$export(module.exports, "fill", () => (parcelRequire("i2LGp")).fill);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("4Jr31")).isMatchingPattern);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("82Gml")).SyncPromise);




parcelRequire("chSbG");
parcelRequire("hGRpR");
parcelRequire("5TQck");

parcelRequire("8gwLa");

var $l6Ec8 = parcelRequire("l6Ec8");
parcelRequire("i2LGp");



parcelRequire("4Jr31");

parcelRequire("82Gml");

var $evtBA = parcelRequire("evtBA");
$parcel$exportWildcard(module.exports, $l6Ec8);
$parcel$exportWildcard(module.exports, $evtBA);

});
parcelRequire.register("chSbG", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $8f211b0facf9737f$export$285b9172a3741fb7);

var $7QK2E = parcelRequire("7QK2E");

var $hGRpR = parcelRequire("hGRpR");

var $5TQck = parcelRequire("5TQck");

var $8gwLa = parcelRequire("8gwLa");

var $i2LGp = parcelRequire("i2LGp");

var $3UwOP = parcelRequire("3UwOP");

var $6GC2j = parcelRequire("6GC2j");
var $8f211b0facf9737f$var$global = (0, $8gwLa.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $8f211b0facf9737f$var$handlers = {};
var $8f211b0facf9737f$var$instrumented = {};
/** Instruments given API */ function $8f211b0facf9737f$var$instrument(type) {
    if ($8f211b0facf9737f$var$instrumented[type]) return;
    $8f211b0facf9737f$var$instrumented[type] = true;
    switch(type){
        case "console":
            $8f211b0facf9737f$var$instrumentConsole();
            break;
        case "dom":
            $8f211b0facf9737f$var$instrumentDOM();
            break;
        case "xhr":
            $8f211b0facf9737f$var$instrumentXHR();
            break;
        case "fetch":
            $8f211b0facf9737f$var$instrumentFetch();
            break;
        case "history":
            $8f211b0facf9737f$var$instrumentHistory();
            break;
        case "error":
            $8f211b0facf9737f$var$instrumentError();
            break;
        case "unhandledrejection":
            $8f211b0facf9737f$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $5TQck.logger).warn("unknown instrumentation type:", type);
    }
}
function $8f211b0facf9737f$export$285b9172a3741fb7(handler) {
    if (!handler || typeof handler.type !== "string" || typeof handler.callback !== "function") return;
    $8f211b0facf9737f$var$handlers[handler.type] = $8f211b0facf9737f$var$handlers[handler.type] || [];
    $8f211b0facf9737f$var$handlers[handler.type].push(handler.callback);
    $8f211b0facf9737f$var$instrument(handler.type);
}
/** JSDoc */ function $8f211b0facf9737f$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$8f211b0facf9737f$var$handlers[type]) return;
    try {
        for(var _b = (0, $7QK2E.__values)($8f211b0facf9737f$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $5TQck.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $3UwOP.getFunctionName)(handler) + "\nError: " + e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $8f211b0facf9737f$var$instrumentConsole() {
    if (!("console" in $8f211b0facf9737f$var$global)) return;
    [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ].forEach(function(level) {
        if (!(level in $8f211b0facf9737f$var$global.console)) return;
        (0, $i2LGp.fill)($8f211b0facf9737f$var$global.console, level, function(originalConsoleLevel) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $8f211b0facf9737f$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleLevel) Function.prototype.apply.call(originalConsoleLevel, $8f211b0facf9737f$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $8f211b0facf9737f$var$instrumentFetch() {
    if (!(0, $6GC2j.supportsNativeFetch)()) return;
    (0, $i2LGp.fill)($8f211b0facf9737f$var$global, "fetch", function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $8f211b0facf9737f$var$getFetchMethod(args),
                    url: $8f211b0facf9737f$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $8f211b0facf9737f$var$triggerHandlers("fetch", (0, $7QK2E.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($8f211b0facf9737f$var$global, args).then(function(response) {
                $8f211b0facf9737f$var$triggerHandlers("fetch", (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $8f211b0facf9737f$var$triggerHandlers("fetch", (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $8f211b0facf9737f$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ("Request" in $8f211b0facf9737f$var$global && (0, $hGRpR.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function $8f211b0facf9737f$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in $8f211b0facf9737f$var$global && (0, $hGRpR.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $8f211b0facf9737f$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $8f211b0facf9737f$var$global)) return;
    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
    var requestKeys = [];
    var requestValues = [];
    var xhrproto = XMLHttpRequest.prototype;
    (0, $i2LGp.fill)(xhrproto, "open", function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $hGRpR.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $hGRpR.isString)(url) && xhr.__sentry_xhr__.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) xhr.__sentry_xhr__.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    try {
                        var requestPos = requestKeys.indexOf(xhr);
                        if (requestPos !== -1) {
                            // Make sure to pop both key and value to keep it in sync.
                            requestKeys.splice(requestPos);
                            var args_1 = requestValues.splice(requestPos)[0];
                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) xhr.__sentry_xhr__.body = args_1[0];
                        }
                    } catch (e) {
                    /* do nothing */ }
                    $8f211b0facf9737f$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, $i2LGp.fill)(xhr, "onreadystatechange", function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $i2LGp.fill)(xhrproto, "send", function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            requestKeys.push(this);
            requestValues.push(args);
            $8f211b0facf9737f$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $8f211b0facf9737f$var$lastHref;
/** JSDoc */ function $8f211b0facf9737f$var$instrumentHistory() {
    if (!(0, $6GC2j.supportsHistory)()) return;
    var oldOnPopState = $8f211b0facf9737f$var$global.onpopstate;
    $8f211b0facf9737f$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $8f211b0facf9737f$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $8f211b0facf9737f$var$lastHref;
        $8f211b0facf9737f$var$lastHref = to;
        $8f211b0facf9737f$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) return oldOnPopState.apply(this, args);
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $8f211b0facf9737f$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $8f211b0facf9737f$var$lastHref = to;
                $8f211b0facf9737f$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $i2LGp.fill)($8f211b0facf9737f$var$global.history, "pushState", historyReplacementFunction);
    (0, $i2LGp.fill)($8f211b0facf9737f$var$global.history, "replaceState", historyReplacementFunction);
}
/** JSDoc */ function $8f211b0facf9737f$var$instrumentDOM() {
    if (!("document" in $8f211b0facf9737f$var$global)) return;
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    $8f211b0facf9737f$var$global.document.addEventListener("click", $8f211b0facf9737f$var$domEventHandler("click", $8f211b0facf9737f$var$triggerHandlers.bind(null, "dom")), false);
    $8f211b0facf9737f$var$global.document.addEventListener("keypress", $8f211b0facf9737f$var$keypressEventHandler($8f211b0facf9737f$var$triggerHandlers.bind(null, "dom")), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */ var proto = $8f211b0facf9737f$var$global[target] && $8f211b0facf9737f$var$global[target].prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */ (0, $i2LGp.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === "click") (0, $i2LGp.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            $8f211b0facf9737f$var$domEventHandler("click", $8f211b0facf9737f$var$triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                    if (eventName === "keypress") (0, $i2LGp.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            $8f211b0facf9737f$var$keypressEventHandler($8f211b0facf9737f$var$triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                } else {
                    if (eventName === "click") $8f211b0facf9737f$var$domEventHandler("click", $8f211b0facf9737f$var$triggerHandlers.bind(null, "dom"), true)(this);
                    if (eventName === "keypress") $8f211b0facf9737f$var$keypressEventHandler($8f211b0facf9737f$var$triggerHandlers.bind(null, "dom"))(this);
                }
                return original.call(this, eventName, fn, options);
            };
        });
        (0, $i2LGp.fill)(proto, "removeEventListener", function(original) {
            return function(eventName, fn, options) {
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                } catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    });
}
var $8f211b0facf9737f$var$debounceDuration = 1000;
var $8f211b0facf9737f$var$debounceTimer = 0;
var $8f211b0facf9737f$var$keypressTimeout;
var $8f211b0facf9737f$var$lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $8f211b0facf9737f$var$domEventHandler(name, handler, debounce) {
    if (debounce === void 0) debounce = false;
    return function(event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        $8f211b0facf9737f$var$keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || $8f211b0facf9737f$var$lastCapturedEvent === event) return;
        $8f211b0facf9737f$var$lastCapturedEvent = event;
        if ($8f211b0facf9737f$var$debounceTimer) clearTimeout($8f211b0facf9737f$var$debounceTimer);
        if (debounce) $8f211b0facf9737f$var$debounceTimer = setTimeout(function() {
            handler({
                event: event,
                name: name
            });
        });
        else handler({
            event: event,
            name: name
        });
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */ function $8f211b0facf9737f$var$keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(event) {
        var target;
        try {
            target = event.target;
        } catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || tagName !== "INPUT" && tagName !== "TEXTAREA" && !target.isContentEditable) return;
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!$8f211b0facf9737f$var$keypressTimeout) $8f211b0facf9737f$var$domEventHandler("input", handler)(event);
        clearTimeout($8f211b0facf9737f$var$keypressTimeout);
        $8f211b0facf9737f$var$keypressTimeout = setTimeout(function() {
            $8f211b0facf9737f$var$keypressTimeout = undefined;
        }, $8f211b0facf9737f$var$debounceDuration);
    };
}
var $8f211b0facf9737f$var$_oldOnErrorHandler = null;
/** JSDoc */ function $8f211b0facf9737f$var$instrumentError() {
    $8f211b0facf9737f$var$_oldOnErrorHandler = $8f211b0facf9737f$var$global.onerror;
    $8f211b0facf9737f$var$global.onerror = function(msg, url, line, column, error) {
        $8f211b0facf9737f$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($8f211b0facf9737f$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $8f211b0facf9737f$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $8f211b0facf9737f$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $8f211b0facf9737f$var$instrumentUnhandledRejection() {
    $8f211b0facf9737f$var$_oldOnUnhandledRejectionHandler = $8f211b0facf9737f$var$global.onunhandledrejection;
    $8f211b0facf9737f$var$global.onunhandledrejection = function(e) {
        $8f211b0facf9737f$var$triggerHandlers("unhandledrejection", e);
        if ($8f211b0facf9737f$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $8f211b0facf9737f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRequire.register("5TQck", function(module, exports) {

$parcel$export(module.exports, "logger", () => $44ba9434f610da91$export$af88d00dbe7f521);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8gwLa = parcelRequire("8gwLa");
// TODO: Implement different loggers for different environments
var $44ba9434f610da91$var$global = (0, $8gwLa.getGlobalObject)();
/** Prefix for logging strings */ var $44ba9434f610da91$var$PREFIX = "Sentry Logger ";
/** JSDoc */ var $44ba9434f610da91$var$Logger = /** @class */ function() {
    /** JSDoc */ function Logger() {
        this._enabled = false;
    }
    /** JSDoc */ Logger.prototype.disable = function() {
        this._enabled = false;
    };
    /** JSDoc */ Logger.prototype.enable = function() {
        this._enabled = true;
    };
    /** JSDoc */ Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $8gwLa.consoleSandbox)(function() {
            $44ba9434f610da91$var$global.console.log($44ba9434f610da91$var$PREFIX + "[Log]: " + args.join(" "));
        });
    };
    /** JSDoc */ Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $8gwLa.consoleSandbox)(function() {
            $44ba9434f610da91$var$global.console.warn($44ba9434f610da91$var$PREFIX + "[Warn]: " + args.join(" "));
        });
    };
    /** JSDoc */ Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $8gwLa.consoleSandbox)(function() {
            $44ba9434f610da91$var$global.console.error($44ba9434f610da91$var$PREFIX + "[Error]: " + args.join(" "));
        });
    };
    return Logger;
}();
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
$44ba9434f610da91$var$global.__SENTRY__ = $44ba9434f610da91$var$global.__SENTRY__ || {};
var $44ba9434f610da91$export$af88d00dbe7f521 = $44ba9434f610da91$var$global.__SENTRY__.logger || ($44ba9434f610da91$var$global.__SENTRY__.logger = new $44ba9434f610da91$var$Logger());

});

parcelRequire.register("6GC2j", function(module, exports) {

$parcel$export(module.exports, "supportsNativeFetch", () => $4de42b8a7d46885f$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsHistory", () => $4de42b8a7d46885f$export$67fc34576016d6ec);

var $5TQck = parcelRequire("5TQck");

var $8gwLa = parcelRequire("8gwLa");
function $4de42b8a7d46885f$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $4de42b8a7d46885f$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $4de42b8a7d46885f$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $4de42b8a7d46885f$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in (0, $8gwLa.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request("");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4de42b8a7d46885f$var$isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $4de42b8a7d46885f$export$c82d238e23c40b21() {
    if (!$4de42b8a7d46885f$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $8gwLa.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($4de42b8a7d46885f$var$isNativeFetch(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $4de42b8a7d46885f$var$isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $5TQck.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $4de42b8a7d46885f$export$531055a6c684a70a() {
    return "ReportingObserver" in (0, $8gwLa.getGlobalObject)();
}
function $4de42b8a7d46885f$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$4de42b8a7d46885f$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $4de42b8a7d46885f$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $8gwLa.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRequire.register("82Gml", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", () => $5daf5e56837b44b4$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $hGRpR = parcelRequire("hGRpR");
/** SyncPromise internal states */ var $5daf5e56837b44b4$var$States;
(function(States) {
    /** Pending */ States["PENDING"] = "PENDING";
    /** Resolved / OK */ States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */ States["REJECTED"] = "REJECTED";
})($5daf5e56837b44b4$var$States || ($5daf5e56837b44b4$var$States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $5daf5e56837b44b4$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = $5daf5e56837b44b4$var$States.PENDING;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult($5daf5e56837b44b4$var$States.RESOLVED, value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult($5daf5e56837b44b4$var$States.REJECTED, reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== $5daf5e56837b44b4$var$States.PENDING) return;
            if ((0, $hGRpR.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */ this._attachHandler = function(handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === $5daf5e56837b44b4$var$States.PENDING) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler.done) return;
                if (_this._state === $5daf5e56837b44b4$var$States.RESOLVED) {
                    if (handler.onfulfilled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler.onfulfilled(_this._value);
                }
                if (_this._state === $5daf5e56837b44b4$var$States.REJECTED) {
                    if (handler.onrejected) handler.onrejected(_this._value);
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.resolve = function(value) {
        return new SyncPromise(function(resolve) {
            resolve(value);
        });
    };
    /** JSDoc */ SyncPromise.reject = function(reason) {
        return new SyncPromise(function(_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */ SyncPromise.all = function(collection) {
        return new SyncPromise(function(resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function(item, index) {
                SyncPromise.resolve(item).then(function(value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) return;
                    resolve(resolvedCollection);
                }).then(null, reject);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function(result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function(reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                }
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.toString = function() {
        return "[object SyncPromise]";
    };
    return SyncPromise;
}();

});


parcelRequire.register("3tCyj", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $2881fc3e8effe2ef$export$775b6bb06e53a214);

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $evtBA = parcelRequire("evtBA");
var $8gwLa = parcelRequire("8gwLa");
var $hGRpR = parcelRequire("hGRpR");
var $82Gml = parcelRequire("82Gml");
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $2881fc3e8effe2ef$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifiying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $7QK2E.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $7QK2E.__assign)({}, scope._tags);
            newScope._extra = (0, $7QK2E.__assign)({}, scope._extra);
            newScope._contexts = (0, $7QK2E.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $7QK2E.__spread)(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        var _a, _b, _c, _d;
        // often, this span will be a transaction, but it's not guaranteed to be
        var span = this.getSpan();
        // try it the new way first
        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
        // fallback to the old way (known bug: this only finds transactions with sampled = true)
        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) return span.spanRecorder.spans[0];
        // neither way found a transaction
        return undefined;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
        } else if ((0, $hGRpR.isPlainObject)(captureContext)) {
            captureContext;
            this._tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = (0, $7QK2E.__assign)({
            timestamp: (0, $evtBA.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0 ? (0, $7QK2E.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxBreadcrumbs) : (0, $7QK2E.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        var _a;
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = (0, $7QK2E.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
            if (transactionName) event.tags = (0, $7QK2E.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $7QK2E.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors((0, $7QK2E.__spread)($2881fc3e8effe2ef$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $82Gml.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor((0, $7QK2E.__assign)({}, event), hint);
                if ((0, $hGRpR.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Retruns the global event processors.
 */ function $2881fc3e8effe2ef$var$getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */ var global = (0, $8gwLa.getGlobalObject)();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ }
function $2881fc3e8effe2ef$export$8e4e25f54d456511(callback) {
    $2881fc3e8effe2ef$var$getGlobalEventProcessors().push(callback);
}

});

parcelRequire.register("8UKb7", function(module, exports) {

$parcel$export(module.exports, "Session", () => $67d75fc12ab05f29$export$1fb4852a55678982);

var $8px7x = parcelRequire("8px7x");
parcelRequire("8wDn2");
var $i2LGp = parcelRequire("i2LGp");
var $8gwLa = parcelRequire("8gwLa");
/**
 * @inheritdoc
 */ var $67d75fc12ab05f29$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $8gwLa.uuid4)();
        this.timestamp = Date.now();
        this.started = Date.now();
        this.duration = 0;
        this.status = (0, $8px7x.SessionStatus).Ok;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || Date.now();
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $8gwLa.uuid4)();
        if (context.did) this.did = "" + context.did;
        if (typeof context.started === "number") this.started = context.started;
        if (typeof context.duration === "number") this.duration = context.duration;
        else this.duration = this.timestamp - this.started;
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (context.ipAddress) this.ipAddress = context.ipAddress;
        if (context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === "number") this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === (0, $8px7x.SessionStatus).Ok) this.update({
            status: (0, $8px7x.SessionStatus).Exited
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $i2LGp.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: true,
            started: new Date(this.started).toISOString(),
            timestamp: new Date(this.timestamp).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === "number" || typeof this.did === "string" ? "" + this.did : undefined,
            duration: this.duration,
            attrs: (0, $i2LGp.dropUndefinedKeys)({
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            })
        });
    };
    return Session;
}();

});
parcelRequire.register("8px7x", function(module, exports) {

$parcel$export(module.exports, "SessionStatus", () => $61fa5999f14f12df$export$5749bf3f1d0fd21b);
/**
 * Session Status
 */ var $61fa5999f14f12df$export$5749bf3f1d0fd21b;
(function(SessionStatus) {
    /** JSDoc */ SessionStatus["Ok"] = "ok";
    /** JSDoc */ SessionStatus["Exited"] = "exited";
    /** JSDoc */ SessionStatus["Crashed"] = "crashed";
    /** JSDoc */ SessionStatus["Abnormal"] = "abnormal";
})($61fa5999f14f12df$export$5749bf3f1d0fd21b || ($61fa5999f14f12df$export$5749bf3f1d0fd21b = {}));

});



parcelRequire.register("egrZk", function(module, exports) {

$parcel$export(module.exports, "TransactionSamplingMethod", () => $a628452b904a6766$export$458e2a303fac1507);
var $a628452b904a6766$export$458e2a303fac1507;
(function(TransactionSamplingMethod) {
    TransactionSamplingMethod["Explicit"] = "explicitly_set";
    TransactionSamplingMethod["Sampler"] = "client_sampler";
    TransactionSamplingMethod["Rate"] = "client_rate";
    TransactionSamplingMethod["Inheritance"] = "inheritance";
})($a628452b904a6766$export$458e2a303fac1507 || ($a628452b904a6766$export$458e2a303fac1507 = {}));

});

parcelRequire.register("6CcjJ", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $4d0fd8a8ac47976e$export$637857c1d87b640c);
parcelRequire("8wDn2");
var $chSbG = parcelRequire("chSbG");
var $5TQck = parcelRequire("5TQck");

var $iL8cJ = parcelRequire("iL8cJ");

var $SQznX = parcelRequire("SQznX");
function $4d0fd8a8ac47976e$export$637857c1d87b640c() {
    (0, $chSbG.addInstrumentationHandler)({
        callback: $4d0fd8a8ac47976e$var$errorCallback,
        type: "error"
    });
    (0, $chSbG.addInstrumentationHandler)({
        callback: $4d0fd8a8ac47976e$var$errorCallback,
        type: "unhandledrejection"
    });
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $4d0fd8a8ac47976e$var$errorCallback() {
    var activeTransaction = (0, $SQznX.getActiveTransaction)();
    if (activeTransaction) {
        (0, $5TQck.logger).log("[Tracing] Transaction: " + (0, $iL8cJ.SpanStatus).InternalError + " -> Global error occured");
        activeTransaction.setStatus((0, $iL8cJ.SpanStatus).InternalError);
    }
}

});
parcelRequire.register("iL8cJ", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", () => $da82faff0ac4ffbd$export$beb8e6a823e89c5d);
/** The status of an Span. */ // eslint-disable-next-line import/export
var $da82faff0ac4ffbd$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ SpanStatus["Ok"] = "ok";
    /** Deadline expired before operation could complete. */ SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ SpanStatus["Unauthenticated"] = "unauthenticated";
    /** 403 Forbidden */ SpanStatus["PermissionDenied"] = "permission_denied";
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ SpanStatus["NotFound"] = "not_found";
    /** 429 Too Many Requests */ SpanStatus["ResourceExhausted"] = "resource_exhausted";
    /** Client specified an invalid argument. 4xx. */ SpanStatus["InvalidArgument"] = "invalid_argument";
    /** 501 Not Implemented */ SpanStatus["Unimplemented"] = "unimplemented";
    /** 503 Service Unavailable */ SpanStatus["Unavailable"] = "unavailable";
    /** Other/generic 5xx. */ SpanStatus["InternalError"] = "internal_error";
    /** Unknown. Any non-standard HTTP status code. */ SpanStatus["UnknownError"] = "unknown_error";
    /** The operation was cancelled (typically by the user). */ SpanStatus["Cancelled"] = "cancelled";
    /** Already exists (409) */ SpanStatus["AlreadyExists"] = "already_exists";
    /** Operation was rejected because the system is not in a state required for the operation's */ SpanStatus["FailedPrecondition"] = "failed_precondition";
    /** The operation was aborted, typically due to a concurrency issue. */ SpanStatus["Aborted"] = "aborted";
    /** Operation was attempted past the valid range. */ SpanStatus["OutOfRange"] = "out_of_range";
    /** Unrecoverable data loss or corruption */ SpanStatus["DataLoss"] = "data_loss";
})($da82faff0ac4ffbd$export$beb8e6a823e89c5d || ($da82faff0ac4ffbd$export$beb8e6a823e89c5d = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function(SpanStatus) {
    /**
     * Converts a HTTP status code into a {@link SpanStatus}.
     *
     * @param httpStatus The HTTP response status code.
     * @returns The span status or {@link SpanStatus.UnknownError}.
     */ function fromHttpCode(httpStatus) {
        if (httpStatus < 400) return SpanStatus.Ok;
        if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
            case 401:
                return SpanStatus.Unauthenticated;
            case 403:
                return SpanStatus.PermissionDenied;
            case 404:
                return SpanStatus.NotFound;
            case 409:
                return SpanStatus.AlreadyExists;
            case 413:
                return SpanStatus.FailedPrecondition;
            case 429:
                return SpanStatus.ResourceExhausted;
            default:
                return SpanStatus.InvalidArgument;
        }
        if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
            case 501:
                return SpanStatus.Unimplemented;
            case 503:
                return SpanStatus.Unavailable;
            case 504:
                return SpanStatus.DeadlineExceeded;
            default:
                return SpanStatus.InternalError;
        }
        return SpanStatus.UnknownError;
    }
    SpanStatus.fromHttpCode = fromHttpCode;
})($da82faff0ac4ffbd$export$beb8e6a823e89c5d || ($da82faff0ac4ffbd$export$beb8e6a823e89c5d = {}));

});

parcelRequire.register("SQznX", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $0a4dd283b3b7e2ea$export$5008da00b1b6dee6);
$parcel$export(module.exports, "extractTraceparentData", () => $0a4dd283b3b7e2ea$export$8e9a29865c0a1226);
$parcel$export(module.exports, "getActiveTransaction", () => $0a4dd283b3b7e2ea$export$a7feb32fdd923295);
$parcel$export(module.exports, "msToSec", () => $0a4dd283b3b7e2ea$export$b4785dbd4a81b33f);
$parcel$export(module.exports, "secToMs", () => $0a4dd283b3b7e2ea$export$a3ba11b11516dfdb);

var $bn2rP = parcelRequire("bn2rP");

var $0a4dd283b3b7e2ea$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $0a4dd283b3b7e2ea$export$5008da00b1b6dee6(options) {
    return "tracesSampleRate" in options || "tracesSampler" in options;
}
function $0a4dd283b3b7e2ea$export$8e9a29865c0a1226(traceparent) {
    var matches = traceparent.match($0a4dd283b3b7e2ea$export$394a210812ba3012);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === "1") parentSampled = true;
        else if (matches[3] === "0") parentSampled = false;
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2]
        };
    }
    return undefined;
}
function $0a4dd283b3b7e2ea$export$a7feb32fdd923295(hub) {
    if (hub === void 0) hub = (0, $bn2rP.getCurrentHub)();
    var _a, _b;
    return (_b = (_a = hub) === null || _a === void 0 ? void 0 : _a.getScope()) === null || _b === void 0 ? void 0 : _b.getTransaction();
}
function $0a4dd283b3b7e2ea$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
function $0a4dd283b3b7e2ea$export$a3ba11b11516dfdb(time) {
    return time * 1000;
}

});


parcelRequire.register("hh22J", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IDLE_TIMEOUT", () => $c9359bee4338f98e$export$68a507a5e6cb6de5);
$parcel$export(module.exports, "IdleTransaction", () => $c9359bee4338f98e$export$b279e6bd7040371f);

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $5TQck = parcelRequire("5TQck");
var $evtBA = parcelRequire("evtBA");

var $7Xrzs = parcelRequire("7Xrzs");

var $iL8cJ = parcelRequire("iL8cJ");

var $lcwYo = parcelRequire("lcwYo");
var $c9359bee4338f98e$export$68a507a5e6cb6de5 = 1000;
/**
 * @inheritDoc
 */ var $c9359bee4338f98e$export$370d6113c18ba86c = /** @class */ function(_super) {
    (0, $7QK2E.__extends)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) transactionSpanId = "";
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */ IdleTransactionSpanRecorder.prototype.add = function(span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function(endTimestamp) {
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $evtBA.timestampWithMs)();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}((0, $7Xrzs.SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var $c9359bee4338f98e$export$b279e6bd7040371f = /** @class */ function(_super) {
    (0, $7QK2E.__extends)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, // The time to wait in ms until the idle transaction will be finished. Default: 1000
    _idleTimeout, // If an idle transaction should be put itself on and off the scope automatically.
    _onScope) {
        if (_idleTimeout === void 0) _idleTimeout = $c9359bee4338f98e$export$68a507a5e6cb6de5;
        if (_onScope === void 0) _onScope = false;
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Stores reference to the timeout that calls _beat().
        _this._heartbeatTimer = 0;
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            $c9359bee4338f98e$var$clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $5TQck.logger).log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function(scope) {
                return scope.setSpan(_this);
            });
        }
        return _this;
    }
    /** {@inheritDoc} */ IdleTransaction.prototype.finish = function(endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) endTimestamp = (0, $evtBA.timestampWithMs)();
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            (0, $5TQck.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for(var _b = (0, $7QK2E.__values)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()){
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus((0, $iL8cJ.SpanStatus).Cancelled);
                    (0, $5TQck.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (0, $5TQck.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            // this._onScope is true if the transaction was previously on the scope.
            if (this._onScope) $c9359bee4338f98e$var$clearActiveTransaction(this._idleHub);
            (0, $5TQck.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, $5TQck.logger).log("[Tracing] No active IdleTransaction");
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */ IdleTransaction.prototype.registerBeforeFinishCallback = function(callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */ IdleTransaction.prototype.initSpanRecorder = function(maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            this._initTimeout = setTimeout(function() {
                if (!_this._finished) _this.finish();
            }, this._idleTimeout);
            var pushActivity = function(id) {
                if (_this._finished) return;
                _this._pushActivity(id);
            };
            var popActivity = function(id) {
                if (_this._finished) return;
                _this._popActivity(id);
            };
            this.spanRecorder = new $c9359bee4338f98e$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $5TQck.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */ IdleTransaction.prototype._pushActivity = function(spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        (0, $5TQck.logger).log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        (0, $5TQck.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */ IdleTransaction.prototype._popActivity = function(spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            (0, $5TQck.logger).log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $5TQck.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = (0, $evtBA.timestampWithMs)() + timeout / 1000;
            setTimeout(function() {
                if (!_this._finished) _this.finish(end_1);
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */ IdleTransaction.prototype._beat = function() {
        clearTimeout(this._heartbeatTimer);
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        var keys = Object.keys(this.activities);
        var heartbeatString = keys.length ? keys.reduce(function(prev, current) {
            return prev + current;
        }) : "";
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter += 1;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (0, $5TQck.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus((0, $iL8cJ.SpanStatus).DeadlineExceeded);
            this.setTag("heartbeat", "failed");
            this.finish();
        } else this._pingHeartbeat();
    };
    /**
     * Pings the heartbeat
     */ IdleTransaction.prototype._pingHeartbeat = function() {
        var _this = this;
        (0, $5TQck.logger).log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        this._heartbeatTimer = setTimeout(function() {
            _this._beat();
        }, 5000);
    };
    return IdleTransaction;
}((0, $lcwYo.Transaction));
/**
 * Reset active transaction on scope
 */ function $c9359bee4338f98e$var$clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) scope.setSpan(undefined);
        }
    }
}

});
parcelRequire.register("7Xrzs", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $5cb36e14f8a38021$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $5cb36e14f8a38021$export$5f1714a13ed34c01);

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $i2LGp = parcelRequire("i2LGp");
var $evtBA = parcelRequire("evtBA");
var $8gwLa = parcelRequire("8gwLa");

var $iL8cJ = parcelRequire("iL8cJ");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var $5cb36e14f8a38021$export$10c95c129cd0d4fe = /** @class */ function() {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) maxlen = 1000;
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */ SpanRecorder.prototype.add = function(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    };
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var $5cb36e14f8a38021$export$5f1714a13ed34c01 = /** @class */ function() {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */ function Span(spanContext) {
        /**
         * @inheritDoc
         */ this.traceId = (0, $8gwLa.uuid4)();
        /**
         * @inheritDoc
         */ this.spanId = (0, $8gwLa.uuid4)().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */ this.startTimestamp = (0, $evtBA.timestampWithMs)();
        /**
         * @inheritDoc
         */ this.tags = {};
        /**
         * @inheritDoc
         */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    /**
     * @inheritDoc
     * @deprecated
     */ Span.prototype.child = function(spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */ Span.prototype.startChild = function(spanContext) {
        var childSpan = new Span((0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, spanContext), {
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */ Span.prototype.setTag = function(key, value) {
        var _a;
        this.tags = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function(key, value) {
        var _a;
        this.data = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.setStatus = function(value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.setHttpStatus = function(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        var spanStatus = (0, $iL8cJ.SpanStatus).fromHttpCode(httpStatus);
        if (spanStatus !== (0, $iL8cJ.SpanStatus).UnknownError) this.setStatus(spanStatus);
        return this;
    };
    /**
     * @inheritDoc
     */ Span.prototype.isSuccess = function() {
        return this.status === (0, $iL8cJ.SpanStatus).Ok;
    };
    /**
     * @inheritDoc
     */ Span.prototype.finish = function(endTimestamp) {
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $evtBA.timestampWithMs)();
    };
    /**
     * @inheritDoc
     */ Span.prototype.toTraceparent = function() {
        var sampledString = "";
        if (this.sampled !== undefined) sampledString = this.sampled ? "-1" : "-0";
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */ Span.prototype.getTraceContext = function() {
        return (0, $i2LGp.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    };
    /**
     * @inheritDoc
     */ Span.prototype.toJSON = function() {
        return (0, $i2LGp.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    };
    return Span;
}();

});

parcelRequire.register("lcwYo", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $f6f44bbd9108c2a2$export$febc5573c75cefb0);

var $7QK2E = parcelRequire("7QK2E");

var $bn2rP = parcelRequire("bn2rP");
parcelRequire("8wDn2");
var $hGRpR = parcelRequire("hGRpR");
var $5TQck = parcelRequire("5TQck");

var $7Xrzs = parcelRequire("7Xrzs");
/** JSDoc */ var $f6f44bbd9108c2a2$export$febc5573c75cefb0 = /** @class */ function(_super) {
    (0, $7QK2E.__extends)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */ function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */ _this._hub = (0, $bn2rP.getCurrentHub)();
        if ((0, $hGRpR.isInstanceOf)(hub, (0, $bn2rP.Hub))) _this._hub = hub;
        _this.name = transactionContext.name ? transactionContext.name : "";
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */ Transaction.prototype.setName = function(name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */ Transaction.prototype.initSpanRecorder = function(maxlen) {
        if (maxlen === void 0) maxlen = 1000;
        if (!this.spanRecorder) this.spanRecorder = new (0, $7Xrzs.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */ Transaction.prototype.setMeasurements = function(measurements) {
        this._measurements = (0, $7QK2E.__assign)({}, measurements);
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.finish = function(endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (0, $5TQck.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $5TQck.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(s) {
            return s !== _this && s.endTimestamp;
        }) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce(function(prev, current) {
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        var transaction = {
            contexts: {
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction"
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $5TQck.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        return this._hub.captureEvent(transaction);
    };
    return Transaction;
}((0, $7Xrzs.Span));

});



parcelRequire.register("cHt7H", function(module, exports) {

$parcel$export(module.exports, "Postgres", () => Postgres);
parcelRequire("8wDn2");
var $l6Ec8 = parcelRequire("l6Ec8");
var $i2LGp = parcelRequire("i2LGp");
var $5TQck = parcelRequire("5TQck");
/** Tracing integration for node-postgres package */ var Postgres = /** @class */ function() {
    function Postgres() {
        /**
         * @inheritDoc
         */ this.name = Postgres.id;
    }
    /**
     * @inheritDoc
     */ Postgres.prototype.setupOnce = function(_, getCurrentHub) {
        var client;
        try {
            var pgModule = (0, $l6Ec8.dynamicRequire)(module, "pg");
            client = pgModule.Client;
        } catch (e) {
            (0, $5TQck.logger).error("Postgres Integration was unable to require `pg` package.");
            return;
        }
        /**
         * function (query, callback) => void
         * function (query, params, callback) => void
         * function (query) => Promise
         * function (query, params) => Promise
         */ (0, $i2LGp.fill)(client.prototype, "query", function(orig) {
            return function(config, values, callback) {
                var _a, _b;
                var scope = getCurrentHub().getScope();
                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
                    description: typeof config === "string" ? config : config.text,
                    op: "db"
                });
                if (typeof callback === "function") return orig.call(this, config, values, function(err, result) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    callback(err, result);
                });
                if (typeof values === "function") return orig.call(this, config, function(err, result) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    values(err, result);
                });
                return orig.call(this, config, values).then(function(res) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    return res;
                });
            };
        });
    };
    /**
     * @inheritDoc
     */ Postgres.id = "Postgres";
    return Postgres;
}();

});

parcelRequire.register("2IAjF", function(module, exports) {

$parcel$export(module.exports, "Mysql", () => Mysql);
parcelRequire("8wDn2");
var $l6Ec8 = parcelRequire("l6Ec8");
var $i2LGp = parcelRequire("i2LGp");
var $5TQck = parcelRequire("5TQck");
/** Tracing integration for node-mysql package */ var Mysql = /** @class */ function() {
    function Mysql() {
        /**
         * @inheritDoc
         */ this.name = Mysql.id;
    }
    /**
     * @inheritDoc
     */ Mysql.prototype.setupOnce = function(_, getCurrentHub) {
        var connection;
        try {
            // Unfortunatelly mysql is using some custom loading system and `Connection` is not exported directly.
            connection = (0, $l6Ec8.dynamicRequire)(module, "mysql/lib/Connection.js");
        } catch (e) {
            (0, $5TQck.logger).error("Mysql Integration was unable to require `mysql` package.");
            return;
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $i2LGp.fill)(connection.prototype, "query", function(orig) {
            return function(options, values, callback) {
                var _a, _b;
                var scope = getCurrentHub().getScope();
                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
                    description: typeof options === "string" ? options : options.sql,
                    op: "db"
                });
                if (typeof callback === "function") return orig.call(this, options, values, function(err, result, fields) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    callback(err, result, fields);
                });
                if (typeof values === "function") return orig.call(this, options, function(err, result, fields) {
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    values(err, result, fields);
                });
                return orig.call(this, options, values, callback);
            };
        });
    };
    /**
     * @inheritDoc
     */ Mysql.id = "Mysql";
    return Mysql;
}();

});

parcelRequire.register("bV6u1", function(module, exports) {

$parcel$export(module.exports, "Mongo", () => Mongo);

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $l6Ec8 = parcelRequire("l6Ec8");
var $i2LGp = parcelRequire("i2LGp");
var $5TQck = parcelRequire("5TQck");
var OPERATIONS = [
    "aggregate",
    "bulkWrite",
    "countDocuments",
    "createIndex",
    "createIndexes",
    "deleteMany",
    "deleteOne",
    "distinct",
    "drop",
    "dropIndex",
    "dropIndexes",
    "estimatedDocumentCount",
    "findOne",
    "findOneAndDelete",
    "findOneAndReplace",
    "findOneAndUpdate",
    "indexes",
    "indexExists",
    "indexInformation",
    "initializeOrderedBulkOp",
    "insertMany",
    "insertOne",
    "isCapped",
    "mapReduce",
    "options",
    "parallelCollectionScan",
    "rename",
    "replaceOne",
    "stats",
    "updateMany",
    "updateOne"
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
var OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        "operations"
    ],
    countDocuments: [
        "query"
    ],
    createIndex: [
        "fieldOrSpec"
    ],
    createIndexes: [
        "indexSpecs"
    ],
    deleteMany: [
        "filter"
    ],
    deleteOne: [
        "filter"
    ],
    distinct: [
        "key",
        "query"
    ],
    dropIndex: [
        "indexName"
    ],
    findOne: [
        "query"
    ],
    findOneAndDelete: [
        "filter"
    ],
    findOneAndReplace: [
        "filter",
        "replacement"
    ],
    findOneAndUpdate: [
        "filter",
        "update"
    ],
    indexExists: [
        "indexes"
    ],
    insertMany: [
        "docs"
    ],
    insertOne: [
        "doc"
    ],
    mapReduce: [
        "map",
        "reduce"
    ],
    rename: [
        "newName"
    ],
    replaceOne: [
        "filter",
        "doc"
    ],
    updateMany: [
        "filter",
        "update"
    ],
    updateOne: [
        "filter",
        "update"
    ]
};
/** Tracing integration for mongo package */ var Mongo = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Mongo(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Mongo.id;
        this._operations = Array.isArray(options.operations) ? options.operations : OPERATIONS;
        this._describeOperations = "describeOperations" in options ? options.describeOperations : true;
    }
    /**
     * @inheritDoc
     */ Mongo.prototype.setupOnce = function(_, getCurrentHub) {
        var collection;
        try {
            var mongodbModule = (0, $l6Ec8.dynamicRequire)(module, "mongodb");
            collection = mongodbModule.Collection;
        } catch (e) {
            (0, $5TQck.logger).error("Mongo Integration was unable to require `mongodb` package.");
            return;
        }
        this._instrumentOperations(collection, this._operations, getCurrentHub);
    };
    /**
     * Patches original collection methods
     */ Mongo.prototype._instrumentOperations = function(collection, operations, getCurrentHub) {
        var _this = this;
        operations.forEach(function(operation) {
            return _this._patchOperation(collection, operation, getCurrentHub);
        });
    };
    /**
     * Patches original collection to utilize our tracing functionality
     */ Mongo.prototype._patchOperation = function(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $i2LGp.fill)(collection.prototype, operation, function(orig) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a, _b, _c;
                var lastArg = args[args.length - 1];
                var scope = getCurrentHub().getScope();
                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== "function" || operation === "mapReduce" && args.length === 2) {
                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
                    return orig.call.apply(orig, (0, $7QK2E.__spread)([
                        this
                    ], args)).then(function(res) {
                        var _a;
                        (_a = span_1) === null || _a === void 0 || _a.finish();
                        return res;
                    });
                }
                var span = (_c = parentSpan) === null || _c === void 0 ? void 0 : _c.startChild(getSpanContext(this, operation, args.slice(0, -1)));
                return orig.call.apply(orig, (0, $7QK2E.__spread)([
                    this
                ], args.slice(0, -1), [
                    function(err, result) {
                        var _a;
                        (_a = span) === null || _a === void 0 || _a.finish();
                        lastArg(err, result);
                    }
                ]));
            };
        });
    };
    /**
     * Form a SpanContext based on the user input to a given operation.
     */ Mongo.prototype._getSpanContextFromOperationArguments = function(collection, operation, args) {
        var data = {
            collectionName: collection.collectionName,
            dbName: collection.dbName,
            namespace: collection.namespace
        };
        var spanContext = {
            op: "db",
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        var signature = OPERATION_SIGNATURES[operation];
        var shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === "mapReduce") {
                var _a = (0, $7QK2E.__read)(args, 2), map = _a[0], reduce = _a[1];
                data[signature[0]] = typeof map === "string" ? map : map.name || "<anonymous>";
                data[signature[1]] = typeof reduce === "string" ? reduce : reduce.name || "<anonymous>";
            } else for(var i = 0; i < signature.length; i++)data[signature[i]] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    };
    /**
     * @inheritDoc
     */ Mongo.id = "Mongo";
    return Mongo;
}();

});

var $35b7bd865360a597$exports = {};
"use strict";

$35b7bd865360a597$exports = (parcelRequire("k149n"));


const $a6fea68bb2a2e7ce$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $a6fea68bb2a2e7ce$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $a6fea68bb2a2e7ce$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $a6fea68bb2a2e7ce$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $a6fea68bb2a2e7ce$var$Logger(this.logger, options);
    }
}
var $a6fea68bb2a2e7ce$var$baseLogger = new $a6fea68bb2a2e7ce$var$Logger();
class $a6fea68bb2a2e7ce$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $a6fea68bb2a2e7ce$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $a6fea68bb2a2e7ce$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $a6fea68bb2a2e7ce$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
const $a6fea68bb2a2e7ce$var$lastOfPathSeparatorRegExp = /###/g;
function $a6fea68bb2a2e7ce$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace($a6fea68bb2a2e7ce$var$lastOfPathSeparatorRegExp, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
}
function $a6fea68bb2a2e7ce$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $a6fea68bb2a2e7ce$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $a6fea68bb2a2e7ce$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $a6fea68bb2a2e7ce$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
}
function $a6fea68bb2a2e7ce$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $a6fea68bb2a2e7ce$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $a6fea68bb2a2e7ce$var$getPath(object, path) {
    const { obj: obj, k: k } = $a6fea68bb2a2e7ce$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $a6fea68bb2a2e7ce$var$getPathWithDefaults(data, defaultData, key) {
    const value = $a6fea68bb2a2e7ce$var$getPath(data, key);
    if (value !== undefined) return value;
    return $a6fea68bb2a2e7ce$var$getPath(defaultData, key);
}
function $a6fea68bb2a2e7ce$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $a6fea68bb2a2e7ce$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $a6fea68bb2a2e7ce$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $a6fea68bb2a2e7ce$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $a6fea68bb2a2e7ce$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$a6fea68bb2a2e7ce$var$_entityMap[s]);
    return data;
}
class $a6fea68bb2a2e7ce$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $a6fea68bb2a2e7ce$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const $a6fea68bb2a2e7ce$var$looksLikeObjectPathRegExpCache = new $a6fea68bb2a2e7ce$var$RegExpCache(20);
function $a6fea68bb2a2e7ce$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $a6fea68bb2a2e7ce$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $a6fea68bb2a2e7ce$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $a6fea68bb2a2e7ce$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
}
function $a6fea68bb2a2e7ce$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $a6fea68bb2a2e7ce$var$ResourceStore extends $a6fea68bb2a2e7ce$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === "string" && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $a6fea68bb2a2e7ce$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $a6fea68bb2a2e7ce$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $a6fea68bb2a2e7ce$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $a6fea68bb2a2e7ce$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $a6fea68bb2a2e7ce$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $a6fea68bb2a2e7ce$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $a6fea68bb2a2e7ce$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $a6fea68bb2a2e7ce$var$checkedLoadedFor = {};
class $a6fea68bb2a2e7ce$var$Translator extends $a6fea68bb2a2e7ce$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $a6fea68bb2a2e7ce$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$a6fea68bb2a2e7ce$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $a6fea68bb2a2e7ce$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $a6fea68bb2a2e7ce$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$a6fea68bb2a2e7ce$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $a6fea68bb2a2e7ce$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $a6fea68bb2a2e7ce$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $a6fea68bb2a2e7ce$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $a6fea68bb2a2e7ce$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $a6fea68bb2a2e7ce$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $a6fea68bb2a2e7ce$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $a6fea68bb2a2e7ce$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $a6fea68bb2a2e7ce$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $a6fea68bb2a2e7ce$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $a6fea68bb2a2e7ce$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $a6fea68bb2a2e7ce$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $a6fea68bb2a2e7ce$var$intlVersions = [
    "v4"
];
const $a6fea68bb2a2e7ce$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $a6fea68bb2a2e7ce$var$createRules() {
    const rules = {};
    $a6fea68bb2a2e7ce$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $a6fea68bb2a2e7ce$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $a6fea68bb2a2e7ce$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $a6fea68bb2a2e7ce$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $a6fea68bb2a2e7ce$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($a6fea68bb2a2e7ce$var$getCleanedCode(code === "dev" ? "en" : code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$a6fea68bb2a2e7ce$var$suffixesOrder[pluralCategory1] - $a6fea68bb2a2e7ce$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$a6fea68bb2a2e7ce$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $a6fea68bb2a2e7ce$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $a6fea68bb2a2e7ce$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $a6fea68bb2a2e7ce$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $a6fea68bb2a2e7ce$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $a6fea68bb2a2e7ce$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $a6fea68bb2a2e7ce$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $a6fea68bb2a2e7ce$var$regexEscape(prefix) : prefixEscaped || "{{";
        this.suffix = suffix ? $a6fea68bb2a2e7ce$var$regexEscape(suffix) : suffixEscaped || "}}";
        this.formatSeparator = formatSeparator || ",";
        this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
        this.nestingPrefix = nestingPrefix ? $a6fea68bb2a2e7ce$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $a6fea68bb2a2e7ce$var$regexEscape("$t(");
        this.nestingSuffix = nestingSuffix ? $a6fea68bb2a2e7ce$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $a6fea68bb2a2e7ce$var$regexEscape(")");
        this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $a6fea68bb2a2e7ce$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($a6fea68bb2a2e7ce$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $a6fea68bb2a2e7ce$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $a6fea68bb2a2e7ce$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $a6fea68bb2a2e7ce$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(":");
                    const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === "false") formatOptions[trimmedKey] = false;
                    if (val === "true") formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $a6fea68bb2a2e7ce$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($a6fea68bb2a2e7ce$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $a6fea68bb2a2e7ce$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $a6fea68bb2a2e7ce$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $a6fea68bb2a2e7ce$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $a6fea68bb2a2e7ce$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $a6fea68bb2a2e7ce$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $a6fea68bb2a2e7ce$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $a6fea68bb2a2e7ce$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $a6fea68bb2a2e7ce$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $a6fea68bb2a2e7ce$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $a6fea68bb2a2e7ce$var$Connector extends $a6fea68bb2a2e7ce$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $a6fea68bb2a2e7ce$var$pushPath(q.loaded, [
                lng
            ], ns);
            $a6fea68bb2a2e7ce$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $a6fea68bb2a2e7ce$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $a6fea68bb2a2e7ce$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $a6fea68bb2a2e7ce$var$noop() {}
function $a6fea68bb2a2e7ce$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $a6fea68bb2a2e7ce$var$I18n extends $a6fea68bb2a2e7ce$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $a6fea68bb2a2e7ce$var$transformOptions(options);
        this.services = {};
        this.logger = $a6fea68bb2a2e7ce$var$baseLogger;
        this.modules = {
            external: []
        };
        $a6fea68bb2a2e7ce$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $a6fea68bb2a2e7ce$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$a6fea68bb2a2e7ce$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $a6fea68bb2a2e7ce$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $a6fea68bb2a2e7ce$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $a6fea68bb2a2e7ce$var$Formatter;
            const lu = new $a6fea68bb2a2e7ce$var$LanguageUtil(this.options);
            this.store = new $a6fea68bb2a2e7ce$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $a6fea68bb2a2e7ce$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $a6fea68bb2a2e7ce$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $a6fea68bb2a2e7ce$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $a6fea68bb2a2e7ce$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $a6fea68bb2a2e7ce$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $a6fea68bb2a2e7ce$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $a6fea68bb2a2e7ce$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a6fea68bb2a2e7ce$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $a6fea68bb2a2e7ce$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $a6fea68bb2a2e7ce$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $a6fea68bb2a2e7ce$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $a6fea68bb2a2e7ce$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $a6fea68bb2a2e7ce$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $a6fea68bb2a2e7ce$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $a6fea68bb2a2e7ce$var$LanguageUtil($a6fea68bb2a2e7ce$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $a6fea68bb2a2e7ce$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a6fea68bb2a2e7ce$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $a6fea68bb2a2e7ce$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $a6fea68bb2a2e7ce$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $a6fea68bb2a2e7ce$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $a6fea68bb2a2e7ce$export$2e2bcd8739ae039 = $a6fea68bb2a2e7ce$var$I18n.createInstance();
$a6fea68bb2a2e7ce$export$2e2bcd8739ae039.createInstance = $a6fea68bb2a2e7ce$var$I18n.createInstance;
const $a6fea68bb2a2e7ce$export$99152e8d49ca4e7d = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.createInstance;
const $a6fea68bb2a2e7ce$export$147ec2801e896265 = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.dir;
const $a6fea68bb2a2e7ce$export$2cd8252107eb640b = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.init;
const $a6fea68bb2a2e7ce$export$d3d08d944062d7e = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.loadResources;
const $a6fea68bb2a2e7ce$export$a5d9bf5d83fcab09 = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.reloadResources;
const $a6fea68bb2a2e7ce$export$1f96ae73734a86cc = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.use;
const $a6fea68bb2a2e7ce$export$61465194746e7fd2 = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.changeLanguage;
const $a6fea68bb2a2e7ce$export$f90d180fc7da3b3b = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.getFixedT;
const $a6fea68bb2a2e7ce$export$625550452a3fa3ec = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.t;
const $a6fea68bb2a2e7ce$export$f7e9f41ea797a17 = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.exists;
const $a6fea68bb2a2e7ce$export$2b4b218e406d2d00 = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.setDefaultNamespace;
const $a6fea68bb2a2e7ce$export$93d9ee97c1ad3f31 = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.hasLoadedNamespace;
const $a6fea68bb2a2e7ce$export$83be934b53fff43b = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.loadNamespaces;
const $a6fea68bb2a2e7ce$export$8cd7e7a54fa865bc = $a6fea68bb2a2e7ce$export$2e2bcd8739ae039.loadLanguages;



var $4hYjL = parcelRequire("4hYjL");

var $4hYjL = parcelRequire("4hYjL");
var $a386689dd1fa669c$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $a386689dd1fa669c$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $d31874ca0e6d36ba$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $d31874ca0e6d36ba$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($a386689dd1fa669c$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($d31874ca0e6d36ba$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $d31874ca0e6d36ba$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $d31874ca0e6d36ba$var$i = /^\s*$/, $d31874ca0e6d36ba$var$s = Object.create(null);
function $d31874ca0e6d36ba$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($d31874ca0e6d36ba$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $d31874ca0e6d36ba$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $d31874ca0e6d36ba$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($d31874ca0e6d36ba$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $d31874ca0e6d36ba$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $d31874ca0e6d36ba$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $d31874ca0e6d36ba$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $d31874ca0e6d36ba$var$a("", t);
        }, "");
    }
};
var $d31874ca0e6d36ba$export$2e2bcd8739ae039 = $d31874ca0e6d36ba$var$c;


function $df587f91c7955b3e$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $df587f91c7955b3e$var$alreadyWarned = {};
function $df587f91c7955b3e$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $df587f91c7955b3e$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $df587f91c7955b3e$var$alreadyWarned[args[0]] = new Date();
    $df587f91c7955b3e$export$c106dd0671a0fc2d(...args);
}
const $df587f91c7955b3e$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $df587f91c7955b3e$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $df587f91c7955b3e$var$loadedClb(i18n, cb));
}
function $df587f91c7955b3e$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $df587f91c7955b3e$var$loadedClb(i18n, cb));
}
function $df587f91c7955b3e$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $df587f91c7955b3e$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $df587f91c7955b3e$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $df587f91c7955b3e$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $df587f91c7955b3e$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $2eb5158e4e708a80$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $2eb5158e4e708a80$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $2eb5158e4e708a80$var$unescapeHtmlEntity = (m)=>$2eb5158e4e708a80$var$htmlEntities[m];
const $2eb5158e4e708a80$export$e8bacd2802a88316 = (text)=>text.replace($2eb5158e4e708a80$var$matchHtmlEntity, $2eb5158e4e708a80$var$unescapeHtmlEntity);


let $75bc3a370e3601a1$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $2eb5158e4e708a80$export$e8bacd2802a88316
};
function $75bc3a370e3601a1$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $75bc3a370e3601a1$var$defaultOptions = {
        ...$75bc3a370e3601a1$var$defaultOptions,
        ...options
    };
}
function $75bc3a370e3601a1$export$212bb2fc580a90a8() {
    return $75bc3a370e3601a1$var$defaultOptions;
}


let $a02805681db0df87$var$i18nInstance;
function $a02805681db0df87$export$a039134f2fc7e0(instance) {
    $a02805681db0df87$var$i18nInstance = instance;
}
function $a02805681db0df87$export$64af334f494c2f47() {
    return $a02805681db0df87$var$i18nInstance;
}


function $89784de82f573dd0$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $89784de82f573dd0$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $89784de82f573dd0$var$getAsArray(children) : children;
}
function $89784de82f573dd0$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $4hYjL.isValidElement)(child));
}
function $89784de82f573dd0$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $89784de82f573dd0$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $89784de82f573dd0$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $89784de82f573dd0$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $4hYjL.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $89784de82f573dd0$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $df587f91c7955b3e$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $df587f91c7955b3e$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $df587f91c7955b3e$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $89784de82f573dd0$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $89784de82f573dd0$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($89784de82f573dd0$var$hasChildren(child)) getData($89784de82f573dd0$var$getChildren(child));
            else if (typeof child === "object" && !(0, $4hYjL.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $d31874ca0e6d36ba$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $89784de82f573dd0$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $89784de82f573dd0$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $4hYjL.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $4hYjL.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $4hYjL.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $89784de82f573dd0$var$getAsArray(reactNode);
        const astNodes = $89784de82f573dd0$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $89784de82f573dd0$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $4hYjL.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $89784de82f573dd0$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($89784de82f573dd0$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $4hYjL.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $4hYjL.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $4hYjL.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $89784de82f573dd0$var$getAsArray(children || []));
    return $89784de82f573dd0$var$getChildren(result[0]);
}
function $89784de82f573dd0$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $a02805681db0df87$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $df587f91c7955b3e$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $75bc3a370e3601a1$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $89784de82f573dd0$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $4hYjL.createElement)((0, $4hYjL.Fragment), null, comp);
        }
        components[c] = (0, $4hYjL.createElement)(Componentized);
    });
    const content = $89784de82f573dd0$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $4hYjL.createElement)(useAsParent, additionalProps, content) : content;
}



var $4hYjL = parcelRequire("4hYjL");




const $7f05b907a0597c85$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $75bc3a370e3601a1$export$2e2366488d12e20d)(instance.options.react);
        (0, $a02805681db0df87$export$a039134f2fc7e0)(instance);
    }
};


const $34aff22e1f62742e$export$5603ab5ced17ce64 = (0, $4hYjL.createContext)();
class $34aff22e1f62742e$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $34aff22e1f62742e$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $34aff22e1f62742e$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $34aff22e1f62742e$export$704200e5d0b9e8f() {
    const i18n = (0, $a02805681db0df87$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $9623d66a7a0ec723$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $4hYjL.useContext)((0, $34aff22e1f62742e$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $a02805681db0df87$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $89784de82f573dd0$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $4hYjL = parcelRequire("4hYjL");


const $c8ccbeb543908ad3$var$usePrevious = (value, ignore)=>{
    const ref = (0, $4hYjL.useRef)();
    (0, $4hYjL.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $c8ccbeb543908ad3$var$alwaysNewT(i18n, language, namespace, keyPrefix) {
    return i18n.getFixedT(language, namespace, keyPrefix);
}
function $c8ccbeb543908ad3$var$useMemoizedT(i18n, language, namespace, keyPrefix) {
    return (0, $4hYjL.useCallback)($c8ccbeb543908ad3$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
}
function $c8ccbeb543908ad3$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $4hYjL.useContext)((0, $34aff22e1f62742e$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $a02805681db0df87$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $34aff22e1f62742e$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $df587f91c7955b3e$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $df587f91c7955b3e$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $75bc3a370e3601a1$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $df587f91c7955b3e$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $c8ccbeb543908ad3$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$c8ccbeb543908ad3$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $4hYjL.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $c8ccbeb543908ad3$var$usePrevious(joinedNS);
    const isMounted = (0, $4hYjL.useRef)(true);
    (0, $4hYjL.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $df587f91c7955b3e$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $df587f91c7955b3e$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        function boundReset() {
            if (isMounted.current) setT(getNewT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $4hYjL.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $df587f91c7955b3e$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $df587f91c7955b3e$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $4hYjL = parcelRequire("4hYjL");


function $2f8141a701f93a88$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $4hYjL.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $df587f91c7955b3e$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $4hYjL.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $4hYjL.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $4d718dddc1b06a73$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $4hYjL = parcelRequire("4hYjL");

function $8fb7a1383ba9bd34$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $4hYjL.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $4hYjL.createElement)((0, $34aff22e1f62742e$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $4hYjL = parcelRequire("4hYjL");

var $4hYjL = parcelRequire("4hYjL");

function $724e9d1a53a5d853$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $4hYjL.useContext)((0, $34aff22e1f62742e$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $a02805681db0df87$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $de139bab0f4e4ace$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $724e9d1a53a5d853$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $4hYjL.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $34aff22e1f62742e$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $df587f91c7955b3e$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $9dd1c6272b6073f5$export$324d90190a8b822a = ()=>"";
const $9dd1c6272b6073f5$export$2da9be4cfdb689b1 = ()=>"";
const $9dd1c6272b6073f5$export$98e628dec113755e = ()=>"";
const $9dd1c6272b6073f5$export$2e6c959c16ff56b8 = ()=>"";
const $9dd1c6272b6073f5$export$4e35d5c922a95490 = ()=>"";
const $9dd1c6272b6073f5$export$720a3b9db04b7a0f = ()=>"";



parcelRequire("4hYjL");
function $9e2d1c1b5deac398$export$2e2bcd8739ae039(t, e) {
    return $9e2d1c1b5deac398$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9e2d1c1b5deac398$export$2e2bcd8739ae039(t, e);
}


function $d496dcfd2d93bfbb$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $9e2d1c1b5deac398$export$2e2bcd8739ae039)(t, o);
}



var $4hYjL = parcelRequire("4hYjL");
var $51fb7df7246ebd58$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $51fb7df7246ebd58$var$ReactIs, $51fb7df7246ebd58$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$51fb7df7246ebd58$exports = (parcelRequire("cNEZM"))();


function $9aa9154e5282885c$export$2e2bcd8739ae039() {
    return $9aa9154e5282885c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9aa9154e5282885c$export$2e2bcd8739ae039.apply(null, arguments);
}


function $fbf39efe0d641922$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $fbf39efe0d641922$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $fbf39efe0d641922$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $fbf39efe0d641922$var$isAbsolute(to);
    var isFromAbs = from && $fbf39efe0d641922$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $fbf39efe0d641922$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $fbf39efe0d641922$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $fbf39efe0d641922$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $fbf39efe0d641922$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$fbf39efe0d641922$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $fbf39efe0d641922$export$2e2bcd8739ae039 = $fbf39efe0d641922$var$resolvePathname;


function $e8a5edda4d527a52$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $e8a5edda4d527a52$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $e8a5edda4d527a52$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $e8a5edda4d527a52$var$valueOf(a);
        var bValue = $e8a5edda4d527a52$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $e8a5edda4d527a52$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $e8a5edda4d527a52$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $e8a5edda4d527a52$export$2e2bcd8739ae039 = $e8a5edda4d527a52$var$valueEqual;



var $2a24e0ee8550d7c8$var$isProduction = true;
var $2a24e0ee8550d7c8$var$prefix = "Invariant failed";
function $2a24e0ee8550d7c8$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($2a24e0ee8550d7c8$var$isProduction) throw new Error($2a24e0ee8550d7c8$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($2a24e0ee8550d7c8$var$prefix, ": ").concat(provided) : $2a24e0ee8550d7c8$var$prefix;
    throw new Error(value);
}


function $6b2807b622ac02a6$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $6b2807b622ac02a6$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $6b2807b622ac02a6$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $6b2807b622ac02a6$var$stripBasename(path, prefix) {
    return $6b2807b622ac02a6$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $6b2807b622ac02a6$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $6b2807b622ac02a6$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $6b2807b622ac02a6$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $6b2807b622ac02a6$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $6b2807b622ac02a6$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $fbf39efe0d641922$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $6b2807b622ac02a6$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $e8a5edda4d527a52$export$2e2bcd8739ae039)(a.state, b.state);
}
function $6b2807b622ac02a6$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $6b2807b622ac02a6$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $6b2807b622ac02a6$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $6b2807b622ac02a6$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $6b2807b622ac02a6$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $6b2807b622ac02a6$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $6b2807b622ac02a6$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $6b2807b622ac02a6$var$PopStateEvent = "popstate";
var $6b2807b622ac02a6$var$HashChangeEvent = "hashchange";
function $6b2807b622ac02a6$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $6b2807b622ac02a6$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$6b2807b622ac02a6$var$canUseDOM && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $6b2807b622ac02a6$var$supportsHistory();
    var needsHashChangeListener = !$6b2807b622ac02a6$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $6b2807b622ac02a6$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $6b2807b622ac02a6$var$stripTrailingSlash($6b2807b622ac02a6$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $6b2807b622ac02a6$var$stripBasename(path, basename);
        return $6b2807b622ac02a6$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $6b2807b622ac02a6$var$createTransitionManager();
    function setState(nextState) {
        (0, $9aa9154e5282885c$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($6b2807b622ac02a6$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($6b2807b622ac02a6$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($6b2807b622ac02a6$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $6b2807b622ac02a6$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $6b2807b622ac02a6$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $6b2807b622ac02a6$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($6b2807b622ac02a6$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($6b2807b622ac02a6$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($6b2807b622ac02a6$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($6b2807b622ac02a6$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $6b2807b622ac02a6$var$HashChangeEvent$1 = "hashchange";
var $6b2807b622ac02a6$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $6b2807b622ac02a6$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $6b2807b622ac02a6$var$stripLeadingSlash,
        decodePath: $6b2807b622ac02a6$var$addLeadingSlash
    },
    slash: {
        encodePath: $6b2807b622ac02a6$var$addLeadingSlash,
        decodePath: $6b2807b622ac02a6$var$addLeadingSlash
    }
};
function $6b2807b622ac02a6$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $6b2807b622ac02a6$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $6b2807b622ac02a6$var$pushHashPath(path) {
    window.location.hash = path;
}
function $6b2807b622ac02a6$var$replaceHashPath(path) {
    window.location.replace($6b2807b622ac02a6$var$stripHash(window.location.href) + "#" + path);
}
function $6b2807b622ac02a6$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$6b2807b622ac02a6$var$canUseDOM && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $6b2807b622ac02a6$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $6b2807b622ac02a6$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $6b2807b622ac02a6$var$stripTrailingSlash($6b2807b622ac02a6$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $6b2807b622ac02a6$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($6b2807b622ac02a6$var$getHashPath());
        if (basename) path = $6b2807b622ac02a6$var$stripBasename(path, basename);
        return $6b2807b622ac02a6$export$90c043f1c57770b8(path);
    }
    var transitionManager = $6b2807b622ac02a6$var$createTransitionManager();
    function setState(nextState) {
        (0, $9aa9154e5282885c$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $6b2807b622ac02a6$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $6b2807b622ac02a6$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $6b2807b622ac02a6$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($6b2807b622ac02a6$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($6b2807b622ac02a6$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $6b2807b622ac02a6$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $6b2807b622ac02a6$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $6b2807b622ac02a6$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $6b2807b622ac02a6$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $6b2807b622ac02a6$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $6b2807b622ac02a6$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $6b2807b622ac02a6$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $6b2807b622ac02a6$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $6b2807b622ac02a6$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($6b2807b622ac02a6$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $6b2807b622ac02a6$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $6b2807b622ac02a6$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $6b2807b622ac02a6$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $6b2807b622ac02a6$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($6b2807b622ac02a6$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($6b2807b622ac02a6$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($6b2807b622ac02a6$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $6b2807b622ac02a6$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $6b2807b622ac02a6$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $6b2807b622ac02a6$var$createTransitionManager();
    function setState(nextState) {
        (0, $9aa9154e5282885c$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $6b2807b622ac02a6$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $6b2807b622ac02a6$export$90c043f1c57770b8(entry, undefined, createKey()) : $6b2807b622ac02a6$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $6b2807b622ac02a6$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $6b2807b622ac02a6$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $6b2807b622ac02a6$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $6b2807b622ac02a6$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $56dbfb47e219760e$exports = {};
var $37c4ca3b3826494d$exports = {};
$37c4ca3b3826494d$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $56dbfb47e219760e$exports = $56dbfb47e219760e$var$pathToRegexp;
$56dbfb47e219760e$exports.parse = $56dbfb47e219760e$var$parse;
$56dbfb47e219760e$exports.compile = $56dbfb47e219760e$var$compile;
$56dbfb47e219760e$exports.tokensToFunction = $56dbfb47e219760e$var$tokensToFunction;
$56dbfb47e219760e$exports.tokensToRegExp = $56dbfb47e219760e$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $56dbfb47e219760e$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $56dbfb47e219760e$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $56dbfb47e219760e$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $56dbfb47e219760e$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $56dbfb47e219760e$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $56dbfb47e219760e$var$compile(str, options) {
    return $56dbfb47e219760e$var$tokensToFunction($56dbfb47e219760e$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $56dbfb47e219760e$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $56dbfb47e219760e$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $56dbfb47e219760e$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $56dbfb47e219760e$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $56dbfb47e219760e$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($37c4ca3b3826494d$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $56dbfb47e219760e$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $56dbfb47e219760e$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $56dbfb47e219760e$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $56dbfb47e219760e$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $56dbfb47e219760e$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $56dbfb47e219760e$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $56dbfb47e219760e$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $56dbfb47e219760e$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($56dbfb47e219760e$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $56dbfb47e219760e$var$flags(options));
    return $56dbfb47e219760e$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $56dbfb47e219760e$var$stringToRegexp(path, keys, options) {
    return $56dbfb47e219760e$var$tokensToRegExp($56dbfb47e219760e$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $56dbfb47e219760e$var$tokensToRegExp(tokens, keys, options) {
    if (!$37c4ca3b3826494d$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $56dbfb47e219760e$var$escapeString(token);
        else {
            var prefix = $56dbfb47e219760e$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $56dbfb47e219760e$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $56dbfb47e219760e$var$attachKeys(new RegExp("^" + route, $56dbfb47e219760e$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $56dbfb47e219760e$var$pathToRegexp(path, keys, options) {
    if (!$37c4ca3b3826494d$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $56dbfb47e219760e$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($37c4ca3b3826494d$exports(path)) return $56dbfb47e219760e$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $56dbfb47e219760e$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $fb64f7e650744890$exports = {};
"use strict";

$fb64f7e650744890$exports = (parcelRequire("1IBpg"));


function $2a4c238e6bea682b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}


var $d821d7836ef7c072$exports = {};
"use strict";
var $f945a9abbc82be56$exports = {};
"use strict";

$f945a9abbc82be56$exports = (parcelRequire("l1BPC"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $d821d7836ef7c072$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d821d7836ef7c072$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d821d7836ef7c072$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d821d7836ef7c072$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d821d7836ef7c072$var$TYPE_STATICS = {};
$d821d7836ef7c072$var$TYPE_STATICS[$f945a9abbc82be56$exports.ForwardRef] = $d821d7836ef7c072$var$FORWARD_REF_STATICS;
$d821d7836ef7c072$var$TYPE_STATICS[$f945a9abbc82be56$exports.Memo] = $d821d7836ef7c072$var$MEMO_STATICS;
function $d821d7836ef7c072$var$getStatics(component) {
    // React v16.11 and below
    if ($f945a9abbc82be56$exports.isMemo(component)) return $d821d7836ef7c072$var$MEMO_STATICS;
     // React v16.12 and above
    return $d821d7836ef7c072$var$TYPE_STATICS[component["$$typeof"]] || $d821d7836ef7c072$var$REACT_STATICS;
}
var $d821d7836ef7c072$var$defineProperty = Object.defineProperty;
var $d821d7836ef7c072$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d821d7836ef7c072$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d821d7836ef7c072$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d821d7836ef7c072$var$getPrototypeOf = Object.getPrototypeOf;
var $d821d7836ef7c072$var$objectPrototype = Object.prototype;
function $d821d7836ef7c072$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($d821d7836ef7c072$var$objectPrototype) {
            var inheritedComponent = $d821d7836ef7c072$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d821d7836ef7c072$var$objectPrototype) $d821d7836ef7c072$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $d821d7836ef7c072$var$getOwnPropertyNames(sourceComponent);
        if ($d821d7836ef7c072$var$getOwnPropertySymbols) keys = keys.concat($d821d7836ef7c072$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d821d7836ef7c072$var$getStatics(targetComponent);
        var sourceStatics = $d821d7836ef7c072$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d821d7836ef7c072$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d821d7836ef7c072$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $d821d7836ef7c072$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$d821d7836ef7c072$exports = $d821d7836ef7c072$var$hoistNonReactStatics;


var $87978d8bc0f45f32$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $87978d8bc0f45f32$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $87978d8bc0f45f32$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $87978d8bc0f45f32$var$commonjsGlobal[key] = ($87978d8bc0f45f32$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $87978d8bc0f45f32$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $87978d8bc0f45f32$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $87978d8bc0f45f32$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $87978d8bc0f45f32$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $87978d8bc0f45f32$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $87978d8bc0f45f32$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($87978d8bc0f45f32$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $87978d8bc0f45f32$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $87978d8bc0f45f32$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $87978d8bc0f45f32$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $87978d8bc0f45f32$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $87978d8bc0f45f32$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createContext || $87978d8bc0f45f32$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $87978d8bc0f45f32$var$createNamedContext = function createNamedContext(name) {
    var context = $87978d8bc0f45f32$var$createContext();
    context.displayName = name;
    return context;
};
var $87978d8bc0f45f32$export$c213558b66925821 = /*#__PURE__*/ $87978d8bc0f45f32$var$createNamedContext("Router-History");
var $87978d8bc0f45f32$export$63baa8ccbe60bb07 = /*#__PURE__*/ $87978d8bc0f45f32$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $87978d8bc0f45f32$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $87978d8bc0f45f32$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6b2807b622ac02a6$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
var $87978d8bc0f45f32$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $87978d8bc0f45f32$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $87978d8bc0f45f32$var$messageType;
var $87978d8bc0f45f32$var$cache = {};
var $87978d8bc0f45f32$var$cacheLimit = 10000;
var $87978d8bc0f45f32$var$cacheCount = 0;
function $87978d8bc0f45f32$var$compilePath(path) {
    if ($87978d8bc0f45f32$var$cache[path]) return $87978d8bc0f45f32$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($56dbfb47e219760e$exports))).compile(path);
    if ($87978d8bc0f45f32$var$cacheCount < $87978d8bc0f45f32$var$cacheLimit) {
        $87978d8bc0f45f32$var$cache[path] = generator;
        $87978d8bc0f45f32$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $87978d8bc0f45f32$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $87978d8bc0f45f32$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $87978d8bc0f45f32$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $6b2807b622ac02a6$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $87978d8bc0f45f32$export$82476f982757e71e(to, computedMatch.params) : (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, to, {
            pathname: $87978d8bc0f45f32$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $6b2807b622ac02a6$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $6b2807b622ac02a6$export$c3e8bb440bd55b18)(prevLocation, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $87978d8bc0f45f32$var$cache$1 = {};
var $87978d8bc0f45f32$var$cacheLimit$1 = 10000;
var $87978d8bc0f45f32$var$cacheCount$1 = 0;
function $87978d8bc0f45f32$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $87978d8bc0f45f32$var$cache$1[cacheKey] || ($87978d8bc0f45f32$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($56dbfb47e219760e$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($87978d8bc0f45f32$var$cacheCount$1 < $87978d8bc0f45f32$var$cacheLimit$1) {
        pathCache[path] = result;
        $87978d8bc0f45f32$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $87978d8bc0f45f32$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $87978d8bc0f45f32$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $87978d8bc0f45f32$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Children.count(children) === 0;
}
function $87978d8bc0f45f32$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $87978d8bc0f45f32$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $87978d8bc0f45f32$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $87978d8bc0f45f32$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
function $87978d8bc0f45f32$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $87978d8bc0f45f32$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, location, {
        pathname: $87978d8bc0f45f32$var$addLeadingSlash(basename) + location.pathname
    });
}
function $87978d8bc0f45f32$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $87978d8bc0f45f32$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $87978d8bc0f45f32$var$createURL(location) {
    return typeof location === "string" ? location : (0, $6b2807b622ac02a6$export$fe53371bee54353d)(location);
}
function $87978d8bc0f45f32$var$staticHandler(methodName) {
    return function() {
        (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
    };
}
function $87978d8bc0f45f32$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $87978d8bc0f45f32$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $87978d8bc0f45f32$var$noop;
        };
        _this.handleBlock = function() {
            return $87978d8bc0f45f32$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $87978d8bc0f45f32$var$addBasename(basename, (0, $6b2807b622ac02a6$export$90c043f1c57770b8)(location));
        context.url = $87978d8bc0f45f32$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $87978d8bc0f45f32$var$addLeadingSlash(basename + $87978d8bc0f45f32$var$createURL(path));
            },
            action: "POP",
            location: $87978d8bc0f45f32$var$stripBasename(basename, (0, $6b2807b622ac02a6$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $87978d8bc0f45f32$var$staticHandler("go"),
            goBack: $87978d8bc0f45f32$var$staticHandler("goBack"),
            goForward: $87978d8bc0f45f32$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$55185c17a0fcbe46, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $87978d8bc0f45f32$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $87978d8bc0f45f32$export$81336c211d5ff295(location.pathname, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $87978d8bc0f45f32$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($87978d8bc0f45f32$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(Component, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($d821d7836ef7c072$exports)))(C, Component);
}
var $87978d8bc0f45f32$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useContext;
function $87978d8bc0f45f32$export$3420e1dc2c4a518c() {
    return $87978d8bc0f45f32$var$useContext($87978d8bc0f45f32$export$c213558b66925821);
}
function $87978d8bc0f45f32$export$45d76561a5302f2b() {
    return $87978d8bc0f45f32$var$useContext($87978d8bc0f45f32$export$63baa8ccbe60bb07).location;
}
function $87978d8bc0f45f32$export$99eaa27ddbbb95ef() {
    var match = $87978d8bc0f45f32$var$useContext($87978d8bc0f45f32$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $87978d8bc0f45f32$export$632be4bb944c1bc7(path) {
    var location = $87978d8bc0f45f32$export$45d76561a5302f2b();
    var match = $87978d8bc0f45f32$var$useContext($87978d8bc0f45f32$export$63baa8ccbe60bb07).match;
    return path ? $87978d8bc0f45f32$export$81336c211d5ff295(location.pathname, path) : match;
}
var $87978d8bc0f45f32$var$global$1, $87978d8bc0f45f32$var$key, $87978d8bc0f45f32$var$buildNames, $87978d8bc0f45f32$var$initialBuildName, $87978d8bc0f45f32$var$secondaryBuildName;




var $4hYjL = parcelRequire("4hYjL");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $d224706ebc88e822$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6b2807b622ac02a6$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $87978d8bc0f45f32$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $d224706ebc88e822$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6b2807b622ac02a6$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $87978d8bc0f45f32$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
var $d224706ebc88e822$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $d224706ebc88e822$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $6b2807b622ac02a6$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $d224706ebc88e822$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $d224706ebc88e822$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).forwardRef;
if (typeof $d224706ebc88e822$var$forwardRef === "undefined") $d224706ebc88e822$var$forwardRef = $d224706ebc88e822$var$forwardRefShim;
function $d224706ebc88e822$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $d224706ebc88e822$var$LinkAnchor = $d224706ebc88e822$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$d224706ebc88e822$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($d224706ebc88e822$var$forwardRefShim !== $d224706ebc88e822$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $d224706ebc88e822$export$a6c7ac8248d6e38a = $d224706ebc88e822$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $d224706ebc88e822$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $87978d8bc0f45f32$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $d224706ebc88e822$var$normalizeToLocation($d224706ebc88e822$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $d224706ebc88e822$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $6b2807b622ac02a6$export$fe53371bee54353d)(context.location) === (0, $6b2807b622ac02a6$export$fe53371bee54353d)($d224706ebc88e822$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($d224706ebc88e822$var$forwardRefShim !== $d224706ebc88e822$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(component, props);
    });
});
var $d224706ebc88e822$var$toType, $d224706ebc88e822$var$refType;
var $d224706ebc88e822$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $d224706ebc88e822$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).forwardRef;
if (typeof $d224706ebc88e822$var$forwardRef$1 === "undefined") $d224706ebc88e822$var$forwardRef$1 = $d224706ebc88e822$var$forwardRefShim$1;
function $d224706ebc88e822$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $d224706ebc88e822$export$b0d92dbee9b5b60d = $d224706ebc88e822$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $87978d8bc0f45f32$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $2a24e0ee8550d7c8$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $d224706ebc88e822$var$normalizeToLocation($d224706ebc88e822$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $87978d8bc0f45f32$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $d224706ebc88e822$var$joinClassnames(className, activeClassName);
            style = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($d224706ebc88e822$var$forwardRefShim$1 !== $d224706ebc88e822$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($d224706ebc88e822$export$a6c7ac8248d6e38a, props);
    });
});
var $d224706ebc88e822$var$ariaCurrentType;



parcelRequire("4hYjL");


var $4hYjL = parcelRequire("4hYjL");


var $4hYjL = parcelRequire("4hYjL");
var $d20308ffb63674e6$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createContext(null);
var $d20308ffb63674e6$export$2e2bcd8739ae039 = $d20308ffb63674e6$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $7a3b39522f1438dd$var$defaultNoopBatch(callback) {
    callback();
}
var $7a3b39522f1438dd$var$batch = $7a3b39522f1438dd$var$defaultNoopBatch; // Allow injecting another batching function later
var $7a3b39522f1438dd$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $7a3b39522f1438dd$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $7a3b39522f1438dd$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $7a3b39522f1438dd$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $f18ea05bd571236f$var$createListenerCollection() {
    var batch = (0, $7a3b39522f1438dd$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f18ea05bd571236f$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $f18ea05bd571236f$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $f18ea05bd571236f$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f18ea05bd571236f$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $f18ea05bd571236f$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $4hYjL = parcelRequire("4hYjL");
var $2d34097b325a3a21$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $4hYjL.useLayoutEffect) : (0, $4hYjL.useEffect);


function $11340a39bad0d245$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $4hYjL.useMemo)(function() {
        var subscription = (0, $f18ea05bd571236f$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $4hYjL.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $2d34097b325a3a21$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $d20308ffb63674e6$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $11340a39bad0d245$export$2e2bcd8739ae039 = $11340a39bad0d245$var$Provider;






var $4hYjL = parcelRequire("4hYjL");
var $499c16b2cb426a93$exports = {};
"use strict";

$499c16b2cb426a93$exports = (parcelRequire("50VM8"));





var $efef9ef72e87350c$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $efef9ef72e87350c$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $efef9ef72e87350c$var$EMPTY_ARRAY = [];
var $efef9ef72e87350c$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $efef9ef72e87350c$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $efef9ef72e87350c$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $efef9ef72e87350c$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $2d34097b325a3a21$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $efef9ef72e87350c$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $efef9ef72e87350c$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $efef9ef72e87350c$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $efef9ef72e87350c$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $d20308ffb63674e6$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref2, $efef9ef72e87350c$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $4hYjL.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $4hYjL.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $efef9ef72e87350c$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $4hYjL.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $499c16b2cb426a93$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $4hYjL.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $4hYjL.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $4hYjL.useMemo)(function() {
                if (!shouldHandleStateChanges) return $efef9ef72e87350c$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $f18ea05bd571236f$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $4hYjL.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $4hYjL.useReducer)($efef9ef72e87350c$var$storeStateUpdatesReducer, $efef9ef72e87350c$var$EMPTY_ARRAY, $efef9ef72e87350c$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $4hYjL.useRef)();
            var lastWrapperProps = (0, $4hYjL.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $4hYjL.useRef)();
            var renderIsScheduled = (0, $4hYjL.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $efef9ef72e87350c$var$useIsomorphicLayoutEffectWithArgs($efef9ef72e87350c$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $efef9ef72e87350c$var$useIsomorphicLayoutEffectWithArgs($efef9ef72e87350c$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $4hYjL.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(WrappedComponent, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $4hYjL.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(Connect, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($d821d7836ef7c072$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($d821d7836ef7c072$exports)))(Connect, WrappedComponent);
    };
}






function $30e834445a5ce9a5$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $30e834445a5ce9a5$export$2e2bcd8739ae039(objA, objB) {
    if ($30e834445a5ce9a5$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$30e834445a5ce9a5$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $7fdbce4c206b7a36$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e215515c6bd993ca$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $11bb03d230ce388c$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $5f914d971efd8b02$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $e215515c6bd993ca$export$2e2bcd8739ae039)(value)) (0, $11bb03d230ce388c$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $15b243ecba6b38ad$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $15b243ecba6b38ad$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $15b243ecba6b38ad$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $15b243ecba6b38ad$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $15b243ecba6b38ad$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $2b7afd78e7d9e03e$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $15b243ecba6b38ad$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $2b7afd78e7d9e03e$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $15b243ecba6b38ad$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $2b7afd78e7d9e03e$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $15b243ecba6b38ad$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $7fdbce4c206b7a36$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $2b7afd78e7d9e03e$export$2e2bcd8739ae039 = [
    $2b7afd78e7d9e03e$export$a9f27b4b187c1166,
    $2b7afd78e7d9e03e$export$ba20d1a7aa0c4a90,
    $2b7afd78e7d9e03e$export$94a6e55709d4d961
];



function $9d1ca2cc0ba245d2$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $15b243ecba6b38ad$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $9d1ca2cc0ba245d2$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $15b243ecba6b38ad$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $9d1ca2cc0ba245d2$export$2e2bcd8739ae039 = [
    $9d1ca2cc0ba245d2$export$23fc470827b14aa,
    $9d1ca2cc0ba245d2$export$514bc8c1a53c1d66
];




function $fb173a3818ca6167$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $fb173a3818ca6167$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $fb173a3818ca6167$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $fb173a3818ca6167$export$5b105939c84b5234(mergeProps) : undefined;
}
function $fb173a3818ca6167$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $fb173a3818ca6167$export$691c327fc30bc857;
    } : undefined;
}
var $fb173a3818ca6167$export$2e2bcd8739ae039 = [
    $fb173a3818ca6167$export$d61b680184bc3f00,
    $fb173a3818ca6167$export$a13ba70ef50dda6d
];




function $aadf042cd955fef5$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $11bb03d230ce388c$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $aadf042cd955fef5$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $aadf042cd955fef5$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $aadf042cd955fef5$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $aadf042cd955fef5$var$verify(mergeProps, "mergeProps", displayName);
}


var $8ea029924c8cf819$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $8ea029924c8cf819$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $8ea029924c8cf819$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $8ea029924c8cf819$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref2, $8ea029924c8cf819$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $8ea029924c8cf819$export$d20c0c2ca6eb2b6f : $8ea029924c8cf819$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $de12548f24812a19$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $de12548f24812a19$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $de12548f24812a19$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $de12548f24812a19$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $efef9ef72e87350c$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $9d1ca2cc0ba245d2$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $2b7afd78e7d9e03e$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $fb173a3818ca6167$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $8ea029924c8cf819$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $de12548f24812a19$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $30e834445a5ce9a5$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $30e834445a5ce9a5$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $30e834445a5ce9a5$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref3, $de12548f24812a19$var$_excluded);
        var initMapStateToProps = $de12548f24812a19$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $de12548f24812a19$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $de12548f24812a19$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $de12548f24812a19$export$2e2bcd8739ae039 = /*#__PURE__*/ $de12548f24812a19$export$9f9feb656dec1fc4();




var $4hYjL = parcelRequire("4hYjL");


var $4hYjL = parcelRequire("4hYjL");

function $4fa722d4ae451647$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $4hYjL.useContext)((0, $d20308ffb63674e6$export$cc80c08dc91f1c00));
    return contextValue;
}


function $df4fc70880f8e243$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $d20308ffb63674e6$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $d20308ffb63674e6$export$cc80c08dc91f1c00) ? (0, $4fa722d4ae451647$export$c1275ca9a6fd3ec5) : function() {
        return (0, $4hYjL.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $df4fc70880f8e243$export$6ccbb43953eebf8 = /*#__PURE__*/ $df4fc70880f8e243$export$671dba69185d0304();


function $c2a3c9daa1d563b4$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $d20308ffb63674e6$export$cc80c08dc91f1c00);
    var useStore = context === (0, $d20308ffb63674e6$export$cc80c08dc91f1c00) ? (0, $df4fc70880f8e243$export$6ccbb43953eebf8) : (0, $df4fc70880f8e243$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $c2a3c9daa1d563b4$export$8ad76b76a4c905f8 = /*#__PURE__*/ $c2a3c9daa1d563b4$export$bc9b55530897c558();



var $4hYjL = parcelRequire("4hYjL");




var $91eac314bee8cc13$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $91eac314bee8cc13$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $4hYjL.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $4hYjL.useMemo)(function() {
        return (0, $f18ea05bd571236f$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $4hYjL.useRef)();
    var latestSelector = (0, $4hYjL.useRef)();
    var latestStoreState = (0, $4hYjL.useRef)();
    var latestSelectedState = (0, $4hYjL.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $2d34097b325a3a21$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $2d34097b325a3a21$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $91eac314bee8cc13$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $d20308ffb63674e6$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $d20308ffb63674e6$export$cc80c08dc91f1c00) ? (0, $4fa722d4ae451647$export$c1275ca9a6fd3ec5) : function() {
        return (0, $4hYjL.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $91eac314bee8cc13$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $91eac314bee8cc13$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $4hYjL.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $91eac314bee8cc13$export$2105062e25df4afe = /*#__PURE__*/ $91eac314bee8cc13$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ var $907ccff5bb941ac5$exports = {};
"use strict";
function $907ccff5bb941ac5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($907ccff5bb941ac5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$907ccff5bb941ac5$var$checkDCE();

$907ccff5bb941ac5$exports = (parcelRequire("87r5V"));





// with standard React renderers (ReactDOM, React Native)
(0, $7a3b39522f1438dd$export$4b9874722d0da7bc)((0, $907ccff5bb941ac5$exports.unstable_batchedUpdates));




var $4hYjL = parcelRequire("4hYjL");


var $b8351d862d7d7474$exports = {};

$b8351d862d7d7474$exports = (parcelRequire("fJICV"));


// ACTIONS
const $d599c499e9218b1e$var$USER_IS_LOGGED_IN = "USER_IS_LOGGED_IN";
const $d599c499e9218b1e$var$OKUSKOLI_DATA = "OKUSKOLI_DATA";
const $d599c499e9218b1e$var$STEP_ANSWER_FEEDBACK = "STEP_ANSWER_FEEDBACK";
const $d599c499e9218b1e$var$UPDATE_TEST_ANSWERS = "UPDATE_TEST_ANSWERS";
const $d599c499e9218b1e$var$UPDATE_TEST_DATA = "UPDATE_TEST_DATA";
const $d599c499e9218b1e$var$GET_FINAL_TEST_DATA = "GET_FINAL_TEST_DATA";
const $d599c499e9218b1e$var$UPDATE_FINAL_TEST_ANSWERS = "UPDATE_FINAL_TEST_ANSWERS";
const $d599c499e9218b1e$var$SHOW_ALERT = "SHOW_ALERT";
const $d599c499e9218b1e$var$ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
const $d599c499e9218b1e$var$UPDATE_STEP_ANSWER = "UPDATE_STEP_ANSWER";
const $d599c499e9218b1e$var$UPDATE_TEST_ANSWER = "UPDATE_TEST_ANSWER";
const $d599c499e9218b1e$var$UPDATE_FINAL_TEST_ANSWER = "UPDATE_FINAL_TEST_ANSWER";
const $d599c499e9218b1e$var$TOGGLE_DYSLEXIA_FONT = "TOGGLE_DYSLEXIA_FONT";
// State
const $d599c499e9218b1e$var$initialState = {
    authenticated: false,
    id: null,
    name: "",
    dyslexiaFont: false,
    userCourses: [],
    tests: [],
    // Timer
    showAlert: false,
    timerHours: 0,
    timerMinutes: 0,
    // Course times
    sinceFirstStart: {
        days: 1,
        hours: 0,
        minutes: 0,
        seconds: 0
    },
    sinceSecondStart: {
        days: 1,
        hours: 0,
        minutes: 0,
        seconds: 0
    },
    extraDaysFirst: 0,
    extraDaysSecond: 0,
    // Course data
    step: null,
    steps: [],
    round: [],
    roundId: null,
    roundNr: null,
    stepAnswers: [],
    test: [],
    testAnswers: [],
    userTest: {},
    wrongTestAnswers: null,
    finalTest: [],
    finalTestAnswers: [],
    nextRoundOpen: true,
    currentRound: 1,
    currentRoundStatus: "Not Started",
    currentStep: 1,
    messages: [],
    messageFeatureUsed: false,
    roundsFinished: false,
    userRounds: [],
    currentUserRounds: []
};
const $d599c499e9218b1e$export$1650419e431d3ba3 = (state = $d599c499e9218b1e$var$initialState, action)=>{
    switch(action.type){
        case $d599c499e9218b1e$var$SHOW_ALERT:
            return Object.assign({}, state, {
                showAlert: true,
                ...action.params
            });
        case $d599c499e9218b1e$var$USER_IS_LOGGED_IN:
            return Object.assign({}, state, {
                ...action.params
            });
        case $d599c499e9218b1e$var$OKUSKOLI_DATA:
            return Object.assign({}, state, {
                ...action.params
            });
        case $d599c499e9218b1e$var$GET_FINAL_TEST_DATA:
            return Object.assign({}, state, {
                finalTest: action.params.finalTest,
                userTest: action.params.userTest,
                finalTestAnswers: [],
                wrongTestAnswers: null
            });
        case $d599c499e9218b1e$var$UPDATE_TEST_DATA:
            return Object.assign({}, state, {
                test: action.params.test,
                userTest: action.params.userTest,
                testAnswers: [],
                wrongTestAnswers: null
            });
        case $d599c499e9218b1e$var$UPDATE_FINAL_TEST_ANSWER:
            const { ftestAnswerId: ftestAnswerId, ftestQuestionId: ftestQuestionId, ftestChecked: ftestChecked } = action.params;
            let ftestAlreadyAnswered = false;
            state.finalTestAnswers.forEach((answer, i)=>{
                if (answer.questionId == ftestQuestionId && answer.answerId == ftestAnswerId) {
                    ftestAlreadyAnswered = true;
                    if (ftestChecked === false) state.finalTestAnswers.splice(i, 1);
                }
            });
            if (ftestAlreadyAnswered === false) state.finalTestAnswers.push({
                questionId: ftestQuestionId,
                answerId: ftestAnswerId
            });
            return {
                ...state
            };
        case $d599c499e9218b1e$var$UPDATE_TEST_ANSWER:
            const { testAnswerId: testAnswerId, testQuestionId: testQuestionId, testId: testId, testChecked: testChecked } = action.params;
            const testImageId = testId === "" ? null : testId;
            let testAlreadyAnswered = false;
            state.testAnswers.forEach((answer, i)=>{
                if (answer.questionId == testQuestionId && answer.answerId == testAnswerId) {
                    testAlreadyAnswered = true;
                    if (testChecked === false) state.testAnswers.splice(i, 1);
                }
            });
            if (testAlreadyAnswered === false) state.testAnswers.push({
                questionId: testQuestionId,
                answerId: testAnswerId,
                imageId: testImageId
            });
            return {
                ...state
            };
        case $d599c499e9218b1e$var$UPDATE_STEP_ANSWER:
            const { answerId: answerId, questionId: questionId, id: id, checked: checked } = action.params;
            const imageId = id === "" ? null : id;
            let alreadyAnswered = false;
            state.stepAnswers.forEach((answer, i)=>{
                if (answer.questionId === questionId && answer.answerId === answerId) {
                    alreadyAnswered = true;
                    if (checked === false) state.stepAnswers.splice(i, 1);
                }
            });
            if (!alreadyAnswered) state.stepAnswers.push({
                questionId: questionId,
                answerId: answerId,
                imageId: imageId
            });
            return {
                ...state
            };
        case $d599c499e9218b1e$var$STEP_ANSWER_FEEDBACK:
            let stepIndex = 0;
            state.steps.forEach((step, index)=>{
                if (step.id === action.params.stepId) stepIndex = index;
            });
            const newState = {
                ...state
            };
            newState.steps[stepIndex].step_questions[0].user_step_answers = action.params.answers;
            newState.steps[stepIndex].user_course_round_steps[0].status = "Finished";
            newState.steps[stepIndex].status = "Finished";
            newState.stepAnswers = []; // clears step answer.
            return newState;
        case $d599c499e9218b1e$var$UPDATE_TEST_ANSWERS:
            const { answers: answers, roundNr: roundNr, wrongAnswers: wrongAnswers, roundFinished: roundFinished } = action.params;
            const newNewState = {
                ...state
            };
            newNewState.userRounds.forEach((round)=>{
                if (round.nr === parseInt(roundNr) && roundFinished === true) round.status = "Finished";
            });
            newNewState.test[0].questions.forEach((question)=>{
                question.answers.forEach((answer)=>{
                    answers.forEach((testAnswer)=>{
                        if (answer.id === testAnswer.answer_id) answer.correct = testAnswer.correct;
                    });
                });
            });
            newNewState.userTest.status = "Finished";
            newNewState.wrongTestAnswers = wrongAnswers;
            return newNewState;
        case $d599c499e9218b1e$var$UPDATE_FINAL_TEST_ANSWERS:
            const fAnswers = action.params.answers;
            const fWrongAnswers = action.params.wrongAnswers;
            const fState = {
                ...state
            };
            fState.finalTest[0].questions.forEach((question)=>{
                question.answers.forEach((answer)=>{
                    fAnswers.forEach((testAnswer)=>{
                        if (answer.id === testAnswer.answer_id) answer.correct = testAnswer.correct;
                    });
                });
            });
            fState.userTest.status = "Finished";
            fState.wrongTestAnswers = fWrongAnswers;
            return fState;
        case $d599c499e9218b1e$var$ADD_NEW_MESSAGE:
            const messageState = {
                ...state
            };
            messageState.messages.push({
                ...action.params
            });
            messageState.messageFeatureUsed = true;
            return messageState;
        case $d599c499e9218b1e$var$TOGGLE_DYSLEXIA_FONT:
            const dyslexiaState = {
                ...state
            };
            dyslexiaState.dyslexiaFont = !state.dyslexiaFont;
            return dyslexiaState;
        default:
            return state;
    }
};
const $d599c499e9218b1e$export$de676d0b1df680f0 = (params)=>({
        type: $d599c499e9218b1e$var$USER_IS_LOGGED_IN,
        params: params
    });
const $d599c499e9218b1e$export$5ed101c55fc6dd45 = (params)=>({
        type: $d599c499e9218b1e$var$OKUSKOLI_DATA,
        params: params
    });
const $d599c499e9218b1e$export$7c7f0a18499ed7a = (params)=>({
        type: $d599c499e9218b1e$var$STEP_ANSWER_FEEDBACK,
        params: params
    });
const $d599c499e9218b1e$export$452251d610794bde = (params)=>({
        type: $d599c499e9218b1e$var$UPDATE_TEST_ANSWERS,
        params: params
    });
const $d599c499e9218b1e$export$ec90248895f5633c = (params)=>({
        type: $d599c499e9218b1e$var$UPDATE_TEST_DATA,
        params: params
    });
const $d599c499e9218b1e$export$449c4f626b590da7 = (params)=>({
        type: $d599c499e9218b1e$var$GET_FINAL_TEST_DATA,
        params: params
    });
const $d599c499e9218b1e$export$e435712bd7e75690 = (params)=>({
        type: $d599c499e9218b1e$var$UPDATE_FINAL_TEST_ANSWERS,
        params: params
    });
const $d599c499e9218b1e$export$de026b00723010c1 = (params)=>({
        type: $d599c499e9218b1e$var$SHOW_ALERT,
        params: params
    });
const $d599c499e9218b1e$export$691a31800a3cc1d0 = (params)=>({
        type: $d599c499e9218b1e$var$ADD_NEW_MESSAGE,
        params: params
    });
const $d599c499e9218b1e$export$6ccc133bc14293ea = (params)=>({
        type: $d599c499e9218b1e$var$UPDATE_STEP_ANSWER,
        params: params
    });
const $d599c499e9218b1e$export$ddd53d3c42320cfc = (params)=>({
        type: $d599c499e9218b1e$var$UPDATE_TEST_ANSWER,
        params: params
    });
const $d599c499e9218b1e$export$98e618dfde36167e = (params)=>({
        type: $d599c499e9218b1e$var$UPDATE_FINAL_TEST_ANSWER,
        params: params
    });
const $d599c499e9218b1e$export$1dc5715de4bfa348 = ()=>({
        type: $d599c499e9218b1e$var$TOGGLE_DYSLEXIA_FONT
    });


const $770b1730f1743b99$export$61bb00ddedae72e4 = async ()=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get("/api/is-logged-in");
        return res.data;
    } catch (error) {
        console.error({
            error: error
        });
        return false;
    }
};
// This component is mounted when
// The redux state says the user is unauthenticated but is trying to access a protected route.
// The component sends a request to the back end to double check if the user is actually unauthenticated.
// If unauthenticated, redirect him to the login page. If authenticated, user can continue on his merry way.
class $770b1730f1743b99$var$AuthBeforeRender extends (0, $4hYjL.Component) {
    constructor(props){
        super(props);
        this.state = {
            loading: true
        };
    }
    componentDidMount() {
        const { dispatch: dispatch } = this.props;
        $770b1730f1743b99$export$61bb00ddedae72e4().then((data)=>{
            dispatch((0, $d599c499e9218b1e$export$de676d0b1df680f0)({
                ...data
            }));
            this.setState({
                loading: false
            });
        });
    }
    render() {
        const { authenticated: authenticated } = this.props.authReducer;
        if (this.state.loading) return null;
        else return authenticated ? this.props.render() : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$2d8d895a0a0f636e), {
            to: {
                pathname: "/innskraning"
            }
        });
    }
}
const $770b1730f1743b99$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $770b1730f1743b99$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($770b1730f1743b99$var$mapStateToProps)($770b1730f1743b99$var$AuthBeforeRender);


const $08be177d729af471$export$77480bcbce7650ac = (props)=>{
    const { component: component, exact: exact, path: path } = props;
    const Component = component;
    const { authenticated: authenticated } = props.authReducer;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
        exact: exact,
        path: path,
        render: (props)=>authenticated ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(Component, {
                ...props
            }) : // If they're not authenticated according to current state
            // Check with the server before denying access - only then we can either redirect them or render the component.
            // See this Stack Overflow for more info: https://tinyurl.com/yxug6lgn
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $770b1730f1743b99$export$2e2bcd8739ae039), {
                render: ()=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(Component, {
                        ...props
                    })
            })
    });
};
const $08be177d729af471$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $08be177d729af471$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($08be177d729af471$var$mapStateToProps)($08be177d729af471$export$77480bcbce7650ac);



var $4hYjL = parcelRequire("4hYjL");

const $4c7626e6bbaa4aa5$var$ScrollToTop = ({ history: history })=>{
    (0, $4hYjL.useEffect)(()=>{
        const unlisten = history.listen(()=>{
            window.scrollTo(0, 0);
        });
        return ()=>{
            unlisten();
        };
    }, []);
    return null;
};
var $4c7626e6bbaa4aa5$export$2e2bcd8739ae039 = (0, $87978d8bc0f45f32$export$369b6b2b30582e8e)($4c7626e6bbaa4aa5$var$ScrollToTop);



const $d7df78052a791524$export$da3bc2f57520e3c3 = {
    is: {
        FrontPage: "/",
        Okuskoli1: "/okuskoli1",
        Okuskoli2: "/okuskoli2",
        Login: "/innskraning",
        LoginError: "/innskranings-villa",
        Registration: "/nyskraning",
        DrivingInstructors: "/okukennarar",
        AboutUs: "/um-okkur",
        ForgotPassword: "/gleymt-lykilor\xf0",
        ResetPassword: "/n\xfdtt-lykilor\xf0/:token",
        TermsAndConditions: "/skilmalar",
        BlogCostOfLicense: "/blogg/hvad-kostar-bilprof",
        BlogHowToGetLicense: "/blogg/hvernig-faer-madur-bilprof",
        Unions: "/blogg/hvernig-faer-madur-odyrt-bilprof",
        // Inside the app
        Settings: "/stillingar"
    },
    en: {
        FrontPage: "/en",
        Okuskoli1: "/driving-school-1",
        Okuskoli2: "/driving-school-2",
        Login: "/login",
        LoginError: "/login-error",
        Registration: "/registration",
        DrivingInstructors: "/driving-instructor",
        AboutUs: "/about-us",
        ForgotPassword: "/forgot-password",
        ResetPassword: "/reset-password/:token",
        TermsAndConditions: "/terms-and-conditions",
        BlogCostOfLicense: "/blog/how-much-does-it-cost-to-get-a-drivers-license-in-Iceland",
        BlogHowToGetLicense: "/blog/how-to-get-a-drivers-license-in-Iceland",
        Unions: "/blog/how-to-get-a-cheap-drivers-license-in-Iceland",
        // Inside the app
        Settings: "/settings"
    }
};
const $d7df78052a791524$export$1dedd60e7a4a716e = ({ path: path, pathLang: pathLang })=>{
    const targetObject = $d7df78052a791524$export$da3bc2f57520e3c3[pathLang];
    // Remove trailing slash if present
    let pathWithoutSlash = path;
    if (path.length > 1 && pathWithoutSlash.charAt(path.length - 1) == "/") pathWithoutSlash = pathWithoutSlash.slice(0, -1);
    // Find "Page" key from value.
    const page = Object.keys(targetObject).find((key)=>targetObject[key] === pathWithoutSlash);
    return page;
};
const $d7df78052a791524$export$2aa3fd96c49a84a8 = ({ page: page, lang: lang })=>{
    return $d7df78052a791524$export$da3bc2f57520e3c3[lang][page];
};



const $3a97a5b6f2ede16a$export$98373bb8fca66b98 = ()=>{
    const { i18n: i18n } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const lang = i18n.language || window.localStorage.language;
    return lang;
};



parcelRequire("4hYjL");


var $91989af38244ad4e$exports = {};
"use strict";
function $91989af38244ad4e$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $4hYjL = parcelRequire("4hYjL");
var $91989af38244ad4e$var$React__default = $91989af38244ad4e$var$_interopDefault($4hYjL);
function $91989af38244ad4e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $91989af38244ad4e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $91989af38244ad4e$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $91989af38244ad4e$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $91989af38244ad4e$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $91989af38244ad4e$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($4hYjL.PureComponent);
        $91989af38244ad4e$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $91989af38244ad4e$var$_defineProperty(SideEffect, "canUseDOM", $91989af38244ad4e$var$canUseDOM);
        return SideEffect;
    };
}
$91989af38244ad4e$exports = $91989af38244ad4e$var$withSideEffect;


var $28c1cf8b47cf1aed$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $28c1cf8b47cf1aed$var$hasElementType = typeof Element !== "undefined";
var $28c1cf8b47cf1aed$var$hasMap = typeof Map === "function";
var $28c1cf8b47cf1aed$var$hasSet = typeof Set === "function";
var $28c1cf8b47cf1aed$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $28c1cf8b47cf1aed$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$28c1cf8b47cf1aed$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($28c1cf8b47cf1aed$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$28c1cf8b47cf1aed$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($28c1cf8b47cf1aed$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($28c1cf8b47cf1aed$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($28c1cf8b47cf1aed$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$28c1cf8b47cf1aed$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$28c1cf8b47cf1aed$exports = function isEqual(a, b) {
    try {
        return $28c1cf8b47cf1aed$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $4hYjL = parcelRequire("4hYjL");
var $f41e5809079df237$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $f41e5809079df237$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f41e5809079df237$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f41e5809079df237$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $f41e5809079df237$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $f41e5809079df237$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$f41e5809079df237$exports = $f41e5809079df237$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $f41e5809079df237$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($f41e5809079df237$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($f41e5809079df237$var$getOwnPropertySymbols) {
            symbols = $f41e5809079df237$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($f41e5809079df237$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $5e0021919929c8b4$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $5e0021919929c8b4$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $5e0021919929c8b4$var$VALID_TAG_NAMES = Object.keys($5e0021919929c8b4$var$TAG_NAMES).map(function(name) {
    return $5e0021919929c8b4$var$TAG_NAMES[name];
});
var $5e0021919929c8b4$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $5e0021919929c8b4$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $5e0021919929c8b4$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $5e0021919929c8b4$var$HTML_TAG_MAP = Object.keys($5e0021919929c8b4$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$5e0021919929c8b4$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $5e0021919929c8b4$var$SELF_CLOSING_TAGS = [
    $5e0021919929c8b4$var$TAG_NAMES.NOSCRIPT,
    $5e0021919929c8b4$var$TAG_NAMES.SCRIPT,
    $5e0021919929c8b4$var$TAG_NAMES.STYLE
];
var $5e0021919929c8b4$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $5e0021919929c8b4$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5e0021919929c8b4$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $5e0021919929c8b4$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $5e0021919929c8b4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5e0021919929c8b4$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $5e0021919929c8b4$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $5e0021919929c8b4$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $5e0021919929c8b4$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $5e0021919929c8b4$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $5e0021919929c8b4$var$getInnermostProperty(propsList, $5e0021919929c8b4$var$TAG_NAMES.TITLE);
    var innermostTemplate = $5e0021919929c8b4$var$getInnermostProperty(propsList, $5e0021919929c8b4$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $5e0021919929c8b4$var$getInnermostProperty(propsList, $5e0021919929c8b4$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $5e0021919929c8b4$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $5e0021919929c8b4$var$getInnermostProperty(propsList, $5e0021919929c8b4$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $5e0021919929c8b4$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $5e0021919929c8b4$var$_extends({}, tagAttrs, current);
    }, {});
};
var $5e0021919929c8b4$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$5e0021919929c8b4$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$5e0021919929c8b4$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $5e0021919929c8b4$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $5e0021919929c8b4$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $5e0021919929c8b4$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $5e0021919929c8b4$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $5e0021919929c8b4$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $5e0021919929c8b4$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $5e0021919929c8b4$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $5e0021919929c8b4$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($f41e5809079df237$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $5e0021919929c8b4$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $5e0021919929c8b4$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $5e0021919929c8b4$var$getBaseTagFromPropsList([
            $5e0021919929c8b4$var$TAG_PROPERTIES.HREF,
            $5e0021919929c8b4$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $5e0021919929c8b4$var$getAttributesFromPropsList($5e0021919929c8b4$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $5e0021919929c8b4$var$getInnermostProperty(propsList, $5e0021919929c8b4$var$HELMET_PROPS.DEFER),
        encode: $5e0021919929c8b4$var$getInnermostProperty(propsList, $5e0021919929c8b4$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $5e0021919929c8b4$var$getAttributesFromPropsList($5e0021919929c8b4$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $5e0021919929c8b4$var$getTagsFromPropsList($5e0021919929c8b4$var$TAG_NAMES.LINK, [
            $5e0021919929c8b4$var$TAG_PROPERTIES.REL,
            $5e0021919929c8b4$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $5e0021919929c8b4$var$getTagsFromPropsList($5e0021919929c8b4$var$TAG_NAMES.META, [
            $5e0021919929c8b4$var$TAG_PROPERTIES.NAME,
            $5e0021919929c8b4$var$TAG_PROPERTIES.CHARSET,
            $5e0021919929c8b4$var$TAG_PROPERTIES.HTTPEQUIV,
            $5e0021919929c8b4$var$TAG_PROPERTIES.PROPERTY,
            $5e0021919929c8b4$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $5e0021919929c8b4$var$getTagsFromPropsList($5e0021919929c8b4$var$TAG_NAMES.NOSCRIPT, [
            $5e0021919929c8b4$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $5e0021919929c8b4$var$getOnChangeClientState(propsList),
        scriptTags: $5e0021919929c8b4$var$getTagsFromPropsList($5e0021919929c8b4$var$TAG_NAMES.SCRIPT, [
            $5e0021919929c8b4$var$TAG_PROPERTIES.SRC,
            $5e0021919929c8b4$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $5e0021919929c8b4$var$getTagsFromPropsList($5e0021919929c8b4$var$TAG_NAMES.STYLE, [
            $5e0021919929c8b4$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $5e0021919929c8b4$var$getTitleFromPropsList(propsList),
        titleAttributes: $5e0021919929c8b4$var$getAttributesFromPropsList($5e0021919929c8b4$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $5e0021919929c8b4$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $5e0021919929c8b4$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $5e0021919929c8b4$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $5e0021919929c8b4$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $5e0021919929c8b4$var$rafPolyfill : $parcel$global.requestAnimationFrame || $5e0021919929c8b4$var$rafPolyfill;
var $5e0021919929c8b4$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $5e0021919929c8b4$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $5e0021919929c8b4$var$cafPolyfill;
var $5e0021919929c8b4$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $5e0021919929c8b4$var$_helmetCallback = null;
var $5e0021919929c8b4$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($5e0021919929c8b4$var$_helmetCallback) $5e0021919929c8b4$var$cancelAnimationFrame($5e0021919929c8b4$var$_helmetCallback);
    if (newState.defer) $5e0021919929c8b4$var$_helmetCallback = $5e0021919929c8b4$var$requestAnimationFrame(function() {
        $5e0021919929c8b4$var$commitTagChanges(newState, function() {
            $5e0021919929c8b4$var$_helmetCallback = null;
        });
    });
    else {
        $5e0021919929c8b4$var$commitTagChanges(newState);
        $5e0021919929c8b4$var$_helmetCallback = null;
    }
};
var $5e0021919929c8b4$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $5e0021919929c8b4$var$updateAttributes($5e0021919929c8b4$var$TAG_NAMES.BODY, bodyAttributes);
    $5e0021919929c8b4$var$updateAttributes($5e0021919929c8b4$var$TAG_NAMES.HTML, htmlAttributes);
    $5e0021919929c8b4$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $5e0021919929c8b4$var$updateTags($5e0021919929c8b4$var$TAG_NAMES.BASE, baseTag),
        linkTags: $5e0021919929c8b4$var$updateTags($5e0021919929c8b4$var$TAG_NAMES.LINK, linkTags),
        metaTags: $5e0021919929c8b4$var$updateTags($5e0021919929c8b4$var$TAG_NAMES.META, metaTags),
        noscriptTags: $5e0021919929c8b4$var$updateTags($5e0021919929c8b4$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $5e0021919929c8b4$var$updateTags($5e0021919929c8b4$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $5e0021919929c8b4$var$updateTags($5e0021919929c8b4$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $5e0021919929c8b4$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $5e0021919929c8b4$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $5e0021919929c8b4$var$flattenArray(title);
    $5e0021919929c8b4$var$updateAttributes($5e0021919929c8b4$var$TAG_NAMES.TITLE, attributes);
};
var $5e0021919929c8b4$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($5e0021919929c8b4$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($5e0021919929c8b4$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($5e0021919929c8b4$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($5e0021919929c8b4$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $5e0021919929c8b4$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($5e0021919929c8b4$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $5e0021919929c8b4$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $5e0021919929c8b4$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $5e0021919929c8b4$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($5e0021919929c8b4$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $5e0021919929c8b4$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $5e0021919929c8b4$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $5e0021919929c8b4$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $5e0021919929c8b4$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $5e0021919929c8b4$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $5e0021919929c8b4$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $5e0021919929c8b4$var$HELMET_ATTRIBUTE + '="true">' + $5e0021919929c8b4$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $5e0021919929c8b4$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $5e0021919929c8b4$var$TAG_PROPERTIES.INNER_HTML || attribute === $5e0021919929c8b4$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $5e0021919929c8b4$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $5e0021919929c8b4$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $5e0021919929c8b4$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $5e0021919929c8b4$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$5e0021919929c8b4$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $5e0021919929c8b4$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$5e0021919929c8b4$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $5e0021919929c8b4$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$5e0021919929c8b4$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $5e0021919929c8b4$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement($5e0021919929c8b4$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $5e0021919929c8b4$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$5e0021919929c8b4$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $5e0021919929c8b4$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $5e0021919929c8b4$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $5e0021919929c8b4$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(type, mappedTag);
    });
};
var $5e0021919929c8b4$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $5e0021919929c8b4$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $5e0021919929c8b4$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $5e0021919929c8b4$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $5e0021919929c8b4$var$ATTRIBUTE_NAMES.BODY:
        case $5e0021919929c8b4$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $5e0021919929c8b4$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $5e0021919929c8b4$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $5e0021919929c8b4$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $5e0021919929c8b4$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $5e0021919929c8b4$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.META, metaTags, encode),
        noscript: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $5e0021919929c8b4$var$getMethodsForTag($5e0021919929c8b4$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $5e0021919929c8b4$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $5e0021919929c8b4$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $5e0021919929c8b4$var$classCallCheck(this, HelmetWrapper);
            return $5e0021919929c8b4$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($28c1cf8b47cf1aed$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $5e0021919929c8b4$var$TAG_NAMES.SCRIPT:
                case $5e0021919929c8b4$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $5e0021919929c8b4$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $5e0021919929c8b4$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $5e0021919929c8b4$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $5e0021919929c8b4$var$TAG_NAMES.TITLE:
                    return $5e0021919929c8b4$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $5e0021919929c8b4$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $5e0021919929c8b4$var$TAG_NAMES.BODY:
                    return $5e0021919929c8b4$var$_extends({}, newProps, {
                        bodyAttributes: $5e0021919929c8b4$var$_extends({}, newChildProps)
                    });
                case $5e0021919929c8b4$var$TAG_NAMES.HTML:
                    return $5e0021919929c8b4$var$_extends({}, newProps, {
                        htmlAttributes: $5e0021919929c8b4$var$_extends({}, newChildProps)
                    });
            }
            return $5e0021919929c8b4$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $5e0021919929c8b4$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $5e0021919929c8b4$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $5e0021919929c8b4$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $5e0021919929c8b4$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $5e0021919929c8b4$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $5e0021919929c8b4$var$TAG_NAMES.LINK:
                    case $5e0021919929c8b4$var$TAG_NAMES.META:
                    case $5e0021919929c8b4$var$TAG_NAMES.NOSCRIPT:
                    case $5e0021919929c8b4$var$TAG_NAMES.SCRIPT:
                    case $5e0021919929c8b4$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $5e0021919929c8b4$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $5e0021919929c8b4$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(Component, newProps);
        };
        $5e0021919929c8b4$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($51fb7df7246ebd58$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $5e0021919929c8b4$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $5e0021919929c8b4$var$NullComponent = function NullComponent() {
    return null;
};
var $5e0021919929c8b4$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($91989af38244ad4e$exports)))($5e0021919929c8b4$var$reducePropsToState, $5e0021919929c8b4$var$handleClientStateChange, $5e0021919929c8b4$var$mapStateOnServer)($5e0021919929c8b4$var$NullComponent);
var $5e0021919929c8b4$export$dcef8f9bb9a41431 = $5e0021919929c8b4$var$Helmet($5e0021919929c8b4$var$HelmetSideEffects);
$5e0021919929c8b4$export$dcef8f9bb9a41431.renderStatic = $5e0021919929c8b4$export$dcef8f9bb9a41431.rewind;
var $5e0021919929c8b4$export$2e2bcd8739ae039 = $5e0021919929c8b4$export$dcef8f9bb9a41431;


parcelRequire("4hYjL");
// TODO: Make "Urðarbrunnur ökuskóli" change with the language
// TODO: Make The keywords and site name change with the language
const $e814f84530fe6172$var$Helmet = ({ pageTitle: pageTitle, keywords: keywords, image: image })=>{
    const title = `${pageTitle} | Urðarbrunnur | Ökuskóli 1 og 2`;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $5e0021919929c8b4$export$dcef8f9bb9a41431), {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                name: "description",
                content: title
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                name: "keywords",
                content: keywords ? keywords : "\xd6kusk\xf3li, \xf6kusk\xf3li 1, \xf6kusk\xf3li 2, b\xedlpr\xf3f \xe1 netinu, net\xf6kusk\xf3li, \xd6kusk\xf3li \xe1 netinu"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                property: "og:url",
                content: window.location.href
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                property: "og:image",
                content: image ? image : "http://urdarbrunnur.is/images/icon-logo.gif"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                property: "og:site_name",
                content: "Ur\xf0arbrunnur — \xd6kusk\xf3li 1 og 2"
            })
        ]
    });
};
var $e814f84530fe6172$export$2e2bcd8739ae039 = $e814f84530fe6172$var$Helmet;





parcelRequire("4hYjL");



parcelRequire("4hYjL");





const $e80d636e54631bbe$export$150b732325d14d04 = {
    is: {
        LangToggle: {
            "Change language to English": "Change language to English"
        }
    },
    en: {
        LangToggle: {
            "Change language to English": "Breyta tungum\xe1li \xed \xcdslensku"
        }
    }
};
const $e80d636e54631bbe$var$LangToggle = ({ onlyShowFlag: onlyShowFlag = true })=>{
    const { i18n: i18n, t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const location = (0, $87978d8bc0f45f32$export$45d76561a5302f2b)();
    const history = (0, $87978d8bc0f45f32$export$3420e1dc2c4a518c)();
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    const changeLanguage = ()=>{
        const newLang = lang === "en" ? "is" : "en";
        const page = (0, $d7df78052a791524$export$1dedd60e7a4a716e)({
            path: location.pathname,
            pathLang: lang
        });
        const newPath = (0, $d7df78052a791524$export$2aa3fd96c49a84a8)({
            page: page,
            lang: newLang
        });
        i18n.changeLanguage(newLang);
        localStorage.setItem("language", newLang);
        history.push(newPath);
        // Update the backend.
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/user-information", {
            field: "language",
            value: newLang
        });
        changeLanguageInHtmlTag(newLang);
    };
    const changeLanguageInHtmlTag = (lang)=>{
        const html = document.querySelector("html");
        html?.setAttribute("lang", lang);
    };
    const showCorrectFlag = ()=>{
        const en = "/images/united-kingdom-flag-icon.webp";
        const is = "/images/iceland-flag-icon.webp";
        return lang === "is" ? en : is;
    };
    const showCorrectAltText = ()=>{
        return lang === "is" ? "Flag of United Kingdom" : "\xcdslenski f\xe1ninn";
    };
    const correctFlag = showCorrectFlag();
    const altText = showCorrectAltText();
    if (onlyShowFlag) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
            style: {
                marginTop: "2px",
                cursor: "pointer"
            },
            width: "32px",
            height: "22px",
            role: "button",
            "data-cy": "toggle-lang",
            tabIndex: 0,
            onClick: changeLanguage,
            onKeyDown: (e)=>{
                e.key === "Enter" && changeLanguage();
            },
            src: correctFlag,
            alt: altText
        })
    });
    else return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("a", {
        style: {
            cursor: "pointer",
            fontSize: "18px"
        },
        onClick: changeLanguage,
        onKeyDown: (e)=>{
            e.key === "Enter" && changeLanguage();
        },
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                style: {
                    position: "relative",
                    top: "5px",
                    marginRight: "3px"
                },
                width: "32px",
                role: "button",
                "data-cy": "toggle-lang",
                tabIndex: 0,
                src: correctFlag
            }),
            t("LangToggle.Change language to English")
        ]
    });
};
var $e80d636e54631bbe$export$2e2bcd8739ae039 = $e80d636e54631bbe$var$LangToggle;




parcelRequire("4hYjL");

// Types of buttons:
// 1. react-router Links
// 2. <a></a> tags
// 3. onClick
const $6e454233c3ce9437$var$Button = ({ href: href, type: type, className: className, size: size, children: children, onClick: onClick, disabled: disabled = false })=>{
    // If no button size is specified, default to big.
    let sizeClassName = "";
    if (!size) sizeClassName = "btn-big";
    else sizeClassName = `btn-${size}`;
    // Return react-router-dom link.
    if (type === "react-router-link" && href !== undefined) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
        to: href,
        id: "btn-component",
        className: `${className} ${sizeClassName}`,
        children: children
    });
    if (type === "link") return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
        href: href,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            id: "btn-component",
            className: `${className} ${sizeClassName}`,
            children: children
        })
    });
    if (type === "onClick") {
        if (onClick === undefined) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
            children: "Pass in onClick"
        });
        const disabledClass = disabled ? "disabled-btn" : "";
        // Don't allow onClick events if button is disabled
        const buttonOnClick = !disabled ? onClick : undefined;
        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            "aria-disabled": disabled,
            id: "btn-component",
            onClick: buttonOnClick,
            className: `${className} ${sizeClassName} ${disabledClass}`,
            tabIndex: 0,
            onKeyDown: (e)=>{
                e.key === "Enter" && !disabled && onClick();
            },
            children: children
        });
    }
    return null; // To silence TS
};
var $6e454233c3ce9437$export$2e2bcd8739ae039 = $6e454233c3ce9437$var$Button;


const $ece04713077ea625$export$150b732325d14d04 = {
    is: {
        Navigation: {
            "\xd6kusk\xf3li 1": "\xd6kusk\xf3li 1",
            "\xd6kusk\xf3li 2": "\xd6kusk\xf3li 2",
            Ökukennari: "\xd6kukennari",
            Innskráning: "Innskr\xe1ning",
            Nýskráning: "N\xfdskr\xe1ning",
            "Fara \xe1 fors\xed\xf0una": "Fara \xe1 fors\xed\xf0una"
        }
    },
    en: {
        Navigation: {
            "\xd6kusk\xf3li 1": "Driving School 1",
            "\xd6kusk\xf3li 2": "Driving School 2",
            Ökukennari: "Driving Instructor",
            Innskráning: "Log in",
            Nýskráning: "Sign up",
            "Fara \xe1 fors\xed\xf0una": "Go to homepage"
        }
    }
};
const $ece04713077ea625$var$Navigation = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("header", {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            },
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "logo-container",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("a", {
                        href: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).FrontPage),
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                className: "assistive-text",
                                children: t("Navigation.Fara \xe1 fors\xed\xf0una")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                        srcSet: "/images/logo.webp",
                                        type: "image/webp"
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                        srcSet: "/images/logo.jpg",
                                        type: "image/jpeg"
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                        id: "logo",
                                        src: "/images/logo.jpg",
                                        alt: "Ur\xf0arbrunnur logo"
                                    })
                                ]
                            }),
                            " "
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "mobile-only sign-up-cta",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                        size: "small",
                        type: "react-router-link",
                        href: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                        children: t("Navigation.N\xfdskr\xe1ning")
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("nav", {
                    className: "navbar",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e80d636e54631bbe$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                    className: "primary-cta",
                                    to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                    children: t("Navigation.N\xfdskr\xe1ning")
                                })
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                    to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Login),
                                    children: t("Navigation.Innskr\xe1ning")
                                })
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                    to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingInstructors),
                                    children: t("Navigation.\xd6kukennari")
                                })
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                    to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool2),
                                    children: t("Navigation.\xd6kusk\xf3li 2")
                                })
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                    to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool1),
                                    children: t("Navigation.\xd6kusk\xf3li 1")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $ece04713077ea625$export$2e2bcd8739ae039 = $ece04713077ea625$var$Navigation;



parcelRequire("4hYjL");



const $1bd9e4aadcbd1f36$export$150b732325d14d04 = {
    is: {
        Footer: {
            // Footer item 1
            "Hagn\xfdtar uppl\xfdsingar": "Hagn\xfdtar uppl\xfdsingar",
            "Allt um b\xedlpr\xf3f": "Allt um b\xedlpr\xf3f",
            "Hva\xf0 kostar b\xedlpr\xf3f": "Hva\xf0 kostar b\xedlpr\xf3f?",
            "Spara\xf0u me\xf0 styrk fr\xe1 st\xe9ttaf\xe9laginu": "Spara\xf0u me\xf0 styrk fr\xe1 st\xe9ttaf\xe9laginu",
            Skilmálar: "Skilm\xe1lar",
            // Footer item 2
            "N\xe1mskei\xf0 og meira": "N\xe1mskei\xf0 og fleira",
            "\xd6kusk\xf3li 1": "\xd6kusk\xf3li 1",
            "\xd6kusk\xf3li 2": "\xd6kusk\xf3li 2",
            "Um okkur": "Um okkur",
            // Footer item 3
            Languages: "Tungum\xe1l og anna\xf0",
            English: "English ",
            OtherLangFrontPage: "/en",
            // Footer item 4
            Urðarbrunnur: "Ur\xf0arbrunnur",
            CardsAltText: "Grei\xf0slukort sem vi\xf0 sam\xfeykkjum: VISA and Mastercard"
        }
    },
    en: {
        Footer: {
            // Footer item 1
            "Hagn\xfdtar uppl\xfdsingar": "Useful information",
            "Allt um b\xedlpr\xf3f": "How to get a drivers license",
            "Hva\xf0 kostar b\xedlpr\xf3f": "How much does it cost to get a drivers license?",
            "Spara\xf0u me\xf0 styrk fr\xe1 st\xe9ttaf\xe9laginu": "How to save money with a union grant",
            Skilmálar: "Terms and Conditions",
            // Footer item 2
            "N\xe1mskei\xf0 og meira": "Courses and more",
            "\xd6kusk\xf3li 1": "Driving School 1",
            "\xd6kusk\xf3li 2": "Driving School 2",
            "Um okkur": "About us",
            // Footer item 3
            Languages: "Languages and more",
            English: "\xcdslenska",
            OtherLangFrontPage: "/",
            // Footer item 4
            Urðarbrunnur: "Ur\xf0arbrunnur Driving School",
            CardsAltText: "Credit cards we accept: VISA and Mastercard"
        }
    }
};
const $1bd9e4aadcbd1f36$var$Footer = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "footer-row",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "footer-item",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                children: t("Footer.Hagn\xfdtar uppl\xfdsingar")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).BlogHowToGetLicense),
                                children: t("Footer.Allt um b\xedlpr\xf3f")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).BlogCostOfLicense),
                                children: t("Footer.Hva\xf0 kostar b\xedlpr\xf3f")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).HowUnionsHelp),
                                children: t("Footer.Spara\xf0u me\xf0 styrk fr\xe1 st\xe9ttaf\xe9laginu")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "footer-item",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                children: t("Footer.N\xe1mskei\xf0 og meira")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool1),
                                children: t("Footer.\xd6kusk\xf3li 1")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool2),
                                children: t("Footer.\xd6kusk\xf3li 2")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).AboutUs),
                                children: t("Footer.Um okkur")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "footer-item",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                children: t("Footer.Languages")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                href: t("Footer.OtherLangFrontPage"),
                                children: t("Footer.English")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).TermsAndConditions),
                                children: t("Footer.Skilm\xe1lar")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "footer-item",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                children: t("Footer.Ur\xf0arbrunnur")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: "FR/AR ehf."
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: "kt: 591214-0710"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                className: "cc-logos",
                                src: "/images/visa-mastercard.gif",
                                alt: t("Footer.CardsAltText")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "bottom-footer",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                    children: [
                        "\xa9 2015 - ",
                        new Date().getFullYear(),
                        " — hallo@urdarbrunnur.is — 777-9344"
                    ]
                })
            })
        ]
    });
};
var $1bd9e4aadcbd1f36$export$2e2bcd8739ae039 = $1bd9e4aadcbd1f36$var$Footer;




var $4hYjL = parcelRequire("4hYjL");




const $5800fa3ce5ed806d$var$MobileMenu = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const history = (0, $87978d8bc0f45f32$export$3420e1dc2c4a518c)();
    // Closes the menu when someone clicks a new link.
    // If you delete the below the user will be taken
    // To a new page but the menu won't close.
    (0, $4hYjL.useEffect)(()=>{
        history.listen(()=>{
            closeMenu();
        });
    }, [
        history
    ]);
    const closeMenu = ()=>{
        const body = document.getElementsByTagName("body")[0];
        if (body.classList.contains("show-nav")) {
            body.classList.remove("show-nav");
            body.classList.add("hide-nav");
        }
    };
    const handleMenuToggle = (event)=>{
        event.preventDefault();
        // Get HTML body element and whack a new class on it.
        const body = document.getElementsByTagName("body")[0];
        if (body.classList.contains("show-nav")) {
            body.classList.remove("show-nav");
            body.classList.add("hide-nav");
        } else {
            body.classList.remove("hide-nav");
            body.classList.add("show-nav");
        }
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "mobile-menu",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("nav", {
                id: "body-nav",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                    className: "mobile-link-container",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                children: t("Navigation.N\xfdskr\xe1ning")
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Login),
                                children: t("Navigation.Innskr\xe1ning")
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingInstructors),
                                children: t("Navigation.\xd6kukennari")
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool1),
                                children: t("Navigation.\xd6kusk\xf3li 1")
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool2),
                                children: t("Navigation.\xd6kusk\xf3li 2")
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            style: {
                                marginTop: "40px"
                            },
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e80d636e54631bbe$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                href: "#",
                className: "toggle-nav",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "mobile-nav",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "menu-btn",
                        onClick: handleMenuToggle,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                className: "assistive-text",
                                children: "Navigation"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {})
                        ]
                    })
                })
            })
        ]
    });
};
var $5800fa3ce5ed806d$export$2e2bcd8739ae039 = $5800fa3ce5ed806d$var$MobileMenu;



const $d798a17fc2cb51c6$export$150b732325d14d04 = {
    is: {
        About: {
            "Um okkur": "Um okkur",
            "Um okkur texti 1": "Ur\xf0arbrunnur var stofna\xf0ur \xed \xe1g\xfast 2015. Bak vi\xf0 sk\xf3lan standa Freyr \xdeorvaldsson og Hilmar Gu\xf0j\xf3nsson. \xd6kusk\xf3linn Ur\xf0arbrunnur er \xed st\xf6\xf0ugri \xfer\xf3un og vi\xf0 leitum s\xedfellt n\xfdrra lei\xf0a til a\xf0 gera hann betri.",
            "Um okkur texti 2": "A\xf0 l\xe6ra \xe1 netinu hentar m\xf6rgum og vi\xf0 sv\xf6rum \xfeeirri \xfe\xf6rf.",
            Teymið: "Teymi\xf0",
            "Freyr Title": "Vefforritari og altmuligmand",
            "Hilmar Title": "Sk\xf3lastj\xf3ri og \xf6kukennari",
            "\xd6kusk\xf3li \xe1 netinu": "\xd6kusk\xf3li \xe1 netinu",
            "Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1": "Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344."
        }
    },
    en: {
        About: {
            "Um okkur": "About us",
            "Um okkur texti 1": "Ur\xf0arbrunnur was founded in August 2015.  Ur\xf0arbrunnur Driving School is in constant evolution and we're always seeking ways to improve.",
            "Um okkur texti 2": "Studying online suits many and we meet that demand.",
            Teymið: "The team",
            "Freyr Title": "Web developer and generalist",
            "Hilmar Title": "Principal and driving instructor",
            "\xd6kusk\xf3li \xe1 netinu": "Online driving school",
            "Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1": "Sign up to Driving School 1 (\xd6kusk\xf3li 1)",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Any questions? Call us at 777-9344."
        }
    }
};
const $d798a17fc2cb51c6$var$About = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: t("About.Um okkur")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "main-body default-page about-us",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "default-text-container",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                    children: t("About.Um okkur")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    children: t("About.Um okkur texti 1")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    children: t("About.Um okkur texti 2")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                    className: "about-us-team",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                            children: t("About.Teymi\xf0")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "starfsmadur",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                                    src: "/images/starfsmenn/hilmar.jpg"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                                    children: "Hilmar Gu\xf0j\xf3nsson"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    children: t("About.Hilmar Title")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "starfsmadur",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                                    src: "/images/starfsmenn/avatar.jpg"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                                    children: "Freyr \xdeorvaldsson"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    children: t("About.Freyr Title")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "button-container",
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                        className: "main-button",
                                        to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                        children: t("About.Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1")
                                    })
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    className: "spurningar-p",
                                    children: t("About.Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $d798a17fc2cb51c6$export$2e2bcd8739ae039 = $d798a17fc2cb51c6$var$About;



parcelRequire("4hYjL");








parcelRequire("4hYjL");



const $e5cba1357cfd75dc$export$150b732325d14d04 = {
    is: {
        BlogOverview: {
            Title: "Fr\xf3\xf0leikur um \xf6kun\xe1mi\xf0",
            CostUpdated: "Uppf\xe6rt 7. jan\xfaar 2025",
            ProcessUpdated: "Uppf\xe6rt 24. j\xfan\xed 2025",
            UnionsUpdated: "Uppf\xe6rt 31. okt\xf3ber 2024"
        }
    },
    en: {
        BlogOverview: {
            Title: "Learning to drive in Iceland",
            CostUpdated: "Updated January 7, 2025",
            ProcessUpdated: "Updated 24 June, 2025",
            UnionsUpdated: "Updated October 31, 2024"
        }
    }
};
const $e5cba1357cfd75dc$var$BlogOverview = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const articles = [
        {
            title: t("Cost.Title"),
            description: t("Cost.Description"),
            updated: t("BlogOverview.CostUpdated"),
            image: "/images/blogg/bill.jpg",
            link: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).BlogCostOfLicense)
        },
        {
            title: t("Process.Title"),
            description: t("Process.Description"),
            updated: t("BlogOverview.ProcessUpdated"),
            image: "/images/blogg/bilprof.jpg",
            link: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).BlogHowToGetLicense)
        },
        {
            title: t("Unions.Title"),
            description: t("Unions.Description"),
            updated: t("BlogOverview.UnionsUpdated"),
            image: "/images/blogg/van-in-iceland.jpg",
            link: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).HowUnionsHelp)
        }
    ];
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "blog-overview",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("BlogOverview.Title")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "blog-grid",
                children: articles.map((article, index)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                        to: article.link,
                        className: "blog-card",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                className: "blog-image",
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                    loading: "lazy",
                                    src: article.image,
                                    alt: article.title
                                })
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "blog-content",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                                children: article.title
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                className: "subtitle",
                                                children: article.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        className: "last-updated",
                                        children: article.updated
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $e5cba1357cfd75dc$export$2e2bcd8739ae039 = $e5cba1357cfd75dc$var$BlogOverview;



const $a636ef439f9c6fd1$export$150b732325d14d04 = {
    is: {
        FrontPage: {
            MetaTitle: "\xd6kusk\xf3li 1 og 2",
            StrapLine: "\xd6kusk\xf3li 1 og 2 \xe1 netinu",
            StrapLineDesc: "Taktu \xf6kusk\xf3lann \xfear sem \xfe\xfa vilt, \xfeegar \xfe\xfa vilt og n\xe1\xf0u b\xf3klega \xf6kupr\xf3finu \xed fyrstu tilraun.",
            Benefit1: "Hlusta\xf0u \xe1 e\xf0a lestu n\xe1msefni\xf0",
            Benefit2: "N\xf3g af myndum og spurningum",
            Price: "Hvert n\xe1mskei\xf0 \xe1 12.500 kr.",
            "Skr\xe1\xf0u \xfeig": "Skr\xe1\xf0u \xfeig",
            "Lestu meira": "Lestu meira",
            MainSalesText: "Meira en 1,000 nemendur hafa teki\xf0 \xd61 og \xd62 hj\xe1 okkur.",
            Myndrænt: "Myndr\xe6nt",
            MyndræntTexti: "Vi\xf0 \xfatsk\xfdrum fl\xf3ki\xf0 efni me\xf0 myndum og myndb\xf6ndum.",
            Gagnvirkt: "Gagnvirkt",
            GagnvirktTexti: "Vi\xf0 notum pr\xf3f og spurningar \xed hverju skrefi til a\xf0 tryggja a\xf0 \xfe\xfa skiljir efni\xf0.",
            Þægilegt: "\xde\xe6gilegt",
            ÞægilegtTexti: "Enginn str\xe6t\xf3, ekkert skutl. \xdea\xf0 er h\xe6gt a\xf0 l\xe6ra hva\xf0an sem er \xed gegnum neti\xf0.",
            AlltafOpið: "Alltaf opi\xf0",
            AlltafOpiðTexti: "N\xe1msefni\xf0 er a\xf0gengilegt allan s\xf3larhringinn.",
            GiltNám: "Gilt n\xe1m",
            GiltNámTexti: "N\xe1m hj\xe1 okkur kemur \xed sta\xf0inn fyrir n\xe1m \xed sk\xf3lastofu.",
            Öryggi: "\xd6ryggi",
            ÖryggiTexti: "Grei\xf0slur eru \xf6ruggar og vi\xf0 deilum ekki uppl\xfdsingum nema me\xf0 \xf6kukennara \xfe\xednum.",
            UmÖkuskóla1Titill: "\xd6kusk\xf3li 1 og 2",
            UmÖkuskóla1Texti1: "\xd6kusk\xf3la 1 og 2 er skipt upp \xed 6 lotur. Til a\xf0 hj\xe1lpa \xfe\xe9r a\xf0 muna efni\xf0 er miki\xf0 notast vi\xf0 myndir og gangvirk verkefni. Eftir hverja lotu er lotupr\xf3f \xfear sem er spurt er \xfar efninu.",
            UmÖkuskóla1Texti2: "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 1 \xfearf nemandi a\xf0 hafa n\xe1msheimild fr\xe1 s\xfdslumanni og kl\xe1ra\xf0 1 \xf6kut\xedma hj\xe1 \xf6kukennara. ",
            "Lestu meira um \xd61": "Lestu meira um \xd61",
            "Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1": "Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344."
        }
    },
    en: {
        FrontPage: {
            MetaTitle: "Driving School 1 and 2 online",
            StrapLine: "Driving School 1 and 2 online",
            StrapLineDesc: "Complete Driving School 1 and 2 wherever you'd like, whenever you'd like and ace the test in the first try.",
            Benefit1: "Completely online course",
            Benefit2: "Illustrated content",
            Price: "12.500 kr each course",
            "Skr\xe1\xf0u \xfeig": "Sign up",
            "Lestu meira": "Read more",
            MainSalesText: "Over 1,000 students have gone through our course. Here's why:",
            Myndrænt: "Visual",
            MyndræntTexti: "We explain complex concepts with pictures and videos.",
            Gagnvirkt: "Interactive",
            GagnvirktTexti: "We use quizes in each step to ensure you've understood the content.",
            Þægilegt: "All online",
            ÞægilegtTexti: "No need to take the bus or beg a friend to drive you. You can study from wherever.",
            AlltafOpið: "Always open",
            AlltafOpiðTexti: "The course is always accessible. 24/7 and even months after you've finished the course.",
            GiltNám: "Certified Course",
            GiltNámTexti: "Studying online is equivalent to taking the course in person.",
            Öryggi: "Safe and secure",
            ÖryggiTexti: "Payments are secure and we only share your progress with your driving instructor.",
            UmÖkuskóla1Titill: "Driving School 1 and 2",
            UmÖkuskóla1Texti1: "Driving School 1 and 2 are split into 6 rounds. We rely on pictures and quizes to help you understand and remember the content. After each round we have a 'round test' where we quiz you on the content of the round.",
            UmÖkuskóla1Texti2: "Before starting Driving School 1 you should have finished at least one driving lesson with a driving instructor. You'll get more out of the course that way.",
            "Lestu meira um \xd61": "Read more",
            "Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1": "Sign up to Driving School 1",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Any questions? Call us at 777-9344."
        }
    }
};
const $a636ef439f9c6fd1$var$FrontPage = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: t("FrontPage.MetaTitle")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "site-wrap",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "push-wrap front-page",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "main-body first-section",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                    className: "front-page-first-text",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                            children: t("FrontPage.StrapLine")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                            children: t("FrontPage.StrapLineDesc")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "checkmark-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                    className: "fa fa-headphones"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    className: "checkmark-text",
                                                    children: t("FrontPage.Benefit1")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "checkmark-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                    className: "fa fa-picture-o"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    className: "checkmark-text",
                                                    children: t("FrontPage.Benefit2")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "checkmark-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                    className: "fa fa-money"
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    className: "checkmark-text",
                                                    children: t("FrontPage.Price")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            className: "button-container",
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                                className: "main-button",
                                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                                children: t("FrontPage.Skr\xe1\xf0u \xfeig")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("picture", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                            srcSet: "/images/driver-1x1.webp",
                                            type: "image/webp"
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                            srcSet: "/images/driver-1x1.jpg",
                                            type: "image/jpeg"
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                            fetchPriority: "high",
                                            className: "front-page-image",
                                            src: "/images/driver-1x1.jpg",
                                            alt: "\xd6kuma\xf0ur"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            className: "second-section",
                            id: "lesameira",
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "main-body",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        className: "sales-main-text",
                                        children: t("FrontPage.MainSalesText")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "threebytwo",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                className: "fa fa-picture-o"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("FrontPage.Myndr\xe6nt")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("FrontPage.Myndr\xe6ntTexti")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "threebytwo",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                className: "fa fa-mobile"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("FrontPage.Gagnvirkt")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("FrontPage.GagnvirktTexti")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "threebytwo",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                className: "fa fa-user"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("FrontPage.\xde\xe6gilegt")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("FrontPage.\xde\xe6gilegtTexti")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "threebytwo",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                className: "fa fa-clock-o"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("FrontPage.AlltafOpi\xf0")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("FrontPage.AlltafOpi\xf0Texti")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "threebytwo",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                className: "fa fa-certificate"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("FrontPage.GiltN\xe1m")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("FrontPage.GiltN\xe1mTexti")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "threebytwo",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                className: "fa fa-lock"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("FrontPage.\xd6ryggi")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("FrontPage.\xd6ryggiTexti")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "main-body third-section",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                    className: "initial-text",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                            children: t("FrontPage.Um\xd6kusk\xf3la1Titill")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                            children: t("FrontPage.Um\xd6kusk\xf3la1Texti1")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                            children: [
                                                t("FrontPage.Um\xd6kusk\xf3la1Texti2"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                                            size: "medium",
                                            href: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).DrivingSchool1),
                                            type: "react-router-link",
                                            children: [
                                                t("FrontPage.Lestu meira um \xd61"),
                                                " ",
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                    className: "fa fa-arrow-right"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("picture", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                            "data-srcset": "/images/4.webp",
                                            type: "image/webp"
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                            "data-srcset": "/images/4.jpg",
                                            type: "image/jpeg"
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                            "data-src": "/images/4.PNG",
                                            className: "lazyload",
                                            alt: "Skj\xe1skot af n\xe1mskei\xf0i"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("picture", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                            "data-srcset": "/images/2.webp",
                                            type: "image/webp"
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                                            "data-srcset": "/images/2.jpg",
                                            type: "image/jpeg"
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                            "data-src": "/images/2.PNG",
                                            className: "lazyload",
                                            alt: "Skj\xe1skot af n\xe1mskei\xf0i"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            className: "fourth-section",
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                className: "main-body",
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e5cba1357cfd75dc$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            className: "main-body",
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "third-section-text-container",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "button-container",
                                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                            className: "main-button",
                                            to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                            children: t("FrontPage.Skr\xe1\xf0u \xfeig \xed \xf6kusk\xf3la 1")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        children: t("FrontPage.Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
};
var $a636ef439f9c6fd1$export$2e2bcd8739ae039 = $a636ef439f9c6fd1$var$FrontPage;




var $4hYjL = parcelRequire("4hYjL");


var $dcf45b7bb74bcba9$exports = {};
"use strict";
Object.defineProperty($dcf45b7bb74bcba9$exports, "__esModule", {
    value: true
});
$dcf45b7bb74bcba9$exports.default = $dcf45b7bb74bcba9$var$isNumeric;

var $dcf45b7bb74bcba9$var$_assertString = $dcf45b7bb74bcba9$var$_interopRequireDefault((parcelRequire("iLQHo")));
var $facc7bed0691849b$exports = {};
"use strict";
Object.defineProperty($facc7bed0691849b$exports, "__esModule", {
    value: true
});
$facc7bed0691849b$exports.commaDecimal = $facc7bed0691849b$exports.dotDecimal = $facc7bed0691849b$exports.bengaliLocales = $facc7bed0691849b$exports.farsiLocales = $facc7bed0691849b$exports.arabicLocales = $facc7bed0691849b$exports.englishLocales = $facc7bed0691849b$exports.decimal = $facc7bed0691849b$exports.alphanumeric = $facc7bed0691849b$exports.alpha = void 0;
var $facc7bed0691849b$var$alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
};
$facc7bed0691849b$exports.alpha = $facc7bed0691849b$var$alpha;
var $facc7bed0691849b$var$alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
};
$facc7bed0691849b$exports.alphanumeric = $facc7bed0691849b$var$alphanumeric;
var $facc7bed0691849b$var$decimal = {
    "en-US": ".",
    ar: "٫"
};
$facc7bed0691849b$exports.decimal = $facc7bed0691849b$var$decimal;
var $facc7bed0691849b$var$englishLocales = [
    "AU",
    "GB",
    "HK",
    "IN",
    "NZ",
    "ZA",
    "ZM"
];
$facc7bed0691849b$exports.englishLocales = $facc7bed0691849b$var$englishLocales;
for(var $facc7bed0691849b$var$locale, $facc7bed0691849b$var$i = 0; $facc7bed0691849b$var$i < $facc7bed0691849b$var$englishLocales.length; $facc7bed0691849b$var$i++){
    $facc7bed0691849b$var$locale = "en-".concat($facc7bed0691849b$var$englishLocales[$facc7bed0691849b$var$i]);
    $facc7bed0691849b$var$alpha[$facc7bed0691849b$var$locale] = $facc7bed0691849b$var$alpha["en-US"];
    $facc7bed0691849b$var$alphanumeric[$facc7bed0691849b$var$locale] = $facc7bed0691849b$var$alphanumeric["en-US"];
    $facc7bed0691849b$var$decimal[$facc7bed0691849b$var$locale] = $facc7bed0691849b$var$decimal["en-US"];
} // Source: http://www.localeplanet.com/java/
var $facc7bed0691849b$var$arabicLocales = [
    "AE",
    "BH",
    "DZ",
    "EG",
    "IQ",
    "JO",
    "KW",
    "LB",
    "LY",
    "MA",
    "QM",
    "QA",
    "SA",
    "SD",
    "SY",
    "TN",
    "YE"
];
$facc7bed0691849b$exports.arabicLocales = $facc7bed0691849b$var$arabicLocales;
for(var $facc7bed0691849b$var$_locale, $facc7bed0691849b$var$_i = 0; $facc7bed0691849b$var$_i < $facc7bed0691849b$var$arabicLocales.length; $facc7bed0691849b$var$_i++){
    $facc7bed0691849b$var$_locale = "ar-".concat($facc7bed0691849b$var$arabicLocales[$facc7bed0691849b$var$_i]);
    $facc7bed0691849b$var$alpha[$facc7bed0691849b$var$_locale] = $facc7bed0691849b$var$alpha.ar;
    $facc7bed0691849b$var$alphanumeric[$facc7bed0691849b$var$_locale] = $facc7bed0691849b$var$alphanumeric.ar;
    $facc7bed0691849b$var$decimal[$facc7bed0691849b$var$_locale] = $facc7bed0691849b$var$decimal.ar;
}
var $facc7bed0691849b$var$farsiLocales = [
    "IR",
    "AF"
];
$facc7bed0691849b$exports.farsiLocales = $facc7bed0691849b$var$farsiLocales;
for(var $facc7bed0691849b$var$_locale2, $facc7bed0691849b$var$_i2 = 0; $facc7bed0691849b$var$_i2 < $facc7bed0691849b$var$farsiLocales.length; $facc7bed0691849b$var$_i2++){
    $facc7bed0691849b$var$_locale2 = "fa-".concat($facc7bed0691849b$var$farsiLocales[$facc7bed0691849b$var$_i2]);
    $facc7bed0691849b$var$alphanumeric[$facc7bed0691849b$var$_locale2] = $facc7bed0691849b$var$alphanumeric.fa;
    $facc7bed0691849b$var$decimal[$facc7bed0691849b$var$_locale2] = $facc7bed0691849b$var$decimal.ar;
}
var $facc7bed0691849b$var$bengaliLocales = [
    "BD",
    "IN"
];
$facc7bed0691849b$exports.bengaliLocales = $facc7bed0691849b$var$bengaliLocales;
for(var $facc7bed0691849b$var$_locale3, $facc7bed0691849b$var$_i3 = 0; $facc7bed0691849b$var$_i3 < $facc7bed0691849b$var$bengaliLocales.length; $facc7bed0691849b$var$_i3++){
    $facc7bed0691849b$var$_locale3 = "bn-".concat($facc7bed0691849b$var$bengaliLocales[$facc7bed0691849b$var$_i3]);
    $facc7bed0691849b$var$alpha[$facc7bed0691849b$var$_locale3] = $facc7bed0691849b$var$alpha.bn;
    $facc7bed0691849b$var$alphanumeric[$facc7bed0691849b$var$_locale3] = $facc7bed0691849b$var$alphanumeric.bn;
    $facc7bed0691849b$var$decimal[$facc7bed0691849b$var$_locale3] = $facc7bed0691849b$var$decimal["en-US"];
} // Source: https://en.wikipedia.org/wiki/Decimal_mark
var $facc7bed0691849b$var$dotDecimal = [
    "ar-EG",
    "ar-LB",
    "ar-LY"
];
$facc7bed0691849b$exports.dotDecimal = $facc7bed0691849b$var$dotDecimal;
var $facc7bed0691849b$var$commaDecimal = [
    "bg-BG",
    "cs-CZ",
    "da-DK",
    "de-DE",
    "el-GR",
    "en-ZM",
    "es-ES",
    "fr-CA",
    "fr-FR",
    "id-ID",
    "it-IT",
    "ku-IQ",
    "hi-IN",
    "hu-HU",
    "nb-NO",
    "nn-NO",
    "nl-NL",
    "pl-PL",
    "pt-PT",
    "ru-RU",
    "si-LK",
    "sl-SI",
    "sr-RS@latin",
    "sr-RS",
    "sv-SE",
    "tr-TR",
    "uk-UA",
    "vi-VN"
];
$facc7bed0691849b$exports.commaDecimal = $facc7bed0691849b$var$commaDecimal;
for(var $facc7bed0691849b$var$_i4 = 0; $facc7bed0691849b$var$_i4 < $facc7bed0691849b$var$dotDecimal.length; $facc7bed0691849b$var$_i4++)$facc7bed0691849b$var$decimal[$facc7bed0691849b$var$dotDecimal[$facc7bed0691849b$var$_i4]] = $facc7bed0691849b$var$decimal["en-US"];
for(var $facc7bed0691849b$var$_i5 = 0; $facc7bed0691849b$var$_i5 < $facc7bed0691849b$var$commaDecimal.length; $facc7bed0691849b$var$_i5++)$facc7bed0691849b$var$decimal[$facc7bed0691849b$var$commaDecimal[$facc7bed0691849b$var$_i5]] = ",";
$facc7bed0691849b$var$alpha["fr-CA"] = $facc7bed0691849b$var$alpha["fr-FR"];
$facc7bed0691849b$var$alphanumeric["fr-CA"] = $facc7bed0691849b$var$alphanumeric["fr-FR"];
$facc7bed0691849b$var$alpha["pt-BR"] = $facc7bed0691849b$var$alpha["pt-PT"];
$facc7bed0691849b$var$alphanumeric["pt-BR"] = $facc7bed0691849b$var$alphanumeric["pt-PT"];
$facc7bed0691849b$var$decimal["pt-BR"] = $facc7bed0691849b$var$decimal["pt-PT"]; // see #862
$facc7bed0691849b$var$alpha["pl-Pl"] = $facc7bed0691849b$var$alpha["pl-PL"];
$facc7bed0691849b$var$alphanumeric["pl-Pl"] = $facc7bed0691849b$var$alphanumeric["pl-PL"];
$facc7bed0691849b$var$decimal["pl-Pl"] = $facc7bed0691849b$var$decimal["pl-PL"]; // see #1455
$facc7bed0691849b$var$alpha["fa-AF"] = $facc7bed0691849b$var$alpha.fa;


function $dcf45b7bb74bcba9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dcf45b7bb74bcba9$var$numericNoSymbols = /^[0-9]+$/;
function $dcf45b7bb74bcba9$var$isNumeric(str, options) {
    (0, $dcf45b7bb74bcba9$var$_assertString.default)(str);
    if (options && options.no_symbols) return $dcf45b7bb74bcba9$var$numericNoSymbols.test(str);
    return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? $facc7bed0691849b$exports.decimal[options.locale] : ".", "])?[0-9]+$")).test(str);
}
$dcf45b7bb74bcba9$exports = $dcf45b7bb74bcba9$exports.default;
$dcf45b7bb74bcba9$exports.default = $dcf45b7bb74bcba9$exports.default;










const $3ea3868f4588d729$export$150b732325d14d04 = {
    is: {
        Login: {
            Error500: "Eitthva\xf0 f\xf3r \xfarskei\xf0is okkar megin!",
            Error400: "Villa: kennitalan e\xf0a lykilor\xf0i\xf0 er vitlaust",
            MetaTitle: "Innskr\xe1ning",
            Innskráning: "Innskr\xe1ning",
            Kennitala: "Kennitala",
            Lykilorð: "Lykilor\xf0",
            Innskrá: "Innskr\xe1",
            "Gleymt lykilor\xf0": "Gleymt lykilor\xf0?",
            "Rafraen Skilriki": "Skr\xe1 inn me\xf0 rafr\xe6num skilr\xedkjum"
        }
    },
    en: {
        Login: {
            Error500: "Something appears to be wrong with the server. Sorry!",
            Error400: "Either the kennitala or password is wrong",
            MetaTitle: "Log in",
            Innskráning: "Log in",
            Kennitala: "Kennitala",
            Lykilorð: "Password",
            Innskrá: "Sign in",
            "Gleymt lykilor\xf0": "Forgot password?",
            "Rafraen Skilriki": "Sign in with electronic ID"
        }
    }
};
const $3ea3868f4588d729$var$Login = (props)=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [state, setState] = (0, $4hYjL.useState)({
        ssnFeedback: "",
        ssnValid: true,
        error: false,
        errorMessage: "",
        success: false,
        password: "",
        ssn: ""
    });
    const history = (0, $87978d8bc0f45f32$export$3420e1dc2c4a518c)();
    (0, $4hYjL.useEffect)(()=>{
        redirectIfLoggedIn();
    }, []);
    (0, $4hYjL.useEffect)(()=>{
        redirectIfLoggedIn();
    });
    const redirectIfLoggedIn = ()=>{
        const { authReducer: authReducer } = props;
        // redirect to dashboard if logged in.
        if (authReducer.authenticated) history.push("/stjornbord");
    };
    const changeFieldValue = (event)=>{
        const { value: value, name: name } = event.target;
        setState((prevState)=>({
                ...prevState,
                [name]: value
            }));
        if (name === "ssn") {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($dcf45b7bb74bcba9$exports)))(value) && value.length !== 0) setState((prevState)=>({
                    ...prevState,
                    ssnValid: false,
                    ssnFeedback: "Kennit\xf6lur eru einungis t\xf6lur"
                }));
            else setState((prevState)=>({
                    ...prevState,
                    ssnValid: true,
                    ssnFeedback: ""
                }));
        }
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            onSubmit();
        }
    };
    const onSubmit = ()=>{
        const { dispatch: dispatch } = props;
        const { password: password, ssn: ssn } = state;
        setState((prevState)=>({
                ...prevState,
                error: false,
                errorMessage: "",
                success: false
            }));
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/sign-in`, {
            password: password,
            ssn: ssn
        }).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$de676d0b1df680f0)({
                ...res.data
            }));
            history.push("/stjornbord");
        }).catch((error)=>{
            let errorMessage = "";
            if (error.response.state === 500) errorMessage = t("Login.Error500");
            else errorMessage = t("Login.Error400");
            setState((prevState)=>({
                    ...prevState,
                    error: true,
                    errorMessage: errorMessage,
                    success: false
                }));
        });
    };
    const { ssn: ssn, password: password, error: error, errorMessage: errorMessage, ssnValid: ssnValid, ssnFeedback: ssnFeedback } = state;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: t("Login.MetaTitle")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "site-wrap",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "push-wrap",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            className: "main-body main-content sign-in",
                            onKeyDown: onKeyDown,
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "sign-in-container",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                        children: t("Login.Innskr\xe1ning")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "form-container",
                                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    className: "field-name",
                                                    children: t("Login.Kennitala")
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                    autoFocus: true,
                                                    type: "number",
                                                    name: "ssn",
                                                    value: ssn,
                                                    onChange: changeFieldValue,
                                                    required: true
                                                }),
                                                !ssnValid ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                                    className: "feedback-message error-message",
                                                    children: [
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                            className: "fa fa-exclamation-triangle",
                                                            "aria-hidden": "true"
                                                        }),
                                                        " ",
                                                        ssnFeedback
                                                    ]
                                                }) : ""
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "form-container",
                                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    className: "field-name",
                                                    children: t("Login.Lykilor\xf0")
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                    type: "password",
                                                    name: "password",
                                                    value: password,
                                                    onChange: changeFieldValue,
                                                    required: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                                                type: "submit",
                                                className: "btn btn-submit",
                                                onClick: onSubmit,
                                                children: t("Login.Innskr\xe1")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).ForgotPassword),
                                                className: "gleymt-lykilord-link",
                                                children: t("Login.Gleymt lykilor\xf0")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                                children: error ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                                    className: "feedback-message error-message",
                                                    children: [
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                                            className: "fa fa-exclamation-triangle",
                                                            "aria-hidden": "true"
                                                        }),
                                                        " ",
                                                        errorMessage
                                                    ]
                                                }) : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "oauth-login",
                                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                            href: "/login/oauth2",
                                            className: "rafraen-skilriki-link",
                                            children: t("Login.Rafraen Skilriki")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
};
const $3ea3868f4588d729$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $3ea3868f4588d729$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($3ea3868f4588d729$var$mapStateToProps)($3ea3868f4588d729$var$Login);



parcelRequire("4hYjL");


parcelRequire("4hYjL");




const $140e6e3b46ce80a7$var$PageTemplate = ({ title: title, url: url, description: description, keywords: keywords, children: children, includeTextContainer: // Text container is at 80% width of the page for easier reading.
includeTextContainer = true })=>{
    const keywordsString = keywords.join(", ");
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $5e0021919929c8b4$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("title", {
                        children: [
                            title,
                            " | Ur\xf0arbrunnur \xd6kusk\xf3li"
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                        name: "keywords",
                        content: keywordsString
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                        name: "og:title",
                        content: `${title} | Urðarbrunnur Ökuskóli`
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                        name: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                        name: "og:url",
                        content: url
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                        name: "og:site_name",
                        content: "Ur\xf0arbrunnur \xd6kusk\xf3li"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "main-body default-page",
                        children: [
                            includeTextContainer && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                className: "default-text-container",
                                children: children
                            }),
                            !includeTextContainer && children
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $140e6e3b46ce80a7$export$2e2bcd8739ae039 = $140e6e3b46ce80a7$var$PageTemplate;




const $25527059244a8d43$export$150b732325d14d04 = {
    is: {
        loginError: {
            title: "Innskr\xe1ning mist\xf3kst",
            description: "Villa \xed innskr\xe1ningu",
            message: "Eitthva\xf0 f\xf3r \xfarskei\xf0is vi\xf0 innskr\xe1ningu.",
            suggestion: "G\xe6ti veri\xf0 a\xf0 \xfe\xfa hefur ekki stofna\xf0 a\xf0gang?",
            signUpLink: "Stofna a\xf0gang"
        }
    },
    en: {
        loginError: {
            title: "Login Failed",
            description: "Login error",
            message: "Something went wrong when you logged in.",
            suggestion: "Is it possible that you haven't signed up yet?",
            signUpLink: "Sign Up"
        }
    }
};
const $25527059244a8d43$var$LoginError = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    const registrationPath = (0, $d7df78052a791524$export$da3bc2f57520e3c3)[lang].Registration;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $140e6e3b46ce80a7$export$2e2bcd8739ae039), {
        title: t("loginError.title"),
        url: "/login-error",
        description: t("loginError.description"),
        keywords: [
            "login",
            "error",
            "urdarbrunnur",
            "okuskoli"
        ],
        includeTextContainer: false,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "login-error-container",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                    children: t("loginError.title")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("loginError.message")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("loginError.suggestion")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                    href: registrationPath,
                    className: "btn",
                    children: t("loginError.signUpLink")
                })
            ]
        })
    });
};
var $25527059244a8d43$export$2e2bcd8739ae039 = $25527059244a8d43$var$LoginError;




var $4hYjL = parcelRequire("4hYjL");





const $074e5beb3f764bd7$export$150b732325d14d04 = {
    is: {
        ForgotPassword: {
            "Gleymt Lykilor\xf0": "Gleymt Lykilor\xf0",
            ForgotPasswordText: "Sl\xe1\xf0u inn kennit\xf6luna \xfe\xedna og vi\xf0 munum senda \xfe\xe9r hlekk sem \xfe\xfa getur smellt \xe1 til a\xf0 breyta um lykilor\xf0.",
            Senda: "Senda",
            "\xdeessi kennitala er ekki \xe1 skr\xe1": "\xdeessi kennitala er ekki \xe1 skr\xe1",
            SuccessMessage: "T\xf6lvup\xf3stur hefur veri\xf0 sendur \xe1 netfangi\xf0 sem \xfe\xfa skr\xe1\xf0ir me\xf0 frekari lei\xf0beiningum.",
            "Ur\xf0arbrunnur \xd6kusk\xf3li": "Ur\xf0arbrunnur Driving School",
            Kennitala: "Kennitala"
        }
    },
    en: {
        ForgotPassword: {
            "Gleymt Lykilor\xf0": "Forgotten Password",
            ForgotPasswordText: "Put your kennitala into the field below and we'll send you a link to your email which you can follow to reset your password.",
            Senda: "Send email",
            "\xdeessi kennitala er ekki \xe1 skr\xe1": "We don't have any record of this kennitala",
            SuccessMessage: "T\xf6lvup\xf3stur hefur veri\xf0 sendur \xe1 netfangi\xf0 sem \xfe\xfa skr\xe1\xf0ir me\xf0 frekari lei\xf0beiningum.",
            "Ur\xf0arbrunnur \xd6kusk\xf3li": "Ur\xf0arbrunnur Driving School",
            Kennitala: "Kennitala"
        }
    }
};
const $074e5beb3f764bd7$var$ForgotPassword = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [ssn, setSsn] = (0, $4hYjL.useState)("");
    const [success, setSuccess] = (0, $4hYjL.useState)(false);
    const [successMessage, setSuccessMessage] = (0, $4hYjL.useState)("");
    const [error, setError] = (0, $4hYjL.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)("");
    function changeSsn(event) {
        const ssn = event.target.value.replace(/(\d{6})(\d+)/, "$1-$2");
        setSsn(ssn);
    }
    function submitSsn(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/forgot-password`, {
            ssn: ssn
        }).then(()=>{
            setError(false);
            setErrorMessage("");
            setSuccess(true);
            setSuccessMessage(t("ForgotPassword.SuccessMessage"));
        }).catch((error)=>{
            let newErrorMessage;
            if (error.response.status === 404) newErrorMessage = t(`ForgotPassword.Þessi kennitala er ekki á skrá`);
            else newErrorMessage = `Villa: ${error.response.status} - ${error.response.statusText}.`;
            setError(true);
            setErrorMessage(newErrorMessage);
            setSuccess(false);
            setSuccessMessage("");
        });
    }
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: t("ForgotPassword.Gleymt Lykilor\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "main-body default-page forgot-password-page",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                    children: t("ForgotPassword.Gleymt Lykilor\xf0")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("form", {
                                    onSubmit: submitSsn,
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "form-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    children: t("ForgotPassword.ForgotPasswordText")
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                            className: "field-name",
                                                            children: t("ForgotPassword.Kennitala")
                                                        }),
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                            autoFocus: true,
                                                            id: "kennitala-field",
                                                            type: "text",
                                                            maxLength: 11,
                                                            name: "ssn",
                                                            placeholder: "999999-9999",
                                                            required: true,
                                                            value: ssn,
                                                            onChange: changeSsn
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                                                type: "submit",
                                                className: "btn btn-submit",
                                                children: t("ForgotPassword.Senda")
                                            })
                                        })
                                    ]
                                }),
                                success ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    className: "feedback-message success-message",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                            className: "fa fa-envelope",
                                            "aria-hidden": "true"
                                        }),
                                        " ",
                                        successMessage
                                    ]
                                }) : "",
                                error ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    className: "feedback-message error-message",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                            className: "fa fa-exclamation-triangle",
                                            "aria-hidden": "true"
                                        }),
                                        " ",
                                        errorMessage
                                    ]
                                }) : ""
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $074e5beb3f764bd7$export$2e2bcd8739ae039 = $074e5beb3f764bd7$var$ForgotPassword;




var $4hYjL = parcelRequire("4hYjL");






const $221fba12115148f9$export$150b732325d14d04 = {
    is: {
        ResetPassword: {
            "Breyta lykilor\xf0i": "Breyta lykilor\xf0i",
            "N\xfdtt lykilor\xf0": "N\xfdtt lykilor\xf0",
            "Sta\xf0festa lykilor\xf0": "Sta\xf0festa lykilor\xf0",
            "Uppf\xe6ra lykilor\xf0": "Uppf\xe6ra lykilor\xf0",
            "Lykilor\xf0in eru ekki eins": "Lykilor\xf0in eru ekki eins",
            "Lykilor\xf0 \xfearf a\xf0 vera 8 stafir a\xf0 l\xe1gmarki": "Lykilor\xf0 \xfearf a\xf0 vera 8 stafir a\xf0 l\xe1gmarki"
        }
    },
    en: {
        ResetPassword: {
            "Breyta lykilor\xf0i": "Change Password",
            "N\xfdtt lykilor\xf0": "New password",
            "Sta\xf0festa lykilor\xf0": "Confirm password",
            "Uppf\xe6ra lykilor\xf0": "Update password",
            "Lykilor\xf0in eru ekki eins": "The passwords do not match",
            "Lykilor\xf0 \xfearf a\xf0 vera 8 stafir a\xf0 l\xe1gmarki": "The password needs to be at least 8 letters long"
        }
    }
};
const $221fba12115148f9$var$ResetPassword = (props)=>{
    const { history: history, match: match } = props;
    const token = match.params.token;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [newPasswordError, setNewPasswordError] = (0, $4hYjL.useState)("");
    const [retypePasswordError, setRetypePasswordError] = (0, $4hYjL.useState)("");
    const [newPassword, setNewPassword] = (0, $4hYjL.useState)("");
    const [newPasswordConfirm, setNewPasswordConfirm] = (0, $4hYjL.useState)(token);
    const changePassword = (event)=>{
        const { value: value, name: name } = event.target;
        setNewPasswordError("");
        setRetypePasswordError("");
        if (name === "newPasswordConfirm" || name === "newPassword") setNewPassword(value);
    };
    const changePasswordConfirm = (event)=>{
        const { value: value, name: name } = event.target;
        setNewPasswordError("");
        setRetypePasswordError("");
        if (name === "newPasswordConfirm" || name === "newPassword") setNewPasswordConfirm(value);
    };
    const submitForm = (event)=>{
        event.preventDefault();
        let error = false;
        let newPasswordError = "";
        let retypePasswordError = "";
        if (newPassword.length < 8) {
            error = true;
            newPasswordError = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: "fa fa-exclamation-circle"
                    }),
                    t("ResetPassword.Lykilor\xf0 \xfearf a\xf0 vera 8 stafir a\xf0 l\xe1gmarki")
                ]
            });
        }
        if (newPassword !== newPasswordConfirm && newPasswordConfirm.length > 0) {
            error = true;
            retypePasswordError = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: "fa fa-exclamation-circle"
                    }),
                    t("ResetPassword.Lykilor\xf0in eru ekki eins")
                ]
            });
        }
        if (error) {
            setNewPasswordError(newPasswordError);
            setRetypePasswordError(retypePasswordError);
        } else {
            setNewPasswordError("");
            setRetypePasswordError("");
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/nytt-lykilord/" + token, {
                password: newPassword
            }).then(()=>{
                history.push(t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Login));
            }).catch((err)=>{
                console.error(err);
            });
        }
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "site-wrap",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "push-wrap",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                    pageTitle: t("ResetPassword.Breyta lykilor\xf0i")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "main-body default-page reset-page",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("form", {
                        method: "post",
                        onSubmit: submitForm,
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                    children: t("ResetPassword.Breyta lykilor\xf0i")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "form-container",
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                className: "field-name",
                                                children: t("ResetPassword.N\xfdtt lykilor\xf0")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                type: "password",
                                                name: "newPassword",
                                                value: newPassword,
                                                required: true,
                                                onChange: changePassword
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                                className: "reset-form-error-short",
                                                children: newPasswordError
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "form-container",
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                className: "field-name",
                                                children: t("ResetPassword.Sta\xf0festa lykilor\xf0")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                type: "password",
                                                name: "newPasswordConfirm",
                                                value: newPasswordConfirm,
                                                required: true,
                                                onChange: changePasswordConfirm
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                                className: "reset-form-error",
                                                children: retypePasswordError
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                                        id: "submit",
                                        type: "submit",
                                        className: "btn",
                                        children: t("ResetPassword.Uppf\xe6ra lykilor\xf0")
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $221fba12115148f9$export$2e2bcd8739ae039 = $221fba12115148f9$var$ResetPassword;



parcelRequire("4hYjL");








parcelRequire("4hYjL");



const $6d2e11f9efc6915b$export$150b732325d14d04 = {
    is: {
        HeroSection: {
            "N\xe1minu er dreift yfir 6 daga": "N\xe1minu er dreift yfir 6 daga",
            VerðPeningar: "N\xe1mskei\xf0i\xf0 kostar 12.500 kr.",
            "Myndr\xe6nt og gangvirkt n\xe1m": "Myndr\xe6nt og gangvirkt n\xe1m"
        }
    },
    en: {
        HeroSection: {
            "N\xe1minu er dreift yfir 6 daga": "Lessons spread across 6 days",
            VerðPeningar: "It costs 12.500 kr.",
            "Myndr\xe6nt og gangvirkt n\xe1m": "Visual and interactive content"
        }
    }
};
const $6d2e11f9efc6915b$var$HeroSection = ({ headline: headline, introText: introText, buttonCTA: buttonCTA, imageURL: imageURL })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "salespage-hero-section",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "first-box",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                        style: {
                            marginTop: "0"
                        },
                        children: headline
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                        style: {
                            maxWidth: "80%"
                        },
                        children: introText
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "points",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-clock-o"
                                    }),
                                    t("HeroSection.N\xe1minu er dreift yfir 6 daga")
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-money"
                                    }),
                                    t("HeroSection.Ver\xf0Peningar")
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                style: {
                                    marginBottom: "44px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-picture-o "
                                    }),
                                    t("HeroSection.Myndr\xe6nt og gangvirkt n\xe1m")
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                                type: "react-router-link",
                                href: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                size: "big",
                                children: [
                                    buttonCTA,
                                    " ",
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-chevron-right",
                                        "aria-hidden": "true",
                                        style: {
                                            color: "white",
                                            fontSize: "16px"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "hide-on-mobile second-box",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                    className: "main-image",
                    src: imageURL
                })
            })
        ]
    });
};
var $6d2e11f9efc6915b$export$2e2bcd8739ae039 = $6d2e11f9efc6915b$var$HeroSection;



parcelRequire("4hYjL");

const $2be9f61885eec5db$export$150b732325d14d04 = {
    is: {
        SocialProof: {
            StudentCount1: "Meira en 1,250 nemendur hafa teki\xf0 \xd61 hj\xe1 okkur",
            StudentCount2: "Meira en 1,250 nemendur hafa teki\xf0 \xd62 hj\xe1 okkur",
            Testimonial1Text: "Efni\xf0 er vanda\xf0 en einnig skemmtilegt sem \xe9g er viss um a\xf0 hafi hj\xe1lpa\xf0 m\xe9r a\xf0 n\xe1 b\xedlpr\xf3finu \xed fyrstu tilraun.",
            Testimonial2Text: "N\xe1mskei\xf0i\xf0 hefur fullt af myndum og g\xf3\xf0um \xfatsk\xfdringum sem gerir \xfea\xf0 au\xf0skiljanlegt, s\xe9rstaklega \xfear sem \xe9g er me\xf0 myndr\xe6nt minni"
        }
    },
    en: {
        SocialProof: {
            StudentCount1: "Over 1,250 students have taken Driving School 1 with us",
            StudentCount2: "Over 1,250 students have taken Driving School 2 with us",
            Testimonial1Text: "The material is well-made and fun, which I'm sure helped me pass the driver's test on my first attempt.",
            Testimonial2Text: "The course has lots of images and clear explanations which makes it easy to understand, especially since I'm a visual learner"
        }
    }
};
const $2be9f61885eec5db$var$SocialProof = ({ drivingSchool: drivingSchool = 1 })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "social-proof",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                src: "/images/car.jpg",
                alt: "Car",
                style: {
                    width: "300px",
                    marginTop: "20px",
                    borderRadius: "4px"
                }
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t(`SocialProof.StudentCount${drivingSchool}`)
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "testimonials",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "testimonial",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "testimonial-content",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    children: [
                                        "“",
                                        t("SocialProof.Testimonial1Text"),
                                        "”"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "testimonial-author",
                                    children: "- \xc1g\xfasta I."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "testimonial",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "testimonial-content",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    children: [
                                        "“",
                                        t("SocialProof.Testimonial2Text"),
                                        "”"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "testimonial-author",
                                    children: "- \xdeorsteinn K."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $2be9f61885eec5db$export$2e2bcd8739ae039 = $2be9f61885eec5db$var$SocialProof;




var $4hYjL = parcelRequire("4hYjL");

const $cebf6585d125e18d$export$150b732325d14d04 = {
    is: {
        FAQ: {
            Title: "Algengar spurningar",
            Q1: "Hentar \xd6kusk\xf3li 1 lesblindum?",
            A1: "J\xe1, \xfea\xf0 er h\xe6gt a\xf0 nota lesblindu textan OpenDyslexic me\xf0 \xfev\xed a\xf0 fara \xed stillingar. A\xf0 auki er h\xe6gt a\xf0 hlusta \xe1 mest allt efni \xd6kusk\xf3la 1 en \xfea\xf0 er lesi\xf0 upp af leikaranum Hallvar\xf0i Jes G\xedslasyni.",
            Q2: "Mig vantar \xf6kukennara \xe1 h\xf6fu\xf0borgarsv\xe6\xf0inu. Bj\xf3\xf0i\xf0 \xfei\xf0 upp \xe1 \xf6kukennslu \xfear?",
            A2: "J\xe1 vi\xf0 bj\xf3\xf0um svo sannarlega upp \xe1 <a href='/okukennarar'>\xf6kukennslu \xe1 h\xf6fu\xf0borgarsv\xe6\xf0inu</a>.",
            Q3: "Hva\xf0 kostar \xf6kun\xe1mi\xf0?",
            A3: "Heppilega h\xf6fum vi\xf0 skrifa\xf0 heila grein um \xfeetta. \xde\xfa <a href='/blogg/hvad-kostar-bilprof'>getur lesi\xf0 um \xfea\xf0 h\xe9rna</a>. Ef \xfe\xfa vilt spara sm\xe1 pening (og hver vil \xfea\xf0 ekki?) \xfe\xe1 getur \xfe\xfa l\xedka lesi\xf0 <a href='/blog/how-to-get-a-cheap-drivers-license-in-Iceland'>\xfeessa grein sem fjallar um hvernig \xfea\xf0 er m\xf6gulega h\xe6gt er a\xf0 n\xfdta n\xe1msstyrki fr\xe1 st\xe9ttarf\xe9l\xf6gum</a> til \xfeess a\xf0 l\xe6kka kostna\xf0inn \xe1 \xf6kun\xe1minu \xfe\xednu.",
            Q4: "Hvernig skr\xe1i \xe9g mig \xed sk\xf3lann?",
            A4: "Fyrst fer\xf0u \xe1 <a href='/registration'>innskr\xe1ningars\xed\xf0una</a> og s\xed\xf0an hefur\xf0u kost \xe1 a\xf0 grei\xf0a me\xf0 grei\xf0slukorti e\xf0a me\xf0 millif\xe6rslu.",
            Q5: "Bj\xf3\xf0i\xf0 \xfei\xf0 upp \xe1 meirapr\xf3f e\xf0a m\xf3torhj\xf3lapr\xf3f?",
            A5: "Nei, \xfev\xed mi\xf0ur ekki. Vi\xf0 einbeitum okkur a\xf0 \xd6kusk\xf3la 1 og 2. \xdea\xf0 eru a\xf0rir \xe1g\xe6tir sk\xf3lar sem geta kennt \xfe\xe9r \xe1 m\xf3torhj\xf3l og allskonar.",
            Q6: "\xc9g hef \xfatskrifast \xfar \xd6kusk\xf3la 1 en mig vantar sta\xf0festingu \xed rafr\xe6nu \xf6kun\xe1msb\xf3kina. Hvernig f\xe6 \xe9g hana?",
            A6: "J\xe1, \xfea\xf0 er ekkert m\xe1l. Hringdu \xed okkur e\xf0a sendu okkur t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is og vi\xf0 skulum koma \xfev\xed \xed lag.",
            Q7: "Er h\xe6gt a\xf0 taka n\xe1mskei\xf0in \xe1 ensku?",
            A7: "J\xe1! Vi\xf0 h\xe9ldum a\xf0 \xfe\xfa myndir aldrei spyrja. Vi\xf0 bj\xf3\xf0um svo sannarlega upp \xe1 n\xe1mskei\xf0i\xf0 \xe1 ensku. Vi\xf0 settum miki\xf0 p\xfa\xf0ur \xed a\xf0 \xfe\xfd\xf0a allt efni\xf0 vel og vandlega, meira a\xf0 segja greinarnar okkar og alla heimas\xed\xf0una. \xdea\xf0 er ekkert Google Translate h\xe9r \xe1 b\xe6.",
            Q8: "Mig vantar \xe6fingaaksturs segulinn. Hvar f\xe6 \xe9g hann?",
            A8: "Allir nemendur okkar f\xe1 segla. Vi\xf0 erum l\xedka tilb\xfain a\xf0 senda ykkur auka segull ef s\xe1 fyrsti t\xfdnist e\xf0a einfaldlega fl\xfdgur af b\xedlnum, eins og gerist stundum. Sendu okkur bara t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is me\xf0 nafni og heimilisfangi og vi\xf0 gr\xe6jum m\xe1li\xf0."
        }
    },
    en: {
        FAQ: {
            Title: "Frequently Asked Questions",
            Q1: "Does Driving School 1 suit those with dyslexia?",
            A1: "Yes, you can use a dyslexia font called OpenDyslexic by going into settings.",
            Q2: "I need a driving instructor in the greater Reykjav\xedk area. Do you offer driving lessons there?",
            A2: "Yes, we do! Have a look at <a href='/okukennarar'>this page</a> for more information.",
            Q3: "How much does learning to drive cost in total?",
            A3: "Luckily we've gone into some depth on the subject in an article that you <a href='/blogg/hvad-kostar-bilprof'>can read here</a>. If you want to save some money (and who doesn't?) then you can also read <a href='/blog/how-to-get-a-cheap-drivers-license-in-Iceland'>this article that tells you how your union can help you</a> potentially lower the cost of learning to drive.",
            Q4: "How do I start Driving School 1?",
            A4: "First you <a href='/registration'>sign up</a> and then you can pay with either a payment card or bank transfer.",
            Q5: "Do you offer motorcycle or 'meirapr\xf3f' courses?",
            A5: "Unfortunately not. We focus especially on Driving School 1 and 2. There are other great schools out there that can teach you to drive a motorcycle and more.",
            Q6: "I've completed Driving School 1 but it doesn't show in my electronic driving book. Can you fix it?",
            A6: "Yes, that's no problem. Just call us or send us an email at hallo@urdarbrunnur.is and we'll sort it out.",
            Q7: "Is it possible to take the courses in English?",
            A7: "Yes! We thought you'd never ask. In fact we put a lot of effort into translating the writing and UI properly into English. As you may have noticed we also translated our articles and the entire website.",
            Q8: "I need a learners magnet (also known as the '\xe6fingaakstur' magnet) to put at the back of my car. Where can I get one?",
            A8: "All our students get driver's magnets. We're even happy to send you another one if you lose it or if it flies off the car, as they have an unfortunate tendency to do. Just send us an email at hallo@urdarbrunnur.is with your name and address and we'll send it to you via post!"
        }
    }
};
const $cebf6585d125e18d$var$FAQ = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [openIndex, setOpenIndex] = (0, $4hYjL.useState)(null);
    const questions = Array.from({
        length: 8
    }, (_, i)=>({
            question: t(`FAQ.Q${i + 1}`),
            answer: t(`FAQ.A${i + 1}`)
        }));
    const toggleQuestion = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "faq-section",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "main-body",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                    children: t("FAQ.Title")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "faq-grid",
                    children: questions.map((item, index)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: `faq-item ${openIndex === index ? "open" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                    className: "faq-question",
                                    onClick: ()=>toggleQuestion(index),
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                            children: item.question
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                            className: "faq-icon",
                                            children: openIndex === index ? "−" : "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "faq-answer",
                                    onClick: (e)=>e.stopPropagation(),
                                    style: {
                                        cursor: "text"
                                    },
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: item.answer
                                        }
                                    })
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};
var $cebf6585d125e18d$export$2e2bcd8739ae039 = $cebf6585d125e18d$var$FAQ;


const $2641eaf58871cbd3$export$150b732325d14d04 = {
    is: {
        Ö1Page: {
            MetaTitle: "\xd6kusk\xf3li 1",
            "\xd6kusk\xf3li 1 \xe1 netinu": "\xd6kusk\xf3li 1 \xe1 netinu",
            IntroTexti: "B\xf3klega n\xe1mi\xf0 byrjar me\xf0 \xd6kusk\xf3la 1. Efni\xf0 er sett fram \xe1 myndr\xe6nan og gangvirkan h\xe1tt.",
            "Fjarn\xe1m Ur\xf0arbrunns": "Fjarn\xe1m Ur\xf0arbrunns",
            FjarnámTexti: "\xd6kusk\xf3li 1 er hluti af \xf6kun\xe1msferlinu og er st\xf3rt skref \xed \xe1tt a\xf0 b\xedlpr\xf3fi. \xd6kusk\xf3li 1 \xed fjarn\xe1mi kemur \xed sta\xf0inn fyrir hef\xf0bundi\xf0 n\xe1m \xed sk\xf3lastofu og fer \xed sama efni.",
            "Hva\xf0 er kennt \xed \xd6kusk\xf3la 1?": "Hva\xf0 er kennt \xed \xd6kusk\xf3la 1?",
            "\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni": "\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni:",
            KaflaprófTexti: "\xcd lok hverrar lotu er 10 spurninga kaflapr\xf3f og n\xe1minu l\xfdkur me\xf0 lokapr\xf3fi \xfar \xf6llu efni n\xe1mskei\xf0sins.",
            SexDagaNámskeið: "Vi\xf0 lok hverrar lotu \xfearf a\xf0 b\xed\xf0a \xed einn s\xf3lahring \xfear til n\xe6sta lota opnast. \xdeetta gerir \xfea\xf0 a\xf0 verkum a\xf0 n\xe1mskei\xf0i\xf0 tekur minnst sex daga. \xdeetta er fyrirkomulag sem Samg\xf6ngustofa \xe1kve\xf0ur og allir net\xf6kusk\xf3lar \xfeurfa a\xf0 fylgja.",
            "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina": "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina",
            "\xdat \xcd Umfer\xf0ina": "\xdat \xcd Umfer\xf0ina",
            "handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1": "handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1",
            "vefverslun \xd6kukennaraf\xe9lagsins": "vefverslun \xd6kukennaraf\xe9lagsins",
            Inntökuskilyrði: "Innt\xf6kuskilyr\xf0i",
            "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 1 \xfearf nemandi a\xf0 hafa": "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 1 \xfearf nemandi a\xf0 hafa:",
            "N\xe1msheimild fr\xe1 s\xfdslumanni": "N\xe1msheimild fr\xe1 s\xfdslumanni",
            "Kl\xe1ra\xf0 1 \xf6kut\xedma hj\xe1 \xf6kukennara": "Kl\xe1ra\xf0 1 \xf6kut\xedma hj\xe1 \xf6kukennara",
            Greiðsla: "Grei\xf0sla",
            GreiðslaText: "Grei\xf0sla fer fram eftir a\xf0 a\xf0gangur hefur veri\xf0 stofna\xf0ur. H\xe6gt er a\xf0 grei\xf0a me\xf0 grei\xf0slukorti e\xf0a millif\xe6rslu inn\xe1 reikning \xf6kusk\xf3lans. Frekari uppl\xfdsingar um grei\xf0slufyrirkomulag m\xe1 finna eftir skr\xe1ningu.",
            "Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 1": "Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 1",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.",
            StudentCount: "Meira en 1,500 nemendur hafa teki\xf0 \xd61 hj\xe1 okkur",
            Testimonial1Text: "Efni\xf0 er vanda\xf0 en einnig skemmtilegt sem \xe9g er viss um a\xf0 hafi hj\xe1lpa\xf0 m\xe9r a\xf0 n\xe1 b\xedlpr\xf3finu \xed fyrstu tilraun.",
            Testimonial2Text: "N\xe1mskei\xf0i\xf0 hefur fullt af myndum og g\xf3\xf0um \xfatsk\xfdringum sem gerir \xfea\xf0 au\xf0skiljanlegt, s\xe9rstaklega \xfear sem \xe9g er me\xf0 myndr\xe6nt minni"
        }
    },
    en: {
        Ö1Page: {
            MetaTitle: "Driving School 1",
            "\xd6kusk\xf3li 1 \xe1 netinu": "Driving School 1 online",
            IntroTexti: "Begin your driving studies with Driving School 1 (\xd6kusk\xf3li 1). Learn through visual content and interactive challenges.",
            "\xcd stuttu m\xe1li": "Summary",
            "Fjarn\xe1m Ur\xf0arbrunns": "Learn online with us in English",
            FjarnámTexti: "Driving school 1 and 2 (\xd6kusk\xf3li 1 and 2) are an integral part of the process to get a drivers license.",
            "Hva\xf0 er kennt \xed \xd6kusk\xf3la 1?": "What is taught in Driving School 1?",
            "\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni": "Driving School 1 is split into 6 rounds. Each round covers a different subject:",
            KaflaprófTexti: "At the end of each round is a 10 question quiz and at the end of the 6 rounds there is a final test that covers the entire course material.",
            SexDagaNámskeið: "After each round you need to wait for a day until the next one opens. This means the course takes at least six days. This is done to follow the rules set by the Ministry of Transport, which all online driving schools follow.",
            "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina": "So you do as well as you can in the driving school you should ideally have the book",
            "\xdat \xcd Umfer\xf0ina": "\xdat \xcd Umfer\xf0ina",
            "handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1": "at hand. You can buy the book in Icelandic on the",
            "vefverslun \xd6kukennaraf\xe9lagsins": "Driving Instructors Association store",
            Inntökuskilyrði: "Admission requirements",
            "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 1 \xfearf nemandi a\xf0 hafa": "To start Driving School 1 you should have:",
            "N\xe1msheimild fr\xe1 s\xfdslumanni": "A study permit",
            "Kl\xe1ra\xf0 1 \xf6kut\xedma hj\xe1 \xf6kukennara": "Finished 1 driving lesson with a driving instructor",
            Greiðsla: "Payment",
            GreiðslaText: "You pay after you've signed up and chosen your course. You can pay either with a credit card or bank transfer.",
            "Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 1": "Sign up to Driving School 1",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Any questions? Call us at 777-9344.",
            StudentCount: "Over 1,500 students have taken Driving School 1 with us",
            Testimonial1Text: "The material is well-made and fun, which I'm sure helped me pass the driver's test on my first attempt.",
            Testimonial2Text: "The course has lots of images and clear explanations which makes it easy to understand, especially since I'm a visual learner"
        }
    }
};
const $2641eaf58871cbd3$var$ScreenShots = ()=>{
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                className: "screenshots first-screenshot",
                src: "/images/4.PNG"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                className: "screenshots",
                src: "/images/2.PNG"
            })
        ]
    });
};
const $2641eaf58871cbd3$var$Okuskoli1SalesPage = ({ school: school = 1 })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: t(`Ö${school}Page.MetaTitle`)
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "main-body default-page sales-page",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6d2e11f9efc6915b$export$2e2bcd8739ae039), {
                                headline: t("\xd61Page.\xd6kusk\xf3li 1 \xe1 netinu"),
                                introText: t("\xd61Page.IntroTexti"),
                                buttonCTA: t("\xd61Page.Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 1"),
                                imageURL: "/images/kona-ad-keyra.jpg"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $2be9f61885eec5db$export$2e2bcd8739ae039), {
                                drivingSchool: 1
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "default-text-container",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "img-and-info",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("\xd61Page.Fjarn\xe1m Ur\xf0arbrunns")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd61Page.Fjarn\xe1mTexti")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("\xd61Page.Hva\xf0 er kennt \xed \xd6kusk\xf3la 1?")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                                children: [
                                                    t("\xd61Page.\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni"),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd61L1")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd61L2")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd61L3")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd61L4")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd61L5")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd61L6")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd61Page.Kaflapr\xf3fTexti")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd61Page.SexDagaN\xe1mskei\xf0")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                                children: [
                                                    t("\xd61Page.Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina"),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("i", {
                                                        children: [
                                                            " ",
                                                            t("\xd61Page.\xdat \xcd Umfer\xf0ina")
                                                        ]
                                                    }),
                                                    " ",
                                                    t("\xd61Page.handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                                        href: "https://www.aka.is/namsefni/",
                                                        children: t("\xd61Page.vefverslun \xd6kukennaraf\xe9lagsins")
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($2641eaf58871cbd3$var$ScreenShots, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                        children: t("\xd61Page.Innt\xf6kuskilyr\xf0i")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        children: t("\xd61Page.Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 1 \xfearf nemandi a\xf0 hafa")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                children: t("\xd61Page.N\xe1msheimild fr\xe1 s\xfdslumanni")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                children: t("\xd61Page.Kl\xe1ra\xf0 1 \xf6kut\xedma hj\xe1 \xf6kukennara")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                        children: t("\xd61Page.Grei\xf0sla")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        children: t("\xd61Page.Grei\xf0slaText")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                className: "faq-section",
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $cebf6585d125e18d$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "button-container",
                                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                            className: "main-button",
                                            to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                            children: t("\xd61Page.Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 1")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        className: "spurningar-p",
                                        children: t("\xd61Page.Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2641eaf58871cbd3$export$2e2bcd8739ae039 = $2641eaf58871cbd3$var$Okuskoli1SalesPage;



parcelRequire("4hYjL");









const $bf14e0a350f7315c$export$150b732325d14d04 = {
    is: {
        Ö2Page: {
            MetaTitle: "\xd6kusk\xf3li 2",
            "\xd6kusk\xf3li 2 \xe1 netinu": "\xd6kusk\xf3li 2 \xe1 netinu",
            IntroTexti: "Framhald af \xd6kusk\xf3la 1. Efni\xf0 hj\xe1 okkur er sett fram \xe1 myndr\xe6nan og gangvirkan h\xe1tt.",
            "\xd6kusk\xf3li 2": "\xd6kusk\xf3li 2",
            "Fjarn\xe1m Ur\xf0arbrunns": "Fjarn\xe1m Ur\xf0arbrunns",
            FjarnámTexti: "\xd6kusk\xf3li 1 og 2 er hluti af \xf6kun\xe1msferlinu og er st\xf3rt skref \xed \xe1tt a\xf0 b\xedlpr\xf3fi. \xd6kusk\xf3li 2 \xed fjarn\xe1mi kemur \xed sta\xf0inn fyrir hef\xf0bundi\xf0 n\xe1m \xed sk\xf3lastofu og fer \xed sama efni.",
            "Hva\xf0 er kennt \xed \xd6kusk\xf3la 2?": "Hva\xf0 er kennt \xed \xd6kusk\xf3la 2?",
            "\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni": "\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni:",
            "Upprifjun \xe1 \xd6kusk\xf3la 1": "Upprifjun \xe1 \xd6kusk\xf3la 1",
            Umferðarsálfræði: "Umfer\xf0ars\xe1lfr\xe6\xf0i",
            "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar": "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar",
            "\xc1byrg\xf0 \xf6kumannsins": "\xc1byrg\xf0 \xf6kumannsins",
            "Opinber vi\xf0url\xf6g vi\xf0 brotum": "Opinber vi\xf0url\xf6g vi\xf0 brotum",
            "Slys og skyndihj\xe1lp": "Slys og skyndihj\xe1lp",
            KaflaprófTexti: "\xcd lok hverrar lotu er 10 spurninga kaflapr\xf3f og n\xe1minu l\xfdkur me\xf0 lokapr\xf3fi \xfar \xf6llu efni n\xe1mskei\xf0sins.",
            SexDagaNámskeið: "Vi\xf0 lok hverrar lotu \xfearf a\xf0 b\xed\xf0a \xed n\xe6stum einn s\xf3lahring (21 t\xedma) \xfear til n\xe6sta lota opnast. \xdeetta gerir \xfea\xf0 a\xf0 verkum a\xf0 n\xe1mskei\xf0i\xf0 tekur minnst sex daga. \xdeetta er gert til a\xf0 fylgja reglum Samg\xf6ngustofu.",
            "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina": "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina",
            "\xdat \xcd Umfer\xf0ina": "\xdat \xcd Umfer\xf0ina",
            "handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1": "handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1",
            "vefverslun \xd6kukennaraf\xe9lagsins": "vefverslun \xd6kukennaraf\xe9lagsins",
            Inntökuskilyrði: "Innt\xf6kuskilyr\xf0i",
            "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 2 \xfearf nemandi a\xf0 hafa": "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 2 \xfearf nemandi a\xf0 hafa:",
            "Kl\xe1ra\xf0 \xd6kusk\xf3la 1": "Kl\xe1ra\xf0 \xd6kusk\xf3la 1",
            Greiðsla: "Grei\xf0sla",
            GreiðslaText: "Grei\xf0sla fer fram eftir a\xf0 a\xf0gangur hefur veri\xf0 stofna\xf0ur. H\xe6gt er a\xf0 grei\xf0a me\xf0 grei\xf0slukorti e\xf0a millif\xe6rslu inn\xe1 reikning \xf6kusk\xf3lans. Frekari uppl\xfdsingar um grei\xf0slufyrirkomulag m\xe1 finna eftir skr\xe1ningu.",
            "Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 2": "Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 2",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344."
        }
    },
    en: {
        Ö2Page: {
            MetaTitle: "Driving School 2",
            "\xd6kusk\xf3li 2 \xe1 netinu": "Driving School 2 online",
            "\xd6kusk\xf3li 2": "Driving School 2",
            IntroTexti: "Driving School 2 is a continuation of Driving School 1 (\xd6kusk\xf3li 2). Learn through visual content and interactive challenges.",
            "Fjarn\xe1m Ur\xf0arbrunns": "Learn online with us",
            FjarnámTexti: "Driving school 1 and 2 (\xd6kusk\xf3li 1 and 2) are an integral part of the process to get a drivers license.",
            "Hva\xf0 er kennt \xed \xd6kusk\xf3la 2?": "What is taught in Driving School 2?",
            "\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni": "Driving School 2 is split into 6 rounds. Each round covers a different subject:",
            "Upprifjun \xe1 \xd6kusk\xf3la 1": "Driving School 1 Revision",
            Umferðarsálfræði: "Traffic psychology",
            "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar": "Traffic risk factors",
            "\xc1byrg\xf0 \xf6kumannsins": "The driver's responsibility",
            "Opinber vi\xf0url\xf6g vi\xf0 brotum": "Penalties for traffic violations",
            "Slys og skyndihj\xe1lp": "Accidents and first-aid",
            KaflaprófTexti: "At the end of each round is a 10 question quiz and at the end of the 6 rounds there is a final test that covers the entire course material.",
            SexDagaNámskeið: "After each round you need to wait for about a day (21 hours) until the next one opens. This means the course takes at least six days. This is done to follow the rules set by the Ministry of Transport",
            "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina": "So you do as well as you can in the driving school you should ideally have the book",
            "\xdat \xcd Umfer\xf0ina": "\xdat \xcd Umfer\xf0ina",
            "handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1": "at hand. You can buy the book in Icelandic on the",
            "vefverslun \xd6kukennaraf\xe9lagsins": "Driving Instructors Association store",
            Inntökuskilyrði: "Admission requirements",
            "Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 2 \xfearf nemandi a\xf0 hafa": "To start Driving School 2 you should have:",
            "Kl\xe1ra\xf0 \xd6kusk\xf3la 1": "Finished Driving School 1",
            Greiðsla: "Payment",
            GreiðslaText: "You pay after you've signed up and chosen your course. You can pay either with a credit card or bank transfer.",
            "Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 2": "Sign up to Driving School 2",
            "Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.": "Any questions? Call us at 777-9344."
        }
    }
};
const $bf14e0a350f7315c$var$Okuskoli2SalesPage = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: t("\xd62Page.MetaTitle")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "main-body default-page sales-page",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6d2e11f9efc6915b$export$2e2bcd8739ae039), {
                                headline: t("\xd62Page.\xd6kusk\xf3li 2 \xe1 netinu"),
                                introText: t("\xd62Page.IntroTexti"),
                                buttonCTA: t("\xd62Page.Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 2"),
                                imageURL: "/images/vegur.jpg"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $2be9f61885eec5db$export$2e2bcd8739ae039), {
                                drivingSchool: 2
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "default-text-container",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("\xd62Page.Fjarn\xe1m Ur\xf0arbrunns")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd62Page.Fjarn\xe1mTexti")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                                children: t("\xd62Page.Hva\xf0 er kennt \xed \xd6kusk\xf3la 2?")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd62Page.\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota fjallar um mismunandi efni")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd62L1")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd62L2")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd62L3")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd62L4")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd62L5")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                                        children: t("RoundTitles.\xd62L6")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd62Page.Kaflapr\xf3fTexti")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                children: t("\xd62Page.SexDagaN\xe1mskei\xf0")
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                                children: [
                                                    t("\xd62Page.Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xe6ttir \xfe\xfa a\xf0 hafa b\xf3kina"),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("i", {
                                                        children: [
                                                            " ",
                                                            t("\xd62Page.\xdat \xcd Umfer\xf0ina"),
                                                            " "
                                                        ]
                                                    }),
                                                    " ",
                                                    t("\xd62Page.handb\xe6ra. H\xfan fylgir ekki me\xf0 skr\xe1ningu hj\xe1 okkur en \xfea\xf0 er h\xe6gt a\xf0 kaupa hana \xe1"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                                        href: "https://www.aka.is/namsefni/",
                                                        children: t("\xd62Page.vefverslun \xd6kukennaraf\xe9lagsins")
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                                className: "screenshots first-screenshot",
                                                src: "/images/4.PNG"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                                className: "screenshots",
                                                src: "/images/2.PNG"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                        children: t("\xd62Page.Innt\xf6kuskilyr\xf0i")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        children: t("\xd62Page.Til \xfeess a\xf0 taka \xfe\xe1tt \xed \xd6kusk\xf3la 2 \xfearf nemandi a\xf0 hafa")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("ul", {
                                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                            children: t("\xd62Page.Kl\xe1ra\xf0 \xd6kusk\xf3la 1")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                        children: t("\xd62Page.Grei\xf0sla")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        children: t("\xd62Page.Grei\xf0slaText")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                                className: "button-container",
                                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                                    className: "main-button",
                                                    to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Registration),
                                                    children: t("\xd62Page.Skr\xe1\xf0u \xfeig \xed \xd6kusk\xf3la 2")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                className: "spurningar-p",
                                                children: t("\xd62Page.Einhverjar spurningar? Hringdu \xed s\xedma 777-9344.")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $bf14e0a350f7315c$export$2e2bcd8739ae039 = $bf14e0a350f7315c$var$Okuskoli2SalesPage;



parcelRequire("4hYjL");





const $26aa2b713864fdb4$export$150b732325d14d04 = {
    is: {
        Terms: {
            "Skilm\xe1lar Ur\xf0arbrunns": "Skilm\xe1lar Ur\xf0arbrunns",
            "\xd6kusk\xf3li Ur\xf0arbrunns hefur starfsleyfi fr\xe1 Samg\xf6ngustofu": "\xd6kusk\xf3li Ur\xf0arbrunns hefur starfsleyfi fr\xe1 Samg\xf6ngustofu.",
            FirstParagraph: "FR/AR ehf. (kt. 591214-0710) er eigandi \xfeessa vefs (urdarbrunnur.is) og er notkun hans a\xf0eins heimil \xfeeim sem hefur skr\xe1\xf0 sig \xed \xd6kusk\xf3la Ur\xf0arbrunns. Nemandi \xfearf a\xf0 lj\xfaka n\xe1mi innan 30 daga fr\xe1 \xfev\xed a\xf0 n\xe1mskei\xf0 er opna\xf0.",
            SecondParagraph: "FR/AR ehf. ber hvorki \xe1byrg\xf0 \xe1 tj\xf3ni sem rekja m\xe1 beint e\xf0a \xf3beint til notkunar \xe1 vef sk\xf3lans n\xe9 tj\xf3ni sem rekja m\xe1 til \xfeess a\xf0 ekki er h\xe6gt a\xf0 nota vefinn, um skemmri e\xf0a lengri t\xedma.",
            ThirdParagraph: "FR/AR ehf. \xe1 h\xf6fundarr\xe9ttinn \xe1 \xf6llum \xfeeim uppl\xfdsingum sem fram koma \xe1 vef \xf6kusk\xf3lans, nema anna\xf0 s\xe9 s\xe9rstaklega teki\xf0 fram e\xf0a lei\xf0a megi af e\xf0li m\xe1ls. Skriflegt sam\xfeykki FR/AR ehf. \xfearf til a\xf0 endurbirta uppl\xfdsingar sem fram koma \xe1 vef sk\xf3lans, dreifa \xfeeim e\xf0a afrita \xfe\xe6r. Ekki skiptir m\xe1li hvers e\xf0lis \xfe\xe6r uppl\xfdsingar eru n\xe9 \xed hva\xf0a tilgangi \xe6tlunin er a\xf0 endurbirta \xfe\xe6r, afrita \xfe\xe6r e\xf0a dreifa \xfeeim. Nemendum \xf6kusk\xf3lans er \xfe\xf3 heimilt a\xf0 vista uppl\xfdsingar af vefnum til einkanota.",
            FourthParagraph: "Nemendur geta h\xe6tt vi\xf0 kaupin innan 14 daga. Frestur \xfeessi byrjar a\xf0 l\xed\xf0a \xfeegar grei\xf0sla \xe1 s\xe9r sta\xf0.",
            FifthParagraph: "Samningur \xfeessi er \xed samr\xe6mi vi\xf0 \xedslensk l\xf6g. R\xedsi m\xe1l vegna hans skal \xfea\xf0 reki\xf0 fyrir H\xe9ra\xf0sd\xf3mi Reykjaness.",
            "Me\xf0fer\xf0 pers\xf3nuuppl\xfdsinga": "Me\xf0fer\xf0 pers\xf3nuuppl\xfdsinga",
            SixthParagraph: "Hj\xe1 Ur\xf0arbrunni skiptir \xf6ryggi m\xe1li og vi\xf0 h\xf6ldum \xfe\xednum pers\xf3nuuppl\xfdsingum \xf6ruggum me\xf0 tryggum forritunara\xf0fer\xf0um.",
            "Hva\xf0a uppl\xfdsingum er safna\xf0?": "Hva\xf0a uppl\xfdsingum er safna\xf0?",
            SeventhParagraph: "Grunnuppl\xfdsingum um nemendur, uppl\xfdsingum um notkun vefs\xed\xf0u ogvuppl\xfdsingum um framvindu n\xe1ms.",
            "Hvers vegna er uppl\xfdsingum safna\xf0?": "Hvers vegna er uppl\xfdsingum safna\xf0?",
            EigthParagraph: "Til \xfeess a\xf0 \xf6kukennslan s\xe9 \xed samr\xe6mi vi\xf0 l\xf6g og relgur sem gilda um \xf6kukennslu \xe1 netinu. Svo vi\xf0 getum fylgst me\xf0 virkni kerfa og til a\xf0 tryggja rekjanleika a\xf0ger\xf0a.",
            "Hvernig ver\xf0a uppl\xfdsingarnar nota\xf0ar?": "Hvernig ver\xf0a uppl\xfdsingarnar nota\xf0ar?",
            NinthParagraph: "Uppl\xfdsingar eru einungis nota\xf0ar til a\xf0 uppfylla lagaskyldu og kr\xf6fur \xed samningum.",
            "Me\xf0 hverjum ver\xf0ur uppl\xfdsingum deilt?": "Me\xf0 hverjum ver\xf0ur uppl\xfdsingum deilt?",
            TenthParagraph: "Ur\xf0arbrunnur deilir ekki uppl\xfdsingum me\xf0 \xf6\xf0rum nema l\xf6g e\xf0a regluger\xf0ir krefjist \xfeess. Vegna laga deilum vi\xf0 einungis uppl\xfdsingum \xfe\xednum me\xf0:",
            "\xd6kukennara \xfe\xednum": "\xd6kukennara \xfe\xednum",
            Samgöngustofu: "Samg\xf6ngustofu"
        }
    },
    en: {
        Terms: {
            "Skilm\xe1lar Ur\xf0arbrunns": "Terms & Conditions",
            "\xd6kusk\xf3li Ur\xf0arbrunns hefur starfsleyfi fr\xe1 Samg\xf6ngustofu": "Ur\xf0arbrunnur Driving school has a license from The Icelandic Transport Authority (Samg\xf6ngustofa).",
            FirstParagraph: "FR/AR ehf. (kt. 591214-0710) is the owner of this webpage (urdarbrunnur.is) and its usage is only permitted to those who have registered with Ur\xf0arbrunnur Driving school. Students must finish a course within 30 days once they finish registering.",
            SecondParagraph: "FR/AR ehf. is not liable for damage that can be traced either directly or indirectly to usage of the school's website nor damage traceable to the website not functioning correctly for a shorter or longer period of time.",
            ThirdParagraph: "FR/AR ehf. has copyright of all information displayed on the school's website unless otherwise stated. A written approval from FR/AR ehf. is needed to publish, share or copy information from the school's website. It does not matter what kind of information nor for what purpose it is published, copied, or shared. Students of the driving school are however permitted to save information from the website for personal use.",
            FourthParagraph: "Students can cancel the purchase within 14 days from the day the payment was made.",
            FifthParagraph: "This contract is in accordance with Icelandic law. If a case arises it shall be brought to Reykjanes District Court.",
            "Me\xf0fer\xf0 pers\xf3nuuppl\xfdsinga": "Treatment of personal information",
            SixthParagraph: "At Ur\xf0arbrunnur, information security is a priority, thus we keep all personal information safe with trustworthy programming methods.",
            "Hva\xf0a uppl\xfdsingum er safna\xf0?": "Which information is collected?",
            SeventhParagraph: "Basic information about students, information on the usage of the website and information regarding study progress.",
            "Hvers vegna er uppl\xfdsingum safna\xf0?": "Why is information collected?",
            EigthParagraph: "Information is collected to ensure that the driving school is compliant with rules and regulations concerning online driving schools. Information is also collected to observe if all systems are working correctly and to ensure traceability of operations.",
            "Hvernig ver\xf0a uppl\xfdsingarnar nota\xf0ar?": "How will my information be used?",
            NinthParagraph: "Information is only used to fulfil legal requirements and claims in the contract.",
            "Me\xf0 hverjum ver\xf0ur uppl\xfdsingum deilt?": "With whom is information shared?",
            TenthParagraph: "Ur\xf0arbrunnur does not share your information with anyone unless law and regulations require it. In accordance with regulations we only share your information with:",
            "\xd6kukennara \xfe\xednum": "Your driving instructor",
            Samgöngustofu: "The Icelandic Transport Authority (Samg\xf6ngustofa)"
        }
    }
};
const $26aa2b713864fdb4$var$Terms = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "site-wrap",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "push-wrap",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                    pageTitle: "Skilm\xe1lar"
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "main-body default-page",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "default-text-container",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                children: t("Terms.Skilm\xe1lar Ur\xf0arbrunns")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.\xd6kusk\xf3li Ur\xf0arbrunns hefur starfsleyfi fr\xe1 Samg\xf6ngustofu")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.FirstParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.SecondParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.ThirdParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.FourthParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.FifthParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                children: t("Terms.Me\xf0fer\xf0 pers\xf3nuuppl\xfdsinga")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.SixthParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                children: t("Terms.Hva\xf0a uppl\xfdsingum er safna\xf0?")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.SeventhParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                children: t("Terms.Hvers vegna er uppl\xfdsingum safna\xf0?")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.EigthParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                children: t("Terms.Hvernig ver\xf0a uppl\xfdsingarnar nota\xf0ar?")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.NinthParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                children: t("Terms.Me\xf0 hverjum ver\xf0ur uppl\xfdsingum deilt?")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: t("Terms.TenthParagraph")
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                        children: t("Terms.\xd6kukennara \xfe\xednum")
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                                        children: t("Terms.Samg\xf6ngustofu")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $26aa2b713864fdb4$export$2e2bcd8739ae039 = $26aa2b713864fdb4$var$Terms;



parcelRequire("4hYjL");



parcelRequire("4hYjL");

const $6437b179468d10a5$var$DrivingInstructor = ({ name: name, desc: desc, price: price, car: car, phone: phone, imgSrc: imgSrc })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "driving-teacher",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                className: "teacher-image",
                src: imgSrc
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                        children: name
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                        children: desc
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "details",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-money"
                                    }),
                                    t("DrivingInstructors.Ver\xf0"),
                                    ": ",
                                    price,
                                    " ",
                                    t("DrivingInstructors.kr / kennslustund")
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-phone-square"
                                    }),
                                    t("DrivingInstructors.S\xedmi"),
                                    ": ",
                                    phone
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: "fa fa-car"
                                    }),
                                    t("DrivingInstructors.B\xedll"),
                                    ": ",
                                    car
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6437b179468d10a5$export$2e2bcd8739ae039 = $6437b179468d10a5$var$DrivingInstructor;


const $28f05a77196fb0ca$export$150b732325d14d04 = {
    is: {
        DrivingInstructors: {
            Ökukennarar: "\xd6kukennari",
            SalesText: "Vantar \xfeig \xf6kukennara? Vertu \xfe\xe1 me\xf0 alla kennsluna \xe1 einum sta\xf0. Ef \xfe\xfa ert \xed kennslu hj\xe1 \xf6kukennurum Ur\xf0arbrunns f\xe6r\xf0u 2.500 kr. \xed afsl\xe1tt af \xd6kusk\xf3la 1 og 2!",
            HilmarDesc: "Hilmar hefur kennt meira en 1.000 nemendum a\xf0 keyra fr\xe1 \xe1rinu 1986. Hann er einnig sk\xf3lastj\xf3ri Ur\xf0arbrunns. Hann kennir yfirleitt \xe1 kv\xf6ldin og um helgar.",
            Verð: "Ver\xf0",
            "kr / kennslustund": "kr / kennslustund",
            Sími: "S\xedmi",
            Bíll: "B\xedll"
        }
    },
    en: {
        DrivingInstructors: {
            Ökukennarar: "Driving Instructors",
            SalesText: "Do you need a driving instructor? Do the whole package with us. If you are taught by one of our driving instructors you get 2.500 kr. off Driving School 1 og 2!",
            HilmarDesc: "Since 1986 Hilmar has taught more than 1.000 nemendum to drive. He is also the principal of Ur\xf0arbrunnur Driving school. He usually teaches in the evenings and during weekends.",
            Verð: "Ver\xf0",
            "kr / kennslustund": "kr / kennslustund",
            Sími: "S\xedmi",
            Bíll: "B\xedll"
        }
    }
};
const $28f05a77196fb0ca$var$DrivingInstructors = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $140e6e3b46ce80a7$export$2e2bcd8739ae039), {
        title: t("DrivingInstructors.\xd6kukennarar"),
        url: "http://urdarbrunnur.is/okukennarar",
        description: "\xd6kukennarar hj\xe1 \xf6kusk\xf3la Ur\xf0arbrunns",
        keywords: [
            "\xd6kukennari, \xf6kukennsla, \xf6kusk\xf3li"
        ],
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                    children: t("DrivingInstructors.\xd6kukennarar")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("DrivingInstructors.SalesText")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6437b179468d10a5$export$2e2bcd8739ae039), {
                    name: "Hilmar Gu\xf0j\xf3nsson",
                    desc: t("DrivingInstructors.HilmarDesc"),
                    imgSrc: "/images/starfsmenn/hilmar.jpg",
                    price: "12.900",
                    car: "Hyundai i30",
                    phone: "893-2700"
                })
            ]
        })
    });
};
var $28f05a77196fb0ca$export$2e2bcd8739ae039 = $28f05a77196fb0ca$var$DrivingInstructors;





var $4hYjL = parcelRequire("4hYjL");
var $599b7a41538cb619$exports = {};
"use strict";
function $599b7a41538cb619$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $599b7a41538cb619$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $599b7a41538cb619$var$_typeof(obj);
}
Object.defineProperty($599b7a41538cb619$exports, "__esModule", {
    value: true
});
$599b7a41538cb619$exports["default"] = $599b7a41538cb619$exports.ReactGAImplementation = void 0;

var $599b7a41538cb619$var$_ga = $599b7a41538cb619$var$_interopRequireWildcard((parcelRequire("2gz21")));
function $599b7a41538cb619$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($599b7a41538cb619$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $599b7a41538cb619$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $599b7a41538cb619$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $599b7a41538cb619$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $599b7a41538cb619$var$ReactGAImplementation = $599b7a41538cb619$var$_ga.GA4;
$599b7a41538cb619$exports.ReactGAImplementation = $599b7a41538cb619$var$ReactGAImplementation;
var $599b7a41538cb619$var$_default = $599b7a41538cb619$var$_ga["default"];
$599b7a41538cb619$exports["default"] = $599b7a41538cb619$var$_default;







var $4hYjL = parcelRequire("4hYjL");

function $441120fd961aac50$var$$f63eea9d7c5f466f$export$2e2bcd8739ae039(v1, v2) {
    return String(v1) === String(v2);
}
function $441120fd961aac50$var$$f7a118348608ef0e$export$2e2bcd8739ae039(value, options) {
    if (Array.isArray(value)) return value.map((v)=>options.find((o)=>$441120fd961aac50$var$$f63eea9d7c5f466f$export$2e2bcd8739ae039(o.value, v))).filter((o)=>o);
    return options.find((o)=>$441120fd961aac50$var$$f63eea9d7c5f466f$export$2e2bcd8739ae039(o.value, value)) || null;
}
function $441120fd961aac50$var$$ab17a5af9c7227da$export$2e2bcd8739ae039(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $441120fd961aac50$var$$fcc1d8b4a4fe77ec$export$2e2bcd8739ae039(newOption, oldOption, multiple) {
    if (!newOption) return oldOption;
    if (!multiple) return newOption;
    if (!oldOption) return $441120fd961aac50$var$$ab17a5af9c7227da$export$2e2bcd8739ae039(newOption);
    const nextOption = $441120fd961aac50$var$$ab17a5af9c7227da$export$2e2bcd8739ae039(oldOption);
    const newOptionIndex = nextOption.findIndex((o)=>$441120fd961aac50$var$$f63eea9d7c5f466f$export$2e2bcd8739ae039(o.value, newOption.value));
    if (newOptionIndex >= 0) nextOption.splice(newOptionIndex, 1);
    else nextOption.push(newOption);
    return nextOption;
}
function $441120fd961aac50$var$$29242e7c542b89e5$export$2e2bcd8739ae039(option, options, placeholder) {
    if (!option && !placeholder) return options && options.length ? options[0].name || "" : "";
    const isMultiple = Array.isArray(option);
    if (!option && !isMultiple) return "";
    return isMultiple ? option.map((o)=>o.name).filter(Boolean).join(", ") : option.name || "";
}
function $441120fd961aac50$var$$8f7d71ac34985a60$export$2e2bcd8739ae039(option) {
    if (!option) return null;
    if (Array.isArray(option)) return option.filter(Boolean).map((o)=>o.value);
    return option.value || null;
}
function $441120fd961aac50$var$$559302edb229d5e8$export$2e2bcd8739ae039(options) {
    const nextOptions = [];
    options.forEach((option)=>{
        if (option.group) {
            const group = nextOptions.findIndex((o)=>o.type === "group" && o.name === option.group);
            if (group >= 0) nextOptions[group].items.push(option);
            else nextOptions.push({
                items: [
                    option
                ],
                type: "group",
                name: option.group
            });
        } else nextOptions.push(option);
    });
    return nextOptions;
}
function $441120fd961aac50$var$$e2eb089248fa8007$var$search(q, text) {
    const searchLength = q.length;
    const textLength = text.length;
    if (searchLength > textLength) return false;
    if (text.indexOf(q) >= 0) return true;
    mainLoop: for(let i = 0, j = 0; i < searchLength; i += 1){
        const ch = q.charCodeAt(i);
        while(j < textLength){
            if (text.charCodeAt(j++) === ch) continue mainLoop;
        }
        return false;
    }
    return true;
}
function $441120fd961aac50$var$$e2eb089248fa8007$export$2e2bcd8739ae039(options, query) {
    return !query.length ? options : options.filter((o)=>$441120fd961aac50$var$$e2eb089248fa8007$var$search(query.toLowerCase(), `${o.name} ${o.group || ""}`.trim().toLowerCase()));
}
function $441120fd961aac50$var$$5b742793c6607960$export$2e2bcd8739ae039(middleware, items, query) {
    return middleware.filter(Boolean).reduce((data, cb)=>cb(data, query), items).map((item, i)=>({
            ...item,
            index: i
        }));
}
function $441120fd961aac50$var$$ab7b6b8f43adf325$export$2e2bcd8739ae039(options) {
    let index = 0;
    return options.map((option)=>{
        if (option.type === "group") return option.items.map((o)=>({
                ...o,
                group: option.name,
                index: index++
            }));
        return {
            ...option,
            index: index++
        };
    }).flat();
}
function $441120fd961aac50$var$$21775510bb0d6713$export$2e2bcd8739ae039(defaultOptions, getOptions, debounceTime, search) {
    const [options, setOptions] = (0, $4hYjL.useState)(()=>$441120fd961aac50$var$$ab7b6b8f43adf325$export$2e2bcd8739ae039(defaultOptions));
    const [fetching, setFetching] = (0, $4hYjL.useState)(false);
    (0, $4hYjL.useEffect)(()=>{
        let timeout;
        if (!getOptions) return;
        timeout = setTimeout(()=>{
            const optionsReq = getOptions(search, options);
            setFetching(true);
            Promise.resolve(optionsReq).then((newOptions)=>setOptions($441120fd961aac50$var$$ab7b6b8f43adf325$export$2e2bcd8739ae039(newOptions))).finally(()=>setFetching(false));
        }, debounceTime);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        search
    ]);
    (0, $4hYjL.useEffect)(()=>{
        setOptions($441120fd961aac50$var$$ab7b6b8f43adf325$export$2e2bcd8739ae039(defaultOptions));
    }, [
        defaultOptions
    ]);
    return [
        options,
        fetching
    ];
}
function $441120fd961aac50$var$$e86f7a275d5b9934$export$2e2bcd8739ae039(current, dir, options) {
    const max = options.length - 1;
    let option = null;
    let i = -1;
    let newHighlighted = current;
    while(i++ <= max && (!option || option.disabled)){
        newHighlighted = dir === "down" ? newHighlighted + 1 : newHighlighted - 1;
        if (newHighlighted < 0) newHighlighted = max;
        else if (newHighlighted > max) newHighlighted = 0;
        option = options[newHighlighted];
    }
    return newHighlighted;
}
function $441120fd961aac50$var$$8c63ada902e0d18e$export$2e2bcd8739ae039(options, onSelect, ref) {
    const [highlighted, setHighlighted] = (0, $4hYjL.useState)(-1);
    return [
        {
            onKeyDown: (e)=>{
                const key = e.key.replace("Arrow", "").toLowerCase();
                if (key === "down" || key === "up") {
                    e.preventDefault();
                    setHighlighted($441120fd961aac50$var$$e86f7a275d5b9934$export$2e2bcd8739ae039(highlighted, key, options));
                }
            },
            onKeyUp: (e)=>{
                if (e.key === "Escape") {
                    e.preventDefault();
                    ref.current.blur();
                } else if (e.key === "Enter") {
                    e.preventDefault();
                    if (options[highlighted]) onSelect(options[highlighted].value);
                }
            }
        },
        highlighted,
        setHighlighted
    ];
}
const $441120fd961aac50$var$$0d0f732c1d5a71da$var$nullCb = ()=>{};
function $441120fd961aac50$export$e64b2f635402ca43({ options: defaultOptions, defaultValue: defaultValue, value: value, multiple: multiple, search: search, onChange: onChange = $441120fd961aac50$var$$0d0f732c1d5a71da$var$nullCb, onFocus: onFocus = $441120fd961aac50$var$$0d0f732c1d5a71da$var$nullCb, onBlur: onBlur = $441120fd961aac50$var$$0d0f732c1d5a71da$var$nullCb, closeOnSelect: closeOnSelect = true, placeholder: placeholder, getOptions: getOptions, filterOptions: filterOptions, useFuzzySearch: useFuzzySearch = true, debounce: debounce }) {
    const ref = (0, $4hYjL.useRef)();
    const [option, setOption] = (0, $4hYjL.useState)(null);
    const [q, setSearch] = (0, $4hYjL.useState)("");
    const [focus, setFocus] = (0, $4hYjL.useState)(false);
    const [options, fetching] = $441120fd961aac50$var$$21775510bb0d6713$export$2e2bcd8739ae039(defaultOptions, getOptions, debounce, q);
    const onSelect = (v)=>{
        const newOption = $441120fd961aac50$var$$fcc1d8b4a4fe77ec$export$2e2bcd8739ae039($441120fd961aac50$var$$f7a118348608ef0e$export$2e2bcd8739ae039(decodeURIComponent(v), options), option, multiple);
        if (value === undefined) setOption(newOption);
        onChange($441120fd961aac50$var$$8f7d71ac34985a60$export$2e2bcd8739ae039(newOption), newOption);
        setTimeout(()=>{
            if (ref.current && closeOnSelect) ref.current.blur();
        }, 0);
    };
    const [keyHandlers, highlighted, setHighlighted] = $441120fd961aac50$var$$8c63ada902e0d18e$export$2e2bcd8739ae039(options, onSelect, ref);
    const middleware = [
        useFuzzySearch ? $441120fd961aac50$var$$e2eb089248fa8007$export$2e2bcd8739ae039 : null,
        ...filterOptions ? filterOptions : []
    ];
    const snapshot = {
        search: q,
        focus: focus,
        option: option,
        value: $441120fd961aac50$var$$8f7d71ac34985a60$export$2e2bcd8739ae039(option),
        fetching: fetching,
        highlighted: highlighted,
        options: $441120fd961aac50$var$$559302edb229d5e8$export$2e2bcd8739ae039($441120fd961aac50$var$$5b742793c6607960$export$2e2bcd8739ae039(middleware, options, q)),
        displayValue: $441120fd961aac50$var$$29242e7c542b89e5$export$2e2bcd8739ae039(option, options, placeholder)
    };
    const valueProps = {
        tabIndex: "0",
        readOnly: !search,
        placeholder: placeholder,
        value: focus && search ? q : snapshot.displayValue,
        ref: ref,
        ...keyHandlers,
        onFocus: (e)=>{
            setFocus(true);
            onFocus(e);
        },
        onBlur: (e)=>{
            setFocus(false);
            setSearch("");
            setHighlighted(-1);
            onBlur(e);
        },
        onMouseDown: (e)=>{
            if (focus) {
                e.preventDefault();
                ref.current.blur();
            }
        },
        onChange: search ? ({ target: target })=>setSearch(target.value) : null
    };
    const optionProps = {
        tabIndex: "-1",
        onMouseDown (e) {
            e.preventDefault();
            onSelect(e.currentTarget.value);
        }
    };
    (0, $4hYjL.useEffect)(()=>{
        setOption($441120fd961aac50$var$$f7a118348608ef0e$export$2e2bcd8739ae039(value === undefined ? defaultValue : value, options));
    }, [
        value,
        options
    ]);
    return [
        snapshot,
        valueProps,
        optionProps
    ];
}
const $441120fd961aac50$var$$461fda4bde208857$var$isString = (str)=>typeof str === "string";
const $441120fd961aac50$var$$461fda4bde208857$var$getClassName = (str, className)=>$441120fd961aac50$var$$461fda4bde208857$var$isString(className) ? `${className}-${str}` : className[str];
function $441120fd961aac50$var$$461fda4bde208857$export$2e2bcd8739ae039(classNames, className) {
    if ($441120fd961aac50$var$$461fda4bde208857$var$isString(classNames)) return $441120fd961aac50$var$$461fda4bde208857$var$getClassName(classNames, className);
    return Object.entries(classNames).filter(([cls, display])=>cls && display).map(([cls])=>$441120fd961aac50$var$$461fda4bde208857$var$getClassName(cls, className)).join(" ");
}
function $441120fd961aac50$var$$9b55b4f5631730e8$var$Option({ optionProps: optionProps, highlighted: highlighted, selected: selected, option: option, cls: cls, renderOption: renderOption, disabled: disabled }) {
    const props = {
        ...optionProps,
        value: encodeURIComponent(option.value),
        disabled: disabled
    };
    const className = cls({
        option: true,
        "is-selected": selected,
        "is-highlighted": highlighted
    });
    return (0, $35b7bd865360a597$exports.jsxs)("li", {
        className: cls("row"),
        role: "menuitem",
        "data-index": option.index,
        children: [
            renderOption && renderOption(props, option, {
                selected: selected,
                highlighted: highlighted
            }, className),
            !renderOption && (0, $35b7bd865360a597$exports.jsx)("button", {
                type: "button",
                className: className,
                ...props,
                children: option.name
            })
        ]
    });
}
var $441120fd961aac50$var$$9b55b4f5631730e8$export$2e2bcd8739ae039 = (0, $4hYjL.memo)($441120fd961aac50$var$$9b55b4f5631730e8$var$Option);
function $441120fd961aac50$var$$b5eecf9f88e2d7ae$export$2e2bcd8739ae039(option, selectedOption) {
    if (!selectedOption) return false;
    return Array.isArray(selectedOption) ? selectedOption.findIndex((o)=>o.value === option.value) >= 0 : selectedOption.value === option.value;
}
function $441120fd961aac50$var$$1b5fcad01c07e709$var$Options(props) {
    const { options: options, cls: cls, renderOption: renderOption, renderGroupHeader: renderGroupHeader, optionProps: optionProps, snapshot: snapshot, disabled: disabled } = props;
    return (0, $35b7bd865360a597$exports.jsx)("ul", {
        className: cls("options"),
        children: options.map((o)=>{
            if (o.type === "group") return (0, $35b7bd865360a597$exports.jsx)("li", {
                role: "none",
                className: cls("row"),
                children: (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: cls("group"),
                    children: [
                        (0, $35b7bd865360a597$exports.jsx)("div", {
                            className: cls("group-header"),
                            children: renderGroupHeader ? renderGroupHeader(o.name) : o.name
                        }),
                        (0, $35b7bd865360a597$exports.jsx)($441120fd961aac50$var$$1b5fcad01c07e709$var$Options, {
                            ...props,
                            options: o.items
                        })
                    ]
                })
            }, o.name);
            return (0, $35b7bd865360a597$exports.jsx)($441120fd961aac50$var$$9b55b4f5631730e8$export$2e2bcd8739ae039, {
                option: o,
                optionProps: optionProps,
                cls: cls,
                renderOption: renderOption,
                selected: $441120fd961aac50$var$$b5eecf9f88e2d7ae$export$2e2bcd8739ae039(o, snapshot.option),
                highlighted: snapshot.highlighted === o.index,
                disabled: o.disabled || disabled
            }, o.value);
        })
    });
}
var $441120fd961aac50$var$$1b5fcad01c07e709$export$2e2bcd8739ae039 = (0, $4hYjL.memo)($441120fd961aac50$var$$1b5fcad01c07e709$var$Options);
const $441120fd961aac50$var$$00d3317695af813e$var$SelectSearch = (0, $4hYjL.forwardRef)(({ disabled: disabled, placeholder: placeholder, multiple: multiple, search: search, autoFocus: autoFocus, autoComplete: autoComplete, id: id, closeOnSelect: closeOnSelect, className: className, renderValue: renderValue, renderOption: renderOption, renderGroupHeader: renderGroupHeader, fuzzySearch: fuzzySearch, emptyMessage: emptyMessage, value: value, ...hookProps }, ref)=>{
    const selectRef = (0, $4hYjL.useRef)(null);
    const cls = (classNames)=>$441120fd961aac50$var$$461fda4bde208857$export$2e2bcd8739ae039(classNames, className);
    const [controlledValue, setControlledValue] = (0, $4hYjL.useState)(value);
    const [snapshot, valueProps, optionProps] = $441120fd961aac50$export$e64b2f635402ca43({
        value: controlledValue,
        placeholder: placeholder,
        multiple: multiple,
        search: search,
        closeOnSelect: closeOnSelect && !multiple,
        useFuzzySearch: fuzzySearch,
        ...hookProps
    });
    const { highlighted: highlighted, value: snapValue, fetching: fetching, focus: focus } = snapshot;
    const props = {
        ...valueProps,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        disabled: disabled
    };
    (0, $4hYjL.useEffect)(()=>{
        const { current: current } = selectRef;
        if (current) {
            const val = Array.isArray(snapValue) ? snapValue[0] : snapValue;
            const selected = current.querySelector(highlighted > -1 ? `[data-index="${highlighted}"]` : `[value="${encodeURIComponent(val)}"]`);
            if (selected) {
                const rect = current.getBoundingClientRect();
                const selectedRect = selected.getBoundingClientRect();
                current.scrollTop = selected.offsetTop - rect.height / 2 + selectedRect.height / 2;
            }
        }
    }, [
        snapValue,
        highlighted,
        selectRef.current
    ]);
    (0, $4hYjL.useEffect)(()=>setControlledValue(value), [
        value
    ]);
    return (0, $35b7bd865360a597$exports.jsxs)("div", {
        ref: ref,
        id: id,
        className: cls({
            container: true,
            "is-multiple": multiple,
            "is-disabled": disabled,
            "is-loading": fetching,
            "has-focus": focus
        }),
        children: [
            (!multiple || placeholder || search) && (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: cls("value"),
                children: [
                    renderValue && renderValue(props, snapshot, cls("input")),
                    !renderValue && (0, $35b7bd865360a597$exports.jsx)("input", {
                        ...props,
                        className: cls("input")
                    })
                ]
            }),
            (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: cls("select"),
                ref: selectRef,
                onMouseDown: (e)=>e.preventDefault(),
                children: [
                    snapshot.options.length > 0 && (0, $35b7bd865360a597$exports.jsx)($441120fd961aac50$var$$1b5fcad01c07e709$export$2e2bcd8739ae039, {
                        options: snapshot.options,
                        optionProps: optionProps,
                        renderOption: renderOption,
                        renderGroupHeader: renderGroupHeader,
                        disabled: disabled,
                        snapshot: snapshot,
                        cls: cls
                    }),
                    !snapshot.options.length && (0, $35b7bd865360a597$exports.jsx)("ul", {
                        className: cls("options"),
                        children: !snapshot.options.length && emptyMessage && (0, $35b7bd865360a597$exports.jsx)("li", {
                            className: cls("not-found"),
                            children: emptyMessage
                        })
                    })
                ]
            })
        ]
    });
});
$441120fd961aac50$var$$00d3317695af813e$var$SelectSearch.defaultProps = {
    // Data
    options: [],
    fuzzySearch: true,
    // Interaction´
    printOptions: "auto",
    closeOnSelect: true,
    debounce: 250,
    // Attributes
    autoComplete: "on",
    // Design
    className: "select-search"
};
$441120fd961aac50$var$$00d3317695af813e$var$SelectSearch.displayName = "SelectSearch";
var $441120fd961aac50$var$$00d3317695af813e$export$2e2bcd8739ae039 = (0, $4hYjL.memo)($441120fd961aac50$var$$00d3317695af813e$var$SelectSearch);
var $441120fd961aac50$export$2e2bcd8739ae039 = $441120fd961aac50$var$$00d3317695af813e$export$2e2bcd8739ae039;






parcelRequire("4hYjL");
// Note: This component is also used inside the app, to signal an error on the magnet request form.
const $ff4dbaa01637bf3d$var$RegistrationError = ({ errorMessage: errorMessage })=>{
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "skraning-form-error",
        children: errorMessage ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: "fa fa-exclamation-triangle",
                    "aria-hidden": "true"
                }),
                " ",
                errorMessage
            ]
        }) : ""
    });
};
var $ff4dbaa01637bf3d$export$2e2bcd8739ae039 = $ff4dbaa01637bf3d$var$RegistrationError;





(0, (/*@__PURE__*/$parcel$interopDefault($599b7a41538cb619$exports))).initialize("UA-40901004-10");
const $885459ca180c2eac$export$150b732325d14d04 = {
    is: {
        Registration: {
            Nýskráning: "N\xfdskr\xe1ning",
            Nafn: "Fullt nafn",
            Netfang: "Netfang",
            "\xd6kukennarinn \xfeinn": "\xd6kukennarinn \xfeinn",
            Aðgangur: "A\xf0gangur",
            "Kennitala nemanda": "Kennitala nemanda",
            Lykilorð: "Lykilor\xf0",
            "\xc9g sam\xfeykki": "\xc9g sam\xfeykki",
            "skilm\xe1la Ur\xf0arbrunns": "skilm\xe1la Ur\xf0arbrunns",
            Nýskrá: "N\xfdskr\xe1",
            "Veldu \xf6kukennara": "Veldu \xf6kukennara",
            Námsheimild: "\xc9g hef fari\xf0 \xed einn e\xf0a fleiri verklegan \xf6kut\xedma.",
            NámsheimildTooltip: "Samkv\xe6mt reglum Samg\xf6ngustofu \xfearft \xfe\xfa a\xf0 hafa loki\xf0 a\xf0 minnsta kosti einum \xf6kut\xedma og fengi\xf0 n\xe1msheimild til \xfeess a\xf0 hefja n\xe1m \xed \xd6kusk\xf3la 1 og 2"
        }
    },
    en: {
        Registration: {
            Nýskráning: "Register",
            Nafn: "Full name",
            Netfang: "Email",
            "\xd6kukennarinn \xfeinn": "Your driving instructor",
            Aðgangur: "Your account",
            "Kennitala nemanda": "Kennitala",
            Lykilorð: "Password",
            "\xc9g sam\xfeykki": "I agree to the schools",
            "skilm\xe1la Ur\xf0arbrunns": "terms and conditions",
            Nýskrá: "N\xfdskr\xe1",
            "Veldu \xf6kukennara": "Choose instructor",
            Námsheimild: "I have gone to one or more driving instructor lessons.",
            NámsheimildTooltip: "According to the Icelandic Transport Authority's rules, you must have completed at least one driving lesson and received a study permit to begin studying in Driving School 1 and 2"
        }
    }
};
const $885459ca180c2eac$var$Registration = ({ authReducer: authReducer })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    const history = (0, $87978d8bc0f45f32$export$3420e1dc2c4a518c)();
    const [lastStateChange, setLastStateChange] = (0, $4hYjL.useState)(Date.now()); // Hacky way to subscribe to changes in the form.
    const [state, setState] = (0, $4hYjL.useState)({
        errors: [],
        error: false,
        ssnError: "",
        passwordError: "",
        teacherError: "",
        emailExistsError: "",
        isLoading: false,
        teachers: [],
        isFormValid: false,
        form: {
            name: {
                value: "",
                valid: true
            },
            email: {
                value: "",
                valid: true
            },
            teacher: {
                value: null,
                valid: false
            },
            kennitala: {
                value: "",
                valid: true
            },
            password: {
                value: "",
                valid: true
            },
            skilmalar: {
                value: false,
                valid: false
            },
            namsheimild: {
                value: false,
                valid: false
            }
        }
    });
    (0, $4hYjL.useEffect)(()=>{
        fetchDrivingInstructors();
        redirectIfLoggedIn();
        checkIfFormIsValid();
    }, []);
    (0, $4hYjL.useEffect)(()=>{
        checkIfFormIsValid();
    }, [
        lastStateChange
    ]);
    const redirectIfLoggedIn = ()=>{
        if (authReducer.authenticated) history.push("/stjornbord");
    };
    const checkIfFormIsValid = ()=>{
        const { form: form } = state;
        let isFormValid = true;
        Object.keys(form).forEach((element)=>{
            if (!form[element].valid) isFormValid = false;
        });
        setState((prevState)=>({
                ...prevState,
                isFormValid: isFormValid
            }));
    };
    const onKeyDown = (event)=>{
        const { isFormValid: isFormValid } = state;
        if (isFormValid && event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit();
        }
    };
    const handleTextFieldChange = (event)=>{
        const { form: form } = state;
        const { name: name } = event.target;
        let isFieldValid = false;
        if (event.target.value.length > 0) isFieldValid = true;
        setState({
            ...state,
            form: {
                ...form,
                [name]: {
                    ...form[name],
                    value: event.target.value,
                    valid: isFieldValid
                }
            }
        });
        setLastStateChange(Date.now());
    };
    const updateCheckbox = (event)=>{
        const { form: form } = state;
        const { name: name } = event.target;
        setState({
            ...state,
            form: {
                ...form,
                [name]: {
                    ...form[name],
                    value: !form[name].value,
                    valid: !form[name].valid
                }
            }
        });
        setLastStateChange(Date.now());
    };
    const handleSelectChange = (chosenTeacher)=>{
        const { form: form } = state;
        setState({
            ...state,
            form: {
                ...form,
                teacher: {
                    value: chosenTeacher,
                    valid: true
                }
            }
        });
        setLastStateChange(Date.now());
    };
    const fetchDrivingInstructors = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get(`/api/teachers`).then((res)=>{
            const teachers = res.data.response;
            setState((prevState)=>({
                    ...prevState,
                    teachers: teachers
                }));
        });
    };
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        const { name: name, email: email, kennitala: kennitala, password: password, teacher: teacher } = state.form;
        setState({
            ...state,
            error: false,
            isLoading: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/register-user`, {
            name: name.value,
            ssn: kennitala.value,
            password: password.value,
            email: email.value,
            teacherId: teacher.value,
            language: lang
        }).then(()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($599b7a41538cb619$exports))).event({
                category: "Sign up flow",
                action: "User sign up"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($599b7a41538cb619$exports))).event("sign_up");
            setState({
                ...state,
                error: false,
                isLoading: false
            });
            window.location.href = "/stjornbord";
        }).catch((error)=>{
            const errorArray = error.response.data.errors;
            setState({
                ...state,
                teacherError: "",
                emailExistsError: "",
                passwordError: "",
                ssnError: "",
                errors: error.response.data.errors,
                error: true,
                isLoading: false
            });
            errorArray.forEach((errorItem)=>{
                if (errorItem.hasOwnProperty("email")) setState({
                    ...state,
                    emailExistsError: errorItem.email
                });
                if (errorItem.hasOwnProperty("password")) setState({
                    ...state,
                    passwordError: errorItem.password
                });
                if (errorItem.hasOwnProperty("ssn")) setState({
                    ...state,
                    ssnError: errorItem.ssn
                });
                if (errorItem.hasOwnProperty("teacher")) setState({
                    ...state,
                    teacherError: errorItem.teacher
                });
            });
        });
    };
    const { form: form, teachers: teachers, isFormValid: isFormValid, isLoading: isLoading, error: error } = state;
    const { name: name, email: email, kennitala: kennitala, password: password, skilmalar: skilmalar, namsheimild: namsheimild, teacher: teacher } = form;
    const options = teachers.map((teacherItem)=>({
            name: teacherItem.name,
            value: teacherItem.id
        }));
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "site-wrap",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "push-wrap",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                    pageTitle: t("Registration.N\xfdskr\xe1ning")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "main-body",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "skraning-section",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                    children: t("Registration.N\xfdskr\xe1ning")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("form", {
                                    className: "skraning-form",
                                    onKeyDown: onKeyDown,
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            className: "field-container",
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                        className: "field-name",
                                                        children: t("Registration.Nafn")
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                        type: "text",
                                                        required: true,
                                                        id: "name",
                                                        name: "name",
                                                        value: name.value,
                                                        onChange: handleTextFieldChange
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "field-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                            className: "field-name",
                                                            children: t("Registration.Netfang")
                                                        }),
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                            className: state.emailExistsError === "" ? "" : "has-error",
                                                            type: "text",
                                                            required: true,
                                                            id: "email",
                                                            name: "email",
                                                            value: email.value,
                                                            onChange: handleTextFieldChange
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff4dbaa01637bf3d$export$2e2bcd8739ae039), {
                                                    errorMessage: state.emailExistsError
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "field-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                    className: "field-name",
                                                    children: t("Registration.\xd6kukennarinn \xfeinn")
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $441120fd961aac50$export$2e2bcd8739ae039), {
                                                    options: options,
                                                    search: true,
                                                    onChange: (value)=>handleSelectChange(value),
                                                    value: teacher.value !== null ? teacher.value.toString() : undefined,
                                                    placeholder: t("Registration.Veldu \xf6kukennara")
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff4dbaa01637bf3d$export$2e2bcd8739ae039), {
                                                    errorMessage: state.teacherError
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                            children: t("Registration.A\xf0gangur")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "field-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                            className: "field-name",
                                                            children: t("Registration.Kennitala nemanda")
                                                        }),
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                            className: state.ssnError == null ? "" : "has-error",
                                                            type: "text",
                                                            required: true,
                                                            id: "kennitala",
                                                            name: "kennitala",
                                                            value: kennitala.value,
                                                            onChange: handleTextFieldChange,
                                                            maxLength: 11
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff4dbaa01637bf3d$export$2e2bcd8739ae039), {
                                                    errorMessage: state.ssnError
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "field-container last-field-container",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                                            className: "field-name",
                                                            children: t("Registration.Lykilor\xf0")
                                                        }),
                                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                            className: state.passwordError == null ? "" : "has-error",
                                                            type: "password",
                                                            required: true,
                                                            id: "password",
                                                            name: "password",
                                                            value: password.value,
                                                            onChange: handleTextFieldChange
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff4dbaa01637bf3d$export$2e2bcd8739ae039), {
                                                    errorMessage: state.passwordError
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            className: "checkbox-container",
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                htmlFor: "namsheimild",
                                                className: "namsheimild-label",
                                                children: [
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        id: "namsheimild",
                                                        name: "namsheimild",
                                                        required: true,
                                                        checked: namsheimild.value,
                                                        onChange: updateCheckbox
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("span", {
                                                        className: "label-text",
                                                        children: [
                                                            t("Registration.N\xe1msheimild"),
                                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                                                className: "help-icon",
                                                                title: t("Registration.N\xe1msheimildTooltip"),
                                                                children: "?"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            className: "checkbox-container",
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                                htmlFor: "skilmalar",
                                                children: [
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        id: "skilmalar",
                                                        name: "skilmalar",
                                                        required: true,
                                                        checked: skilmalar.value,
                                                        onChange: updateCheckbox
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("span", {
                                                        className: "label-text",
                                                        children: [
                                                            t("Registration.\xc9g sam\xfeykki"),
                                                            " ",
                                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).TermsAndConditions),
                                                                target: "_blank",
                                                                className: "skilmala-link",
                                                                children: [
                                                                    t("Registration.skilm\xe1la Ur\xf0arbrunns"),
                                                                    "."
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                            className: "btn-div",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("button", {
                                                    onClick: handleSubmit,
                                                    type: "submit",
                                                    id: "submit",
                                                    className: "btn",
                                                    disabled: !isFormValid,
                                                    children: [
                                                        isLoading ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                                            className: "lds-ring",
                                                            children: [
                                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {})
                                                            ]
                                                        }) : "",
                                                        t("Registration.N\xfdskr\xe1")
                                                    ]
                                                }),
                                                error ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff4dbaa01637bf3d$export$2e2bcd8739ae039), {
                                                    errorMessage: "\xdea\xf0 kom upp villa, sj\xe1\xf0u frekar \xed forminu ↑"
                                                }) : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
const $885459ca180c2eac$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $885459ca180c2eac$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($885459ca180c2eac$var$mapStateToProps)($885459ca180c2eac$var$Registration);




var $4hYjL = parcelRequire("4hYjL");






const $9006db8f79d2e261$export$150b732325d14d04 = {
    is: {
        NotFound: {
            "404 - S\xed\xf0a er ekki til": "404 - S\xed\xf0a er ekki til",
            "\xc1 hva\xf0a lei\xf0 varst \xfe\xfa f\xe9lagi?": "\xc1 hva\xf0a lei\xf0 varst \xfe\xfa f\xe9lagi?",
            "\xdeessi s\xed\xf0a er ekki til!": "\xdeessi s\xed\xf0a er ekki til!"
        }
    },
    en: {
        NotFound: {
            "404 - S\xed\xf0a er ekki til": "404 - Page not found",
            "\xc1 hva\xf0a lei\xf0 varst \xfe\xfa f\xe9lagi?": "It's a dead end.",
            "\xdeessi s\xed\xf0a er ekki til!": "This page doesn't exist! :-/"
        }
    }
};
const $9006db8f79d2e261$var$NotFound = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const { i18n: i18n } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    // Change the language, in case the route exists but in a different language
    // This is important for the pre-renderer.
    const changeLanguage = ()=>{
        const newLang = lang === "en" ? "is" : "en";
        i18n.changeLanguage(newLang);
        localStorage.setItem("language", newLang);
    };
    (0, $4hYjL.useEffect)(()=>{
        changeLanguage();
    }, []);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5e0021919929c8b4$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("title", {
                    children: "404 | Ur\xf0arbrunnur Net\xf6kusk\xf3li"
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "main-body",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "default-text-container",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                    children: t("NotFound.404 - S\xed\xf0a er ekki til")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    children: t("NotFound.\xc1 hva\xf0a lei\xf0 varst \xfe\xfa f\xe9lagi?")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    children: t("NotFound.\xdeessi s\xed\xf0a er ekki til!")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $9006db8f79d2e261$export$2e2bcd8739ae039 = $9006db8f79d2e261$var$NotFound;



parcelRequire("4hYjL");

parcelRequire("4hYjL");




const $d5e625687d701cdc$var$Template = ({ title: title, description: description, keywords: keywords, imageOptions: imageOptions, children: children })=>{
    const keywordsString = keywords.join(", ");
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "site-wrap",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e814f84530fe6172$export$2e2bcd8739ae039), {
                pageTitle: title,
                keywords: keywordsString,
                image: `https://www.urdarbrunnur.is${imageOptions.imgSrc}`
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "push-wrap",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5800fa3ce5ed806d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ece04713077ea625$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "main-body blog-text",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                className: "sub-title",
                                children: description
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                alt: imageOptions.imgAlt,
                                src: imageOptions.imgSrc
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                className: "image-caption",
                                children: imageOptions.imgCaption
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1bd9e4aadcbd1f36$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $d5e625687d701cdc$export$2e2bcd8739ae039 = $d5e625687d701cdc$var$Template;


var $839da9af9fcc35ae$exports = {};
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2021, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    $839da9af9fcc35ae$exports = factory();
})($839da9af9fcc35ae$exports, function() {
    "use strict";
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var defaults$5 = {
        exports: {}
    };
    function getDefaults$1() {
        return {
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: "",
            highlight: null,
            langPrefix: "language-",
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartLists: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    function changeDefaults$1(newDefaults) {
        defaults$5.exports.defaults = newDefaults;
    }
    defaults$5.exports = {
        defaults: getDefaults$1(),
        getDefaults: getDefaults$1,
        changeDefaults: changeDefaults$1
    };
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = /[&<>"']/g;
    var escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
    var escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
    var escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape$2(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function unescape$1(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    var caret = /(^|[^\[])\^/g;
    function edit$1(regex, opt) {
        regex = regex.source || regex;
        opt = opt || "";
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, "$1");
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function cleanUrl$1(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape$1(href)).replace(nonWordAndColonTest, "").toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    function resolveUrl(base, href) {
        if (!baseUrls[" " + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[" " + base] = base + "/";
            else baseUrls[" " + base] = rtrim$1(base, "/", true);
        }
        base = baseUrls[" " + base];
        var relativeBase = base.indexOf(":") === -1;
        if (href.substring(0, 2) === "//") {
            if (relativeBase) return href;
            return base.replace(protocol, "$1") + href;
        } else if (href.charAt(0) === "/") {
            if (relativeBase) return href;
            return base.replace(domain, "$1") + href;
        } else return base + href;
    }
    var noopTest$1 = {
        exec: function noopTest() {}
    };
    function merge$2(obj) {
        var i = 1, target, key;
        for(; i < arguments.length; i++){
            target = arguments[i];
            for(key in target)if (Object.prototype.hasOwnProperty.call(target, key)) obj[key] = target[key];
        }
        return obj;
    }
    function splitCells$1(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        var i = 0;
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    } // Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
    // /c*$/ is vulnerable to REDOS.
    // invert: Remove suffix of non-c chars instead. Default falsey.
    function rtrim$1(str, c, invert) {
        var l = str.length;
        if (l === 0) return "";
         // Length of suffix matching the invert condition.
        var suffLen = 0; // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.substr(0, l - suffLen);
    }
    function findClosingBracket$1(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation$1(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    } // copied from https://stackoverflow.com/a/5450113/806777
    function repeatString$1(pattern, count) {
        if (count < 1) return "";
        var result = "";
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    var helpers = {
        escape: escape$2,
        unescape: unescape$1,
        edit: edit$1,
        cleanUrl: cleanUrl$1,
        resolveUrl: resolveUrl,
        noopTest: noopTest$1,
        merge: merge$2,
        splitCells: splitCells$1,
        rtrim: rtrim$1,
        findClosingBracket: findClosingBracket$1,
        checkSanitizeDeprecation: checkSanitizeDeprecation$1,
        repeatString: repeatString$1
    };
    var defaults$4 = defaults$5.exports.defaults;
    var rtrim = helpers.rtrim, splitCells = helpers.splitCells, _escape = helpers.escape, findClosingBracket = helpers.findClosingBracket;
    function outputLink(cap, link, raw) {
        var href = link.href;
        var title = link.title ? _escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") return {
            type: "link",
            raw: raw,
            href: href,
            title: title,
            text: text
        };
        else return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: _escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split("\n").map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
   * Tokenizer
   */ var Tokenizer_1 = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || defaults$4;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap) {
                if (cap[0].length > 1) return {
                    type: "space",
                    raw: cap[0]
                };
                return {
                    raw: "\n"
                };
            }
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim() : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim(); // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text
                };
            }
        };
        _proto.nptable = function nptable(src) {
            var cap = this.rules.block.nptable.exec(src);
            if (cap) {
                var item = {
                    type: "table",
                    header: splitCells(cap[1].replace(/^ *| *\| *$/g, "")),
                    align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: cap[3] ? cap[3].replace(/\n$/, "").split("\n") : [],
                    raw: cap[0]
                };
                if (item.header.length === item.align.length) {
                    var l = item.align.length;
                    var i;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = "right";
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = "center";
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = "left";
                        else item.align[i] = null;
                    }
                    l = item.cells.length;
                    for(i = 0; i < l; i++)item.cells[i] = splitCells(item.cells[i], item.header.length);
                    return item;
                }
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *> ?/gm, "");
                return {
                    type: "blockquote",
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw = cap[0];
                var bull = cap[2];
                var isordered = bull.length > 1;
                var list = {
                    type: "list",
                    raw: raw,
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                }; // Get each top-level item.
                var itemMatch = cap[0].match(this.rules.block.item);
                var next = false, item, space, bcurr, bnext, addBack, loose, istask, ischecked, endMatch;
                var l = itemMatch.length;
                bcurr = this.rules.block.listItemStart.exec(itemMatch[0]);
                for(var i = 0; i < l; i++){
                    item = itemMatch[i];
                    raw = item;
                    if (!this.options.pedantic) {
                        // Determine if current item contains the end of the list
                        endMatch = item.match(new RegExp("\\n\\s*\\n {0," + (bcurr[0].length - 1) + "}\\S"));
                        if (endMatch) {
                            addBack = item.length - endMatch.index + itemMatch.slice(i + 1).join("\n").length;
                            list.raw = list.raw.substring(0, list.raw.length - addBack);
                            item = item.substring(0, endMatch.index);
                            raw = item;
                            l = i + 1;
                        }
                    } // Determine whether the next list item belongs here.
                    // Backpedal if it does not belong in this list.
                    if (i !== l - 1) {
                        bnext = this.rules.block.listItemStart.exec(itemMatch[i + 1]);
                        if (!this.options.pedantic ? bnext[1].length >= bcurr[0].length || bnext[1].length > 3 : bnext[1].length > bcurr[1].length) {
                            // nested list or continuation
                            itemMatch.splice(i, 2, itemMatch[i] + (!this.options.pedantic && bnext[1].length < bcurr[0].length && !itemMatch[i].match(/\n$/) ? "" : "\n") + itemMatch[i + 1]);
                            i--;
                            l--;
                            continue;
                        } else if (!this.options.pedantic || this.options.smartLists ? bnext[2][bnext[2].length - 1] !== bull[bull.length - 1] : isordered === (bnext[2].length === 1)) {
                            addBack = itemMatch.slice(i + 1).join("\n").length;
                            list.raw = list.raw.substring(0, list.raw.length - addBack);
                            i = l - 1;
                        }
                        bcurr = bnext;
                    } // Remove the list item's bullet
                    // so it is seen as the next token.
                    space = item.length;
                    item = item.replace(/^ *([*+-]|\d+[.)]) ?/, ""); // Outdent whatever the
                    // list item contains. Hacky.
                    if (~item.indexOf("\n ")) {
                        space -= item.length;
                        item = !this.options.pedantic ? item.replace(new RegExp("^ {1," + space + "}", "gm"), "") : item.replace(/^ {1,4}/gm, "");
                    } // trim item newlines at end
                    item = rtrim(item, "\n");
                    if (i !== l - 1) raw = raw + "\n";
                     // Determine whether item is loose or not.
                    // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
                    // for discount behavior.
                    loose = next || /\n\n(?!\s*$)/.test(raw);
                    if (i !== l - 1) {
                        next = raw.slice(-2) === "\n\n";
                        if (!loose) loose = next;
                    }
                    if (loose) list.loose = true;
                     // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.test(item);
                        ischecked = undefined;
                        if (istask) {
                            ischecked = item[1] !== " ";
                            item = item.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: istask,
                        checked: ischecked,
                        loose: loose,
                        text: item
                    });
                }
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) return {
                type: this.options.sanitize ? "paragraph" : "html",
                raw: cap[0],
                pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
                text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0]
            };
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
                var tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: cap[2],
                    title: cap[3]
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: "table",
                    header: splitCells(cap[1].replace(/^ *| *\| *$/g, "")),
                    align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: cap[3] ? cap[3].replace(/\n$/, "").split("\n") : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = "right";
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = "center";
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = "left";
                        else item.align[i] = null;
                    }
                    l = item.cells.length;
                    for(i = 0; i < l; i++)item.cells[i] = splitCells(item.cells[i].replace(/^ *\| *| *\| *$/g, ""), item.header.length);
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1]
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) return {
                type: "paragraph",
                raw: cap[0],
                text: cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1]
            };
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0]
            };
        };
        _proto.escape = function escape(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: _escape(cap[1])
            };
        };
        _proto.tag = function tag(src, inLink, inRawBlock) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!inLink && /^<a /i.test(cap[0])) inLink = true;
                else if (inLink && /^<\/a>/i.test(cap[0])) inLink = false;
                if (!inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) inRawBlock = true;
                else if (inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) inRawBlock = false;
                return {
                    type: this.options.sanitize ? "text" : "html",
                    raw: cap[0],
                    inLink: inLink,
                    inRawBlock: inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                     // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                var href = cap[2];
                var title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                    title: title ? title.replace(this.rules.inline._escapes, "$1") : title
                }, cap[0]);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, " ");
                link = links[link.toLowerCase()];
                if (!link || !link.href) {
                    var text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0]);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = "";
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return; // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || "";
            if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0; // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal); // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) return {
                        type: "em",
                        raw: src.slice(0, lLength + match.index + rLength + 1),
                        text: src.slice(1, lLength + match.index + rLength)
                    };
                     // Create 'strong' if smallest delimiter has even char count. **a***
                    return {
                        type: "strong",
                        raw: src.slice(0, lLength + match.index + rLength + 1),
                        text: src.slice(2, lLength + match.index + rLength - 1)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, " ");
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = _escape(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2]
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === "@") {
                    text = _escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = _escape(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === "@") {
                    text = _escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = _escape(cap[0]);
                    if (cap[1] === "www.") href = "http://" + text;
                    else href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, inRawBlock, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0];
                else text = _escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    var noopTest = helpers.noopTest, edit = helpers.edit, merge$1 = helpers.merge;
    /**
   * Block-Level Grammar
   */ var block$1 = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
        hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?! {0,3}bull )\n*|\s*$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
        nptable: noopTest,
        table: noopTest,
        lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block$1._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
    block$1._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block$1.def = edit(block$1.def).replace("label", block$1._label).replace("title", block$1._title).getRegex();
    block$1.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block$1.item = /^( *)(bull) ?[^\n]*(?:\n(?! *bull ?)[^\n]*)*/;
    block$1.item = edit(block$1.item, "gm").replace(/bull/g, block$1.bullet).getRegex();
    block$1.listItemStart = edit(/^( *)(bull) */).replace("bull", block$1.bullet).getRegex();
    block$1.list = edit(block$1.list).replace(/bull/g, block$1.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block$1.def.source + ")").getRegex();
    block$1._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block$1._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block$1.html = edit(block$1.html, "i").replace("comment", block$1._comment).replace("tag", block$1._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block$1.paragraph = edit(block$1._paragraph).replace("hr", block$1.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$1._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block$1.blockquote = edit(block$1.blockquote).replace("paragraph", block$1.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block$1.normal = merge$1({}, block$1);
    /**
   * GFM Block Grammar
   */ block$1.gfm = merge$1({}, block$1.normal, {
        nptable: "^ *([^|\\n ].*\\|.*)\\n {0,3}([-:]+ *\\|[-| :]*)(?:\\n((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)",
        // Cells
        table: "^ *\\|(.+)\\n {0,3}\\|?( *[-:]+[-| :]*)(?:\\n *((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block$1.gfm.nptable = edit(block$1.gfm.nptable).replace("hr", block$1.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$1._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block$1.gfm.table = edit(block$1.gfm.table).replace("hr", block$1.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$1._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block$1.pedantic = merge$1({}, block$1.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", block$1._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        paragraph: edit(block$1.normal._paragraph).replace("hr", block$1.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block$1.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline$1 = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
        nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
        reflinkSearch: "reflink|nolink(?!\\()",
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //        () Skip other delimiter (1) #***                   (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /\_\_[^_*]*?\*[^_*]*?\_\_|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
            rDelimUnd: /\*\*[^_*]*?\_[^_*]*?\*\*|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    }; // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline$1._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
    inline$1.punctuation = edit(inline$1.punctuation).replace(/punctuation/g, inline$1._punctuation).getRegex(); // sequences em should skip over [title](link), `code`, <html>
    inline$1.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    inline$1.escapedEmSt = /\\\*|\\_/g;
    inline$1._comment = edit(block$1._comment).replace("(?:-->|$)", "-->").getRegex();
    inline$1.emStrong.lDelim = edit(inline$1.emStrong.lDelim).replace(/punct/g, inline$1._punctuation).getRegex();
    inline$1.emStrong.rDelimAst = edit(inline$1.emStrong.rDelimAst, "g").replace(/punct/g, inline$1._punctuation).getRegex();
    inline$1.emStrong.rDelimUnd = edit(inline$1.emStrong.rDelimUnd, "g").replace(/punct/g, inline$1._punctuation).getRegex();
    inline$1._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline$1._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline$1._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline$1.autolink = edit(inline$1.autolink).replace("scheme", inline$1._scheme).replace("email", inline$1._email).getRegex();
    inline$1._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline$1.tag = edit(inline$1.tag).replace("comment", inline$1._comment).replace("attribute", inline$1._attribute).getRegex();
    inline$1._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline$1._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline$1._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline$1.link = edit(inline$1.link).replace("label", inline$1._label).replace("href", inline$1._href).replace("title", inline$1._title).getRegex();
    inline$1.reflink = edit(inline$1.reflink).replace("label", inline$1._label).getRegex();
    inline$1.reflinkSearch = edit(inline$1.reflinkSearch, "g").replace("reflink", inline$1.reflink).replace("nolink", inline$1.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline$1.normal = merge$1({}, inline$1);
    /**
   * Pedantic Inline Grammar
   */ inline$1.pedantic = merge$1({}, inline$1.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline$1._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline$1._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline$1.gfm = merge$1({}, inline$1.normal, {
        escape: edit(inline$1.escape).replace("])", "~|])").getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline$1.gfm.url = edit(inline$1.gfm.url, "i").replace("email", inline$1.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline$1.breaks = merge$1({}, inline$1.gfm, {
        br: edit(inline$1.br).replace("{2,}", "*").getRegex(),
        text: edit(inline$1.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    var rules = {
        block: block$1,
        inline: inline$1
    };
    var Tokenizer$1 = Tokenizer_1;
    var defaults$3 = defaults$5.exports.defaults;
    var block = rules.block, inline = rules.inline;
    var repeatString = helpers.repeatString;
    /**
   * smartypants text replacement
   */ function smartypants(text) {
        return text // em-dashes
        .replace(/---/g, "—") // en-dashes
        .replace(/--/g, "–") // opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘") // closing singles & apostrophes
        .replace(/'/g, "’") // opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“") // closing doubles
        .replace(/"/g, "”") // ellipses
        .replace(/\.{3}/g, "…");
    }
    /**
   * mangle email addresses
   */ function mangle(text) {
        var out = "", i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = "x" + ch.toString(16);
            out += "&#" + ch + ";";
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer_1 = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || defaults$3;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer$1();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        } /**
     * Static Lex Inline Method
     */ ;
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        } /**
     * Preprocessing
     */ ;
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ");
            this.blockTokens(src, this.tokens, true);
            this.inline(this.tokens);
            return this.tokens;
        } /**
     * Lexing
     */ ;
        _proto.blockTokens = function blockTokens(src, tokens, top) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (top === void 0) top = true;
            if (this.options.pedantic) src = src.replace(/^ +$/gm, "");
            var token, i, l, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call(_this, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                 // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.type) tokens.push(token);
                    continue;
                } // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1]; // An indented code block cannot interrupt a paragraph.
                    if (lastToken && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                    } else tokens.push(token);
                    continue;
                } // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // table no leading pipe (gfm)
                if (token = this.tokenizer.nptable(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    token.tokens = this.blockTokens(token.text, [], top);
                    tokens.push(token);
                    continue;
                } // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    l = token.items.length;
                    for(i = 0; i < l; i++)token.items[i].tokens = this.blockTokens(token.items[i].text, [], false);
                    tokens.push(token);
                    continue;
                } // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // def
                if (top && (token = this.tokenizer.def(src))) {
                    src = src.substring(token.raw.length);
                    if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                } // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call(this, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                } // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _proto.inline = function inline(tokens) {
            var i, j, k, l2, row, token;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                switch(token.type){
                    case "paragraph":
                    case "text":
                    case "heading":
                        token.tokens = [];
                        this.inlineTokens(token.text, token.tokens);
                        break;
                    case "table":
                        token.tokens = {
                            header: [],
                            cells: []
                        }; // header
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++){
                            token.tokens.header[j] = [];
                            this.inlineTokens(token.header[j], token.tokens.header[j]);
                        } // cells
                        l2 = token.cells.length;
                        for(j = 0; j < l2; j++){
                            row = token.cells[j];
                            token.tokens.cells[j] = [];
                            for(k = 0; k < row.length; k++){
                                token.tokens.cells[j][k] = [];
                                this.inlineTokens(row[k], token.tokens.cells[j][k]);
                            }
                        }
                        break;
                    case "blockquote":
                        this.inline(token.tokens);
                        break;
                    case "list":
                        l2 = token.items.length;
                        for(j = 0; j < l2; j++)this.inline(token.items[j].tokens);
                        break;
                }
            }
            return tokens;
        } /**
     * Lexing/Compiling
     */ ;
        _proto.inlineTokens = function inlineTokens(src, tokens, inLink, inRawBlock) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            if (inLink === void 0) inLink = false;
            if (inRawBlock === void 0) inRawBlock = false;
            var token, lastToken, cutSrc; // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar; // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            } // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
             // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false; // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call(_this2, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                 // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // tag
                if (token = this.tokenizer.tag(src, inLink, inRawBlock)) {
                    src = src.substring(token.raw.length);
                    inLink = token.inLink;
                    inRawBlock = token.inRawBlock;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                } // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    if (token.type === "link") token.tokens = this.inlineTokens(token.text, [], true, inRawBlock);
                    tokens.push(token);
                    continue;
                } // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (token.type === "link") {
                        token.tokens = this.inlineTokens(token.text, [], true, inRawBlock);
                        tokens.push(token);
                    } else if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                } // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    token.tokens = this.inlineTokens(token.text, [], inLink, inRawBlock);
                    tokens.push(token);
                    continue;
                } // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    token.tokens = this.inlineTokens(token.text, [], inLink, inRawBlock);
                    tokens.push(token);
                    continue;
                } // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // url (gfm)
                if (!inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call(this, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, inRawBlock, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    var defaults$2 = defaults$5.exports.defaults;
    var cleanUrl = helpers.cleanUrl, escape$1 = helpers.escape;
    /**
   * Renderer
   */ var Renderer_1 = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || defaults$2;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || "").match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? _code : escape$1(_code, true)) + "</code></pre>\n";
            return '<pre><code class="' + this.options.langPrefix + escape$1(lang, true) + '">' + (escaped ? _code : escape$1(_code, true)) + "</code></pre>\n";
        };
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        };
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) return "<h" + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text + "</h" + level + ">\n";
             // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        };
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
        };
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        };
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        };
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? "th" : "td";
            var tag = flags.align ? "<" + type + ' align="' + flags.align + '">' : "<" + type + ">";
            return tag + content + "</" + type + ">\n";
        } // span level renderer
        ;
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        };
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        };
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? "<br/>" : "<br>";
        };
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        };
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + escape$1(href) + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        };
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<img src="' + href + '" alt="' + text + '"';
            if (title) out += ' title="' + title + '"';
            out += this.options.xhtml ? "/>" : ">";
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer_1 = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return "" + text;
        };
        _proto.image = function image(href, title, text) {
            return "" + text;
        };
        _proto.br = function br() {
            return "";
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger_1 = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim() // remove html tags
            .replace(/<[!\/a-z].*?>/ig, "") // remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
        } /**
     * Finds the next safe (unique) slug to use
     */ ;
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + "-" + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        } /**
     * Convert string to unique id
     * @param {object} options
     * @param {boolean} options.dryrun Generates the next unique slug without updating the internal accumulator.
     */ ;
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    var Renderer$1 = Renderer_1;
    var TextRenderer$1 = TextRenderer_1;
    var Slugger$1 = Slugger_1;
    var defaults$1 = defaults$5.exports.defaults;
    var unescape = helpers.unescape;
    /**
   * Parsing & Compiling
   */ var Parser_1 = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || defaults$1;
            this.options.renderer = this.options.renderer || new Renderer$1();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer$1();
            this.slugger = new Slugger$1();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        } /**
     * Static Parse Inline Method
     */ ;
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        } /**
     * Parse Loop
     */ ;
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = "", i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i]; // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call(this, token);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case "code":
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case "table":
                        header = ""; // header
                        cell = "";
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.tokens.header[j]), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = "";
                        l2 = token.cells.length;
                        for(j = 0; j < l2; j++){
                            row = token.tokens.cells[j];
                            cell = "";
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k]), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case "blockquote":
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case "list":
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = "";
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = "";
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === "text") {
                                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: "text",
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case "html":
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case "text":
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === "text"){
                            token = tokens[++i];
                            body += "\n" + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        } /**
     * Parse Inline Tokens
     */ ;
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = "", i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i]; // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call(this, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        out += renderer.text(token.text);
                        break;
                    case "html":
                        out += renderer.html(token.text);
                        break;
                    case "link":
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case "image":
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case "strong":
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case "em":
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case "codespan":
                        out += renderer.codespan(token.text);
                        break;
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case "text":
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Lexer = Lexer_1;
    var Parser = Parser_1;
    var Tokenizer = Tokenizer_1;
    var Renderer = Renderer_1;
    var TextRenderer = TextRenderer_1;
    var Slugger = Slugger_1;
    var merge = helpers.merge, checkSanitizeDeprecation = helpers.checkSanitizeDeprecation, escape = helpers.escape;
    var getDefaults = defaults$5.exports.getDefaults, changeDefaults = defaults$5.exports.changeDefaults, defaults = defaults$5.exports.defaults;
    /**
   * Marked
   */ function marked(src, opt, callback) {
        // throw error in case of non string input
        if (typeof src === "undefined" || src === null) throw new Error("marked(): input parameter is undefined or null");
        if (typeof src !== "string") throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
        if (typeof opt === "function") {
            callback = opt;
            opt = null;
        }
        opt = merge({}, marked.defaults, opt || {});
        checkSanitizeDeprecation(opt);
        if (callback) {
            var highlight = opt.highlight;
            var tokens;
            try {
                tokens = Lexer.lex(src, opt);
            } catch (e) {
                return callback(e);
            }
            var done = function done(err) {
                var out;
                if (!err) try {
                    if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                    out = Parser.parse(tokens, opt);
                } catch (e) {
                    err = e;
                }
                opt.highlight = highlight;
                return err ? callback(err) : callback(null, out);
            };
            if (!highlight || highlight.length < 3) return done();
            delete opt.highlight;
            if (!tokens.length) return done();
            var pending = 0;
            marked.walkTokens(tokens, function(token) {
                if (token.type === "code") {
                    pending++;
                    setTimeout(function() {
                        highlight(token.text, token.lang, function(err, code) {
                            if (err) return done(err);
                            if (code != null && code !== token.text) {
                                token.text = code;
                                token.escaped = true;
                            }
                            pending--;
                            if (pending === 0) done();
                        });
                    }, 0);
                }
            });
            if (pending === 0) done();
            return;
        }
        try {
            var _tokens = Lexer.lex(src, opt);
            if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
            return Parser.parse(_tokens, opt);
        } catch (e) {
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (opt.silent) return "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
            throw e;
        }
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        merge(marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var opts = merge.apply(void 0, [
            {}
        ].concat(args));
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        var hasExtensions;
        args.forEach(function(pack) {
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                hasExtensions = true;
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error("extension name required");
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
            } // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop]; // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop]; // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
             // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    pack.walkTokens.call(_this, token);
                    if (walkTokens) walkTokens(token);
                };
            }
            if (hasExtensions) opts.extensions = extensions;
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var _loop3 = function _loop3() {
            var token = _step.value;
            callback(token);
            switch(token.type){
                case "table":
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.tokens.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        marked.walkTokens(cell, callback);
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.tokens.cells), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            marked.walkTokens(_cell, callback);
                        }
                    }
                    break;
                case "list":
                    marked.walkTokens(token.items, callback);
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        marked.walkTokens(token[childTokens], callback);
                    });
                    else if (token.tokens) marked.walkTokens(token.tokens, callback);
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop3();
    };
    /**
   * Parse Inline
   */ marked.parseInline = function(src, opt) {
        // throw error in case of non string input
        if (typeof src === "undefined" || src === null) throw new Error("marked.parseInline(): input parameter is undefined or null");
        if (typeof src !== "string") throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
        opt = merge({}, marked.defaults, opt || {});
        checkSanitizeDeprecation(opt);
        try {
            var tokens = Lexer.lexInline(src, opt);
            if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
            return Parser.parseInline(tokens, opt);
        } catch (e) {
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (opt.silent) return "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
            throw e;
        }
    };
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.parse = marked;
    var marked_1 = marked;
    return marked_1;
});


var $7342b9d25afc8814$exports = {};
/*! @license DOMPurify 2.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.5/LICENSE */ (function(global, factory) {
    $7342b9d25afc8814$exports = factory();
})($7342b9d25afc8814$exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== "undefined" && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === "string") {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]); // SVG
    var svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    var svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]); // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "fedropshadow",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    var mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover"
    ]); // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    var text = freeze([
        "#text"
    ]);
    var html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns",
        "slot"
    ]);
    var svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    var mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    var xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
         // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = "data-tt-policy-suffix";
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "2.4.5";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        var getParentNode = lookupGetter(ElementPrototype, "parentNode"); // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            var template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML("") : "";
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === "function" && implementation && typeof implementation.createHTMLDocument !== "undefined" && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement("form");
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = "ALLOWED_NAMESPACES" in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            } // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "desc",
            "title",
            "annotation-xml"
        ]); // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                 // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                 // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                 // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                 // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                 // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            } // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
             // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {}
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === "object" ? object instanceof Node : object && _typeof(object) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === "select" && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === "noscript" || tagName === "noembed") && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, " ");
                content = stringReplace(content, ERB_EXPR$1, " ");
                content = stringReplace(content, TMPLIT_EXPR$1, " ");
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if (!value) ;
            else return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName.indexOf("-") > 0;
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === "value" ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, " ");
                    value = stringReplace(value, ERB_EXPR$1, " ");
                    value = stringReplace(value, TMPLIT_EXPR$1, " ");
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                // eslint-disable-next-line no-negated-condition
                if (typeof dirty.toString !== "function") throw typeErrorCreate("toString is not a function");
                else {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                }
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === "object" || typeof window1.toStaticHTML === "function") {
                    if (typeof dirty === "string") return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});



const $4421afaa372fc760$var$markdown = `
Til þess að keyra á götum Íslands þá þarftu bílpróf og ef þú vilt fá bílpróf þá þarftu að klára ökunámið.

Samkvæmt lögum má hefja ökunám 16 ára, en þú færð ekki bílpróf fyrr en þú verður 17 ára og hefur lokið ökunáminu.

Í **stuttu máli** er ökunáminu skipt upp í

- 15+ verklega ökutíma með ökukennara
- 3 námskeið (2 bókleg og 1 verklegt námskeið)
- Æfingarakstur
- 2 próf (1 verklegt og 1 bóklegt)

Í heildina <a href="/blogg/hvad-kostar-bilprof">kostar allur pakkinn frá 270.000 kr upp í 400.000 kr.</a> 

Til þess að hefja ökunám er lang best að heyra í góðum ökukennara sem getur leitt þig í gegnum ferlið. 


## Bílpróf í lengra máli

Að læra á bíl getur verið ruglandi. Margir aðilar koma að því og það er erfitt að átta sig á hvar maður er í ferlinu. 

Til að einfalda málið er hægt að skipta ökunáminu niður í 11 skref:

1. <a href="#okukennari">Finna sér ökukennara</a>
2. <a href="#namsleyfi">Fá námsheimild frá sýslumanni</a>
3. <a href="#okuskoli1">Ökuskóli 1</a>
4. <a href="#aefingaakstur">Æfingaakstur</a>
5. <a href="#okuskoli2">Ökuskóli 2</a>
6. Klára 12 ökutíma
7. <a href="#okuskoli3">Ökuskóli 3</a>
8. Klára 5 fleiri ökutíma
9. <a href="#skriflegt-prof">Skriflegt próf</a>
10. <a href="#verklegt-prof">Verklegt próf</a>
11. <a href="#bilprof">Bílprófi náð (Bráðarbirgðar- og fullnaðarskírteini)</a>

### <span id="okukennari">Finna sér ökukennara</span>

Fyrsta skrefið í ökunáminu er að finna sér ökukennara sem passar manni. Almennt er best að spyrja vini sína hvaða ökukennara þeir séu hjá og heyra í þeim. 

Full ástæða er til að vanda valið á ökukennaranum því að hann fylgir þér gegnum allt ökunámið. Gott er að hafa í huga hvort kennsluáætlun hans samræmist þínum þörfum, hvort tími dagsins sem hann kennir henti þér og hver kostnaður ökutímanna er.

### <span id="namsleyfi">Fá námsheimild frá sýslumanni</span>

Áður en þú hefur nám af alvöru skaltu fá námsheimild frá Sýslumanni. Þú gerir það inn á ísland.is og ferð svo á skrifstofu sýslumanns með passamynd. Þú ættir að fá námsheimild áður en þú hefur námið.

Þú getur sótt um námsheimild hérna: https://island.is/fyrsta-okuskirteini-namsheimild

### <span id="okuskoli1">Ökuskóli 1</span>
Ökuskóli 1 er fyrsti hluti bóklegs ökunáms. Algengt er að nemendur taki ökuskóla 1 á netinu (t.d hjá okkur og öðrum netökuskólum), en það er enn þá hægt að sitja tíma í kennslustofu.

Hægt er að lesa meira um hvernig <a href="/okuskoli1">ökuskóla 1 er háttað hjá okkur hérna.</a>

<img src="/images/blogg/mosi-og-vegur.jpg" />

### <span id="aefingaakstur">Æfingaakstur</span>

Æfingaakstur fer þannig fram að nemandinn æfir sig að aka venjulegum bíl með leiðbeinanda sem gjarnan er foreldri eða forráðamaður. 

Þegar Ö1 og að minnsta kosti 10 verklegum tímum er lokið má sækja um leyfi til æfingaaksturs. Ökukennarinn metur hvort og hvenær nemandi er tilbúinn að hefja æfingaakstur og staðfestir það með sérstöku vottorði.

Þegar tryggingafélag hefur staðfest að vátrygging sé í gildi vegna æfingaaksturs er hægt að sækja um heimild til sýslumanns.

Æfingaakstur er ekki skylda í ökunámi en það er góður valkostur til að fá sem bestan undirbúning fyrir akstur í framtíðinni. 

Athugið að leiðbeinandinn verður að uppfylla eftirfarandi skilyrði:

- hafa náð 24 ára aldri
- hafa gild ökuréttindi og a.m.k. 5 ára reynslu af akstri
- ekki hafa verið án ökuskírteinis eða verið refsað fyrir vítaverðan akstur síðastliðið ár

### <span id="okuskoli2">Ökuskóli 2</span>

Ökuskóli 2 er framhald af ökuskóla 1 og er háttað á sama máta. Nemandi þarf að ljúka þeim báðum áður en hann getur tekið skriflega prófið.

### <span id="okuskoli3">Ökuskóli 3</span>
Nemandi þarf að hafa lokið 10 ökutímum til að geta farið í Ökuskóla 3. 

Ökuskóli 3 er verklegt námskeið sem fer fram í ökugerði. Tilgangur ökugerðisins er að líkja eftir aðstæðum þar sem nemandi upplifir það að missa vald á bílnum. Það er gert með hálkubrautum eða skrikbíll, malarvegum og veltubíl. 

Það þarf að klára ökuskóla 3 áður en nemandi má taka verklegt próf. 

### <span id="skriflegt-prof">Skriflegt ökupróf</span>

Skriflega prófið samanstendur af 50 fullyrðingum. Við hverri fullyrðingu eru gefnir tveir valmöguleikar: satt eða ósatt. 

30 spurningar eru um umferðarmerki, yfirborðsmerkingar á vegum og forgang í umferð. 20 spurningar eru almennar: um umferðina, bílinn, ökumanninn og skyndihjálp. 

Þú mátt að hámarki vera með 5 villur í prófinu. Niðurstöðuna fær nemandi strax að loknu prófi.

Ef nemandi stenst ekki prófið verður að líða a.m.k. ein vika þangað til hann getur gert aðra tilraun. 

Það er ansi algengt að nemendur falli í þessu prófi og við mælum með því að æfa sig vel fyrir prófið. Það getur orðið dýrt að falla endurtekið því hver próftaka kostar 7.090 kr. 
 
### <span id="verklegt-prof">Verklegt ökupróf</span>
Verklega ökuprófið skiptist í tvo hluta; munnlegt próf og verklegt próf. Munnlega prófið er tekið í bílnum. Prófdómarinn spyr um ýmislegt í sambandi við bílinn; t.d. ljósabúnað, stjórntæki, öryggisbúnað og viðhald. Ef munnlega prófið gengur vel tekur verklega prófið við í beinu framhaldi. Ekin er viss leið sem prófdómari ákveður og hann skráir hjá sér plúsa og mínusa. Verklega prófið kostar 18.820 kr.

Prófdómarinn kveður upp úrskurðinn strax að loknu prófi.

### <span id="bilprof">Bráðarbirgðar- og fullnaðarskírteini</span>
<img alt="Ökuskírteini" src="/images/lotur/Okuskirteini.png">
<p class="image-caption">Ökuskírteini</p>

Þegar prófunum er náð og náminu lokið fær nemandi fyrsta ökuskírteinið sem er svokallað bráðabirgðaskírteini. 

Bráðabirgðaskírteini gildir í þrjú ár og á meðan þarf færri punkta til þess að missa ökuréttindin. Hafi ökumaður með bráðabirgðaskírteini ekki fengið punkt vegna umferðarlagabrota í eitt ár og hafi ekki verið sviptur ökuréttindum í 12 mánuði getur hann farið í akstursmat hjá ökukennara. 

Eftir akstursmatið fær hann fullnaðarskírteini sem gildir í 15 ár. 

Þá er formlegu námi lokið.


### Annað efni 
<a href="https://www.samgongustofa.is/umferd/nam-og-rettindi/okunam/">Á vef Samgöngustofu er hægt að finna allskonar efni um ökunámið</a>

<a href="/blogg/hvad-kostar-bilprof">Hvað kostar bílpróf?</a> 

Ef þú hefur frekari spurningar getur þú líka sent okkur tölvupóst á <a href="mailto:hallo@urdarbrunnur.is">hallo@urdarbrunnur.is</a>.


<span class="last-updated">Uppfært 24. júní 2025</span>
`;
const $4421afaa372fc760$var$markdownEn = `
To drive on Icelandic roads and streets, you will first need a driving licence and if you want to acquire one you need to go through a formal process to learn how to drive.

You can start learning to drive at 16 years old, but to be granted a driving licence you must have reached the age of 17.

**In short** the driving school is split into

- 15+ practical driving lessons with a driving instructor
- 3 courses (2 academic and 1 practical)
- Learner driving (*Æfingaakstur*)
- 2 tests (1 written and 1 practical)

In total the <a href="/blogg/hvad-kostar-bilprof">cost of driving school ranges from 270.000 kr up to 400.000 kr</a> 

To start your driving education it is best to contact a driving instructor who can guide you through the process.


## The long road to a driving licence 

Að læra á bíl getur verið ruglandi. Margir aðilar koma að því og það er erfitt að átta sig á hvar maður er í ferlinu. 
Learning how to drive a car can be confusing. Many different parties are involved in the process and it can be difficult to know what you need to do next.

The process can be broken down into 11 steps:

1. <a href="#okukennari">Find a driving instructor</a>
2. <a href="#namsleyfi">Acquire a study permit (námsheimild) from the district commissioners office (sýslumaður)</a>
3. <a href="#okuskoli1">Driving School 1 (Ökuskóli 1)</a>
4. <a href="#aefingaakstur">Learners driving (Æfingaakstur)</a>
5. <a href="#okuskoli2">Driving School 2 (Ökuskóli 2)</a>
6. Finish 12 practical lessons with an instructor
7. <a href="#okuskoli3">Driving School 3 (Ökuskóli 3)</a>
8. Finish 5 more practical lessons.
9. <a href="#skriflegt-prof">Written exam</a>
10. <a href="#verklegt-prof">Practical exam</a>
11. <a href="#bilprof">You get a driving licence!</a>

### <span id="okukennari">Finding a driving instructor</span>

The first step is to find a driving instructor who suits you. Generally is it easiest to ask your friends or family which driving instructor they have used and contact them.

It is a good idea to think through the choice of instructors as they will guide you through the process. You need to consider if their teaching style suits you, that their schedule fits with yours and how much they charge per lesson.

### <span id="namsleyfi">Applying for a study permit</span>

Before you start you need to apply for a study permit at the district commissioners office. You apply on island.is and then head to the district commissioners office with a pass photo. You should have the study permit before you start your studies.

You can apply for a study permit here: https://island.is/fyrsta-okuskirteini-namsheimild

### <span id="okuskoli1">Driving School (Ökuskóli 1)</span>
Driving School 1 (Ökuskóli 1) is the first of two written courses that you need to complete. It is common that students take driving school 1 online (with us or at other online driving schools), but you can choose to attend classes in person.
You can read more about how we <a href="/okuskoli1">arrange Driving School 1 here.</a>

<img src="/images/blogg/mosi-og-vegur.jpg" />

### <span id="aefingaakstur">Learner driving (Æfingaakstur)</span>

Learner driving is when a student practices driving a regular car with someone else in the car who usually is a parent or guardian. 

You can apply for a learner driver's permission when you've finished Driving School 1 and at least 10 practical lessons. Ökukennarinn metur hvort og hvenær nemandi er tilbúinn að hefja æfingaakstur og staðfestir það með sérstöku vottorði. 

When your insurance company has confirmed that your insurance covers a learner driver you can apply for a permit with the district commissioner's office.

Learner driving is not obligatory to finish driving school, however, it is a fantastic way to prepare yourself for driving in the future.

Note that your learner driver instructor must:

- Be a minimum of 24 years old
- Have a valid driving licence and at least 5 years of driving experience
- Not had their licence revoked or been penalized for reckless driving in the past year

### <span id="okuskoli2">Driving School 2 (Ökuskóli 2)</span>

Driving school 2 is a continuation of Driving school 1 and is structured in the same way. The student needs to complete both courses before taking the written exam.

### <span id="okuskoli3">Driving School 3 (Ökuskóli 3)</span>
Students need to have finished 10 practical lessons before starting Driving school 3. 

Driving school 3 is a practical course that takes place inside an open-air driving area. The purpose of the exercise area is to simulate situations where the student will experience losing control of the vehicle. This is done with skid-tracks, skid-car, gravel tracks and roll-over simulator.

The student needs to finish Driving school 3 to be able to take the practical exam.

### <span id="skriflegt-prof">Written exam</span>

The written exam is composed of 50 questions.

30 questions are about about traffic signs, surface markings on roads and priority rules in traffic. 20 questions are more general; about traffic, the car, the driver and first-aid.

For each question you can answer either true or fails.

Students can have a maximum of 5 errors on the exam. Students receive their exam results immediately after the exam.

If a student does not pass the exam, then one week must pass before another attempt is made.

It is common that students fail the written exam so it is recommended to practice thoroughly. Each attempt costs 7.090 kr, so it can get expensive if you fail often. 

### <span id="verklegt-prof">Practical exam</span> 

The practical driving exam is split into two parts; an oral exam and a practical exam. The oral exam is taken in the vehicle where the examiner asks questions concerning the vehicle, e.g.  lighting systems, control systems, safety mechanisms and vehicle maintenance. If the oral exam goes well the practical exam will begin. A predetermined route chosen by the examiner is driven. While the student is driving the examiner registers points and deductions during the exam. The practical exam costs 18.820 kr. 

The examiner tells the student the exam results immediately. 

### <span id="bilprof">Temporary- and Full driving licence</span>
<img alt="An Icelandic driving licence" src="/images/lotur/Okuskirteini.png">
<p class="image-caption">An Icelandic driving licence.</p>

When the exams have been passed and the studies concluded the student receives their first driving licence which is a temporary driving licence.

The temporary licence is valid for three years, during which fewer points are needed to have the licence revoked. If the driver has not received a point for traffic violation or had their licence revoked within a year the driver can take a driving assessment with their driving instructor. 

After this assessment the driver receives a full driving licence that is valid for 15 years.

At this point the driver's formal education is finished.


### Further reading 
<a href="https://www.samgongustofa.is/umferd/nam-og-rettindi/okunam/">On the Samgöngustofa (The Icelandic Transport Authority) webpage you can find all kinds of helpful material on the process.</a>

<a href="/blogg/hvad-kostar-bilprof">How much does it cost to get a driving licence?</a> 

Further questions? Reach out to us at <a href="mailto:hallo@urdarbrunnur.is">hallo@urdarbrunnur.is</a>.


<span class="last-updated">Updated 24. June 2025</span>
`;
const $4421afaa372fc760$export$150b732325d14d04 = {
    is: {
        Process: {
            BlogPost: $4421afaa372fc760$var$markdown,
            Title: "Hvernig f\xe6r ma\xf0ur b\xedlpr\xf3f?",
            Description: "Allt sem \xfe\xfa \xfearft a\xf0 vita um \xf6kun\xe1mi\xf0"
        }
    },
    en: {
        Process: {
            BlogPost: $4421afaa372fc760$var$markdownEn,
            Title: "How do you get a driving license in Iceland?",
            Description: "Everything you need to know about learning to drive in Iceland"
        }
    }
};
const $4421afaa372fc760$var$Process = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const keywords = [
        "b\xedlpr\xf3f",
        "b r\xe9ttindi",
        "\xf6kun\xe1m",
        "\xe6fingarakstur"
    ];
    const imageOptions = {
        imgCaption: "\xd6kun\xe1mi\xf0 \xed einfaldri mynd",
        imgAlt: "b\xedlpr\xf3f",
        imgSrc: "/images/blogg/bilprof.jpg"
    };
    const parseMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($839da9af9fcc35ae$exports)))(t("Process.BlogPost"));
    const cleanMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($7342b9d25afc8814$exports))).sanitize(parseMarkdown);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d5e625687d701cdc$export$2e2bcd8739ae039), {
        title: t("Process.Title"),
        description: t("Process.Description"),
        keywords: keywords,
        imageOptions: imageOptions,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("article", {
            dangerouslySetInnerHTML: {
                __html: cleanMarkdown
            }
        })
    });
};
var $4421afaa372fc760$export$2e2bcd8739ae039 = $4421afaa372fc760$var$Process;



parcelRequire("4hYjL");




const $fd3f77f399c369ce$var$namsheimild = "4.300";
const $fd3f77f399c369ce$var$utiumferdina = "1.990";
const $fd3f77f399c369ce$var$skriflega = "7.090";
const $fd3f77f399c369ce$var$tvoskrifleg = "14.180";
const $fd3f77f399c369ce$var$verklega = "18.820";
const $fd3f77f399c369ce$var$okuskoli3 = "52.000";
const $fd3f77f399c369ce$var$markdown = `
Það kostar sitt að læra að keyra bíl. Það kostar að lágmarki í kringum 270.000 kr. en getur farið upp í kr. 400.000 kr. fyrir allan pakkann.

Kostnaðurinn gæti skiptst upp á eftirfarandi máta:

<table>
  <tr>
    <td>Námsheimild frá sýslumanni</td>
    <td>${$fd3f77f399c369ce$var$namsheimild} kr.</td>
  </tr>
  <tr>
    <td>15 ökutímar (12.900 kr tíminn) </td>
    <td>193.500 kr.</td>
  </tr>
  <tr>
    <td>Námsbókin - Út í umferðina</td>
    <td>${$fd3f77f399c369ce$var$utiumferdina} kr.</td>
  </tr>
  <tr>
    <td>Ökuskóli 1 (hjá okkur)</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Ökuskóli 2 (hjá okkur)</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Ökuskóli 3</td>
    <td>${$fd3f77f399c369ce$var$okuskoli3} kr.</td>
  </tr>
  <tr>
    <td>Skriflega prófið</td>
    <td>${$fd3f77f399c369ce$var$skriflega} kr.</td>
  </tr>
  <tr>
    <td>Verklega prófið</td>
    <td>${$fd3f77f399c369ce$var$verklega} kr.</td>
  </tr>
 <tr>
    <td><b>Heildarverð</b></td>
    <td><b>302.700 kr.</b></td>
  </tr>
</table>

Ef þú vilt skilja ferlið aðeins betur getur þú <a href="/blogg/hvernig-faer-madur-bilprof">lesið um það betur hérna.</a> 

Margir vilja taka fleiri en 15 ökutíma hjá ökukennara og þurfa þar af leiðandi að greiða meira fyrir námið. Síðan þurfa sumir að endurtaka verklega eða bóklega bílprófið. Þannig hækkar kostnaðurinn.

Þannig það er allur gangur á þessu. 

Til dæmis, ef þú tækir 20 ökunámstíma og féllir einu sinni í skriflega prófinu þá gæti kostnaðurinn litið svona út:

<table>
  <tr>
    <td>Námsheimild frá sýslumanni</td>
    <td>${$fd3f77f399c369ce$var$namsheimild} kr.</td>
  </tr>
  <tr>
    <td>20 ökutímar (12.900 kr. tíminn)</td>
    <td>258.000 kr.</td>
  </tr>
  <tr>
    <td>Námsbókin - Út í umferðina</td>
    <td>${$fd3f77f399c369ce$var$utiumferdina} kr.</td>
  </tr>
  <tr>
    <td>Ökuskóli 1 (hjá okkur)</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Ökuskóli 2 (hjá okkur)</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Ökuskóli 3</td>
    <td>${$fd3f77f399c369ce$var$okuskoli3} kr.</td>
  </tr>
  <tr>
    <td>Skriflega prófið (tvisvar)</td>
    <td>${$fd3f77f399c369ce$var$tvoskrifleg} kr.</td>
  </tr>
  <tr>
    <td>Verklega prófið</td>
    <td>${$fd3f77f399c369ce$var$verklega} kr.</td>
  </tr>
 <tr>
    <td><b>Heildarverð</b></td>
    <td><b>374.290 kr.</b></td>
  </tr>
</table>

<span class="last-updated">Uppfært 7. janúar 2025</span>`;
const $fd3f77f399c369ce$var$markdownEn = `
It costs a good deal to learn how to drive a car. The total cost to get a driving licence in Iceland can ranges from 270.000 kr up to 400.000 kr for the entire process.

Here is an example of how the total amount could be broken down:

<table>
  <tr>
    <td>Applying for a study permit</td>
    <td>${$fd3f77f399c369ce$var$namsheimild} kr.</td>
  </tr>
  <tr>
    <td>15 driving lessons (12.900 per lesson)</td>
    <td>193.500 kr.</td>
  </tr>
  <tr>
    <td>The textbook - Út í umferðina</td>
    <td>${$fd3f77f399c369ce$var$utiumferdina} kr.</td>
  </tr>
  <tr>
    <td>Driving school 1 (Ökuskóli 1) with us</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Driving school 2 (Ökuskóli 2) with us</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Driving school 3</td>
    <td>${$fd3f77f399c369ce$var$okuskoli3} kr.</td>
  </tr>
  <tr>
    <td>Written exam</td>
    <td>${$fd3f77f399c369ce$var$skriflega} kr.</td>
  </tr>
  <tr>
    <td>Practical exam</td>
    <td>${$fd3f77f399c369ce$var$verklega} kr.</td>
  </tr>
 <tr>
    <td><b>Total</b></td>
    <td><b>300.200 kr.</b></td>
  </tr>
</table>

If you want to know a little more about the whole process you can <a href="/blogg/hvernig-faer-madur-bilprof">[fix link!!!]read about the process here.</a> 

Many students will want to take more than 15 lessons with an instructor to gain more confidence and will thus end up paying more. In addition, some students need to retake the practical or written exam (or both!) and thus the cost can increase quickly.

So as you can see, the cost can vary. 

For example, if you took 20 driving lessons and needed to retake the written exam once the breakdown could look like this:

<table>
  <tr>
    <td>Student permit application</td>
    <td>${$fd3f77f399c369ce$var$namsheimild} kr.</td>
  </tr>
  <tr>
    <td>20 driving lessons (12.900 kr. per lesson) </td>
    <td>258.000 kr.</td>
  </tr>
  <tr>
    <td>Textbook - Út í umferðina</td>
    <td>${$fd3f77f399c369ce$var$utiumferdina} kr.</td>
  </tr>
  <tr>
    <td>Driving school 1 (Ökuskóli 1) with us</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Driving school 2 (Ökuskóli 2) with us</td>
    <td>12.500 kr.</td>
  </tr>
  <tr>
    <td>Driving school 3</td>
    <td>${$fd3f77f399c369ce$var$okuskoli3} kr.</td>
  </tr>
    <td>Written exam (twice)</td>
    <td>${$fd3f77f399c369ce$var$tvoskrifleg} kr.</td>
  </tr>
  <tr>
    <td>Practical exam</td>
    <td>${$fd3f77f399c369ce$var$verklega} kr.</td>
  </tr>
 <tr>
    <td><b>Total</b></td>
    <td><b>371.790 kr.</b></td>
  </tr>
</table>

<span class="last-updated">Last updated 7. January 2025</span>`;
const $fd3f77f399c369ce$export$150b732325d14d04 = {
    is: {
        Cost: {
            BlogPost: $fd3f77f399c369ce$var$markdown,
            Title: "Hva\xf0 kostar b\xedlpr\xf3f?",
            Description: "\xd6kut\xedmar, \xf6kusk\xf3lar 1, 2 og 3, og b\xedlpr\xf3fi\xf0 sj\xe1lft. \xdeetta safnast flj\xf3tt saman."
        }
    },
    en: {
        Cost: {
            BlogPost: $fd3f77f399c369ce$var$markdownEn,
            Title: "How much does a driving licence in Iceland cost?",
            Description: "Driving lessons, Driving schools 1, 2 and 3 and exams. The costs can add up quickly."
        }
    }
};
const $fd3f77f399c369ce$var$Process = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const keywords = [
        "b\xedlpr\xf3f",
        "kostar",
        "b r\xe9ttindi",
        "\xf6kun\xe1m",
        "\xe6fingarakstur"
    ];
    const imageOptions = {
        imgAlt: "b\xedlpr\xf3f",
        imgSrc: "/images/blogg/bill.jpg"
    };
    const parseMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($839da9af9fcc35ae$exports)))(t("Cost.BlogPost"));
    const cleanMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($7342b9d25afc8814$exports))).sanitize(parseMarkdown);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d5e625687d701cdc$export$2e2bcd8739ae039), {
        title: t("Cost.Title"),
        description: t("Cost.Description"),
        keywords: keywords,
        imageOptions: imageOptions,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("article", {
            dangerouslySetInnerHTML: {
                __html: cleanMarkdown
            }
        })
    });
};
var $fd3f77f399c369ce$export$2e2bcd8739ae039 = $fd3f77f399c369ce$var$Process;



parcelRequire("4hYjL");




const $54ef0f485df38191$var$markdown = `
Að læra að keyra getur kostað <a href="/blogg/hvad-kostar-bilprof/">á milli 300.000 og 400.000 kr</a>. Það er ekki á hvers mann færi að greiða slíkar upphæðir en það eru til leiðir til að lækka kostnaðinn! 

Til dæmis bjóða mörg (en ekki öll) stéttarfélög upp á styrk til almenns ökunáms. Í sumum tilfellum er jafnvel hægt að lækka kostnaðinn um mörg hundruð þúsund krónur með þeirra hjálp. 

Hvort og hve mikið er styrkt fer eftir því í hvaða stéttarfélagi þú ert, hve lengi þú hefur unnið, vinnuhlutfalli og hvort þú hafir sótt um aðra styrki.

Tökum nokkur dæmi. 

## Dæmi 1: Félagi í Eflingu í fullri vinnu

Hámarksstyrkur til náms og námskeiða Eflingu nemur 130.000 kr. á ári. En ef félagi í Eflingu hefur ekki nýtt sér styrkinn í þrjú ár á hann rétt á 390.000 kr. styrk (130.000 x 3) fyrir námskeið og nám. Það má nýta upp í 90% af námskostnaði. Það þýðir að mögulegt er að klára ökunám fyrir u.þ.b. 60.000 kr!

Styrkurinn getur farið upp í bóklega og verklega hluta námsins. Hafðu í huga að styrkurinn fer ekki upp í bókakostnað eða próf. 


## Dæmi 2: Félagi í VR í fullri vinnu

Félagsmenn VR eiga rétt á allt að 180.000 kr styrk á ári fyrir nám og námskeið. Félagsmaður sem ekki hefur nýtt sér styrk í þrjú árá rétt á 540.000 kr. styrk. <a href="https://www.starfsmennt.is/starfsreglur/">Sömu reglur</a> gilda hjá VR og hjá Eflingu að styrkupphæð má ekki vera hærri en 90%
af námskeiðskostnaði.

Við sjáum því að þetta er mjög svipað dæmi og hjá Eflingu!

## Dæmi 3: Félagi í sumarstarfi
Ef þú ert í skóla á veturna en ert dugleg/ur að vinna yfir sumarmánuðina þá áttu rétt á að sækja um styrk hjá mörgum en ekki öllum stéttarfélögum. Sum stéttarfélög miða við 6 mánuði og önnur jafnvel 12. 

Styrkur eftir 3 mánuði vinnu er venjulega lágmarks styrkur og fer það eftir stéttarfélagi hversu hár hann er.

## Dæmi 4: Félagi í hlutastarfi
Ef þú ert í hlutastarfi (t.d. með skóla) þá áttu venjulega rétt á að sækja um styrk í samræmi við vinnuhlutfall.

## Samantekt
Styrkur frá stéttarfélagi þínu getur **mögulega** lækkað kostnaðinn af ökunáminu þínu. Hvort og hve mikið er styrkt fer eftir stéttarfélagi, hve lengi þú hefur unnið, hlutfall vinnu í mánuði og hvort þú hafir sótt um aðra styrki. Kíktu á heimasíðu þíns stéttarfélags eða hafðu samband við félagið til að kanna rétt þinn.

Á heimasíðum stéttarfélaga er ekki alltaf sagt berum orðum hvort að veittur sé styrkur til ökunáms. Ökunám flokkast venjulega sem "Nám og námskeið" hjá flestum eða sem "Annað". 

Ef þú ert í vafa um rétt þinn þá er best að senda línu á þitt stéttarfélag og spyrja.

<span class="last-updated">Uppfært 31. október 2024</span>
`;
const $54ef0f485df38191$var$markdownEn = `Learning to drive in Iceland can cost between 300,000 to 400,000 kr but it’s not within everyone’s means to pay that sort of money. 

There are, however, ways to reduce the cost.

Many, but not all, unions in Iceland offer grants to help you pay for your driving licence. In some cases it’s even possible to save yourself hundreds of thousands of kronurs with their help. 

Whether or not you can get a grant depends on what union you’re in, how long you’ve been working, how much you work in a given month and whether or not you’ve applied for other grants.

## Example 1: An Efling union member in a full-time job
The maximum grant for education and courses from Efling is 130,000 kr per year. This means that the grant covers about almost half of the typical cost of the studies each year. But if it so happens that you haven’t applied for a grant in three years then you have a right to a 390,000 kr (130,000 x 3) grant. You can use that money for up to 90% of the education costs.

Efiling used to only pay for the theory part of the studies. But in 2022 their rules changed and now the grant can be used for both the theory courses and the in-person practical lessons. Keep in mind that the grant *can’t* be used to buy books, pay for the final theory or practical test. All this means that it’s not possible to get the licence for free but you can to learn to drive for just 60,000 kr!

## Example 2: A VR union member
Let’s take another example from a large union.

VR union members have a right to up to 180,000 kr grant per year for education and courses. That’s a bit over half of the typical cost of learning to drive, every year. In addition VR union members that haven’t used their grant for three years have a right to 540,000 kr. The same rules apply as with Efling; the grant amount can’t be more than 90% of the study cost. 


## Example 3: Union members in summer jobs
If you are, for example, studying during the winter but spend the summer months of June, July and August working, then you may have the right to a grant from your union. But some unions need you to work 6 months or even 12 months out of the year to accrue grant rights.

However, the bad news is that the grants for only three months work are usually on the lower end. 

## Example 4: A union member in a part-time job
If you’re in a part time job you usually have a right to a grant proportionate to the amount you work. So a half job might give you half the normal grant.

## Conclusion
Your union can possibly pay for part of your driver’s education. Whether and how much you get depends on what union you’re in, how long you’ve been working, how much you work in a given month and whether or not you’ve applied for other grants. Our advice is simply: you should have a look at your union’s website to check your rights.

By the way, it’s not always obvious on union websites whether or not they subsidise your driving studies. Typically learning to drive is categorised under “Studies and courses” or as “Other.” If you’re in any doubt then it’s best to send a message to your union and ask.

<span class="last-updated">Updated 31 October 2024</span>
`;
const $54ef0f485df38191$export$150b732325d14d04 = {
    is: {
        Unions: {
            BlogPost: $54ef0f485df38191$var$markdown,
            Title: "B\xedlpr\xf3f \xe1 60.000 kr? Hvernig st\xe9ttarf\xe9l\xf6gin geta hj\xe1lpa\xf0 \xfe\xe9r",
            Description: "Spara\xf0u \xe1 milli 40-85% af \xf6kun\xe1minu!"
        }
    },
    en: {
        Unions: {
            BlogPost: $54ef0f485df38191$var$markdownEn,
            Title: "A driver's licence for 60,000 kr? How your union may be able to help you.",
            Description: "You may be able to save between 40-85% on the cost of learning to drive"
        }
    }
};
const $54ef0f485df38191$var$Unions = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const keywords = [
        "b\xedlpr\xf3f",
        "st\xe9ttaf\xe9l\xf6g",
        "\xf6kun\xe1m"
    ];
    const imageOptions = {
        imgCaption: "",
        imgAlt: "Sendib\xedll \xe1 \xcdslandi",
        imgSrc: "/images/blogg/van-in-iceland.jpg"
    };
    const parseMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($839da9af9fcc35ae$exports)))(t("Unions.BlogPost"));
    const cleanMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($7342b9d25afc8814$exports))).sanitize(parseMarkdown);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d5e625687d701cdc$export$2e2bcd8739ae039), {
        title: t("Unions.Title"),
        description: t("Unions.Description"),
        keywords: keywords,
        imageOptions: imageOptions,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("article", {
            dangerouslySetInnerHTML: {
                __html: cleanMarkdown
            }
        })
    });
};
var $54ef0f485df38191$export$2e2bcd8739ae039 = $54ef0f485df38191$var$Unions;





var $4hYjL = parcelRequire("4hYjL");


parcelRequire("4hYjL");



var $4hYjL = parcelRequire("4hYjL");



parcelRequire("4hYjL");


const $a2753bb663df18bd$var$NavItem = ({ courseId: courseId, roundNr: roundNr, roundStatus: roundStatus, isCurrentRound: isCurrentRound, nextRoundOpen: nextRoundOpen, messageFeatureUsed: messageFeatureUsed, currentStep: currentStep })=>{
    let icon = "fa fa-square-o";
    let status = "enabled-link";
    let step = "1";
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    if (roundStatus === "Not Started") {
        icon = "fa fa-lock";
        status = "disabled-link";
    }
    if (nextRoundOpen && isCurrentRound) {
        icon = "fa fa-square-o";
        status = "enabled-link";
        step = currentStep.toString();
    }
    if (roundStatus === "Finished") icon = "fa fa-check-square-o";
    if (parseInt(courseId) === 2 && !messageFeatureUsed) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
        to: `/okuskoli-${courseId}/lota-${roundNr}/skref-${step}`,
        className: "disabled-link",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: "fa fa-lock"
                }),
                " ",
                `${t("DashNavigation.Lota")} ${roundNr}`
            ]
        })
    });
    else return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
        to: `/okuskoli-${courseId}/lota-${roundNr}/skref-${step}`,
        className: `${status}`,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: icon
                }),
                " ",
                `${t("DashNavigation.Lota")} ${roundNr}`
            ]
        })
    });
};
var $a2753bb663df18bd$export$2e2bcd8739ae039 = $a2753bb663df18bd$var$NavItem;




var $4hYjL = parcelRequire("4hYjL");



var $4hYjL = parcelRequire("4hYjL");

function $3166cecf58f4f56c$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $3166cecf58f4f56c$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $3166cecf58f4f56c$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $3166cecf58f4f56c$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $3166cecf58f4f56c$export$2e2bcd8739ae039 = $3166cecf58f4f56c$export$4f5d2d50c9deca37;



function $b9256293aee0086e$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $b9256293aee0086e$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}


function $90828746836bf58c$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}


/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $966219a2cc67a38f$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }


/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ee4e4eff643c0f2b$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $ee4e4eff643c0f2b$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $ee4e4eff643c0f2b$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ee4e4eff643c0f2b$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $ee4e4eff643c0f2b$export$677b39864803984e($ee4e4eff643c0f2b$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $966219a2cc67a38f$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $966219a2cc67a38f$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ee4e4eff643c0f2b$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $ee4e4eff643c0f2b$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $ee4e4eff643c0f2b$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $ee4e4eff643c0f2b$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $ee4e4eff643c0f2b$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ee4e4eff643c0f2b$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $ee4e4eff643c0f2b$export$29fb7152bd3f781a(color) {
    color = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $ee4e4eff643c0f2b$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ee4e4eff643c0f2b$export$c852d90bf7403b62(color) {
    color = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $ee4e4eff643c0f2b$export$677b39864803984e($ee4e4eff643c0f2b$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ee4e4eff643c0f2b$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ee4e4eff643c0f2b$export$c852d90bf7403b62(foreground);
    const lumB = $ee4e4eff643c0f2b$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ee4e4eff643c0f2b$export$58f0f39f63f3cf42(color, value) {
    color = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    value = $ee4e4eff643c0f2b$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ee4e4eff643c0f2b$export$211a73f2b8c10ce4(color);
}
function $ee4e4eff643c0f2b$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $ee4e4eff643c0f2b$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $ee4e4eff643c0f2b$export$4b073707ff63303(color, coefficient) {
    color = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    coefficient = $ee4e4eff643c0f2b$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ee4e4eff643c0f2b$export$211a73f2b8c10ce4(color);
}
function $ee4e4eff643c0f2b$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $ee4e4eff643c0f2b$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ee4e4eff643c0f2b$export$c0816ed86df316af(color, coefficient) {
    color = $ee4e4eff643c0f2b$export$677b39864803984e(color);
    coefficient = $ee4e4eff643c0f2b$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ee4e4eff643c0f2b$export$211a73f2b8c10ce4(color);
}
function $ee4e4eff643c0f2b$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $ee4e4eff643c0f2b$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ee4e4eff643c0f2b$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ee4e4eff643c0f2b$export$c852d90bf7403b62(color) > 0.5 ? $ee4e4eff643c0f2b$export$4b073707ff63303(color, coefficient) : $ee4e4eff643c0f2b$export$c0816ed86df316af(color, coefficient);
}
function $ee4e4eff643c0f2b$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $ee4e4eff643c0f2b$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}




/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 

var $4hYjL = parcelRequire("4hYjL");
function $bf04a10aabf5b477$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $863a29b13f82576c$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $863a29b13f82576c$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $bf04a10aabf5b477$export$2e2bcd8739ae039)(function(prop) {
    return $863a29b13f82576c$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $4hYjL = parcelRequire("4hYjL");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $3fabbdc7cd23bfd4$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $3fabbdc7cd23bfd4$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $3fabbdc7cd23bfd4$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3fabbdc7cd23bfd4$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $3fabbdc7cd23bfd4$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $b603667f644cdb6c$export$71ad59f2e432cfe8 = "-ms-";
var $b603667f644cdb6c$export$2c0f367103c8d01c = "-moz-";
var $b603667f644cdb6c$export$39dfd62a25e0fe93 = "-webkit-";
var $b603667f644cdb6c$export$a29989082612d0d9 = "comm";
var $b603667f644cdb6c$export$aa3a2e812ca8570d = "rule";
var $b603667f644cdb6c$export$527d108ccf083c2b = "decl";
var $b603667f644cdb6c$export$d3d35020fa5b54f0 = "@page";
var $b603667f644cdb6c$export$500415a86c544f73 = "@media";
var $b603667f644cdb6c$export$a763edbf796b780a = "@import";
var $b603667f644cdb6c$export$2790aeb8b4e5c826 = "@charset";
var $b603667f644cdb6c$export$1cc683e23b84b133 = "@viewport";
var $b603667f644cdb6c$export$9447a5efea57e862 = "@supports";
var $b603667f644cdb6c$export$ef011b4e114b1fba = "@document";
var $b603667f644cdb6c$export$6aad947bda0f3f46 = "@namespace";
var $b603667f644cdb6c$export$b44a8529a35fcb60 = "@keyframes";
var $b603667f644cdb6c$export$2c16de31893252e6 = "@font-face";
var $b603667f644cdb6c$export$3d846dd52e150c6f = "@counter-style";
var $b603667f644cdb6c$export$22314bfbb57653fe = "@font-feature-values";
var $b603667f644cdb6c$export$d773506282b3cfe6 = "@layer";
var $b603667f644cdb6c$export$2335f513bbd82c6d = Math.abs;
var $b603667f644cdb6c$export$6788812c4e6611e6 = String.fromCharCode;
var $b603667f644cdb6c$export$e6e34fd1f2686227 = Object.assign;
function $b603667f644cdb6c$export$d6af199866bfb566(e, r) {
    return $b603667f644cdb6c$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $b603667f644cdb6c$export$a9db5e087081082d(e, 0)) << 2 ^ $b603667f644cdb6c$export$a9db5e087081082d(e, 1)) << 2 ^ $b603667f644cdb6c$export$a9db5e087081082d(e, 2)) << 2 ^ $b603667f644cdb6c$export$a9db5e087081082d(e, 3) : 0;
}
function $b603667f644cdb6c$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $b603667f644cdb6c$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $b603667f644cdb6c$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $b603667f644cdb6c$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $b603667f644cdb6c$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $b603667f644cdb6c$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $b603667f644cdb6c$export$36776f635604f274(e) {
    return e.length;
}
function $b603667f644cdb6c$export$f9084667e487ed46(e) {
    return e.length;
}
function $b603667f644cdb6c$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $b603667f644cdb6c$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $b603667f644cdb6c$export$53f1d5ea8de3d7c = 1;
var $b603667f644cdb6c$export$4e0c71f277ca26b3 = 1;
var $b603667f644cdb6c$export$f24224f1c91d8156 = 0;
var $b603667f644cdb6c$export$5880b8b5730aff45 = 0;
var $b603667f644cdb6c$export$c0306caf338ac095 = 0;
var $b603667f644cdb6c$export$30a86d91af8ff6e6 = "";
function $b603667f644cdb6c$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $b603667f644cdb6c$export$53f1d5ea8de3d7c,
        column: $b603667f644cdb6c$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $b603667f644cdb6c$export$784d13d8ee351f07(e, r) {
    return $b603667f644cdb6c$export$e6e34fd1f2686227($b603667f644cdb6c$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $b603667f644cdb6c$export$eba6f6f03b0a92e7() {
    return $b603667f644cdb6c$export$c0306caf338ac095;
}
function $b603667f644cdb6c$export$232faf9add678146() {
    $b603667f644cdb6c$export$c0306caf338ac095 = $b603667f644cdb6c$export$5880b8b5730aff45 > 0 ? $b603667f644cdb6c$export$a9db5e087081082d($b603667f644cdb6c$export$30a86d91af8ff6e6, --$b603667f644cdb6c$export$5880b8b5730aff45) : 0;
    if ($b603667f644cdb6c$export$4e0c71f277ca26b3--, $b603667f644cdb6c$export$c0306caf338ac095 === 10) $b603667f644cdb6c$export$4e0c71f277ca26b3 = 1, $b603667f644cdb6c$export$53f1d5ea8de3d7c--;
    return $b603667f644cdb6c$export$c0306caf338ac095;
}
function $b603667f644cdb6c$export$48cfd1e771a65c4f() {
    $b603667f644cdb6c$export$c0306caf338ac095 = $b603667f644cdb6c$export$5880b8b5730aff45 < $b603667f644cdb6c$export$f24224f1c91d8156 ? $b603667f644cdb6c$export$a9db5e087081082d($b603667f644cdb6c$export$30a86d91af8ff6e6, $b603667f644cdb6c$export$5880b8b5730aff45++) : 0;
    if ($b603667f644cdb6c$export$4e0c71f277ca26b3++, $b603667f644cdb6c$export$c0306caf338ac095 === 10) $b603667f644cdb6c$export$4e0c71f277ca26b3 = 1, $b603667f644cdb6c$export$53f1d5ea8de3d7c++;
    return $b603667f644cdb6c$export$c0306caf338ac095;
}
function $b603667f644cdb6c$export$4d3fb11e950abb9e() {
    return $b603667f644cdb6c$export$a9db5e087081082d($b603667f644cdb6c$export$30a86d91af8ff6e6, $b603667f644cdb6c$export$5880b8b5730aff45);
}
function $b603667f644cdb6c$export$e88cb2efb12ae807() {
    return $b603667f644cdb6c$export$5880b8b5730aff45;
}
function $b603667f644cdb6c$export$58adb3bec8346d0f(e, r) {
    return $b603667f644cdb6c$export$2f35ab04d2335697($b603667f644cdb6c$export$30a86d91af8ff6e6, e, r);
}
function $b603667f644cdb6c$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $b603667f644cdb6c$export$2de70f21292aac9e(e) {
    return $b603667f644cdb6c$export$53f1d5ea8de3d7c = $b603667f644cdb6c$export$4e0c71f277ca26b3 = 1, $b603667f644cdb6c$export$f24224f1c91d8156 = $b603667f644cdb6c$export$36776f635604f274($b603667f644cdb6c$export$30a86d91af8ff6e6 = e), $b603667f644cdb6c$export$5880b8b5730aff45 = 0, [];
}
function $b603667f644cdb6c$export$45918ac1574455b1(e) {
    return $b603667f644cdb6c$export$30a86d91af8ff6e6 = "", e;
}
function $b603667f644cdb6c$export$410ac95b9ec204b8(e) {
    return $b603667f644cdb6c$export$87c2784dc9fc4ab($b603667f644cdb6c$export$58adb3bec8346d0f($b603667f644cdb6c$export$5880b8b5730aff45 - 1, $b603667f644cdb6c$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $b603667f644cdb6c$export$660b2ee2d4fb4eff(e) {
    return $b603667f644cdb6c$export$45918ac1574455b1($b603667f644cdb6c$export$5f8c09e3ae6f64e1($b603667f644cdb6c$export$2de70f21292aac9e(e)));
}
function $b603667f644cdb6c$export$7af1228ff777d175(e) {
    while($b603667f644cdb6c$export$c0306caf338ac095 = $b603667f644cdb6c$export$4d3fb11e950abb9e())if ($b603667f644cdb6c$export$c0306caf338ac095 < 33) $b603667f644cdb6c$export$48cfd1e771a65c4f();
    else break;
    return $b603667f644cdb6c$export$9e1725a4cfeada27(e) > 2 || $b603667f644cdb6c$export$9e1725a4cfeada27($b603667f644cdb6c$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $b603667f644cdb6c$export$5f8c09e3ae6f64e1(e) {
    while($b603667f644cdb6c$export$48cfd1e771a65c4f())switch($b603667f644cdb6c$export$9e1725a4cfeada27($b603667f644cdb6c$export$c0306caf338ac095)){
        case 0:
            $b603667f644cdb6c$export$10d8903dec122b9d($b603667f644cdb6c$export$c2ab62c7bf24634($b603667f644cdb6c$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $b603667f644cdb6c$export$10d8903dec122b9d($b603667f644cdb6c$export$410ac95b9ec204b8($b603667f644cdb6c$export$c0306caf338ac095), e);
            break;
        default:
            $b603667f644cdb6c$export$10d8903dec122b9d($b603667f644cdb6c$export$6788812c4e6611e6($b603667f644cdb6c$export$c0306caf338ac095), e);
    }
    return e;
}
function $b603667f644cdb6c$export$955ba06d119e085e(e, r) {
    while(--r && $b603667f644cdb6c$export$48cfd1e771a65c4f())if ($b603667f644cdb6c$export$c0306caf338ac095 < 48 || $b603667f644cdb6c$export$c0306caf338ac095 > 102 || $b603667f644cdb6c$export$c0306caf338ac095 > 57 && $b603667f644cdb6c$export$c0306caf338ac095 < 65 || $b603667f644cdb6c$export$c0306caf338ac095 > 70 && $b603667f644cdb6c$export$c0306caf338ac095 < 97) break;
    return $b603667f644cdb6c$export$58adb3bec8346d0f(e, $b603667f644cdb6c$export$e88cb2efb12ae807() + (r < 6 && $b603667f644cdb6c$export$4d3fb11e950abb9e() == 32 && $b603667f644cdb6c$export$48cfd1e771a65c4f() == 32));
}
function $b603667f644cdb6c$export$c889f2fcc19dbf12(e) {
    while($b603667f644cdb6c$export$48cfd1e771a65c4f())switch($b603667f644cdb6c$export$c0306caf338ac095){
        case e:
            return $b603667f644cdb6c$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $b603667f644cdb6c$export$c889f2fcc19dbf12($b603667f644cdb6c$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $b603667f644cdb6c$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $b603667f644cdb6c$export$48cfd1e771a65c4f();
            break;
    }
    return $b603667f644cdb6c$export$5880b8b5730aff45;
}
function $b603667f644cdb6c$export$4254d4e2b3745c4c(e, r) {
    while($b603667f644cdb6c$export$48cfd1e771a65c4f())if (e + $b603667f644cdb6c$export$c0306caf338ac095 === 57) break;
    else if (e + $b603667f644cdb6c$export$c0306caf338ac095 === 84 && $b603667f644cdb6c$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $b603667f644cdb6c$export$58adb3bec8346d0f(r, $b603667f644cdb6c$export$5880b8b5730aff45 - 1) + "*" + $b603667f644cdb6c$export$6788812c4e6611e6(e === 47 ? e : $b603667f644cdb6c$export$48cfd1e771a65c4f());
}
function $b603667f644cdb6c$export$c2ab62c7bf24634(e) {
    while(!$b603667f644cdb6c$export$9e1725a4cfeada27($b603667f644cdb6c$export$4d3fb11e950abb9e()))$b603667f644cdb6c$export$48cfd1e771a65c4f();
    return $b603667f644cdb6c$export$58adb3bec8346d0f(e, $b603667f644cdb6c$export$5880b8b5730aff45);
}
function $b603667f644cdb6c$export$ef7acd7185315e22(e) {
    return $b603667f644cdb6c$export$45918ac1574455b1($b603667f644cdb6c$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $b603667f644cdb6c$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $b603667f644cdb6c$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $b603667f644cdb6c$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $b603667f644cdb6c$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($b603667f644cdb6c$export$f8e21b1e77979a08(j += $b603667f644cdb6c$export$77ad94ebf1c2b9ed($b603667f644cdb6c$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $b603667f644cdb6c$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $b603667f644cdb6c$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $b603667f644cdb6c$export$955ba06d119e085e($b603667f644cdb6c$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($b603667f644cdb6c$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $b603667f644cdb6c$export$10d8903dec122b9d($b603667f644cdb6c$export$4a34f930e789283c($b603667f644cdb6c$export$4254d4e2b3745c4c($b603667f644cdb6c$export$48cfd1e771a65c4f(), $b603667f644cdb6c$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $b603667f644cdb6c$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $b603667f644cdb6c$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $b603667f644cdb6c$export$36776f635604f274(j) - l) $b603667f644cdb6c$export$10d8903dec122b9d(p > 32 ? $b603667f644cdb6c$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $b603667f644cdb6c$export$f8483753829ec8f3($b603667f644cdb6c$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $b603667f644cdb6c$export$10d8903dec122b9d(y = $b603667f644cdb6c$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $b603667f644cdb6c$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $b603667f644cdb6c$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $b603667f644cdb6c$export$98e6a39c04603d36(e, y, y, n && $b603667f644cdb6c$export$10d8903dec122b9d($b603667f644cdb6c$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $b603667f644cdb6c$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $b603667f644cdb6c$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $b603667f644cdb6c$export$232faf9add678146() == 125) continue;
            }
            switch(j += $b603667f644cdb6c$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($b603667f644cdb6c$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($b603667f644cdb6c$export$4d3fb11e950abb9e() === 45) j += $b603667f644cdb6c$export$410ac95b9ec204b8($b603667f644cdb6c$export$48cfd1e771a65c4f());
                    v = $b603667f644cdb6c$export$4d3fb11e950abb9e(), o = l = $b603667f644cdb6c$export$36776f635604f274(g = j += $b603667f644cdb6c$export$c2ab62c7bf24634($b603667f644cdb6c$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $b603667f644cdb6c$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $b603667f644cdb6c$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $b603667f644cdb6c$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $b603667f644cdb6c$export$2f35ab04d2335697(e, v + 1, v = $b603667f644cdb6c$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $b603667f644cdb6c$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $b603667f644cdb6c$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $b603667f644cdb6c$export$35059013cd4a06db(e, r, a, s === 0 ? $b603667f644cdb6c$export$aa3a2e812ca8570d : i, f, o, l);
}
function $b603667f644cdb6c$export$4a34f930e789283c(e, r, a) {
    return $b603667f644cdb6c$export$35059013cd4a06db(e, r, a, $b603667f644cdb6c$export$a29989082612d0d9, $b603667f644cdb6c$export$6788812c4e6611e6($b603667f644cdb6c$export$eba6f6f03b0a92e7()), $b603667f644cdb6c$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $b603667f644cdb6c$export$f8483753829ec8f3(e, r, a, n) {
    return $b603667f644cdb6c$export$35059013cd4a06db(e, r, a, $b603667f644cdb6c$export$527d108ccf083c2b, $b603667f644cdb6c$export$2f35ab04d2335697(e, 0, n), $b603667f644cdb6c$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $b603667f644cdb6c$export$82e9f45cca5ba907(n, c, s) {
    switch($b603667f644cdb6c$export$d6af199866bfb566(n, c)){
        case 5103:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $b603667f644cdb6c$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$2c0f367103c8d01c + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($b603667f644cdb6c$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $b603667f644cdb6c$export$39dfd62a25e0fe93 + "box-$1$2" + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "flex-item-" + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$b603667f644cdb6c$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $b603667f644cdb6c$export$71ad59f2e432cfe8 + "grid-row-" + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "flex-line-pack" + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + "box-" + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "-grow", "") + $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $b603667f644cdb6c$export$39dfd62a25e0fe93 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $b603667f644cdb6c$export$77ad94ebf1c2b9ed($b603667f644cdb6c$export$77ad94ebf1c2b9ed($b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $b603667f644cdb6c$export$77ad94ebf1c2b9ed($b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $b603667f644cdb6c$export$39dfd62a25e0fe93 + "box-pack:$3" + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $b603667f644cdb6c$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$b603667f644cdb6c$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $b603667f644cdb6c$export$71ad59f2e432cfe8 + "grid-column-align" + $b603667f644cdb6c$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $b603667f644cdb6c$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$b603667f644cdb6c$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$b603667f644cdb6c$export$f8e21b1e77979a08(s, "span") ? $b603667f644cdb6c$export$4659b591c19bdf3d(s, /\d+/) : +$b603667f644cdb6c$export$4659b591c19bdf3d(s, /\d+/) - +$b603667f644cdb6c$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $b603667f644cdb6c$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $b603667f644cdb6c$export$71ad59f2e432cfe8 + $b603667f644cdb6c$export$77ad94ebf1c2b9ed($b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($b603667f644cdb6c$export$36776f635604f274(n) - 1 - c > 6) switch($b603667f644cdb6c$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($b603667f644cdb6c$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $b603667f644cdb6c$export$2c0f367103c8d01c + ($b603667f644cdb6c$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$b603667f644cdb6c$export$f8e21b1e77979a08(n, "stretch") ? $b603667f644cdb6c$export$82e9f45cca5ba907($b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $b603667f644cdb6c$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $b603667f644cdb6c$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($b603667f644cdb6c$export$a9db5e087081082d(n, c + 6) === 121) return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, ":", ":" + $b603667f644cdb6c$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($b603667f644cdb6c$export$a9db5e087081082d(n, $b603667f644cdb6c$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $b603667f644cdb6c$export$39dfd62a25e0fe93 + ($b603667f644cdb6c$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $b603667f644cdb6c$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $b603667f644cdb6c$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, ":", ":" + $b603667f644cdb6c$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $b603667f644cdb6c$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $b603667f644cdb6c$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $b603667f644cdb6c$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $b603667f644cdb6c$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $b603667f644cdb6c$export$a763edbf796b780a:
        case $b603667f644cdb6c$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $b603667f644cdb6c$export$a29989082612d0d9:
            return "";
        case $b603667f644cdb6c$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $b603667f644cdb6c$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $b603667f644cdb6c$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $b603667f644cdb6c$export$36776f635604f274(a = $b603667f644cdb6c$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $b603667f644cdb6c$export$5a7767152ae0305f(e) {
    var r = $b603667f644cdb6c$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $b603667f644cdb6c$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $b603667f644cdb6c$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $b603667f644cdb6c$export$527d108ccf083c2b:
                n.return = $b603667f644cdb6c$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $b603667f644cdb6c$export$b44a8529a35fcb60:
                return $b603667f644cdb6c$export$dfdc1655ccc5b9cb([
                    $b603667f644cdb6c$export$784d13d8ee351f07(n, {
                        value: $b603667f644cdb6c$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $b603667f644cdb6c$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $b603667f644cdb6c$export$aa3a2e812ca8570d:
                if (n.length) return $b603667f644cdb6c$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($b603667f644cdb6c$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $b603667f644cdb6c$export$dfdc1655ccc5b9cb([
                                $b603667f644cdb6c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b603667f644cdb6c$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $b603667f644cdb6c$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $b603667f644cdb6c$export$dfdc1655ccc5b9cb([
                                $b603667f644cdb6c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b603667f644cdb6c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b603667f644cdb6c$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $b603667f644cdb6c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b603667f644cdb6c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b603667f644cdb6c$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $b603667f644cdb6c$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b603667f644cdb6c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $b603667f644cdb6c$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $b603667f644cdb6c$export$76a88f7de6507443(e) {
    switch(e.type){
        case $b603667f644cdb6c$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $b603667f644cdb6c$export$1be1fc439b849fdf($b603667f644cdb6c$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($b603667f644cdb6c$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $b603667f644cdb6c$export$2f35ab04d2335697(r, 1, $b603667f644cdb6c$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $b603667f644cdb6c$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $b603667f644cdb6c$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $b603667f644cdb6c$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $01dd6d6edb5751b1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $13c40669f427ffbb$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $b603667f644cdb6c$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $b603667f644cdb6c$export$9e1725a4cfeada27)(character)) break;
        (0, $b603667f644cdb6c$export$48cfd1e771a65c4f)();
    }
    return (0, $b603667f644cdb6c$export$58adb3bec8346d0f)(begin, (0, $b603667f644cdb6c$export$5880b8b5730aff45));
};
var $13c40669f427ffbb$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $b603667f644cdb6c$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $b603667f644cdb6c$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $13c40669f427ffbb$var$identifierWithPointTracking((0, $b603667f644cdb6c$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $b603667f644cdb6c$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $b603667f644cdb6c$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $b603667f644cdb6c$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $b603667f644cdb6c$export$48cfd1e771a65c4f)());
    return parsed;
};
var $13c40669f427ffbb$var$getRules = function getRules(value, points) {
    return (0, $b603667f644cdb6c$export$45918ac1574455b1)($13c40669f427ffbb$var$toRules((0, $b603667f644cdb6c$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $13c40669f427ffbb$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $13c40669f427ffbb$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$13c40669f427ffbb$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $13c40669f427ffbb$var$fixedElements.set(element, true);
    var points = [];
    var rules = $13c40669f427ffbb$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $13c40669f427ffbb$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $13c40669f427ffbb$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $13c40669f427ffbb$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($13c40669f427ffbb$var$ignoreFlag) > -1;
};
var $13c40669f427ffbb$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($13c40669f427ffbb$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $13c40669f427ffbb$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $13c40669f427ffbb$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$13c40669f427ffbb$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $13c40669f427ffbb$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $13c40669f427ffbb$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$13c40669f427ffbb$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $13c40669f427ffbb$var$nullifyElement(element);
    } else if ($13c40669f427ffbb$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $13c40669f427ffbb$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $13c40669f427ffbb$var$prefix(value, length) {
    switch((0, $b603667f644cdb6c$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$2c0f367103c8d01c) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "flex-item-" + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "box-" + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)((0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)((0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)((0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $b603667f644cdb6c$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $b603667f644cdb6c$export$2c0f367103c8d01c) + ((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $b603667f644cdb6c$export$f8e21b1e77979a08)(value, "stretch") ? $13c40669f427ffbb$var$prefix((0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, (0, $b603667f644cdb6c$export$36776f635604f274)(value) - 3 - (~(0, $b603667f644cdb6c$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + ((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $b603667f644cdb6c$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + value + (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $13c40669f427ffbb$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $b603667f644cdb6c$export$527d108ccf083c2b:
                element["return"] = $13c40669f427ffbb$var$prefix(element.value, element.length);
                break;
            case 0, $b603667f644cdb6c$export$b44a8529a35fcb60:
                return (0, $b603667f644cdb6c$export$dfdc1655ccc5b9cb)([
                    (0, $b603667f644cdb6c$export$784d13d8ee351f07)(element, {
                        value: (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $b603667f644cdb6c$export$aa3a2e812ca8570d:
                if (element.length) return (0, $b603667f644cdb6c$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $b603667f644cdb6c$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $b603667f644cdb6c$export$dfdc1655ccc5b9cb)([
                                (0, $b603667f644cdb6c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $b603667f644cdb6c$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $b603667f644cdb6c$export$dfdc1655ccc5b9cb)([
                                (0, $b603667f644cdb6c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $b603667f644cdb6c$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $b603667f644cdb6c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $b603667f644cdb6c$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $b603667f644cdb6c$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b603667f644cdb6c$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $b603667f644cdb6c$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $13c40669f427ffbb$var$defaultStylisPlugins = [
    $13c40669f427ffbb$var$prefixer
];
var $13c40669f427ffbb$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $13c40669f427ffbb$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $13c40669f427ffbb$var$compat,
        $13c40669f427ffbb$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $b603667f644cdb6c$export$fac44ee5b035f737),
        (0, $b603667f644cdb6c$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b603667f644cdb6c$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $b603667f644cdb6c$export$dfdc1655ccc5b9cb)((0, $b603667f644cdb6c$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $3fabbdc7cd23bfd4$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0fcc55b37a65f8be$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($d821d7836ef7c072$exports)))(targetComponent, sourceComponent);
};


var $ea23acab5a770aea$var$isBrowser = true;
function $ea23acab5a770aea$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $ea23acab5a770aea$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ea23acab5a770aea$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ea23acab5a770aea$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ea23acab5a770aea$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $61be2aa39c3c9037$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $377b1585eb96bcf1$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $9380ae9a473d79d2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $9380ae9a473d79d2$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $9380ae9a473d79d2$var$hyphenateRegex = /[A-Z]|^ms/g;
var $9380ae9a473d79d2$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $9380ae9a473d79d2$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $9380ae9a473d79d2$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $9380ae9a473d79d2$var$processStyleName = /* #__PURE__ */ (0, $bf04a10aabf5b477$export$2e2bcd8739ae039)(function(styleName) {
    return $9380ae9a473d79d2$var$isCustomProperty(styleName) ? styleName : styleName.replace($9380ae9a473d79d2$var$hyphenateRegex, "-$&").toLowerCase();
});
var $9380ae9a473d79d2$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($9380ae9a473d79d2$var$animationRegex, function(match, p1, p2) {
                $9380ae9a473d79d2$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $9380ae9a473d79d2$var$cursor
                };
                return p1;
            });
    }
    if ((0, $377b1585eb96bcf1$export$2e2bcd8739ae039)[key] !== 1 && !$9380ae9a473d79d2$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $9380ae9a473d79d2$var$contentValuePattern, $9380ae9a473d79d2$var$contentValues, $9380ae9a473d79d2$var$oldProcessStyleValue, $9380ae9a473d79d2$var$msPattern, $9380ae9a473d79d2$var$hyphenPattern, $9380ae9a473d79d2$var$hyphenatedCache;
var $9380ae9a473d79d2$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $9380ae9a473d79d2$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $9380ae9a473d79d2$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $9380ae9a473d79d2$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $9380ae9a473d79d2$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $9380ae9a473d79d2$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $9380ae9a473d79d2$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $9380ae9a473d79d2$var$cursor;
                var result = interpolation(mergedProps);
                $9380ae9a473d79d2$var$cursor = previousCursor;
                return $9380ae9a473d79d2$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $9380ae9a473d79d2$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $9380ae9a473d79d2$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($9380ae9a473d79d2$var$isProcessableValue(value)) string += $9380ae9a473d79d2$var$processStyleName(_key) + ":" + $9380ae9a473d79d2$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($9380ae9a473d79d2$var$isProcessableValue(value[_i])) string += $9380ae9a473d79d2$var$processStyleName(_key) + ":" + $9380ae9a473d79d2$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $9380ae9a473d79d2$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $9380ae9a473d79d2$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $9380ae9a473d79d2$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $9380ae9a473d79d2$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $9380ae9a473d79d2$var$cursor;
var $9380ae9a473d79d2$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $9380ae9a473d79d2$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $9380ae9a473d79d2$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $9380ae9a473d79d2$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $9380ae9a473d79d2$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $9380ae9a473d79d2$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $61be2aa39c3c9037$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $9380ae9a473d79d2$var$cursor
    };
};



var $4hYjL = parcelRequire("4hYjL");
var $12b575ec95b2fa61$var$syncFallback = function syncFallback(create) {
    return create();
};
var $12b575ec95b2fa61$var$useInsertionEffect = $4hYjL.useInsertionEffect ? $4hYjL.useInsertionEffect : false;
var $12b575ec95b2fa61$export$db21c7ffa21794e7 = $12b575ec95b2fa61$var$useInsertionEffect || $12b575ec95b2fa61$var$syncFallback;
var $12b575ec95b2fa61$export$811a713a7276cb9d = $12b575ec95b2fa61$var$useInsertionEffect || $4hYjL.useLayoutEffect;


var $ba9e5771634a3fa6$export$23f2a1d2818174ef = true;
var $ba9e5771634a3fa6$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ba9e5771634a3fa6$var$EmotionCacheContext = /* #__PURE__ */ $4hYjL.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $13c40669f427ffbb$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $ba9e5771634a3fa6$export$e7094788287c5e9b = $ba9e5771634a3fa6$var$EmotionCacheContext.Provider;
var $ba9e5771634a3fa6$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $4hYjL.useContext)($ba9e5771634a3fa6$var$EmotionCacheContext);
};
var $ba9e5771634a3fa6$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $4hYjL.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $4hYjL.useContext)($ba9e5771634a3fa6$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$ba9e5771634a3fa6$export$23f2a1d2818174ef) $ba9e5771634a3fa6$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $4hYjL.useContext)($ba9e5771634a3fa6$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $13c40669f427ffbb$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $4hYjL.createElement($ba9e5771634a3fa6$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $ba9e5771634a3fa6$export$971d5caa766a69d7 = /* #__PURE__ */ $4hYjL.createContext({});
var $ba9e5771634a3fa6$export$3b14a55fb2447963 = function useTheme() {
    return $4hYjL.useContext($ba9e5771634a3fa6$export$971d5caa766a69d7);
};
var $ba9e5771634a3fa6$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $ba9e5771634a3fa6$var$createCacheWithTheme = /* #__PURE__ */ (0, $01dd6d6edb5751b1$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $01dd6d6edb5751b1$export$2e2bcd8739ae039)(function(theme) {
        return $ba9e5771634a3fa6$var$getTheme(outerTheme, theme);
    });
});
var $ba9e5771634a3fa6$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $4hYjL.useContext($ba9e5771634a3fa6$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ba9e5771634a3fa6$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $4hYjL.createElement($ba9e5771634a3fa6$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ba9e5771634a3fa6$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $4hYjL.useContext($ba9e5771634a3fa6$export$971d5caa766a69d7);
        return /*#__PURE__*/ $4hYjL.createElement(Component, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $4hYjL.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $0fcc55b37a65f8be$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $ba9e5771634a3fa6$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $ba9e5771634a3fa6$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $ba9e5771634a3fa6$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $ba9e5771634a3fa6$var$getLastPart(match[1]);
    return undefined;
};
var $ba9e5771634a3fa6$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $ba9e5771634a3fa6$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $ba9e5771634a3fa6$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $ba9e5771634a3fa6$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($ba9e5771634a3fa6$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $ba9e5771634a3fa6$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $ba9e5771634a3fa6$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $ba9e5771634a3fa6$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $ba9e5771634a3fa6$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ba9e5771634a3fa6$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ba9e5771634a3fa6$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $ba9e5771634a3fa6$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $ea23acab5a770aea$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $12b575ec95b2fa61$export$db21c7ffa21794e7)(function() {
        return (0, $ea23acab5a770aea$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $ba9e5771634a3fa6$var$Emotion = /* #__PURE__ */ $ba9e5771634a3fa6$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ba9e5771634a3fa6$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $ea23acab5a770aea$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $9380ae9a473d79d2$export$6321afa313b251b5)(registeredStyles, undefined, $4hYjL.useContext($ba9e5771634a3fa6$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ba9e5771634a3fa6$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $ba9e5771634a3fa6$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $4hYjL.createElement($4hYjL.Fragment, null, /*#__PURE__*/ $4hYjL.createElement($ba9e5771634a3fa6$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $4hYjL.createElement(WrappedComponent, newProps));
});
var $ba9e5771634a3fa6$export$a9c23c6ac3fc3eca = $ba9e5771634a3fa6$var$Emotion;



var $4hYjL = parcelRequire("4hYjL");




var $a36f907fd01647ba$exports = {};
function $a36f907fd01647ba$var$_extends() {
    return $a36f907fd01647ba$exports = $a36f907fd01647ba$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a36f907fd01647ba$exports.__esModule = true, $a36f907fd01647ba$exports["default"] = $a36f907fd01647ba$exports, $a36f907fd01647ba$var$_extends.apply(null, arguments);
}
$a36f907fd01647ba$exports = $a36f907fd01647ba$var$_extends, $a36f907fd01647ba$exports.__esModule = true, $a36f907fd01647ba$exports["default"] = $a36f907fd01647ba$exports;





var $93f238fb4c7fa273$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $93f238fb4c7fa273$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $ba9e5771634a3fa6$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $4hYjL.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $ba9e5771634a3fa6$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $ba9e5771634a3fa6$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $4hYjL.createElement.apply(null, createElementArgArray);
};
var $93f238fb4c7fa273$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $93f238fb4c7fa273$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $ba9e5771634a3fa6$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $9380ae9a473d79d2$export$6321afa313b251b5)([
        styles
    ], undefined, $4hYjL.useContext((0, $ba9e5771634a3fa6$export$971d5caa766a69d7)));
    if (!(0, $ba9e5771634a3fa6$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $4hYjL.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $4hYjL.useRef();
    (0, $12b575ec95b2fa61$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $12b575ec95b2fa61$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $ea23acab5a770aea$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $93f238fb4c7fa273$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9380ae9a473d79d2$export$6321afa313b251b5)(args);
}
var $93f238fb4c7fa273$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $93f238fb4c7fa273$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $93f238fb4c7fa273$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $93f238fb4c7fa273$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $ea23acab5a770aea$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $93f238fb4c7fa273$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $12b575ec95b2fa61$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $ea23acab5a770aea$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $93f238fb4c7fa273$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $ba9e5771634a3fa6$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $9380ae9a473d79d2$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $ea23acab5a770aea$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $93f238fb4c7fa273$var$merge(cache.registered, css, $93f238fb4c7fa273$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $4hYjL.useContext((0, $ba9e5771634a3fa6$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $4hYjL.createElement($4hYjL.Fragment, null, /*#__PURE__*/ $4hYjL.createElement($93f238fb4c7fa273$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $93f238fb4c7fa273$var$isBrowser, $93f238fb4c7fa273$var$isTestEnv, $93f238fb4c7fa273$var$globalContext, $93f238fb4c7fa273$var$globalKey;





var $d465dff511a11449$var$testOmitPropsOnStringTag = (0, $863a29b13f82576c$export$2e2bcd8739ae039);
var $d465dff511a11449$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $d465dff511a11449$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $d465dff511a11449$var$testOmitPropsOnStringTag : $d465dff511a11449$var$testOmitPropsOnComponent;
};
var $d465dff511a11449$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $d465dff511a11449$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $d465dff511a11449$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $ea23acab5a770aea$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $12b575ec95b2fa61$export$db21c7ffa21794e7)(function() {
        return (0, $ea23acab5a770aea$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $d465dff511a11449$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $d465dff511a11449$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $d465dff511a11449$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $ba9e5771634a3fa6$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $4hYjL.useContext((0, $ba9e5771634a3fa6$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $ea23acab5a770aea$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $9380ae9a473d79d2$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $d465dff511a11449$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $4hYjL.createElement($4hYjL.Fragment, null, /*#__PURE__*/ $4hYjL.createElement($d465dff511a11449$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $4hYjL.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $d465dff511a11449$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("4hYjL");





var $baa5fd1ed4259a75$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $baa5fd1ed4259a75$export$2e2bcd8739ae039 = (0, $d465dff511a11449$export$2e2bcd8739ae039).bind();
$baa5fd1ed4259a75$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $baa5fd1ed4259a75$export$2e2bcd8739ae039[tagName] = $baa5fd1ed4259a75$export$2e2bcd8739ae039(tagName);
});





function $46714366c23b252c$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $baa5fd1ed4259a75$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $46714366c23b252c$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};






function $1c6e6053d8f46bf2$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $1c6e6053d8f46bf2$var$deepClone(source) {
    if (!$1c6e6053d8f46bf2$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $1c6e6053d8f46bf2$var$deepClone(source[key]);
    });
    return output;
}
function $1c6e6053d8f46bf2$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, target) : target;
    if ($1c6e6053d8f46bf2$export$53b83ca8eaab0383(target) && $1c6e6053d8f46bf2$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($1c6e6053d8f46bf2$export$53b83ca8eaab0383(source[key]) && key in target && $1c6e6053d8f46bf2$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $1c6e6053d8f46bf2$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $1c6e6053d8f46bf2$export$53b83ca8eaab0383(source[key]) ? $1c6e6053d8f46bf2$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}




const $2fb591a86626101f$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $2fb591a86626101f$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $2fb591a86626101f$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $2fb591a86626101f$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(breakpoints, $2fb591a86626101f$var$_excluded);
    const sortedValues = $2fb591a86626101f$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}


const $08b4ce24f2264b02$var$shape = {
    borderRadius: 4
};
var $08b4ce24f2264b02$export$2e2bcd8739ae039 = $08b4ce24f2264b02$var$shape;







function $afcac0406c3626fc$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $afcac0406c3626fc$export$2e2bcd8739ae039 = $afcac0406c3626fc$var$merge;


const $43ffa14d1f5b328d$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $43ffa14d1f5b328d$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$43ffa14d1f5b328d$export$68c286be0e7e55b7[key]}px)`
};
function $43ffa14d1f5b328d$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $43ffa14d1f5b328d$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $43ffa14d1f5b328d$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $43ffa14d1f5b328d$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $43ffa14d1f5b328d$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $43ffa14d1f5b328d$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $afcac0406c3626fc$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $43ffa14d1f5b328d$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $43ffa14d1f5b328d$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $43ffa14d1f5b328d$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $43ffa14d1f5b328d$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)(prev, next), {});
    return $43ffa14d1f5b328d$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $43ffa14d1f5b328d$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $43ffa14d1f5b328d$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $43ffa14d1f5b328d$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $43ffa14d1f5b328d$export$2e2bcd8739ae039 = $43ffa14d1f5b328d$var$breakpoints;



function $baca60b879486349$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $966219a2cc67a38f$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $d7c65c71583a29e0$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $d7c65c71583a29e0$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $d7c65c71583a29e0$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $d7c65c71583a29e0$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $d7c65c71583a29e0$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $d7c65c71583a29e0$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $d7c65c71583a29e0$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $baca60b879486349$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d7c65c71583a29e0$export$2e2bcd8739ae039 = $d7c65c71583a29e0$var$style;



function $e5efa942e73f0aed$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $a08f87d59a31c007$var$properties = {
    m: "margin",
    p: "padding"
};
const $a08f87d59a31c007$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $a08f87d59a31c007$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $a08f87d59a31c007$var$getCssProperties = (0, $e5efa942e73f0aed$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($a08f87d59a31c007$var$aliases[prop]) prop = $a08f87d59a31c007$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $a08f87d59a31c007$var$properties[a];
    const direction = $a08f87d59a31c007$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $a08f87d59a31c007$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $a08f87d59a31c007$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $a08f87d59a31c007$var$spacingKeys = [
    ...$a08f87d59a31c007$export$aab52a0dde05ad8a,
    ...$a08f87d59a31c007$export$f8397d44f03ab6ad
];
function $a08f87d59a31c007$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $d7c65c71583a29e0$export$2aa3fd96c49a84a8)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $a08f87d59a31c007$export$1def6f833384e3d1(theme) {
    return $a08f87d59a31c007$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $a08f87d59a31c007$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $a08f87d59a31c007$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $a08f87d59a31c007$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $a08f87d59a31c007$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $a08f87d59a31c007$var$getCssProperties(prop);
    const styleFromPropValue = $a08f87d59a31c007$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $a08f87d59a31c007$var$style(props, keys) {
    const transformer = $a08f87d59a31c007$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$a08f87d59a31c007$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $afcac0406c3626fc$export$2e2bcd8739ae039), {});
}
function $a08f87d59a31c007$export$7ede87f9b603dd3c(props) {
    return $a08f87d59a31c007$var$style(props, $a08f87d59a31c007$export$aab52a0dde05ad8a);
}
$a08f87d59a31c007$export$7ede87f9b603dd3c.propTypes = {};
$a08f87d59a31c007$export$7ede87f9b603dd3c.filterProps = $a08f87d59a31c007$export$aab52a0dde05ad8a;
function $a08f87d59a31c007$export$6f98e8eaf0be1996(props) {
    return $a08f87d59a31c007$var$style(props, $a08f87d59a31c007$export$f8397d44f03ab6ad);
}
$a08f87d59a31c007$export$6f98e8eaf0be1996.propTypes = {};
$a08f87d59a31c007$export$6f98e8eaf0be1996.filterProps = $a08f87d59a31c007$export$f8397d44f03ab6ad;
function $a08f87d59a31c007$var$spacing(props) {
    return $a08f87d59a31c007$var$style(props, $a08f87d59a31c007$var$spacingKeys);
}
$a08f87d59a31c007$var$spacing.propTypes = {};
$a08f87d59a31c007$var$spacing.filterProps = $a08f87d59a31c007$var$spacingKeys;
var $a08f87d59a31c007$export$2e2bcd8739ae039 = $a08f87d59a31c007$var$spacing;


function $7864fb1d20aad4b5$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $a08f87d59a31c007$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}










function $967e8fac5f16b4ce$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $afcac0406c3626fc$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $967e8fac5f16b4ce$export$2e2bcd8739ae039 = $967e8fac5f16b4ce$var$compose;




function $419dc1c45e838533$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $419dc1c45e838533$export$1edee58a52776cd9 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $419dc1c45e838533$export$34e2febe53ae29cc
});
const $419dc1c45e838533$export$f9a7b6bd24892946 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $419dc1c45e838533$export$34e2febe53ae29cc
});
const $419dc1c45e838533$export$5abca33e6be905d2 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $419dc1c45e838533$export$34e2febe53ae29cc
});
const $419dc1c45e838533$export$e2ce9f12a980a822 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $419dc1c45e838533$export$34e2febe53ae29cc
});
const $419dc1c45e838533$export$47658cca1a909427 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $419dc1c45e838533$export$34e2febe53ae29cc
});
const $419dc1c45e838533$export$e7fb0694ba2404fc = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
const $419dc1c45e838533$export$126a92c968acdb85 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $419dc1c45e838533$export$85cc51cb8fbb8c0e = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $419dc1c45e838533$export$340b0327727f6d1a = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $419dc1c45e838533$export$60beef91a985b4bf = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $419dc1c45e838533$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $a08f87d59a31c007$export$cb5ee237cce814a2)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $a08f87d59a31c007$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$419dc1c45e838533$export$7a57f79000377ca2.propTypes = {};
$419dc1c45e838533$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $419dc1c45e838533$var$borders = (0, $967e8fac5f16b4ce$export$2e2bcd8739ae039)($419dc1c45e838533$export$1edee58a52776cd9, $419dc1c45e838533$export$f9a7b6bd24892946, $419dc1c45e838533$export$5abca33e6be905d2, $419dc1c45e838533$export$e2ce9f12a980a822, $419dc1c45e838533$export$47658cca1a909427, $419dc1c45e838533$export$e7fb0694ba2404fc, $419dc1c45e838533$export$126a92c968acdb85, $419dc1c45e838533$export$85cc51cb8fbb8c0e, $419dc1c45e838533$export$340b0327727f6d1a, $419dc1c45e838533$export$60beef91a985b4bf, $419dc1c45e838533$export$7a57f79000377ca2);
var $419dc1c45e838533$export$2e2bcd8739ae039 = $419dc1c45e838533$var$borders;







const $56ae03e1be692661$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $a08f87d59a31c007$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $a08f87d59a31c007$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$56ae03e1be692661$export$5df9adcb0db95e1e.propTypes = {};
$56ae03e1be692661$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $56ae03e1be692661$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $a08f87d59a31c007$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $a08f87d59a31c007$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$56ae03e1be692661$export$ec60d70ff941a580.propTypes = {};
$56ae03e1be692661$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $56ae03e1be692661$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $a08f87d59a31c007$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $a08f87d59a31c007$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$56ae03e1be692661$export$8a833ffa5f5dbeda.propTypes = {};
$56ae03e1be692661$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $56ae03e1be692661$export$baf44164ca3a34e8 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
const $56ae03e1be692661$export$8f7213a1cd01e832 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
const $56ae03e1be692661$export$b0e0abbc49ba668 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
const $56ae03e1be692661$export$bcd8b929d4b4142 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
const $56ae03e1be692661$export$e5039a674e14c828 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
const $56ae03e1be692661$export$42bd9088661ffb03 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
const $56ae03e1be692661$export$920682ae05b999bc = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
const $56ae03e1be692661$export$1b88fbdd482fd33a = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
const $56ae03e1be692661$export$bdb486e40d52d26f = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
const $56ae03e1be692661$var$grid = (0, $967e8fac5f16b4ce$export$2e2bcd8739ae039)($56ae03e1be692661$export$5df9adcb0db95e1e, $56ae03e1be692661$export$ec60d70ff941a580, $56ae03e1be692661$export$8a833ffa5f5dbeda, $56ae03e1be692661$export$baf44164ca3a34e8, $56ae03e1be692661$export$8f7213a1cd01e832, $56ae03e1be692661$export$b0e0abbc49ba668, $56ae03e1be692661$export$bcd8b929d4b4142, $56ae03e1be692661$export$e5039a674e14c828, $56ae03e1be692661$export$42bd9088661ffb03, $56ae03e1be692661$export$920682ae05b999bc, $56ae03e1be692661$export$1b88fbdd482fd33a, $56ae03e1be692661$export$bdb486e40d52d26f);
var $56ae03e1be692661$export$2e2bcd8739ae039 = $56ae03e1be692661$var$grid;




function $991e40255f26f4ea$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $991e40255f26f4ea$export$35e9368ef982300f = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette",
    transform: $991e40255f26f4ea$export$dbaffd4420ea0ac6
});
const $991e40255f26f4ea$export$2506f56c10355b33 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $991e40255f26f4ea$export$dbaffd4420ea0ac6
});
const $991e40255f26f4ea$export$8c5a050822fd698c = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $991e40255f26f4ea$export$dbaffd4420ea0ac6
});
const $991e40255f26f4ea$var$palette = (0, $967e8fac5f16b4ce$export$2e2bcd8739ae039)($991e40255f26f4ea$export$35e9368ef982300f, $991e40255f26f4ea$export$2506f56c10355b33, $991e40255f26f4ea$export$8c5a050822fd698c);
var $991e40255f26f4ea$export$2e2bcd8739ae039 = $991e40255f26f4ea$var$palette;





function $e32cb1c6d1ac047b$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $e32cb1c6d1ac047b$export$7e3df82ee760448c = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $43ffa14d1f5b328d$export$68c286be0e7e55b7)[propValue];
            return {
                maxWidth: breakpoint || $e32cb1c6d1ac047b$export$8afece71750ec241(propValue)
            };
        };
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$e32cb1c6d1ac047b$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $e32cb1c6d1ac047b$export$ee148fbbe8357dd2 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$ac607276a8fe9f0a = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$dc0d8bd0b94f8570 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$a43cf604e12f3b17 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$ffed9f14fb65e276 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$905076ed6620e671 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $e32cb1c6d1ac047b$export$8afece71750ec241
});
const $e32cb1c6d1ac047b$export$6ccc93f785106a58 = (0, $d7c65c71583a29e0$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
const $e32cb1c6d1ac047b$var$sizing = (0, $967e8fac5f16b4ce$export$2e2bcd8739ae039)($e32cb1c6d1ac047b$export$7e3df82ee760448c, $e32cb1c6d1ac047b$export$488fda99655ff65a, $e32cb1c6d1ac047b$export$ee148fbbe8357dd2, $e32cb1c6d1ac047b$export$ac607276a8fe9f0a, $e32cb1c6d1ac047b$export$dc0d8bd0b94f8570, $e32cb1c6d1ac047b$export$a43cf604e12f3b17, $e32cb1c6d1ac047b$export$6ccc93f785106a58);
var $e32cb1c6d1ac047b$export$2e2bcd8739ae039 = $e32cb1c6d1ac047b$var$sizing;


const $cde2aef51403f7e2$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $419dc1c45e838533$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $419dc1c45e838533$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $419dc1c45e838533$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $419dc1c45e838533$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $419dc1c45e838533$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $419dc1c45e838533$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $991e40255f26f4ea$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $991e40255f26f4ea$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $991e40255f26f4ea$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $a08f87d59a31c007$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $a08f87d59a31c007$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $56ae03e1be692661$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $56ae03e1be692661$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $56ae03e1be692661$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $e32cb1c6d1ac047b$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $e32cb1c6d1ac047b$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $e32cb1c6d1ac047b$export$8afece71750ec241)
    },
    height: {
        transform: (0, $e32cb1c6d1ac047b$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $e32cb1c6d1ac047b$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $e32cb1c6d1ac047b$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $cde2aef51403f7e2$export$2e2bcd8739ae039 = $cde2aef51403f7e2$var$defaultSxConfig;


function $1f7bcf6080aec179$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $1f7bcf6080aec179$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $1f7bcf6080aec179$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $d7c65c71583a29e0$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $d7c65c71583a29e0$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $d7c65c71583a29e0$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $baca60b879486349$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $cde2aef51403f7e2$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $43ffa14d1f5b328d$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $1f7bcf6080aec179$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $afcac0406c3626fc$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $43ffa14d1f5b328d$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($1f7bcf6080aec179$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $afcac0406c3626fc$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $afcac0406c3626fc$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $43ffa14d1f5b328d$export$8922c90b6e020726)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $1f7bcf6080aec179$var$styleFunctionSx = $1f7bcf6080aec179$export$7d53d8bf2911e013();
$1f7bcf6080aec179$var$styleFunctionSx.filterProps = [
    "sx"
];
var $1f7bcf6080aec179$export$2e2bcd8739ae039 = $1f7bcf6080aec179$var$styleFunctionSx;



const $54aa115c114e75e2$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $54aa115c114e75e2$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(options, $54aa115c114e75e2$var$_excluded);
    const breakpoints = (0, $2fb591a86626101f$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $7864fb1d20aad4b5$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, (0, $08b4ce24f2264b02$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, (0, $cde2aef51403f7e2$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $1f7bcf6080aec179$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $54aa115c114e75e2$export$2e2bcd8739ae039 = $54aa115c114e75e2$var$createTheme;




const $db8e1207e0535e38$var$_excluded = [
    "variant"
];
function $db8e1207e0535e38$var$isEmpty(string) {
    return string.length === 0;
}
function $db8e1207e0535e38$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $db8e1207e0535e38$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $db8e1207e0535e38$var$isEmpty(classKey) ? props[key] : (0, $baca60b879486349$export$2e2bcd8739ae039)(props[key]);
        else classKey += `${$db8e1207e0535e38$var$isEmpty(classKey) ? key : (0, $baca60b879486349$export$2e2bcd8739ae039)(key)}${(0, $baca60b879486349$export$2e2bcd8739ae039)(props[key].toString())}`;
    });
    return classKey;
}



const $4a217562dd85efa3$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $4a217562dd85efa3$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $4a217562dd85efa3$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $4a217562dd85efa3$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $4a217562dd85efa3$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $db8e1207e0535e38$export$2e2bcd8739ae039)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $4a217562dd85efa3$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $db8e1207e0535e38$export$2e2bcd8739ae039)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $4a217562dd85efa3$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $4a217562dd85efa3$export$35e57303dbd8a66 = (0, $54aa115c114e75e2$export$2e2bcd8739ae039)();
const $4a217562dd85efa3$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $4a217562dd85efa3$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $4a217562dd85efa3$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $4a217562dd85efa3$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $4a217562dd85efa3$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $4a217562dd85efa3$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $4a217562dd85efa3$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $1f7bcf6080aec179$export$2e2bcd8739ae039)((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
            theme: $4a217562dd85efa3$var$resolveTheme((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $46714366c23b252c$export$e00380445f2b9e0c)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(inputOptions, $4a217562dd85efa3$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $4a217562dd85efa3$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($4a217562dd85efa3$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $46714366c23b252c$export$2e2bcd8739ae039)(tag, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                        theme: $4a217562dd85efa3$var$resolveTheme((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $4a217562dd85efa3$var$resolveTheme((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $4a217562dd85efa3$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $4a217562dd85efa3$var$resolveTheme((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $4a217562dd85efa3$var$variantsResolver(props, $4a217562dd85efa3$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                    theme: $4a217562dd85efa3$var$resolveTheme((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}








function $7b22fda72254538c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}






const $a2a48f05ae91fef0$var$common = {
    black: "#000",
    white: "#fff"
};
var $a2a48f05ae91fef0$export$2e2bcd8739ae039 = $a2a48f05ae91fef0$var$common;


const $c9fddd520d7ed071$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $c9fddd520d7ed071$export$2e2bcd8739ae039 = $c9fddd520d7ed071$var$grey;


const $c4a20b2d8356e6e5$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $c4a20b2d8356e6e5$export$2e2bcd8739ae039 = $c4a20b2d8356e6e5$var$purple;


const $81f4c6c7286fd132$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $81f4c6c7286fd132$export$2e2bcd8739ae039 = $81f4c6c7286fd132$var$red;


const $1296db0ec817cc4e$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $1296db0ec817cc4e$export$2e2bcd8739ae039 = $1296db0ec817cc4e$var$orange;


const $b60fa6139340cdc0$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $b60fa6139340cdc0$export$2e2bcd8739ae039 = $b60fa6139340cdc0$var$blue;


const $1e076fec59c10b6d$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $1e076fec59c10b6d$export$2e2bcd8739ae039 = $1e076fec59c10b6d$var$lightBlue;


const $41aac8f55f856d42$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $41aac8f55f856d42$export$2e2bcd8739ae039 = $41aac8f55f856d42$var$green;


const $32660e444dceda09$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $32660e444dceda09$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $a2a48f05ae91fef0$export$2e2bcd8739ae039).white,
        default: (0, $a2a48f05ae91fef0$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $32660e444dceda09$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $a2a48f05ae91fef0$export$2e2bcd8739ae039).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $a2a48f05ae91fef0$export$2e2bcd8739ae039).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $32660e444dceda09$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $ee4e4eff643c0f2b$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $ee4e4eff643c0f2b$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $32660e444dceda09$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $b60fa6139340cdc0$export$2e2bcd8739ae039)[200],
        light: (0, $b60fa6139340cdc0$export$2e2bcd8739ae039)[50],
        dark: (0, $b60fa6139340cdc0$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $b60fa6139340cdc0$export$2e2bcd8739ae039)[700],
        light: (0, $b60fa6139340cdc0$export$2e2bcd8739ae039)[400],
        dark: (0, $b60fa6139340cdc0$export$2e2bcd8739ae039)[800]
    };
}
function $32660e444dceda09$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $c4a20b2d8356e6e5$export$2e2bcd8739ae039)[200],
        light: (0, $c4a20b2d8356e6e5$export$2e2bcd8739ae039)[50],
        dark: (0, $c4a20b2d8356e6e5$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $c4a20b2d8356e6e5$export$2e2bcd8739ae039)[500],
        light: (0, $c4a20b2d8356e6e5$export$2e2bcd8739ae039)[300],
        dark: (0, $c4a20b2d8356e6e5$export$2e2bcd8739ae039)[700]
    };
}
function $32660e444dceda09$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $81f4c6c7286fd132$export$2e2bcd8739ae039)[500],
        light: (0, $81f4c6c7286fd132$export$2e2bcd8739ae039)[300],
        dark: (0, $81f4c6c7286fd132$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $81f4c6c7286fd132$export$2e2bcd8739ae039)[700],
        light: (0, $81f4c6c7286fd132$export$2e2bcd8739ae039)[400],
        dark: (0, $81f4c6c7286fd132$export$2e2bcd8739ae039)[800]
    };
}
function $32660e444dceda09$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1e076fec59c10b6d$export$2e2bcd8739ae039)[400],
        light: (0, $1e076fec59c10b6d$export$2e2bcd8739ae039)[300],
        dark: (0, $1e076fec59c10b6d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $1e076fec59c10b6d$export$2e2bcd8739ae039)[700],
        light: (0, $1e076fec59c10b6d$export$2e2bcd8739ae039)[500],
        dark: (0, $1e076fec59c10b6d$export$2e2bcd8739ae039)[900]
    };
}
function $32660e444dceda09$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $41aac8f55f856d42$export$2e2bcd8739ae039)[400],
        light: (0, $41aac8f55f856d42$export$2e2bcd8739ae039)[300],
        dark: (0, $41aac8f55f856d42$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $41aac8f55f856d42$export$2e2bcd8739ae039)[800],
        light: (0, $41aac8f55f856d42$export$2e2bcd8739ae039)[500],
        dark: (0, $41aac8f55f856d42$export$2e2bcd8739ae039)[900]
    };
}
function $32660e444dceda09$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1296db0ec817cc4e$export$2e2bcd8739ae039)[400],
        light: (0, $1296db0ec817cc4e$export$2e2bcd8739ae039)[300],
        dark: (0, $1296db0ec817cc4e$export$2e2bcd8739ae039)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $1296db0ec817cc4e$export$2e2bcd8739ae039)[500],
        dark: (0, $1296db0ec817cc4e$export$2e2bcd8739ae039)[900]
    };
}
function $32660e444dceda09$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(palette, $32660e444dceda09$var$_excluded);
    const primary = palette.primary || $32660e444dceda09$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $32660e444dceda09$var$getDefaultSecondary(mode);
    const error = palette.error || $32660e444dceda09$var$getDefaultError(mode);
    const info = palette.info || $32660e444dceda09$var$getDefaultInfo(mode);
    const success = palette.success || $32660e444dceda09$var$getDefaultSuccess(mode);
    const warning = palette.warning || $32660e444dceda09$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $ee4e4eff643c0f2b$export$d061e26956a60b0a)(background, $32660e444dceda09$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $32660e444dceda09$export$55ce6f3a06c59543.text.primary : $32660e444dceda09$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $966219a2cc67a38f$export$2e2bcd8739ae039)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $966219a2cc67a38f$export$2e2bcd8739ae039)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $32660e444dceda09$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $32660e444dceda09$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $32660e444dceda09$export$55ce6f3a06c59543,
        light: $32660e444dceda09$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, (0, $a2a48f05ae91fef0$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $c9fddd520d7ed071$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}





const $48b1e17367fc0ae6$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $48b1e17367fc0ae6$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $48b1e17367fc0ae6$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $48b1e17367fc0ae6$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $48b1e17367fc0ae6$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $48b1e17367fc0ae6$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_ref, $48b1e17367fc0ae6$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $48b1e17367fc0ae6$var$defaultFontFamily ? {
            letterSpacing: `${$48b1e17367fc0ae6$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $48b1e17367fc0ae6$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $48b1e17367fc0ae6$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $25da05ddcd262418$var$shadowKeyUmbraOpacity = 0.2;
const $25da05ddcd262418$var$shadowKeyPenumbraOpacity = 0.14;
const $25da05ddcd262418$var$shadowAmbientShadowOpacity = 0.12;
function $25da05ddcd262418$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$25da05ddcd262418$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$25da05ddcd262418$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$25da05ddcd262418$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $25da05ddcd262418$var$shadows = [
    "none",
    $25da05ddcd262418$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $25da05ddcd262418$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $25da05ddcd262418$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $25da05ddcd262418$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $25da05ddcd262418$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $25da05ddcd262418$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $25da05ddcd262418$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $25da05ddcd262418$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $25da05ddcd262418$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $25da05ddcd262418$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $25da05ddcd262418$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $25da05ddcd262418$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $25da05ddcd262418$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $25da05ddcd262418$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $25da05ddcd262418$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $25da05ddcd262418$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $25da05ddcd262418$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $25da05ddcd262418$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $25da05ddcd262418$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $25da05ddcd262418$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $25da05ddcd262418$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $25da05ddcd262418$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $25da05ddcd262418$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $25da05ddcd262418$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $25da05ddcd262418$export$2e2bcd8739ae039 = $25da05ddcd262418$var$shadows;




const $20d2750e1dcf99e3$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $20d2750e1dcf99e3$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $20d2750e1dcf99e3$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $20d2750e1dcf99e3$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $20d2750e1dcf99e3$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $20d2750e1dcf99e3$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, $20d2750e1dcf99e3$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, $20d2750e1dcf99e3$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(options, $20d2750e1dcf99e3$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $20d2750e1dcf99e3$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $20d2750e1dcf99e3$var$formatMs(delay)}`).join(",");
    };
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        getAutoHeightDuration: $20d2750e1dcf99e3$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $a8d96e693fbf1663$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $a8d96e693fbf1663$export$2e2bcd8739ae039 = $a8d96e693fbf1663$var$zIndex;


const $41cb2a53bdb96b96$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $41cb2a53bdb96b96$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(options, $41cb2a53bdb96b96$var$_excluded);
    if (options.vars) throw new Error((0, $966219a2cc67a38f$export$2e2bcd8739ae039)(18));
    const palette = (0, $32660e444dceda09$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $54aa115c114e75e2$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $7b22fda72254538c$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $25da05ddcd262418$export$2e2bcd8739ae039).slice(),
        typography: (0, $48b1e17367fc0ae6$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $20d2750e1dcf99e3$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, (0, $a8d96e693fbf1663$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $1c6e6053d8f46bf2$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, (0, $cde2aef51403f7e2$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $1f7bcf6080aec179$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $41cb2a53bdb96b96$var$warnedOnce = false;
function $41cb2a53bdb96b96$export$c469355549431d9b(...args) {
    return $41cb2a53bdb96b96$var$createTheme(...args);
}
var $41cb2a53bdb96b96$export$2e2bcd8739ae039 = $41cb2a53bdb96b96$var$createTheme;


const $2fa8eaec34a3cd3e$var$defaultTheme = (0, $41cb2a53bdb96b96$export$2e2bcd8739ae039)();
var $2fa8eaec34a3cd3e$export$2e2bcd8739ae039 = $2fa8eaec34a3cd3e$var$defaultTheme;


var $4dc79eb3bce727b2$export$2e2bcd8739ae039 = "$$material";


const $8d4ef4a46782ebc0$export$effb20ecdbf4d6aa = (prop)=>(0, $4a217562dd85efa3$export$3ba67b570e26eea0)(prop) && prop !== "classes";
const $8d4ef4a46782ebc0$export$f10c5a10d27438e5 = (0, $4a217562dd85efa3$export$3ba67b570e26eea0);
const $8d4ef4a46782ebc0$var$styled = (0, $4a217562dd85efa3$export$2e2bcd8739ae039)({
    themeId: (0, $4dc79eb3bce727b2$export$2e2bcd8739ae039),
    defaultTheme: $2fa8eaec34a3cd3e$export$2e2bcd8739ae039,
    rootShouldForwardProp: $8d4ef4a46782ebc0$export$effb20ecdbf4d6aa
});
var $8d4ef4a46782ebc0$export$2e2bcd8739ae039 = $8d4ef4a46782ebc0$var$styled;



function $a5db86442d0b8a93$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $b9256293aee0086e$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $4hYjL = parcelRequire("4hYjL");

function $916ae223faa11bf3$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $916ae223faa11bf3$var$useTheme(defaultTheme = null) {
    const contextTheme = $4hYjL.useContext((0, $ba9e5771634a3fa6$export$971d5caa766a69d7));
    return !contextTheme || $916ae223faa11bf3$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $916ae223faa11bf3$export$2e2bcd8739ae039 = $916ae223faa11bf3$var$useTheme;


const $c5d8add1abee878a$export$35e57303dbd8a66 = (0, $54aa115c114e75e2$export$2e2bcd8739ae039)();
function $c5d8add1abee878a$var$useTheme(defaultTheme = $c5d8add1abee878a$export$35e57303dbd8a66) {
    return (0, $916ae223faa11bf3$export$2e2bcd8739ae039)(defaultTheme);
}
var $c5d8add1abee878a$export$2e2bcd8739ae039 = $c5d8add1abee878a$var$useTheme;


function $cb2920aeb64241f2$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $c5d8add1abee878a$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $a5db86442d0b8a93$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}




function $3405cc40bb868ed6$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $cb2920aeb64241f2$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $2fa8eaec34a3cd3e$export$2e2bcd8739ae039,
        themeId: (0, $4dc79eb3bce727b2$export$2e2bcd8739ae039)
    });
}





var $4hYjL = parcelRequire("4hYjL");







var $4hYjL = parcelRequire("4hYjL");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $0e3faf62bf14a312$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $21d9794b7ea727d3$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $4hYjL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $0e3faf62bf14a312$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $969e6bfd49df518d$export$2e2bcd8739ae039 = (0, $21d9794b7ea727d3$export$2e2bcd8739ae039);



var $4hYjL = parcelRequire("4hYjL");

var $4hYjL = parcelRequire("4hYjL");
const $dbeaa3c3ffc0b211$var$useEnhancedEffect = typeof window !== "undefined" ? $4hYjL.useLayoutEffect : $4hYjL.useEffect;
var $dbeaa3c3ffc0b211$export$2e2bcd8739ae039 = $dbeaa3c3ffc0b211$var$useEnhancedEffect;


function $0968f876f2537a0c$export$2e2bcd8739ae039(fn) {
    const ref = $4hYjL.useRef(fn);
    (0, $dbeaa3c3ffc0b211$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $4hYjL.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $3c9399d5f20d7073$export$2e2bcd8739ae039 = (0, $0968f876f2537a0c$export$2e2bcd8739ae039);


// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $4hYjL = parcelRequire("4hYjL");
let $766219a5ec3934c0$var$hadKeyboardEvent = true;
let $766219a5ec3934c0$var$hadFocusVisibleRecently = false;
let $766219a5ec3934c0$var$hadFocusVisibleRecentlyTimeout;
const $766219a5ec3934c0$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $766219a5ec3934c0$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $766219a5ec3934c0$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $766219a5ec3934c0$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $766219a5ec3934c0$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $766219a5ec3934c0$var$handlePointerDown() {
    $766219a5ec3934c0$var$hadKeyboardEvent = false;
}
function $766219a5ec3934c0$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($766219a5ec3934c0$var$hadFocusVisibleRecently) $766219a5ec3934c0$var$hadKeyboardEvent = true;
    }
}
function $766219a5ec3934c0$var$prepare(doc) {
    doc.addEventListener("keydown", $766219a5ec3934c0$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $766219a5ec3934c0$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $766219a5ec3934c0$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $766219a5ec3934c0$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $766219a5ec3934c0$var$handleVisibilityChange, true);
}
function $766219a5ec3934c0$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $766219a5ec3934c0$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $766219a5ec3934c0$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $766219a5ec3934c0$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $766219a5ec3934c0$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $766219a5ec3934c0$var$handleVisibilityChange, true);
}
function $766219a5ec3934c0$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $766219a5ec3934c0$var$hadKeyboardEvent || $766219a5ec3934c0$var$focusTriggersKeyboardModality(target);
}
function $766219a5ec3934c0$export$2e2bcd8739ae039() {
    const ref = $4hYjL.useCallback((node)=>{
        if (node != null) $766219a5ec3934c0$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $4hYjL.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $766219a5ec3934c0$var$hadFocusVisibleRecently = true;
            window.clearTimeout($766219a5ec3934c0$var$hadFocusVisibleRecentlyTimeout);
            $766219a5ec3934c0$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $766219a5ec3934c0$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($766219a5ec3934c0$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $72c112128bb5d456$export$2e2bcd8739ae039 = (0, $766219a5ec3934c0$export$2e2bcd8739ae039);





var $4hYjL = parcelRequire("4hYjL");



function $d96462e9631d8c55$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $4hYjL = parcelRequire("4hYjL");

var $4hYjL = parcelRequire("4hYjL");
var $03f6b948e6bea39f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createContext(null);



var $4hYjL = parcelRequire("4hYjL");
function $7625f6bf8abd9b06$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $4hYjL.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $4hYjL.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $7625f6bf8abd9b06$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $7625f6bf8abd9b06$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $7625f6bf8abd9b06$export$fa71e2345c31d7a2(props, onExited) {
    return $7625f6bf8abd9b06$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $4hYjL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $7625f6bf8abd9b06$var$getProp(child, "appear", props),
            enter: $7625f6bf8abd9b06$var$getProp(child, "enter", props),
            exit: $7625f6bf8abd9b06$var$getProp(child, "exit", props)
        });
    });
}
function $7625f6bf8abd9b06$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $7625f6bf8abd9b06$export$bbc8a025727ea824(nextProps.children);
    var children = $7625f6bf8abd9b06$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $4hYjL.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $4hYjL.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $4hYjL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $7625f6bf8abd9b06$var$getProp(child, "exit", nextProps),
            enter: $7625f6bf8abd9b06$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $4hYjL.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $4hYjL.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $4hYjL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $7625f6bf8abd9b06$var$getProp(child, "exit", nextProps),
            enter: $7625f6bf8abd9b06$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $396f23821981d6d1$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $396f23821981d6d1$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $396f23821981d6d1$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $d96462e9631d8c55$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $7625f6bf8abd9b06$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $7625f6bf8abd9b06$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $7625f6bf8abd9b06$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $396f23821981d6d1$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $03f6b948e6bea39f$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $03f6b948e6bea39f$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
$396f23821981d6d1$var$TransitionGroup.propTypes = {};
$396f23821981d6d1$var$TransitionGroup.defaultProps = $396f23821981d6d1$var$defaultProps;
var $396f23821981d6d1$export$2e2bcd8739ae039 = $396f23821981d6d1$var$TransitionGroup;







var $4hYjL = parcelRequire("4hYjL");



function $160084b540468f80$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $4hYjL.useState(false);
    const rippleClassName = (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $4hYjL.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $160084b540468f80$export$2e2bcd8739ae039 = $160084b540468f80$var$Ripple;


const $bd0daf4cfdad36d2$var$defaultGenerator = (componentName)=>componentName;
const $bd0daf4cfdad36d2$var$createClassNameGenerator = ()=>{
    let generate = $bd0daf4cfdad36d2$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $bd0daf4cfdad36d2$var$defaultGenerator;
        }
    };
};
const $bd0daf4cfdad36d2$var$ClassNameGenerator = $bd0daf4cfdad36d2$var$createClassNameGenerator();
var $bd0daf4cfdad36d2$export$2e2bcd8739ae039 = $bd0daf4cfdad36d2$var$ClassNameGenerator;


const $9750c624a461307a$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $9750c624a461307a$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $9750c624a461307a$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bd0daf4cfdad36d2$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}


function $34fca79d41e3ad70$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $9750c624a461307a$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $8d8084db60bec588$export$b464606f735ab902(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiTouchRipple", slot);
}
const $8d8084db60bec588$var$touchRippleClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $8d8084db60bec588$export$2e2bcd8739ae039 = $8d8084db60bec588$var$touchRippleClasses;



const $94b993970ea073a1$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $94b993970ea073a1$var$_ = (t)=>t, $94b993970ea073a1$var$_t, $94b993970ea073a1$var$_t2, $94b993970ea073a1$var$_t3, $94b993970ea073a1$var$_t4;
const $94b993970ea073a1$var$DURATION = 550;
const $94b993970ea073a1$export$95d0c9356b2231a3 = 80;
const $94b993970ea073a1$var$enterKeyframe = (0, $93f238fb4c7fa273$export$d25ddfdf17c3ad3e)($94b993970ea073a1$var$_t || ($94b993970ea073a1$var$_t = $94b993970ea073a1$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $94b993970ea073a1$var$exitKeyframe = (0, $93f238fb4c7fa273$export$d25ddfdf17c3ad3e)($94b993970ea073a1$var$_t2 || ($94b993970ea073a1$var$_t2 = $94b993970ea073a1$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $94b993970ea073a1$var$pulsateKeyframe = (0, $93f238fb4c7fa273$export$d25ddfdf17c3ad3e)($94b993970ea073a1$var$_t3 || ($94b993970ea073a1$var$_t3 = $94b993970ea073a1$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $94b993970ea073a1$export$f6b7418508c72c25 = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $94b993970ea073a1$export$676cfe7b12693c4b = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $160084b540468f80$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($94b993970ea073a1$var$_t4 || ($94b993970ea073a1$var$_t4 = $94b993970ea073a1$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $8d8084db60bec588$export$2e2bcd8739ae039).rippleVisible, $94b993970ea073a1$var$enterKeyframe, $94b993970ea073a1$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $8d8084db60bec588$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $8d8084db60bec588$export$2e2bcd8739ae039).child, (0, $8d8084db60bec588$export$2e2bcd8739ae039).childLeaving, $94b993970ea073a1$var$exitKeyframe, $94b993970ea073a1$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $8d8084db60bec588$export$2e2bcd8739ae039).childPulsate, $94b993970ea073a1$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $94b993970ea073a1$var$TouchRipple = /*#__PURE__*/ $4hYjL.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $94b993970ea073a1$var$_excluded);
    const [ripples, setRipples] = $4hYjL.useState([]);
    const nextKey = $4hYjL.useRef(0);
    const rippleCallback = $4hYjL.useRef(null);
    $4hYjL.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $4hYjL.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $4hYjL.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $4hYjL.useRef(null);
    const container = $4hYjL.useRef(null);
    $4hYjL.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $4hYjL.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($94b993970ea073a1$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.ripple, (0, $8d8084db60bec588$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $8d8084db60bec588$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $8d8084db60bec588$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.child, (0, $8d8084db60bec588$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.childLeaving, (0, $8d8084db60bec588$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.childPulsate, (0, $8d8084db60bec588$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $94b993970ea073a1$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $4hYjL.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $94b993970ea073a1$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $4hYjL.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $4hYjL.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $4hYjL.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($94b993970ea073a1$export$f6b7418508c72c25, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)((0, $8d8084db60bec588$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $396f23821981d6d1$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $94b993970ea073a1$export$2e2bcd8739ae039 = $94b993970ea073a1$var$TouchRipple;




function $88b58341764d6f89$export$fccb0498dcd99783(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiButtonBase", slot);
}
const $88b58341764d6f89$var$buttonBaseClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $88b58341764d6f89$export$2e2bcd8739ae039 = $88b58341764d6f89$var$buttonBaseClasses;



const $1a5cd9261656a2e3$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $1a5cd9261656a2e3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $88b58341764d6f89$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $1a5cd9261656a2e3$export$7ec0dcc5e3cdcd36 = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $88b58341764d6f89$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $1a5cd9261656a2e3$var$ButtonBase = /*#__PURE__*/ $4hYjL.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $1a5cd9261656a2e3$var$_excluded);
    const buttonRef = $4hYjL.useRef(null);
    const rippleRef = $4hYjL.useRef(null);
    const handleRippleRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $72c112128bb5d456$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $4hYjL.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $4hYjL.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $4hYjL.useState(false);
    $4hYjL.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $4hYjL.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $3c9399d5f20d7073$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $3c9399d5f20d7073$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $4hYjL.useRef(false);
    const handleKeyDown = (0, $3c9399d5f20d7073$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $3c9399d5f20d7073$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $1a5cd9261656a2e3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)($1a5cd9261656a2e3$export$7ec0dcc5e3cdcd36, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        as: ComponentProp,
        className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $35b7bd865360a597$exports.jsx)((0, $94b993970ea073a1$export$2e2bcd8739ae039), (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $1a5cd9261656a2e3$export$2e2bcd8739ae039 = $1a5cd9261656a2e3$var$ButtonBase;



var $51517492c7e4eb3f$export$2e2bcd8739ae039 = (0, $baca60b879486349$export$2e2bcd8739ae039);




function $5d961e7ffd8ad0eb$export$5a6f9035944c8119(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiButton", slot);
}
const $5d961e7ffd8ad0eb$var$buttonClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $5d961e7ffd8ad0eb$export$2e2bcd8739ae039 = $5d961e7ffd8ad0eb$var$buttonClasses;



var $4hYjL = parcelRequire("4hYjL");
/**
 * @ignore - internal component.
 */ const $6dc7f1efa058d1f6$var$ButtonGroupContext = /*#__PURE__*/ $4hYjL.createContext({});
var $6dc7f1efa058d1f6$export$2e2bcd8739ae039 = $6dc7f1efa058d1f6$var$ButtonGroupContext;



const $23d1b71d86f92b28$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $23d1b71d86f92b28$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $5d961e7ffd8ad0eb$export$5a6f9035944c8119), classes);
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $23d1b71d86f92b28$var$commonIconStyles = (ownerState)=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $23d1b71d86f92b28$var$ButtonRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $1a5cd9261656a2e3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8d4ef4a46782ebc0$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $5d961e7ffd8ad0eb$export$2e2bcd8739ae039).focusVisible}`]: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $5d961e7ffd8ad0eb$export$2e2bcd8739ae039).disabled}`]: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $5d961e7ffd8ad0eb$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $5d961e7ffd8ad0eb$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $23d1b71d86f92b28$var$ButtonStartIcon = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $23d1b71d86f92b28$var$commonIconStyles(ownerState)));
const $23d1b71d86f92b28$var$ButtonEndIcon = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $51517492c7e4eb3f$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $23d1b71d86f92b28$var$commonIconStyles(ownerState)));
const $23d1b71d86f92b28$var$Button = /*#__PURE__*/ $4hYjL.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $4hYjL.useContext((0, $6dc7f1efa058d1f6$export$2e2bcd8739ae039));
    const resolvedProps = (0, $b9256293aee0086e$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $23d1b71d86f92b28$var$_excluded);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $23d1b71d86f92b28$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($23d1b71d86f92b28$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($23d1b71d86f92b28$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)($23d1b71d86f92b28$var$ButtonRoot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        ownerState: ownerState,
        className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $23d1b71d86f92b28$export$2e2bcd8739ae039 = $23d1b71d86f92b28$var$Button;





var $4hYjL = parcelRequire("4hYjL");
var $e01fe13cc536c125$exports = {};
"use strict";

$e01fe13cc536c125$exports = (parcelRequire("3T7bj"));









var $4hYjL = parcelRequire("4hYjL");


function $745c43e92492654b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $da20dba5fe141dff$export$2e2bcd8739ae039 = (0, $745c43e92492654b$export$2e2bcd8739ae039);





var $4hYjL = parcelRequire("4hYjL");






var $4hYjL = parcelRequire("4hYjL");
/**
 * @ignore - internal component.
 */ const $babe028962687e80$var$ListContext = /*#__PURE__*/ $4hYjL.createContext({});
var $babe028962687e80$export$2e2bcd8739ae039 = $babe028962687e80$var$ListContext;




function $5245730f536586b5$export$c6bd6795ed6e3203(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiList", slot);
}
const $5245730f536586b5$var$listClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $5245730f536586b5$export$2e2bcd8739ae039 = $5245730f536586b5$var$listClasses;



const $20aecac975e317f5$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $20aecac975e317f5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $5245730f536586b5$export$c6bd6795ed6e3203), classes);
};
const $20aecac975e317f5$var$ListRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $20aecac975e317f5$var$List = /*#__PURE__*/ $4hYjL.forwardRef(function List(inProps, ref) {
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $20aecac975e317f5$var$_excluded);
    const context = $4hYjL.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $20aecac975e317f5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $babe028962687e80$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)($20aecac975e317f5$var$ListRoot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            as: component,
            className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $20aecac975e317f5$export$2e2bcd8739ae039 = $20aecac975e317f5$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $680c72f909d48444$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $4909fdbeba8231eb$export$2e2bcd8739ae039 = (0, $680c72f909d48444$export$2e2bcd8739ae039);




var $fc4ea3f46397fae5$export$2e2bcd8739ae039 = (0, $dbeaa3c3ffc0b211$export$2e2bcd8739ae039);



const $6ed2d9c173700aeb$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $6ed2d9c173700aeb$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $6ed2d9c173700aeb$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $6ed2d9c173700aeb$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $6ed2d9c173700aeb$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$6ed2d9c173700aeb$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $6ed2d9c173700aeb$var$MenuList = /*#__PURE__*/ $4hYjL.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $6ed2d9c173700aeb$var$_excluded);
    const listRef = $4hYjL.useRef(null);
    const textCriteriaRef = $4hYjL.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $fc4ea3f46397fae5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $4hYjL.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $4909fdbeba8231eb$export$2e2bcd8739ae039)((0, $da20dba5fe141dff$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $da20dba5fe141dff$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $6ed2d9c173700aeb$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $6ed2d9c173700aeb$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $6ed2d9c173700aeb$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $6ed2d9c173700aeb$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $6ed2d9c173700aeb$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $6ed2d9c173700aeb$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $6ed2d9c173700aeb$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $6ed2d9c173700aeb$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $6ed2d9c173700aeb$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $6ed2d9c173700aeb$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $6ed2d9c173700aeb$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $4hYjL.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $4hYjL.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $4hYjL.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $4hYjL.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $20aecac975e317f5$export$2e2bcd8739ae039), (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $6ed2d9c173700aeb$export$2e2bcd8739ae039 = $6ed2d9c173700aeb$var$MenuList;





var $4hYjL = parcelRequire("4hYjL");


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $5fd330934bee4de9$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}






function $b693b8cbe675a255$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $5fd330934bee4de9$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, otherProps, {
        ownerState: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, otherProps.ownerState, ownerState)
    });
}



function $216447d4e4c02e0a$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $216447d4e4c02e0a$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $216447d4e4c02e0a$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $216447d4e4c02e0a$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $216447d4e4c02e0a$export$2e2bcd8739ae039 = $216447d4e4c02e0a$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $a6f23c8e049e51fc$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $e2012eab554cc8ec$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $42537b4da347ca44$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $216447d4e4c02e0a$export$2e2bcd8739ae039)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $a6f23c8e049e51fc$export$2e2bcd8739ae039)((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $e2012eab554cc8ec$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $e2012eab554cc8ec$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $216447d4e4c02e0a$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $748cbb8705a3f960$export$2e2bcd8739ae039(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


const $fd48fe2dbd78ba6d$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $fd48fe2dbd78ba6d$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(parameters, $fd48fe2dbd78ba6d$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $748cbb8705a3f960$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $42537b4da347ca44$export$2e2bcd8739ae039)((0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $21d9794b7ea727d3$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $b693b8cbe675a255$export$2e2bcd8739ae039)(elementType, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}





// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $3fde0448e6d8e6c5$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $5f9b11930493ca72$export$2e2bcd8739ae039 = (0, $3fde0448e6d8e6c5$export$2e2bcd8739ae039);




function $74637a0e31b8f5d4$export$2e2bcd8739ae039(node) {
    const doc = (0, $745c43e92492654b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $590cea3da6450931$export$2e2bcd8739ae039 = (0, $74637a0e31b8f5d4$export$2e2bcd8739ae039);






var $4hYjL = parcelRequire("4hYjL");






var $4hYjL = parcelRequire("4hYjL");

var $57be0ffed76e75de$export$2e2bcd8739ae039 = {
    disabled: false
};




var $4f7c5fdb2cf68a95$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $9196a4b986b04663$export$bb38bb9a1161268 = "unmounted";
var $9196a4b986b04663$export$84cbff306f539230 = "exited";
var $9196a4b986b04663$export$df38205c966be359 = "entering";
var $9196a4b986b04663$export$78e9e6e3e014d60a = "entered";
var $9196a4b986b04663$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9196a4b986b04663$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $d496dcfd2d93bfbb$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9196a4b986b04663$export$84cbff306f539230;
                _this.appearStatus = $9196a4b986b04663$export$df38205c966be359;
            } else initialStatus = $9196a4b986b04663$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9196a4b986b04663$export$bb38bb9a1161268;
        else initialStatus = $9196a4b986b04663$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9196a4b986b04663$export$bb38bb9a1161268) return {
            status: $9196a4b986b04663$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9196a4b986b04663$export$df38205c966be359 && status !== $9196a4b986b04663$export$78e9e6e3e014d60a) nextStatus = $9196a4b986b04663$export$df38205c966be359;
            } else if (status === $9196a4b986b04663$export$df38205c966be359 || status === $9196a4b986b04663$export$78e9e6e3e014d60a) nextStatus = $9196a4b986b04663$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9196a4b986b04663$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($907ccff5bb941ac5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4f7c5fdb2cf68a95$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9196a4b986b04663$export$84cbff306f539230) this.setState({
            status: $9196a4b986b04663$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($907ccff5bb941ac5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $57be0ffed76e75de$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9196a4b986b04663$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9196a4b986b04663$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9196a4b986b04663$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($907ccff5bb941ac5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $57be0ffed76e75de$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9196a4b986b04663$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9196a4b986b04663$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9196a4b986b04663$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($907ccff5bb941ac5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9196a4b986b04663$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createElement((0, $03f6b948e6bea39f$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).Component);
$9196a4b986b04663$var$Transition.contextType = (0, $03f6b948e6bea39f$export$2e2bcd8739ae039);
$9196a4b986b04663$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9196a4b986b04663$var$noop() {}
$9196a4b986b04663$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9196a4b986b04663$var$noop,
    onEntering: $9196a4b986b04663$var$noop,
    onEntered: $9196a4b986b04663$var$noop,
    onExit: $9196a4b986b04663$var$noop,
    onExiting: $9196a4b986b04663$var$noop,
    onExited: $9196a4b986b04663$var$noop
};
$9196a4b986b04663$var$Transition.UNMOUNTED = $9196a4b986b04663$export$bb38bb9a1161268;
$9196a4b986b04663$var$Transition.EXITED = $9196a4b986b04663$export$84cbff306f539230;
$9196a4b986b04663$var$Transition.ENTERING = $9196a4b986b04663$export$df38205c966be359;
$9196a4b986b04663$var$Transition.ENTERED = $9196a4b986b04663$export$78e9e6e3e014d60a;
$9196a4b986b04663$var$Transition.EXITING = $9196a4b986b04663$export$4aacc83d4d59139f;
var $9196a4b986b04663$export$2e2bcd8739ae039 = $9196a4b986b04663$var$Transition;


parcelRequire("4hYjL");



function $12db8cd831292426$export$2e2bcd8739ae039() {
    const theme = (0, $c5d8add1abee878a$export$2e2bcd8739ae039)((0, $2fa8eaec34a3cd3e$export$2e2bcd8739ae039));
    return theme[0, $4dc79eb3bce727b2$export$2e2bcd8739ae039] || theme;
}


const $baff1ddd6aebad88$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $baff1ddd6aebad88$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




const $289f2c3a00e3fce5$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $289f2c3a00e3fce5$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $289f2c3a00e3fce5$var$styles = {
    entering: {
        opacity: 1,
        transform: $289f2c3a00e3fce5$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $289f2c3a00e3fce5$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $289f2c3a00e3fce5$var$Grow = /*#__PURE__*/ $4hYjL.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $9196a4b986b04663$export$2e2bcd8739ae039) } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $289f2c3a00e3fce5$var$_excluded);
    const timer = $4hYjL.useRef();
    const autoTimeout = $4hYjL.useRef();
    const theme = (0, $12db8cd831292426$export$2e2bcd8739ae039)();
    const nodeRef = $4hYjL.useRef(null);
    const handleRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $baff1ddd6aebad88$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $baff1ddd6aebad88$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $289f2c3a00e3fce5$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $baff1ddd6aebad88$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $289f2c3a00e3fce5$var$isWebKit154 ? duration : duration * 0.666,
                delay: $289f2c3a00e3fce5$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $289f2c3a00e3fce5$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $4hYjL.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(TransitionComponent, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $4hYjL.cloneElement(children, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
                style: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
                    opacity: 0,
                    transform: $289f2c3a00e3fce5$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $289f2c3a00e3fce5$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$289f2c3a00e3fce5$var$Grow.muiSupportAuto = true;
var $289f2c3a00e3fce5$export$2e2bcd8739ae039 = $289f2c3a00e3fce5$var$Grow;





var $4hYjL = parcelRequire("4hYjL");





var $4hYjL = parcelRequire("4hYjL");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $f86ea56cb13e30ec$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




var $4hYjL = parcelRequire("4hYjL");




function $0d04acbb02c07805$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $0d04acbb02c07805$var$Portal = /*#__PURE__*/ $4hYjL.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $4hYjL.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $21d9794b7ea727d3$export$2e2bcd8739ae039)(/*#__PURE__*/ $4hYjL.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $dbeaa3c3ffc0b211$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($0d04acbb02c07805$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $dbeaa3c3ffc0b211$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $0e3faf62bf14a312$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $0e3faf62bf14a312$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $4hYjL.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $4hYjL.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($4hYjL.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($4hYjL.Fragment, {
        children: mountNode ? /*#__PURE__*/ $907ccff5bb941ac5$exports.createPortal(children, mountNode) : mountNode
    });
});
var $0d04acbb02c07805$export$2e2bcd8739ae039 = $0d04acbb02c07805$var$Portal;



// Is a vertical scrollbar displayed?
function $bd6fc7aec1269c13$var$isOverflowing(container) {
    const doc = (0, $745c43e92492654b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $74637a0e31b8f5d4$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $bd6fc7aec1269c13$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $bd6fc7aec1269c13$var$getPaddingRight(element) {
    return parseInt((0, $74637a0e31b8f5d4$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $bd6fc7aec1269c13$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $bd6fc7aec1269c13$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$bd6fc7aec1269c13$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $bd6fc7aec1269c13$export$e1bd0c6150f13d96(element, show);
    });
}
function $bd6fc7aec1269c13$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $bd6fc7aec1269c13$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($bd6fc7aec1269c13$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $680c72f909d48444$export$2e2bcd8739ae039)((0, $745c43e92492654b$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$bd6fc7aec1269c13$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $745c43e92492654b$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$bd6fc7aec1269c13$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $745c43e92492654b$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $74637a0e31b8f5d4$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $bd6fc7aec1269c13$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $bd6fc7aec1269c13$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $bd6fc7aec1269c13$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $bd6fc7aec1269c13$var$getHiddenSiblings(container);
        $bd6fc7aec1269c13$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $bd6fc7aec1269c13$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $bd6fc7aec1269c13$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $bd6fc7aec1269c13$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $bd6fc7aec1269c13$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $bd6fc7aec1269c13$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $bd6fc7aec1269c13$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $bd6fc7aec1269c13$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $4hYjL = parcelRequire("4hYjL");



// Inspired by https://github.com/focus-trap/tabbable
const $290b06fda6a54577$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $290b06fda6a54577$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $290b06fda6a54577$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $290b06fda6a54577$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $290b06fda6a54577$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $290b06fda6a54577$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($290b06fda6a54577$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $290b06fda6a54577$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$290b06fda6a54577$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $290b06fda6a54577$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $290b06fda6a54577$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $290b06fda6a54577$var$defaultGetTabbable, isEnabled: isEnabled = $290b06fda6a54577$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $4hYjL.useRef(false);
    const sentinelStart = $4hYjL.useRef(null);
    const sentinelEnd = $4hYjL.useRef(null);
    const nodeToRestore = $4hYjL.useRef(null);
    const reactFocusEventTarget = $4hYjL.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $4hYjL.useRef(false);
    const rootRef = $4hYjL.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $21d9794b7ea727d3$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $4hYjL.useRef(null);
    $4hYjL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $4hYjL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $745c43e92492654b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $4hYjL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $745c43e92492654b$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)($4hYjL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $4hYjL.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $290b06fda6a54577$export$2e2bcd8739ae039 = $290b06fda6a54577$var$FocusTrap;




function $e4befd37f91328c1$export$67960e22b12a638d(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiModal", slot);
}
const $e4befd37f91328c1$var$modalClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $e4befd37f91328c1$export$2e2bcd8739ae039 = $e4befd37f91328c1$var$modalClasses;




var $4hYjL = parcelRequire("4hYjL");

const $595f230b4d902233$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $595f230b4d902233$var$ClassNameConfiguratorContext = /*#__PURE__*/ $4hYjL.createContext($595f230b4d902233$var$defaultContextValue);
function $595f230b4d902233$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $4hYjL.useContext($595f230b4d902233$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $595f230b4d902233$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $4hYjL.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($595f230b4d902233$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



const $859f9b21323632a8$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $859f9b21323632a8$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $595f230b4d902233$export$b0f7603cd2f9ee15)((0, $e4befd37f91328c1$export$67960e22b12a638d)));
};
function $859f9b21323632a8$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $859f9b21323632a8$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $859f9b21323632a8$var$defaultManager = new (0, $bd6fc7aec1269c13$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base-ui/react-modal/components-api/#modal)
 */ const $859f9b21323632a8$var$Modal = /*#__PURE__*/ $4hYjL.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children, closeAfterTransition: closeAfterTransition = false, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, // private
    manager: managerProp = $859f9b21323632a8$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $859f9b21323632a8$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $4hYjL.useState(!open);
    const modal = $4hYjL.useRef({});
    const mountNodeRef = $4hYjL.useRef(null);
    const modalRef = $4hYjL.useRef(null);
    const handleRef = (0, $21d9794b7ea727d3$export$2e2bcd8739ae039)(modalRef, forwardedRef);
    const hasTransition = $859f9b21323632a8$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $745c43e92492654b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0968f876f2537a0c$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $859f9b21323632a8$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $4hYjL.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $0968f876f2537a0c$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $bd6fc7aec1269c13$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $4hYjL.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $4hYjL.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $4hYjL.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $859f9b21323632a8$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $f86ea56cb13e30ec$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $f86ea56cb13e30ec$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $fd48fe2dbd78ba6d$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $fd48fe2dbd78ba6d$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $0d04acbb02c07805$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)(Root, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(BackdropComponent, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $290b06fda6a54577$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $4hYjL.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $859f9b21323632a8$export$2e2bcd8739ae039 = $859f9b21323632a8$var$Modal;









var $4hYjL = parcelRequire("4hYjL");








var $4hYjL = parcelRequire("4hYjL");







const $4457403db92059e1$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $4457403db92059e1$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4457403db92059e1$var$Fade = /*#__PURE__*/ $4hYjL.forwardRef(function Fade(props, ref) {
    const theme = (0, $12db8cd831292426$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $9196a4b986b04663$export$2e2bcd8739ae039) } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $4457403db92059e1$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $4hYjL.useRef(null);
    const handleRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $baff1ddd6aebad88$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $baff1ddd6aebad88$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $baff1ddd6aebad88$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(TransitionComponent, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $4hYjL.cloneElement(children, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
                style: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $4457403db92059e1$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $4457403db92059e1$export$2e2bcd8739ae039 = $4457403db92059e1$var$Fade;




function $0184e6c879c72a2b$export$9927a91fd93152bd(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiBackdrop", slot);
}
const $0184e6c879c72a2b$var$backdropClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $0184e6c879c72a2b$export$2e2bcd8739ae039 = $0184e6c879c72a2b$var$backdropClasses;



const $22f5c32481e664e6$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $22f5c32481e664e6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $0184e6c879c72a2b$export$9927a91fd93152bd), classes);
};
const $22f5c32481e664e6$var$BackdropRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $22f5c32481e664e6$var$Backdrop = /*#__PURE__*/ $4hYjL.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $4457403db92059e1$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $22f5c32481e664e6$var$_excluded);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $22f5c32481e664e6$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(TransitionComponent, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($22f5c32481e664e6$var$BackdropRoot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $22f5c32481e664e6$export$2e2bcd8739ae039 = $22f5c32481e664e6$var$Backdrop;



const $8ec4b451eaf29cb6$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $8ec4b451eaf29cb6$export$eb211a494147b724 = (0, $e4befd37f91328c1$export$2e2bcd8739ae039);
const $8ec4b451eaf29cb6$var$ModalRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $8ec4b451eaf29cb6$var$ModalBackdrop = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $22f5c32481e664e6$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $8ec4b451eaf29cb6$var$Modal = /*#__PURE__*/ $4hYjL.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $8ec4b451eaf29cb6$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classes, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, open: open, slotProps: slotProps, slots: slots, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $8ec4b451eaf29cb6$var$_excluded);
    const [exited, setExited] = $4hYjL.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $8ec4b451eaf29cb6$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $859f9b21323632a8$export$2e2bcd8739ae039), (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, (0, $748cbb8705a3f960$export$2e2bcd8739ae039)(rootSlotProps, ownerState), !(0, $5fd330934bee4de9$export$2e2bcd8739ae039)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, BackdropProps, (0, $748cbb8705a3f960$export$2e2bcd8739ae039)(backdropSlotProps, ownerState), {
                    className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $8ec4b451eaf29cb6$export$2e2bcd8739ae039 = $8ec4b451eaf29cb6$var$Modal;





var $4hYjL = parcelRequire("4hYjL");






// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $ac758188986afce6$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $ac758188986afce6$export$2e2bcd8739ae039 = $ac758188986afce6$var$getOverlayAlpha;






function $0b98f877c29c991a$export$29cdb466b9b6f20b(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiPaper", slot);
}
const $0b98f877c29c991a$var$paperClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $0b98f877c29c991a$export$2e2bcd8739ae039 = $0b98f877c29c991a$var$paperClasses;



const $ea2cba236373d2c2$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $ea2cba236373d2c2$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $0b98f877c29c991a$export$29cdb466b9b6f20b), classes);
};
const $ea2cba236373d2c2$var$PaperRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)("#fff", (0, $ac758188986afce6$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)("#fff", (0, $ac758188986afce6$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $ea2cba236373d2c2$var$Paper = /*#__PURE__*/ $4hYjL.forwardRef(function Paper(inProps, ref) {
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $ea2cba236373d2c2$var$_excluded);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $ea2cba236373d2c2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($ea2cba236373d2c2$var$PaperRoot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        as: component,
        ownerState: ownerState,
        className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other));
});
var $ea2cba236373d2c2$export$2e2bcd8739ae039 = $ea2cba236373d2c2$var$Paper;




function $955de4a8e19a77b0$export$88f455dd56c95edb(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiPopover", slot);
}
const $955de4a8e19a77b0$var$popoverClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiPopover", [
    "root",
    "paper"
]);
var $955de4a8e19a77b0$export$2e2bcd8739ae039 = $955de4a8e19a77b0$var$popoverClasses;



const $64162396c29fb7ee$var$_excluded = [
    "onEntering"
], $64162396c29fb7ee$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
], $64162396c29fb7ee$var$_excluded3 = [
    "slotProps"
];
function $64162396c29fb7ee$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $64162396c29fb7ee$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $64162396c29fb7ee$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $64162396c29fb7ee$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $64162396c29fb7ee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $955de4a8e19a77b0$export$88f455dd56c95edb), classes);
};
const $64162396c29fb7ee$export$bcce13685275fc99 = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $8ec4b451eaf29cb6$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $64162396c29fb7ee$export$821346c38a2d9390 = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $ea2cba236373d2c2$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $64162396c29fb7ee$var$Popover = /*#__PURE__*/ $4hYjL.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $289f2c3a00e3fce5$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {} } = props, TransitionProps = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props.TransitionProps, $64162396c29fb7ee$var$_excluded), other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $64162396c29fb7ee$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $4hYjL.useRef();
    const handlePaperRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $64162396c29fb7ee$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $4hYjL.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $64162396c29fb7ee$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $da20dba5fe141dff$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $64162396c29fb7ee$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $64162396c29fb7ee$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $4hYjL.useCallback((elemRect)=>{
        return {
            vertical: $64162396c29fb7ee$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $64162396c29fb7ee$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $4hYjL.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $64162396c29fb7ee$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $590cea3da6450931$export$2e2bcd8739ae039)($64162396c29fb7ee$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $64162396c29fb7ee$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $4hYjL.useState(open);
    const setPositioningStyles = $4hYjL.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $4hYjL.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $4hYjL.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $4hYjL.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $5f9b11930493ca72$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $590cea3da6450931$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $da20dba5fe141dff$export$2e2bcd8739ae039)($64162396c29fb7ee$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $64162396c29fb7ee$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $64162396c29fb7ee$export$821346c38a2d9390;
    const paperProps = (0, $fd48fe2dbd78ba6d$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $fd48fe2dbd78ba6d$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(_useSlotProps, $64162396c29fb7ee$var$_excluded3);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(RootSlot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, rootProps, !(0, $5fd330934bee4de9$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp
    }, {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(TransitionComponent, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)(PaperSlot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $64162396c29fb7ee$export$2e2bcd8739ae039 = $64162396c29fb7ee$var$Popover;







function $8e1db59cefd5e3d6$export$2cf86a63a84fe23d(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiMenu", slot);
}
const $8e1db59cefd5e3d6$var$menuClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $8e1db59cefd5e3d6$export$2e2bcd8739ae039 = $8e1db59cefd5e3d6$var$menuClasses;



const $ae03d07cbb118e6d$var$_excluded = [
    "onEntering"
], $ae03d07cbb118e6d$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $ae03d07cbb118e6d$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $ae03d07cbb118e6d$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $ae03d07cbb118e6d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $8e1db59cefd5e3d6$export$2cf86a63a84fe23d), classes);
};
const $ae03d07cbb118e6d$var$MenuRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $64162396c29fb7ee$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8d4ef4a46782ebc0$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $ae03d07cbb118e6d$export$4f7c51a5920c9f33 = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $64162396c29fb7ee$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $ae03d07cbb118e6d$var$MenuMenuList = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $6ed2d9c173700aeb$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $ae03d07cbb118e6d$var$Menu = /*#__PURE__*/ $4hYjL.forwardRef(function Menu(inProps, ref) {
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu" } = props, TransitionProps = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props.TransitionProps, $ae03d07cbb118e6d$var$_excluded), other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $ae03d07cbb118e6d$var$_excluded2);
    const theme = (0, $12db8cd831292426$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $ae03d07cbb118e6d$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $4hYjL.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $4hYjL.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $4hYjL.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($ae03d07cbb118e6d$var$MenuRoot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $ae03d07cbb118e6d$var$RTL_ORIGIN : $ae03d07cbb118e6d$var$LTR_ORIGIN,
        slots: {
            paper: $ae03d07cbb118e6d$export$4f7c51a5920c9f33
        },
        slotProps: {
            paper: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, PaperProps, {
                classes: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, PaperProps.classes, {
                    root: classes.paper
                })
            })
        },
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($ae03d07cbb118e6d$var$MenuMenuList, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $ae03d07cbb118e6d$export$2e2bcd8739ae039 = $ae03d07cbb118e6d$var$Menu;





var $4hYjL = parcelRequire("4hYjL");












function $13727edf58e5213e$export$46f01d01378ec5a2(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiDivider", slot);
}
const $13727edf58e5213e$var$dividerClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $13727edf58e5213e$export$2e2bcd8739ae039 = $13727edf58e5213e$var$dividerClasses;




function $d4f79f6f96af80c3$export$81478e24460c57f2(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiListItemIcon", slot);
}
const $d4f79f6f96af80c3$var$listItemIconClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $d4f79f6f96af80c3$export$2e2bcd8739ae039 = $d4f79f6f96af80c3$var$listItemIconClasses;




function $60f14e62eb822995$export$1061006a0db3aeb5(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiListItemText", slot);
}
const $60f14e62eb822995$var$listItemTextClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $60f14e62eb822995$export$2e2bcd8739ae039 = $60f14e62eb822995$var$listItemTextClasses;




function $de3406d06d999567$export$515f8c67b5305377(slot) {
    return (0, $9750c624a461307a$export$2e2bcd8739ae039)("MuiMenuItem", slot);
}
const $de3406d06d999567$var$menuItemClasses = (0, $34fca79d41e3ad70$export$2e2bcd8739ae039)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $de3406d06d999567$export$2e2bcd8739ae039 = $de3406d06d999567$var$menuItemClasses;



const $ae1fbb8618984f67$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $ae1fbb8618984f67$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $ae1fbb8618984f67$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $90828746836bf58c$export$2e2bcd8739ae039)(slots, (0, $de3406d06d999567$export$515f8c67b5305377), classes);
    return (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
const $ae1fbb8618984f67$var$MenuItemRoot = (0, $8d4ef4a46782ebc0$export$2e2bcd8739ae039)((0, $1a5cd9261656a2e3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8d4ef4a46782ebc0$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $ae1fbb8618984f67$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $de3406d06d999567$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $de3406d06d999567$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $de3406d06d999567$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $ee4e4eff643c0f2b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $de3406d06d999567$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $de3406d06d999567$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $13727edf58e5213e$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $13727edf58e5213e$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $60f14e62eb822995$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $60f14e62eb822995$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $d4f79f6f96af80c3$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $d4f79f6f96af80c3$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $ae1fbb8618984f67$var$MenuItem = /*#__PURE__*/ $4hYjL.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $3405cc40bb868ed6$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $2a4c238e6bea682b$export$2e2bcd8739ae039)(props, $ae1fbb8618984f67$var$_excluded);
    const context = $4hYjL.useContext((0, $babe028962687e80$export$2e2bcd8739ae039));
    const childContext = $4hYjL.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $4hYjL.useRef(null);
    (0, $fc4ea3f46397fae5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $ae1fbb8618984f67$var$useUtilityClasses(props);
    const handleRef = (0, $969e6bfd49df518d$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $babe028962687e80$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($ae1fbb8618984f67$var$MenuItemRoot, (0, $9aa9154e5282885c$export$2e2bcd8739ae039)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $3166cecf58f4f56c$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $ae1fbb8618984f67$export$2e2bcd8739ae039 = $ae1fbb8618984f67$var$MenuItem;






const $3ae3328c97d3dae3$var$MobileNav = ({ links: links, finalTestStatus: finalTestStatus, finalTestEnabled: finalTestEnabled, courseId: courseId, messageFeatureUsed: messageFeatureUsed, courseStatus: courseStatus })=>{
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useState(null);
    const history = (0, $87978d8bc0f45f32$export$3420e1dc2c4a518c)();
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (linkTo)=>{
        if (linkTo) history.push(linkTo);
        setAnchorEl(null);
    };
    const handleLogout = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get(`/logout`).then(()=>{
            history.push("/");
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "mobile-menu",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $23d1b71d86f92b28$export$2e2bcd8739ae039), {
                "aria-controls": "simple-menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                sx: {
                    color: "#444444",
                    fontWeight: "bold"
                },
                children: t("DashNavigation.Valmynd")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $ae03d07cbb118e6d$export$2e2bcd8739ae039), {
                id: "simple-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: ()=>{
                    handleClose();
                },
                children: [
                    courseStatus === "Expired" || courseId === undefined ? "" : links.map((link)=>{
                        const { roundNr: roundNr, roundStatus: roundStatus, nextRoundOpen: nextRoundOpen, isCurrentRound: isCurrentRound } = link;
                        let icon;
                        let disabled;
                        icon = "fa fa-square-o";
                        if (roundStatus === "Not Started") {
                            icon = "fa fa-lock";
                            disabled = true;
                        }
                        if (nextRoundOpen && isCurrentRound) {
                            icon = "fa fa-square-o";
                            disabled = false;
                        }
                        // If no message has been sent then...
                        if (parseInt(courseId) === 2 && !messageFeatureUsed) {
                            icon = "fa fa-lock";
                            disabled = true;
                        }
                        if (roundStatus === "Finished") icon = "fa fa-check-square-o";
                        const linkTo = `/okuskoli-${courseId}/lota-${roundNr}/skref-1/`;
                        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ae1fbb8618984f67$export$2e2bcd8739ae039), {
                            onClick: ()=>handleClose(linkTo),
                            disabled: disabled,
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: linkTo,
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                            className: icon
                                        }),
                                        ` ${t("DashNavigation.Lota")} ${roundNr}`
                                    ]
                                })
                            })
                        }, roundNr);
                    }),
                    links.length === 0 || courseStatus === "Expired" || courseId === undefined ? "" : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ae1fbb8618984f67$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            handleClose();
                        },
                        disabled: finalTestEnabled === "disabled-link" ? true : false,
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: `/okuskoli-${courseId}/lokaprof`,
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                        className: finalTestStatus
                                    }),
                                    " ",
                                    t("DashNavigation.Pr\xf3f")
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ae1fbb8618984f67$export$2e2bcd8739ae039), {
                        onClick: ()=>handleClose(t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Settings)),
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                    className: "fa fa-cog"
                                }),
                                " ",
                                t("DashNavigation.Stillingar")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ae1fbb8618984f67$export$2e2bcd8739ae039), {
                        onClick: handleLogout,
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                    className: "fa fa-sign-out"
                                }),
                                " ",
                                t("DashNavigation.Skr\xe1 \xfat")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $3ae3328c97d3dae3$export$2e2bcd8739ae039 = $3ae3328c97d3dae3$var$MobileNav;




parcelRequire("4hYjL");

parcelRequire("4hYjL");

const $7986e950d9876b6f$var$PaymentStep = ({ stepNr: stepNr, state: state, path: path })=>{
    const className = state.toLowerCase();
    let disabled = false;
    if (state === "Unfinished") disabled = true;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: className,
        children: disabled && stepNr !== 2 ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                className: "payment-step-icon",
                children: state === "Finished" ? "✓" : `${stepNr}`
            })
        }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
            to: path,
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                className: "payment-step-icon",
                children: state === "Finished" ? "✓" : `${stepNr}`
            })
        })
    });
};
var $7986e950d9876b6f$export$2e2bcd8739ae039 = $7986e950d9876b6f$var$PaymentStep;



const $47acb6749a58ce27$var$useDetectSchool = ()=>{
    const location = (0, $87978d8bc0f45f32$export$45d76561a5302f2b)();
    let school = "1";
    if (location.pathname === "/okuskoli2-upplysingar" || location.pathname === "/okuskoli-2/skraning" || location.pathname === "/okuskoli-2/takk-fyrir") school = "2";
    return school;
};
const $47acb6749a58ce27$var$PaymentNav = ({ paymentStep: paymentStep, isPaymentFlow: isPaymentFlow })=>{
    const school = $47acb6749a58ce27$var$useDetectSchool();
    if (!isPaymentFlow || !paymentStep) // If the page isn't a part of the payment flow, don't render anything.
    return null;
    // Takes step number, returns states as array
    const [firstState, secondState, thirdState] = $47acb6749a58ce27$var$generateClasses(paymentStep);
    // Hacky management of if arrows are given active-pd class or not.
    let firstClass;
    let secondClass;
    firstState === "Finished" ? firstClass = "active-pd" : firstClass = "";
    secondState === "Finished" ? secondClass = "active-pd" : secondClass = "";
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "payment-nav",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "payment-container",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $7986e950d9876b6f$export$2e2bcd8739ae039), {
                    stepNr: 1,
                    state: firstState,
                    path: `/okuskoli${school}-upplysingar`
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                    className: `payment-divider ${firstClass}`
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: `arrow right ${firstClass}`
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $7986e950d9876b6f$export$2e2bcd8739ae039), {
                    stepNr: 2,
                    state: secondState,
                    path: `/okuskoli-${school}/skraning`
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                    className: `payment-divider ${secondClass}`
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: `arrow right ${secondClass}`
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $7986e950d9876b6f$export$2e2bcd8739ae039), {
                    stepNr: 3,
                    state: thirdState,
                    path: `/okuskoli-${school}/takk-fyrir`
                })
            ]
        })
    });
};
// Takes step number, returns states as array
const $47acb6749a58ce27$var$generateClasses = (stepNumber)=>{
    const lastChar = stepNumber.charAt(stepNumber.length - 1);
    const number = parseInt(lastChar);
    const emptyArray = [
        "",
        "",
        ""
    ];
    const results = emptyArray.map((elem, index)=>{
        const numberIndex = number - 1;
        if (numberIndex > index) return "Finished";
        else if (numberIndex === index) return "Active";
        else if (numberIndex < index) return "Unfinished";
        // if all fails, return unfinished
        return "Unfinished";
    });
    return results;
};
var $47acb6749a58ce27$export$2e2bcd8739ae039 = $47acb6749a58ce27$var$PaymentNav;




const $d9a79446859e6988$export$150b732325d14d04 = {
    is: {
        DashNavigation: {
            Próf: "Pr\xf3f",
            Stillingar: "Stillingar",
            "Skr\xe1 \xfat": "Skr\xe1 \xfat",
            Lota: "Lota",
            Valmynd: "Valmynd"
        }
    },
    en: {
        DashNavigation: {
            Próf: "Test",
            Stillingar: "Settings",
            "Skr\xe1 \xfat": "Sign out",
            Lota: "Round",
            Valmynd: "Menu"
        }
    }
};
const $d9a79446859e6988$var$Navigation = ({ courseId: courseId, paymentStep: paymentStep, isPaymentFlow: isPaymentFlow, authReducer: authReducer, dispatch: dispatch })=>{
    const { userCourses: userCourses, userRounds: userRounds, messageFeatureUsed: messageFeatureUsed, currentStep: currentStep } = authReducer;
    let finalTestStatus = "fa fa-lock";
    let finalTestEnabled = "disabled-link";
    let allFinished = true;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const links = [];
    let courseStatus = "";
    userCourses.forEach((course)=>{
        if (courseId && parseInt(course.id) === parseInt(courseId)) courseStatus = course.status;
    });
    const fetchCourseData = ()=>{
        const { id: id, currentUserRounds: currentUserRounds } = authReducer;
        // Fetch data when needed
        if (courseId !== undefined && currentUserRounds.length !== 6) (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/sub-dashboard`, {
            userId: id,
            courseId: parseInt(courseId)
        }).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$5ed101c55fc6dd45)({
                ...res.data
            }));
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    (0, $4hYjL.useEffect)(()=>{
        fetchCourseData();
    }, []);
    // Check if the user is registered for the course
    if (userRounds.length > 0) {
        // Steps through each round, checks if open.
        userRounds.forEach((round)=>{
            const { nr: nr, status: status } = round;
            const { nextRoundOpen: nextRoundOpen, currentRound: currentRound } = authReducer;
            let isCurrentRound = false;
            currentRound === nr ? isCurrentRound = true : isCurrentRound = false;
            const roundLink = {
                roundNr: nr,
                roundStatus: status,
                isCurrentRound: isCurrentRound,
                nextRoundOpen: nextRoundOpen
            };
            if (courseId && parseInt(courseId) === round.course_id) links.push(roundLink);
            // If at least one round is not finished
            if (courseId && status !== "Finished" && parseInt(courseId) === round.course_id) allFinished = false;
        });
        // Render final test link correctly
        if (allFinished === true && courseId !== undefined) {
            finalTestStatus = "fa fa-square-o";
            finalTestEnabled = "enabled-link";
            authReducer.userCourses.forEach((course)=>{
                if (course.id === parseInt(courseId) && course.status === "Finished") finalTestStatus = "fa fa-check-square-o";
            });
        }
    }
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "navigation",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "logo-container",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                            to: "/stjornbord",
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                id: "logo",
                                src: "/images/icon-logo.gif"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $3ae3328c97d3dae3$export$2e2bcd8739ae039), {
                        links: links,
                        finalTestStatus: finalTestStatus,
                        finalTestEnabled: finalTestEnabled,
                        courseId: courseId,
                        messageFeatureUsed: messageFeatureUsed,
                        courseStatus: courseStatus
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "lotu-links",
                        children: [
                            courseStatus === "Expired" || courseId === undefined ? "" : links.map((link)=>{
                                const { roundNr: roundNr, roundStatus: roundStatus, nextRoundOpen: nextRoundOpen, isCurrentRound: isCurrentRound } = link;
                                return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $a2753bb663df18bd$export$2e2bcd8739ae039), {
                                    courseId: courseId,
                                    roundNr: roundNr,
                                    currentStep: currentStep,
                                    roundStatus: roundStatus,
                                    nextRoundOpen: nextRoundOpen,
                                    isCurrentRound: isCurrentRound,
                                    messageFeatureUsed: messageFeatureUsed
                                }, roundNr);
                            }),
                            links.length === 0 || courseStatus === "Expired" ? "" : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: `/okuskoli-${courseId}/lokaprof`,
                                className: finalTestEnabled,
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                            className: finalTestStatus
                                        }),
                                        " ",
                                        t("DashNavigation.Pr\xf3f")
                                    ]
                                })
                            }, "link-finaltest"),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                                to: t((0, $eb42b516ad2b007c$export$c717c2ee03fc6c49).Settings),
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                            className: "fa fa-cog"
                                        }),
                                        " ",
                                        t("DashNavigation.Stillingar")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                href: "/logout",
                                target: "_self",
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                            className: "fa fa-sign-out"
                                        }),
                                        " ",
                                        t("DashNavigation.Skr\xe1 \xfat")
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $47acb6749a58ce27$export$2e2bcd8739ae039), {
                paymentStep: paymentStep,
                isPaymentFlow: isPaymentFlow
            })
        ]
    });
};
const $d9a79446859e6988$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $d9a79446859e6988$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($d9a79446859e6988$var$mapStateToProps)($d9a79446859e6988$var$Navigation);





var $4hYjL = parcelRequire("4hYjL");

parcelRequire("4hYjL");
const $e781f4f9cb813b75$var$FormButton = ({ onClick: onClick, className: className, text: text, size: size, name: name })=>{
    // If no button size is specified, default to big.
    let sizeClassName = "";
    if (!size) sizeClassName = "btn-big";
    else sizeClassName = `btn-${size}`;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
        type: "button",
        id: "btn-component",
        name: name,
        onClick: onClick,
        value: text,
        className: `${className} ${sizeClassName}`
    });
};
var $e781f4f9cb813b75$export$2e2bcd8739ae039 = $e781f4f9cb813b75$var$FormButton;





const $6755d5b71c61fa31$export$150b732325d14d04 = {
    is: {
        Feedback: {
            "\xc1bending?": "\xc1bending?",
            "Er eithva\xf0 vitlaust e\xf0a ruglandi?": "Er eithva\xf0 vitlaust e\xf0a ruglandi?",
            "Sendi...": "Sendi...",
            "Skeyti sent! Takk fyrir \xe1bendinguna": "Skeyti sent! Takk fyrir \xe1bendinguna.",
            Senda: "Senda",
            "Villa!": "Villa!"
        }
    },
    en: {
        Feedback: {
            "\xc1bending?": "Feedback",
            "Er eithva\xf0 vitlaust e\xf0a ruglandi?": "Is there anything we could do better?",
            "Sendi...": "Sending...",
            "Skeyti sent! Takk fyrir \xe1bendinguna": "Message sent! Thank you for your feedback.",
            Senda: "Send",
            "Villa!": "Error!"
        }
    }
};
const $6755d5b71c61fa31$var$FeedbackBox = ()=>{
    const location = (0, $87978d8bc0f45f32$export$45d76561a5302f2b)();
    const [isOpen, setIsOpen] = (0, $4hYjL.useState)(false);
    const [text, setText] = (0, $4hYjL.useState)("");
    const [requestStatus, setRequestStatus] = (0, $4hYjL.useState)("");
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)("");
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    function submitFeedback() {
        setRequestStatus("loading");
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/send-feedback`, {
            messageText: text,
            path: location.pathname
        }).then((res)=>{
            console.log(res);
            setRequestStatus("success");
            setText("");
        }).catch((error)=>{
            setRequestStatus("error");
            setErrorMessage(error.response.data);
            console.error(error.response);
        });
    }
    function handleOpen() {
        if (isOpen === false) setIsOpen(true);
    }
    function handleClose() {
        setRequestStatus("");
        setErrorMessage("");
        setIsOpen(false);
    }
    let classNames;
    if (isOpen) classNames = "feedback-box no-pointer open";
    else classNames = "feedback-box";
    function handleChange(event) {
        setText(event.target.value);
    }
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: classNames,
        onClick: handleOpen,
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                className: "title",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: "fa fa-comment",
                        "aria-hidden": "true"
                    }),
                    t("Feedback.\xc1bending?")
                ]
            }),
            isOpen ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                className: "close",
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: "fa fa-times",
                    "aria-hidden": "true"
                })
            }) : "",
            isOpen ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                        children: t("Feedback.Er eithva\xf0 vitlaust e\xf0a ruglandi?")
                    }),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("textarea", {
                        rows: 4,
                        cols: 40,
                        value: text,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                            text: t("Feedback.Senda"),
                            onClick: submitFeedback,
                            className: "secondary-btn"
                        })
                    }),
                    requestStatus === "loading" ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                        children: t("Feedback.Sendi...")
                    }) : "",
                    requestStatus === "success" ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                        children: t("Feedback.Skeyti sent! Takk fyrir \xe1bendinguna")
                    }) : "",
                    requestStatus === "error" ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                        children: [
                            t("Feedback.Villa!"),
                            " ",
                            errorMessage
                        ]
                    }) : ""
                ]
            }) : ""
        ]
    });
};
var $6755d5b71c61fa31$export$2e2bcd8739ae039 = $6755d5b71c61fa31$var$FeedbackBox;



const $8a5760c834750577$export$150b732325d14d04 = {
    is: {
        CourseWrapper: {
            "Ur\xf0arbrunnur \xd6kusk\xf3li": "Ur\xf0arbrunnur \xd6kusk\xf3li"
        }
    },
    en: {
        CourseWrapper: {
            "Ur\xf0arbrunnur \xd6kusk\xf3li": "Ur\xf0arbrunnur Driving School"
        }
    }
};
const $8a5760c834750577$var$CourseWrapper = ({ title: title, courseId: courseId, paymentStep: paymentStep, children: children })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const buildMetatitle = ()=>{
        if (title) return `${title} | ${t("CourseWrapper.Ur\xf0arbrunnur \xd6kusk\xf3li")}`;
        else return t("CourseWrapper.Ur\xf0arbrunnur \xd6kusk\xf3li");
    };
    const metaTitle = buildMetatitle();
    let isPaymentFlow;
    paymentStep === undefined ? isPaymentFlow = false : isPaymentFlow = true;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "user-area",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d9a79446859e6988$export$2e2bcd8739ae039), {
                courseId: courseId,
                paymentStep: paymentStep,
                isPaymentFlow: isPaymentFlow
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5e0021919929c8b4$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("title", {
                    children: metaTitle
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "main-content",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "lotu-container",
                    children: [
                        paymentStep ? null : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            style: {
                                height: "91px"
                            }
                        }),
                        children
                    ]
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6755d5b71c61fa31$export$2e2bcd8739ae039), {})
        ]
    });
};
var $8a5760c834750577$export$2e2bcd8739ae039 = $8a5760c834750577$var$CourseWrapper;





const $51580f109d31ab7b$export$150b732325d14d04 = {
    is: {
        Dashboard: {
            "Kaupa a\xf0gang": "Kaupa a\xf0gang",
            "Smelltu \xe1 hnappinn h\xe9r fyrir ne\xf0an til a\xf0 kaupa a\xf0gang": "Smelltu \xe1 hnappinn h\xe9r fyrir ne\xf0an til a\xf0 kaupa a\xf0gang.",
            "\xde\xfa ert ekki skr\xe1\xf0(ur) \xed \xd6kusk\xf3la": "\xde\xfa ert ekki skr\xe1\xf0(ur) \xed \xd6kusk\xf3la",
            "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la": "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la",
            "en \xfe\xfa getur alltaf k\xedkt inn aftur og sko\xf0a\xf0 n\xe1msefni\xf0 ef \xfeig langar a\xf0 rifja upp efni\xf0": "en \xfe\xfa getur alltaf k\xedkt inn aftur og sko\xf0a\xf0 n\xe1msefni\xf0 ef \xfeig langar a\xf0 rifja upp efni\xf0",
            Skoða: "Sko\xf0a",
            "\xdeetta er allt a\xf0 koma! Smelltu \xe1 hnappinn h\xe9r a\xf0 ne\xf0an til a\xf0 halda \xe1fram me\xf0 \xd6kusk\xf3la": "\xdeetta er allt a\xf0 koma! Smelltu \xe1 hnappinn h\xe9r a\xf0 ne\xf0an til a\xf0 halda \xe1fram me\xf0 \xd6kusk\xf3la",
            "Halda \xe1fram": "Halda \xe1fram",
            Ökuskóli: "\xd6kusk\xf3li"
        }
    },
    en: {
        Dashboard: {
            "Kaupa a\xf0gang": "Buy access",
            "Smelltu \xe1 hnappinn h\xe9r fyrir ne\xf0an til a\xf0 kaupa a\xf0gang": "Click on the button below to purchase access.",
            "\xde\xfa ert ekki skr\xe1\xf0(ur) \xed \xd6kusk\xf3la": "You are not yet signed up to driving school",
            "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la": "You have finished Driving School",
            "en \xfe\xfa getur alltaf k\xedkt inn aftur og sko\xf0a\xf0 n\xe1msefni\xf0 ef \xfeig langar a\xf0 rifja upp efni\xf0": "but you can always access the course again and review the material",
            Skoða: "View course",
            "\xdeetta er allt a\xf0 koma! Smelltu \xe1 hnappinn h\xe9r a\xf0 ne\xf0an til a\xf0 halda \xe1fram me\xf0 \xd6kusk\xf3la": "Keep up the good... studying. Click on the button below to continue with Driving School",
            "Halda \xe1fram": "Continue course",
            Ökuskóli: "Driving School"
        }
    }
};
const $51580f109d31ab7b$var$CourseBox = ({ authReducer: authReducer, courseNumber: courseNumber })=>{
    const { userRounds: userRounds, userCourses: userCourses, tests: tests } = authReducer;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const progressBar = [];
    let counter = 0;
    let message = null;
    let registered = false;
    let link = `/okuskoli-${courseNumber}`;
    let status = "fa fa-lock";
    let buttonText = t("Dashboard.Kaupa a\xf0gang");
    if (!$51580f109d31ab7b$var$inObject(userCourses, `Ökuskóli ${courseNumber}`)) {
        message = `${t("Dashboard.\xde\xfa ert ekki skr\xe1\xf0(ur) \xed \xd6kusk\xf3la")} ${courseNumber}. ${t("Dashboard.Smelltu \xe1 hnappinn h\xe9r fyrir ne\xf0an til a\xf0 kaupa a\xf0gang")}`;
        link = `/okuskoli${courseNumber}-upplysingar`;
    } else {
        const tmp = $51580f109d31ab7b$var$getCourse(userCourses, `Ökuskóli ${courseNumber}`);
        registered = true;
        if (tmp && tmp.status == "Finished") {
            message = `${t("Dashboard.\xde\xfa hefur loki\xf0 \xd6kusk\xf3la")} ${courseNumber} ${t("Dashboard.en \xfe\xfa getur alltaf k\xedkt inn aftur og sko\xf0a\xf0 n\xe1msefni\xf0 ef \xfeig langar a\xf0 rifja upp efni\xf0")}.`;
            status = "fa fa-check-square-o";
            buttonText = t("Dashboard.Sko\xf0a");
        } else {
            message = `${t("Dashboard.\xdeetta er allt a\xf0 koma! Smelltu \xe1 hnappinn h\xe9r a\xf0 ne\xf0an til a\xf0 halda \xe1fram me\xf0 \xd6kusk\xf3la")} ${courseNumber}.`;
            status = "fa fa-square-o";
            buttonText = t("Dashboard.Halda \xe1fram");
        }
    }
    userRounds.forEach((round)=>{
        let status = "";
        if (round.name === `Ökuskóli ${courseNumber}`) {
            if (round.status === "Finished") status = "finished";
            else if (round.status === "Ongoing") status = "active";
            else if (round.status === "Not Started") status = "inactive";
            progressBar[counter] = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "pb-section pb-" + status
            }, counter);
        }
        counter++;
    });
    if (progressBar.length === 0) for(let i = 0; i < 7; i++)progressBar[i] = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "pb-section pb-inactive"
    }, "progress-" + i);
    let finalTestStatus = "inactive";
    tests.forEach((test)=>{
        if (test.name == `Lokapróf Ö${courseNumber}`) {
            if (test.status == "Finished") finalTestStatus = "finished";
            else if (test.status == "Ongoing" && finalTestStatus !== "finished") finalTestStatus = "active";
        }
    });
    if (registered) {
        counter++;
        progressBar[counter] = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "pb-section pb-" + finalTestStatus
        }, "progress-" + counter);
    }
    const button = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
        className: "mg-bottom-20",
        type: "react-router-link",
        href: link,
        children: buttonText
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "course-box",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "progressbar",
                children: progressBar
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h2", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: status
                    }),
                    " ",
                    t("Dashboard.\xd6kusk\xf3li"),
                    " ",
                    courseNumber
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: message
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "btn-div",
                children: button
            })
        ]
    });
};
const $51580f109d31ab7b$var$Dashboard = ({ dispatch: dispatch, authReducer: authReducer })=>{
    // Fetch fresh course data when the dashboard is mounted.
    const getUserCourseData = async ()=>{
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get("/api/is-logged-in");
        if (response.status === 200) dispatch((0, $d599c499e9218b1e$export$de676d0b1df680f0)({
            ...response.data
        }));
    };
    (0, $4hYjL.useEffect)(()=>{
        getUserCourseData();
    }, []);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: "Stj\xf3rnbor\xf0",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "dashboard-container",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($51580f109d31ab7b$var$CourseBox, {
                    authReducer: authReducer,
                    courseNumber: 1
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($51580f109d31ab7b$var$CourseBox, {
                    authReducer: authReducer,
                    courseNumber: 2
                })
            ]
        })
    });
};
function $51580f109d31ab7b$var$getCourse(courses, name) {
    for(let i = 0; i < courses.length; i++){
        if (courses[i].name === name) return courses[i];
    }
}
function $51580f109d31ab7b$var$inObject(arr, search) {
    let len = arr.length;
    while(len--){
        if (arr[len].name === search) return true;
    }
    return false;
}
const $51580f109d31ab7b$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $51580f109d31ab7b$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($51580f109d31ab7b$var$mapStateToProps)($51580f109d31ab7b$var$Dashboard);



parcelRequire("4hYjL");



const $9313e485d494c864$export$150b732325d14d04 = {
    is: {
        Okuskoli1Info: {
            MetaTitle: "\xd61 | Grei\xf0sla",
            "A\xf0eins um \xd6kusk\xf3la 1": "A\xf0eins um \xd6kusk\xf3la 1",
            "Um hva\xf0 fjallar \xd6kusk\xf3li 1": "Um hva\xf0 fjallar \xd6kusk\xf3li 1?",
            "\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema": "\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema:",
            Ökunámsferlið: "\xd6kun\xe1msferli\xf0",
            "B\xedll og b\xfana\xf0ur": "B\xedll og b\xfana\xf0ur",
            Umferðarheild: "Umfer\xf0arheild",
            Umferðarreglur: "Umfer\xf0arreglur",
            "Vi\xf0horf gagnvart umfer\xf0inni": "Vi\xf0horf gagnvart umfer\xf0inni",
            Umferðarskilti: "Umfer\xf0arskilti",
            TextBlock1: "Hver lota er skipt upp \xed 10 skref sem innihalda texta, spurningar og myndir. Ef \xfe\xfa lendir \xed vandr\xe6\xf0um getur \xfe\xfa alltaf haft samband vi\xf0 Hilmar Gu\xf0j\xf3nsson, \xf6kukennarann okkar.",
            TextBlock2: "\xdeegar \xfe\xfa kl\xe1rar lotu \xfearf a\xf0 b\xed\xf0a \xed s\xf3larhring \xe1\xf0ur en n\xe6sta lota opnist. \xdeetta er gert til a\xf0 fylgja regluger\xf0um Samg\xf6gustofu.",
            "Haf\xf0u \xed huga a\xf0": "Haf\xf0u \xed huga a\xf0",
            TextBlock3: "Samkv\xe6mt regluger\xf0um \xfearf a\xf0 kl\xe1ra \xf6kusk\xf3lann 30 d\xf6gum fr\xe1 fyrstu innskr\xe1ningu. Ef \xfe\xfa hefur ekki kl\xe1ra\xf0 \xf6kusk\xf3lann eftir 30 daga getur \xfe\xfa endurteki\xf0 n\xe1mskei\xf0i\xf0 hj\xe1 okkur fr\xedtt.",
            "Allt kl\xe1rt": "Allt kl\xe1rt?",
            "\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0": "\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0!",
            "\xc1fram \xed grei\xf0slu": "\xc1fram \xed grei\xf0slu"
        }
    },
    en: {
        Okuskoli1Info: {
            MetaTitle: "Driving School 1 | Payment",
            "A\xf0eins um \xd6kusk\xf3la 1": "About Driving School 1",
            "Um hva\xf0 fjallar \xd6kusk\xf3li 1": "What is covered in Driving School 1?",
            "\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema": "Driving School 1 is split into 6 rounds. Each round has a seperate theme:",
            Ökunámsferlið: "The process of learning to drive",
            "B\xedll og b\xfana\xf0ur": "Cars and Equipment",
            Umferðarheild: "Traffic as a whole",
            Umferðarreglur: "Traffic laws",
            "Vi\xf0horf gagnvart umfer\xf0inni": "Behaviour in traffic",
            Umferðarskilti: "Traffic signs",
            TextBlock1: "Each round is split into 10 steps that have text, questions and images. You can always contact us if something is unclear or you don't understand something.",
            TextBlock2: "When you finish a round it will be a day before the next round opens. This is done to follow rules set us by the Ministry of Transport.",
            "Haf\xf0u \xed huga a\xf0": "Keep in mind",
            TextBlock3: "You need to finish the school within 30 days. But if you don't manage to finish it you can always repeat the course with us for free.",
            "Allt kl\xe1rt": "Ready?",
            "\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0": "Then all you need to do is purchase the course and begin!",
            "\xc1fram \xed grei\xf0slu": "Go to payment"
        }
    }
};
const $9313e485d494c864$var$Okuskoli1Info = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: t("Okuskoli1Info.MetaTitle"),
        paymentStep: "step-1",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: t("Okuskoli1Info.A\xf0eins um \xd6kusk\xf3la 1")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("Okuskoli1Info.Um hva\xf0 fjallar \xd6kusk\xf3li 1")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("Okuskoli1Info.\xd6kusk\xf3la 1 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema"),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                        children: t("Okuskoli1Info.\xd6kun\xe1msferli\xf0")
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                        children: t("Okuskoli1Info.B\xedll og b\xfana\xf0ur")
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                        children: t("Okuskoli1Info.Umfer\xf0arheild")
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                        children: t("Okuskoli1Info.Umfer\xf0arreglur")
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                        children: t("Okuskoli1Info.Vi\xf0horf gagnvart umfer\xf0inni")
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                        children: t("Okuskoli1Info.Umfer\xf0arskilti")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("Okuskoli1Info.TextBlock1")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("Okuskoli1Info.TextBlock2")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("Okuskoli1Info.Haf\xf0u \xed huga a\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("Okuskoli1Info.TextBlock3")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h2", {
                children: [
                    t("Okuskoli1Info.Allt kl\xe1rt"),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("Okuskoli1Info.\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                to: "/okuskoli-1/skraning",
                className: "btn",
                children: [
                    t("Okuskoli1Info.\xc1fram \xed grei\xf0slu"),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        style: {
                            fontSize: "14px"
                        },
                        className: "fa fa-chevron-right",
                        "aria-hidden": "true"
                    })
                ]
            })
        ]
    });
};
var $9313e485d494c864$export$2e2bcd8739ae039 = $9313e485d494c864$var$Okuskoli1Info;



parcelRequire("4hYjL");



const $545b8c5e6eaacca6$export$150b732325d14d04 = {
    is: {
        Okuskoli2Info: {
            MetaTitle: "\xd62 | Grei\xf0sla",
            "Um \xd6kusk\xf3la 2": "A\xf0eins um \xd6kusk\xf3la 2",
            "Um hva\xf0 fjallar \xd6kusk\xf3li 2": "Um hva\xf0 fjallar \xd6kusk\xf3li 2?",
            "\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema": "\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema:",
            "Upprifjun \xe1 \xd6kusk\xf3la 1": "Upprifjun \xe1 \xd6kusk\xf3la 1",
            Umferðarsálfræði: "Umfer\xf0ars\xe1lfr\xe6\xf0i",
            "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar": "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar",
            "\xc1byrg\xf0 \xf6kumannsins": "\xc1byrg\xf0 \xf6kumannsins",
            "Opinber vi\xf0url\xf6g vi\xf0 brotum": "Opinber vi\xf0url\xf6g vi\xf0 brotum",
            "Slys og skyndihj\xe1lp": "Slys og skyndihj\xe1lp",
            TextBlock1: "Hver lota er skipt upp \xed 10 skref sem innihalda texta, spurningar og myndir. Ef \xfe\xfa lendir \xed vandr\xe6\xf0um getur \xfe\xfa alltaf haft samband vi\xf0 Hilmar Gu\xf0j\xf3nsson, \xf6kukennarann okkar.",
            TextBlock2: "\xdeegar \xfe\xfa kl\xe1rar lotu \xfearf a\xf0 b\xed\xf0a \xed s\xf3larhring \xe1\xf0ur en n\xe6sta lota opnist. \xdeetta er gert til a\xf0 fylgja regluger\xf0um Samg\xf6gustofu.",
            "Haf\xf0u \xed huga a\xf0": "Haf\xf0u \xed huga a\xf0",
            TextBlock3: "Samkv\xe6mt regluger\xf0um \xfearf a\xf0 kl\xe1ra \xf6kusk\xf3lann 30 d\xf6gum fr\xe1 fyrstu innskr\xe1ningu. Ef \xfe\xfa hefur ekki kl\xe1ra\xf0 \xf6kusk\xf3lann eftir 30 daga getur \xfe\xfa endurteki\xf0 n\xe1mskei\xf0i\xf0 hj\xe1 okkur fr\xedtt.",
            "Allt kl\xe1rt": "Allt kl\xe1rt?",
            "\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0": "\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0!",
            "\xc1fram \xed grei\xf0slu": "\xc1fram \xed grei\xf0slu"
        }
    },
    en: {
        Okuskoli2Info: {
            MetaTitle: "Driving School 2 | Payment",
            "Um \xd6kusk\xf3la 2": "About Driving School 2",
            "Um hva\xf0 fjallar \xd6kusk\xf3li 2": "What is covered in Driving School 2?",
            "\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema": "Driving School 2 is split into 6 rounds. Each round has a seperate theme:",
            "Upprifjun \xe1 \xd6kusk\xf3la 1": "Driving School 1 Revision",
            Umferðarsálfræði: "Traffic psychology",
            "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar": "Traffic risk factors",
            "\xc1byrg\xf0 \xf6kumannsins": "The driver's responsibility",
            "Opinber vi\xf0url\xf6g vi\xf0 brotum": "Penalties for traffic violations",
            "Slys og skyndihj\xe1lp": "Accidents and first-aid",
            TextBlock1: "Each round is split into 10 steps that have text, questions and images. You can always contact us if something is unclear or you don't understand something.",
            TextBlock2: "When you finish a round it will be a day before the next round opens. This is done to follow rules set us by the Ministry of Transport.",
            "Haf\xf0u \xed huga a\xf0": "Keep in mind",
            TextBlock3: "You need to finish the school within 30 days. But if you don't manage to finish it you can always repeat the course with us for free.",
            "Allt kl\xe1rt": "Ready?",
            "\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0": "Then all you need to do is purchase the course and begin!",
            "\xc1fram \xed grei\xf0slu": "Go to payment"
        }
    }
};
const $545b8c5e6eaacca6$var$Okuskoli2Info = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: `Ö2 | Greiðsla`,
        paymentStep: "step-1",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "payment-info-text",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                    children: t("Okuskoli2Info.Um \xd6kusk\xf3la 2")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Okuskoli2Info.\xd6kusk\xf3la 2 er skipt upp \xed 6 lotur. Hver lota hefur sitt \xfeema")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: t("Okuskoli2Info.Upprifjun \xe1 \xd6kusk\xf3la 1")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: t("Okuskoli2Info.Umfer\xf0ars\xe1lfr\xe6\xf0i")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: t("Okuskoli2Info.\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: t("Okuskoli2Info.\xc1byrg\xf0 \xf6kumannsins")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: t("Okuskoli2Info.Opinber vi\xf0url\xf6g vi\xf0 brotum")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            children: t("Okuskoli2Info.Slys og skyndihj\xe1lp")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Okuskoli2Info.TextBlock1")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Okuskoli2Info.TextBlock2")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                    children: t("Okuskoli2Info.Haf\xf0u \xed huga a\xf0")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Okuskoli2Info.TextBlock3")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                    children: t("Okuskoli2Info.Allt kl\xe1rt")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Okuskoli2Info.\xde\xe1 er bara eftir a\xf0 grei\xf0a og svo getur \xfe\xfa byrja\xf0")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                    to: "/okuskoli-2/skraning",
                    className: "btn",
                    children: [
                        t("Okuskoli2Info.\xc1fram \xed grei\xf0slu"),
                        " ",
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                            style: {
                                fontSize: "14px"
                            },
                            className: "fa fa-chevron-right",
                            "aria-hidden": "true"
                        })
                    ]
                })
            ]
        })
    });
};
var $545b8c5e6eaacca6$export$2e2bcd8739ae039 = $545b8c5e6eaacca6$var$Okuskoli2Info;




var $4hYjL = parcelRequire("4hYjL");




var $4hYjL = parcelRequire("4hYjL");


var $4hYjL = parcelRequire("4hYjL");

function $5d09362e9dfe6519$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $5d09362e9dfe6519$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $5d09362e9dfe6519$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $5d09362e9dfe6519$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5d09362e9dfe6519$export$2e2bcd8739ae039 = $5d09362e9dfe6519$export$4f5d2d50c9deca37;


var $6341adc0b94c7664$exports = {};
"use strict";
Object.defineProperty($6341adc0b94c7664$exports, Symbol.toStringTag, {
    value: "Module"
});
const $6341adc0b94c7664$var$CLASS_PART_SEPARATOR = "-";
function $6341adc0b94c7664$var$createClassGroupUtils(config) {
    const classMap = $6341adc0b94c7664$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    function getClassGroupId(className) {
        const classParts = className.split($6341adc0b94c7664$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $6341adc0b94c7664$var$getGroupRecursive(classParts, classMap) || $6341adc0b94c7664$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $6341adc0b94c7664$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $6341adc0b94c7664$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($6341adc0b94c7664$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
}
const $6341adc0b94c7664$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $6341adc0b94c7664$var$getGroupIdForArbitraryProperty(className) {
    if ($6341adc0b94c7664$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $6341adc0b94c7664$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $6341adc0b94c7664$var$createClassMap(config) {
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $6341adc0b94c7664$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $6341adc0b94c7664$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $6341adc0b94c7664$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === "string") {
            const classPartObjectToEdit = classDefinition === "" ? classPartObject : $6341adc0b94c7664$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($6341adc0b94c7664$var$isThemeGetter(classDefinition)) {
                $6341adc0b94c7664$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $6341adc0b94c7664$var$processClassesRecursively(classGroup, $6341adc0b94c7664$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $6341adc0b94c7664$var$getPart(classPartObject, path) {
    let currentClassPartObject = classPartObject;
    path.split($6341adc0b94c7664$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $6341adc0b94c7664$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $6341adc0b94c7664$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $6341adc0b94c7664$var$createLruCache(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}
const $6341adc0b94c7664$var$IMPORTANT_MODIFIER = "!";
function $6341adc0b94c7664$var$createParseClassName(config) {
    const { separator: separator, experimentalParseClassName: experimentalParseClassName } = config;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    function parseClassName(className) {
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($6341adc0b94c7664$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    }
    if (experimentalParseClassName) return function parseClassNameExperimental(className) {
        return experimentalParseClassName({
            className: className,
            parseClassName: parseClassName
        });
    };
    return parseClassName;
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $6341adc0b94c7664$var$sortModifiers(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
}
function $6341adc0b94c7664$var$createConfigUtils(config) {
    return {
        cache: $6341adc0b94c7664$var$createLruCache(config.cacheSize),
        parseClassName: $6341adc0b94c7664$var$createParseClassName(config),
        ...$6341adc0b94c7664$var$createClassGroupUtils(config)
    };
}
const $6341adc0b94c7664$var$SPLIT_CLASSES_REGEX = /\s+/;
function $6341adc0b94c7664$var$mergeClassList(classList, configUtils) {
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = new Set();
    return classList.trim().split($6341adc0b94c7664$var$SPLIT_CLASSES_REGEX).map((originalClassName)=>{
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        const variantModifier = $6341adc0b94c7664$var$sortModifiers(modifiers).join(":");
        const modifierId = hasImportantModifier ? variantModifier + $6341adc0b94c7664$var$IMPORTANT_MODIFIER : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter((parsed)=>{
        if (!parsed.isTailwindClass) return true;
        const { modifierId: modifierId, classGroupId: classGroupId, hasPostfixModifier: hasPostfixModifier } = parsed;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group)=>classGroupsInConflict.add(modifierId + group));
        return true;
    }).reverse().map((parsed)=>parsed.originalClassName).join(" ");
}
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $6341adc0b94c7664$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $6341adc0b94c7664$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $6341adc0b94c7664$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    let resolvedValue;
    let string = "";
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $6341adc0b94c7664$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $6341adc0b94c7664$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $6341adc0b94c7664$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $6341adc0b94c7664$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($6341adc0b94c7664$var$twJoin.apply(null, arguments));
    };
}
function $6341adc0b94c7664$var$fromTheme(key) {
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
}
const $6341adc0b94c7664$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $6341adc0b94c7664$var$fractionRegex = /^\d+\/\d+$/;
const $6341adc0b94c7664$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
const $6341adc0b94c7664$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $6341adc0b94c7664$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $6341adc0b94c7664$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $6341adc0b94c7664$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $6341adc0b94c7664$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function $6341adc0b94c7664$var$isLength(value) {
    return $6341adc0b94c7664$var$isNumber(value) || $6341adc0b94c7664$var$stringLengths.has(value) || $6341adc0b94c7664$var$fractionRegex.test(value);
}
function $6341adc0b94c7664$var$isArbitraryLength(value) {
    return $6341adc0b94c7664$var$getIsArbitraryValue(value, "length", $6341adc0b94c7664$var$isLengthOnly);
}
function $6341adc0b94c7664$var$isNumber(value) {
    return Boolean(value) && !Number.isNaN(Number(value));
}
function $6341adc0b94c7664$var$isArbitraryNumber(value) {
    return $6341adc0b94c7664$var$getIsArbitraryValue(value, "number", $6341adc0b94c7664$var$isNumber);
}
function $6341adc0b94c7664$var$isInteger(value) {
    return Boolean(value) && Number.isInteger(Number(value));
}
function $6341adc0b94c7664$var$isPercent(value) {
    return value.endsWith("%") && $6341adc0b94c7664$var$isNumber(value.slice(0, -1));
}
function $6341adc0b94c7664$var$isArbitraryValue(value) {
    return $6341adc0b94c7664$var$arbitraryValueRegex.test(value);
}
function $6341adc0b94c7664$var$isTshirtSize(value) {
    return $6341adc0b94c7664$var$tshirtUnitRegex.test(value);
}
const $6341adc0b94c7664$var$sizeLabels = /*#__PURE__*/ new Set([
    "length",
    "size",
    "percentage"
]);
function $6341adc0b94c7664$var$isArbitrarySize(value) {
    return $6341adc0b94c7664$var$getIsArbitraryValue(value, $6341adc0b94c7664$var$sizeLabels, $6341adc0b94c7664$var$isNever);
}
function $6341adc0b94c7664$var$isArbitraryPosition(value) {
    return $6341adc0b94c7664$var$getIsArbitraryValue(value, "position", $6341adc0b94c7664$var$isNever);
}
const $6341adc0b94c7664$var$imageLabels = /*#__PURE__*/ new Set([
    "image",
    "url"
]);
function $6341adc0b94c7664$var$isArbitraryImage(value) {
    return $6341adc0b94c7664$var$getIsArbitraryValue(value, $6341adc0b94c7664$var$imageLabels, $6341adc0b94c7664$var$isImage);
}
function $6341adc0b94c7664$var$isArbitraryShadow(value) {
    return $6341adc0b94c7664$var$getIsArbitraryValue(value, "", $6341adc0b94c7664$var$isShadow);
}
function $6341adc0b94c7664$var$isAny() {
    return true;
}
function $6341adc0b94c7664$var$getIsArbitraryValue(value, label, testValue) {
    const result = $6341adc0b94c7664$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
}
function $6341adc0b94c7664$var$isLengthOnly(value) {
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    return $6341adc0b94c7664$var$lengthUnitRegex.test(value) && !$6341adc0b94c7664$var$colorFunctionRegex.test(value);
}
function $6341adc0b94c7664$var$isNever() {
    return false;
}
function $6341adc0b94c7664$var$isShadow(value) {
    return $6341adc0b94c7664$var$shadowRegex.test(value);
}
function $6341adc0b94c7664$var$isImage(value) {
    return $6341adc0b94c7664$var$imageRegex.test(value);
}
const $6341adc0b94c7664$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $6341adc0b94c7664$var$isAny,
    isArbitraryImage: $6341adc0b94c7664$var$isArbitraryImage,
    isArbitraryLength: $6341adc0b94c7664$var$isArbitraryLength,
    isArbitraryNumber: $6341adc0b94c7664$var$isArbitraryNumber,
    isArbitraryPosition: $6341adc0b94c7664$var$isArbitraryPosition,
    isArbitraryShadow: $6341adc0b94c7664$var$isArbitraryShadow,
    isArbitrarySize: $6341adc0b94c7664$var$isArbitrarySize,
    isArbitraryValue: $6341adc0b94c7664$var$isArbitraryValue,
    isInteger: $6341adc0b94c7664$var$isInteger,
    isLength: $6341adc0b94c7664$var$isLength,
    isNumber: $6341adc0b94c7664$var$isNumber,
    isPercent: $6341adc0b94c7664$var$isPercent,
    isTshirtSize: $6341adc0b94c7664$var$isTshirtSize
}, Symbol.toStringTag, {
    value: "Module"
});
function $6341adc0b94c7664$var$getDefaultConfig() {
    const colors = $6341adc0b94c7664$var$fromTheme("colors");
    const spacing = $6341adc0b94c7664$var$fromTheme("spacing");
    const blur = $6341adc0b94c7664$var$fromTheme("blur");
    const brightness = $6341adc0b94c7664$var$fromTheme("brightness");
    const borderColor = $6341adc0b94c7664$var$fromTheme("borderColor");
    const borderRadius = $6341adc0b94c7664$var$fromTheme("borderRadius");
    const borderSpacing = $6341adc0b94c7664$var$fromTheme("borderSpacing");
    const borderWidth = $6341adc0b94c7664$var$fromTheme("borderWidth");
    const contrast = $6341adc0b94c7664$var$fromTheme("contrast");
    const grayscale = $6341adc0b94c7664$var$fromTheme("grayscale");
    const hueRotate = $6341adc0b94c7664$var$fromTheme("hueRotate");
    const invert = $6341adc0b94c7664$var$fromTheme("invert");
    const gap = $6341adc0b94c7664$var$fromTheme("gap");
    const gradientColorStops = $6341adc0b94c7664$var$fromTheme("gradientColorStops");
    const gradientColorStopPositions = $6341adc0b94c7664$var$fromTheme("gradientColorStopPositions");
    const inset = $6341adc0b94c7664$var$fromTheme("inset");
    const margin = $6341adc0b94c7664$var$fromTheme("margin");
    const opacity = $6341adc0b94c7664$var$fromTheme("opacity");
    const padding = $6341adc0b94c7664$var$fromTheme("padding");
    const saturate = $6341adc0b94c7664$var$fromTheme("saturate");
    const scale = $6341adc0b94c7664$var$fromTheme("scale");
    const sepia = $6341adc0b94c7664$var$fromTheme("sepia");
    const skew = $6341adc0b94c7664$var$fromTheme("skew");
    const space = $6341adc0b94c7664$var$fromTheme("space");
    const translate = $6341adc0b94c7664$var$fromTheme("translate");
    const getOverscroll = ()=>[
            "auto",
            "contain",
            "none"
        ];
    const getOverflow = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            "auto",
            $6341adc0b94c7664$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $6341adc0b94c7664$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            "",
            $6341adc0b94c7664$var$isLength,
            $6341adc0b94c7664$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            "auto",
            $6341adc0b94c7664$var$isNumber,
            $6341adc0b94c7664$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    const getLineStyles = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    const getBlendModes = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ];
    const getAlign = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    const getZeroAndEmpty = ()=>[
            "",
            "0",
            $6341adc0b94c7664$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    const getNumber = ()=>[
            $6341adc0b94c7664$var$isNumber,
            $6341adc0b94c7664$var$isArbitraryNumber
        ];
    const getNumberAndArbitrary = ()=>[
            $6341adc0b94c7664$var$isNumber,
            $6341adc0b94c7664$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $6341adc0b94c7664$var$isAny
            ],
            spacing: [
                $6341adc0b94c7664$var$isLength,
                $6341adc0b94c7664$var$isArbitraryLength
            ],
            blur: [
                "none",
                "",
                $6341adc0b94c7664$var$isTshirtSize,
                $6341adc0b94c7664$var$isArbitraryValue
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $6341adc0b94c7664$var$isTshirtSize,
                $6341adc0b94c7664$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $6341adc0b94c7664$var$isPercent,
                $6341adc0b94c7664$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $6341adc0b94c7664$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...getPositions(),
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $6341adc0b94c7664$var$isInteger,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $6341adc0b94c7664$var$isInteger,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $6341adc0b94c7664$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $6341adc0b94c7664$var$isInteger,
                                $6341adc0b94c7664$var$isArbitraryValue
                            ]
                        },
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $6341adc0b94c7664$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $6341adc0b94c7664$var$isInteger,
                                $6341adc0b94c7664$var$isArbitraryValue
                            ]
                        },
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $6341adc0b94c7664$var$isTshirtSize
                            ]
                        },
                        $6341adc0b94c7664$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $6341adc0b94c7664$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $6341adc0b94c7664$var$isTshirtSize,
                        $6341adc0b94c7664$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $6341adc0b94c7664$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $6341adc0b94c7664$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $6341adc0b94c7664$var$isNumber,
                        $6341adc0b94c7664$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...getLineStyles(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...getPositions(),
                        $6341adc0b94c7664$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $6341adc0b94c7664$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $6341adc0b94c7664$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...getLineStyles(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $6341adc0b94c7664$var$isTshirtSize,
                        $6341adc0b94c7664$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $6341adc0b94c7664$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...getBlendModes(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $6341adc0b94c7664$var$isTshirtSize,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $6341adc0b94c7664$var$isInteger,
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $6341adc0b94c7664$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $6341adc0b94c7664$var$isLength,
                        $6341adc0b94c7664$var$isArbitraryLength,
                        $6341adc0b94c7664$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $6341adc0b94c7664$var$mergeConfigs(baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} }) {
    $6341adc0b94c7664$var$overrideProperty(baseConfig, "cacheSize", cacheSize);
    $6341adc0b94c7664$var$overrideProperty(baseConfig, "prefix", prefix);
    $6341adc0b94c7664$var$overrideProperty(baseConfig, "separator", separator);
    $6341adc0b94c7664$var$overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
    for(const configKey in override)$6341adc0b94c7664$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$6341adc0b94c7664$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
}
function $6341adc0b94c7664$var$overrideProperty(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
}
function $6341adc0b94c7664$var$overrideConfigProperties(baseObject, overrideObject) {
    if (overrideObject) for(const key in overrideObject)$6341adc0b94c7664$var$overrideProperty(baseObject, key, overrideObject[key]);
}
function $6341adc0b94c7664$var$mergeConfigProperties(baseObject, mergeObject) {
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
}
function $6341adc0b94c7664$var$extendTailwindMerge(configExtension, ...createConfig) {
    return typeof configExtension === "function" ? $6341adc0b94c7664$var$createTailwindMerge($6341adc0b94c7664$var$getDefaultConfig, configExtension, ...createConfig) : $6341adc0b94c7664$var$createTailwindMerge(()=>$6341adc0b94c7664$var$mergeConfigs($6341adc0b94c7664$var$getDefaultConfig(), configExtension), ...createConfig);
}
const $6341adc0b94c7664$var$twMerge = /*#__PURE__*/ $6341adc0b94c7664$var$createTailwindMerge($6341adc0b94c7664$var$getDefaultConfig);
$6341adc0b94c7664$exports.createTailwindMerge = $6341adc0b94c7664$var$createTailwindMerge;
$6341adc0b94c7664$exports.extendTailwindMerge = $6341adc0b94c7664$var$extendTailwindMerge;
$6341adc0b94c7664$exports.fromTheme = $6341adc0b94c7664$var$fromTheme;
$6341adc0b94c7664$exports.getDefaultConfig = $6341adc0b94c7664$var$getDefaultConfig;
$6341adc0b94c7664$exports.mergeConfigs = $6341adc0b94c7664$var$mergeConfigs;
$6341adc0b94c7664$exports.twJoin = $6341adc0b94c7664$var$twJoin;
$6341adc0b94c7664$exports.twMerge = $6341adc0b94c7664$var$twMerge;
$6341adc0b94c7664$exports.validators = $6341adc0b94c7664$var$validators;


const $1ec4bc0caf14a55f$export$1343a74baacb0543 = (...inputs)=>{
    return (0, $6341adc0b94c7664$exports.twMerge)((0, $5d09362e9dfe6519$export$4f5d2d50c9deca37)(inputs));
};
const $1ec4bc0caf14a55f$export$d551776f75c8159b = (number)=>{
    let str = number.toLocaleString("en-US");
    str = str.replace(/,/g, ".");
    return str + " kr.";
};




const $f8257e074bcde079$export$150b732325d14d04 = {
    is: {
        PaymentMethods: {
            "Grei\xf0slukort me\xf0 Teya": "Grei\xf0slukort",
            TeyaText: "\xde\xfa getur nota\xf0 grei\xf0slukort til a\xf0 grei\xf0a fyrir n\xe1mskei\xf0i\xf0. Hlekkurinn fyrir ne\xf0an tekur \xfeig \xe1 \xf6rugga grei\xf0slus\xed\xf0u, s\xed\xf0an er \xfe\xe9r beint aftur \xe1 okkar s\xed\xf0u \xfeegar grei\xf0slan fer \xed gegn.",
            "Rapyd grei\xf0slus\xed\xf0an": "Grei\xf0slus\xed\xf0a",
            "Fara \xe1 grei\xf0slus\xed\xf0una": "Fara \xe1 grei\xf0slus\xed\xf0una",
            Upphæð: "Upph\xe6\xf0",
            Millifærsla: "Millif\xe6rsla",
            TransferText: "Ath. Eftir a\xf0 \xfe\xfa hefur greitt me\xf0 millif\xe6rslu \xfe\xe1 geta li\xf0i\xf0 allt a\xf0 24 t\xedmar \xfear til a\xf0 \xfe\xfa f\xe6r\xf0 a\xf0gang a\xf0 n\xe1mskei\xf0inu. Ef \xfe\xfa getur ekki be\xf0i\xf0 og vilt byrja strax \xfe\xe1 er betra a\xf0 nota debit- e\xf0a kreditkort.",
            "Fylgdu eftirfarandi tveim skrefum til a\xf0 grei\xf0a me\xf0 millif\xe6rslu": "Fylgdu eftirfarandi tveim skrefum til a\xf0 grei\xf0a me\xf0 millif\xe6rslu.",
            "1. Millif\xe6ra": "1. Millif\xe6ra",
            Millifærðu: "Millif\xe6r\xf0u",
            "inn \xe1 eftirfarandi reikning": "inn \xe1 eftirfarandi reikning",
            Kennitala: "Kennitala",
            Reikningsnúmer: "Reikningsn\xfamer",
            "2. L\xe1ttu okkur vita": "2. L\xe1ttu okkur vita",
            TransferText2: "Smelltu \xe1 takkann fyrir ne\xf0an til a\xf0 senda okkur tilkynningu. \xdeetta sendir okkur t\xf6lvup\xf3st svo vi\xf0 getum athuga\xf0 hvort a\xf0 grei\xf0sla hefur borist og opna\xf0 n\xe1mskei\xf0i\xf0 fyrir \xfe\xe9r.",
            "Senda tilkynningu": "Senda tilkynningu",
            "Tilkynning send": "Tilkynning send",
            "\xcd vinnslu": "\xcd vinnslu"
        }
    },
    en: {
        PaymentMethods: {
            "Grei\xf0slukort me\xf0 Teya": "Payment card",
            TeyaText: "You can use a payment card to pay for the course. The link below will take you to a secure payment page. Once you've paid you will be redirected back to this webpage.",
            "Rapyd grei\xf0slus\xed\xf0an": "Payment Page",
            "Fara \xe1 grei\xf0slus\xed\xf0una": "Go to payment page",
            Upphæð: "Price",
            Millifærsla: "Bank Transfer",
            TransferText: "After you've paid with a transfer it could take up to 24 hours until you get access to the course. If you can't wait and want to begin right away then it's better to use a payment card instead.",
            "Fylgdu eftirfarandi tveim skrefum til a\xf0 grei\xf0a me\xf0 millif\xe6rslu": "Follow the following two steps to pay with a bank transfer.",
            "1. Millif\xe6ra": "1. Transfer",
            Millifærðu: "Transfer",
            "inn \xe1 eftirfarandi reikning": "into the following account",
            Kennitala: "Kennitala",
            Reikningsnúmer: "Account number (Reikningsn\xfamer)",
            "2. L\xe1ttu okkur vita": "2. Let us know",
            TransferText2: "Click on the button below to send us a notification. This sends us an email so we can check if a payment has reached us. Then we can open the course for you.",
            "Senda tilkynningu": "Send notification",
            "Tilkynning send": "Notification sent",
            "\xcd vinnslu": "Loading"
        }
    }
};
const $f8257e074bcde079$var$PaymentMethods = ({ paymentData: paymentData, price: price, picked: picked, courseId: courseId })=>{
    let renderedHtml = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {});
    const formattedPrice = (0, $1ec4bc0caf14a55f$export$d551776f75c8159b)(Number(price));
    const [loading, setLoading] = (0, $4hYjL.useState)(false);
    const [notificationSent, setNotificationSent] = (0, $4hYjL.useState)(false);
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const confirmTransfer = (courseId)=>{
        setLoading(true);
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/confirm-bank-transfer`, {
            courseId: Number(courseId)
        }).then((res)=>{
            setLoading(false);
            setNotificationSent(true);
            console.log("Done", res);
        }).catch((error)=>{
            setLoading(false);
            console.error(error.response);
        });
    };
    if (picked === "payment-card") renderedHtml = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "card-payment",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("PaymentMethods.Grei\xf0slukort me\xf0 Teya")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("PaymentMethods.TeyaText")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                className: "valitor-sida-mynd",
                src: "/images/valitor-sida.png"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                className: "caption",
                children: t("PaymentMethods.Rapyd grei\xf0slus\xed\xf0an")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: `${t("PaymentMethods.Upph\xe6\xf0")}: ${formattedPrice}`
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("form", {
                action: paymentData.PaymentUrl,
                method: "post",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "merchantid",
                        value: paymentData.MerchantId
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "paymentgatewayid",
                        value: paymentData.PaymentGatewayId
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "orderid",
                        value: paymentData.OrderId
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "reference",
                        value: paymentData.Reference
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "checkhash",
                        value: paymentData.checkhash
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "amount",
                        value: paymentData.Amount
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "currency",
                        value: paymentData.Currency
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "language",
                        value: paymentData.Language
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "itemdescription_0",
                        value: paymentData.ItemDescription_0
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "itemcount_0",
                        value: paymentData.ItemCount_0
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "itemunitamount_0",
                        value: paymentData.ItemUnitAmount_0
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "itemamount_0",
                        value: paymentData.ItemAmount_0
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "returnurlsuccess",
                        value: paymentData.ReturnUrlSuccess
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "returnurlsuccessserver",
                        value: paymentData.ReturnUrlSuccessServer
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "returnurlcancel",
                        value: paymentData.ReturnUrlCancel
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "returnurlerror",
                        value: paymentData.ReturnUrlError
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        type: "hidden",
                        name: "skipreceiptpage",
                        value: paymentData.SkipReceiptPage
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("button", {
                        className: "btn",
                        type: "submit",
                        children: [
                            t("PaymentMethods.Fara \xe1 grei\xf0slus\xed\xf0una"),
                            " ",
                            " ",
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                className: "fa fa-external-link",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    else if (picked === "transfer") renderedHtml = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "transfer-payment",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("PaymentMethods.Millif\xe6rsla")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("PaymentMethods.TransferText")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("PaymentMethods.Fylgdu eftirfarandi tveim skrefum til a\xf0 grei\xf0a me\xf0 millif\xe6rslu")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                children: t("PaymentMethods.1. Millif\xe6ra")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("PaymentMethods.Millif\xe6r\xf0u"),
                    " ",
                    formattedPrice,
                    " ",
                    t("PaymentMethods.inn \xe1 eftirfarandi reikning"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                style: {
                    padding: "10px 16px",
                    backgroundColor: "#fff4d6",
                    display: "block",
                    fontFamily: "monospace"
                },
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                    style: {
                        fontFamily: "monospace"
                    },
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("b", {
                            children: t("PaymentMethods.Kennitala")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("br", {}),
                        " 591214-0710",
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("b", {
                            style: {
                                marginTop: "12px",
                                display: "inline-block"
                            },
                            children: t("PaymentMethods.Reikningsn\xfamer")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("br", {}),
                        " 0133-26-005912",
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("b", {
                            style: {
                                marginTop: "12px",
                                display: "inline-block"
                            },
                            children: t("PaymentMethods.Upph\xe6\xf0")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("br", {}),
                        " ",
                        formattedPrice
                    ]
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                children: t("PaymentMethods.2. L\xe1ttu okkur vita")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("PaymentMethods.TransferText2")
            }),
            notificationSent ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    "✔️ ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("em", {
                        children: t("PaymentMethods.Tilkynning send")
                    })
                ]
            }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                type: "onClick",
                onClick: ()=>confirmTransfer(courseId),
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: "fa fa-envelope-o",
                        "aria-hidden": "true"
                    }),
                    " ",
                    loading ? t("PaymentMethods.\xcd vinnslu") : t("PaymentMethods.Senda tilkynningu")
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        children: renderedHtml
    });
};
var $f8257e074bcde079$export$2e2bcd8739ae039 = $f8257e074bcde079$var$PaymentMethods;



parcelRequire("4hYjL");
const $3a823d631c50b237$var$PaymentOption = ({ handlePick: handlePick, isPicked: isPicked, name: name, text: text, prettyName: prettyName })=>{
    const isOptionPicked = isPicked(name);
    let icon = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
        className: "payment-icon",
        src: "/images/netgiro.png"
    });
    if (name === "payment-card") icon = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
        className: "fa fa-credit-card fa-4x",
        "aria-hidden": "true"
    });
    else if (name === "transfer") icon = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
        className: "fa fa-exchange fa-4x",
        "aria-hidden": "true"
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: `payment-choice ${isOptionPicked ? "picked" : ""}`,
        onClick: ()=>handlePick(name),
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "checkbox",
                children: isOptionPicked ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: "fa fa-check-square-o"
                }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                    className: "fa fa-square-o"
                })
            }),
            icon,
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                style: {
                    fontSize: "28px",
                    marginBottom: "0",
                    marginTop: "10px"
                },
                children: prettyName
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                className: "payment-option-desc",
                children: text
            })
        ]
    });
};
var $3a823d631c50b237$export$2e2bcd8739ae039 = $3a823d631c50b237$var$PaymentOption;



const $163558810dd8fc95$export$150b732325d14d04 = {
    is: {
        PaymentPicker: {
            "Veldu grei\xf0slulei\xf0": "Veldu grei\xf0slulei\xf0",
            Greiðslukort: "Grei\xf0slukort",
            "Borga\xf0u me\xf0 Rapyd": "Borga\xf0u me\xf0 korti",
            Millifærsla: "Millif\xe6rsla",
            "Greiddu me\xf0 millif\xe6rslu og vi\xf0 opnum innan vi\xf0 24 t\xedma": "Greiddu me\xf0 millif\xe6rslu og vi\xf0 opnum innan vi\xf0 24 t\xedma"
        }
    },
    en: {
        PaymentPicker: {
            "Veldu grei\xf0slulei\xf0": "Choose payment type",
            Greiðslukort: "Payment card",
            "Borga\xf0u me\xf0 Rapyd": "Pay with card",
            Millifærsla: "Bank Transfer",
            "Greiddu me\xf0 millif\xe6rslu og vi\xf0 opnum innan vi\xf0 24 t\xedma": "Pay with bank transfer and we'll open within 24 hours  "
        }
    }
};
const $163558810dd8fc95$var$PaymentPicker = ({ paymentData: paymentData, price: price, courseId: courseId })=>{
    const [picked, setPicked] = (0, $4hYjL.useState)("");
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const handlePick = (value)=>{
        if (value === picked) setPicked("");
        else setPicked(value);
    };
    const isPicked = (value)=>{
        if (picked === value) return true;
        return false;
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "payment-area",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h2", {
                className: "pick-payment-type-title",
                children: [
                    t("PaymentPicker.Veldu grei\xf0slulei\xf0"),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "payment-picker",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $3a823d631c50b237$export$2e2bcd8739ae039), {
                        handlePick: handlePick,
                        isPicked: isPicked,
                        name: "payment-card",
                        prettyName: t("PaymentPicker.Grei\xf0slukort"),
                        text: t("PaymentPicker.Borga\xf0u me\xf0 Rapyd")
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $3a823d631c50b237$export$2e2bcd8739ae039), {
                        handlePick: handlePick,
                        isPicked: isPicked,
                        name: "transfer",
                        prettyName: t("PaymentPicker.Millif\xe6rsla"),
                        text: t("PaymentPicker.Greiddu me\xf0 millif\xe6rslu og vi\xf0 opnum innan vi\xf0 24 t\xedma")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $f8257e074bcde079$export$2e2bcd8739ae039), {
                picked: picked,
                paymentData: paymentData,
                price: price.toString(),
                courseId: courseId
            })
        ]
    });
};
var $163558810dd8fc95$export$2e2bcd8739ae039 = $163558810dd8fc95$var$PaymentPicker;





const $e97eb64309dcdec7$export$150b732325d14d04 = {
    is: {
        Payment: {
            Ökuskóli: "\xd6kusk\xf3li",
            Greiðsla: "Grei\xf0sla",
            "Til baka": "Til baka",
            Ö: "\xd6"
        }
    },
    en: {
        Payment: {
            Ökuskóli: "Driving School",
            Greiðsla: "Payment",
            "Til baka": "Back",
            Ö: "Driving School"
        }
    }
};
const $e97eb64309dcdec7$var$Payment = ({ authReducer: authReducer, match: match })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const { name: name, id: id } = authReducer;
    const { courseId: courseId } = match.params;
    const [paymentData, setPaymentData] = (0, $4hYjL.useState)(null);
    const price = 12500;
    (0, $4hYjL.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/payment-data`, {
            name: name,
            id: id,
            courseId: courseId
        }).then((res)=>setPaymentData(res.data.response)).catch((error)=>console.error(error.response));
    }, []);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: courseId,
        title: `${t("Payment.\xd6")}${courseId} | ${t("Payment.Grei\xf0sla")}`,
        paymentStep: "step-2",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "payment-page",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                    children: `${t("Payment.\xd6kusk\xf3li")} ${courseId} — ${t("Payment.Grei\xf0sla")}`
                }),
                paymentData !== null ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $163558810dd8fc95$export$2e2bcd8739ae039), {
                    paymentData: paymentData,
                    price: price,
                    courseId: courseId
                }) : null,
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                    to: `/okuskoli${courseId}-upplysingar`,
                    className: "btn",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                            className: "fa fa-chevron-left",
                            "aria-hidden": "true"
                        }),
                        " ",
                        t("Payment.Til baka")
                    ]
                })
            ]
        })
    });
};
const $e97eb64309dcdec7$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $e97eb64309dcdec7$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($e97eb64309dcdec7$var$mapStateToProps)($e97eb64309dcdec7$var$Payment);




var $4hYjL = parcelRequire("4hYjL");



const $af31a5e97e272e65$export$150b732325d14d04 = {
    is: {
        ThankYou: {
            Villa: "Villa \uD83D\uDE28",
            "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin": "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin.",
            "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!": "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!",
            Villumelding: "Villumelding",
            "Grei\xf0slu loki\xf0": "Grei\xf0slu loki\xf0",
            "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0": "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0.",
            "\xc1fram \xed n\xe1mskei\xf0": "\xc1fram \xed n\xe1mskei\xf0"
        }
    },
    en: {
        ThankYou: {
            Villa: "Error \uD83D\uDE28",
            "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin": "Something has gone wrong on our end.",
            "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!": "If your course doesn't open please contact us at hallo@urdarbrunnur.is",
            Villumelding: "Error message",
            "Grei\xf0slu loki\xf0": "Payment successful",
            "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0": "All is well. You can now start the course!",
            "\xc1fram \xed n\xe1mskei\xf0": "Continue to course"
        }
    }
};
const $af31a5e97e272e65$var$ThankYou = ({ match: match })=>{
    const { courseId: courseId } = match.params;
    const [loading, setLoading] = (0, $4hYjL.useState)(true);
    const [success, setSuccess] = (0, $4hYjL.useState)(false);
    const [error, setError] = (0, $4hYjL.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)("");
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    (0, $4hYjL.useEffect)(()=>{
        verifyPayment();
    }, []);
    const verifyPayment = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get(`/api/course-access/${courseId}`).then((res)=>{
            const hasAccess = res.data.access || false;
            setError(!hasAccess);
            setSuccess(hasAccess);
            setErrorMessage("Access to this course is not authorized.");
            setLoading(false);
        }).catch((error)=>{
            console.log(error);
            setSuccess(false);
            setError(true);
            setErrorMessage("Unknown error.");
            setLoading(false);
        });
    };
    let display = null;
    if (error) display = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: t("ThankYou.Villa")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("b", {
                        children: [
                            t("ThankYou.Villumelding"),
                            ":"
                        ]
                    }),
                    " ",
                    errorMessage
                ]
            })
        ]
    });
    else if (success) display = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: t("ThankYou.Grei\xf0slu loki\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0")
            })
        ]
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: t("ThankYou.Grei\xf0slu loki\xf0"),
        paymentStep: "step-3",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "main-content",
            children: loading ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "lds-ring",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {}),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {})
                    ]
                })
            }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "",
                children: [
                    display,
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("a", {
                        href: "/stjornbord",
                        className: "btn",
                        children: [
                            t("ThankYou.\xc1fram \xed n\xe1mskei\xf0"),
                            " →"
                        ]
                    })
                ]
            })
        })
    });
};
var $af31a5e97e272e65$export$2e2bcd8739ae039 = $af31a5e97e272e65$var$ThankYou;



parcelRequire("4hYjL");


const $546766ead212f1a0$export$150b732325d14d04 = {
    is: {
        ThankYou: {
            Villa: "Villa \uD83D\uDE28",
            "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is": "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is.",
            "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!": "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!",
            Villumelding: "Villumelding",
            "Grei\xf0slu loki\xf0": "Grei\xf0slu loki\xf0",
            "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0": "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0.",
            "\xc1fram \xed n\xe1mskei\xf0": "\xc1fram \xed n\xe1mskei\xf0"
        }
    },
    en: {
        ThankYou: {
            Villa: "Error \uD83D\uDE28",
            "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is": "Something has gone wrong.",
            "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!": "If your course doesn't open please contact us at hallo@urdarbrunnur.is",
            Villumelding: "Error message",
            "Grei\xf0slu loki\xf0": "Payment successful",
            "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0": "All is well. You can now start the course!",
            "\xc1fram \xed n\xe1mskei\xf0": "Continue to course"
        }
    }
};
const $546766ead212f1a0$var$PaymentCanceled = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const content = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: t("ThankYou.Villa")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("b", {
                        children: [
                            t("ThankYou.Villumelding"),
                            ":"
                        ]
                    }),
                    " ",
                    "Payment was canceled."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: "ThankYou.Grei\xf0slu loki\xf0",
        paymentStep: "step-2",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "main-content",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "",
                children: content
            })
        })
    });
};
var $546766ead212f1a0$export$2e2bcd8739ae039 = $546766ead212f1a0$var$PaymentCanceled;



parcelRequire("4hYjL");


const $8e2cf8f07e24f1a1$export$150b732325d14d04 = {
    is: {
        ThankYou: {
            Villa: "Villa \uD83D\uDE28",
            "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin": "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin.",
            "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!": "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!",
            Villumelding: "Villumelding",
            "Grei\xf0slu loki\xf0": "Grei\xf0slu loki\xf0",
            "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0": "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0.",
            "\xc1fram \xed n\xe1mskei\xf0": "\xc1fram \xed n\xe1mskei\xf0"
        }
    },
    en: {
        ThankYou: {
            Villa: "Error \uD83D\uDE28",
            "Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin": "Something has gone wrong on our end.",
            "Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!": "If your course doesn't open please contact us at hallo@urdarbrunnur.is",
            Villumelding: "Error message",
            "Grei\xf0slu loki\xf0": "Payment successful",
            "N\xfa er allt klappa\xf0 og kl\xe1rt og \xfe\xfa getur hafi\xf0 n\xe1mskei\xf0i\xf0": "All is well. You can now start the course!",
            "\xc1fram \xed n\xe1mskei\xf0": "Continue to course"
        }
    }
};
const $8e2cf8f07e24f1a1$var$PaymentError = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const content = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: t("ThankYou.Villa")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.Eithva\xf0 hefur fari\xf0 \xfarskei\xf0is okkar megin")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("ThankYou.Ef \xfe\xfa kemst ekki inn \xe1 n\xe1mskei\xf0i\xf0 skaltu hafa samband vi\xf0 hallo@urdarbrunnur.is. Vi\xf0 bi\xf0jumst velvir\xf0ingar \xe1 \xfeessu!")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("b", {
                        children: [
                            t("ThankYou.Villumelding"),
                            ":"
                        ]
                    }),
                    " ",
                    "An unknown error occured."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: "ThankYou.Grei\xf0slu loki\xf0",
        paymentStep: "step-2",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "main-content",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "",
                children: content
            })
        })
    });
};
var $8e2cf8f07e24f1a1$export$2e2bcd8739ae039 = $8e2cf8f07e24f1a1$var$PaymentError;


/* eslint-env browser */ 

var $4hYjL = parcelRequire("4hYjL");






parcelRequire("4hYjL");

const $70f351cd6e21fc9c$export$150b732325d14d04 = {
    is: {
        DaysLeft: {
            "\xde\xfa n\xe1\xf0ir ekki a\xf0 kl\xe1ra \xd6kusk\xf3la": "\xde\xfa n\xe1\xf0ir ekki a\xf0 kl\xe1ra \xd6kusk\xf3la",
            "innan 30 daga fr\xe1 \xfev\xed a\xf0 \xfe\xfa h\xf3fst n\xe1mi\xf0": "innan 30 daga fr\xe1 \xfev\xed a\xf0 \xfe\xfa h\xf3fst n\xe1mi\xf0.",
            "\xde\xfa getur byrja\xf0 n\xe1mi\xf0 aftur endurgjaldslaust me\xf0 \xfev\xed a\xf0 smella \xe1 'Byrja upp \xe1 n\xfdtt' h\xe9r a\xf0 ne\xf0an.": "\xde\xfa getur byrja\xf0 n\xe1mi\xf0 aftur endurgjaldslaust me\xf0 \xfev\xed a\xf0 smella \xe1 'Byrja upp \xe1 n\xfdtt' h\xe9r a\xf0 ne\xf0an.",
            "\xde\xfa hefur": "\xde\xfa hefur",
            "til a\xf0 kl\xe1ra \xd6kusk\xf3la": "til a\xf0 kl\xe1ra \xd6kusk\xf3la",
            dag: "dag",
            daga: "daga"
        }
    },
    en: {
        DaysLeft: {
            "\xde\xfa n\xe1\xf0ir ekki a\xf0 kl\xe1ra \xd6kusk\xf3la": "\xde\xfa n\xe1\xf0ir ekki a\xf0 kl\xe1ra \xd6kusk\xf3la",
            "innan 30 daga fr\xe1 \xfev\xed a\xf0 \xfe\xfa h\xf3fst n\xe1mi\xf0": "innan 30 daga fr\xe1 \xfev\xed a\xf0 \xfe\xfa h\xf3fst n\xe1mi\xf0.",
            "\xde\xfa getur byrja\xf0 n\xe1mi\xf0 aftur endurgjaldslaust me\xf0 \xfev\xed a\xf0 smella \xe1 'Byrja upp \xe1 n\xfdtt' h\xe9r a\xf0 ne\xf0an.": "\xde\xfa getur byrja\xf0 n\xe1mi\xf0 aftur endurgjaldslaust me\xf0 \xfev\xed a\xf0 smella \xe1 'Byrja upp \xe1 n\xfdtt' h\xe9r a\xf0 ne\xf0an.",
            "\xde\xfa hefur": "You have",
            "til a\xf0 kl\xe1ra \xd6kusk\xf3la": "to finish Driving School",
            dag: "day",
            daga: "days"
        }
    }
};
const $70f351cd6e21fc9c$export$4707a8f602e8f05a = ({ daysLeft: daysLeft, courseStatus: courseStatus, courseId: courseId })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    let daysLeftText;
    if (courseStatus === "Expired" || daysLeft <= 0 && courseStatus !== "Finished") daysLeftText = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "course-expired",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("DaysLeft.\xde\xfa n\xe1\xf0ir ekki a\xf0 kl\xe1ra \xd6kusk\xf3la"),
                    " ",
                    courseId,
                    " ",
                    t("DaysLeft.innan 30 daga fr\xe1 \xfev\xed a\xf0 \xfe\xfa h\xf3fst n\xe1mi\xf0")
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("DaysLeft.\xde\xfa getur byrja\xf0 n\xe1mi\xf0 aftur endurgjaldslaust me\xf0 \xfev\xed a\xf0 smella \xe1 'Byrja upp \xe1 n\xfdtt' h\xe9r a\xf0 ne\xf0an.")
            })
        ]
    });
    else if (courseStatus !== "Finished") {
        let formatDaysLeft;
        if (daysLeft === 1 || daysLeft === 21) formatDaysLeft = `${daysLeft} ${t("DaysLeft.dag")}`;
        else formatDaysLeft = `${daysLeft} ${t("DaysLeft.daga")}`;
        daysLeftText = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "daysleft-alert-box",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "daysleft-alert-text-container",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                            className: "fa fa-calendar"
                        }),
                        `  ${t("DaysLeft.\xde\xfa hefur")} ${formatDaysLeft} ${t("DaysLeft.til a\xf0 kl\xe1ra \xd6kusk\xf3la")} ${courseId}.`
                    ]
                })
            })
        });
    } else daysLeftText = null;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
        children: daysLeftText
    });
};
var $70f351cd6e21fc9c$export$2e2bcd8739ae039 = $70f351cd6e21fc9c$export$4707a8f602e8f05a;



parcelRequire("4hYjL");

const $efb0620606697874$export$150b732325d14d04 = {
    is: {
        StartAgain: {
            "Byrja upp \xe1 n\xfdtt": "Byrja upp \xe1 n\xfdtt"
        }
    },
    en: {
        StartAgain: {
            "Byrja upp \xe1 n\xfdtt": "Restart course"
        }
    }
};
const $efb0620606697874$export$7841d5c4e12d894a = ({ daysLeft: daysLeft, courseStatus: courseStatus, startAgain: startAgain })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    let startAgainJsx = null;
    if (courseStatus === "Expired" || daysLeft <= 0 && courseStatus !== "Finished") startAgainJsx = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("span", {
        className: "btn restart-course",
        onClick: startAgain,
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                className: "fa fa-refresh",
                "aria-hidden": "true"
            }),
            " ",
            t("StartAgain.Byrja upp \xe1 n\xfdtt")
        ]
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
        children: startAgainJsx
    });
};
var $efb0620606697874$export$2e2bcd8739ae039 = $efb0620606697874$export$7841d5c4e12d894a;



parcelRequire("4hYjL");

const $294514a41354fbee$export$150b732325d14d04 = {
    is: {
        Alert: {
            Lota: "Lota",
            "er n\xfa opin": "er n\xfa opin",
            "Smelltu \xe1 Byrja Lotu": "Byrja\xf0u Lotu",
            "fyrir ofan til a\xf0 byrja": "me\xf0 \xfev\xed a\xf0 endurhla\xf0a śi\xf0una",
            mínútur: "m\xedn\xfatur",
            mínúta: "m\xedn\xfata",
            eru: "eru",
            er: "er",
            "t\xedmar og": "t\xedmar og",
            "t\xedmi og": "t\xedmi og",
            Það: "\xdea\xf0",
            "\xed a\xf0 lota": "\xed a\xf0 lota",
            opnist: "opnist",
            "\xcd millit\xed\xf0inni getur \xfe\xfa endurteki\xf0 lotu": "\xcd millit\xed\xf0inni getur \xfe\xfa endurteki\xf0 lotu",
            "\xc6fingin skapar umfer\xf0armeistarann": "\xc6fingin skapar umfer\xf0armeistarann",
            "Samkv\xe6mt reglum Samg\xf6ngustofu um net\xf6kusk\xf3la ver\xf0ur a\xf0 vera s\xf3lahringur \xe1 milli lota": "Samkv\xe6mt reglum Samg\xf6ngustofu um net\xf6kusk\xf3la ver\xf0ur a\xf0 vera s\xf3lahringur \xe1 milli lota."
        }
    },
    en: {
        Alert: {
            Lota: "Round",
            "er n\xfa opin": "is now open",
            "Smelltu \xe1 Byrja Lotu": "Refresh to begin Round",
            "fyrir ofan til a\xf0 byrja": "",
            mínútur: "minutes",
            mínúta: "minutes",
            eru: "are",
            er: "is",
            "t\xedmar og": "hours and",
            "t\xedmi og": "hour and",
            Það: "There",
            "\xed a\xf0 lota": "until round",
            opnist: "opens",
            "\xcd millit\xed\xf0inni getur \xfe\xfa endurteki\xf0 lotu": "In the meantime you can repeat round",
            "\xc6fingin skapar umfer\xf0armeistarann": "Practice makes perfect",
            "Samkv\xe6mt reglum Samg\xf6ngustofu um net\xf6kusk\xf3la ver\xf0ur a\xf0 vera s\xf3lahringur \xe1 milli lota": "According to rules from the Ministry of Transport there must be one day between rounds."
        }
    }
};
const $294514a41354fbee$export$caec2af78bcc877f = ({ showAlert: showAlert, courseStatus: courseStatus, nextRoundOpen: nextRoundOpen, timerMinutes: timerMinutes, timerHours: timerHours, prevNr: prevNr, nr: nr })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    let alertText = null;
    if (showAlert && courseStatus !== "Expired") {
        if (nextRoundOpen || timerMinutes < 0) // Return that round is open.
        alertText = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "time-to-round",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                className: "alert-box",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: "fa fa-clock-o"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "alert-text-container",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                children: `${t("Alert.Lota")} ${nr} ${t("Alert.er n\xfa opin")}!`
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                children: `${t("Alert.Smelltu \xe1 Byrja Lotu")} ${nr} ${t("Alert.fyrir ofan til a\xf0 byrja")}.`
                            })
                        ]
                    })
                ]
            })
        });
        else {
            // Format text to fit Icelandic grammar rules
            let minutes = t("Alert.m\xedn\xfatur");
            let hours = "";
            let is = t("Alert.eru");
            // Format minutes text
            // Use singular if 1, 21, 31 etc minutes are left
            if (timerMinutes % 10 === 1 && timerMinutes !== 11) {
                minutes = t("Alert.m\xedn\xfata");
                is = t("Alert.er");
            }
            // Format hours text
            // Use singular if 1 hour is left
            if (timerHours > 1) hours = `${timerHours} ${t("Alert.t\xedmar og")} `;
            else if (timerHours === 1) hours = `${timerHours} ${t("Alert.t\xedmi og")} `;
            else hours = "";
            // Put it all together.
            alertText = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "time-to-round",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            className: "alert-box",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                    className: "fa fa-clock-o"
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                    className: "alert-text-container",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                            children: `${t("Alert.\xdea\xf0")} ${is} ${hours + timerMinutes} ${minutes} ${t("Alert.\xed a\xf0 lota")} ${nr} ${t("Alert.opnist")}`
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                            children: `${t("Alert.\xcd millit\xed\xf0inni getur \xfe\xfa endurteki\xf0 lotu")} ${prevNr}. ${t("Alert.\xc6fingin skapar umfer\xf0armeistarann")}!`
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                        children: t("Alert.Samkv\xe6mt reglum Samg\xf6ngustofu um net\xf6kusk\xf3la ver\xf0ur a\xf0 vera s\xf3lahringur \xe1 milli lota")
                    })
                ]
            });
        }
    }
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
        children: alertText
    });
};



parcelRequire("4hYjL");


const $af82ceed56dc8679$export$150b732325d14d04 = {
    is: {
        NextRoundButton: {
            "Byrja Lotu 1": "Byrja Lotu 1",
            "Kynntu \xfeig fyrir ne\xf0an til a\xf0 byrja": "Kynntu \xfeig fyrir ne\xf0an til a\xf0 byrja",
            "Fara \xed lokapr\xf3f": "Fara \xed lokapr\xf3f",
            "Halda \xe1fram me\xf0 Lotu": "Halda \xe1fram me\xf0 Lotu ",
            "Byrja Lotu": "Byrja Lotu ",
            "Fara \xed krossaprof lotu": "Fara \xed krossaprof lotu"
        }
    },
    en: {
        NextRoundButton: {
            "Byrja Lotu 1": "Begin Round 1",
            "Kynntu \xfeig fyrir ne\xf0an til a\xf0 byrja": "Introduce yourself below to start",
            "Fara \xed lokapr\xf3f": "Go to final test",
            "Halda \xe1fram me\xf0 Lotu": "Continue with Round ",
            "Byrja Lotu": "Begin Round ",
            "Fara \xed krossaprof lotu": "Go to test for round"
        }
    }
};
const $af82ceed56dc8679$export$f662aaa9145f1aaa = ({ daysLeft: daysLeft, courseStatus: courseStatus, currentRoundStatus: currentRoundStatus, nextRoundOpen: nextRoundOpen, courseId: courseId, currentRound: currentRound, roundsFinished: roundsFinished, currentStep: currentStep, messageFeatureUsed: messageFeatureUsed })=>{
    if ((nextRoundOpen || currentRound === 1) && courseStatus !== "Finished" && courseStatus !== "Expired" && daysLeft > 0) {
        const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
        let roundText = "";
        if (parseInt(courseId) === 2 && !messageFeatureUsed) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
            to: `/`,
            onClick: (e)=>e.preventDefault(),
            className: "btn first-btn disabled-btn",
            disabled: true,
            children: [
                t("NextRoundButton.Byrja Lotu 1"),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                            className: "fa fa-exclamation-triangle"
                        }),
                        " ",
                        t("NextRoundButton.Kynntu \xfeig fyrir ne\xf0an til a\xf0 byrja")
                    ]
                })
            ]
        });
        if (roundsFinished) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
            to: `/okuskoli-${courseId}/lokaprof`,
            className: "btn first-btn",
            children: t("NextRoundButton.Fara \xed lokapr\xf3f")
        });
        let thisRoundsStep = currentStep;
        if (currentStep === 11 && !nextRoundOpen && currentRoundStatus !== "Finished") return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
            to: `/okuskoli-${courseId}/lota-${currentRound}/krossaprof`,
            className: "btn first-btn",
            children: [
                t("NextRoundButton.Fara \xed krossaprof lotu"),
                " ",
                currentRound
            ]
        });
        if (!roundsFinished) {
            if (currentRoundStatus === "Finished") return null;
            if (currentRoundStatus === "Ongoing") roundText = t("NextRoundButton.Halda \xe1fram me\xf0 Lotu");
            else if (currentRoundStatus === "Not Started") {
                roundText = t("NextRoundButton.Byrja Lotu");
                thisRoundsStep = 1;
            }
            if (roundText !== "") return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                to: `/okuskoli-${courseId}/lota-${currentRound}/skref-${thisRoundsStep}`,
                className: "btn first-btn",
                children: roundText + currentRound
            });
        }
    }
    return null;
};
var $af82ceed56dc8679$export$2e2bcd8739ae039 = $af82ceed56dc8679$export$f662aaa9145f1aaa;



parcelRequire("4hYjL");


var $4hYjL = parcelRequire("4hYjL");

parcelRequire("4hYjL");

const $ff1c392d837ab99c$export$150b732325d14d04 = {
    is: {
        Message: {
            Jan: "jan",
            Feb: "feb",
            Mar: "mar",
            Apr: "apr",
            Maí: "ma\xed",
            Jún: "j\xfan",
            Júl: "j\xfal",
            Ágú: "ag\xfa",
            Sep: "sep",
            Okt: "okt",
            Nóv: "n\xf3v",
            Des: "des"
        }
    },
    en: {
        Message: {
            Jan: "Jan",
            Feb: "Feb",
            Mar: "Mar",
            Apr: "Apr",
            Maí: "May",
            Jún: "June",
            Júl: "Jul",
            Ágú: "Aug",
            Sep: "Sept",
            Okt: "Oct",
            Nóv: "Nov",
            Des: "Dec"
        }
    }
};
const $ff1c392d837ab99c$var$Message = ({ index: index, user: user, text: text, time: time })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const monthNames = [
        t("Message.Jan"),
        t("Message.Feb"),
        t("Message.Mar"),
        t("Message.Apr"),
        t("Message.Ma\xed"),
        t("Message.J\xfan"),
        t("Message.J\xfal"),
        t("Message.\xc1g\xfa"),
        t("Message.Sep"),
        t("Message.Okt"),
        t("Message.N\xf3v"),
        t("Message.Des")
    ];
    // Creates contrast between messages.
    let backgroundColor = "#e4e4e4";
    if (index % 2 === 0) backgroundColor = "#cccccc";
    // Formats time stamp.
    const date = new Date(time);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const timeString = date.getDate() + ". " + monthNames[date.getMonth()] + " " + hours + ":" + minutes;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "message",
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "timestamp",
                children: timeString
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("strong", {
                children: [
                    user,
                    ": "
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                children: text
            })
        ]
    });
};
var $ff1c392d837ab99c$export$2e2bcd8739ae039 = $ff1c392d837ab99c$var$Message;




var $4hYjL = parcelRequire("4hYjL");

const $df962374ea5fc9ca$export$150b732325d14d04 = {
    is: {
        MessageForm: {
            Senda: "Senda",
            "Skrifi\xf0 h\xe9r og \xfdti\xf0 \xe1 enter til a\xf0 senda": "Skrifi\xf0 h\xe9r og \xfdti\xf0 \xe1 enter til a\xf0 senda"
        }
    },
    en: {
        MessageForm: {
            Senda: "Send message",
            "Skrifi\xf0 h\xe9r og \xfdti\xf0 \xe1 enter til a\xf0 senda": "Write here (press enter to send)"
        }
    }
};
const $df962374ea5fc9ca$var$MessageForm = ({ onMessageSubmit: onMessageSubmit })=>{
    const [text, setText] = (0, $4hYjL.useState)("");
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (text.length > 1) {
            onMessageSubmit({
                text: text
            });
            setText("");
        }
    };
    const changeHandler = (e)=>{
        setText(e.target.value);
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: "message_form",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                    onChange: changeHandler,
                    value: text,
                    placeholder: t("MessageForm.Skrifi\xf0 h\xe9r og \xfdti\xf0 \xe1 enter til a\xf0 senda")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                    className: "send-message",
                    children: t("MessageForm.Senda")
                })
            ]
        })
    });
};
var $df962374ea5fc9ca$export$2e2bcd8739ae039 = $df962374ea5fc9ca$var$MessageForm;





class $8fa41cf3ffe663f7$var$Chatbox extends (0, $4hYjL.Component) {
    constructor(props){
        super(props);
        this.myRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).createRef();
        // this.myRef = React.createRef<HTMLDivElement>();
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.onMessageSubmit = this.onMessageSubmit.bind(this);
    }
    scrollToBottom() {
        if (this.myRef.current) this.myRef.current.scrollTo({
            top: 1000
        });
    }
    componentDidUpdate() {
        this.scrollToBottom();
    }
    componentDidMount() {
        this.scrollToBottom();
    }
    onMessageSubmit(message) {
        const { dispatch: dispatch } = this.props;
        const { name: name } = this.props.authReducer;
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/send-message", {
            messageText: message.text
        }).then((res)=>{
            const { message_text: message_text, created_date: created_date } = res.data.message;
            dispatch((0, $d599c499e9218b1e$export$691a31800a3cc1d0)({
                messageTime: created_date,
                text: message_text,
                user: name
            }));
        }).catch((error)=>{
            console.error(error);
        });
    }
    render() {
        const { messages: messages } = this.props;
        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    id: "chat-box",
                    ref: this.myRef,
                    children: messages.map(function(message, index) {
                        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff1c392d837ab99c$export$2e2bcd8739ae039), {
                            index: index,
                            user: message.user,
                            text: message.text,
                            time: message.messageTime
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $df962374ea5fc9ca$export$2e2bcd8739ae039), {
                        onMessageSubmit: this.onMessageSubmit
                    })
                })
            ]
        });
    }
}
const $8fa41cf3ffe663f7$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $8fa41cf3ffe663f7$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($8fa41cf3ffe663f7$var$mapStateToProps)($8fa41cf3ffe663f7$var$Chatbox);



const $e8ec60b3e89354be$export$150b732325d14d04 = {
    is: {
        MainText: {
            Markmið: "Markmi\xf0",
            MarkmiðText: "Markmi\xf0 \xf6kusk\xf3la Ur\xf0arbrunns er a\xf0 gera \xfeig a\xf0 g\xf3\xf0um \xf6kumanni sem ekur af \xf6ryggi og tillitsemi. \xcd \xd6kusk\xf3la 1 leggur \xfe\xfa grunninn a\xf0 \xe1framhaldandi \xf6kun\xe1mi \xfe\xednu en almennt hafa \xf6kumenn ekki n\xe1\xf0 fullri f\xe6rni \xed umfer\xf0inni fyrr en eftir sj\xf6 \xe1r. Traustur grunnur er mikilv\xe6gur og \xfeess vegna skaltu vanda \xfeig fr\xe1 upphafi.",
            MarkmiðTextÖ2: "Markmi\xf0 \xf6kusk\xf3la Ur\xf0arbrunns er a\xf0 gera \xfeig a\xf0 g\xf3\xf0um \xf6kumanni sem ekur af \xf6ryggi og tillitsemi. \xcd \xd6kusk\xf3la 2 leggur \xfe\xfa grunninn a\xf0 \xe1framhaldandi \xf6kun\xe1mi \xfe\xednu en almennt hafa \xf6kumenn ekki n\xe1\xf0 fullri f\xe6rni \xed umfer\xf0inni fyrr en eftir sj\xf6 \xe1r. Traustur grunnur er mikilv\xe6gur og \xfeess vegna skaltu vanda \xfeig fr\xe1 upphafi.",
            "Haf\xf0u \xed huga a\xf0": "Haf\xf0u \xed huga a\xf0",
            HafðuíhugaText: "Samkv\xe6mt regluger\xf0um \xfearf a\xf0 kl\xe1ra \xf6kusk\xf3lann 30 d\xf6gum. Ef \xfe\xfa hefur ekki kl\xe1ra\xf0 \xf6kusk\xf3lann eftir 30 daga getur \xfe\xfa endurteki\xf0 n\xe1mskei\xf0i\xf0 hj\xe1 okkur \xe1n \xfeess a\xf0 borga fyrir \xfea\xf0 aftur.",
            "\xdat \xed Umfer\xf0ina": "\xdat \xed Umfer\xf0ina",
            "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed skriflega \xf6kupr\xf3finu \xfearft \xfe\xfa a\xf0 hafa b\xf3kina": "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed \xf6kusk\xf3lanum \xfearft \xfe\xfa a\xf0 hafa b\xf3kina ",
            "\xfe\xe9r vi\xf0 hli\xf0. Vi\xf0 v\xedsum \xed hana t\xf6luvert og vi\xf0 gerum r\xe1\xf0 fyrir a\xf0 nemendur okkar eigi hana. H\xe6gt er a\xf0 n\xe1lgast b\xf3kina hj\xe1": "\xfe\xe9r vi\xf0 hli\xf0. Vi\xf0 v\xedsum \xed hana t\xf6luvert og vi\xf0 gerum r\xe1\xf0 fyrir a\xf0 nemendur okkar eigi hana. H\xe6gt er a\xf0 n\xe1lgast b\xf3kina hj\xe1",
            "\xd6kukennaraf\xe9lagi \xcdslands": "\xd6kukennaraf\xe9lagi \xcdslands.",
            "\xde\xfa getur l\xedka athuga\xf0 hvort einhver vinur \xfeinn eigi hana": "\xde\xfa getur l\xedka athuga\xf0 hvort einhver vinur \xfeinn eigi hana.",
            "\xdearftu a\xf0sto\xf0": "\xdearftu a\xf0sto\xf0?",
            AðstoðTexti: "Ef \xfe\xfa vilt heyra \xed Hilmari (\xf6kukennara okkar) \xfe\xe1 er h\xe6gt a\xf0 hringja \xe1 milli 20:00 og 22:00 \xe1 \xf6llum virkum d\xf6gum \xed s\xedma 893-2700 e\xf0a \xfe\xfa getur sent okkur t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is",
            Spjallið: "Spjalli\xf0",
            SpjalliðText: "Svo a\xf0 \xfe\xfa getir \xe1tt samskipti vi\xf0 samnemendur getur \xfe\xfa nota\xf0 spjalli\xf0 h\xe9r fyrir ne\xf0an. Til a\xf0 hefja \xf6kusk\xf3la 2 \xfearftu a\xf0 taka \xfe\xe1tt \xed spjallinu. Kynntu \xfeig og seg\xf0u okkur hva\xf0an \xfe\xfa ert!"
        }
    },
    en: {
        MainText: {
            Markmið: "Goal",
            MarkmiðText: "The goal of Ur\xf0arbrunnur Driving School is to guide you along the path of becoming a safe and polite driver. In Driving School 1 you should lay the foundation to your continued driving education as generally drivers don't become as good as they'll get until they've been on the road for 7 years! A strong foundation is important and therefore we suggest you take your time and study carefully from the start.",
            MarkmiðTextÖ2: "The goal of Ur\xf0arbrunnur Driving School is to guide you along the path of becoming a safe and polite driver. In Driving School 2 you should lay the foundation to your continued driving education as generally drivers don't become as good as they'll get until they've been on the road for 7 years! A strong foundation is important and therefore we suggest you take your time and study carefully from the start.",
            "Haf\xf0u \xed huga a\xf0": "The 30 day limit",
            HafðuíhugaText: "You'll need to finish the driving school in 30 days. This is a rule we need to follow from the Ministry of Transport. But not to worry, if you don't finish the driving school in 30 days you can always retake the course with us without paying again.",
            "\xdat \xed Umfer\xf0ina": "\xdat \xed Umfer\xf0ina",
            "Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed skriflega \xf6kupr\xf3finu \xfearft \xfe\xfa a\xf0 hafa b\xf3kina": "For best results in the driving school you should have the book",
            "\xfe\xe9r vi\xf0 hli\xf0. Vi\xf0 v\xedsum \xed hana t\xf6luvert og vi\xf0 gerum r\xe1\xf0 fyrir a\xf0 nemendur okkar eigi hana. H\xe6gt er a\xf0 n\xe1lgast b\xf3kina hj\xe1": "by your side. It's in Icelandic, but we reference the book quite a bit. You can get the book from",
            "\xd6kukennaraf\xe9lagi \xcdslands": "The driving instructor's association.",
            "\xde\xfa getur l\xedka athuga\xf0 hvort einhver vinur \xfeinn eigi hana": "",
            "\xdearftu a\xf0sto\xf0": "Need any help?",
            AðstoðTexti: "If you want to hear from Hilmar (our driving instructor) then you can call him between 20:00 and 22:00 on all working days at 893-2700 or you can send us an email at hallo@urdarbrunnur.is",
            Spjallið: "The Chat",
            SpjalliðText: "You can use the below chat to communicate with your co-students. To start Driving School 2 you need to take part in the chat. Introduce yourself and tell us where you're from!"
        }
    }
};
const $e8ec60b3e89354be$var$MainText = ({ courseId: courseId, messages: messages })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    let text = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {});
    if (parseInt(courseId) === 1) text = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.Markmi\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("MainText.Markmi\xf0Text")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.Haf\xf0u \xed huga a\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("MainText.Haf\xf0u\xedhugaText"),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.\xdat \xed Umfer\xf0ina")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("MainText.Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed skriflega \xf6kupr\xf3finu \xfearft \xfe\xfa a\xf0 hafa b\xf3kina"),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("em", {
                        children: t("MainText.\xdat \xed Umfer\xf0ina")
                    }),
                    " ",
                    t("MainText.\xfe\xe9r vi\xf0 hli\xf0. Vi\xf0 v\xedsum \xed hana t\xf6luvert og vi\xf0 gerum r\xe1\xf0 fyrir a\xf0 nemendur okkar eigi hana. H\xe6gt er a\xf0 n\xe1lgast b\xf3kina hj\xe1"),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("a", {
                        href: "https://www.aka.is/namsefni/",
                        children: [
                            t("MainText.\xd6kukennaraf\xe9lagi \xcdslands"),
                            " "
                        ]
                    }),
                    t("MainText.\xde\xfa getur l\xedka athuga\xf0 hvort einhver vinur \xfeinn eigi hana")
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.\xdearftu a\xf0sto\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("MainText.A\xf0sto\xf0Texti")
            })
        ]
    });
    if (parseInt(courseId) === 2) text = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.Spjalli\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("MainText.Spjalli\xf0Text")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8fa41cf3ffe663f7$export$2e2bcd8739ae039), {
                messages: messages
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.Markmi\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("MainText.Markmi\xf0Text\xd62")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.Haf\xf0u \xed huga a\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("MainText.Haf\xf0u\xedhugaText"),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.\xdat \xed Umfer\xf0ina")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("MainText.Svo a\xf0 \xfe\xfa standir \xfeig sem best \xed skriflega \xf6kupr\xf3finu \xfearft \xfe\xfa a\xf0 hafa b\xf3kina"),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("em", {
                        children: t("MainText.\xdat \xed Umfer\xf0ina")
                    }),
                    " ",
                    t("MainText.\xfe\xe9r vi\xf0 hli\xf0. Vi\xf0 v\xedsum \xed hana t\xf6luvert og vi\xf0 gerum r\xe1\xf0 fyrir a\xf0 nemendur okkar eigi hana. H\xe6gt er a\xf0 n\xe1lgast b\xf3kina hj\xe1"),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("a", {
                        href: "https://www.aka.is/namsefni/",
                        children: [
                            t("MainText.\xd6kukennaraf\xe9lagi \xcdslands"),
                            " "
                        ]
                    }),
                    t("MainText.\xde\xfa getur l\xedka athuga\xf0 hvort einhver vinur \xfeinn eigi hana")
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MainText.\xdearftu a\xf0sto\xf0")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("MainText.A\xf0sto\xf0Texti")
            })
        ]
    });
    return text;
};
var $e8ec60b3e89354be$export$2e2bcd8739ae039 = $e8ec60b3e89354be$var$MainText;




var $4hYjL = parcelRequire("4hYjL");
function $94489d9cefb3e1ce$export$f4b266cd2aae9cb1(callback, delay) {
    const intervalRef = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useRef(0);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useEffect(()=>{
        const tick = ()=>savedCallback.current();
        intervalRef.current = window.setInterval(tick, delay);
        return ()=>window.clearInterval(intervalRef.current);
    }, [
        delay
    ]);
    return intervalRef;
}


const $d4584cbb579a562d$export$150b732325d14d04 = {
    is: {
        Main: {
            Ökuskóli: "\xd6kusk\xf3li",
            "Aftur \xe1 stj\xf3rnbor\xf0": "Aftur \xe1 stj\xf3rnbor\xf0",
            Ö: "\xd6"
        }
    },
    en: {
        Main: {
            Ökuskóli: "Driving School",
            "Aftur \xe1 stj\xf3rnbor\xf0": "Back to dashboard",
            Ö: "DS"
        }
    }
};
const $d4584cbb579a562d$var$Main = ({ authReducer: authReducer, match: match, dispatch: dispatch })=>{
    const { courseId: courseId } = match.params;
    const { currentStep: currentStep, currentRoundStatus: currentRoundStatus, sinceFirstStart: sinceFirstStart, sinceSecondStart: sinceSecondStart, extraDaysFirst: extraDaysFirst, extraDaysSecond: extraDaysSecond, roundsFinished: roundsFinished, userCourses: userCourses, showAlert: showAlert, timerMinutes: timerMinutes, timerHours: timerHours, messages: messages, messageFeatureUsed: messageFeatureUsed, currentUserRounds: currentUserRounds, nextRoundOpen: nextRoundOpen, currentRound: currentRound, id: id } = authReducer;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const fetchCourseData = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/sub-dashboard`, {
            userId: id,
            courseId: parseInt(courseId)
        }).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$5ed101c55fc6dd45)({
                ...res.data
            }));
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    // Takes userRounds and spits out
    const setUpTicker = ()=>{
        if (!nextRoundOpen) currentUserRounds.forEach((round, index)=>{
            const lastFinishedTime = currentUserRounds[index].finished_time;
            if (parseInt(courseId) === round.course_id && round.nr === currentRound && lastFinishedTime) {
                const dateDiff = $d4584cbb579a562d$var$msToTime(new Date().getTime() - new Date(lastFinishedTime).getTime());
                const hours = dateDiff[0];
                const minutes = dateDiff[1];
                const newHour = hours - 3;
                dispatch((0, $d599c499e9218b1e$export$de026b00723010c1)({
                    timerHours: newHour,
                    timerMinutes: minutes
                }));
            }
        });
    };
    (0, $4hYjL.useEffect)(()=>{
        setUpTicker();
    }, [
        authReducer.nextRoundOpen
    ]);
    (0, $4hYjL.useEffect)(()=>{
        fetchCourseData();
    }, []);
    // Update fetchCourseData every 60 seconds in order to update the
    // "there are 19 hours and 50 minutes until round 2 opens" ticker.
    // This is an easy way to keep things in sync.
    (0, $94489d9cefb3e1ce$export$f4b266cd2aae9cb1)(()=>{
        fetchCourseData();
        setUpTicker();
    }, 60000);
    const startAgain = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/restart-course", {
            courseId: parseInt(courseId)
        }).then(()=>{
            window.location.reload();
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    let daysLeft;
    if (parseInt(courseId) === 1) daysLeft = 30 + extraDaysFirst - sinceFirstStart.days;
    else daysLeft = 30 + extraDaysSecond - sinceSecondStart.days;
    // Set courseStatus var to pass into components below.
    let courseStatus = "Ongoing";
    userCourses.forEach((course)=>{
        if (course.id === parseInt(courseId)) courseStatus = course.status;
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: courseId,
        title: `${t("Main.\xd6")}${courseId}`,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "payment-page",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h1", {
                    children: [
                        t("Main.\xd6kusk\xf3li"),
                        " ",
                        courseId
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $70f351cd6e21fc9c$export$4707a8f602e8f05a), {
                    daysLeft: daysLeft,
                    courseStatus: courseStatus,
                    courseId: courseId
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "subdashboard-btn-container",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $af82ceed56dc8679$export$f662aaa9145f1aaa), {
                            daysLeft: daysLeft,
                            courseId: courseId,
                            courseStatus: courseStatus,
                            currentRoundStatus: currentRoundStatus,
                            nextRoundOpen: nextRoundOpen,
                            currentRound: currentRound,
                            roundsFinished: roundsFinished,
                            currentStep: currentStep,
                            messageFeatureUsed: messageFeatureUsed
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                            to: "/stjornbord",
                            className: "secondary-btn",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                    className: "fa fa-tachometer"
                                }),
                                t("Main.Aftur \xe1 stj\xf3rnbor\xf0")
                            ]
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $efb0620606697874$export$7841d5c4e12d894a), {
                            daysLeft: daysLeft,
                            courseStatus: courseStatus,
                            startAgain: startAgain
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $294514a41354fbee$export$caec2af78bcc877f), {
                    showAlert: showAlert,
                    courseStatus: courseStatus,
                    nextRoundOpen: nextRoundOpen,
                    timerMinutes: timerMinutes,
                    timerHours: timerHours,
                    prevNr: currentRound,
                    nr: currentRound + 1
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e8ec60b3e89354be$export$2e2bcd8739ae039), {
                        courseId: courseId,
                        messages: messages
                    })
                })
            ]
        })
    });
};
function $d4584cbb579a562d$var$msToTime(duration) {
    const minutes = 59 - duration / 60000 % 60;
    const hours = 23 - duration / 3600000 % 24;
    return [
        Math.round(hours),
        Math.round(minutes)
    ];
}
const $d4584cbb579a562d$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $d4584cbb579a562d$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($d4584cbb579a562d$var$mapStateToProps)($d4584cbb579a562d$var$Main);


var $1de63c28c2a63f69$exports = {};

$parcel$export($1de63c28c2a63f69$exports, "translations", () => $1de63c28c2a63f69$export$150b732325d14d04);
$parcel$export($1de63c28c2a63f69$exports, "default", () => $1de63c28c2a63f69$export$2e2bcd8739ae039);
/* eslint-env browser */ 

var $4hYjL = parcelRequire("4hYjL");





parcelRequire("4hYjL");

const $5dbd16c7c4c8c597$export$150b732325d14d04 = {
    is: {
        PrevStepButton: {
            "Til baka": "Til baka"
        }
    },
    en: {
        PrevStepButton: {
            "Til baka": "Back"
        }
    }
};
const $5dbd16c7c4c8c597$export$dc262acb21978b1a = ({ history: history, params: params })=>{
    const { courseId: courseId, roundNr: roundNr, stepNr: stepNr } = params;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    function prevStep() {
        const prevStep = parseInt(stepNr) - 1;
        history.push(`/okuskoli-${courseId}/lota-${roundNr}/skref-${prevStep}`);
    }
    if (parseInt(stepNr) > 1) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("button", {
        type: "submit",
        id: "previous",
        className: "btn",
        onClick: prevStep,
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                className: "fa fa-arrow-left"
            }),
            " ",
            t("PrevStepButton.Til baka")
        ]
    });
    return null;
};
var $5dbd16c7c4c8c597$export$2e2bcd8739ae039 = $5dbd16c7c4c8c597$export$dc262acb21978b1a;



parcelRequire("4hYjL");


const $1887a4ff5604fbbb$export$150b732325d14d04 = {
    is: {
        NextStepButton: {
            "N\xe6sta skref": "N\xe6sta skref",
            "Fara \xed krossapr\xf3f": "Fara \xed krossapr\xf3f"
        }
    },
    en: {
        NextStepButton: {
            "N\xe6sta skref": "Next step",
            "Fara \xed krossapr\xf3f": "Go to round test"
        }
    }
};
const $1887a4ff5604fbbb$export$8ab440949452f9d9 = ({ history: history, params: params, steps: steps })=>{
    const { courseId: courseId, roundNr: roundNr } = params;
    const stepNr = parseInt(params.stepNr);
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const changeStep = (stepNr, stepId, stepStatus, roundNr, course)=>{
        if (stepStatus === null) (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/update-user-step", {
            stepId: stepId,
            stepNr: stepNr,
            roundNr: roundNr,
            course: course
        }).then((res)=>{
            res.data.stepNr = stepNr;
            history.push(`/okuskoli-${courseId}/lota-${roundNr}/skref-${stepNr}`);
        }).catch((error)=>{
            if (error) console.error(error);
        });
        else history.push(`/okuskoli-${courseId}/lota-${roundNr}/skref-${stepNr}`);
    };
    const goToNextStep = ()=>{
        if (stepNr === 10) history.push(`/okuskoli-${courseId}/lota-${roundNr}/krossaprof`);
        else {
            let stepId = null;
            let stepStatus = null;
            let nextStep = stepNr + 1;
            steps.forEach((step)=>{
                if (step.nr == nextStep) {
                    stepId = step.id;
                    stepStatus = step.user_course_round_steps[0].status;
                }
            });
            changeStep(nextStep, stepId, stepStatus, roundNr, 1);
        }
    };
    const shouldDisplayButton = (steps, stepNr)=>{
        let shouldDisplay = false;
        steps.forEach((step)=>{
            if (step.nr === stepNr) {
                if (step.user_course_round_steps[0].status === "Finished") shouldDisplay = true;
            }
        });
        return shouldDisplay;
    };
    let nextButtonText = "";
    if (stepNr < 10) nextButtonText = t("NextStepButton.N\xe6sta skref");
    else if (stepNr === 10) nextButtonText = t("NextStepButton.Fara \xed krossapr\xf3f");
    // Should display button
    const shouldDisplay = shouldDisplayButton(steps, stepNr);
    if (shouldDisplay) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("button", {
        type: "submit",
        id: "next",
        className: "btn",
        onClick: goToNextStep,
        children: [
            nextButtonText,
            " ",
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                className: "fa fa-arrow-right"
            })
        ]
    });
    return null;
};
var $1887a4ff5604fbbb$export$2e2bcd8739ae039 = $1887a4ff5604fbbb$export$8ab440949452f9d9;



parcelRequire("4hYjL");

const $c7926a8ba1268017$export$150b732325d14d04 = {
    is: {
        SubmitStepButton: {
            Svara: "Svara"
        }
    },
    en: {
        SubmitStepButton: {
            Svara: "Submit answers"
        }
    }
};
const $c7926a8ba1268017$export$9a9820d0240529ff = ({ stepId: stepId, stepNr: stepNr, steps: steps, submitAssignment: submitAssignment })=>{
    const shouldDisplay = $c7926a8ba1268017$var$shouldDisplayButton(steps, stepNr);
    const stepIndex = $c7926a8ba1268017$var$indexOfStep(steps, stepNr);
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    if (shouldDisplay) return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
        type: "submit",
        id: "answer",
        className: "btn",
        onClick: ()=>submitAssignment(steps[stepIndex], stepId),
        children: t("SubmitStepButton.Svara")
    });
    return null;
};
function $c7926a8ba1268017$var$indexOfStep(steps, stepNr) {
    let stepIndex = 0;
    steps.forEach((step, index)=>{
        if (step.nr === parseInt(stepNr)) stepIndex = index;
    });
    return stepIndex;
}
function $c7926a8ba1268017$var$shouldDisplayButton(steps, stepId) {
    let shouldDisplay = true;
    steps.forEach((step)=>{
        if (step.nr === parseInt(stepId)) {
            if (step.user_course_round_steps[0].status === "Finished") shouldDisplay = false;
        }
    });
    return shouldDisplay;
}
var $c7926a8ba1268017$export$2e2bcd8739ae039 = $c7926a8ba1268017$export$9a9820d0240529ff;




parcelRequire("4hYjL");
const $895075af5b1c20a3$var$Card = ({ children: children, className: className })=>{
    const appliedClassName = "card " + className;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        className: appliedClassName,
        children: children
    });
};
var $895075af5b1c20a3$export$2e2bcd8739ae039 = $895075af5b1c20a3$var$Card;




var $4hYjL = parcelRequire("4hYjL");
function $f5c19f13a064abcc$export$2e2bcd8739ae039(callback, delay) {
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useRef(null);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4hYjL))).useEffect(()=>{
        const tick = ()=>savedCallback.current();
        if (typeof delay === "number") {
            timeoutRef.current = window.setTimeout(tick, delay);
            return ()=>window.clearTimeout(timeoutRef.current);
        }
    }, [
        delay
    ]);
    return timeoutRef;
}




var $4hYjL = parcelRequire("4hYjL");



const $396154a05d9ea4fc$export$150b732325d14d04 = {
    is: {
        CorrectAnswers: {
            "Fela r\xe9tt svar": "Fela r\xe9tt svar",
            "S\xfdna r\xe9tt svar": "S\xfdna r\xe9tt svar",
            "R\xe9tt svar er": "R\xe9tt svar er:"
        }
    },
    en: {
        CorrectAnswers: {
            "Fela r\xe9tt svar": "Hide correct answer",
            "S\xfdna r\xe9tt svar": "Show correct answer",
            "R\xe9tt svar er": "Correct answer is:"
        }
    }
};
const $396154a05d9ea4fc$var$CorrectAnswers = ({ question: question, stepQuestion: stepQuestion = false })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [isOpen, setIsOpen] = (0, $4hYjL.useState)(false);
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    const key = stepQuestion ? "step_answers" : "answers";
    const text = isOpen ? t("CorrectAnswers.Fela r\xe9tt svar") : t("CorrectAnswers.S\xfdna r\xe9tt svar");
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        style: {
            marginTop: "7px"
        },
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                size: "small",
                text: text,
                onClick: ()=>setIsOpen((prevState)=>!prevState)
            }),
            isOpen && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    t("CorrectAnswers.R\xe9tt svar er"),
                    " "
                ]
            }),
            isOpen && question[key].map((answer, answerIndex)=>{
                const answerId = `a${answer.id}`;
                const isRight = answer.correct;
                return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                    className: `checkbox-button-container correct`,
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                        htmlFor: answerId,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                className: "checkbox-button",
                                type: "checkbox",
                                name: question.id.toString(),
                                checked: isRight,
                                disabled: true,
                                value: answer.id,
                                id: answerId
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                children: lang === "is" ? answer.answer : answer.answer_en
                            })
                        ]
                    })
                }, answerIndex);
            })
        ]
    });
};
var $396154a05d9ea4fc$export$2e2bcd8739ae039 = $396154a05d9ea4fc$var$CorrectAnswers;




var $4hYjL = parcelRequire("4hYjL");


const $05a861c4b7a7ee2e$var$axiosParams = {
    baseURL: "/api/"
};
const $05a861c4b7a7ee2e$var$axiosInstance = (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).create($05a861c4b7a7ee2e$var$axiosParams);
const $05a861c4b7a7ee2e$var$api = (axios)=>{
    return {
        get: (url, config = {})=>axios.get(url, config),
        post: (url, body, config = {})=>axios.post(url, body, config),
        patch: (url, body, config = {})=>axios.patch(url, body, config),
        delete: (url, config = {})=>axios.delete(url, config)
    };
};
var $05a861c4b7a7ee2e$export$2e2bcd8739ae039 = $05a861c4b7a7ee2e$var$api($05a861c4b7a7ee2e$var$axiosInstance);


const $aa5e023b7183ddf0$var$URLS = {
    openCourseUrl: "admin/open-course",
    closeCourseUrl: "admin/close-course",
    confirmCourse: "admin/confirm-course",
    getUserDetailsUrl: "admin/user-details",
    getUsersUrl: "admin/users",
    getUserSettingsUrl: "user-information",
    getUserTransactionsUrl: "transactions",
    userEventsUrl: "user-events"
};
const $aa5e023b7183ddf0$export$bdf060f8502bcfbd = ()=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).get($aa5e023b7183ddf0$var$URLS.getUserSettingsUrl);
};
const $aa5e023b7183ddf0$export$925a4945a6cd0f3e = ()=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).get($aa5e023b7183ddf0$var$URLS.getUsersUrl);
};
const $aa5e023b7183ddf0$export$714d3544202969b = (userId)=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).post($aa5e023b7183ddf0$var$URLS.getUserDetailsUrl, {
        userId: userId
    });
};
const $aa5e023b7183ddf0$export$5e3d0809e8b56e59 = (userId, course)=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).post($aa5e023b7183ddf0$var$URLS.closeCourseUrl, {
        course: course,
        userId: userId
    });
};
const $aa5e023b7183ddf0$export$ba609cc3d52c26c = (course, paymentType, amount, userId)=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).post($aa5e023b7183ddf0$var$URLS.openCourseUrl, {
        course: course,
        paymentType: paymentType,
        amount: amount,
        userId: userId
    });
};
const $aa5e023b7183ddf0$export$d1b79a0c9f20fdfe = (course, userId)=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).post($aa5e023b7183ddf0$var$URLS.confirmCourse, {
        course: course,
        userId: userId
    });
};
const $aa5e023b7183ddf0$export$3c1b75b9a74b445c = ()=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).get($aa5e023b7183ddf0$var$URLS.getUserTransactionsUrl);
};
const $aa5e023b7183ddf0$export$115663dc807a2e95 = ()=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).get("statistics");
};
const $aa5e023b7183ddf0$export$8e6a06772b1c34e1 = (eventType)=>{
    return (0, $05a861c4b7a7ee2e$export$2e2bcd8739ae039).post($aa5e023b7183ddf0$var$URLS.userEventsUrl, {
        event_type: eventType
    });
};


const $f0655db60c75d3e1$var$StepAudioPlayer = ({ school: school, round: round, step: step })=>{
    const audioRef = (0, $4hYjL.useRef)(null);
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    (0, $4hYjL.useEffect)(()=>{
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.load();
        }
    }, [
        school,
        round,
        step
    ]);
    const handlePlay = ()=>{
        (0, $aa5e023b7183ddf0$export$8e6a06772b1c34e1)(`PLAY_AUDIO_Ö${school}_LOTA${round}_SKREF${step}`);
    };
    console.log({
        school: school,
        round: round
    });
    if (lang === "en") return null;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "step-audio-player",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: "Hlusta\xf0u \xe1 efni\xf0"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("audio", {
                controls: true,
                ref: audioRef,
                onPlay: handlePlay,
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("source", {
                        src: `https://ub-assets.s3.eu-north-1.amazonaws.com/okuskoli${school}-lota${round}-skref${step}.mp3`,
                        type: "audio/mpeg"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                        children: [
                            "Your browser does not support HTML audio, but you can",
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                href: "audio-file.mp3",
                                children: "download the audio file here."
                            }),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
};
var $f0655db60c75d3e1$export$2e2bcd8739ae039 = $f0655db60c75d3e1$var$StepAudioPlayer;




var $4hYjL = parcelRequire("4hYjL");


parcelRequire("4hYjL");
const $86daad009a1aa110$var$capitalizeFirstLetter = (word)=>{
    return word.charAt(0).toUpperCase() + word.slice(1);
};
const $86daad009a1aa110$var$WordDefinitionModal = ({ word: word, definition: definition, imageUrl: imageUrl, position: position, width: width = 300 })=>{
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "word-definition-modal",
        style: {
            position: "absolute",
            left: position.x,
            top: position.y,
            zIndex: 1000,
            backgroundColor: "white",
            padding: "1rem",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            maxWidth: width,
            width: width,
            border: "2px solid #eab60b",
            wordBreak: "break-word"
        },
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                style: {
                    margin: "0 0 0.5rem 0",
                    color: "#444444"
                },
                children: $86daad009a1aa110$var$capitalizeFirstLetter(word)
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                style: {
                    margin: "0 0 0.5rem 0",
                    color: "#666666"
                },
                children: definition
            }),
            imageUrl && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                src: imageUrl,
                alt: `Illustration of ${word}`,
                style: {
                    width: "100%",
                    height: "auto",
                    borderRadius: "4px",
                    marginTop: "0.5rem"
                }
            })
        ]
    });
};
var $86daad009a1aa110$export$2e2bcd8739ae039 = $86daad009a1aa110$var$WordDefinitionModal;


// Define base definitions
const $63597edd6d8089de$var$baseDefinitions = {
    vegur: {
        definition: "Mannvirki \xe6tla\xf0 fyrir umfer\xf0. D\xe6mi um veg eru g\xf6tur, st\xedgar, b\xedlast\xe6\xf0i, br\xfdr, hringtorg og ne\xf0anjar\xf0arg\xf6ng."
    },
    akbraut: {
        definition: "S\xe1 hluti vegar sem \xe6tla\xf0ur er v\xe9lkn\xfanum e\xf0a \xf3v\xe9lkn\xfanum \xf6kut\xe6kjum, s.s. b\xedlum og rei\xf0hj\xf3lum."
    },
    akrein: {
        definition: "Hluti akbrautar \xfear sem einf\xf6ld r\xf6\xf0 \xf6kut\xe6kja ekur \xed eina \xe1tt. \xc1 akbraut geta veri\xf0 fleiri en ein akrein."
    },
    vegamót: {
        definition: "Sta\xf0ur \xfear sem tveir e\xf0a fleiri vegir m\xe6tast e\xf0a skerast e\xf0a \xfear sem einn vegur greinist \xed tvo e\xf0a fleiri."
    },
    vegöxl: {
        definition: "Ysti hluti vegarins me\xf0 bundnu slitlagi. \xc6tla\xf0 til a\xf0 b\xedlar geti viki\xf0 undan hra\xf0ari umfer\xf0 og st\xf6\xf0va\xf0 \xed ney\xf0artilfellum."
    },
    beygjurein: {
        definition: "Akrein sem \xf6kuma\xf0ur notar til a\xf0 beygja til vinstri gegnum umfer\xf0 \xe1 m\xf3ti."
    },
    "bundi\xf0 slitlag": {
        definition: "Slitlag er efsta lag vegar. Bundin slitl\xf6g eru t.d. slitl\xf6g \xfar steinsteypu og malbiki."
    },
    slitlagsbrún: {
        definition: "Vi\xf0 vegkantinn endar fasta slitlagi\xf0 — \xfe\xe1 erum vi\xf0 venjulega a\xf0 tala um malbik — og m\xf6l tekur vi\xf0. S\xfa br\xfan kallast slitlagsbr\xfan."
    },
    þjóðvegur: {
        definition: "A\xf0alvegur \xe6tla\xf0ur almennri umfer\xf0 utan \xfe\xe9ttb\xfdlis. \xdej\xf3\xf0vegir eru allir \xfeeir vegir sem eru (1) ekki \xed einkaeigu e\xf0a (2) ekki \xed umsj\xf3n sveitarf\xe9laga."
    },
    aðrein: {
        definition: "A\xf0rein er akrein sem liggur \xed sveig inn \xe1 akbraut."
    },
    frárein: {
        definition: "Fr\xe1rein er akrein sem liggur \xed sveig \xfat af akbraut."
    },
    hemlunarvegalengd: {
        definition: "Vegalengd sem \xf6kut\xe6ki fer fr\xe1 \xfev\xed a\xf0 b\xedlstj\xf3ri st\xedgur \xe1 bremsuna (hemlar) og \xfear til \xf6kut\xe6ki st\xf6\xf0vast."
    },
    hemlunarljós: {
        definition: "Bremsulj\xf3s."
    },
    hemla: {
        definition: "Bremsa."
    },
    vistgata: {
        definition: "\xcd vistg\xf6tum hafa gangandi vegfarendur forgang. \xdear m\xe1 ekki aka yfir 15 km / klst."
    },
    heimkeyrsla: {
        definition: "B\xedlast\xe6\xf0i og/e\xf0a vegur upp a\xf0 h\xfasi e\xf0a b\xedlsk\xfar. Sama og innkeyrsla og heimrei\xf0."
    },
    hliðarvegur: {
        definition: "Vegur \xfat fr\xe1 a\xf0alvegi, sama og afleggjari."
    },
    einbreiður: {
        definition: "Vegur e\xf0a br\xfa sem a\xf0eins eitt \xf6kut\xe6ki getur fari\xf0 eftir."
    },
    blindhæð: {
        definition: "H\xe6\xf0 \xe1 vegi svo h\xe1 a\xf0 umfer\xf0 handan hennar s\xe9st ekki."
    },
    vegsýn: {
        definition: "S\xfa fjarl\xe6g\xf0 sem b\xedlstj\xf3ri s\xe9r sk\xfdrt fram undan."
    },
    torvelda: {
        definition: "Gera erfi\xf0ara."
    },
    "handfrj\xe1ls b\xfana\xf0ar": {
        definition: "Hvers kyns b\xfana\xf0ur sem gerir b\xedlstj\xf3ra kleift a\xf0 svara, tala \xed fars\xedma \xe1n \xfeess a\xf0 nota hendurnar, t.d \xfer\xe1\xf0laus heyrnat\xf3l e\xf0a tengja fars\xedmann vi\xf0 b\xedlinn me\xf0 Bluetooth."
    },
    vegstika: {
        definition: "Gulur stafur vi\xf0 vegbr\xfan me\xf0 endurskins l\xednum (glitmerki). Stikan markar vegbr\xfan \xfeegar h\xfan s\xe9st illa vegna myrkurs, snj\xf3a e\xf0a \xfeoku."
    },
    vegbrún: {
        definition: "Kantur vegsins til beggja hli\xf0a."
    },
    glituð: {
        definition: "L\xfdsast upp \xed myrkri, endurskina."
    },
    einstefnuvegur: {
        definition: "Vegur e\xf0a gata \xfear sem umfer\xf0 liggur \xed eina \xe1tt."
    },
    torfær: {
        definition: "Erfi\xf0ur yfirfer\xf0ar."
    },
    einstefna: {
        definition: "Umfer\xf0 liggur bara \xed eina \xe1tt."
    }
};
// Map word variations to their base forms
const $63597edd6d8089de$var$wordVariations = {
    akreinin: "akrein",
    akreinar: "akrein",
    akreina: "akrein",
    vegurinn: "vegur",
    vegir: "vegur",
    vega: "vegur",
    akbrautin: "akbraut",
    akbrautir: "akbraut",
    akbrauta: "akbraut",
    vegamótið: "vegam\xf3t",
    vegamót: "vegam\xf3t",
    vegamóta: "vegam\xf3t",
    vegöxlin: "veg\xf6xl",
    vegaxlir: "veg\xf6xl",
    vegaxla: "veg\xf6xl",
    "bundna slitlagsins": "bundi\xf0 slitlag",
    "bundnu slitlagi": "bundi\xf0 slitlag",
    slitlagsbrúnina: "slitlagsbr\xfan",
    þjóðvegir: "\xfej\xf3\xf0vegur",
    þjóðvegum: "\xfej\xf3\xf0vegur",
    þjóðvegurinn: "\xfej\xf3\xf0vegur",
    þjóðvegar: "\xfej\xf3\xf0vegur",
    þjóðvega: "\xfej\xf3\xf0vegur",
    aðreinin: "a\xf0rein",
    aðreinar: "a\xf0rein",
    aðreina: "a\xf0rein",
    fráreinin: "fr\xe1rein",
    fráreinar: "fr\xe1rein",
    fráreina: "fr\xe1rein",
    hemlunarvegalengdina: "hemlunarvegalengd",
    hemlunarvegalengdir: "hemlunarvegalengd",
    hemlunarvegalengda: "hemlunarvegalengd",
    hemlunarljósin: "hemlunarlj\xf3s",
    hemlunarljós: "hemlunarlj\xf3s",
    hemlunarljósa: "hemlunarlj\xf3s",
    hemlar: "hemla",
    hemlaði: "hemla",
    hemlað: "hemla",
    vistgötur: "vistgata",
    vistgötu: "vistgata",
    vistgatan: "vistgata",
    heimkeyrslur: "heimkeyrsla",
    heimkeyrslu: "heimkeyrsla",
    heimkeyrsluna: "heimkeyrsla",
    hliðarvegar: "hli\xf0arvegur",
    hliðarvegi: "hli\xf0arvegur",
    hliðarvegurinn: "hli\xf0arvegur",
    hliðarvegum: "hli\xf0arvegur",
    hliðarvega: "hli\xf0arvegur",
    einbreiðir: "einbrei\xf0ur",
    einbreiða: "einbrei\xf0ur",
    einbreiðurinn: "einbrei\xf0ur",
    blindhæðir: "blindh\xe6\xf0",
    blindhæðar: "blindh\xe6\xf0",
    blindhæðina: "blindh\xe6\xf0",
    vegsýnið: "vegs\xfdn",
    vegsýni: "vegs\xfdn",
    vegsýnis: "vegs\xfdn",
    torveldar: "torvelda",
    torveldaði: "torvelda",
    torveldað: "torvelda",
    "handfrj\xe1ls b\xfana\xf0ar": "handfrj\xe1ls b\xfana\xf0ar",
    "handfrj\xe1lsa b\xfana\xf0urinn": "handfrj\xe1ls b\xfana\xf0ur",
    "handfrj\xe1lsa b\xfana\xf0ar": "handfrj\xe1ls b\xfana\xf0ur",
    vegstikan: "vegstika",
    vegstikur: "vegstika",
    vegstiku: "vegstika",
    vegstikum: "vegstika",
    vegbrúnar: "vegbr\xfan",
    vegbrúnir: "vegbr\xfan",
    vegbrúninni: "vegbr\xfan",
    glitandi: "glitu\xf0",
    glitir: "glitu\xf0",
    glit: "glitu\xf0",
    einstefnuvegurinn: "einstefnuvegur",
    einstefnuvegar: "einstefnuvegur",
    einstefnuvegi: "einstefnuvegur",
    einstefnuvega: "einstefnuvegur",
    torfærri: "torf\xe6r",
    torfærastur: "torf\xe6r",
    einstefnu: "einstefna",
    einstefnur: "einstefna"
};
// Helper to calculate safe modal position and width
function $63597edd6d8089de$var$getSafeModalPosition(rect) {
    let modalMaxWidth = Math.min(window.innerWidth - 16, 300);
    let left = rect.left;
    let top = rect.bottom + window.scrollY + 10;
    // If modal would overflow right, shift it left
    if (left + modalMaxWidth + 36 > window.innerWidth - 8) left = 8;
    // If modal would overflow left, align to left margin
    if (left < 8) left = 8;
    // If modal is wider than available space, shrink it
    if (modalMaxWidth > window.innerWidth - 16) {
        modalMaxWidth = window.innerWidth - 16;
        left = 8;
    }
    // Adjust if modal would overflow bottom edge
    const modalHeight = 160; // estimate
    if (top + modalHeight > window.innerHeight + window.scrollY) top = rect.top + window.scrollY - modalHeight - 10;
    return {
        x: left,
        y: top,
        width: modalMaxWidth
    };
}
const $63597edd6d8089de$var$StepContent = ({ stepData: stepData })=>{
    const [hoveredWord, setHoveredWord] = (0, $4hYjL.useState)(null);
    const [modalPosition, setModalPosition] = (0, $4hYjL.useState)({
        x: 0,
        y: 0
    });
    const [modalWidth, setModalWidth] = (0, $4hYjL.useState)(300); // default max width
    const contentRef = (0, $4hYjL.useRef)(null);
    const processedStepData = $63597edd6d8089de$var$processStepData(stepData);
    const cleanStepData = $63597edd6d8089de$var$purifyString(processedStepData);
    const handleOpenModal = (e)=>{
        if (!(e.target instanceof HTMLElement)) return;
        if (e.target.classList.contains("highlighted-word")) {
            const word = e.target.textContent?.toLowerCase() || "";
            const baseWord = $63597edd6d8089de$var$wordVariations[word] || word;
            if ($63597edd6d8089de$var$baseDefinitions[baseWord]) {
                const rect = e.target.getBoundingClientRect();
                const { x: x, y: y, width: width } = $63597edd6d8089de$var$getSafeModalPosition(rect);
                setModalWidth(width);
                setModalPosition({
                    x: x,
                    y: y
                });
                setHoveredWord(baseWord);
                e.preventDefault();
                e.stopPropagation();
            }
        } else if (!e.target.closest(".word-definition-modal")) setHoveredWord(null);
    };
    (0, $4hYjL.useEffect)(()=>{
        const handleMouseOver = (event)=>{
            const target = event.target;
            if (target instanceof HTMLElement && target.classList.contains("highlighted-word")) {
                const word = target.textContent?.toLowerCase();
                if (word) {
                    const baseWord = $63597edd6d8089de$var$wordVariations[word] || word;
                    if ($63597edd6d8089de$var$baseDefinitions[baseWord]) {
                        const rect = target.getBoundingClientRect();
                        const { x: x, y: y, width: width } = $63597edd6d8089de$var$getSafeModalPosition(rect);
                        setModalWidth(width);
                        setModalPosition({
                            x: x,
                            y: y
                        });
                        setHoveredWord(baseWord);
                    }
                }
            }
        };
        const handleMouseOut = (event)=>{
            const target = event.target;
            if (target instanceof HTMLElement && target.classList.contains("highlighted-word")) setHoveredWord(null);
        };
        // Add mouseover/mouseout event listeners
        const contentElement = contentRef.current;
        if (contentElement) {
            contentElement.addEventListener("mouseover", handleMouseOver);
            contentElement.addEventListener("mouseout", handleMouseOut);
        }
        return ()=>{
            if (contentElement) {
                contentElement.removeEventListener("mouseover", handleMouseOver);
                contentElement.removeEventListener("mouseout", handleMouseOut);
            }
        };
    }, []);
    // Add a document-level click handler that closes the modal when clicking outside
    (0, $4hYjL.useEffect)(()=>{
        const handleDocumentClick = (e)=>{
            if (!(e.target instanceof HTMLElement)) return;
            if (hoveredWord && // Modal is open
            !e.target.closest(".word-definition-modal") && !e.target.classList.contains("highlighted-word")) setHoveredWord(null);
        };
        document.addEventListener("click", handleDocumentClick);
        return ()=>{
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [
        hoveredWord
    ]);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "lotu-content",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                ref: contentRef,
                onClick: handleOpenModal,
                dangerouslySetInnerHTML: {
                    __html: cleanStepData
                }
            }),
            hoveredWord && $63597edd6d8089de$var$baseDefinitions[hoveredWord] && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $86daad009a1aa110$export$2e2bcd8739ae039), {
                word: hoveredWord,
                definition: $63597edd6d8089de$var$baseDefinitions[hoveredWord].definition,
                imageUrl: $63597edd6d8089de$var$baseDefinitions[hoveredWord].imageUrl,
                position: modalPosition,
                width: modalWidth
            })
        ]
    });
};
const $63597edd6d8089de$var$processStepData = (string)=>{
    if (string === null) return null;
    // Create a map to track which base words have been found
    const foundBaseWords = new Set();
    let processedString = string;
    // Create a combined map of all words and their base forms
    const allWords = new Map();
    // Add base words
    Object.keys($63597edd6d8089de$var$baseDefinitions).forEach((word)=>{
        allWords.set(word.toLowerCase(), word);
    });
    // Add variations
    Object.entries($63597edd6d8089de$var$wordVariations).forEach(([variation, baseWord])=>{
        allWords.set(variation.toLowerCase(), baseWord);
    });
    // Find all word matches in order of appearance
    const matches = [];
    allWords.forEach((baseWord, word)=>{
        // Use a custom word boundary pattern that includes Icelandic characters
        const regex = new RegExp(`(?<![a-zA-ZáéíóúýþæöðÁÉÍÓÚÝÞÆÖÐ])${word}(?![a-zA-ZáéíóúýþæöðÁÉÍÓÚÝÞÆÖÐ])`, "gi");
        let match;
        while((match = regex.exec(processedString)) !== null)matches.push({
            word: match[0],
            baseWord: baseWord,
            index: match.index
        });
    });
    // Sort matches by their position in the text
    matches.sort((a, b)=>a.index - b.index);
    // Process matches in order, skipping if base word was already found
    let offset = 0;
    matches.forEach(({ word: word, baseWord: baseWord, index: index })=>{
        if (foundBaseWords.has(baseWord)) return;
        const start = index + offset;
        const end = start + word.length;
        const before = processedString.slice(0, start);
        const after = processedString.slice(end);
        const highlighted = `<span class="highlighted-word" role="button" tabindex="0">${word}</span>`;
        processedString = before + highlighted + after;
        offset += highlighted.length - word.length;
        foundBaseWords.add(baseWord);
    });
    return processedString;
};
const $63597edd6d8089de$var$purifyString = (string)=>{
    if (string === null) return "";
    return (0, (/*@__PURE__*/$parcel$interopDefault($7342b9d25afc8814$exports))).sanitize(string, {
        ADD_TAGS: [
            "iframe",
            "span"
        ],
        ADD_ATTR: [
            "allow",
            "allowfullscreen",
            "frameborder",
            "scrolling",
            "class",
            "role",
            "tabindex"
        ]
    });
};
var $63597edd6d8089de$export$2e2bcd8739ae039 = $63597edd6d8089de$var$StepContent;


const $1de63c28c2a63f69$export$150b732325d14d04 = {
    is: {
        Step: {
            spurningu: "spurningu",
            spurningum: "spurningum",
            "\xde\xfa \xe1tt eftir a\xf0 svara": "\xde\xfa \xe1tt eftir a\xf0 svara",
            Skref: "Skref",
            Verkefni: "Verkefni",
            "\xdearftu a\xf0sto\xf0? Sendu t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is": "\xdearftu a\xf0sto\xf0? Sendu t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is",
            Lota: "Lota",
            Ö: "\xd6"
        }
    },
    en: {
        Step: {
            spurningu: "question",
            spurningum: "questions",
            "\xde\xfa \xe1tt eftir a\xf0 svara": "You have yet to answer",
            Skref: "Step",
            Verkefni: "Question",
            "\xdearftu a\xf0sto\xf0? Sendu t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is": "Need help? Send an email to hallo@urdarbrunnur.is",
            Lota: "Round",
            Ö: "DS"
        }
    }
};
const $1de63c28c2a63f69$var$Step = ({ authReducer: authReducer, dispatch: dispatch, match: match, history: history })=>{
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)(null);
    const { roundNr: roundNr, stepNr: stepNr, courseId: courseId } = match.params;
    const { t: t, i18n: i18n } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const { language: language } = i18n;
    (0, $4hYjL.useEffect)(()=>{
        fetchRoundData();
        updateStepStatusIfEmpty();
        updateRoundStatusIfEmpty();
    }, []);
    // Why so many? Because there was a bug that was caused
    // By users not having a user_round set up. When the step answer
    // Was submitted it would put them into a bad state where
    // They weren't able to procede with the course.
    // No good. So this is the solution, a bit excessive, but there you are.
    (0, $f5c19f13a064abcc$export$2e2bcd8739ae039)(()=>{
        updateRoundStatusIfEmpty();
        updateStepStatusIfEmpty();
    }, 3000);
    (0, $f5c19f13a064abcc$export$2e2bcd8739ae039)(()=>{
        updateRoundStatusIfEmpty();
        updateStepStatusIfEmpty();
    }, 10000);
    (0, $4hYjL.useEffect)(()=>{
        updateRoundStatusIfEmpty();
        updateStepStatusIfEmpty();
    }, [
        stepNr
    ]);
    (0, $4hYjL.useEffect)(()=>{
        fetchRoundData();
        updateStepStatusIfEmpty();
        updateRoundStatusIfEmpty();
    }, [
        roundNr,
        courseId
    ]);
    // This is here so that no user round has an empty start_time.
    const updateRoundStatusIfEmpty = ()=>{
        const { userRounds: userRounds } = authReducer;
        userRounds.forEach((round)=>{
            // If round is current round and startime is empty
            if (parseInt(roundNr) === round.nr && round.start_time === null && parseInt(courseId) === round.course_id) // Add a start time.
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/update-user-round", {
                roundId: round.round_id,
                roundNr: parseInt(roundNr)
            }).then(()=>{
                updateStepStatusIfEmpty();
            }).catch((error)=>{
                if (error) console.error(error);
            });
        });
    };
    const updateStepStatusIfEmpty = ()=>{
        const { steps: steps } = authReducer;
        // Get step status and id
        let stepId = 1;
        let stepStatus = "Ongoing";
        steps.forEach((step)=>{
            if (step.nr === parseInt(stepNr)) {
                stepId = step.id;
                stepStatus = step.user_course_round_steps[0].status;
            }
        });
        if (stepStatus === null) // start the step by sending a msg to the server
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/update-user-step", {
            stepId: stepId,
            stepNr: parseInt(stepNr),
            roundNr: parseInt(roundNr),
            course: parseInt(courseId)
        }).catch((error)=>{
            if (error) console.error(error);
        });
    };
    const fetchRoundData = ()=>{
        const { roundNr: roundNr, stepNr: stepNr, courseId: courseId } = match.params;
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get(`/api/round-data?round=${roundNr}&step=${stepNr}&course=${courseId}`).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$5ed101c55fc6dd45)({
                ...res.data
            }));
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    const submitStepAnswers = (answers, stepId)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/submit-step-answers", {
            answers: answers,
            stepId: stepId
        }).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$7c7f0a18499ed7a)(res.data));
            setErrorMessage(null);
            // This is a bandaid solution.
            // When there are two questions doing the state updates
            // gets quite tough, so in order to avoid a bug where only
            // the first question gets feedback sent back to it
            // The code below checks if there were two questions answered, if so we
            // fetch the relevant data and render the correct feedback.
            let firstId = null;
            answers.forEach((answer)=>{
                // if no id has been sought, pick this first one.
                if (firstId === null) firstId = answer.questionId;
                // If saved id isn't same as the answer.id then reload page to bring in the fresh data.
                if (firstId !== answer.questionId) fetchRoundData();
            });
        }).catch((error)=>{
            setErrorMessage(JSON.stringify(error));
            console.error(error);
        });
    };
    const answerSelected = (e)=>{
        dispatch((0, $d599c499e9218b1e$export$6ccc133bc14293ea)({
            answerId: e.target.value,
            questionId: e.currentTarget.name,
            id: e.currentTarget.id,
            checked: e.target.checked
        }));
    };
    const submitAssignment = (step, stepId)=>{
        const { stepAnswers: stepAnswers } = authReducer;
        // Check if there are unanswered questions
        if (stepAnswers.length < step.step_questions.length) {
            const unansweredQuestions = [];
            step.step_questions.forEach((question, index)=>{
                let hasBeenAnswered = false;
                stepAnswers.forEach(function(answer) {
                    if (question.id.toString() === answer.questionId) hasBeenAnswered = true;
                });
                if (hasBeenAnswered == false) unansweredQuestions.push(index + 1);
            });
            const count = unansweredQuestions.length === 1 ? t("Step.spurningu") : t("Step.spurningum");
            const message = `${t("Step.\xde\xfa \xe1tt eftir a\xf0 svara")} ${count} ${unansweredQuestions.toString()}`;
            setErrorMessage(message);
        } else submitStepAnswers(stepAnswers, stepId);
    };
    let stepQuestionRows = null;
    let stepData = null;
    let stepId = null;
    authReducer.steps.forEach((step)=>{
        if (step.nr === parseInt(stepNr)) {
            if (step.step_questions.length > 0) stepQuestionRows = step.step_questions.map((question, index)=>{
                let imageRows = null;
                if (question.question_images !== null) {
                    imageRows = question.question_images.map((image, imageIndex)=>{
                        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                                src: "/images/skilti/" + image.filename,
                                height: "75",
                                width: "75"
                            })
                        }, `image-${imageIndex}`);
                    });
                    imageRows = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        children: imageRows
                    });
                }
                const stepFinished = typeof question.user_step_answers !== "undefined" && question.user_step_answers.length > 0;
                let anyWrong = false;
                const stepAnswerRows = question.step_answers.map((answer, subIndex)=>{
                    let disabled = false;
                    let checked = false;
                    let answerClass = null;
                    // If the user has submitted the answers
                    if (stepFinished) {
                        question.user_step_answers.forEach((stepAnswer)=>{
                            disabled = true;
                            if (stepAnswer.step_answer_id === answer.id) {
                                checked = true;
                                if (answer.correct) answerClass = "correct";
                                else {
                                    answerClass = "wrong";
                                    anyWrong = true;
                                }
                            }
                        });
                        if (answerClass === null) {
                            // If question hasn't been evaluated, check it
                            if (answer.correct) {
                                answerClass = "wrong";
                                anyWrong = true;
                            } else answerClass = "correct";
                        }
                    } else authReducer.stepAnswers.forEach((userAnswer)=>{
                        if (userAnswer.questionId === question.id.toString()) {
                            if (userAnswer.answerId === answer.id.toString()) checked = true;
                        }
                    });
                    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                            className: "checkbox-button-container " + answerClass,
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                                className: "step-test-label",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                        type: "checkbox",
                                        name: question.id.toString(),
                                        value: answer.id,
                                        disabled: disabled,
                                        checked: checked,
                                        onChange: answerSelected
                                    }),
                                    language === "is" ? answer.answer : answer.answer_en
                                ]
                            })
                        })
                    }, subIndex);
                });
                const questionText = language === "is" ? question.question : question.question_en;
                return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "step-test-container",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                            className: "step-test-question",
                            children: index + 1 + ". " + questionText
                        }),
                        imageRows,
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
                            className: "questionRow-ul",
                            children: [
                                stepAnswerRows,
                                stepFinished && anyWrong ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $396154a05d9ea4fc$export$2e2bcd8739ae039), {
                                    question: question,
                                    stepQuestion: true
                                }) : null
                            ]
                        })
                    ]
                }, index);
            });
            stepData = language === "is" ? step.data : step.data_en;
            stepId = step.id;
        }
    }, undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($7342b9d25afc8814$exports))).addHook("uponSanitizeElement", (node, data)=>{
        if (data.tagName === "iframe") {
            const src = node.getAttribute("src") || "";
            if (!src.startsWith("https://www.youtube.com/embed/")) {
                if (node.parentNode) return node.parentNode.removeChild(node);
            }
        }
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: courseId,
        title: `${t("Step.Lota")} ${roundNr} | ${t("Step.\xd6")}${courseId}`,
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: t(`RoundTitles.Ö${courseId}L${roundNr}`)
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                        className: "step",
                        children: [
                            `${t("Step.Lota")} ${roundNr}`,
                            " — ",
                            t("Step.Skref"),
                            " ",
                            stepNr,
                            "/10"
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $f0655db60c75d3e1$export$2e2bcd8739ae039), {
                        school: courseId,
                        round: roundNr,
                        step: stepNr
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $63597edd6d8089de$export$2e2bcd8739ae039), {
                        stepData: stepData
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                children: stepQuestionRows ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                            children: t("Step.Verkefni")
                                        }),
                                        stepQuestionRows
                                    ]
                                }) : null
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                className: "erorr-message-container",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                className: "btn-div",
                                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $c7926a8ba1268017$export$9a9820d0240529ff), {
                                    stepId: stepId,
                                    stepNr: match.params.stepNr,
                                    submitAssignment: submitAssignment,
                                    steps: authReducer.steps
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5dbd16c7c4c8c597$export$dc262acb21978b1a), {
                        history: history,
                        params: match.params
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1887a4ff5604fbbb$export$8ab440949452f9d9), {
                        history: history,
                        params: match.params,
                        steps: authReducer.steps
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "get-help-text",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                            children: t("Step.\xdearftu a\xf0sto\xf0? Sendu t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is")
                        })
                    })
                ]
            })
        ]
    });
};
const $1de63c28c2a63f69$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $1de63c28c2a63f69$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($1de63c28c2a63f69$var$mapStateToProps)($1de63c28c2a63f69$var$Step);




var $4hYjL = parcelRequire("4hYjL");





parcelRequire("4hYjL");


parcelRequire("4hYjL");


// This receives 1 question and the 2 - 4 question answers associated with it.
const $43fe0dd29818e17c$var$AnswerCheckboxes = ({ question: question, testAnswers: testAnswers, userTest: userTest, disabled: disabled, answerSelected: answerSelected })=>{
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    let wasQuestionWrong = false;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("ul", {
        className: "answerRows",
        children: [
            question.answers.map((answer, answerIndex)=>{
                let checked = false;
                let answerClass = null;
                // The thing below does two things:
                // 1. Updates UI when answers are checked in the UI
                // 2. Checks if answers are correct when test is submitted.
                testAnswers?.forEach((userAnswer)=>{
                    if (parseInt(userAnswer.answerId) === answer.id) {
                        checked = true; // If a answer has been checked, reflect that in UI.
                        if (typeof answer.correct !== "undefined" && userTest.status === "Finished") {
                            answerClass = answer.correct ? "correct" : "wrong";
                            if (answer.correct === false) wasQuestionWrong = true;
                        }
                    }
                });
                // Evaluate non-checked answers, are they correct or not?
                if (userTest.status === "Finished" && answerClass === null) {
                    answerClass = answer.correct ? "wrong" : "correct";
                    if (answer.correct === true) wasQuestionWrong = true;
                }
                const answerId = `a${answer.id}`;
                return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("li", {
                    className: `checkbox-button-container ${answerClass}`,
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                        htmlFor: answerId,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                className: "checkbox-button",
                                type: "checkbox",
                                name: question.id.toString(),
                                checked: checked,
                                disabled: disabled,
                                value: answer.id,
                                id: answerId,
                                onChange: answerSelected
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                children: lang === "is" ? answer.answer : answer.answer_en
                            })
                        ]
                    })
                }, answerIndex);
            }),
            wasQuestionWrong && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $396154a05d9ea4fc$export$2e2bcd8739ae039), {
                question: question
            })
        ]
    });
};
var $43fe0dd29818e17c$export$2e2bcd8739ae039 = $43fe0dd29818e17c$var$AnswerCheckboxes;



parcelRequire("4hYjL");
const $6dd4b4ffab7e2185$var$QuestionImages = ({ questionImages: questionImages })=>{
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
        children: questionImages.map((image)=>{
            return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                    src: `/images/skilti/${image.filename}`,
                    height: "75",
                    width: "75"
                })
            }, image.id);
        })
    });
};
var $6dd4b4ffab7e2185$export$2e2bcd8739ae039 = $6dd4b4ffab7e2185$var$QuestionImages;



const $1f31a53319231dae$export$d235e49c9f14be16 = ({ testAnswers: testAnswers, userTest: userTest, disabled: disabled, test: test, answerSelected: answerSelected, testType: testType })=>{
    const totalQuestions = testType === "FinalTest" ? 30 : 10;
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
        children: test.questions.slice(0, totalQuestions).map((question, index)=>{
            const { question_images: question_images, id: id } = question;
            const hasImages = question_images.length ? true : false;
            const initialQuestionText = lang === "is" ? question.question : question.question_en;
            const questionText = `${index + 1}. ${initialQuestionText}`;
            return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                className: "mg-bottom-10",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                            children: questionText
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                            children: hasImages && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6dd4b4ffab7e2185$export$2e2bcd8739ae039), {
                                questionImages: question_images
                            })
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $43fe0dd29818e17c$export$2e2bcd8739ae039), {
                            question: question,
                            testAnswers: testAnswers,
                            userTest: userTest,
                            disabled: disabled,
                            answerSelected: answerSelected
                        })
                    ]
                })
            }, id);
        })
    });
};
var $1f31a53319231dae$export$2e2bcd8739ae039 = $1f31a53319231dae$export$d235e49c9f14be16;



const $fd548af5d0a2aad5$export$150b732325d14d04 = {
    is: {
        Test: {
            Svara: "Svara",
            "Taka aftur": "Taka aftur",
            "Til baka": "Til baka",
            Lota: "Lota",
            Krossapróf: "Krossapr\xf3f",
            Próf: "Pr\xf3f",
            "Vi\xf0 hverja spurningu getur veri\xf0 fleiri en eitt svar": "Vi\xf0 hverja spurningu getur veri\xf0 fleiri en eitt svar.",
            "Til \xfeess a\xf0 lj\xfaka lotunni \xfearf a\xf0 svara \xf6llum spurningunum r\xe9tt. En \xfe\xfa getur endurteki\xf0 krossapr\xf3fi\xf0 eins oft og \xfe\xfa vilt": "Til \xfeess a\xf0 lj\xfaka lotunni \xfearf a\xf0 svara \xf6llum spurningunum r\xe9tt. En \xfe\xfa getur endurteki\xf0 krossapr\xf3fi\xf0 eins oft og \xfe\xfa vilt.",
            "Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 lotu": "Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 lotu",
            "Fara \xed lokapr\xf3f": "Fara \xed lokapr\xf3f",
            "Aftur \xe1 fors\xed\xf0u": "Aftur \xe1 fors\xed\xf0u",
            "\xde\xfa varst me\xf0": "\xde\xfa varst me\xf0",
            "\xde\xfa \xe1tt eftir a\xf0 svara": "\xde\xfa \xe1tt eftir a\xf0 svara",
            spurningu: "spurningu",
            spurningum: "spurningum",
            villur: " villur",
            villu: " villu"
        }
    },
    en: {
        Test: {
            Svara: "Submit answers",
            "Taka aftur": "Repeat test",
            "Til baka": "Back",
            Lota: "Round",
            Krossapróf: "Test",
            Próf: "Test",
            "Vi\xf0 hverja spurningu getur veri\xf0 fleiri en eitt svar": "Each question can have multiple correct answers.",
            "Til \xfeess a\xf0 lj\xfaka lotunni \xfearf a\xf0 svara \xf6llum spurningunum r\xe9tt. En \xfe\xfa getur endurteki\xf0 krossapr\xf3fi\xf0 eins oft og \xfe\xfa vilt": "You have to answer all the questions correctly to finish the round. But you can repeat the test as often as you need to.",
            "Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 lotu": "Well done! You answered all the questions correctly and have now finished round",
            "Fara \xed lokapr\xf3f": "Go to final test",
            "Aftur \xe1 fors\xed\xf0u": "Back to dashboard",
            "\xde\xfa varst me\xf0": "You had",
            "\xde\xfa \xe1tt eftir a\xf0 svara": "You haven't answered questions",
            spurningu: "spurningu",
            spurningum: "spurningum",
            villur: " incorrect answers",
            villu: " incorrect answer"
        }
    }
};
const $fd548af5d0a2aad5$var$SubmitTestButton = ({ submitTest: submitTest, isTestFinished: isTestFinished })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    if (isTestFinished) return null;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
        type: "submit",
        id: "submitTest",
        className: "btn",
        onClick: submitTest,
        children: t("Test.Svara")
    });
};
const $fd548af5d0a2aad5$var$RetakeTestButton = ({ retakeTest: retakeTest, isTestFinished: isTestFinished })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    if (!isTestFinished) return null;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
        type: "submit",
        id: "retake",
        className: "btn",
        onClick: retakeTest,
        children: t("Test.Taka aftur")
    });
};
const $fd548af5d0a2aad5$var$Test = ({ match: match, dispatch: dispatch, authReducer: authReducer, history: history })=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)(null);
    const { testAnswers: testAnswers, userTest: userTest, wrongTestAnswers: wrongTestAnswers, userRounds: userRounds } = authReducer;
    const { courseId: courseId, roundNr: roundNr } = match.params;
    (0, $4hYjL.useEffect)(()=>{
        fetchTestQuestions();
    }, []);
    const fetchTestQuestions = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get(`/api/test?course=${courseId}&round=${roundNr}`).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$ec90248895f5633c)({
                ...res.data
            }));
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    const answerSelected = (e)=>{
        dispatch((0, $d599c499e9218b1e$export$ddd53d3c42320cfc)({
            testAnswerId: e.target.value,
            testQuestionId: e.currentTarget.name,
            testId: e.currentTarget.id,
            testChecked: e.target.checked
        }));
    };
    const prevStep = ()=>{
        history.push(`/okuskoli-${courseId}/lota-${roundNr}/skref-10`);
    };
    const getRoundId = ()=>{
        let roundId;
        userRounds.forEach((round)=>{
            const { course_id: course_id, round_id: round_id, nr: nr } = round;
            if (course_id === parseInt(courseId) && nr === parseInt(roundNr)) roundId = round_id;
        });
        return roundId;
    };
    const submitTest = ()=>{
        // If there are unanswered questions
        if (testAnswers.length < 10) {
            const unansweredQuestions = [];
            authReducer.test[0].questions.forEach((question, index)=>{
                let hasBeenAnswered = false;
                testAnswers.forEach(function(answer) {
                    if (question.id.toString() === answer.questionId) hasBeenAnswered = true;
                });
                if (hasBeenAnswered == false) {
                    const questionNumber = index + 1;
                    unansweredQuestions.push(" " + questionNumber);
                }
            });
            const tmp = unansweredQuestions.length === 1 ? t("Test.spurningu") : t("Test.spurningum");
            const message = `${t("Test.\xde\xfa \xe1tt eftir a\xf0 svara")} ${tmp} ${unansweredQuestions.toString()}`;
            setErrorMessage(message);
        } else {
            const testId = authReducer.test[0].id;
            const roundId = getRoundId();
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/submit-test`, {
                answers: testAnswers,
                testId: testId,
                userTestId: userTest.id,
                roundId: roundId
            }).then((res)=>{
                dispatch((0, $d599c499e9218b1e$export$452251d610794bde)({
                    ...res.data,
                    roundNr: roundNr
                }));
            }).catch((error)=>{
                console.error(error.response);
            });
        }
    };
    const retakeTest = ()=>fetchTestQuestions();
    const goToFinalTest = ()=>history.push(`/okuskoli-${courseId}/lokaprof`);
    let disabled = false;
    if (userTest !== null && userTest.status == "Finished") disabled = true;
    const test = authReducer.test[0];
    let wrongAnswers = null;
    let roundFinishedFeedback = null;
    let roundFinishedButton = null;
    if (wrongTestAnswers !== null && wrongTestAnswers > 0) {
        let wrongAnswerCount = t("Test.villur");
        if (wrongTestAnswers == 1) wrongAnswerCount = t("Test.villu");
        wrongAnswers = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "negative-alert",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                        className: "fa fa-frown-o"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                        children: `${t("Test.\xde\xfa varst me\xf0")} ${wrongTestAnswers} ${wrongAnswerCount}`
                    })
                ]
            })
        });
    } else if (userTest.status === "Finished") userRounds.forEach((round)=>{
        if (round.nr === parseInt(roundNr)) {
            if (round.status === "Finished") {
                roundFinishedFeedback = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    className: "positive-alert",
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                className: "fa fa-smile-o"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                children: `${t("Test.Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 lotu")} ${parseInt(roundNr)}!`
                            })
                        ]
                    })
                });
                if (parseInt(roundNr) === 6) roundFinishedButton = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                    type: "submit",
                    id: "goToFinalTest",
                    className: "btn",
                    onClick: goToFinalTest,
                    children: t("Test.Fara \xed lokapr\xf3f")
                });
                else roundFinishedButton = // It's an <a> tag for a reason - changing to other will introduce bug.
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                    href: "/okuskoli-" + courseId,
                    id: "backToMain",
                    className: "btn",
                    children: t("Test.Aftur \xe1 fors\xed\xf0u")
                });
            }
        }
    });
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: courseId,
        title: `${t("Test.Pr\xf3f")} | ${t("Test.Lota")} ${roundNr} | Ö${courseId}`,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "test-container",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h2", {
                    children: [
                        t("Test.Lota"),
                        " ",
                        roundNr,
                        " | ",
                        t("Test.Krossapr\xf3f")
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Test.Vi\xf0 hverja spurningu getur veri\xf0 fleiri en eitt svar")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Test.Til \xfeess a\xf0 lj\xfaka lotunni \xfearf a\xf0 svara \xf6llum spurningunum r\xe9tt. En \xfe\xfa getur endurteki\xf0 krossapr\xf3fi\xf0 eins oft og \xfe\xfa vilt")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("ul", {
                    className: "questionRow-ul",
                    children: test && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1f31a53319231dae$export$2e2bcd8739ae039), {
                        testAnswers: testAnswers,
                        userTest: userTest,
                        disabled: disabled,
                        test: test,
                        answerSelected: answerSelected,
                        testType: "RoundTest"
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                        children: errorMessage
                    })
                }),
                wrongAnswers,
                roundFinishedFeedback,
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "btn-div",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                            type: "submit",
                            id: "previous",
                            className: "btn",
                            onClick: prevStep,
                            children: t("Test.Til baka")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($fd548af5d0a2aad5$var$SubmitTestButton, {
                            submitTest: submitTest,
                            isTestFinished: userTest.status === "Finished"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($fd548af5d0a2aad5$var$RetakeTestButton, {
                            retakeTest: retakeTest,
                            isTestFinished: userTest.status === "Finished"
                        }),
                        roundFinishedButton
                    ]
                })
            ]
        })
    });
};
const $fd548af5d0a2aad5$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $fd548af5d0a2aad5$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($fd548af5d0a2aad5$var$mapStateToProps)($fd548af5d0a2aad5$var$Test);




var $4hYjL = parcelRequire("4hYjL");






const $a8351bf3e56b1846$export$150b732325d14d04 = {
    is: {
        FinalTest: {
            MetaTitle: "Lokapr\xf3f \xd6",
            "\xde\xfa \xe1tt eftir a\xf0 svara": "\xde\xfa \xe1tt eftir a\xf0 svara",
            spurningu: "spurningu",
            spurningum: "spurningum",
            "Lokapr\xf3f \xd6kusk\xf3la": "Lokapr\xf3f \xd6kusk\xf3la",
            "\xde\xfa m\xe1tt ekki f\xe1 fleiri en 3 villur til a\xf0 n\xe1 pr\xf3finu": "\xde\xfa m\xe1tt ekki f\xe1 fleiri en 3 villur til a\xf0 n\xe1 pr\xf3finu.",
            "Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 \xd6kusk\xf3la": "Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 \xd6kusk\xf3la",
            "Halda \xe1fram": "Halda \xe1fram",
            "Vel gert! \xde\xfa n\xe1\xf0ir lokapr\xf3finu og hefur n\xfa loki\xf0 \xd6kusk\xf3la": "Vel gert! \xde\xfa n\xe1\xf0ir lokapr\xf3finu og hefur n\xfa loki\xf0 \xd6kusk\xf3la",
            "\xde\xfa varst me\xf0": "\xde\xfa varst me\xf0",
            villu: "villu",
            villur: "villur",
            "Taka aftur": "Taka aftur",
            Svara: "Svara"
        }
    },
    en: {
        FinalTest: {
            MetaTitle: "Final Test DS",
            "\xde\xfa \xe1tt eftir a\xf0 svara": "You haven't answered",
            spurningu: "question",
            spurningum: "questions",
            "Lokapr\xf3f \xd6kusk\xf3la": "Final Test - Driving School",
            "\xde\xfa m\xe1tt ekki f\xe1 fleiri en 3 villur til a\xf0 n\xe1 pr\xf3finu": "To pass the final test you can't have more than 3 wrong answers.",
            "Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 \xd6kusk\xf3la": "Well done! You answered all the questions correctly and have now finished Driving School",
            "Halda \xe1fram": "Continue",
            "Vel gert! \xde\xfa n\xe1\xf0ir lokapr\xf3finu og hefur n\xfa loki\xf0 \xd6kusk\xf3la": "Well done! You passed the final test and have now finished Driving School",
            "\xde\xfa varst me\xf0": "You had",
            villu: "wrong answer",
            villur: "wrong answers",
            "Taka aftur": "Try again",
            Svara: "Answer"
        }
    }
};
const $a8351bf3e56b1846$var$FinalTest = ({ authReducer: authReducer, dispatch: dispatch, match: match, history: history })=>{
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)("");
    const { courseId: courseId } = match.params;
    const { userTest: userTest, wrongTestAnswers: wrongTestAnswers, finalTestAnswers: finalTestAnswers, finalTest: finalTest } = authReducer;
    const test = authReducer.finalTest[0];
    const { status: status } = userTest;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    (0, $4hYjL.useEffect)(()=>{
        fetchTestQuestions();
    }, []);
    const fetchTestQuestions = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get(`/api/final-test?course=${courseId}&startTest=true`).then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$449c4f626b590da7)({
                finalTest: res.data.finalTest,
                userTest: res.data.userTest
            }));
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    const answerSelected = (e)=>{
        const answerId = e.target.value;
        const questionId = e.currentTarget.name;
        dispatch((0, $d599c499e9218b1e$export$98e618dfde36167e)({
            ftestAnswerId: answerId,
            ftestQuestionId: questionId,
            ftestChecked: e.target.checked
        }));
    };
    const displayValidationError = ()=>{
        const unansweredQuestions = [];
        // Build a list of the unanswered question id's
        finalTest[0].questions.forEach((question, index)=>{
            let hasBeenAnswered = false;
            finalTestAnswers.forEach((answer)=>{
                if (question.id === parseInt(answer.questionId)) hasBeenAnswered = true;
            });
            if (!hasBeenAnswered) unansweredQuestions.push(" " + (index + 1));
        });
        const questionsString = unansweredQuestions.length === 1 ? t("FinalTest.spurningu") : t("FinalTest.spurningum");
        const message = `${t("FinalTest.\xde\xfa \xe1tt eftir a\xf0 svara")} ${questionsString} ${unansweredQuestions.toString()}`;
        setErrorMessage(message);
    };
    const submitTest = ()=>{
        // Check if there are unanswered questions
        if (finalTestAnswers.length < 30) displayValidationError();
        else {
            const testId = authReducer.finalTest[0].id;
            const userTestId = authReducer.userTest.id;
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/submit-final-test", {
                answers: finalTestAnswers,
                testId: testId,
                userTestId: userTestId,
                course: parseInt(courseId)
            }).then((res)=>{
                dispatch((0, $d599c499e9218b1e$export$e435712bd7e75690)({
                    ...res.data
                }));
            }).catch((error)=>{
                console.error(error.response);
            });
        }
    };
    const retakeTest = ()=>fetchTestQuestions();
    const forward = ()=>history.push(`/okuskoli-${courseId}/vel-gert`);
    let submitTestButton = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
        type: "submit",
        id: "submitTest",
        value: t("FinalTest.Svara"),
        className: "btn",
        onClick: submitTest
    });
    let retakeTestButton = null;
    let disabled = false;
    if (userTest !== null && status === "Finished") {
        disabled = true;
        submitTestButton = null;
        retakeTestButton = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
            type: "submit",
            id: "retake",
            value: t("FinalTest.Taka aftur"),
            className: "btn",
            onClick: retakeTest
        });
    }
    let wrongAnswers = null;
    let maxErrors = null;
    let roundFinished = null;
    let roundFinishedButton = null;
    let isTestSubmitted = false;
    if (wrongTestAnswers !== null) isTestSubmitted = true;
    // Test has been submitted and if there was more than 0 wrong answers
    if (isTestSubmitted && wrongTestAnswers !== null && wrongTestAnswers > 0) {
        let wrongAnswerCount = " " + t("FinalTest.villur");
        if (wrongTestAnswers === 1) wrongAnswerCount = " " + t("FinalTest.villu");
        wrongAnswers = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            children: t("FinalTest.\xde\xfa varst me\xf0") + " " + authReducer.wrongTestAnswers + " " + wrongAnswerCount
        });
        if (wrongTestAnswers < 4) {
            roundFinished = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "positive-alert",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: `${t("FinalTest.Vel gert! \xde\xfa n\xe1\xf0ir lokapr\xf3finu og hefur n\xfa loki\xf0 \xd6kusk\xf3la")} ${courseId}!`
                })
            });
            roundFinishedButton = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                type: "submit",
                id: "forward",
                value: t("FinalTest.Halda \xe1fram"),
                className: "btn",
                onClick: forward
            });
        } else maxErrors = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "negative-alert",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("FinalTest.\xde\xfa m\xe1tt ekki f\xe1 fleiri en 3 villur til a\xf0 n\xe1 pr\xf3finu")
            })
        });
    } else if (isTestSubmitted && wrongTestAnswers === 0) {
        // If all answers were answered right then show this message.
        roundFinished = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "positive-alert",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: `${t("FinalTest.Vel gert! \xde\xfa svara\xf0ir \xf6llum spurningum r\xe9tt og hefur n\xfa loki\xf0 \xd6kusk\xf3la")} ${courseId}!`
            })
        });
        roundFinishedButton = /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
            type: "submit",
            id: "forward",
            value: t("FinalTest.Halda \xe1fram"),
            className: "btn",
            onClick: forward
        });
    }
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: courseId,
        title: `${t("FinalTest.MetaTitle")}${courseId}`,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "test-container",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h1", {
                    children: [
                        t("FinalTest.Lokapr\xf3f \xd6kusk\xf3la"),
                        " ",
                        courseId
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("ul", {
                    className: "questionRow-ul",
                    children: test && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $1f31a53319231dae$export$d235e49c9f14be16), {
                        testAnswers: finalTestAnswers,
                        userTest: userTest,
                        disabled: disabled,
                        test: test,
                        answerSelected: answerSelected,
                        testType: "FinalTest"
                    })
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                    children: errorMessage
                }),
                wrongAnswers,
                maxErrors,
                roundFinished,
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "btn-div",
                    children: [
                        submitTestButton,
                        retakeTestButton,
                        roundFinishedButton
                    ]
                })
            ]
        })
    });
};
const $a8351bf3e56b1846$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $a8351bf3e56b1846$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($a8351bf3e56b1846$var$mapStateToProps)($a8351bf3e56b1846$var$FinalTest);



parcelRequire("4hYjL");





var $4hYjL = parcelRequire("4hYjL");




const $602e0fce79bb6fe6$export$150b732325d14d04 = {
    is: {
        MagnetForm: {
            "F\xe1\xf0u segulinn heim": "F\xe1\xf0u segulinn sendan heim",
            Heimilisfang: "Heimilisfangi\xf0 \xfeitt",
            Póstnúmer: "P\xf3stn\xfamer",
            example: "t.d.",
            Senda: "Senda",
            ErrorMessage: "\xdea\xf0 kom upp villa! Vinsamlegast reyndu aftur e\xf0a sendu okkur t\xf6lvup\xf3st \xe1 hallo@urdarbrunnur.is.",
            Success: "Takk fyrir. Vi\xf0 sendum \xe1 \xfeig segulinn sem allra fyrst."
        }
    },
    en: {
        MagnetForm: {
            "F\xe1\xf0u segulinn heim": "Get the Learner Driving magnet",
            Heimilisfang: "Your address",
            Póstnúmer: "Postcode",
            example: "e.g.",
            Senda: "Send",
            ErrorMessage: "There was an error! Please try again or contact us at hallo@urdarbrunnur.is.",
            Success: "Thank you! We will send you the magnet as soon as possible."
        }
    }
};
const $602e0fce79bb6fe6$var$MagnetForm = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [address, setAddress] = (0, $4hYjL.useState)({
        value: "",
        valid: false
    });
    const [postcode, setPostcode] = (0, $4hYjL.useState)({
        value: "",
        valid: false
    });
    const [submitting, setSubmitting] = (0, $4hYjL.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)("");
    const [success, setSuccess] = (0, $4hYjL.useState)(false);
    const handleAddressChange = (event)=>{
        const { value: value } = event.target;
        let isFieldValid = false;
        if (event.target.value.length > 0) isFieldValid = true;
        setAddress({
            value: value,
            valid: isFieldValid
        });
    };
    const handlePostcodeChange = (event)=>{
        const { value: value } = event.target;
        let isFieldValid = false;
        if (event.target.value.length > 2) isFieldValid = true;
        setPostcode({
            value: value,
            valid: isFieldValid
        });
    };
    const submitForm = ()=>{
        setSubmitting(true);
        setErrorMessage("");
        setSuccess(false);
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post(`/api/send-magnet`, {
            address: address.value,
            postcode: postcode.value
        }).then(()=>{
            setSubmitting(false);
            setSuccess(true);
        }).catch((error)=>{
            setSubmitting(false);
            setErrorMessage(t("MagnetForm.ErrorMessage"));
            console.error(error.response);
        });
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "magnet-form",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: t("MagnetForm.F\xe1\xf0u segulinn heim")
            }),
            !success ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "field-container",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    className: "field-name",
                                    children: t("MagnetForm.Heimilisfang")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                    type: "text",
                                    required: true,
                                    id: "address",
                                    name: "address",
                                    placeholder: `${t("MagnetForm.example")} Vonarstræti 1`,
                                    value: address.value,
                                    onChange: handleAddressChange
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "field-container",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                    className: "field-name",
                                    children: t("MagnetForm.P\xf3stn\xfamer")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                    type: "text",
                                    required: true,
                                    id: "postcode",
                                    name: "postcode",
                                    placeholder: `${t("MagnetForm.example")} 101 Reykjavík`,
                                    value: postcode.value,
                                    onChange: handlePostcodeChange
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                        disabled: !address.valid || !postcode.valid,
                        type: "onClick",
                        onClick: submitForm,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                                style: {
                                    marginRight: "5px"
                                },
                                className: "fa fa-paper-plane"
                            }),
                            "  ",
                            submitting ? "Sendi..." : t("MagnetForm.Senda")
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                children: t("MagnetForm.Success")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $ff4dbaa01637bf3d$export$2e2bcd8739ae039), {
                errorMessage: errorMessage
            })
        ]
    });
};
var $602e0fce79bb6fe6$export$2e2bcd8739ae039 = $602e0fce79bb6fe6$var$MagnetForm;


const $1bfa76ecafe81f69$export$150b732325d14d04 = {
    is: {
        Done: {
            "Vel gert": "Til hamingju!",
            "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 1": "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 1",
            Text1: "N\xfa getur \xfe\xfa byrja\xf0 a\xf0 \xe6fa \xfeig \xed \xe6fingarakstri e\xf0a skr\xe1\xf0 \xfeig \xed \xd6kusk\xf3la 2 og haldi\xf0 \xe1fram a\xf0 s\xfdna pr\xfd\xf0ilegan \xe1rgangur \xe1 svi\xf0i \xf6kun\xe1ms.",
            Text2: "Ef \xfe\xfa vilt f\xe1 \xe6fingaaksturssegulinn sendan heim til \xfe\xedn \xfe\xe1 getur \xfe\xfa fyllt \xfat formi\xf0 fyrir ne\xf0an me\xf0 heimilisfanginu \xfe\xednu og vi\xf0 skulum senda \xfe\xe9r hann alveg \xf3keypis!",
            Text3: "\xdea\xf0 tekur venjulega 4-5 virka daga fyrir segulinn a\xf0 koma me\xf0 p\xf3sti.",
            "Aftur \xe1 stj\xf3rnbor\xf0": "Aftur \xe1 stj\xf3rnbor\xf0",
            Segulinn: "Segulinn",
            Æfingaaskturssegulinn: "\xc6fingaasktur segul"
        }
    },
    en: {
        Done: {
            "Vel gert": "Well done!",
            "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 1": "You've finished Driving School 1",
            Text1: "You can now begin practicing by doing Learner Driving (\xe6fingaakstur). You can now also begin Driving School 2.",
            Text2: "If you want to have the Learner Driving magnet sent home to you then you can fill out the form below with your address and we will send it to you for free!",
            Text3: "It usually takes 4-5 working days for the magnet to arrive.",
            "Aftur \xe1 stj\xf3rnbor\xf0": "Back to dashboard",
            Segulinn: "The magnet",
            Æfingaaskturssegulinn: "Learner Driving magnet"
        }
    }
};
const $1bfa76ecafe81f69$var$Done = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: "1",
        title: t("Done.Vel gert"),
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                    children: t("Done.Vel gert")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h2", {
                    children: [
                        "\uD83C\uDF89 ",
                        t("Done.\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 1"),
                        " \uD83C\uDF89"
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Done.Text1")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                    children: t("Done.Segulinn")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Done.Text2")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("Done.Text3")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("img", {
                    alt: "\xe6fingaaksturssegull",
                    src: "/images/lotur/aefingarakstur.jpg",
                    width: "300px"
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    className: "caption",
                    style: {
                        marginTop: 0
                    },
                    children: t("Done.\xc6fingaaskturssegulinn")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $602e0fce79bb6fe6$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                    to: "/stjornbord",
                    className: "btn",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("i", {
                            className: "fa fa-tachometer"
                        }),
                        " ",
                        t("Done.Aftur \xe1 stj\xf3rnbor\xf0")
                    ]
                })
            ]
        })
    });
};
var $1bfa76ecafe81f69$export$2e2bcd8739ae039 = $1bfa76ecafe81f69$var$Done;



parcelRequire("4hYjL");



const $95ef19fc3d28d157$export$150b732325d14d04 = {
    is: {
        DoneOkuskoliTwo: {
            "Vel gert": "Vel gert!",
            "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 2": "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 2",
            Text1: "N\xfa getur \xfe\xfa haldi\xf0 \xe1fram a\xf0 \xe6fa \xfeig \xed \xe6fingarakstri, teki\xf0 skriflega \xf6kupr\xf3fi\xf0 e\xf0a fari\xf0 \xed \xd6kusk\xf3la 3 og haldi\xf0 \xe1fram a\xf0 s\xfdna pr\xfd\xf0ilegan \xe1rgangur \xe1 svi\xf0i \xf6kun\xe1ms.",
            "Aftur \xe1 stj\xf3rnbor\xf0": "Aftur \xe1 stj\xf3rnbor\xf0"
        }
    },
    en: {
        DoneOkuskoliTwo: {
            "Vel gert": "Well done!",
            "\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 2": "You have finished Driving School 2",
            Text1: "You can now continue practicing through Learner Driving (\xe6fingaakstur). You can also take the written exam and go to Driving School 3.",
            "Aftur \xe1 stj\xf3rnbor\xf0": "Back to dashboard"
        }
    }
};
const $95ef19fc3d28d157$var$Done2 = ()=>{
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        courseId: "2",
        title: t("Done.Vel gert"),
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                    children: t("DoneOkuskoliTwo.Vel gert")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                    children: t("DoneOkuskoliTwo.\xde\xfa hefur loki\xf0 \xd6kusk\xf3la 2")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                    children: t("DoneOkuskoliTwo.Text1")
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$a6c7ac8248d6e38a), {
                    to: "/stjornbord",
                    className: "btn",
                    children: t("DoneOkuskoliTwo.Aftur \xe1 stj\xf3rnbor\xf0")
                })
            ]
        })
    });
};
var $95ef19fc3d28d157$export$2e2bcd8739ae039 = $95ef19fc3d28d157$var$Done2;




var $4hYjL = parcelRequire("4hYjL");



var $4hYjL = parcelRequire("4hYjL");




const $46f208e2af2c905e$export$150b732325d14d04 = {
    is: {
        TextSetting: {
            "Loading...": "Loading...",
            Breyta: "Breyta",
            "H\xe6tta vi\xf0": "H\xe6tta vi\xf0",
            Vista: "Vista",
            "er ekki \xe1 r\xe9ttu formi": "er ekki \xe1 r\xe9ttu formi"
        }
    },
    en: {
        TextSetting: {
            "Loading...": "Loading...",
            Breyta: "Change",
            "H\xe6tta vi\xf0": "Cancel",
            Vista: "Save",
            "er ekki \xe1 r\xe9ttu formi": "is not in the correct format"
        }
    }
};
const $46f208e2af2c905e$var$TextSetting = ({ label: label, userData: userData, name: name, updateUserData: updateUserData })=>{
    const [editing, setEditing] = (0, $4hYjL.useState)(false);
    const [value, setValue] = (0, $4hYjL.useState)("");
    const [isDiff, setIsDiff] = (0, $4hYjL.useState)(false);
    const [isLoading, setIsLoading] = (0, $4hYjL.useState)(false);
    const [error, setError] = (0, $4hYjL.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $4hYjL.useState)("");
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const toggleEditing = ()=>{
        setEditing(!editing);
        setError(false);
        setErrorMessage("");
        if (!value) setValue(userData);
    };
    // This ensures you're not submitting data to the API
    // unless an actual change has been made.
    (0, $4hYjL.useEffect)(()=>{
        if (value !== userData) setIsDiff(true);
        else setIsDiff(false);
    }, [
        value,
        userData
    ]);
    const handleUserInput = (event)=>{
        const { value: value } = event.target;
        setValue(value);
    };
    const updateUserSettings = ()=>{
        if (isDiff) {
            // Set loading, clear error.
            setIsLoading(true);
            setError(false);
            setErrorMessage("");
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/user-information", {
                field: name,
                value: value
            }).then((res)=>{
                const { field: field, value: value } = res.data;
                updateUserData(field, value);
                toggleEditing();
            }).catch((err)=>{
                setError(true);
                if (err.response.status === 400) setErrorMessage(`${label} ${t("TextSetting.er ekki \xe1 r\xe9ttu formi")}.`);
                else setErrorMessage(err.message);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else // If there's no data to update, toggle out of editing mode.
        toggleEditing();
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
        className: "text-setting mb-5",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                className: "label",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("b", {
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "text-input",
                children: isLoading ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                    className: "loading-text",
                    children: t("TextSetting.Loading...")
                }) : editing ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                    style: {
                        lineHeight: "22px",
                        padding: "4px 2px"
                    },
                    type: "text",
                    value: value,
                    onChange: handleUserInput
                }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                    children: userData
                })
            }),
            editing ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                size: "small",
                text: t("TextSetting.Vista"),
                onClick: updateUserSettings
            }) : "",
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                className: "edit-button",
                onClick: toggleEditing,
                children: editing ? t("TextSetting.H\xe6tta vi\xf0") : t("TextSetting.Breyta")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                className: "error",
                children: error && errorMessage
            })
        ]
    });
};
var $46f208e2af2c905e$export$2e2bcd8739ae039 = $46f208e2af2c905e$var$TextSetting;



var $4hYjL = parcelRequire("4hYjL");
var $80dbacb179855cfb$var$Status;
(function(Status) {
    Status[Status["IDLE"] = 0] = "IDLE";
    Status[Status["PENDING"] = 1] = "PENDING";
    Status[Status["SUCCESS"] = 2] = "SUCCESS";
    Status[Status["ERROR"] = 3] = "ERROR";
})($80dbacb179855cfb$var$Status || ($80dbacb179855cfb$var$Status = {}));
const $80dbacb179855cfb$export$eb2799109db70ffd = (method, config = {})=>{
    const { immediate: immediate = false, initialValue: initialValue, initialParams: initialParams, responseAdapter: responseAdapter } = config;
    const [data, setData] = (0, $4hYjL.useState)(initialValue);
    const [message, setMessage] = (0, $4hYjL.useState)(null);
    const [status, setStatus] = (0, $4hYjL.useState)("IDLE");
    const exec = async (...args)=>{
        try {
            setStatus("PENDING");
            setMessage(false);
            let payload = [];
            if (args.length) payload = args;
            else if (immediate && initialParams?.length) payload = initialParams;
            const response = await method(...payload);
            const result = typeof responseAdapter === "function" ? responseAdapter(response) : response.data;
            setStatus("SUCCESS");
            setData(result);
            return {
                data: data,
                error: false,
                message: null
            };
        } catch (error) {
            console.error(error);
            setStatus("ERROR");
            setMessage(error.message);
            return {
                data: null,
                error: true,
                message: error.message
            };
        }
    };
    (0, $4hYjL.useEffect)(()=>{
        if (immediate) exec();
    }, []);
    return {
        data: data,
        status: status,
        message: message,
        exec: exec
    };
};








parcelRequire("4hYjL");





var $4hYjL = parcelRequire("4hYjL");

var $4hYjL = parcelRequire("4hYjL");
// packages/core/primitive/src/primitive.tsx
function $6cb3a3f20b32521b$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $4hYjL = parcelRequire("4hYjL");
function $5ca3d6fae47b854a$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $5ca3d6fae47b854a$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$5ca3d6fae47b854a$var$setRef(ref, node));
}
function $5ca3d6fae47b854a$export$c7b2cbe3552a0d05(...refs) {
    return $4hYjL.useCallback($5ca3d6fae47b854a$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $4hYjL = parcelRequire("4hYjL");

function $325ba5673e3af16f$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $4hYjL.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $4hYjL.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $4hYjL.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $325ba5673e3af16f$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $4hYjL.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $4hYjL.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $4hYjL.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $4hYjL.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $4hYjL.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $325ba5673e3af16f$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $325ba5673e3af16f$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $4hYjL.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $4hYjL = parcelRequire("4hYjL");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $4hYjL = parcelRequire("4hYjL");
function $4c11b06aef899c4e$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $4hYjL.useRef(callback);
    $4hYjL.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $4hYjL.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $592e0084c771fb8a$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $592e0084c771fb8a$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $4c11b06aef899c4e$export$25bec8c6f54ee79a)(onChange);
    const setValue = $4hYjL.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $592e0084c771fb8a$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $4hYjL.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $4hYjL.useRef(value);
    const handleChange = (0, $4c11b06aef899c4e$export$25bec8c6f54ee79a)(onChange);
    $4hYjL.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/use-previous/src/usePrevious.tsx

var $4hYjL = parcelRequire("4hYjL");
function $1dce113eb20a39d1$export$5cae361ad82dce8b(value) {
    const ref = $4hYjL.useRef({
        value: value,
        previous: value
    });
    return $4hYjL.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// packages/react/use-size/src/useSize.tsx

var $4hYjL = parcelRequire("4hYjL");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $4hYjL = parcelRequire("4hYjL");
var $1172a2ba2ddb59dd$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $4hYjL.useLayoutEffect : ()=>{};


function $f7432ffee0a132f0$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $4hYjL.useState(void 0);
    (0, $1172a2ba2ddb59dd$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}


// packages/react/primitive/src/Primitive.tsx

var $4hYjL = parcelRequire("4hYjL");

// packages/react/slot/src/Slot.tsx

var $4hYjL = parcelRequire("4hYjL");


var $551dc9d1395f67fb$export$8c6ed5c666ac1360 = $4hYjL.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $4hYjL.Children.toArray(children);
    const slottable = childrenArray.find($551dc9d1395f67fb$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($4hYjL.Children.count(newElement) > 1) return $4hYjL.Children.only(null);
                return $4hYjL.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)($551dc9d1395f67fb$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $4hYjL.isValidElement(newElement) ? $4hYjL.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)($551dc9d1395f67fb$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$551dc9d1395f67fb$export$8c6ed5c666ac1360.displayName = "Slot";
var $551dc9d1395f67fb$var$SlotClone = $4hYjL.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($4hYjL.isValidElement(children)) {
        const childrenRef = $551dc9d1395f67fb$var$getElementRef(children);
        return $4hYjL.cloneElement(children, {
            ...$551dc9d1395f67fb$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $5ca3d6fae47b854a$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $4hYjL.Children.count(children) > 1 ? $4hYjL.Children.only(null) : null;
});
$551dc9d1395f67fb$var$SlotClone.displayName = "SlotClone";
var $551dc9d1395f67fb$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)((0, $35b7bd865360a597$exports.Fragment), {
        children: children
    });
};
function $551dc9d1395f67fb$var$isSlottable(child) {
    return $4hYjL.isValidElement(child) && child.type === $551dc9d1395f67fb$export$d9f1ccf0bdb05d45;
}
function $551dc9d1395f67fb$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $551dc9d1395f67fb$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $551dc9d1395f67fb$export$be92b6f5f03c0fe9 = $551dc9d1395f67fb$export$8c6ed5c666ac1360;



var $e6be145617a767a7$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $e6be145617a767a7$export$250ffa63cdc0d034 = $e6be145617a767a7$var$NODES.reduce((primitive, node)=>{
    const Node = $4hYjL.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $551dc9d1395f67fb$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $e6be145617a767a7$export$6d1a0317bde7de7f(target, event) {
    if (target) $907ccff5bb941ac5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $e6be145617a767a7$export$be92b6f5f03c0fe9 = $e6be145617a767a7$export$250ffa63cdc0d034;



"use client";
var $4e1f021e3f79abc1$var$SWITCH_NAME = "Switch";
var [$4e1f021e3f79abc1$var$createSwitchContext, $4e1f021e3f79abc1$export$cf7f5f17f69cbd43] = (0, $325ba5673e3af16f$export$50c7b4e9d9f19c1)($4e1f021e3f79abc1$var$SWITCH_NAME);
var [$4e1f021e3f79abc1$var$SwitchProvider, $4e1f021e3f79abc1$var$useSwitchContext] = $4e1f021e3f79abc1$var$createSwitchContext($4e1f021e3f79abc1$var$SWITCH_NAME);
var $4e1f021e3f79abc1$export$b5d5cf8927ab7262 = $4hYjL.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...switchProps } = props;
    const [button, setButton] = $4hYjL.useState(null);
    const composedRefs = (0, $5ca3d6fae47b854a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $4hYjL.useRef(false);
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $592e0084c771fb8a$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsxs)($4e1f021e3f79abc1$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)((0, $e6be145617a767a7$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": $4e1f021e3f79abc1$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, $6cb3a3f20b32521b$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)($4e1f021e3f79abc1$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$4e1f021e3f79abc1$export$b5d5cf8927ab7262.displayName = $4e1f021e3f79abc1$var$SWITCH_NAME;
var $4e1f021e3f79abc1$var$THUMB_NAME = "SwitchThumb";
var $4e1f021e3f79abc1$export$4d07bf653ea69106 = $4hYjL.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $4e1f021e3f79abc1$var$useSwitchContext($4e1f021e3f79abc1$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)((0, $e6be145617a767a7$export$250ffa63cdc0d034).span, {
        "data-state": $4e1f021e3f79abc1$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$4e1f021e3f79abc1$export$4d07bf653ea69106.displayName = $4e1f021e3f79abc1$var$THUMB_NAME;
var $4e1f021e3f79abc1$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $4hYjL.useRef(null);
    const prevChecked = (0, $1dce113eb20a39d1$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $f7432ffee0a132f0$export$1ab7ae714698c4b8)(control);
    $4hYjL.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $35b7bd865360a597$exports.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $4e1f021e3f79abc1$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $4e1f021e3f79abc1$export$be92b6f5f03c0fe9 = $4e1f021e3f79abc1$export$b5d5cf8927ab7262;
var $4e1f021e3f79abc1$export$6521433ed15a34db = $4e1f021e3f79abc1$export$4d07bf653ea69106;



"use client";
const $d10c612543935ceb$export$b5d5cf8927ab7262 = /*#__PURE__*/ $4hYjL.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($4e1f021e3f79abc1$export$be92b6f5f03c0fe9, {
        className: (0, $1ec4bc0caf14a55f$export$1343a74baacb0543)("peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", className),
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($4e1f021e3f79abc1$export$6521433ed15a34db, {
            className: (0, $1ec4bc0caf14a55f$export$1343a74baacb0543)("pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0")
        })
    }));
$d10c612543935ceb$export$b5d5cf8927ab7262.displayName = $4e1f021e3f79abc1$export$be92b6f5f03c0fe9.displayName;



const $015e2b8c2bc83e24$export$150b732325d14d04 = {
    is: {
        DyslexiaSetting: {
            "OpenDyslexic lesblindutexti": "OpenDyslexic lesblindutexti",
            "Nota lesblindu texta": "Nota lesblindu texta"
        }
    },
    en: {
        DyslexiaSetting: {
            "OpenDyslexic lesblindutexti": "OpenDyslexic dyslexia typeface",
            "Nota lesblindu texta": "Use dyslexia typeface"
        }
    }
};
const $015e2b8c2bc83e24$var$DyslexiaSetting = ({ authReducer: authReducer, dispatch: dispatch })=>{
    // This should probably be in global state
    const { dyslexiaFont: dyslexiaFont } = authReducer;
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const updateDyslexicFont = async ()=>{
        // Make a request to the API
        // Setting to true or false.
        // Then udpate the UI.
        await (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/user-information", {
            field: "dyslexia_font",
            value: !dyslexiaFont
        });
        dispatch((0, $d599c499e9218b1e$export$1dc5715de4bfa348)());
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                className: "mt-0 mb-2 font-bold",
                children: t("DyslexiaSetting.OpenDyslexic lesblindutexti")
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                onClick: updateDyslexicFont,
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d10c612543935ceb$export$b5d5cf8927ab7262), {
                        checked: dyslexiaFont
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                        className: "ml-2",
                        children: t("DyslexiaSetting.Nota lesblindu texta")
                    })
                ]
            })
        ]
    });
};
const $015e2b8c2bc83e24$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $015e2b8c2bc83e24$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($015e2b8c2bc83e24$var$mapStateToProps)($015e2b8c2bc83e24$var$DyslexiaSetting);



const $5f99be61ae2e398d$export$150b732325d14d04 = {
    is: {
        Settings: {
            Stillingar: "Stillingar",
            Notendaupplýsingar: "Notendauppl\xfdsingar",
            "\xdabs! Eithva\xf0 f\xf3r \xfarskei\xf0is": "\xdabs! Eithva\xf0 f\xf3r \xfarskei\xf0is:",
            Nafn: "Nafn",
            Tölvupóstur: "T\xf6lvup\xf3stur",
            Notendaupplifun: "Notenda stillingar",
            Language: "Tungum\xe1l",
            Kaup: "Vi\xf0skipti og kvittanir",
            Námskeið: "N\xe1mskei\xf0",
            Verð: "Ver\xf0",
            Dagsetning: "Dagsetning",
            "S\xfdna kvittun": "S\xfdna kvittun",
            "Engin kaup": "Engin vi\xf0skipti fundust"
        }
    },
    en: {
        Settings: {
            Stillingar: "Settings",
            Notendaupplýsingar: "User profile",
            "\xdabs! Eithva\xf0 f\xf3r \xfarskei\xf0is": "Oops! Something went wrong:",
            Nafn: "Name",
            Tölvupóstur: "Email",
            Notendaupplifun: "User settings",
            Language: "Language",
            Kaup: "Purchases",
            Námskeið: "Course",
            Verð: "Price",
            Dagsetning: "Date",
            "S\xfdna kvittun": "Show receipt",
            "Engin kaup": "No purchases found"
        }
    }
};
const $5f99be61ae2e398d$var$Settings = ()=>{
    const { data: response, status: status, message: message, exec: initGetUserSettings } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$bdf060f8502bcfbd));
    const { data: transactionsResponse, exec: initGetUserTransactions } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$3c1b75b9a74b445c));
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const [user, setUser] = (0, $4hYjL.useState)({
        name: "Loading...",
        email: "Loading..."
    });
    const [transactions, setTransactions] = (0, $4hYjL.useState)([]);
    (0, $4hYjL.useEffect)(()=>{
        initGetUserSettings();
        initGetUserTransactions();
    }, []);
    (0, $4hYjL.useEffect)(()=>{
        if (response?.user) {
            const { user: user } = response;
            setUser(user);
        }
    }, [
        response
    ]);
    (0, $4hYjL.useEffect)(()=>{
        if (transactionsResponse?.transactions) setTransactions(transactionsResponse.transactions);
    }, [
        transactionsResponse
    ]);
    (0, $4hYjL.useEffect)(()=>{
        if (status === "ERROR") setUser({
            name: "",
            email: ""
        });
    }, [
        status
    ]);
    const updateUserData = (field, value)=>{
        setUser((prevUser)=>{
            const fieldToUpdate = {
                [field]: value
            };
            return {
                ...prevUser,
                ...fieldToUpdate
            };
        });
    };
    const formatDate = (dateString)=>{
        return new Date(dateString).toLocaleDateString("is-IS");
    };
    const formatPrice = (price)=>{
        return new Intl.NumberFormat("is-IS", {
            style: "currency",
            currency: "ISK",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(price);
    };
    const { name: name, email: email } = user;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: t("Settings.Stillingar"),
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "main-content",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "lotu-container",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "settings-page",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                            children: t("Settings.Stillingar")
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                            children: t("Settings.Notendauppl\xfdsingar")
                        }),
                        status === "ERROR" && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                            className: "error",
                            children: [
                                t("Settings.\xdabs! Eithva\xf0 f\xf3r \xfarskei\xf0is"),
                                " ",
                                message
                            ]
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $46f208e2af2c905e$export$2e2bcd8739ae039), {
                            label: t("Settings.Nafn"),
                            userData: name,
                            name: "name",
                            updateUserData: updateUserData
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $46f208e2af2c905e$export$2e2bcd8739ae039), {
                            label: t("Settings.T\xf6lvup\xf3stur"),
                            userData: email,
                            name: "email",
                            updateUserData: updateUserData
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                    children: t("Settings.Notendaupplifun")
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                            className: "mt-0 mb-0 font-bold",
                                            children: t("Settings.Language")
                                        }),
                                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e80d636e54631bbe$export$2e2bcd8739ae039), {
                                            onlyShowFlag: false
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $015e2b8c2bc83e24$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h3", {
                                    children: t("Settings.Kaup")
                                }),
                                transactions.length > 0 ? /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                    className: "space-y-4",
                                    children: transactions.map((transaction)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                                                className: "font-medium",
                                                                children: transaction.course_name
                                                            }),
                                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                                                className: "text-sm text-gray-600",
                                                                children: [
                                                                    formatDate(transaction.time),
                                                                    " -",
                                                                    " ",
                                                                    formatPrice(transaction.price)
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                                                        className: "inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200",
                                                        onClick: ()=>window.open(`/api/receipt/${transaction.id}`, "_blank"),
                                                        children: t("Settings.S\xfdna kvittun")
                                                    })
                                                ]
                                            })
                                        }, transaction.id))
                                }) : /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                                        className: "text-gray-500 text-center py-4",
                                        children: t("Settings.Engin kaup")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $5f99be61ae2e398d$export$2e2bcd8739ae039 = $5f99be61ae2e398d$var$Settings;




var $4hYjL = parcelRequire("4hYjL");




const $cd3e748636b7b1d2$var$Admin = ()=>{
    const { data: users, status: status, message: message, exec: initGetUsers } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$925a4945a6cd0f3e));
    (0, $4hYjL.useEffect)(()=>{
        initGetUsers();
    }, []);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: "Yfirlit nemendur",
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "main-content",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "lotu-container",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "admin-page",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                            children: "Nemendur"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                status === "PENDING" && "loading",
                                status === "ERROR" && message,
                                users && users.map(({ name: name, email: email, ssn: ssn, address: address, zip_code: zip_code, id: id, created_date: created_date })=>{
                                    const date = new Date(created_date);
                                    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "student",
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    name,
                                                    " | ",
                                                    ssn,
                                                    " | ",
                                                    id,
                                                    " | ",
                                                    email,
                                                    " | ",
                                                    address,
                                                    ",",
                                                    " ",
                                                    zip_code,
                                                    " | ",
                                                    date.toLocaleString()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                                                size: "tiny",
                                                type: "react-router-link",
                                                href: `/command/nemandi/${id}`,
                                                children: "Sko\xf0a betur"
                                            })
                                        ]
                                    }, id);
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $cd3e748636b7b1d2$export$2e2bcd8739ae039 = $cd3e748636b7b1d2$var$Admin;




var $4hYjL = parcelRequire("4hYjL");






parcelRequire("4hYjL");
const $bc71e96a99545c7b$var$PrettyData = ({ json: json })=>{
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("pre", {
            children: JSON.stringify(json, null, 2)
        })
    });
};
var $bc71e96a99545c7b$export$2e2bcd8739ae039 = $bc71e96a99545c7b$var$PrettyData;




var $4hYjL = parcelRequire("4hYjL");




const $5234b507c179e3db$var$OpenForm = ()=>{
    const { userId: userId } = (0, $87978d8bc0f45f32$export$99eaa27ddbbb95ef)();
    const [form, setForm] = (0, $4hYjL.useState)({
        course: "1",
        paymentType: "transfer",
        amount: 12500
    });
    const { status: status, message: message, exec: initOpenCourse } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$ba609cc3d52c26c));
    const submitForm = async (event)=>{
        event.preventDefault();
        initOpenCourse(form.course, form.paymentType, form.amount, parseInt(userId));
    };
    const handleSelectChange = (e)=>{
        const { value: value, name: name } = e.target;
        setForm({
            ...form,
            [name]: value
        });
    };
    const handleTyping = (e)=>{
        const { value: value, name: name } = e.target;
        setForm({
            ...form,
            [name]: value
        });
    };
    const { course: course, paymentType: paymentType, amount: amount } = form;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: "Open"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("label", {
                        children: "Course"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("select", {
                        name: "course",
                        onChange: handleSelectChange,
                        value: course,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("option", {
                                value: "1",
                                children: "\xd6kusk\xf3li 1"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("option", {
                                value: "2",
                                children: "\xd6kusk\xf3li 2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("label", {
                        children: "Payment type"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("select", {
                        name: "paymentType",
                        onChange: handleSelectChange,
                        value: paymentType,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("option", {
                                value: "transfer",
                                children: "Millif\xe6rsla"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("option", {
                                value: "teya",
                                children: "Teya"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("label", {
                        children: "Upph\xe6\xf0"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                        name: "amount",
                        onChange: handleTyping,
                        type: "text",
                        value: amount
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                size: "tiny",
                text: "Open course",
                onClick: submitForm
            }),
            status === "SUCCESS" && "Course opened",
            status === "PENDING" && "Loading",
            status === "ERROR" && message
        ]
    });
};
var $5234b507c179e3db$export$2e2bcd8739ae039 = $5234b507c179e3db$var$OpenForm;



parcelRequire("4hYjL");




const $922b6923fe4f1ad0$var$OpenForm = ()=>{
    const { userId: userId } = (0, $87978d8bc0f45f32$export$99eaa27ddbbb95ef)();
    const { data: data, status: status, message: message, exec: initCloseCourse } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$5e3d0809e8b56e59));
    const submitForm = (course)=>async (e)=>{
            e.preventDefault();
            initCloseCourse(parseInt(userId), parseInt(course));
        };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: "Close"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                    size: "small",
                    name: "1",
                    text: "Close \xd6kusk\xf3li 1",
                    onClick: submitForm("1")
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                style: {
                    marginTop: "10px",
                    marginBottom: "5px"
                },
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                    size: "small",
                    name: "2",
                    text: "Close \xd6kusk\xf3li 2",
                    onClick: submitForm("2")
                })
            }),
            "STATUS: ",
            status,
            JSON.stringify({
                data: data,
                status: status,
                message: message
            })
        ]
    });
};
var $922b6923fe4f1ad0$export$2e2bcd8739ae039 = $922b6923fe4f1ad0$var$OpenForm;




var $4hYjL = parcelRequire("4hYjL");




const $bc5b9bcc86065b6d$var$ConfirmForm = ()=>{
    const { userId: userId } = (0, $87978d8bc0f45f32$export$99eaa27ddbbb95ef)();
    const [form, setForm] = (0, $4hYjL.useState)({
        course: "1"
    });
    const { status: status, message: message, exec: initConfirmCourse } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$d1b79a0c9f20fdfe));
    const submitForm = async (event)=>{
        event.preventDefault();
        initConfirmCourse(form.course, parseInt(userId));
    };
    const handleSelectChange = (e)=>{
        const { value: value, name: name } = e.target;
        setForm({
            ...form,
            [name]: value
        });
    };
    const { course: course } = form;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                children: "Sta\xf0festa n\xe1mslok \xe1 island.is"
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                style: {
                    marginBottom: "5px"
                },
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("label", {
                        children: "Course "
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("select", {
                        name: "course",
                        onChange: handleSelectChange,
                        value: course,
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("option", {
                                value: "1",
                                children: "\xd6kusk\xf3li 1"
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("option", {
                                value: "2",
                                children: "\xd6kusk\xf3li 2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $e781f4f9cb813b75$export$2e2bcd8739ae039), {
                size: "tiny",
                text: "Confirm course",
                onClick: submitForm
            }),
            status === "SUCCESS" && "Course confirmed",
            status === "PENDING" && "Loading",
            status === "ERROR" && message
        ]
    });
};
var $bc5b9bcc86065b6d$export$2e2bcd8739ae039 = $bc5b9bcc86065b6d$var$ConfirmForm;


const $138f4409c8b2e008$var$Student = ()=>{
    const { userId: userId } = (0, $87978d8bc0f45f32$export$99eaa27ddbbb95ef)();
    const { data: userDetails, status: status, message: message, exec: initGetUserDetails } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$714d3544202969b), {
        immediate: true,
        initialParams: [
            userId
        ]
    });
    (0, $4hYjL.useEffect)(()=>{
        initGetUserDetails();
    }, []);
    const user = userDetails?.user;
    const userTransactions = userDetails?.userTransactions;
    const userCourses = userDetails?.userCourses;
    const userCourseRounds = userDetails?.userCourseRounds;
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: user?.name,
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
            className: "main-content",
            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                className: "lotu-container",
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    className: "settings-page",
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                            children: "Nemandi"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                            children: [
                                status === "PENDING" && "loading",
                                status === "ERROR" && message,
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $5234b507c179e3db$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $922b6923fe4f1ad0$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $bc5b9bcc86065b6d$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                    children: "User"
                                }),
                                user && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $bc71e96a99545c7b$export$2e2bcd8739ae039), {
                                    json: user
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                    children: "User transactions"
                                }),
                                userTransactions && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $bc71e96a99545c7b$export$2e2bcd8739ae039), {
                                    json: userTransactions
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                    children: "User courses"
                                }),
                                userCourses && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $bc71e96a99545c7b$export$2e2bcd8739ae039), {
                                    json: userCourses
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                                    children: "User course rounds"
                                }),
                                userCourseRounds && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $bc71e96a99545c7b$export$2e2bcd8739ae039), {
                                    json: userCourseRounds
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $6e454233c3ce9437$export$2e2bcd8739ae039), {
                            size: "tiny",
                            type: "react-router-link",
                            href: `/command/`,
                            children: "⬅ Til baka"
                        })
                    ]
                })
            })
        })
    });
};
var $138f4409c8b2e008$export$2e2bcd8739ae039 = $138f4409c8b2e008$var$Student;




var $4hYjL = parcelRequire("4hYjL");


const $4d962cc3ef50291a$var$Content = ()=>{
    const [courseContent, setCourseContent] = (0, $4hYjL.useState)(null);
    (0, $4hYjL.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get("/api/admin/course-content").then((res)=>{
            console.log(res.data);
            setCourseContent(res.data);
        });
    }, []);
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: "Skref yfirlit",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                children: "Skref"
            }),
            courseContent !== null ? courseContent.map((courseRound)=>{
                return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("b", {
                                children: [
                                    "\xd6",
                                    courseRound.course_id,
                                    " ",
                                    courseRound.name
                                ]
                            })
                        }),
                        courseRound.steps.map((step)=>{
                            return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                                        href: `/command/content/skref/${step.id}`,
                                        children: step.nr
                                    }, step.id),
                                    " "
                                ]
                            });
                        })
                    ]
                }, courseRound.id);
            }) : null
        ]
    });
};
var $4d962cc3ef50291a$export$2e2bcd8739ae039 = $4d962cc3ef50291a$var$Content;


var $4e6641cb1223bdc7$export$2e2bcd8739ae039 = (0, $4d962cc3ef50291a$export$2e2bcd8739ae039);




var $4hYjL = parcelRequire("4hYjL");


const $a13c1af668e67310$var$Content = ({ match: match })=>{
    const { stepId: stepId } = match.params;
    const [skrefContent, setSkrefContent] = (0, $4hYjL.useState)("");
    const [skrefQuestions, setSkrefQuestions] = (0, $4hYjL.useState)([]);
    const [skrefContentEn, setSkrefContentEn] = (0, $4hYjL.useState)("");
    (0, $4hYjL.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/step-content", {
            stepId: stepId
        }).then((res)=>{
            setSkrefQuestions(res.data.step_questions);
            setSkrefContent(res.data.data);
            setSkrefContentEn(res.data.data_en);
        });
    }, []);
    const submitStepContent = (e)=>{
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/update-step-content", {
            stepData: skrefContent,
            stepId: stepId
        }).catch((error)=>{
            console.error(error);
        });
        skrefQuestions.forEach((question)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/update-step-question", {
                question: question.question,
                questionId: question.id,
                lang: "is"
            }).catch((error)=>{
                console.error(error);
            });
            // For each question, update the answers too.
            question.step_answers.forEach((answer)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/update-step-answer", {
                    answer: answer.answer,
                    answerId: answer.id,
                    lang: "is"
                }).catch((error)=>{
                    console.error(error);
                });
            });
        });
    };
    const submitStepContentEn = (e)=>{
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/update-step-content-en", {
            stepDataEnglish: skrefContentEn,
            stepId: stepId
        }).catch((error)=>{
            console.error(error);
        });
        skrefQuestions.forEach((question)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/update-step-question", {
                question: question.question_en,
                questionId: question.id,
                lang: "en"
            }).catch((error)=>{
                console.error(error);
            });
            // For each question, update the answers too.
            question.step_answers.forEach((answer)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).post("/api/admin/update-step-answer", {
                    answer: answer.answer_en,
                    answerId: answer.id,
                    lang: "en"
                }).catch((error)=>{
                    console.error(error);
                });
            });
        });
    };
    // Only updates the question text
    const updateStepQuestion = (e, index, isEnglish)=>{
        const targetField = isEnglish ? "question_en" : "question";
        setSkrefQuestions((prevProp)=>{
            const newOne = {
                ...prevProp[index],
                [targetField]: e.target.value
            };
            const newProp = [
                ...prevProp
            ];
            newProp[index] = newOne;
            return newProp;
        });
    };
    // Only updates the answer text
    const updateAnswer = (e, index, answerIndex, isEnglish)=>{
        const field = isEnglish ? "answer_en" : "answer";
        setSkrefQuestions((prevProp)=>{
            const newState = [
                ...prevProp
            ];
            newState[index].step_answers[answerIndex][field] = e.target.value;
            return newState;
        });
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $8a5760c834750577$export$2e2bcd8739ae039), {
        title: "Skrefa editor",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("h1", {
                children: [
                    "Skref ID: ",
                    stepId
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                style: {
                    marginBottom: "20px"
                },
                children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("a", {
                    href: "/command/content",
                    children: "⇜ Aftur \xed yfirlit"
                })
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("form", {
                onSubmit: submitStepContent,
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("label", {
                        htmlFor: "skrefContent",
                        children: "Efni"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("textarea", {
                        id: "skrefContent",
                        name: "skrefContent",
                        rows: 40,
                        cols: 100,
                        value: skrefContent,
                        onChange: (e)=>setSkrefContent(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                        children: "Verkefni"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        children: skrefQuestions ? skrefQuestions.map((skrefQuestion, index)=>{
                            return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                children: [
                                    "Spurning:",
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                        type: "text",
                                        style: {
                                            marginBottom: "20px"
                                        },
                                        size: 100,
                                        height: 20,
                                        value: skrefQuestion.question,
                                        onChange: (e)=>updateStepQuestion(e, index, false)
                                    }),
                                    "Sv\xf6r (gr\xe6nt s\xfdnir r\xe9tt svar):",
                                    skrefQuestion.step_answers.map((answer, answerIndex)=>{
                                        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                type: "text",
                                                style: {
                                                    marginTop: "5px",
                                                    backgroundColor: answer.correct ? "#c1ffc1" : ""
                                                },
                                                size: 100,
                                                height: 20,
                                                value: answer.answer,
                                                onChange: (e)=>updateAnswer(e, index, answerIndex, false)
                                            })
                                        }, answer.id);
                                    })
                                ]
                            }, skrefQuestion.id);
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                        type: "submit",
                        style: {
                            marginTop: "8px",
                            marginBottom: "15px"
                        },
                        children: "Uppf\xe6ra efni"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("form", {
                onSubmit: submitStepContentEn,
                style: {
                    marginTop: "20px"
                },
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("label", {
                        htmlFor: "skrefContentEn",
                        children: "Efni \xe1 Ensku"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("textarea", {
                        id: "skrefContentEn",
                        name: "skrefContentEn",
                        rows: 40,
                        cols: 100,
                        value: skrefContentEn,
                        onChange: (e)=>setSkrefContentEn(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        children: skrefQuestions ? skrefQuestions.map((skrefQuestion, index)=>{
                            return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                children: [
                                    "Spurning:",
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                        type: "text",
                                        style: {
                                            marginBottom: "20px"
                                        },
                                        size: 100,
                                        height: 20,
                                        value: skrefQuestion.question_en,
                                        onChange: (e)=>updateStepQuestion(e, index, true)
                                    }),
                                    "Sv\xf6r (gr\xe6nt s\xfdnir r\xe9tt svar):",
                                    skrefQuestion.step_answers.map((answer, answerIndex)=>{
                                        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("input", {
                                                type: "text",
                                                style: {
                                                    marginTop: "5px",
                                                    backgroundColor: answer.correct ? "#c1ffc1" : ""
                                                },
                                                size: 100,
                                                height: 20,
                                                value: answer.answer_en,
                                                onChange: (e)=>updateAnswer(e, index, answerIndex, true)
                                            })
                                        }, answer.id);
                                    })
                                ]
                            }, skrefQuestion.id);
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("button", {
                        style: {
                            marginTop: "8px",
                            marginBottom: "15px"
                        },
                        type: "submit",
                        children: "Uppf\xe6ra efni"
                    })
                ]
            })
        ]
    });
};
var $a13c1af668e67310$export$2e2bcd8739ae039 = $a13c1af668e67310$var$Content;


var $eb35a914128b10a0$export$2e2bcd8739ae039 = (0, $a13c1af668e67310$export$2e2bcd8739ae039);




var $4hYjL = parcelRequire("4hYjL");



const $f05ae875bd7f4a64$var$Statistics = ()=>{
    const { data: response, exec: initGetStatistics } = (0, $80dbacb179855cfb$export$eb2799109db70ffd)((0, $aa5e023b7183ddf0$export$115663dc807a2e95));
    const [monthlyStats, setMonthlyStats] = (0, $4hYjL.useState)([]);
    const [dailyStats, setDailyStats] = (0, $4hYjL.useState)([]);
    const [teacherStats, setTeacherStats] = (0, $4hYjL.useState)([]);
    const [currentMonth, setCurrentMonth] = (0, $4hYjL.useState)(null);
    (0, $4hYjL.useEffect)(()=>{
        initGetStatistics();
    }, []);
    (0, $4hYjL.useEffect)(()=>{
        if (response) {
            setMonthlyStats(response.lastThreeMonths);
            setDailyStats(response.last14Days);
            setTeacherStats(response.teacherStats);
            setCurrentMonth(response.currentMonth);
        }
    }, [
        response
    ]);
    const formatCurrency = (amount)=>{
        return new Intl.NumberFormat("is-IS", {
            style: "currency",
            currency: "ISK",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };
    const formatDate = (dateString)=>{
        return new Date(dateString).toLocaleDateString("is-IS", {
            year: "numeric",
            month: "long"
        });
    };
    const formatDayDate = (dateString)=>{
        return new Date(dateString).toLocaleDateString("is-IS", {
            month: "long",
            day: "numeric"
        });
    };
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
        className: "p-6",
        children: [
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h1", {
                className: "text-2xl font-bold mb-6",
                children: "T\xf6lfr\xe6\xf0i"
            }),
            currentMonth && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                        className: "text-xl font-semibold mb-4",
                        children: "Yfirlit m\xe1na\xf0arins"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "bg-gray-50 p-4 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "text-sm text-gray-600",
                                        children: "Sala \xfea\xf0 sem af er m\xe1nu\xf0i"
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "text-2xl font-bold",
                                        children: formatCurrency(currentMonth.total)
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            currentMonth.count,
                                            " s\xf6lur"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "bg-gray-50 p-4 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "text-sm text-gray-600",
                                        children: "Me\xf0altal \xe1 dag"
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "text-2xl font-bold",
                                        children: formatCurrency(currentMonth.dailyAverage)
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            currentMonth.daysPassed,
                                            " dagar li\xf0nir af",
                                            " ",
                                            currentMonth.daysInMonth
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                className: "bg-gray-50 p-4 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "text-sm text-gray-600",
                                        children: "\xc1\xe6tlu\xf0 heildarsala m\xe1na\xf0arins"
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                                        className: "text-2xl font-bold",
                                        children: formatCurrency(currentMonth.projectedTotal)
                                    }),
                                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "\xc1\xe6tla\xf0ar s\xf6lur: ",
                                            currentMonth.projectedCount
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                        className: "text-xl font-semibold mb-4",
                        children: "S\xed\xf0ustu 14 dagar"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("table", {
                            className: "min-w-full divide-y divide-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Dagur"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Fj\xf6ldi vi\xf0skipta"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Heildarsala"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-200",
                                    children: dailyStats.map((stat, index)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: formatDayDate(stat.day)
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: stat.count
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: formatCurrency(parseInt(stat.total || "0"))
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                        className: "text-xl font-semibold mb-4",
                        children: "S\xed\xf0ustu 13 m\xe1nu\xf0ir"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("table", {
                            className: "min-w-full divide-y divide-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "M\xe1nu\xf0ur"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Fj\xf6ldi vi\xf0skipta"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Heildarsala"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-200",
                                    children: monthlyStats.map((stat, index)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: formatDate(stat.month)
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: stat.count
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: formatCurrency(parseInt(stat.total))
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $895075af5b1c20a3$export$2e2bcd8739ae039), {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("h2", {
                        className: "text-xl font-semibold mb-4",
                        children: "Kennarar s\xed\xf0ustu 12 m\xe1nu\xf0i"
                    }),
                    /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("div", {
                        className: "overflow-x-auto",
                        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("table", {
                            className: "min-w-full divide-y divide-gray-200",
                            children: [
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Kennari"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Fj\xf6ldi nemenda"
                                            }),
                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("th", {
                                                className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                children: "Heildarsala"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("tbody", {
                                    className: "bg-white divide-y divide-gray-200",
                                    children: teacherStats.map((stat, index)=>/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("tr", {
                                            className: stat.isNewTeacher ? "bg-yellow-50" : "",
                                            children: [
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm",
                                                    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                                                className: `${stat.isNewTeacher ? "font-semibold text-yellow-800" : "text-gray-900"}`,
                                                                children: stat.teacher.name
                                                            }),
                                                            stat.isNewTeacher && /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("span", {
                                                                className: "ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800",
                                                                children: "N\xfdr kennari"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: stat.studentCount
                                                }),
                                                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("td", {
                                                    className: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
                                                    children: formatCurrency(parseInt(stat.total))
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $f05ae875bd7f4a64$export$2e2bcd8739ae039 = $f05ae875bd7f4a64$var$Statistics;


// TODO: bring into normal page structure...
const $eb42b516ad2b007c$var$AppPages = {
    DrivingSchoolOneInformation: "/okuskoli1-upplysingar",
    Settings: "PageLinks.Settings"
};
const $eb42b516ad2b007c$export$40b8d92a5a695fd3 = {
    is: {
        PageLinks: {
            ...(0, $d7df78052a791524$export$da3bc2f57520e3c3)["is"]
        }
    },
    en: {
        PageLinks: {
            ...(0, $d7df78052a791524$export$da3bc2f57520e3c3)["en"]
        }
    }
};
const $eb42b516ad2b007c$export$c717c2ee03fc6c49 = {
    FrontPage: "PageLinks.FrontPage",
    AboutUs: "PageLinks.AboutUs",
    ForgotPassword: "PageLinks.ForgotPassword",
    ResetPassword: "PageLinks.ResetPassword",
    TermsAndConditions: "PageLinks.TermsAndConditions",
    BlogCostOfLicense: "PageLinks.BlogCostOfLicense",
    BlogHowToGetLicense: "PageLinks.BlogHowToGetLicense",
    DrivingSchool1: "PageLinks.Okuskoli1",
    DrivingSchool2: "PageLinks.Okuskoli2",
    Login: "PageLinks.Login",
    LoginError: "PageLinks.LoginError",
    Registration: "PageLinks.Registration",
    DrivingInstructors: "PageLinks.DrivingInstructors",
    HowUnionsHelp: "PageLinks.Unions",
    ...$eb42b516ad2b007c$var$AppPages
};
// Extremely hacky way of
// 1. Setting the correct language in the <html> tag on render
// 2. Setting the language to English if an English route is triggered
const $eb42b516ad2b007c$var$LanguageLogic = ()=>{
    const location = (0, $87978d8bc0f45f32$export$45d76561a5302f2b)();
    const { i18n: i18n } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    const lang = (0, $3a97a5b6f2ede16a$export$98373bb8fca66b98)();
    // Set correct language in main <html> tag.
    // It'll look like this: <html lang="is">
    const changeLanguageInHtmlTag = (lang)=>{
        const html = document.querySelector("html");
        html?.setAttribute("lang", lang);
    };
    Object.keys((0, $d7df78052a791524$export$da3bc2f57520e3c3)["en"]).forEach((key)=>{
        if (location.pathname === (0, $d7df78052a791524$export$da3bc2f57520e3c3)["en"][key] + "/" && lang !== "en") {
            i18n.changeLanguage("en");
            localStorage.setItem("language", "en");
            changeLanguageInHtmlTag("en");
        }
    });
    changeLanguageInHtmlTag(lang);
    return null;
};
function $eb42b516ad2b007c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $c8ccbeb543908ad3$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $d224706ebc88e822$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $35b7bd865360a597$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)($eb42b516ad2b007c$var$LanguageLogic, {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $4c7626e6bbaa4aa5$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $87978d8bc0f45f32$export$b5d5cf8927ab7262), {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: $eb42b516ad2b007c$export$c717c2ee03fc6c49.DrivingSchoolOneInformation,
                            component: (0, $9313e485d494c864$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli2-upplysingar",
                            component: (0, $545b8c5e6eaacca6$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/skraning",
                            component: (0, $e97eb64309dcdec7$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/takk-fyrir",
                            component: (0, $af31a5e97e272e65$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/villa",
                            component: (0, $8e2cf8f07e24f1a1$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/haetta",
                            component: (0, $546766ead212f1a0$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-1/vel-gert",
                            component: (0, $1bfa76ecafe81f69$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-2/vel-gert",
                            exact: true,
                            component: (0, $95ef19fc3d28d157$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/lota-:roundNr/skref-:stepNr",
                            component: (0, $1de63c28c2a63f69$exports.default)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/lota-:roundNr/krossaprof",
                            component: (0, $fd548af5d0a2aad5$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId/lokaprof",
                            component: (0, $a8351bf3e56b1846$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/okuskoli-:courseId",
                            exact: true,
                            component: (0, $d4584cbb579a562d$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.Settings),
                            exact: true,
                            component: (0, $5f99be61ae2e398d$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/command",
                            exact: true,
                            component: (0, $cd3e748636b7b1d2$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/command/nemandi/:userId",
                            exact: true,
                            component: (0, $138f4409c8b2e008$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/command/content",
                            exact: true,
                            component: (0, $4e6641cb1223bdc7$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/command/content/skref/:stepId",
                            exact: true,
                            component: (0, $eb35a914128b10a0$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/statistics",
                            exact: true,
                            component: (0, $f05ae875bd7f4a64$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $08be177d729af471$export$2e2bcd8739ae039), {
                            path: "/stjornbord",
                            component: (0, $51580f109d31ab7b$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.TermsAndConditions),
                            component: (0, $26aa2b713864fdb4$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.TermsAndConditions,
                            component: (0, $26aa2b713864fdb4$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.LoginError),
                            component: (0, $25527059244a8d43$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.LoginError,
                            component: (0, $25527059244a8d43$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.ForgotPassword),
                            component: (0, $074e5beb3f764bd7$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.ForgotPassword,
                            component: (0, $074e5beb3f764bd7$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.ResetPassword),
                            component: (0, $221fba12115148f9$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.ResetPassword,
                            component: (0, $221fba12115148f9$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.DrivingSchool1),
                            component: (0, $2641eaf58871cbd3$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.Okuskoli1,
                            component: (0, $bf14e0a350f7315c$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.DrivingSchool2),
                            component: (0, $bf14e0a350f7315c$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.Okuskoli2,
                            component: (0, $bf14e0a350f7315c$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.AboutUs),
                            component: (0, $d798a17fc2cb51c6$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.AboutUs,
                            component: (0, $d798a17fc2cb51c6$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.Login),
                            component: (0, $3ea3868f4588d729$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.Login,
                            component: (0, $3ea3868f4588d729$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.Registration),
                            component: (0, $885459ca180c2eac$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.Registration,
                            component: (0, $885459ca180c2eac$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.DrivingInstructors),
                            component: (0, $28f05a77196fb0ca$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.DrivingInstructors,
                            component: (0, $28f05a77196fb0ca$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.BlogHowToGetLicense),
                            component: (0, $4421afaa372fc760$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.BlogHowToGetLicense,
                            component: (0, $4421afaa372fc760$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.BlogCostOfLicense),
                            component: (0, $fd3f77f399c369ce$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.BlogCostOfLicense,
                            component: (0, $fd3f77f399c369ce$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.HowUnionsHelp),
                            component: (0, $54ef0f485df38191$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.Unions,
                            component: (0, $54ef0f485df38191$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: t($eb42b516ad2b007c$export$c717c2ee03fc6c49.FrontPage),
                            component: (0, $a636ef439f9c6fd1$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            path: (0, $d7df78052a791524$export$da3bc2f57520e3c3).en.FrontPage,
                            component: (0, $a636ef439f9c6fd1$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $87978d8bc0f45f32$export$e7b0ac011bb776c6), {
                            component: (0, $9006db8f79d2e261$export$2e2bcd8739ae039)
                        })
                    ]
                })
            ]
        })
    });
}























































const $29ba48ae163cf9ae$export$150b732325d14d04 = {
    is: {
        RoundTitles: {
            Ö1L1: "\xd6kun\xe1msferli\xf0",
            Ö1L2: "B\xedll og b\xfana\xf0ur",
            Ö1L3: "Umfer\xf0arheild",
            Ö1L4: "Umfer\xf0arreglur",
            Ö1L5: "Vi\xf0horf gagnvart umfer\xf0inni",
            Ö1L6: "Umfer\xf0arskilti",
            Ö2L1: "Upprifjun \xe1 \xd6kusk\xf3la 1",
            Ö2L2: "Umfer\xf0ars\xe1lfr\xe6\xf0i",
            Ö2L3: "\xc1h\xe6ttu\xfe\xe6ttir umfer\xf0arinnar",
            Ö2L4: "\xc1byrg\xf0 \xf6kumannsins",
            Ö2L5: "Opinber vi\xf0url\xf6g vi\xf0 brotum",
            Ö2L6: "Slys og skyndihj\xe1lp"
        }
    },
    en: {
        RoundTitles: {
            Ö1L1: "Learning to drive",
            Ö1L2: "Cars and their equipment",
            Ö1L3: "Traffic as a whole",
            Ö1L4: "Traffic laws",
            Ö1L5: "Behaving in traffic",
            Ö1L6: "Traffic signs",
            Ö2L1: "Driving School 1 Revision",
            Ö2L2: "Traffic psychology",
            Ö2L3: "Traffic risk factors",
            Ö2L4: "The driver's responsibility",
            Ö2L5: "Penalties for traffic violations",
            Ö2L6: "Accidents and first-aid"
        }
    }
};


// The big translation object.
// Maintained in the codebase, against all advice.
const $5e5d22975bbf20cf$var$resources = {
    is: {
        translation: {
            ...(0, $eb42b516ad2b007c$export$40b8d92a5a695fd3).is,
            ...(0, $d798a17fc2cb51c6$export$150b732325d14d04).is,
            ...(0, $28f05a77196fb0ca$export$150b732325d14d04).is,
            ...(0, $ece04713077ea625$export$150b732325d14d04).is,
            ...(0, $a636ef439f9c6fd1$export$150b732325d14d04).is,
            ...(0, $1bd9e4aadcbd1f36$export$150b732325d14d04).is,
            ...(0, $3ea3868f4588d729$export$150b732325d14d04).is,
            ...(0, $9006db8f79d2e261$export$150b732325d14d04).is,
            ...(0, $2641eaf58871cbd3$export$150b732325d14d04).is,
            ...(0, $bf14e0a350f7315c$export$150b732325d14d04).is,
            ...(0, $6d2e11f9efc6915b$export$150b732325d14d04).is,
            ...(0, $e5cba1357cfd75dc$export$150b732325d14d04).is,
            ...(0, $cebf6585d125e18d$export$150b732325d14d04).is,
            ...(0, $074e5beb3f764bd7$export$150b732325d14d04).is,
            ...(0, $221fba12115148f9$export$150b732325d14d04).is,
            ...(0, $885459ca180c2eac$export$150b732325d14d04).is,
            ...(0, $26aa2b713864fdb4$export$150b732325d14d04).is,
            ...(0, $fd3f77f399c369ce$export$150b732325d14d04).is,
            ...(0, $4421afaa372fc760$export$150b732325d14d04).is,
            ...(0, $5f99be61ae2e398d$export$150b732325d14d04).is,
            ...(0, $46f208e2af2c905e$export$150b732325d14d04).is,
            ...(0, $e80d636e54631bbe$export$150b732325d14d04).is,
            ...(0, $d9a79446859e6988$export$150b732325d14d04).is,
            ...(0, $6755d5b71c61fa31$export$150b732325d14d04).is,
            ...(0, $51580f109d31ab7b$export$150b732325d14d04).is,
            ...(0, $8a5760c834750577$export$150b732325d14d04).is,
            ...(0, $d4584cbb579a562d$export$150b732325d14d04).is,
            ...(0, $e8ec60b3e89354be$export$150b732325d14d04).is,
            ...(0, $70f351cd6e21fc9c$export$150b732325d14d04).is,
            ...(0, $ff1c392d837ab99c$export$150b732325d14d04).is,
            ...(0, $df962374ea5fc9ca$export$150b732325d14d04).is,
            ...(0, $af82ceed56dc8679$export$150b732325d14d04).is,
            ...(0, $efb0620606697874$export$150b732325d14d04).is,
            ...(0, $9313e485d494c864$export$150b732325d14d04).is,
            ...(0, $545b8c5e6eaacca6$export$150b732325d14d04).is,
            ...(0, $163558810dd8fc95$export$150b732325d14d04).is,
            ...(0, $f8257e074bcde079$export$150b732325d14d04).is,
            ...(0, $e97eb64309dcdec7$export$150b732325d14d04).is,
            ...(0, $95ef19fc3d28d157$export$150b732325d14d04).is,
            ...(0, $1bfa76ecafe81f69$export$150b732325d14d04).is,
            ...(0, $602e0fce79bb6fe6$export$150b732325d14d04).is,
            ...(0, $1de63c28c2a63f69$exports.translations).is,
            ...(0, $5dbd16c7c4c8c597$export$150b732325d14d04).is,
            ...(0, $1887a4ff5604fbbb$export$150b732325d14d04).is,
            ...(0, $c7926a8ba1268017$export$150b732325d14d04).is,
            ...(0, $fd548af5d0a2aad5$export$150b732325d14d04).is,
            ...(0, $294514a41354fbee$export$150b732325d14d04).is,
            ...(0, $396154a05d9ea4fc$export$150b732325d14d04).is,
            ...(0, $a8351bf3e56b1846$export$150b732325d14d04).is,
            ...(0, $af31a5e97e272e65$export$150b732325d14d04).is,
            ...(0, $015e2b8c2bc83e24$export$150b732325d14d04).is,
            ...(0, $54ef0f485df38191$export$150b732325d14d04).is,
            ...(0, $2be9f61885eec5db$export$150b732325d14d04).is,
            ...(0, $25527059244a8d43$export$150b732325d14d04).is,
            ...(0, $29ba48ae163cf9ae$export$150b732325d14d04).is
        }
    },
    en: {
        translation: {
            ...(0, $eb42b516ad2b007c$export$40b8d92a5a695fd3).en,
            ...(0, $d798a17fc2cb51c6$export$150b732325d14d04).en,
            ...(0, $28f05a77196fb0ca$export$150b732325d14d04).en,
            ...(0, $ece04713077ea625$export$150b732325d14d04).en,
            ...(0, $a636ef439f9c6fd1$export$150b732325d14d04).en,
            ...(0, $1bd9e4aadcbd1f36$export$150b732325d14d04).en,
            ...(0, $3ea3868f4588d729$export$150b732325d14d04).en,
            ...(0, $9006db8f79d2e261$export$150b732325d14d04).en,
            ...(0, $2641eaf58871cbd3$export$150b732325d14d04).en,
            ...(0, $bf14e0a350f7315c$export$150b732325d14d04).en,
            ...(0, $6d2e11f9efc6915b$export$150b732325d14d04).en,
            ...(0, $e5cba1357cfd75dc$export$150b732325d14d04).en,
            ...(0, $cebf6585d125e18d$export$150b732325d14d04).en,
            ...(0, $074e5beb3f764bd7$export$150b732325d14d04).en,
            ...(0, $221fba12115148f9$export$150b732325d14d04).en,
            ...(0, $885459ca180c2eac$export$150b732325d14d04).en,
            ...(0, $26aa2b713864fdb4$export$150b732325d14d04).en,
            ...(0, $fd3f77f399c369ce$export$150b732325d14d04).en,
            ...(0, $4421afaa372fc760$export$150b732325d14d04).en,
            ...(0, $5f99be61ae2e398d$export$150b732325d14d04).en,
            ...(0, $46f208e2af2c905e$export$150b732325d14d04).en,
            ...(0, $e80d636e54631bbe$export$150b732325d14d04).en,
            ...(0, $d9a79446859e6988$export$150b732325d14d04).en,
            ...(0, $6755d5b71c61fa31$export$150b732325d14d04).en,
            ...(0, $51580f109d31ab7b$export$150b732325d14d04).en,
            ...(0, $8a5760c834750577$export$150b732325d14d04).en,
            ...(0, $d4584cbb579a562d$export$150b732325d14d04).en,
            ...(0, $e8ec60b3e89354be$export$150b732325d14d04).en,
            ...(0, $70f351cd6e21fc9c$export$150b732325d14d04).en,
            ...(0, $ff1c392d837ab99c$export$150b732325d14d04).en,
            ...(0, $df962374ea5fc9ca$export$150b732325d14d04).en,
            ...(0, $af82ceed56dc8679$export$150b732325d14d04).en,
            ...(0, $efb0620606697874$export$150b732325d14d04).en,
            ...(0, $9313e485d494c864$export$150b732325d14d04).en,
            ...(0, $545b8c5e6eaacca6$export$150b732325d14d04).en,
            ...(0, $163558810dd8fc95$export$150b732325d14d04).en,
            ...(0, $f8257e074bcde079$export$150b732325d14d04).en,
            ...(0, $e97eb64309dcdec7$export$150b732325d14d04).en,
            ...(0, $95ef19fc3d28d157$export$150b732325d14d04).en,
            ...(0, $1bfa76ecafe81f69$export$150b732325d14d04).en,
            ...(0, $602e0fce79bb6fe6$export$150b732325d14d04).en,
            ...(0, $1de63c28c2a63f69$exports.translations).en,
            ...(0, $5dbd16c7c4c8c597$export$150b732325d14d04).en,
            ...(0, $1887a4ff5604fbbb$export$150b732325d14d04).en,
            ...(0, $c7926a8ba1268017$export$150b732325d14d04).en,
            ...(0, $fd548af5d0a2aad5$export$150b732325d14d04).en,
            ...(0, $294514a41354fbee$export$150b732325d14d04).en,
            ...(0, $396154a05d9ea4fc$export$150b732325d14d04).en,
            ...(0, $a8351bf3e56b1846$export$150b732325d14d04).en,
            ...(0, $af31a5e97e272e65$export$150b732325d14d04).en,
            ...(0, $015e2b8c2bc83e24$export$150b732325d14d04).en,
            ...(0, $54ef0f485df38191$export$150b732325d14d04).en,
            ...(0, $2be9f61885eec5db$export$150b732325d14d04).en,
            ...(0, $25527059244a8d43$export$150b732325d14d04).en,
            ...(0, $29ba48ae163cf9ae$export$150b732325d14d04).en
        }
    }
};
(0, $a6fea68bb2a2e7ce$export$2e2bcd8739ae039).use((0, $7f05b907a0597c85$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
.init({
    resources: $5e5d22975bbf20cf$var$resources,
    lng: window.localStorage.language || "is",
    interpolation: {
        escapeValue: false
    }
});
var $5e5d22975bbf20cf$export$2e2bcd8739ae039 = (0, $a6fea68bb2a2e7ce$export$2e2bcd8739ae039);


var $904002c1a41310d2$exports = {};
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if (0, $904002c1a41310d2$exports) $904002c1a41310d2$exports = lazySizes;
})(typeof window != "undefined" ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    "use strict";
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = "addEventListener";
    var _getAttribute = "getAttribute";
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        "load",
        "error",
        "lazyincluded",
        "_lazyloaded"
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : "removeEventListener";
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent("Event");
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]("srcset")) el.setAttribute("srcset", full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = "onscroll" in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, "visibility") == "hidden";
            return isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden");
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, "opacity") || 1) > 0;
                if (visible && getCSS(parent, "overflow") != "visible") {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto"))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) source.setAttribute("media", customMedia);
            if (sourceSrcset) source.setAttribute("srcset", sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute("sizes", sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || "");
                }
                firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName("source"), handleSources);
                if (srcset) elem.setAttribute("srcset", srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ("_lazyCache" in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == "lazy") isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, "lazyunveilread").detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener("scroll", altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);
                addEventListener("scroll", throttledCheckElements, true);
                addEventListener("resize", throttledCheckElements, true);
                addEventListener("pageshow", function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll("." + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
                    docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener("hashchange", throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend"
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener("load", onload);
                    document[_addEventListener]("DOMContentLoaded", throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";
            elem.setAttribute("sizes", width);
            if (regPicture.test(parent.nodeName || "")) {
                sources = parent.getElementsByTagName("source");
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute("sizes", width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, "lazybeforesizes", {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});


parcelRequire("4hYjL");

function $23b58c8c3713a6f1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $23b58c8c3713a6f1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $23b58c8c3713a6f1$export$2e2bcd8739ae039(o);
}



function $a8d52eeb1c74d152$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $23b58c8c3713a6f1$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $23b58c8c3713a6f1$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $e9d15df3df5c819c$export$2e2bcd8739ae039(t) {
    var i = (0, $a8d52eeb1c74d152$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $23b58c8c3713a6f1$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $6350475b52601c61$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $e9d15df3df5c819c$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $727a91becb59e3dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $727a91becb59e3dd$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $727a91becb59e3dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6350475b52601c61$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $727a91becb59e3dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $1d4ef72e121e7884$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $1d4ef72e121e7884$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $1d4ef72e121e7884$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $1d4ef72e121e7884$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $1d4ef72e121e7884$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $1d4ef72e121e7884$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $1d4ef72e121e7884$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $1d4ef72e121e7884$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $1d4ef72e121e7884$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($1d4ef72e121e7884$var$isDate(val)) return "date";
    if ($1d4ef72e121e7884$var$isError(val)) return "error";
    var constructorName = $1d4ef72e121e7884$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $1d4ef72e121e7884$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $1d4ef72e121e7884$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $1d4ef72e121e7884$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $1d4ef72e121e7884$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $1d4ef72e121e7884$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(1));
        return enhancer($1d4ef72e121e7884$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$1d4ef72e121e7884$var$isPlainObject(action)) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $1d4ef72e121e7884$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$1d4ef72e121e7884$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $1d4ef72e121e7884$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$1d4ef72e121e7884$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $1d4ef72e121e7884$export$8928921ea2d3b126 = $1d4ef72e121e7884$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1d4ef72e121e7884$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $1d4ef72e121e7884$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $1d4ef72e121e7884$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$1d4ef72e121e7884$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $1d4ef72e121e7884$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $1d4ef72e121e7884$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $1d4ef72e121e7884$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $1d4ef72e121e7884$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $1d4ef72e121e7884$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $1d4ef72e121e7884$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $1d4ef72e121e7884$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $1d4ef72e121e7884$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $1d4ef72e121e7884$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $1d4ef72e121e7884$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $1d4ef72e121e7884$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $1d4ef72e121e7884$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $1d4ef72e121e7884$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($1d4ef72e121e7884$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $1d4ef72e121e7884$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $727a91becb59e3dd$export$2e2bcd8739ae039)((0, $727a91becb59e3dd$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $cd0694c153ccd76b$exports = {};
!function(e, t) {
    t($cd0694c153ccd76b$exports);
}($cd0694c153ccd76b$exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "→",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("—— no diff ——");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("—— diff end —— ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("—— log end ——");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



const $fcd934a37020a658$export$31499a9cd224b78c = "8.9.2";


/** Get's the global object for the current JavaScript runtime */ const $9222e08ab7462e92$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $9222e08ab7462e92$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $9222e08ab7462e92$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $fcd934a37020a658$export$31499a9cd224b78c] = __SENTRY__[0, $fcd934a37020a658$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $87b050d966c95572$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$e6127cc7fe7395c3(wat) {
    switch($87b050d966c95572$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $87b050d966c95572$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$var$isBuiltin(wat, className) {
    return $87b050d966c95572$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$9f9636d330b71954(wat) {
    return $87b050d966c95572$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$ef9e2056653f0c8e(wat) {
    return $87b050d966c95572$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$12e869b2a583f783(wat) {
    return $87b050d966c95572$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$844ec244b1367d54(wat) {
    return $87b050d966c95572$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$c3825b437cbdea5c(wat) {
    return wat === null || $87b050d966c95572$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$53b83ca8eaab0383(wat) {
    return $87b050d966c95572$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $87b050d966c95572$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $87b050d966c95572$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$49841c62b9eff15(wat) {
    return $87b050d966c95572$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $87b050d966c95572$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$bc2894c7158efbac(wat) {
    return $87b050d966c95572$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $87b050d966c95572$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5612f6f559e4d1ed$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $5148f2b1674eb1d0$var$PREFIX = "Sentry Logger ";
const $5148f2b1674eb1d0$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $5148f2b1674eb1d0$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $5148f2b1674eb1d0$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($5148f2b1674eb1d0$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $5148f2b1674eb1d0$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $5148f2b1674eb1d0$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $5612f6f559e4d1ed$export$16a28057038b10ef) $5148f2b1674eb1d0$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $5148f2b1674eb1d0$export$cda52e2a8927a2ca(()=>{
                (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).console[name](`${$5148f2b1674eb1d0$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $5148f2b1674eb1d0$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $5148f2b1674eb1d0$export$af88d00dbe7f521 = $5148f2b1674eb1d0$var$makeLogger();


const $8adcee472a454ea1$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $8adcee472a454ea1$export$7740643b9eeaf0c4() {
    return Date.now() / $8adcee472a454ea1$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $8adcee472a454ea1$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $8adcee472a454ea1$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $8adcee472a454ea1$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $8adcee472a454ea1$export$ee52dced521e3e18 = $8adcee472a454ea1$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $8adcee472a454ea1$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $8adcee472a454ea1$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $8adcee472a454ea1$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $8adcee472a454ea1$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $8adcee472a454ea1$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $8adcee472a454ea1$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



const $2163c3d7ae318f39$var$WINDOW = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1);
const $2163c3d7ae318f39$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2163c3d7ae318f39$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $2163c3d7ae318f39$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2163c3d7ae318f39$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2163c3d7ae318f39$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($2163c3d7ae318f39$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        className = elem.className;
        if (className && (0, $87b050d966c95572$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $2163c3d7ae318f39$export$1cfafeee2987818b() {
    try {
        return $2163c3d7ae318f39$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2163c3d7ae318f39$export$c660c1f3ab49225c(selector) {
    if ($2163c3d7ae318f39$var$WINDOW.document && $2163c3d7ae318f39$var$WINDOW.document.querySelector) return $2163c3d7ae318f39$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precendence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $2163c3d7ae318f39$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$2163c3d7ae318f39$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $2bde4ec6030552ba$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $2bde4ec6030552ba$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2bde4ec6030552ba$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $87b050d966c95572$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $2bde4ec6030552ba$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $87b050d966c95572$export$844ec244b1367d54)(value)) return false;
    if ((0, $87b050d966c95572$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $87b050d966c95572$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $2bde4ec6030552ba$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$2bde4ec6030552ba$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $abf88abf981430c6$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $abf88abf981430c6$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $abf88abf981430c6$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $5612f6f559e4d1ed$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $abf88abf981430c6$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $abf88abf981430c6$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $abf88abf981430c6$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $abf88abf981430c6$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $abf88abf981430c6$export$62ff257738bf57f5(value) {
    if ((0, $87b050d966c95572$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$abf88abf981430c6$var$getOwnProperties(value)
    };
    else if ((0, $87b050d966c95572$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $abf88abf981430c6$var$serializeEventTarget(value.target),
            currentTarget: $abf88abf981430c6$var$serializeEventTarget(value.currentTarget),
            ...$abf88abf981430c6$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $87b050d966c95572$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $abf88abf981430c6$var$serializeEventTarget(target) {
    try {
        return (0, $87b050d966c95572$export$45a5e7f76e0caa8d)(target) ? (0, $2163c3d7ae318f39$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $abf88abf981430c6$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $abf88abf981430c6$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($abf88abf981430c6$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $2bde4ec6030552ba$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $2bde4ec6030552ba$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $abf88abf981430c6$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $abf88abf981430c6$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $abf88abf981430c6$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($abf88abf981430c6$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $abf88abf981430c6$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($abf88abf981430c6$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $abf88abf981430c6$var$isPojo(input) {
    if (!(0, $87b050d966c95572$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $abf88abf981430c6$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $87b050d966c95572$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $83cbf171dda1db92$export$19f53698e68b2496() {
    const gbl = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $83cbf171dda1db92$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $83cbf171dda1db92$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $83cbf171dda1db92$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $83cbf171dda1db92$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $83cbf171dda1db92$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $83cbf171dda1db92$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $83cbf171dda1db92$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $83cbf171dda1db92$export$d364f2020ab30578(input) {
    const match = input.match($83cbf171dda1db92$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $83cbf171dda1db92$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $2bde4ec6030552ba$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $2bde4ec6030552ba$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $2bde4ec6030552ba$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $83cbf171dda1db92$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $abf88abf981430c6$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $83cbf171dda1db92$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $fd441d1f1c9fdc6c$export$849dbeeeda01ae98 = "production";




/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $f3103ab3d685dede$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $f3103ab3d685dede$export$c8bfa33e4e8ae492((0, $9222e08ab7462e92$export$f1a6cdb1459e81d1));
    return 0, $9222e08ab7462e92$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $f3103ab3d685dede$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $fcd934a37020a658$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $fcd934a37020a658$export$31499a9cd224b78c] = __SENTRY__[0, $fcd934a37020a658$export$31499a9cd224b78c] || {};
}





/**
 * Returns a new minimal propagation context
 */ function $42eeaf24d049c4df$export$37f0f2f9cf343e5e() {
    return {
        traceId: (0, $83cbf171dda1db92$export$19f53698e68b2496)(),
        spanId: (0, $83cbf171dda1db92$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $81528f38bc832f5c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $8adcee472a454ea1$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $83cbf171dda1db92$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$81528f38bc832f5c$var$sessionToJSON(session)
    };
    if (context) $81528f38bc832f5c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $81528f38bc832f5c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $8adcee472a454ea1$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $83cbf171dda1db92$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $81528f38bc832f5c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $81528f38bc832f5c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $81528f38bc832f5c$var$sessionToJSON(session) {
    return (0, $abf88abf981430c6$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}



const $13d5ec8fe2e0e32f$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $13d5ec8fe2e0e32f$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $abf88abf981430c6$export$e73679ffaf56810e)(scope, $13d5ec8fe2e0e32f$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$13d5ec8fe2e0e32f$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $13d5ec8fe2e0e32f$export$91f063ebb8eff307(scope) {
    return scope[$13d5ec8fe2e0e32f$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $178f330cbcdfe731$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $178f330cbcdfe731$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = (0, $42eeaf24d049c4df$export$37f0f2f9cf343e5e)();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $178f330cbcdfe731$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $13d5ec8fe2e0e32f$export$3f25fa50c18e20ca)(newScope, (0, $13d5ec8fe2e0e32f$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $81528f38bc832f5c$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $178f330cbcdfe731$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $87b050d966c95572$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $13d5ec8fe2e0e32f$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this._propagationContext = (0, $42eeaf24d049c4df$export$37f0f2f9cf343e5e)();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $178f330cbcdfe731$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $8adcee472a454ea1$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $13d5ec8fe2e0e32f$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $83cbf171dda1db92$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $83cbf171dda1db92$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $83cbf171dda1db92$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $178f330cbcdfe731$export$775b6bb06e53a214 = $178f330cbcdfe731$var$ScopeClass;


/** Get the default current scope. */ function $5f9fb91368e8d9df$export$6f1b9191db9c4d5() {
    return (0, $9222e08ab7462e92$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $178f330cbcdfe731$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $5f9fb91368e8d9df$export$de9862929b76bf57() {
    return (0, $9222e08ab7462e92$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $178f330cbcdfe731$export$775b6bb06e53a214)());
}




/**
 * This is an object that holds a stack of scopes.
 */ class $453efa6a9761879d$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $178f330cbcdfe731$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $178f330cbcdfe731$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $87b050d966c95572$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $453efa6a9761879d$var$getAsyncContextStack() {
    const registry = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const sentry = (0, $f3103ab3d685dede$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $453efa6a9761879d$export$d36ec451f120cfba((0, $5f9fb91368e8d9df$export$6f1b9191db9c4d5)(), (0, $5f9fb91368e8d9df$export$de9862929b76bf57)());
}
function $453efa6a9761879d$var$withScope(callback) {
    return $453efa6a9761879d$var$getAsyncContextStack().withScope(callback);
}
function $453efa6a9761879d$var$withSetScope(scope, callback) {
    const stack = $453efa6a9761879d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $453efa6a9761879d$var$withIsolationScope(callback) {
    return $453efa6a9761879d$var$getAsyncContextStack().withScope(()=>{
        return callback($453efa6a9761879d$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $453efa6a9761879d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $453efa6a9761879d$var$withIsolationScope,
        withScope: $453efa6a9761879d$var$withScope,
        withSetScope: $453efa6a9761879d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $453efa6a9761879d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$453efa6a9761879d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$453efa6a9761879d$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $980086d5b779e4d1$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const sentry = (0, $f3103ab3d685dede$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $980086d5b779e4d1$export$f639b0c2752203be(carrier) {
    const sentry = (0, $f3103ab3d685dede$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $453efa6a9761879d$export$329d4d4d54e42710)();
}




/**
 * Get the currently active scope.
 */ function $022d20d77c62b0bf$export$c7be4b0125a10cba() {
    const carrier = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const acs = (0, $980086d5b779e4d1$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context.
 */ function $022d20d77c62b0bf$export$68f3af03034c9e90() {
    const carrier = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const acs = (0, $980086d5b779e4d1$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $022d20d77c62b0bf$export$aa55d5ab8e05984f() {
    return (0, $9222e08ab7462e92$export$7e223ec222791509)("globalScope", ()=>new (0, $178f330cbcdfe731$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $022d20d77c62b0bf$export$ec58d9285c204497(...rest) {
    const carrier = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const acs = (0, $980086d5b779e4d1$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $022d20d77c62b0bf$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const acs = (0, $980086d5b779e4d1$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $022d20d77c62b0bf$export$6bb76d6eba7e258c() {
    return $022d20d77c62b0bf$export$c7be4b0125a10cba().getClient();
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $94a58217e7416525$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $1972fa06761f1ee9$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



const $7f67340513956d2e$var$STACKTRACE_FRAME_LIMIT = 50;
const $7f67340513956d2e$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $7f67340513956d2e$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $7f67340513956d2e$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $7f67340513956d2e$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $7f67340513956d2e$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($7f67340513956d2e$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $7f67340513956d2e$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $7f67340513956d2e$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $7f67340513956d2e$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $7f67340513956d2e$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $7f67340513956d2e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($7f67340513956d2e$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($7f67340513956d2e$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $7f67340513956d2e$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || $7f67340513956d2e$export$27c7e15d453fc0ac
        }));
}
const $7f67340513956d2e$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $7f67340513956d2e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $7f67340513956d2e$var$defaultFunctionName;
        return fn.name || $7f67340513956d2e$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $7f67340513956d2e$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $7f67340513956d2e$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $17f292a1fa5b8a69$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $17f292a1fa5b8a69$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $17f292a1fa5b8a69$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $17f292a1fa5b8a69$export$a3295358bff77e(object, depth);
    if ($17f292a1fa5b8a69$var$jsonSize(normalized) > maxSize) return $17f292a1fa5b8a69$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $17f292a1fa5b8a69$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $1972fa06761f1ee9$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !Number.isNaN(value)) return value;
    const stringified = $17f292a1fa5b8a69$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $17f292a1fa5b8a69$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $abf88abf981430c6$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $17f292a1fa5b8a69$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $17f292a1fa5b8a69$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $87b050d966c95572$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $87b050d966c95572$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $7f67340513956d2e$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $17f292a1fa5b8a69$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $17f292a1fa5b8a69$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $17f292a1fa5b8a69$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $17f292a1fa5b8a69$var$jsonSize(value) {
    return $17f292a1fa5b8a69$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $17f292a1fa5b8a69$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9679420bcc61692d$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9679420bcc61692d$var$States || ($9679420bcc61692d$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9679420bcc61692d$export$1fda8aa4d135f8aa(value) {
    return new $9679420bcc61692d$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9679420bcc61692d$export$78e43115b553f358(reason) {
    return new $9679420bcc61692d$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9679420bcc61692d$export$6f292d4960313241 {
    constructor(executor){
        $9679420bcc61692d$export$6f292d4960313241.prototype.__init.call(this);
        $9679420bcc61692d$export$6f292d4960313241.prototype.__init2.call(this);
        $9679420bcc61692d$export$6f292d4960313241.prototype.__init3.call(this);
        $9679420bcc61692d$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9679420bcc61692d$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9679420bcc61692d$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9679420bcc61692d$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9679420bcc61692d$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9679420bcc61692d$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9679420bcc61692d$var$States.PENDING) return;
            if ((0, $87b050d966c95572$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9679420bcc61692d$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9679420bcc61692d$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $9679420bcc61692d$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $eed27c053773bdce$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9679420bcc61692d$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $94a58217e7416525$export$16a28057038b10ef) && processor.id && result === null && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $87b050d966c95572$export$f5b060c2914b97c8)(result)) result.then((final)=>$eed27c053773bdce$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $eed27c053773bdce$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}







const $e1b85047a018d498$export$9ca9946bd449ac06 = "baggage";
const $e1b85047a018d498$export$6e69537d67fa20f = "sentry-";
const $e1b85047a018d498$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $e1b85047a018d498$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $e1b85047a018d498$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $e1b85047a018d498$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($e1b85047a018d498$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($e1b85047a018d498$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $e1b85047a018d498$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$e1b85047a018d498$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $e1b85047a018d498$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $e1b85047a018d498$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $87b050d966c95572$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $e1b85047a018d498$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    return $e1b85047a018d498$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $e1b85047a018d498$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $e1b85047a018d498$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $e1b85047a018d498$export$bdd844ddb2def819) {
            (0, $5612f6f559e4d1ed$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}




/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $ed43fa8b2297667f$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $ed43fa8b2297667f$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $ed43fa8b2297667f$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $ed43fa8b2297667f$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $ed43fa8b2297667f$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $ed43fa8b2297667f$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $ed43fa8b2297667f$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * The id of the profile that this span occured in.
 */ const $ed43fa8b2297667f$export$1efec95406bbe327 = "sentry.profile_id";
const $ed43fa8b2297667f$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $ed43fa8b2297667f$export$b016f89ac1066ec = "cache.hit";
const $ed43fa8b2297667f$export$3110e4c3f4386399 = "cache.key";
const $ed43fa8b2297667f$export$86be76deee227ff2 = "cache.item_size";




// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $8a75435ee351c1e4$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $8a75435ee351c1e4$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($8a75435ee351c1e4$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $8a75435ee351c1e4$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $8a75435ee351c1e4$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $e1b85047a018d498$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $83cbf171dda1db92$export$19f53698e68b2496)(),
        spanId: (0, $83cbf171dda1db92$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $83cbf171dda1db92$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $83cbf171dda1db92$export$19f53698e68b2496)().substring(16),
        spanId: (0, $83cbf171dda1db92$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $8a75435ee351c1e4$export$f35d907436da45cf(traceId = (0, $83cbf171dda1db92$export$19f53698e68b2496)(), spanId = (0, $83cbf171dda1db92$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $64abf0c7d877288f$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $64abf0c7d877288f$export$2e7205e45c58797d(span) {
    const storage = span[$64abf0c7d877288f$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $abf88abf981430c6$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $64abf0c7d877288f$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$64abf0c7d877288f$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$64abf0c7d877288f$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}



const $e58af589c449b07f$export$136e25984ba4a383 = 0;
const $e58af589c449b07f$export$58f7963109c806fc = 1;
const $e58af589c449b07f$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $e58af589c449b07f$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $e58af589c449b07f$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $e58af589c449b07f$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $e58af589c449b07f$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $e58af589c449b07f$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $e58af589c449b07f$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



// These are aligned with OpenTelemetry trace flags
const $d390c5fffcaa33bb$export$208d5b368507fb8b = 0x0;
const $d390c5fffcaa33bb$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $d390c5fffcaa33bb$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $d390c5fffcaa33bb$export$92d8c23565496537(span);
    return (0, $abf88abf981430c6$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $d390c5fffcaa33bb$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $d390c5fffcaa33bb$export$92d8c23565496537(span);
    return (0, $abf88abf981430c6$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $d390c5fffcaa33bb$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d390c5fffcaa33bb$export$5caecac1caaf3a71(span);
    return (0, $8a75435ee351c1e4$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $d390c5fffcaa33bb$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $d390c5fffcaa33bb$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d390c5fffcaa33bb$var$ensureTimestampInSeconds(input.getTime());
    return (0, $8adcee472a454ea1$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $d390c5fffcaa33bb$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $d390c5fffcaa33bb$export$92d8c23565496537(span) {
    if ($d390c5fffcaa33bb$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($d390c5fffcaa33bb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $abf88abf981430c6$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $d390c5fffcaa33bb$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $d390c5fffcaa33bb$export$3f7581298f56c6d7(endTime) || undefined,
                status: $d390c5fffcaa33bb$export$e238a77ea3a8cd66(status),
                op: attributes[0, $ed43fa8b2297667f$export$1a413bd9a88fdb09],
                origin: attributes[0, $ed43fa8b2297667f$export$cca8dd30f57f805e],
                _metrics_summary: (0, $64abf0c7d877288f$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $d390c5fffcaa33bb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $d390c5fffcaa33bb$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $d390c5fffcaa33bb$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $d390c5fffcaa33bb$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $d390c5fffcaa33bb$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $e58af589c449b07f$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $e58af589c449b07f$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $d390c5fffcaa33bb$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $d390c5fffcaa33bb$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $d390c5fffcaa33bb$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$d390c5fffcaa33bb$var$ROOT_SPAN_FIELD] || span;
    (0, $abf88abf981430c6$export$e73679ffaf56810e)(childSpan, $d390c5fffcaa33bb$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$d390c5fffcaa33bb$var$CHILD_SPANS_FIELD]) span[$d390c5fffcaa33bb$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $abf88abf981430c6$export$e73679ffaf56810e)(span, $d390c5fffcaa33bb$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $d390c5fffcaa33bb$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$d390c5fffcaa33bb$var$CHILD_SPANS_FIELD]) span[$d390c5fffcaa33bb$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $d390c5fffcaa33bb$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($d390c5fffcaa33bb$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$d390c5fffcaa33bb$var$CHILD_SPANS_FIELD] ? Array.from(span[$d390c5fffcaa33bb$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $d390c5fffcaa33bb$export$c4c6a79b1260ca1b(span) {
    return span[$d390c5fffcaa33bb$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $d390c5fffcaa33bb$export$1be426a8e585c83e() {
    const carrier = (0, $f3103ab3d685dede$export$19eade501500c6c1)();
    const acs = (0, $980086d5b779e4d1$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $13d5ec8fe2e0e32f$export$91f063ebb8eff307)((0, $022d20d77c62b0bf$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $d390c5fffcaa33bb$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $d390c5fffcaa33bb$export$1be426a8e585c83e();
    if (span) (0, $64abf0c7d877288f$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}


/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $15cb09f128b88478$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $15cb09f128b88478$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $abf88abf981430c6$export$e73679ffaf56810e)(spanWithMaybeDsc, $15cb09f128b88478$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $15cb09f128b88478$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $abf88abf981430c6$export$d25f2688db1bb433)({
        environment: options.environment || (0, $fd441d1f1c9fdc6c$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $15cb09f128b88478$export$a117f995597e25df(span) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const dsc = $15cb09f128b88478$export$366bad00d6815eed((0, $d390c5fffcaa33bb$export$92d8c23565496537)(span).trace_id || "", client);
    const rootSpan = (0, $d390c5fffcaa33bb$export$c4c6a79b1260ca1b)(span);
    if (!rootSpan) return dsc;
    const frozenDsc = rootSpan[$15cb09f128b88478$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    const jsonSpan = (0, $d390c5fffcaa33bb$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $ed43fa8b2297667f$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $ed43fa8b2297667f$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $d390c5fffcaa33bb$export$5caecac1caaf3a71)(rootSpan));
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $15cb09f128b88478$export$95cf936fdacaff7b(span) {
    const dsc = $15cb09f128b88478$export$a117f995597e25df(span);
    return (0, $e1b85047a018d498$export$56766feef403f365)(dsc);
}



/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $c8675c870bf9661d$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $c8675c870bf9661d$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $c8675c870bf9661d$var$applySpanToEvent(event, span);
    $c8675c870bf9661d$var$applyFingerprintToEvent(event, fingerprint);
    $c8675c870bf9661d$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $c8675c870bf9661d$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $c8675c870bf9661d$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $c8675c870bf9661d$export$b1a120a2871faa46(data, "extra", extra);
    $c8675c870bf9661d$export$b1a120a2871faa46(data, "tags", tags);
    $c8675c870bf9661d$export$b1a120a2871faa46(data, "user", user);
    $c8675c870bf9661d$export$b1a120a2871faa46(data, "contexts", contexts);
    $c8675c870bf9661d$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $c8675c870bf9661d$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $c8675c870bf9661d$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $abf88abf981430c6$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $abf88abf981430c6$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $abf88abf981430c6$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $abf88abf981430c6$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $c8675c870bf9661d$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $c8675c870bf9661d$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $c8675c870bf9661d$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $d390c5fffcaa33bb$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $15cb09f128b88478$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $d390c5fffcaa33bb$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $d390c5fffcaa33bb$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $c8675c870bf9661d$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $83cbf171dda1db92$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $86531463a99f06dd$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $83cbf171dda1db92$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $8adcee472a454ea1$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $86531463a99f06dd$var$applyClientOptions(prepared, options);
    $86531463a99f06dd$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $86531463a99f06dd$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $86531463a99f06dd$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $83cbf171dda1db92$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $022d20d77c62b0bf$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $c8675c870bf9661d$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $c8675c870bf9661d$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $c8675c870bf9661d$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $eed27c053773bdce$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $86531463a99f06dd$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $86531463a99f06dd$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $86531463a99f06dd$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $fd441d1f1c9fdc6c$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $2bde4ec6030552ba$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $2bde4ec6030552ba$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $2bde4ec6030552ba$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $86531463a99f06dd$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $86531463a99f06dd$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $86531463a99f06dd$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $86531463a99f06dd$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $86531463a99f06dd$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $86531463a99f06dd$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $86531463a99f06dd$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $17f292a1fa5b8a69$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $17f292a1fa5b8a69$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $17f292a1fa5b8a69$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $17f292a1fa5b8a69$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $17f292a1fa5b8a69$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $17f292a1fa5b8a69$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $86531463a99f06dd$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $178f330cbcdfe731$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $86531463a99f06dd$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($86531463a99f06dd$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($86531463a99f06dd$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $86531463a99f06dd$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $178f330cbcdfe731$export$775b6bb06e53a214) || typeof hint === "function";
}
const $86531463a99f06dd$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $86531463a99f06dd$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$86531463a99f06dd$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $5356ef0fd5f12fed$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)().captureException(exception, (0, $86531463a99f06dd$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $5356ef0fd5f12fed$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $5356ef0fd5f12fed$export$1462b974fdcf6ba2(event, hint) {
    return (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5356ef0fd5f12fed$export$2f04de43fe27971a(name, context) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $5356ef0fd5f12fed$export$bb4922da0dd51b92(extras) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $5356ef0fd5f12fed$export$8e8e7789d42ed61d(key, extra) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $5356ef0fd5f12fed$export$74a8fb34822092e6(tags) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $5356ef0fd5f12fed$export$a37d07ee78eb4569(key, value) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $5356ef0fd5f12fed$export$8b6bb3dd62a01be2(user) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $5356ef0fd5f12fed$export$5d4e9fd7fac8e617() {
    return (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $5356ef0fd5f12fed$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)();
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    if (!client) (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $83cbf171dda1db92$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $5356ef0fd5f12fed$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $5356ef0fd5f12fed$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $8adcee472a454ea1$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $5356ef0fd5f12fed$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $8adcee472a454ea1$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $022d20d77c62b0bf$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $87b050d966c95572$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, ()=>{
            finishCheckIn("error");
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $5356ef0fd5f12fed$export$4909b86c8034bf73(timeout) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $5356ef0fd5f12fed$export$8360e631d277ea4d(timeout) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $5356ef0fd5f12fed$export$3f95c6f800b78024() {
    return !!(0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $5356ef0fd5f12fed$export$3b029eb57ac4d562() {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $5356ef0fd5f12fed$export$9aac0b9f77928fbf(callback) {
    (0, $022d20d77c62b0bf$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $5356ef0fd5f12fed$export$c0d84948cecf78d8(context) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $022d20d77c62b0bf$export$68f3af03034c9e90)();
    const currentScope = (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $fd441d1f1c9fdc6c$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $81528f38bc832f5c$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $81528f38bc832f5c$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $5356ef0fd5f12fed$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $5356ef0fd5f12fed$export$17a5be43989a0bc1() {
    const isolationScope = (0, $022d20d77c62b0bf$export$68f3af03034c9e90)();
    const currentScope = (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $81528f38bc832f5c$export$56521d9ba90f62ee)(session);
    $5356ef0fd5f12fed$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $5356ef0fd5f12fed$var$_sendSessionUpdate() {
    const isolationScope = (0, $022d20d77c62b0bf$export$68f3af03034c9e90)();
    const currentScope = (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)();
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $5356ef0fd5f12fed$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $5356ef0fd5f12fed$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $5356ef0fd5f12fed$var$_sendSessionUpdate();
}





const $835ae2271a14d653$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $835ae2271a14d653$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $835ae2271a14d653$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $83cbf171dda1db92$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $835ae2271a14d653$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $835ae2271a14d653$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $835ae2271a14d653$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $835ae2271a14d653$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $835ae2271a14d653$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $835ae2271a14d653$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($835ae2271a14d653$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $835ae2271a14d653$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $835ae2271a14d653$export$2d8f5188773bcddd(integration) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $835ae2271a14d653$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $835ae2271a14d653$export$2323046b9414659f(fn) {
    return fn;
}



const $66072b4a73e3e9c8$var$INTEGRATION_NAME = "Dedupe";
const $66072b4a73e3e9c8$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $66072b4a73e3e9c8$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($66072b4a73e3e9c8$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $66072b4a73e3e9c8$export$6d39aa44cd0c7567 = (0, $835ae2271a14d653$export$2323046b9414659f)($66072b4a73e3e9c8$var$_dedupeIntegration);
/** only exported for tests. */ function $66072b4a73e3e9c8$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($66072b4a73e3e9c8$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($66072b4a73e3e9c8$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $66072b4a73e3e9c8$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$66072b4a73e3e9c8$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$66072b4a73e3e9c8$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $66072b4a73e3e9c8$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $66072b4a73e3e9c8$var$_getExceptionFromEvent(previousEvent);
    const currentException = $66072b4a73e3e9c8$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$66072b4a73e3e9c8$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$66072b4a73e3e9c8$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $66072b4a73e3e9c8$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $7f67340513956d2e$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $7f67340513956d2e$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $66072b4a73e3e9c8$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $66072b4a73e3e9c8$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $5ce31e4a9aa9bd07$var$originalFunctionToString;
const $5ce31e4a9aa9bd07$var$INTEGRATION_NAME = "FunctionToString";
const $5ce31e4a9aa9bd07$var$SETUP_CLIENTS = new WeakMap();
const $5ce31e4a9aa9bd07$var$_functionToStringIntegration = ()=>{
    return {
        name: $5ce31e4a9aa9bd07$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $5ce31e4a9aa9bd07$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $abf88abf981430c6$export$e6cc1e135e2092e5)(this);
                    const context = $5ce31e4a9aa9bd07$var$SETUP_CLIENTS.has((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $5ce31e4a9aa9bd07$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $5ce31e4a9aa9bd07$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $5ce31e4a9aa9bd07$export$7918117e9202e4fb = (0, $835ae2271a14d653$export$2323046b9414659f)($5ce31e4a9aa9bd07$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $8365e334e68a7141$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $8365e334e68a7141$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $8365e334e68a7141$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $8365e334e68a7141$export$b892860177f70a30(str) {
    const match = $8365e334e68a7141$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $5148f2b1674eb1d0$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $8365e334e68a7141$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $8365e334e68a7141$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $8365e334e68a7141$var$validateDsn(dsn) {
    if (!(0, $5612f6f559e4d1ed$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$8365e334e68a7141$var$isValidProtocol(protocol)) {
        (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $8365e334e68a7141$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $8365e334e68a7141$export$b892860177f70a30(from) : $8365e334e68a7141$var$dsnFromComponents(from);
    if (!components || !$8365e334e68a7141$var$validateDsn(components)) return undefined;
    return components;
}


const $0d4214334e915ebf$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0d4214334e915ebf$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0d4214334e915ebf$var$_getIngestEndpoint(dsn) {
    return `${$0d4214334e915ebf$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0d4214334e915ebf$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $abf88abf981430c6$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $0d4214334e915ebf$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0d4214334e915ebf$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0d4214334e915ebf$var$_getIngestEndpoint(dsn)}?${$0d4214334e915ebf$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0d4214334e915ebf$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $8365e334e68a7141$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$0d4214334e915ebf$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $8365e334e68a7141$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $fccc63ab4518e5f9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler"
];
/** Options for the InboundFilters integration */ const $fccc63ab4518e5f9$var$INTEGRATION_NAME = "InboundFilters";
const $fccc63ab4518e5f9$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $fccc63ab4518e5f9$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $fccc63ab4518e5f9$var$_mergeOptions(options, clientOptions);
            return $fccc63ab4518e5f9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $fccc63ab4518e5f9$export$cb3c5c2ceb9818ba = (0, $835ae2271a14d653$export$2323046b9414659f)($fccc63ab4518e5f9$var$_inboundFiltersIntegration);
function $fccc63ab4518e5f9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $fccc63ab4518e5f9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $fccc63ab4518e5f9$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $fccc63ab4518e5f9$var$_isSentryError(event)) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fccc63ab4518e5f9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fccc63ab4518e5f9$var$_isUselessError(event)) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fccc63ab4518e5f9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fccc63ab4518e5f9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}.\nUrl: ${$fccc63ab4518e5f9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$fccc63ab4518e5f9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}.\nUrl: ${$fccc63ab4518e5f9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $fccc63ab4518e5f9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $fccc63ab4518e5f9$var$_getPossibleEventMessages(event).some((message)=>(0, $2bde4ec6030552ba$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $fccc63ab4518e5f9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $2bde4ec6030552ba$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $fccc63ab4518e5f9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $fccc63ab4518e5f9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $2bde4ec6030552ba$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $fccc63ab4518e5f9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $fccc63ab4518e5f9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $2bde4ec6030552ba$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $fccc63ab4518e5f9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $fccc63ab4518e5f9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $fccc63ab4518e5f9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $fccc63ab4518e5f9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $fccc63ab4518e5f9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $83cbf171dda1db92$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $fccc63ab4518e5f9$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $b43877d5357e9f98$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $94a58217e7416525$export$16a28057038b10ef) (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $5148f2b1674eb1d0$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $b43877d5357e9f98$export$ecb76f41d43c0e43(client);
    client.init();
}
/**
 * Make the given client the current client.
 */ function $b43877d5357e9f98$export$ecb76f41d43c0e43(client) {
    (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)().setClient(client);
}





const $53bb5a20d5e38816$var$WINDOW = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $53bb5a20d5e38816$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $53bb5a20d5e38816$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $53bb5a20d5e38816$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $53bb5a20d5e38816$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $53bb5a20d5e38816$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $53bb5a20d5e38816$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $53bb5a20d5e38816$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$53bb5a20d5e38816$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($53bb5a20d5e38816$export$d5f608b368e73f38($53bb5a20d5e38816$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $53bb5a20d5e38816$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $53bb5a20d5e38816$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $5612f6f559e4d1ed$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $53bb5a20d5e38816$export$531055a6c684a70a() {
    return "ReportingObserver" in $53bb5a20d5e38816$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $53bb5a20d5e38816$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$53bb5a20d5e38816$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $87fed25efabe9a89$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $b4461e639a3be5d5$export$31499a9cd224b78c = "8.9.2";


/** Get's the global object for the current JavaScript runtime */ const $c07d329353be01ca$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $c07d329353be01ca$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $c07d329353be01ca$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $b4461e639a3be5d5$export$31499a9cd224b78c] = __SENTRY__[0, $b4461e639a3be5d5$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $615df8bcb88e0f1b$var$PREFIX = "Sentry Logger ";
const $615df8bcb88e0f1b$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $615df8bcb88e0f1b$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $615df8bcb88e0f1b$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $c07d329353be01ca$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($615df8bcb88e0f1b$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $615df8bcb88e0f1b$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $615df8bcb88e0f1b$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $87fed25efabe9a89$export$16a28057038b10ef) $615df8bcb88e0f1b$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $615df8bcb88e0f1b$export$cda52e2a8927a2ca(()=>{
                (0, $c07d329353be01ca$export$f1a6cdb1459e81d1).console[name](`${$615df8bcb88e0f1b$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $615df8bcb88e0f1b$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $615df8bcb88e0f1b$export$af88d00dbe7f521 = $615df8bcb88e0f1b$var$makeLogger();


const $79c29ab200c8aec1$var$STACKTRACE_FRAME_LIMIT = 50;
const $79c29ab200c8aec1$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $79c29ab200c8aec1$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $79c29ab200c8aec1$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $79c29ab200c8aec1$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $79c29ab200c8aec1$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($79c29ab200c8aec1$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $79c29ab200c8aec1$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $79c29ab200c8aec1$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $79c29ab200c8aec1$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $79c29ab200c8aec1$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $79c29ab200c8aec1$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($79c29ab200c8aec1$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($79c29ab200c8aec1$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $79c29ab200c8aec1$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || $79c29ab200c8aec1$export$27c7e15d453fc0ac
        }));
}
const $79c29ab200c8aec1$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $79c29ab200c8aec1$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $79c29ab200c8aec1$var$defaultFunctionName;
        return fn.name || $79c29ab200c8aec1$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $79c29ab200c8aec1$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $79c29ab200c8aec1$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $13de9df4f25ead26$var$handlers = {};
const $13de9df4f25ead26$var$instrumented = {};
/** Add a handler function. */ function $13de9df4f25ead26$export$a4e09611e30da72e(type, handler) {
    $13de9df4f25ead26$var$handlers[type] = $13de9df4f25ead26$var$handlers[type] || [];
    $13de9df4f25ead26$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $13de9df4f25ead26$export$b17eab759a1cb5fe() {
    Object.keys($13de9df4f25ead26$var$handlers).forEach((key)=>{
        $13de9df4f25ead26$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $13de9df4f25ead26$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$13de9df4f25ead26$var$instrumented[type]) {
        instrumentFn();
        $13de9df4f25ead26$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $13de9df4f25ead26$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $13de9df4f25ead26$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $87fed25efabe9a89$export$16a28057038b10ef) && (0, $615df8bcb88e0f1b$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $79c29ab200c8aec1$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $c82445dca7dd07f7$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$e6127cc7fe7395c3(wat) {
    switch($c82445dca7dd07f7$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $c82445dca7dd07f7$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$var$isBuiltin(wat, className) {
    return $c82445dca7dd07f7$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$9f9636d330b71954(wat) {
    return $c82445dca7dd07f7$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$ef9e2056653f0c8e(wat) {
    return $c82445dca7dd07f7$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$12e869b2a583f783(wat) {
    return $c82445dca7dd07f7$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$844ec244b1367d54(wat) {
    return $c82445dca7dd07f7$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$c3825b437cbdea5c(wat) {
    return wat === null || $c82445dca7dd07f7$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$53b83ca8eaab0383(wat) {
    return $c82445dca7dd07f7$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $c82445dca7dd07f7$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $c82445dca7dd07f7$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$49841c62b9eff15(wat) {
    return $c82445dca7dd07f7$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $c82445dca7dd07f7$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$bc2894c7158efbac(wat) {
    return $c82445dca7dd07f7$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c82445dca7dd07f7$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



const $11eb83a7d983836a$var$WINDOW = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);
const $11eb83a7d983836a$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $11eb83a7d983836a$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $11eb83a7d983836a$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $11eb83a7d983836a$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $11eb83a7d983836a$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($11eb83a7d983836a$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        className = elem.className;
        if (className && (0, $c82445dca7dd07f7$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $11eb83a7d983836a$export$1cfafeee2987818b() {
    try {
        return $11eb83a7d983836a$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $11eb83a7d983836a$export$c660c1f3ab49225c(selector) {
    if ($11eb83a7d983836a$var$WINDOW.document && $11eb83a7d983836a$var$WINDOW.document.querySelector) return $11eb83a7d983836a$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precendence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $11eb83a7d983836a$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$11eb83a7d983836a$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $bd99ee5c3fc627b8$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $bd99ee5c3fc627b8$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bd99ee5c3fc627b8$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $c82445dca7dd07f7$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $bd99ee5c3fc627b8$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $c82445dca7dd07f7$export$844ec244b1367d54)(value)) return false;
    if ((0, $c82445dca7dd07f7$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $c82445dca7dd07f7$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $bd99ee5c3fc627b8$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$bd99ee5c3fc627b8$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $bd446536334e2710$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $bd446536334e2710$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $bd446536334e2710$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $87fed25efabe9a89$export$16a28057038b10ef) && (0, $615df8bcb88e0f1b$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $bd446536334e2710$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $bd446536334e2710$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $bd446536334e2710$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $bd446536334e2710$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $bd446536334e2710$export$62ff257738bf57f5(value) {
    if ((0, $c82445dca7dd07f7$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$bd446536334e2710$var$getOwnProperties(value)
    };
    else if ((0, $c82445dca7dd07f7$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $bd446536334e2710$var$serializeEventTarget(value.target),
            currentTarget: $bd446536334e2710$var$serializeEventTarget(value.currentTarget),
            ...$bd446536334e2710$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $c82445dca7dd07f7$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $bd446536334e2710$var$serializeEventTarget(target) {
    try {
        return (0, $c82445dca7dd07f7$export$45a5e7f76e0caa8d)(target) ? (0, $11eb83a7d983836a$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $bd446536334e2710$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $bd446536334e2710$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($bd446536334e2710$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $bd99ee5c3fc627b8$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $bd99ee5c3fc627b8$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $bd446536334e2710$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $bd446536334e2710$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $bd446536334e2710$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($bd446536334e2710$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $bd446536334e2710$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($bd446536334e2710$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $bd446536334e2710$var$isPojo(input) {
    if (!(0, $c82445dca7dd07f7$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $bd446536334e2710$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $c82445dca7dd07f7$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $8793e6e24358bc5e$var$WINDOW = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $8793e6e24358bc5e$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $8793e6e24358bc5e$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $8793e6e24358bc5e$var$WINDOW && !!$8793e6e24358bc5e$var$WINDOW.history.pushState && !!$8793e6e24358bc5e$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $cc5f6894bec56116$export$56d8a8a25bd48b81 = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);


let $00ce2291404672d2$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $00ce2291404672d2$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $13de9df4f25ead26$export$a4e09611e30da72e)(type, handler);
    (0, $13de9df4f25ead26$export$e18d6c5462c01368)(type, $00ce2291404672d2$var$instrumentHistory);
}
function $00ce2291404672d2$var$instrumentHistory() {
    if (!(0, $8793e6e24358bc5e$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).onpopstate;
    (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $00ce2291404672d2$var$lastHref;
        $00ce2291404672d2$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $13de9df4f25ead26$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $00ce2291404672d2$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $00ce2291404672d2$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $13de9df4f25ead26$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $bd446536334e2710$export$9563e054e6f787fb)((0, $cc5f6894bec56116$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $bd446536334e2710$export$9563e054e6f787fb)((0, $cc5f6894bec56116$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $96ef6f8393162eac$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $fcd934a37020a658$export$31499a9cd224b78c)
            })),
        version: (0, $fcd934a37020a658$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}





/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $da0f6ec95b6f5d70$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $da0f6ec95b6f5d70$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $da0f6ec95b6f5d70$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $da0f6ec95b6f5d70$export$604a45d95a155e2b(envelope, types) {
    return $da0f6ec95b6f5d70$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $da0f6ec95b6f5d70$var$encodeUTF8(input) {
    return (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $da0f6ec95b6f5d70$var$decodeUTF8(input) {
    return (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $da0f6ec95b6f5d70$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $da0f6ec95b6f5d70$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $da0f6ec95b6f5d70$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $17f292a1fa5b8a69$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $da0f6ec95b6f5d70$var$concatBuffers(parts);
}
function $da0f6ec95b6f5d70$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $da0f6ec95b6f5d70$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $da0f6ec95b6f5d70$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($da0f6ec95b6f5d70$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $da0f6ec95b6f5d70$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $da0f6ec95b6f5d70$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $da0f6ec95b6f5d70$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $abf88abf981430c6$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $da0f6ec95b6f5d70$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $da0f6ec95b6f5d70$export$b11169581eeaf237(type) {
    return $da0f6ec95b6f5d70$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $da0f6ec95b6f5d70$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $da0f6ec95b6f5d70$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8365e334e68a7141$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $abf88abf981430c6$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $2132b6ecdceedf6d$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}








/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $663901348bf949da$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $663901348bf949da$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $da0f6ec95b6f5d70$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8365e334e68a7141$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $da0f6ec95b6f5d70$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $663901348bf949da$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $da0f6ec95b6f5d70$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $663901348bf949da$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $da0f6ec95b6f5d70$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $da0f6ec95b6f5d70$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $663901348bf949da$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $15cb09f128b88478$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8365e334e68a7141$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $d390c5fffcaa33bb$export$92d8c23565496537)(span)) : (span)=>(0, $d390c5fffcaa33bb$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $da0f6ec95b6f5d70$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $da0f6ec95b6f5d70$export$f93f7f385160c44e)(headers, items);
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $c12c86f0b1c0fc84$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}



const $bf606044a23d9eb3$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $bf606044a23d9eb3$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $8365e334e68a7141$export$128827c3562ec0cb)(options.dsn);
        else (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $0d4214334e915ebf$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $83cbf171dda1db92$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $83cbf171dda1db92$export$6de4ffac6a2f1098)(exception)) {
            (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log($bf606044a23d9eb3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $83cbf171dda1db92$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $87b050d966c95572$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $87b050d966c95572$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $83cbf171dda1db92$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $83cbf171dda1db92$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log($bf606044a23d9eb3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $81528f38bc832f5c$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $835ae2271a14d653$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $835ae2271a14d653$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $663901348bf949da$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $da0f6ec95b6f5d70$export$d650323442802f6f)(env, (0, $da0f6ec95b6f5d70$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $663901348bf949da$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error("Error while sending event:", reason);
            return reason;
        });
        (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $835ae2271a14d653$export$51abed9797baa598)(this, integrations);
        (0, $835ae2271a14d653$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $81528f38bc832f5c$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $9679420bcc61692d$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $022d20d77c62b0bf$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $86531463a99f06dd$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $abf88abf981430c6$export$d25f2688db1bb433)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $15cb09f128b88478$export$366bad00d6815eed)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $94a58217e7416525$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $bf606044a23d9eb3$var$isTransactionEvent(event);
        const isError = $bf606044a23d9eb3$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $c12c86f0b1c0fc84$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $9679420bcc61692d$export$78e43115b553f358)(new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $bf606044a23d9eb3$var$processBeforeSend(options, prepared, hint);
            return $bf606044a23d9eb3$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $bf606044a23d9eb3$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $87b050d966c95572$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $87b050d966c95572$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $87b050d966c95572$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $bf606044a23d9eb3$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($bf606044a23d9eb3$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($bf606044a23d9eb3$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) return beforeSendTransaction(event, hint);
    }
    return event;
}
function $bf606044a23d9eb3$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $bf606044a23d9eb3$var$isTransactionEvent(event) {
    return event.type === "transaction";
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $af1855b8b26c794b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $8adcee472a454ea1$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $da0f6ec95b6f5d70$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1f0b166c935a81cf$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1f0b166c935a81cf$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $45cb83ffaa4a3f4d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $8e1d22f77b8d2a16$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $8e1d22f77b8d2a16$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $8e1d22f77b8d2a16$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $8e1d22f77b8d2a16$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $8e1d22f77b8d2a16$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $17f292a1fa5b8a69$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $8e1d22f77b8d2a16$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $87b050d966c95572$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $8e1d22f77b8d2a16$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $8e1d22f77b8d2a16$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $8e1d22f77b8d2a16$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $8e1d22f77b8d2a16$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $8e1d22f77b8d2a16$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $8e1d22f77b8d2a16$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $8e1d22f77b8d2a16$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $8e1d22f77b8d2a16$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $8e1d22f77b8d2a16$var$getSkipFirstStackStringLines(ex) {
    if (ex && $8e1d22f77b8d2a16$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $8e1d22f77b8d2a16$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $8e1d22f77b8d2a16$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $8e1d22f77b8d2a16$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $8e1d22f77b8d2a16$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $83cbf171dda1db92$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $8e1d22f77b8d2a16$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $8e1d22f77b8d2a16$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $8e1d22f77b8d2a16$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $87b050d966c95572$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $8e1d22f77b8d2a16$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $87b050d966c95572$export$ef9e2056653f0c8e)(exception) || (0, $87b050d966c95572$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $8e1d22f77b8d2a16$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $87b050d966c95572$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $8e1d22f77b8d2a16$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $83cbf171dda1db92$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $87b050d966c95572$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $8e1d22f77b8d2a16$var$eventFromError(stackParser, exception);
    if ((0, $87b050d966c95572$export$53b83ca8eaab0383)(exception) || (0, $87b050d966c95572$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $8e1d22f77b8d2a16$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $83cbf171dda1db92$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $8e1d22f77b8d2a16$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $83cbf171dda1db92$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $83cbf171dda1db92$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $8e1d22f77b8d2a16$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $8e1d22f77b8d2a16$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $87b050d966c95572$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $8e1d22f77b8d2a16$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $abf88abf981430c6$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $87b050d966c95572$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $87b050d966c95572$export$9671ea99bd126ace)(exception)) {
        const className = $8e1d22f77b8d2a16$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $8e1d22f77b8d2a16$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $8e1d22f77b8d2a16$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




const $641b3c7d095db335$export$56d8a8a25bd48b81 = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1);
let $641b3c7d095db335$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $641b3c7d095db335$export$b79738ab10c590b2() {
    return $641b3c7d095db335$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $641b3c7d095db335$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $641b3c7d095db335$var$ignoreOnError++;
    setTimeout(()=>{
        $641b3c7d095db335$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $641b3c7d095db335$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $abf88abf981430c6$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$641b3c7d095db335$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $641b3c7d095db335$export$1265a142ff5ba165();
            (0, $022d20d77c62b0bf$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $83cbf171dda1db92$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $83cbf171dda1db92$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $5356ef0fd5f12fed$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $abf88abf981430c6$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $abf88abf981430c6$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $72abf2df4d3710cf$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $8365e334e68a7141$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $72abf2df4d3710cf$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $da0f6ec95b6f5d70$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $72abf2df4d3710cf$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $179684780faa3e5d$export$1df9218a526d318d extends (0, $bf606044a23d9eb3$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $641b3c7d095db335$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1f0b166c935a81cf$export$8ad33f488b1ab046)();
        (0, $96ef6f8393162eac$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document) (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $641b3c7d095db335$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $8e1d22f77b8d2a16$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $8e1d22f77b8d2a16$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $72abf2df4d3710cf$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $af1855b8b26c794b$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $8365e334e68a7141$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}







/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $eb3dcffd6a595abf$export$19f53698e68b2496() {
    const gbl = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $eb3dcffd6a595abf$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $eb3dcffd6a595abf$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $eb3dcffd6a595abf$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $eb3dcffd6a595abf$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $eb3dcffd6a595abf$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $eb3dcffd6a595abf$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $eb3dcffd6a595abf$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $eb3dcffd6a595abf$export$d364f2020ab30578(input) {
    const match = input.match($eb3dcffd6a595abf$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $eb3dcffd6a595abf$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $bd99ee5c3fc627b8$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $bd99ee5c3fc627b8$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $bd99ee5c3fc627b8$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $eb3dcffd6a595abf$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $bd446536334e2710$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $eb3dcffd6a595abf$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



const $891d0df4f5e6e3aa$var$DEBOUNCE_DURATION = 1000;
let $891d0df4f5e6e3aa$var$debounceTimerID;
let $891d0df4f5e6e3aa$var$lastCapturedEventType;
let $891d0df4f5e6e3aa$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $891d0df4f5e6e3aa$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $13de9df4f25ead26$export$a4e09611e30da72e)(type, handler);
    (0, $13de9df4f25ead26$export$e18d6c5462c01368)(type, $891d0df4f5e6e3aa$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $891d0df4f5e6e3aa$export$3014bbf0af0e1d4a() {
    if (!(0, $cc5f6894bec56116$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $13de9df4f25ead26$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $891d0df4f5e6e3aa$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $cc5f6894bec56116$export$56d8a8a25bd48b81)[target] && (0, $cc5f6894bec56116$export$56d8a8a25bd48b81)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $bd446536334e2710$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $891d0df4f5e6e3aa$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $bd446536334e2710$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $891d0df4f5e6e3aa$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $891d0df4f5e6e3aa$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $891d0df4f5e6e3aa$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $891d0df4f5e6e3aa$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $891d0df4f5e6e3aa$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $891d0df4f5e6e3aa$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($891d0df4f5e6e3aa$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $bd446536334e2710$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $bd446536334e2710$export$e73679ffaf56810e)(target, "_sentryId", (0, $eb3dcffd6a595abf$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$891d0df4f5e6e3aa$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $891d0df4f5e6e3aa$var$lastCapturedEventType = event.type;
            $891d0df4f5e6e3aa$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($891d0df4f5e6e3aa$var$debounceTimerID);
        $891d0df4f5e6e3aa$var$debounceTimerID = (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).setTimeout(()=>{
            $891d0df4f5e6e3aa$var$lastCapturedEventTargetId = undefined;
            $891d0df4f5e6e3aa$var$lastCapturedEventType = undefined;
        }, $891d0df4f5e6e3aa$var$DEBOUNCE_DURATION);
    };
}
function $891d0df4f5e6e3aa$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


const $b8e4c38d1b8e20fc$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $b8e4c38d1b8e20fc$export$7740643b9eeaf0c4() {
    return Date.now() / $b8e4c38d1b8e20fc$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b8e4c38d1b8e20fc$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $b8e4c38d1b8e20fc$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b8e4c38d1b8e20fc$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $b8e4c38d1b8e20fc$export$ee52dced521e3e18 = $b8e4c38d1b8e20fc$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $b8e4c38d1b8e20fc$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $b8e4c38d1b8e20fc$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $b8e4c38d1b8e20fc$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $b8e4c38d1b8e20fc$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $b8e4c38d1b8e20fc$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $b8e4c38d1b8e20fc$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



const $d981c57d844c3de9$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d981c57d844c3de9$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $13de9df4f25ead26$export$a4e09611e30da72e)(type, handler);
    (0, $13de9df4f25ead26$export$e18d6c5462c01368)(type, $d981c57d844c3de9$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $d981c57d844c3de9$export$c67d533bf77cbf54() {
    if (!(0, $cc5f6894bec56116$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $bd446536334e2710$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = (0, $b8e4c38d1b8e20fc$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $c82445dca7dd07f7$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $d981c57d844c3de9$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$d981c57d844c3de9$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$d981c57d844c3de9$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $b8e4c38d1b8e20fc$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $13de9df4f25ead26$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $bd446536334e2710$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $bd446536334e2710$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$d981c57d844c3de9$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $c82445dca7dd07f7$export$844ec244b1367d54)(header) && (0, $c82445dca7dd07f7$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $bd446536334e2710$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$d981c57d844c3de9$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                startTimestamp: (0, $b8e4c38d1b8e20fc$export$ee52dced521e3e18)() * 1000,
                xhr: this
            };
            (0, $13de9df4f25ead26$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $d981c57d844c3de9$var$parseUrl(url) {
    if ((0, $c82445dca7dd07f7$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4537c0d325d79dfd$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4537c0d325d79dfd$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $022d20d77c62b0bf$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4537c0d325d79dfd$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $8adcee472a454ea1$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $5148f2b1674eb1d0$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}








// We keep the handlers globally
const $f3ebd6a4d320fc42$var$handlers = {};
const $f3ebd6a4d320fc42$var$instrumented = {};
/** Add a handler function. */ function $f3ebd6a4d320fc42$export$a4e09611e30da72e(type, handler) {
    $f3ebd6a4d320fc42$var$handlers[type] = $f3ebd6a4d320fc42$var$handlers[type] || [];
    $f3ebd6a4d320fc42$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f3ebd6a4d320fc42$export$b17eab759a1cb5fe() {
    Object.keys($f3ebd6a4d320fc42$var$handlers).forEach((key)=>{
        $f3ebd6a4d320fc42$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f3ebd6a4d320fc42$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f3ebd6a4d320fc42$var$instrumented[type]) {
        instrumentFn();
        $f3ebd6a4d320fc42$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f3ebd6a4d320fc42$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f3ebd6a4d320fc42$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $5612f6f559e4d1ed$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $7f67340513956d2e$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f5e2a9354506b0d4$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $f3ebd6a4d320fc42$export$a4e09611e30da72e)(type, handler);
    (0, $f3ebd6a4d320fc42$export$e18d6c5462c01368)(type, $f5e2a9354506b0d4$var$instrumentConsole);
}
function $f5e2a9354506b0d4$var$instrumentConsole() {
    if (!("console" in (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1))) return;
    (0, $5148f2b1674eb1d0$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).console)) return;
        (0, $abf88abf981430c6$export$9563e054e6f787fb)((0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $5148f2b1674eb1d0$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f3ebd6a4d320fc42$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $5148f2b1674eb1d0$export$77c4ce905194557b)[level];
                log && log.apply((0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $14eeda8d52551576$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $f3ebd6a4d320fc42$export$a4e09611e30da72e)(type, handler);
    (0, $f3ebd6a4d320fc42$export$e18d6c5462c01368)(type, $14eeda8d52551576$var$instrumentFetch);
}
function $14eeda8d52551576$var$instrumentFetch() {
    if (!(0, $53bb5a20d5e38816$export$c82d238e23c40b21)()) return;
    (0, $abf88abf981430c6$export$9563e054e6f787fb)((0, $9222e08ab7462e92$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $14eeda8d52551576$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $8adcee472a454ea1$export$ee52dced521e3e18)() * 1000
            };
            (0, $f3ebd6a4d320fc42$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // We capture the stack right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualStackTrace = new Error().stack;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $9222e08ab7462e92$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: (0, $8adcee472a454ea1$export$ee52dced521e3e18)() * 1000,
                    response: response
                };
                (0, $f3ebd6a4d320fc42$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: (0, $8adcee472a454ea1$export$ee52dced521e3e18)() * 1000,
                    error: error
                };
                (0, $f3ebd6a4d320fc42$export$b18c893e424d3127)("fetch", erroredHandlerData);
                if ((0, $87b050d966c95572$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualStackTrace;
                    (0, $abf88abf981430c6$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $14eeda8d52551576$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $14eeda8d52551576$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($14eeda8d52551576$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $14eeda8d52551576$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $14eeda8d52551576$var$getUrlFromResource(url),
            method: $14eeda8d52551576$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $14eeda8d52551576$var$getUrlFromResource(arg),
        method: $14eeda8d52551576$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $f258b8fe2152636c$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $f258b8fe2152636c$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $f258b8fe2152636c$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $f258b8fe2152636c$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $8fe05a0dc30d6dae$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $8fe05a0dc30d6dae$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $8fe05a0dc30d6dae$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $fdc83a5cb05a8e90$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $fdc83a5cb05a8e90$var$INTEGRATION_NAME = "Breadcrumbs";
const $fdc83a5cb05a8e90$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $fdc83a5cb05a8e90$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $f5e2a9354506b0d4$export$1d6e0d073f9e6723)($fdc83a5cb05a8e90$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $891d0df4f5e6e3aa$export$5aeffd3db2cf9df7)($fdc83a5cb05a8e90$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $d981c57d844c3de9$export$26ace48dd54c9aea)($fdc83a5cb05a8e90$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $14eeda8d52551576$export$f75d3c772c923df0)($fdc83a5cb05a8e90$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $00ce2291404672d2$export$3f18c56c58114e75)($fdc83a5cb05a8e90$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $fdc83a5cb05a8e90$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $fdc83a5cb05a8e90$export$c079d904b326663a = (0, $835ae2271a14d653$export$2323046b9414659f)($fdc83a5cb05a8e90$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $fdc83a5cb05a8e90$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4537c0d325d79dfd$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $83cbf171dda1db92$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $fdc83a5cb05a8e90$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $fdc83a5cb05a8e90$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$fdc83a5cb05a8e90$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$fdc83a5cb05a8e90$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $fdc83a5cb05a8e90$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $fdc83a5cb05a8e90$var$_isEvent(event) ? event.target : event;
            target = (0, $2163c3d7ae318f39$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $2163c3d7ae318f39$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $4537c0d325d79dfd$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $fdc83a5cb05a8e90$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $8fe05a0dc30d6dae$export$d771ef054122c30a)(handlerData.level),
            message: (0, $2bde4ec6030552ba$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $2bde4ec6030552ba$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4537c0d325d79dfd$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $fdc83a5cb05a8e90$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $d981c57d844c3de9$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $4537c0d325d79dfd$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $fdc83a5cb05a8e90$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4537c0d325d79dfd$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4537c0d325d79dfd$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $fdc83a5cb05a8e90$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $f258b8fe2152636c$export$7a5253c0f62e0150)((0, $641b3c7d095db335$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $f258b8fe2152636c$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $f258b8fe2152636c$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4537c0d325d79dfd$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $fdc83a5cb05a8e90$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $b74a119dfa3acaa8$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $b74a119dfa3acaa8$var$INTEGRATION_NAME = "BrowserApiErrors";
const $b74a119dfa3acaa8$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $b74a119dfa3acaa8$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $abf88abf981430c6$export$9563e054e6f787fb)((0, $641b3c7d095db335$export$56d8a8a25bd48b81), "setTimeout", $b74a119dfa3acaa8$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $abf88abf981430c6$export$9563e054e6f787fb)((0, $641b3c7d095db335$export$56d8a8a25bd48b81), "setInterval", $b74a119dfa3acaa8$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $abf88abf981430c6$export$9563e054e6f787fb)((0, $641b3c7d095db335$export$56d8a8a25bd48b81), "requestAnimationFrame", $b74a119dfa3acaa8$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $641b3c7d095db335$export$56d8a8a25bd48b81)) (0, $abf88abf981430c6$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $b74a119dfa3acaa8$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $b74a119dfa3acaa8$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($b74a119dfa3acaa8$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $b74a119dfa3acaa8$export$59bfe9f1c76150e = (0, $835ae2271a14d653$export$2323046b9414659f)($b74a119dfa3acaa8$var$_browserApiErrorsIntegration);
function $b74a119dfa3acaa8$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $641b3c7d095db335$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $7f67340513956d2e$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b74a119dfa3acaa8$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $641b3c7d095db335$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $7f67340513956d2e$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $b74a119dfa3acaa8$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $abf88abf981430c6$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $7f67340513956d2e$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $abf88abf981430c6$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $7f67340513956d2e$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $641b3c7d095db335$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $b74a119dfa3acaa8$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $641b3c7d095db335$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $abf88abf981430c6$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $641b3c7d095db335$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $7f67340513956d2e$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $641b3c7d095db335$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $7f67340513956d2e$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $abf88abf981430c6$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}





let $c24ed0c8d0670f21$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c24ed0c8d0670f21$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $f3ebd6a4d320fc42$export$a4e09611e30da72e)(type, handler);
    (0, $f3ebd6a4d320fc42$export$e18d6c5462c01368)(type, $c24ed0c8d0670f21$var$instrumentError);
}
function $c24ed0c8d0670f21$var$instrumentError() {
    $c24ed0c8d0670f21$var$_oldOnErrorHandler = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).onerror;
    (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f3ebd6a4d320fc42$export$b18c893e424d3127)("error", handlerData);
        if ($c24ed0c8d0670f21$var$_oldOnErrorHandler && !$c24ed0c8d0670f21$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $c24ed0c8d0670f21$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $6b3cc5c68864ca87$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6b3cc5c68864ca87$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $f3ebd6a4d320fc42$export$a4e09611e30da72e)(type, handler);
    (0, $f3ebd6a4d320fc42$export$e18d6c5462c01368)(type, $6b3cc5c68864ca87$var$instrumentUnhandledRejection);
}
function $6b3cc5c68864ca87$var$instrumentUnhandledRejection() {
    $6b3cc5c68864ca87$var$_oldOnUnhandledRejectionHandler = (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f3ebd6a4d320fc42$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($6b3cc5c68864ca87$var$_oldOnUnhandledRejectionHandler && !$6b3cc5c68864ca87$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $6b3cc5c68864ca87$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $9222e08ab7462e92$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $ac85ba5fa75ad8c0$var$INTEGRATION_NAME = "GlobalHandlers";
const $ac85ba5fa75ad8c0$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $ac85ba5fa75ad8c0$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $ac85ba5fa75ad8c0$var$_installGlobalOnErrorHandler(client);
                $ac85ba5fa75ad8c0$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $ac85ba5fa75ad8c0$var$_installGlobalOnUnhandledRejectionHandler(client);
                $ac85ba5fa75ad8c0$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $ac85ba5fa75ad8c0$export$66acc70e8cf2b71a = (0, $835ae2271a14d653$export$2323046b9414659f)($ac85ba5fa75ad8c0$var$_globalHandlersIntegration);
function $ac85ba5fa75ad8c0$var$_installGlobalOnErrorHandler(client) {
    (0, $c24ed0c8d0670f21$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ac85ba5fa75ad8c0$var$getOptions();
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client || (0, $641b3c7d095db335$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $ac85ba5fa75ad8c0$var$_enhanceEventWithInitialFrame((0, $8e1d22f77b8d2a16$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $5356ef0fd5f12fed$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $ac85ba5fa75ad8c0$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $6b3cc5c68864ca87$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $ac85ba5fa75ad8c0$var$getOptions();
        if ((0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)() !== client || (0, $641b3c7d095db335$export$b79738ab10c590b2)()) return;
        const error = $ac85ba5fa75ad8c0$var$_getUnhandledRejectionError(e);
        const event = (0, $87b050d966c95572$export$c3825b437cbdea5c)(error) ? $ac85ba5fa75ad8c0$var$_eventFromRejectionWithPrimitive(error) : (0, $8e1d22f77b8d2a16$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $5356ef0fd5f12fed$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $ac85ba5fa75ad8c0$var$_getUnhandledRejectionError(error) {
    if ((0, $87b050d966c95572$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $ac85ba5fa75ad8c0$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ac85ba5fa75ad8c0$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $87b050d966c95572$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $2163c3d7ae318f39$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $7f67340513956d2e$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $ac85ba5fa75ad8c0$var$globalHandlerLog(type) {
    (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $ac85ba5fa75ad8c0$var$getOptions() {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $8b374597fafe9fb4$export$1378794447170364 = (0, $835ae2271a14d653$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $641b3c7d095db335$export$56d8a8a25bd48b81).navigator && !(0, $641b3c7d095db335$export$56d8a8a25bd48b81).location && !(0, $641b3c7d095db335$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $641b3c7d095db335$export$56d8a8a25bd48b81).location && (0, $641b3c7d095db335$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $641b3c7d095db335$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $73f79bbc6eb7a641$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $87b050d966c95572$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $73f79bbc6eb7a641$var$truncateAggregateExceptions($73f79bbc6eb7a641$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $73f79bbc6eb7a641$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $87b050d966c95572$export$49034edbe6b62415)(error[key], Error)) {
        $73f79bbc6eb7a641$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $73f79bbc6eb7a641$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $73f79bbc6eb7a641$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $87b050d966c95572$export$49034edbe6b62415)(childError, Error)) {
            $73f79bbc6eb7a641$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $73f79bbc6eb7a641$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $73f79bbc6eb7a641$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $73f79bbc6eb7a641$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $73f79bbc6eb7a641$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $73f79bbc6eb7a641$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $2bde4ec6030552ba$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $34cb4acedc4a07b4$var$DEFAULT_KEY = "cause";
const $34cb4acedc4a07b4$var$DEFAULT_LIMIT = 5;
const $34cb4acedc4a07b4$var$INTEGRATION_NAME = "LinkedErrors";
const $34cb4acedc4a07b4$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $34cb4acedc4a07b4$var$DEFAULT_LIMIT;
    const key = options.key || $34cb4acedc4a07b4$var$DEFAULT_KEY;
    return {
        name: $34cb4acedc4a07b4$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $73f79bbc6eb7a641$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $8e1d22f77b8d2a16$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $34cb4acedc4a07b4$export$ebabb00eb7f3a395 = (0, $835ae2271a14d653$export$2323046b9414659f)($34cb4acedc4a07b4$var$_linkedErrorsIntegration);



const $87542b70008a1d2d$var$OPERA10_PRIORITY = 10;
const $87542b70008a1d2d$var$OPERA11_PRIORITY = 20;
const $87542b70008a1d2d$var$CHROME_PRIORITY = 30;
const $87542b70008a1d2d$var$WINJS_PRIORITY = 40;
const $87542b70008a1d2d$var$GECKO_PRIORITY = 50;
function $87542b70008a1d2d$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $7f67340513956d2e$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $87542b70008a1d2d$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $87542b70008a1d2d$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $87542b70008a1d2d$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $87542b70008a1d2d$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $87542b70008a1d2d$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $87542b70008a1d2d$var$createFrame(filename, (0, $7f67340513956d2e$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $87542b70008a1d2d$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $87542b70008a1d2d$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $87542b70008a1d2d$var$extractSafariExtensionDetails(parts[1] || (0, $7f67340513956d2e$export$27c7e15d453fc0ac), parts[2]);
        return $87542b70008a1d2d$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $87542b70008a1d2d$export$263a749fff749872 = [
    $87542b70008a1d2d$var$CHROME_PRIORITY,
    $87542b70008a1d2d$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $87542b70008a1d2d$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $87542b70008a1d2d$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $87542b70008a1d2d$var$gecko = (line)=>{
    const parts = $87542b70008a1d2d$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $87542b70008a1d2d$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $7f67340513956d2e$export$27c7e15d453fc0ac);
        [func, filename] = $87542b70008a1d2d$var$extractSafariExtensionDetails(func, filename);
        return $87542b70008a1d2d$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $87542b70008a1d2d$export$cdba47a5dd2804d = [
    $87542b70008a1d2d$var$GECKO_PRIORITY,
    $87542b70008a1d2d$var$gecko
];
const $87542b70008a1d2d$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $87542b70008a1d2d$var$winjs = (line)=>{
    const parts = $87542b70008a1d2d$var$winjsRegex.exec(line);
    return parts ? $87542b70008a1d2d$var$createFrame(parts[2], parts[1] || (0, $7f67340513956d2e$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $87542b70008a1d2d$export$179460296da408e8 = [
    $87542b70008a1d2d$var$WINJS_PRIORITY,
    $87542b70008a1d2d$var$winjs
];
const $87542b70008a1d2d$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $87542b70008a1d2d$var$opera10 = (line)=>{
    const parts = $87542b70008a1d2d$var$opera10Regex.exec(line);
    return parts ? $87542b70008a1d2d$var$createFrame(parts[2], parts[3] || (0, $7f67340513956d2e$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $87542b70008a1d2d$export$f892b52c880ffc7a = [
    $87542b70008a1d2d$var$OPERA10_PRIORITY,
    $87542b70008a1d2d$var$opera10
];
const $87542b70008a1d2d$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $87542b70008a1d2d$var$opera11 = (line)=>{
    const parts = $87542b70008a1d2d$var$opera11Regex.exec(line);
    return parts ? $87542b70008a1d2d$var$createFrame(parts[5], parts[3] || parts[4] || (0, $7f67340513956d2e$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $87542b70008a1d2d$export$af11af13f09fb0dc = [
    $87542b70008a1d2d$var$OPERA11_PRIORITY,
    $87542b70008a1d2d$var$opera11
];
const $87542b70008a1d2d$export$7197c0fe6554c079 = [
    $87542b70008a1d2d$export$263a749fff749872,
    $87542b70008a1d2d$export$cdba47a5dd2804d
];
const $87542b70008a1d2d$export$2b2b997d81bf3907 = (0, $7f67340513956d2e$export$a5739666fb2d03d4)(...$87542b70008a1d2d$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $87542b70008a1d2d$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $7f67340513956d2e$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





const $a17e13069c0afff5$var$WINDOW = (0, $c07d329353be01ca$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a17e13069c0afff5$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a17e13069c0afff5$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a17e13069c0afff5$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a17e13069c0afff5$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a17e13069c0afff5$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a17e13069c0afff5$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a17e13069c0afff5$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a17e13069c0afff5$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a17e13069c0afff5$export$d5f608b368e73f38($a17e13069c0afff5$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a17e13069c0afff5$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a17e13069c0afff5$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $87fed25efabe9a89$export$16a28057038b10ef) && (0, $615df8bcb88e0f1b$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a17e13069c0afff5$export$531055a6c684a70a() {
    return "ReportingObserver" in $a17e13069c0afff5$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a17e13069c0afff5$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a17e13069c0afff5$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1e521e5bf6192188$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $bf127e207565cd00$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $bf127e207565cd00$export$e464f4a514ac28a8(name) {
    const cached = $bf127e207565cd00$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $cc5f6894bec56116$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $a17e13069c0afff5$export$d5f608b368e73f38)(impl)) return $bf127e207565cd00$var$cachedImplementations[name] = impl.bind((0, $cc5f6894bec56116$export$56d8a8a25bd48b81));
    const document = (0, $cc5f6894bec56116$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $1e521e5bf6192188$export$16a28057038b10ef) && (0, $615df8bcb88e0f1b$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $bf127e207565cd00$var$cachedImplementations[name] = impl.bind((0, $cc5f6894bec56116$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $bf127e207565cd00$export$8aa36702e8c8978(name) {
    $bf127e207565cd00$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $bf127e207565cd00$export$e7aa7bc5c1b3cfb3(...rest) {
    return $bf127e207565cd00$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $bf127e207565cd00$export$831dc9f2ab0a617b(...rest) {
    return $bf127e207565cd00$export$e464f4a514ac28a8("setTimeout")(...rest);
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $aa0e498b375917db$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $aa0e498b375917db$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $aa0e498b375917db$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $aa0e498b375917db$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $aa0e498b375917db$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $aa0e498b375917db$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $aa0e498b375917db$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $aa0e498b375917db$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $bc3efd96a51e1c9e$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9679420bcc61692d$export$78e43115b553f358)(new (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $9679420bcc61692d$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $13eb02c3e8b3ec22$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $13eb02c3e8b3ec22$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $bc3efd96a51e1c9e$export$85a4f67f852183e6)(options.bufferSize || $13eb02c3e8b3ec22$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $da0f6ec95b6f5d70$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $da0f6ec95b6f5d70$export$b11169581eeaf237)(type);
            if ((0, $aa0e498b375917db$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $13eb02c3e8b3ec22$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $da0f6ec95b6f5d70$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $da0f6ec95b6f5d70$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $13eb02c3e8b3ec22$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $da0f6ec95b6f5d70$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $da0f6ec95b6f5d70$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $aa0e498b375917db$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $2132b6ecdceedf6d$export$5949942ba2a7c0e2)) {
                (0, $94a58217e7416525$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $9679420bcc61692d$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $13eb02c3e8b3ec22$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $d176ed5d23ccfd52$export$b2311068c46d7cc8(options, nativeFetch = (0, $bf127e207565cd00$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $bf127e207565cd00$export$8aa36702e8c8978)("fetch");
            return (0, $9679420bcc61692d$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $bf127e207565cd00$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $9679420bcc61692d$export$78e43115b553f358)(e);
        }
    }
    return (0, $13eb02c3e8b3ec22$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $9f40eb2a79a05e1d$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $fccc63ab4518e5f9$export$cb3c5c2ceb9818ba)(),
        (0, $5ce31e4a9aa9bd07$export$7918117e9202e4fb)(),
        (0, $b74a119dfa3acaa8$export$59bfe9f1c76150e)(),
        (0, $fdc83a5cb05a8e90$export$c079d904b326663a)(),
        (0, $ac85ba5fa75ad8c0$export$66acc70e8cf2b71a)(),
        (0, $34cb4acedc4a07b4$export$ebabb00eb7f3a395)(),
        (0, $66072b4a73e3e9c8$export$6d39aa44cd0c7567)(),
        (0, $8b374597fafe9fb4$export$1378794447170364)()
    ];
}
function $9f40eb2a79a05e1d$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $9f40eb2a79a05e1d$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $641b3c7d095db335$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $641b3c7d095db335$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $641b3c7d095db335$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $9f40eb2a79a05e1d$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = (0, $641b3c7d095db335$export$56d8a8a25bd48b81);
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $641b3c7d095db335$export$56d8a8a25bd48b81).location && (0, $641b3c7d095db335$export$56d8a8a25bd48b81).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $641b3c7d095db335$export$56d8a8a25bd48b81) === (0, $641b3c7d095db335$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    return !!runtimeId && !isDedicatedExtensionPage;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $9f40eb2a79a05e1d$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $9f40eb2a79a05e1d$var$applyDefaultOptions(browserOptions);
    if ($9f40eb2a79a05e1d$var$shouldShowBrowserExtensionError()) {
        (0, $5148f2b1674eb1d0$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) {
        if (!(0, $53bb5a20d5e38816$export$edf3cb81fd7d2a3e)()) (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $7f67340513956d2e$export$1d5cf88b347146d4)(options.stackParser || (0, $87542b70008a1d2d$export$2b2b997d81bf3907)),
        integrations: (0, $835ae2271a14d653$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $d176ed5d23ccfd52$export$b2311068c46d7cc8)
    };
    (0, $b43877d5357e9f98$export$5333c3f1c58d9bc1)((0, $179684780faa3e5d$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $9f40eb2a79a05e1d$var$startSessionTracking();
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $9f40eb2a79a05e1d$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $641b3c7d095db335$export$56d8a8a25bd48b81).document) {
        (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $022d20d77c62b0bf$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $5356ef0fd5f12fed$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $0d4214334e915ebf$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $641b3c7d095db335$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $641b3c7d095db335$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document.head || (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $9f40eb2a79a05e1d$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $9f40eb2a79a05e1d$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $9f40eb2a79a05e1d$var$startSessionTracking() {
    if (typeof (0, $641b3c7d095db335$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $45cb83ffaa4a3f4d$export$16a28057038b10ef) && (0, $5148f2b1674eb1d0$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $5356ef0fd5f12fed$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $5356ef0fd5f12fed$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $00ce2291404672d2$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $5356ef0fd5f12fed$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $5356ef0fd5f12fed$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $9f40eb2a79a05e1d$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $022d20d77c62b0bf$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}


const $373a168ea5327e10$export$31499a9cd224b78c = "8.9.2";


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $b655ce20e0f31921$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $373a168ea5327e10$export$31499a9cd224b78c)
            })),
        version: (0, $373a168ea5327e10$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}


/**
 * Inits the React SDK
 */ function $a3ac3bfd5482036b$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $b655ce20e0f31921$export$b9f95b027256052c)(opts, "react");
    (0, $9f40eb2a79a05e1d$export$2cd8252107eb640b)(opts);
}



var $7QK2E = parcelRequire("7QK2E");

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $5TQck = parcelRequire("5TQck");

var $4J6aQ = parcelRequire("4J6aQ");

var $hh22J = parcelRequire("hh22J");

var $iL8cJ = parcelRequire("iL8cJ");

var $SQznX = parcelRequire("SQznX");
parcelRequire("8wDn2");
var $8gwLa = parcelRequire("8gwLa");
var $5TQck = parcelRequire("5TQck");

var $iL8cJ = parcelRequire("iL8cJ");

var $SQznX = parcelRequire("SQznX");
var $c2f9f900a985ce10$var$global = (0, $8gwLa.getGlobalObject)();
function $c2f9f900a985ce10$export$6f18f55521af71a1() {
    if ($c2f9f900a985ce10$var$global && $c2f9f900a985ce10$var$global.document) $c2f9f900a985ce10$var$global.document.addEventListener("visibilitychange", function() {
        var activeTransaction = (0, $SQznX.getActiveTransaction)();
        if ($c2f9f900a985ce10$var$global.document.hidden && activeTransaction) {
            (0, $5TQck.logger).log("[Tracing] Transaction: " + (0, $iL8cJ.SpanStatus).Cancelled + " -> since tab moved to the background, op: " + activeTransaction.op);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus((0, $iL8cJ.SpanStatus).Cancelled);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (0, $5TQck.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $evtBA = parcelRequire("evtBA");
var $8gwLa = parcelRequire("8gwLa");
var $5TQck = parcelRequire("5TQck");

var $SQznX = parcelRequire("SQznX");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8c21a6c6a7c9b6c6$export$17679dccdd551979 = function(callback, metric, po, observeAllUpdates) {
    var prevValue;
    return function() {
        if (po && metric.isFinal) po.disconnect();
        if (metric.value >= 0) {
            if (observeAllUpdates || metric.isFinal || document.visibilityState === "hidden") {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta, if the metric is
                // final, or if no previous value exists (which can happen in the case
                // of the document becoming hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || metric.isFinal || prevValue === undefined) {
                    callback(metric);
                    prevValue = metric.value;
                }
            }
        }
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 27-char string by combining the current
 * timestamp with a 13-digit random number.
 * @return {string}
 */ var $4f7caf08f7f77791$export$407ea409d1f3b539 = function() {
    return Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};


var $ddc1e6c59457d7f3$export$3c29b44508a0612b = function(name, value) {
    if (value === void 0) value = -1;
    return {
        name: name,
        value: value,
        delta: 0,
        entries: [],
        id: (0, $4f7caf08f7f77791$export$407ea409d1f3b539)(),
        isFinal: false
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var $2b2c5461174b93b2$export$d1203567a167490e = function(type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(l) {
                return l.getEntries().map(callback);
            });
            po.observe({
                type: type,
                buffered: true
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e8077c887b6c3fd5$var$isUnloading = false;
var $e8077c887b6c3fd5$var$listenersAdded = false;
var $e8077c887b6c3fd5$var$onPageHide = function(event) {
    $e8077c887b6c3fd5$var$isUnloading = !event.persisted;
};
var $e8077c887b6c3fd5$var$addListeners = function() {
    addEventListener("pagehide", $e8077c887b6c3fd5$var$onPageHide);
    // `beforeunload` is needed to fix this bug:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=987409
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    addEventListener("beforeunload", function() {});
};
var $e8077c887b6c3fd5$export$91ec2be6fdd8f1b4 = function(cb, once) {
    if (once === void 0) once = false;
    if (!$e8077c887b6c3fd5$var$listenersAdded) {
        $e8077c887b6c3fd5$var$addListeners();
        $e8077c887b6c3fd5$var$listenersAdded = true;
    }
    addEventListener("visibilitychange", function(_a) {
        var timeStamp = _a.timeStamp;
        if (document.visibilityState === "hidden") cb({
            timeStamp: timeStamp,
            isUnloading: $e8077c887b6c3fd5$var$isUnloading
        });
    }, {
        capture: true,
        once: once
    });
};


var $b68e28db1102675f$export$fc6227831ee7c7 = function(onReport, reportAllChanges) {
    if (reportAllChanges === void 0) reportAllChanges = false;
    var metric = (0, $ddc1e6c59457d7f3$export$3c29b44508a0612b)("CLS", 0);
    var report;
    var entryHandler = function(entry) {
        // Only count layout shifts without recent user input.
        if (!entry.hadRecentInput) {
            metric.value += entry.value;
            metric.entries.push(entry);
            report();
        }
    };
    var po = (0, $2b2c5461174b93b2$export$d1203567a167490e)("layout-shift", entryHandler);
    if (po) {
        report = (0, $8c21a6c6a7c9b6c6$export$17679dccdd551979)(onReport, metric, po, reportAllChanges);
        (0, $e8077c887b6c3fd5$export$91ec2be6fdd8f1b4)(function(_a) {
            var isUnloading = _a.isUnloading;
            po.takeRecords().map(entryHandler);
            if (isUnloading) metric.isFinal = true;
            report();
        });
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $41133c4e5784d7b8$var$firstHiddenTime;
var $41133c4e5784d7b8$export$e300bd30df761ba5 = function() {
    if ($41133c4e5784d7b8$var$firstHiddenTime === undefined) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $41133c4e5784d7b8$var$firstHiddenTime = document.visibilityState === "hidden" ? 0 : Infinity;
        // Update the time if/when the document becomes hidden.
        (0, $e8077c887b6c3fd5$export$91ec2be6fdd8f1b4)(function(_a) {
            var timeStamp = _a.timeStamp;
            return $41133c4e5784d7b8$var$firstHiddenTime = timeStamp;
        }, true);
    }
    return {
        get timeStamp () {
            return $41133c4e5784d7b8$var$firstHiddenTime;
        }
    };
};





var $2747cd40f83334fd$export$134ed2977d320dfd = function(onReport) {
    var metric = (0, $ddc1e6c59457d7f3$export$3c29b44508a0612b)("FID");
    var firstHidden = (0, $41133c4e5784d7b8$export$e300bd30df761ba5)();
    var entryHandler = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < firstHidden.timeStamp) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            metric.isFinal = true;
            report();
        }
    };
    var po = (0, $2b2c5461174b93b2$export$d1203567a167490e)("first-input", entryHandler);
    var report = (0, $8c21a6c6a7c9b6c6$export$17679dccdd551979)(onReport, metric, po);
    if (po) (0, $e8077c887b6c3fd5$export$91ec2be6fdd8f1b4)(function() {
        po.takeRecords().map(entryHandler);
        po.disconnect();
    }, true);
    else if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) window.perfMetrics.onFirstInputDelay(function(value, event) {
        // Only report if the page wasn't hidden prior to the first input.
        if (event.timeStamp < firstHidden.timeStamp) {
            metric.value = value;
            metric.isFinal = true;
            metric.entries = [
                {
                    entryType: "first-input",
                    name: event.type,
                    target: event.target,
                    cancelable: event.cancelable,
                    startTime: event.timeStamp,
                    processingStart: event.timeStamp + value
                }
            ];
            report();
        }
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $55cbfc11b5b386d4$var$inputPromise;
var $55cbfc11b5b386d4$export$1ec26101f26bcb8b = function() {
    if (!$55cbfc11b5b386d4$var$inputPromise) $55cbfc11b5b386d4$var$inputPromise = new Promise(function(r) {
        return [
            "scroll",
            "keydown",
            "pointerdown"
        ].map(function(type) {
            addEventListener(type, r, {
                once: true,
                passive: true,
                capture: true
            });
        });
    });
    return $55cbfc11b5b386d4$var$inputPromise;
};


var $030cc5c423975187$export$da982ced0ff8a670 = function(onReport, reportAllChanges) {
    if (reportAllChanges === void 0) reportAllChanges = false;
    var metric = (0, $ddc1e6c59457d7f3$export$3c29b44508a0612b)("LCP");
    var firstHidden = (0, $41133c4e5784d7b8$export$e300bd30df761ba5)();
    var report;
    var entryHandler = function(entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < firstHidden.timeStamp) {
            metric.value = value;
            metric.entries.push(entry);
        } else metric.isFinal = true;
        report();
    };
    var po = (0, $2b2c5461174b93b2$export$d1203567a167490e)("largest-contentful-paint", entryHandler);
    if (po) {
        report = (0, $8c21a6c6a7c9b6c6$export$17679dccdd551979)(onReport, metric, po, reportAllChanges);
        var onFinal = function() {
            if (!metric.isFinal) {
                po.takeRecords().map(entryHandler);
                metric.isFinal = true;
                report();
            }
        };
        (0, $55cbfc11b5b386d4$export$1ec26101f26bcb8b)().then(onFinal);
        (0, $e8077c887b6c3fd5$export$91ec2be6fdd8f1b4)(onFinal, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("8wDn2");
var $8gwLa = parcelRequire("8gwLa");

var $ecdaaa455c3362e8$var$global = (0, $8gwLa.getGlobalObject)();
var $ecdaaa455c3362e8$var$afterLoad = function(callback) {
    if (document.readyState === "complete") // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
    else // Use `pageshow` so the callback runs after `loadEventEnd`.
    addEventListener("pageshow", callback);
};
var $ecdaaa455c3362e8$var$getNavigationEntryFromPerformanceTiming = function() {
    // Really annoying that TypeScript errors when using `PerformanceTiming`.
    // eslint-disable-next-line deprecation/deprecation
    var timing = $ecdaaa455c3362e8$var$global.performance.timing;
    var navigationEntry = {
        entryType: "navigation",
        startTime: 0
    };
    for(var key in timing)if (key !== "navigationStart" && key !== "toJSON") navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
var $ecdaaa455c3362e8$export$6e8eea9a35032c92 = function(onReport) {
    var metric = (0, $ddc1e6c59457d7f3$export$3c29b44508a0612b)("TTFB");
    $ecdaaa455c3362e8$var$afterLoad(function() {
        try {
            // Use the NavigationTiming L2 entry if available.
            var navigationEntry = $ecdaaa455c3362e8$var$global.performance.getEntriesByType("navigation")[0] || $ecdaaa455c3362e8$var$getNavigationEntryFromPerformanceTiming();
            metric.value = metric.delta = navigationEntry.responseStart;
            metric.entries = [
                navigationEntry
            ];
            onReport(metric);
        } catch (error) {
        // Do nothing.
        }
    });
};



var $7c924e2d9dde5b37$var$global = (0, $8gwLa.getGlobalObject)();
/** Class tracking metrics  */ var $7c924e2d9dde5b37$export$8d26291c4fcc1971 = /** @class */ function() {
    function MetricsInstrumentation() {
        this._measurements = {};
        this._performanceCursor = 0;
        if ($7c924e2d9dde5b37$var$global && $7c924e2d9dde5b37$var$global.performance) {
            if ($7c924e2d9dde5b37$var$global.performance.mark) $7c924e2d9dde5b37$var$global.performance.mark("sentry-tracing-init");
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
            this._trackTTFB();
        }
    }
    /** Add performance related spans to a transaction */ MetricsInstrumentation.prototype.addPerformanceEntries = function(transaction) {
        var _this = this;
        if (!$7c924e2d9dde5b37$var$global || !$7c924e2d9dde5b37$var$global.performance || !$7c924e2d9dde5b37$var$global.performance.getEntries || !(0, $evtBA.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
        return;
        (0, $5TQck.logger).log("[Tracing] Adding & adjusting spans using Performance API");
        var timeOrigin = (0, $SQznX.msToSec)((0, $evtBA.browserPerformanceTimeOrigin));
        var entryScriptSrc;
        if ($7c924e2d9dde5b37$var$global.document) {
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for(var i = 0; i < document.scripts.length; i++)// We go through all scripts on the page and look for 'data-entry'
            // We remember the name and measure the time between this script finished loading and
            // our mark 'sentry-tracing-init'
            if (document.scripts[i].dataset.entry === "true") {
                entryScriptSrc = document.scripts[i].src;
                break;
            }
        }
        var entryScriptStartTimestamp;
        var tracingInitMarkStartTime;
        $7c924e2d9dde5b37$var$global.performance.getEntries().slice(this._performanceCursor).forEach(function(entry) {
            var startTime = (0, $SQznX.msToSec)(entry.startTime);
            var duration = (0, $SQznX.msToSec)(entry.duration);
            if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
            switch(entry.entryType){
                case "navigation":
                    $7c924e2d9dde5b37$var$addNavigationSpans(transaction, entry, timeOrigin);
                    break;
                case "mark":
                case "paint":
                case "measure":
                    var startTimestamp = $7c924e2d9dde5b37$var$addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    if (tracingInitMarkStartTime === undefined && entry.name === "sentry-tracing-init") tracingInitMarkStartTime = startTimestamp;
                    // capture web vitals
                    var firstHidden = (0, $41133c4e5784d7b8$export$e300bd30df761ba5)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.timeStamp;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $5TQck.logger).log("[Measurements] Adding FP");
                        _this._measurements["fp"] = {
                            value: entry.startTime
                        };
                        _this._measurements["mark.fp"] = {
                            value: startTimestamp
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $5TQck.logger).log("[Measurements] Adding FCP");
                        _this._measurements["fcp"] = {
                            value: entry.startTime
                        };
                        _this._measurements["mark.fcp"] = {
                            value: startTimestamp
                        };
                    }
                    break;
                case "resource":
                    var resourceName = entry.name.replace(window.location.origin, "");
                    var endTimestamp = $7c924e2d9dde5b37$export$c35d8cdf016ac02b(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    // We remember the entry script end time to calculate the difference to the first init mark
                    if (entryScriptStartTimestamp === undefined && (entryScriptSrc || "").indexOf(resourceName) > -1) entryScriptStartTimestamp = endTimestamp;
                    break;
                default:
            }
        });
        if (entryScriptStartTimestamp !== undefined && tracingInitMarkStartTime !== undefined) $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
            description: "evaluation",
            endTimestamp: tracingInitMarkStartTime,
            op: "script",
            startTimestamp: entryScriptStartTimestamp
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === "pageload") {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = (0, $SQznX.msToSec)((0, $evtBA.browserPerformanceTimeOrigin));
            [
                "fcp",
                "fp",
                "lcp",
                "ttfb"
            ].forEach(function(name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) return;
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + (0, $SQznX.msToSec)(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                (0, $5TQck.logger).log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements["mark.fid"] && this._measurements["fid"]) // create span for FID
            $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
                description: "first input delay",
                endTimestamp: this._measurements["mark.fid"].value + (0, $SQznX.msToSec)(this._measurements["fid"].value),
                op: "web.vitals",
                startTimestamp: this._measurements["mark.fid"].value
            });
            transaction.setMeasurements(this._measurements);
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */ MetricsInstrumentation.prototype._trackCLS = function() {
        var _this = this;
        (0, $b68e28db1102675f$export$fc6227831ee7c7)(function(metric) {
            var entry = metric.entries.pop();
            if (!entry) return;
            (0, $5TQck.logger).log("[Measurements] Adding CLS");
            _this._measurements["cls"] = {
                value: metric.value
            };
        });
    };
    /**
     * Capture the information of the user agent.
     */ MetricsInstrumentation.prototype._trackNavigator = function(transaction) {
        var navigator = $7c924e2d9dde5b37$var$global.navigator;
        if (!navigator) return;
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
            if (connection.type) transaction.setTag("connectionType", connection.type);
            if ($7c924e2d9dde5b37$var$isMeasurementValue(connection.rtt)) this._measurements["connection.rtt"] = {
                value: connection.rtt
            };
            if ($7c924e2d9dde5b37$var$isMeasurementValue(connection.downlink)) this._measurements["connection.downlink"] = {
                value: connection.downlink
            };
        }
        if ($7c924e2d9dde5b37$var$isMeasurementValue(navigator.deviceMemory)) transaction.setTag("deviceMemory", String(navigator.deviceMemory));
        if ($7c924e2d9dde5b37$var$isMeasurementValue(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */ MetricsInstrumentation.prototype._trackLCP = function() {
        var _this = this;
        (0, $030cc5c423975187$export$da982ced0ff8a670)(function(metric) {
            var entry = metric.entries.pop();
            if (!entry) return;
            var timeOrigin = (0, $SQznX.msToSec)(performance.timeOrigin);
            var startTime = (0, $SQznX.msToSec)(entry.startTime);
            (0, $5TQck.logger).log("[Measurements] Adding LCP");
            _this._measurements["lcp"] = {
                value: metric.value
            };
            _this._measurements["mark.lcp"] = {
                value: timeOrigin + startTime
            };
        });
    };
    /** Starts tracking the First Input Delay on the current page. */ MetricsInstrumentation.prototype._trackFID = function() {
        var _this = this;
        (0, $2747cd40f83334fd$export$134ed2977d320dfd)(function(metric) {
            var entry = metric.entries.pop();
            if (!entry) return;
            var timeOrigin = (0, $SQznX.msToSec)(performance.timeOrigin);
            var startTime = (0, $SQznX.msToSec)(entry.startTime);
            (0, $5TQck.logger).log("[Measurements] Adding FID");
            _this._measurements["fid"] = {
                value: metric.value
            };
            _this._measurements["mark.fid"] = {
                value: timeOrigin + startTime
            };
        });
    };
    /** Starts tracking the Time to First Byte on the current page. */ MetricsInstrumentation.prototype._trackTTFB = function() {
        var _this = this;
        (0, $ecdaaa455c3362e8$export$6e8eea9a35032c92)(function(metric) {
            var _a;
            var entry = metric.entries.pop();
            if (!entry) return;
            (0, $5TQck.logger).log("[Measurements] Adding TTFB");
            _this._measurements["ttfb"] = {
                value: metric.value
            };
            // Capture the time spent making the request and receiving the first byte of the response
            var requestTime = metric.value - (_a = metric.entries[0], _a !== null && _a !== void 0 ? _a : entry).requestStart;
            _this._measurements["ttfb.requestTime"] = {
                value: requestTime
            };
        });
    };
    return MetricsInstrumentation;
}();
/** Instrument navigation entries */ function $7c924e2d9dde5b37$var$addNavigationSpans(transaction, entry, timeOrigin) {
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "unloadEvent", timeOrigin);
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "redirect", timeOrigin);
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "domContentLoadedEvent", timeOrigin);
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "loadEvent", timeOrigin);
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "connect", timeOrigin);
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "connectEnd");
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "domainLookupStart");
    $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin);
    $7c924e2d9dde5b37$var$addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */ function $7c924e2d9dde5b37$var$addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
function $7c924e2d9dde5b37$export$c35d8cdf016ac02b(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return undefined;
    var data = {};
    if ("transferSize" in entry) data["Transfer Size"] = entry.transferSize;
    if ("encodedBodySize" in entry) data["Encoded Body Size"] = entry.encodedBodySize;
    if ("decodedBodySize" in entry) data["Decoded Body Size"] = entry.decodedBodySize;
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : "resource",
        startTimestamp: startTimestamp,
        data: data
    });
    return endTimestamp;
}
/** Create performance navigation related spans */ function $7c924e2d9dde5b37$var$addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) return;
    $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
        op: "browser",
        description: event,
        startTimestamp: timeOrigin + (0, $SQznX.msToSec)(start),
        endTimestamp: timeOrigin + (0, $SQznX.msToSec)(end)
    });
}
/** Create request and response related spans */ function $7c924e2d9dde5b37$var$addRequest(transaction, entry, timeOrigin) {
    $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
        op: "browser",
        description: "request",
        startTimestamp: timeOrigin + (0, $SQznX.msToSec)(entry.requestStart),
        endTimestamp: timeOrigin + (0, $SQznX.msToSec)(entry.responseEnd)
    });
    $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, {
        op: "browser",
        description: "response",
        startTimestamp: timeOrigin + (0, $SQznX.msToSec)(entry.responseStart),
        endTimestamp: timeOrigin + (0, $SQznX.msToSec)(entry.responseEnd)
    });
}
function $7c924e2d9dde5b37$export$8bd469e1f37aa721(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0, $7QK2E.__rest)(_a, [
        "startTimestamp"
    ]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild((0, $7QK2E.__assign)({
        startTimestamp: startTimestamp
    }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */ function $7c924e2d9dde5b37$var$isMeasurementValue(value) {
    return typeof value === "number" && isFinite(value);
}



var $7QK2E = parcelRequire("7QK2E");

var $bn2rP = parcelRequire("bn2rP");
parcelRequire("8wDn2");
var $chSbG = parcelRequire("chSbG");
var $hGRpR = parcelRequire("hGRpR");
var $4Jr31 = parcelRequire("4Jr31");

var $SQznX = parcelRequire("SQznX");
var $a79d11ababb55c0c$export$55480f254af1dbc1 = [
    "localhost",
    /^\//
];
var $a79d11ababb55c0c$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: $a79d11ababb55c0c$export$55480f254af1dbc1
};
function $a79d11ababb55c0c$export$788a417854f7d78b(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, $a79d11ababb55c0c$export$cc17fb3c0bc95cd7), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function(url) {
        if (urlMap[url]) return urlMap[url];
        var origins = tracingOrigins;
        urlMap[url] = origins.some(function(origin) {
            return (0, $4Jr31.isMatchingPattern)(url, origin);
        }) && !(0, $4Jr31.isMatchingPattern)(url, "sentry_key");
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === "function") shouldCreateSpan = function(url) {
        return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
    var spans = {};
    if (traceFetch) (0, $chSbG.addInstrumentationHandler)({
        callback: function(handlerData) {
            $a79d11ababb55c0c$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, spans);
        },
        type: "fetch"
    });
    if (traceXHR) (0, $chSbG.addInstrumentationHandler)({
        callback: function(handlerData) {
            $a79d11ababb55c0c$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, spans);
        },
        type: "xhr"
    });
}
function $a79d11ababb55c0c$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, spans) {
    var _a;
    var currentClientOptions = (_a = (0, $bn2rP.getCurrentHub)().getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
    if (!(currentClientOptions && (0, $SQznX.hasTracingEnabled)(currentClientOptions)) || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp && handlerData.fetchData.__span) {
        var span = spans[handlerData.fetchData.__span];
        if (span) {
            var response = handlerData.response;
            if (response) // TODO (kmclb) remove this once types PR goes through
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            span.setHttpStatus(response.status);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[handlerData.fetchData.__span];
        }
        return;
    }
    var activeTransaction = (0, $SQznX.getActiveTransaction)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, handlerData.fetchData), {
                type: "fetch"
            }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: "http"
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = handlerData.args[0] = handlerData.args[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1] = handlerData.args[1] || {};
        var headers = options.headers;
        if ((0, $hGRpR.isInstanceOf)(request, Request)) headers = request.headers;
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === "function") // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            headers.append("sentry-trace", span.toTraceparent());
            else if (Array.isArray(headers)) headers = (0, $7QK2E.__spread)(headers, [
                [
                    "sentry-trace",
                    span.toTraceparent()
                ]
            ]);
            else headers = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, headers), {
                "sentry-trace": span.toTraceparent()
            });
        } else headers = {
            "sentry-trace": span.toTraceparent()
        };
        options.headers = headers;
    }
}
function $a79d11ababb55c0c$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, spans) {
    var _a;
    var currentClientOptions = (_a = (0, $bn2rP.getCurrentHub)().getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
    if (!(currentClientOptions && (0, $SQznX.hasTracingEnabled)(currentClientOptions)) || !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url)) || handlerData.xhr.__sentry_own_request__) return;
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && handlerData.xhr.__sentry_xhr_span_id__) {
        var span = spans[handlerData.xhr.__sentry_xhr_span_id__];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[handlerData.xhr.__sentry_xhr_span_id__];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0, $SQznX.getActiveTransaction)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, xhr.data), {
                type: "xhr",
                method: xhr.method,
                url: xhr.url
            }),
            description: xhr.method + " " + xhr.url,
            op: "http"
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) try {
            handlerData.xhr.setRequestHeader("sentry-trace", span.toTraceparent());
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}


parcelRequire("8wDn2");
var $chSbG = parcelRequire("chSbG");
var $8gwLa = parcelRequire("8gwLa");
var $5TQck = parcelRequire("5TQck");
var $3596c19a07d60bb3$var$global = (0, $8gwLa.getGlobalObject)();
function $3596c19a07d60bb3$export$418cdc057b2898cb(startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) startTransactionOnPageLoad = true;
    if (startTransactionOnLocationChange === void 0) startTransactionOnLocationChange = true;
    if (!$3596c19a07d60bb3$var$global || !$3596c19a07d60bb3$var$global.location) {
        (0, $5TQck.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    var startingUrl = $3596c19a07d60bb3$var$global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = startTransaction({
        name: $3596c19a07d60bb3$var$global.location.pathname,
        op: "pageload"
    });
    if (startTransactionOnLocationChange) (0, $chSbG.addInstrumentationHandler)({
        callback: function(_a) {
            var to = _a.to, from = _a.from;
            /**
                 * This early return is there to account for some cases where a navigation transaction starts right after
                 * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
                 * create an uneccessary navigation transaction.
                 *
                 * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
                 * only be caused in certain development environments where the usage of a hot module reloader is causing
                 * errors.
                 */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    (0, $5TQck.logger).log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = startTransaction({
                    name: $3596c19a07d60bb3$var$global.location.pathname,
                    op: "navigation"
                });
            }
        },
        type: "history"
    });
}


var $ef82dc9d7abf7517$export$ec51320719fd8e96 = 600;
var $ef82dc9d7abf7517$var$DEFAULT_BROWSER_TRACING_OPTIONS = (0, $7QK2E.__assign)({
    idleTimeout: (0, $hh22J.DEFAULT_IDLE_TIMEOUT),
    markBackgroundTransactions: true,
    maxTransactionDuration: $ef82dc9d7abf7517$export$ec51320719fd8e96,
    routingInstrumentation: (0, $3596c19a07d60bb3$export$418cdc057b2898cb),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true
}, (0, $a79d11ababb55c0c$export$cc17fb3c0bc95cd7));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ var $ef82dc9d7abf7517$export$46d3bbd0375f5fa4 = /** @class */ function() {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */ this.name = BrowserTracing.id;
        this._metrics = new (0, $7c924e2d9dde5b37$export$8d26291c4fcc1971)();
        this._emitOptionsWarning = false;
        var tracingOrigins = (0, $a79d11ababb55c0c$export$cc17fb3c0bc95cd7).tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options && _options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) tracingOrigins = _options.tracingOrigins;
        else this._emitOptionsWarning = true;
        this.options = (0, $7QK2E.__assign)((0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, $ef82dc9d7abf7517$var$DEFAULT_BROWSER_TRACING_OPTIONS), _options), {
            tracingOrigins: tracingOrigins
        });
    }
    /**
     * @inheritDoc
     */ BrowserTracing.prototype.setupOnce = function(_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            (0, $5TQck.logger).warn("[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.");
            (0, $5TQck.logger).warn("[Tracing] We added a reasonable default for you: " + (0, $a79d11ababb55c0c$export$cc17fb3c0bc95cd7).tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, routingInstrumentation = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        routingInstrumentation(function(context) {
            return _this._createRouteTransaction(context);
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $c2f9f900a985ce10$export$6f18f55521af71a1)();
        (0, $a79d11ababb55c0c$export$788a417854f7d78b)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracingOrigins: tracingOrigins,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    };
    /** Create routing idle transaction. */ BrowserTracing.prototype._createRouteTransaction = function(context) {
        var _this = this;
        if (!this._getCurrentHub) {
            (0, $5TQck.logger).warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === "pageload" ? $ef82dc9d7abf7517$export$53cebc3a2ff13451() : undefined;
        var expandedContext = (0, $7QK2E.__assign)((0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, context), parentContextFromHeader), {
            trimEnd: true
        });
        var modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, expandedContext), {
            sampled: false
        }) : modifiedContext;
        if (finalContext.sampled === false) (0, $5TQck.logger).log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        var hub = this._getCurrentHub();
        var idleTransaction = (0, $4J6aQ.startIdleTransaction)(hub, finalContext, idleTimeout, true);
        (0, $5TQck.logger).log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        idleTransaction.registerBeforeFinishCallback(function(transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            $ef82dc9d7abf7517$var$adjustTransactionDuration((0, $SQznX.secToMs)(maxTransactionDuration), transaction, endTimestamp);
        });
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */ BrowserTracing.id = "BrowserTracing";
    return BrowserTracing;
}();
function $ef82dc9d7abf7517$export$53cebc3a2ff13451() {
    var header = $ef82dc9d7abf7517$export$f147b32b03c9cf11("sentry-trace");
    if (header) return (0, $SQznX.extractTraceparentData)(header);
    return undefined;
}
function $ef82dc9d7abf7517$export$f147b32b03c9cf11(metaName) {
    var el = document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute("content") : null;
}
/** Adjusts transaction value based on max transaction duration */ function $ef82dc9d7abf7517$var$adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus((0, $iL8cJ.SpanStatus).DeadlineExceeded);
        transaction.setTag("maxTransactionDurationExceeded", "true");
    }
}



var $4J6aQ = parcelRequire("4J6aQ");
var $5988524190219a8b$exports = {};

$parcel$export($5988524190219a8b$exports, "Express", () => $3d693b11d5c54b08$export$6dafdd8fec05099d);
$parcel$export($5988524190219a8b$exports, "Postgres", () => (parcelRequire("cHt7H")).Postgres);
$parcel$export($5988524190219a8b$exports, "Mysql", () => (parcelRequire("2IAjF")).Mysql);
$parcel$export($5988524190219a8b$exports, "Mongo", () => (parcelRequire("bV6u1")).Mongo);

var $7QK2E = parcelRequire("7QK2E");
parcelRequire("8wDn2");
var $5TQck = parcelRequire("5TQck");
/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ var $3d693b11d5c54b08$export$6dafdd8fec05099d = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Express(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = Express.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat("use");
    }
    /**
     * @inheritDoc
     */ Express.prototype.setupOnce = function() {
        if (!this._router) {
            (0, $5TQck.logger).error("ExpressIntegration is missing an Express instance");
            return;
        }
        $3d693b11d5c54b08$var$instrumentMiddlewares(this._router, this._methods);
    };
    /**
     * @inheritDoc
     */ Express.id = "Express";
    return Express;
}();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $3d693b11d5c54b08$var$wrap(fn, method) {
    var arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                var transaction = res.__sentry_transaction;
                if (transaction) {
                    var span_1 = transaction.startChild({
                        description: fn.name,
                        op: "middleware." + method
                    });
                    res.once("finish", function() {
                        span_1.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                var _a;
                var transaction = res.__sentry_transaction;
                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
                    description: fn.name,
                    op: "middleware." + method
                });
                fn.call(this, req, res, function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    next.call.apply(next, (0, $7QK2E.__spread)([
                        this
                    ], args));
                });
            };
        case 4:
            return function(err, req, res, next) {
                var _a;
                var transaction = res.__sentry_transaction;
                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
                    description: fn.name,
                    op: "middleware." + method
                });
                fn.call(this, err, req, res, function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var _a;
                    (_a = span) === null || _a === void 0 || _a.finish();
                    next.call.apply(next, (0, $7QK2E.__spread)([
                        this
                    ], args));
                });
            };
        default:
            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $3d693b11d5c54b08$var$wrapMiddlewareArgs(args, method) {
    return args.map(function(arg) {
        if (typeof arg === "function") return $3d693b11d5c54b08$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map(function(a) {
            if (typeof a === "function") return $3d693b11d5c54b08$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $3d693b11d5c54b08$var$patchMiddleware(router, method) {
    var originalCallback = router[method];
    router[method] = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return originalCallback.call.apply(originalCallback, (0, $7QK2E.__spread)([
            this
        ], $3d693b11d5c54b08$var$wrapMiddlewareArgs(args, method)));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $3d693b11d5c54b08$var$instrumentMiddlewares(router, methods) {
    if (methods === void 0) methods = [];
    methods.forEach(function(method) {
        return $3d693b11d5c54b08$var$patchMiddleware(router, method);
    });
}



var $cHt7H = parcelRequire("cHt7H");

var $2IAjF = parcelRequire("2IAjF");

var $bV6u1 = parcelRequire("bV6u1");







var $b4391f323436e8d0$export$99d02219d259eb94 = (0, $7QK2E.__assign)((0, $7QK2E.__assign)({}, $5988524190219a8b$exports), {
    BrowserTracing: (0, $ef82dc9d7abf7517$export$46d3bbd0375f5fa4)
});
// We are patching the global object with our hub extension methods
(0, $4J6aQ.addExtensionMethods)();





var $4hYjL = parcelRequire("4hYjL");




class $cacef8b730ae1823$var$App extends (0, $4hYjL.Component) {
    constructor(props){
        super(props);
    }
    componentDidMount() {
        this.isLoggedin();
    }
    isLoggedin() {
        const { dispatch: dispatch } = this.props;
        (0, (/*@__PURE__*/$parcel$interopDefault($b8351d862d7d7474$exports))).get("/api/is-logged-in").then((res)=>{
            dispatch((0, $d599c499e9218b1e$export$de676d0b1df680f0)({
                ...res.data
            }));
        });
    }
    render() {
        return /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)("div", {
            id: this.props.authReducer.dyslexiaFont ? "show-dyslexia-font" : "",
            children: [
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsxs)((0, $5e0021919929c8b4$export$dcef8f9bb9a41431), {
                    children: [
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("title", {
                            children: "Ur\xf0arbrunnur \xd6kusk\xf3li"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            name: "description",
                            content: "Ur\xf0arbrunnur \xd6kusk\xf3li"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            name: "keywords",
                            content: "Ur\xf0arbrunnur \xd6kusk\xf3li"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            property: "og:title",
                            content: "Ur\xf0arbrunnur \xd6kusk\xf3li"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            property: "og:type",
                            content: "website"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            property: "og:url",
                            content: "http://www.urdarbrunnur.is/"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            property: "og:image",
                            content: "http://urdarbrunnur.herokuapp.com/images/icon-logo.gif"
                        }),
                        /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)("meta", {
                            property: "og:site_name",
                            content: "Ur\xf0arbrunnur \xd6kusk\xf3li"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $eb42b516ad2b007c$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
const $cacef8b730ae1823$var$mapStateToProps = (state)=>{
    const { authReducer: authReducer } = state;
    return {
        authReducer: authReducer
    };
};
var $cacef8b730ae1823$export$2e2bcd8739ae039 = (0, $de12548f24812a19$export$2e2bcd8739ae039)($cacef8b730ae1823$var$mapStateToProps)($cacef8b730ae1823$var$App);




var $927258c2c50c6217$export$2e2bcd8739ae039 = (0, $1d4ef72e121e7884$export$66e4520cdb265d18)({
    authReducer: $d599c499e9218b1e$export$1650419e431d3ba3
});


var $d8a3e3887ad44afd$exports = {};
"use strict";
var $0033a7def0812767$exports = {};
"use strict";
var $f7676523e9a862c1$exports = {};
"use strict";
var $1c8da37ffe273379$exports = {};
"use strict";
Object.defineProperty($1c8da37ffe273379$exports, "__esModule", {
    value: true
});
var $1c8da37ffe273379$var$warn = function warn(s) {
    console.warn("[react-gtm]", s);
};
$1c8da37ffe273379$exports.default = $1c8da37ffe273379$var$warn;


var $f7676523e9a862c1$var$_warn2 = $f7676523e9a862c1$var$_interopRequireDefault($1c8da37ffe273379$exports);
function $f7676523e9a862c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://developers.google.com/tag-manager/quickstart
var $f7676523e9a862c1$var$Snippets = {
    tags: function tags(_ref) {
        var id = _ref.id, events = _ref.events, dataLayer = _ref.dataLayer, dataLayerName = _ref.dataLayerName, preview = _ref.preview, auth = _ref.auth;
        var gtm_auth = "&gtm_auth=" + auth;
        var gtm_preview = "&gtm_preview=" + preview;
        if (!id) (0, $f7676523e9a862c1$var$_warn2.default)("GTM Id is required");
        var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', " + JSON.stringify(events).slice(1, -1) + "});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'" + gtm_auth + gtm_preview + "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','" + dataLayerName + "','" + id + "');";
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(_dataLayer, dataLayerName) {
        return "\n      window." + dataLayerName + " = window." + dataLayerName + " || [];\n      window." + dataLayerName + ".push(" + JSON.stringify(_dataLayer) + ")";
    }
};
$f7676523e9a862c1$exports = $f7676523e9a862c1$var$Snippets;


var $0033a7def0812767$var$_Snippets2 = $0033a7def0812767$var$_interopRequireDefault($f7676523e9a862c1$exports);
function $0033a7def0812767$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0033a7def0812767$var$TagManager = {
    dataScript: function dataScript(dataLayer) {
        var script = document.createElement("script");
        script.innerHTML = dataLayer;
        return script;
    },
    gtm: function gtm(args) {
        var snippets = $0033a7def0812767$var$_Snippets2.default.tags(args);
        var noScript = function noScript() {
            var noscript = document.createElement("noscript");
            noscript.innerHTML = snippets.iframe;
            return noscript;
        };
        var script = function script() {
            var script = document.createElement("script");
            script.innerHTML = snippets.script;
            return script;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            dataScript: dataScript
        };
    },
    initialize: function initialize(_ref) {
        var gtmId = _ref.gtmId, _ref$events = _ref.events, events = _ref$events === undefined ? {} : _ref$events, dataLayer = _ref.dataLayer, _ref$dataLayerName = _ref.dataLayerName, dataLayerName = _ref$dataLayerName === undefined ? "dataLayer" : _ref$dataLayerName, _ref$auth = _ref.auth, auth = _ref$auth === undefined ? "" : _ref$auth, _ref$preview = _ref.preview, preview = _ref$preview === undefined ? "" : _ref$preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    dataLayer: function dataLayer(_ref2) {
        var _dataLayer = _ref2.dataLayer, _ref2$dataLayerName = _ref2.dataLayerName, dataLayerName = _ref2$dataLayerName === undefined ? "dataLayer" : _ref2$dataLayerName;
        if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
        var snippets = $0033a7def0812767$var$_Snippets2.default.dataLayer(_dataLayer, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
$0033a7def0812767$exports = $0033a7def0812767$var$TagManager;


var $d8a3e3887ad44afd$var$_TagManager2 = $d8a3e3887ad44afd$var$_interopRequireDefault($0033a7def0812767$exports);
function $d8a3e3887ad44afd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d8a3e3887ad44afd$exports = $d8a3e3887ad44afd$var$_TagManager2.default;


const $16e5d1c2d857f18f$var$tagManagerArgs = {
    gtmId: "GTM-WZK7TZB"
};
// Apply logger if it's not in production.
let $16e5d1c2d857f18f$var$store;
$16e5d1c2d857f18f$var$store = (0, $1d4ef72e121e7884$export$f51a9068ac82ea43)((0, $927258c2c50c6217$export$2e2bcd8739ae039));
$a3ac3bfd5482036b$export$2cd8252107eb640b({
    dsn: "https://e1aeec67347f4c6aa830300e6728ee1f@o368748.ingest.sentry.io/5408270",
    integrations: [
        new (0, $b4391f323436e8d0$export$99d02219d259eb94).BrowserTracing()
    ],
    tracesSampleRate: 1.0
});
(0, (/*@__PURE__*/$parcel$interopDefault($d8a3e3887ad44afd$exports))).initialize($16e5d1c2d857f18f$var$tagManagerArgs);
// Fixes Google Translate issue
// See here: https://github.com/facebook/react/issues/11538
if (typeof Node === "function" && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function(child) {
        if (child.parentNode !== this) {
            if (console) console.error("Cannot remove a child from a different parent", child, this);
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (console) console.error("Cannot insert before a reference node from a different parent", referenceNode, this);
            return newNode;
        }
        return originalInsertBefore.apply(this, arguments);
    };
}
(0, $907ccff5bb941ac5$exports.render)(/*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $11340a39bad0d245$export$2e2bcd8739ae039), {
    store: $16e5d1c2d857f18f$var$store,
    children: /*#__PURE__*/ (0, $35b7bd865360a597$exports.jsx)((0, $cacef8b730ae1823$export$2e2bcd8739ae039), {})
}), document.getElementById("react-main-mount"));


//# sourceMappingURL=200.js.map
